
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree1fe"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree1fe"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("abGvd", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $76abe68dd2b5f1d5$export$ffb0004e005737fa; }, function (v) { return $76abe68dd2b5f1d5$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $76abe68dd2b5f1d5$export$34b9dba7ce09269b; }, function (v) { return $76abe68dd2b5f1d5$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $76abe68dd2b5f1d5$export$25062201e9e25d76; }, function (v) { return $76abe68dd2b5f1d5$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $76abe68dd2b5f1d5$export$ffb0004e005737fa;
var $76abe68dd2b5f1d5$export$34b9dba7ce09269b;
var $76abe68dd2b5f1d5$export$25062201e9e25d76;
"use strict";

var $4RFnf = parcelRequire("4RFnf");
var $76abe68dd2b5f1d5$var$k = Symbol.for("react.element"), $76abe68dd2b5f1d5$var$l = Symbol.for("react.fragment"), $76abe68dd2b5f1d5$var$m = Object.prototype.hasOwnProperty, $76abe68dd2b5f1d5$var$n = $4RFnf.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $76abe68dd2b5f1d5$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $76abe68dd2b5f1d5$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$76abe68dd2b5f1d5$var$m.call(a, b) && !$76abe68dd2b5f1d5$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $76abe68dd2b5f1d5$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $76abe68dd2b5f1d5$var$n.current
    };
}
$76abe68dd2b5f1d5$export$ffb0004e005737fa = $76abe68dd2b5f1d5$var$l;
$76abe68dd2b5f1d5$export$34b9dba7ce09269b = $76abe68dd2b5f1d5$var$q;
$76abe68dd2b5f1d5$export$25062201e9e25d76 = $76abe68dd2b5f1d5$var$q;

});
parcelRegister("4RFnf", function(module, exports) {
"use strict";

module.exports = (parcelRequire("kAGzt"));

});
parcelRegister("kAGzt", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $efd8312e16f87340$export$dca3b0875bd9a954; }, function (v) { return $efd8312e16f87340$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $efd8312e16f87340$export$16fa2f45be04daa8; }, function (v) { return $efd8312e16f87340$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $efd8312e16f87340$export$ffb0004e005737fa; }, function (v) { return $efd8312e16f87340$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $efd8312e16f87340$export$e2c29f18771995cb; }, function (v) { return $efd8312e16f87340$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $efd8312e16f87340$export$221d75b3f55bb0bd; }, function (v) { return $efd8312e16f87340$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $efd8312e16f87340$export$5f8d39834fd61797; }, function (v) { return $efd8312e16f87340$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $efd8312e16f87340$export$74bf444e3cd11ea5; }, function (v) { return $efd8312e16f87340$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $efd8312e16f87340$export$ae55be85d98224ed; }, function (v) { return $efd8312e16f87340$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $efd8312e16f87340$export$3ba232387fd5d6dd; }, function (v) { return $efd8312e16f87340$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $efd8312e16f87340$export$e530037191fcd5d7; }, function (v) { return $efd8312e16f87340$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $efd8312e16f87340$export$fd42f52fd3ae1109; }, function (v) { return $efd8312e16f87340$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $efd8312e16f87340$export$c8a8987d4410bf2d; }, function (v) { return $efd8312e16f87340$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $efd8312e16f87340$export$d38cd72104c1f0e9; }, function (v) { return $efd8312e16f87340$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $efd8312e16f87340$export$7d1e3a5e95ceca43; }, function (v) { return $efd8312e16f87340$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $efd8312e16f87340$export$257a8862b851cb5b; }, function (v) { return $efd8312e16f87340$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $efd8312e16f87340$export$a8257692ac88316c; }, function (v) { return $efd8312e16f87340$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $efd8312e16f87340$export$488013bae63b21da; }, function (v) { return $efd8312e16f87340$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $efd8312e16f87340$export$7c73462e0d25e514; }, function (v) { return $efd8312e16f87340$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $efd8312e16f87340$export$7568632d0d33d16d; }, function (v) { return $efd8312e16f87340$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $efd8312e16f87340$export$88948ce120ea2619; }, function (v) { return $efd8312e16f87340$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $efd8312e16f87340$export$35808ee640e87ca7; }, function (v) { return $efd8312e16f87340$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $efd8312e16f87340$export$fae74005e78b1a27; }, function (v) { return $efd8312e16f87340$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $efd8312e16f87340$export$dc8fbce3eb94dc1e; }, function (v) { return $efd8312e16f87340$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $efd8312e16f87340$export$6a7bc4e911dc01cf; }, function (v) { return $efd8312e16f87340$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $efd8312e16f87340$export$6d9c69b0de29b591; }, function (v) { return $efd8312e16f87340$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $efd8312e16f87340$export$f680877a34711e37; }, function (v) { return $efd8312e16f87340$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $efd8312e16f87340$export$d5a552a76deda3c2; }, function (v) { return $efd8312e16f87340$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $efd8312e16f87340$export$aaabe4eda9ed9969; }, function (v) { return $efd8312e16f87340$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $efd8312e16f87340$export$e5c5a5f917a5871c; }, function (v) { return $efd8312e16f87340$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $efd8312e16f87340$export$1538c33de8887b59; }, function (v) { return $efd8312e16f87340$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $efd8312e16f87340$export$13e3392192263954; }, function (v) { return $efd8312e16f87340$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $efd8312e16f87340$export$b8f5890fc79d6aca; }, function (v) { return $efd8312e16f87340$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $efd8312e16f87340$export$60241385465d0a34; }, function (v) { return $efd8312e16f87340$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $efd8312e16f87340$export$306c0aa65ff9ec16; }, function (v) { return $efd8312e16f87340$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $efd8312e16f87340$export$7b286972b8d8ccbf; }, function (v) { return $efd8312e16f87340$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $efd8312e16f87340$export$83d89fbfd8236492; }, function (v) { return $efd8312e16f87340$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $efd8312e16f87340$export$dca3b0875bd9a954;
var $efd8312e16f87340$export$16fa2f45be04daa8;
var $efd8312e16f87340$export$ffb0004e005737fa;
var $efd8312e16f87340$export$e2c29f18771995cb;
var $efd8312e16f87340$export$221d75b3f55bb0bd;
var $efd8312e16f87340$export$5f8d39834fd61797;
var $efd8312e16f87340$export$74bf444e3cd11ea5;
var $efd8312e16f87340$export$ae55be85d98224ed;
var $efd8312e16f87340$export$3ba232387fd5d6dd;
var $efd8312e16f87340$export$e530037191fcd5d7;
var $efd8312e16f87340$export$fd42f52fd3ae1109;
var $efd8312e16f87340$export$c8a8987d4410bf2d;
var $efd8312e16f87340$export$d38cd72104c1f0e9;
var $efd8312e16f87340$export$7d1e3a5e95ceca43;
var $efd8312e16f87340$export$257a8862b851cb5b;
var $efd8312e16f87340$export$a8257692ac88316c;
var $efd8312e16f87340$export$488013bae63b21da;
var $efd8312e16f87340$export$7c73462e0d25e514;
var $efd8312e16f87340$export$7568632d0d33d16d;
var $efd8312e16f87340$export$88948ce120ea2619;
var $efd8312e16f87340$export$35808ee640e87ca7;
var $efd8312e16f87340$export$fae74005e78b1a27;
var $efd8312e16f87340$export$dc8fbce3eb94dc1e;
var $efd8312e16f87340$export$6a7bc4e911dc01cf;
var $efd8312e16f87340$export$6d9c69b0de29b591;
var $efd8312e16f87340$export$f680877a34711e37;
var $efd8312e16f87340$export$d5a552a76deda3c2;
var $efd8312e16f87340$export$aaabe4eda9ed9969;
var $efd8312e16f87340$export$e5c5a5f917a5871c;
var $efd8312e16f87340$export$1538c33de8887b59;
var $efd8312e16f87340$export$13e3392192263954;
var $efd8312e16f87340$export$b8f5890fc79d6aca;
var $efd8312e16f87340$export$60241385465d0a34;
var $efd8312e16f87340$export$306c0aa65ff9ec16;
var $efd8312e16f87340$export$7b286972b8d8ccbf;
var $efd8312e16f87340$export$83d89fbfd8236492;
"use strict";
var $efd8312e16f87340$var$l = Symbol.for("react.element"), $efd8312e16f87340$var$n = Symbol.for("react.portal"), $efd8312e16f87340$var$p = Symbol.for("react.fragment"), $efd8312e16f87340$var$q = Symbol.for("react.strict_mode"), $efd8312e16f87340$var$r = Symbol.for("react.profiler"), $efd8312e16f87340$var$t = Symbol.for("react.provider"), $efd8312e16f87340$var$u = Symbol.for("react.context"), $efd8312e16f87340$var$v = Symbol.for("react.forward_ref"), $efd8312e16f87340$var$w = Symbol.for("react.suspense"), $efd8312e16f87340$var$x = Symbol.for("react.memo"), $efd8312e16f87340$var$y = Symbol.for("react.lazy"), $efd8312e16f87340$var$z = Symbol.iterator;
function $efd8312e16f87340$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $efd8312e16f87340$var$z && a[$efd8312e16f87340$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $efd8312e16f87340$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $efd8312e16f87340$var$C = Object.assign, $efd8312e16f87340$var$D = {};
function $efd8312e16f87340$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $efd8312e16f87340$var$D;
    this.updater = e || $efd8312e16f87340$var$B;
}
$efd8312e16f87340$var$E.prototype.isReactComponent = {};
$efd8312e16f87340$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$efd8312e16f87340$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $efd8312e16f87340$var$F() {}
$efd8312e16f87340$var$F.prototype = $efd8312e16f87340$var$E.prototype;
function $efd8312e16f87340$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $efd8312e16f87340$var$D;
    this.updater = e || $efd8312e16f87340$var$B;
}
var $efd8312e16f87340$var$H = $efd8312e16f87340$var$G.prototype = new $efd8312e16f87340$var$F;
$efd8312e16f87340$var$H.constructor = $efd8312e16f87340$var$G;
$efd8312e16f87340$var$C($efd8312e16f87340$var$H, $efd8312e16f87340$var$E.prototype);
$efd8312e16f87340$var$H.isPureReactComponent = !0;
var $efd8312e16f87340$var$I = Array.isArray, $efd8312e16f87340$var$J = Object.prototype.hasOwnProperty, $efd8312e16f87340$var$K = {
    current: null
}, $efd8312e16f87340$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $efd8312e16f87340$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$efd8312e16f87340$var$J.call(b, d) && !$efd8312e16f87340$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $efd8312e16f87340$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $efd8312e16f87340$var$K.current
    };
}
function $efd8312e16f87340$var$N(a, b) {
    return {
        $$typeof: $efd8312e16f87340$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $efd8312e16f87340$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $efd8312e16f87340$var$l;
}
function $efd8312e16f87340$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $efd8312e16f87340$var$P = /\/+/g;
function $efd8312e16f87340$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $efd8312e16f87340$var$escape("" + a.key) : b.toString(36);
}
function $efd8312e16f87340$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $efd8312e16f87340$var$l:
                case $efd8312e16f87340$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $efd8312e16f87340$var$Q(h, 0) : d, $efd8312e16f87340$var$I(c) ? (e = "", null != a && (e = a.replace($efd8312e16f87340$var$P, "$&/") + "/"), $efd8312e16f87340$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($efd8312e16f87340$var$O(c) && (c = $efd8312e16f87340$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($efd8312e16f87340$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($efd8312e16f87340$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $efd8312e16f87340$var$Q(k, g);
        h += $efd8312e16f87340$var$R(k, b, e, f, c);
    }
    else if (f = $efd8312e16f87340$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $efd8312e16f87340$var$Q(k, g++), h += $efd8312e16f87340$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $efd8312e16f87340$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $efd8312e16f87340$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $efd8312e16f87340$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $efd8312e16f87340$var$U = {
    current: null
}, $efd8312e16f87340$var$V = {
    transition: null
}, $efd8312e16f87340$var$W = {
    ReactCurrentDispatcher: $efd8312e16f87340$var$U,
    ReactCurrentBatchConfig: $efd8312e16f87340$var$V,
    ReactCurrentOwner: $efd8312e16f87340$var$K
};
function $efd8312e16f87340$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$efd8312e16f87340$export$dca3b0875bd9a954 = {
    map: $efd8312e16f87340$var$S,
    forEach: function(a, b, e) {
        $efd8312e16f87340$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $efd8312e16f87340$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $efd8312e16f87340$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$efd8312e16f87340$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$efd8312e16f87340$export$16fa2f45be04daa8 = $efd8312e16f87340$var$E;
$efd8312e16f87340$export$ffb0004e005737fa = $efd8312e16f87340$var$p;
$efd8312e16f87340$export$e2c29f18771995cb = $efd8312e16f87340$var$r;
$efd8312e16f87340$export$221d75b3f55bb0bd = $efd8312e16f87340$var$G;
$efd8312e16f87340$export$5f8d39834fd61797 = $efd8312e16f87340$var$q;
$efd8312e16f87340$export$74bf444e3cd11ea5 = $efd8312e16f87340$var$w;
$efd8312e16f87340$export$ae55be85d98224ed = $efd8312e16f87340$var$W;
$efd8312e16f87340$export$3ba232387fd5d6dd = $efd8312e16f87340$var$X;
$efd8312e16f87340$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $efd8312e16f87340$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $efd8312e16f87340$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$efd8312e16f87340$var$J.call(b, f) && !$efd8312e16f87340$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $efd8312e16f87340$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$efd8312e16f87340$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $efd8312e16f87340$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $efd8312e16f87340$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$efd8312e16f87340$export$c8a8987d4410bf2d = $efd8312e16f87340$var$M;
$efd8312e16f87340$export$d38cd72104c1f0e9 = function(a) {
    var b = $efd8312e16f87340$var$M.bind(null, a);
    b.type = a;
    return b;
};
$efd8312e16f87340$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$efd8312e16f87340$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $efd8312e16f87340$var$v,
        render: a
    };
};
$efd8312e16f87340$export$a8257692ac88316c = $efd8312e16f87340$var$O;
$efd8312e16f87340$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $efd8312e16f87340$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $efd8312e16f87340$var$T
    };
};
$efd8312e16f87340$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $efd8312e16f87340$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$efd8312e16f87340$export$7568632d0d33d16d = function(a) {
    var b = $efd8312e16f87340$var$V.transition;
    $efd8312e16f87340$var$V.transition = {};
    try {
        a();
    } finally{
        $efd8312e16f87340$var$V.transition = b;
    }
};
$efd8312e16f87340$export$88948ce120ea2619 = $efd8312e16f87340$var$X;
$efd8312e16f87340$export$35808ee640e87ca7 = function(a, b) {
    return $efd8312e16f87340$var$U.current.useCallback(a, b);
};
$efd8312e16f87340$export$fae74005e78b1a27 = function(a) {
    return $efd8312e16f87340$var$U.current.useContext(a);
};
$efd8312e16f87340$export$dc8fbce3eb94dc1e = function() {};
$efd8312e16f87340$export$6a7bc4e911dc01cf = function(a) {
    return $efd8312e16f87340$var$U.current.useDeferredValue(a);
};
$efd8312e16f87340$export$6d9c69b0de29b591 = function(a, b) {
    return $efd8312e16f87340$var$U.current.useEffect(a, b);
};
$efd8312e16f87340$export$f680877a34711e37 = function() {
    return $efd8312e16f87340$var$U.current.useId();
};
$efd8312e16f87340$export$d5a552a76deda3c2 = function(a, b, e) {
    return $efd8312e16f87340$var$U.current.useImperativeHandle(a, b, e);
};
$efd8312e16f87340$export$aaabe4eda9ed9969 = function(a, b) {
    return $efd8312e16f87340$var$U.current.useInsertionEffect(a, b);
};
$efd8312e16f87340$export$e5c5a5f917a5871c = function(a, b) {
    return $efd8312e16f87340$var$U.current.useLayoutEffect(a, b);
};
$efd8312e16f87340$export$1538c33de8887b59 = function(a, b) {
    return $efd8312e16f87340$var$U.current.useMemo(a, b);
};
$efd8312e16f87340$export$13e3392192263954 = function(a, b, e) {
    return $efd8312e16f87340$var$U.current.useReducer(a, b, e);
};
$efd8312e16f87340$export$b8f5890fc79d6aca = function(a) {
    return $efd8312e16f87340$var$U.current.useRef(a);
};
$efd8312e16f87340$export$60241385465d0a34 = function(a) {
    return $efd8312e16f87340$var$U.current.useState(a);
};
$efd8312e16f87340$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $efd8312e16f87340$var$U.current.useSyncExternalStore(a, b, e);
};
$efd8312e16f87340$export$7b286972b8d8ccbf = function() {
    return $efd8312e16f87340$var$U.current.useTransition();
};
$efd8312e16f87340$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("bwgJJ", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $862faa6cda49c095$export$ae55be85d98224ed; }, function (v) { return $862faa6cda49c095$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $862faa6cda49c095$export$d39a5bbd09211389; }, function (v) { return $862faa6cda49c095$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $862faa6cda49c095$export$882461b6382ed46c; }, function (v) { return $862faa6cda49c095$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $862faa6cda49c095$export$466bfc07425424d5; }, function (v) { return $862faa6cda49c095$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $862faa6cda49c095$export$cd75ccfd720a3cd4; }, function (v) { return $862faa6cda49c095$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $862faa6cda49c095$export$fa8d919ba61d84db; }, function (v) { return $862faa6cda49c095$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $862faa6cda49c095$export$757ceba2d55c277e; }, function (v) { return $862faa6cda49c095$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $862faa6cda49c095$export$b3890eb0ae9dca99; }, function (v) { return $862faa6cda49c095$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $862faa6cda49c095$export$502457920280e6be; }, function (v) { return $862faa6cda49c095$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $862faa6cda49c095$export$c78a37762a8d58e1; }, function (v) { return $862faa6cda49c095$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $862faa6cda49c095$export$dc54d992c10e8a18; }, function (v) { return $862faa6cda49c095$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $862faa6cda49c095$export$83d89fbfd8236492; }, function (v) { return $862faa6cda49c095$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $862faa6cda49c095$export$ae55be85d98224ed;
var $862faa6cda49c095$export$d39a5bbd09211389;
var $862faa6cda49c095$export$882461b6382ed46c;
var $862faa6cda49c095$export$466bfc07425424d5;
var $862faa6cda49c095$export$cd75ccfd720a3cd4;
var $862faa6cda49c095$export$fa8d919ba61d84db;
var $862faa6cda49c095$export$757ceba2d55c277e;
var $862faa6cda49c095$export$b3890eb0ae9dca99;
var $862faa6cda49c095$export$502457920280e6be;
var $862faa6cda49c095$export$c78a37762a8d58e1;
var $862faa6cda49c095$export$dc54d992c10e8a18;
var $862faa6cda49c095$export$83d89fbfd8236492;
"use strict";

var $4RFnf = parcelRequire("4RFnf");

var $8TTSu = parcelRequire("8TTSu");
function $862faa6cda49c095$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $862faa6cda49c095$var$da = new Set, $862faa6cda49c095$var$ea = {};
function $862faa6cda49c095$var$fa(a, b) {
    $862faa6cda49c095$var$ha(a, b);
    $862faa6cda49c095$var$ha(a + "Capture", b);
}
function $862faa6cda49c095$var$ha(a, b) {
    $862faa6cda49c095$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$862faa6cda49c095$var$da.add(b[a]);
}
var $862faa6cda49c095$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $862faa6cda49c095$var$ja = Object.prototype.hasOwnProperty, $862faa6cda49c095$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $862faa6cda49c095$var$la = {}, $862faa6cda49c095$var$ma = {};
function $862faa6cda49c095$var$oa(a) {
    if ($862faa6cda49c095$var$ja.call($862faa6cda49c095$var$ma, a)) return !0;
    if ($862faa6cda49c095$var$ja.call($862faa6cda49c095$var$la, a)) return !1;
    if ($862faa6cda49c095$var$ka.test(a)) return $862faa6cda49c095$var$ma[a] = !0;
    $862faa6cda49c095$var$la[a] = !0;
    return !1;
}
function $862faa6cda49c095$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $862faa6cda49c095$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $862faa6cda49c095$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $862faa6cda49c095$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $862faa6cda49c095$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $862faa6cda49c095$var$z[b] = new $862faa6cda49c095$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $862faa6cda49c095$var$ra = /[\-:]([a-z])/g;
function $862faa6cda49c095$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($862faa6cda49c095$var$ra, $862faa6cda49c095$var$sa);
    $862faa6cda49c095$var$z[b] = new $862faa6cda49c095$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($862faa6cda49c095$var$ra, $862faa6cda49c095$var$sa);
    $862faa6cda49c095$var$z[b] = new $862faa6cda49c095$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($862faa6cda49c095$var$ra, $862faa6cda49c095$var$sa);
    $862faa6cda49c095$var$z[b] = new $862faa6cda49c095$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$862faa6cda49c095$var$z.xlinkHref = new $862faa6cda49c095$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $862faa6cda49c095$var$ta(a, b, c, d) {
    var e = $862faa6cda49c095$var$z.hasOwnProperty(b) ? $862faa6cda49c095$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $862faa6cda49c095$var$qa(b, c, e, d) && (c = null), d || null === e ? $862faa6cda49c095$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $862faa6cda49c095$var$ua = $4RFnf.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $862faa6cda49c095$var$va = Symbol.for("react.element"), $862faa6cda49c095$var$wa = Symbol.for("react.portal"), $862faa6cda49c095$var$ya = Symbol.for("react.fragment"), $862faa6cda49c095$var$za = Symbol.for("react.strict_mode"), $862faa6cda49c095$var$Aa = Symbol.for("react.profiler"), $862faa6cda49c095$var$Ba = Symbol.for("react.provider"), $862faa6cda49c095$var$Ca = Symbol.for("react.context"), $862faa6cda49c095$var$Da = Symbol.for("react.forward_ref"), $862faa6cda49c095$var$Ea = Symbol.for("react.suspense"), $862faa6cda49c095$var$Fa = Symbol.for("react.suspense_list"), $862faa6cda49c095$var$Ga = Symbol.for("react.memo"), $862faa6cda49c095$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $862faa6cda49c095$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $862faa6cda49c095$var$Ja = Symbol.iterator;
function $862faa6cda49c095$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $862faa6cda49c095$var$Ja && a[$862faa6cda49c095$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $862faa6cda49c095$var$A = Object.assign, $862faa6cda49c095$var$La;
function $862faa6cda49c095$var$Ma(a) {
    if (void 0 === $862faa6cda49c095$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $862faa6cda49c095$var$La = b && b[1] || "";
    }
    return "\n" + $862faa6cda49c095$var$La + a;
}
var $862faa6cda49c095$var$Na = !1;
function $862faa6cda49c095$var$Oa(a, b) {
    if (!a || $862faa6cda49c095$var$Na) return "";
    $862faa6cda49c095$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $862faa6cda49c095$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $862faa6cda49c095$var$Ma(a) : "";
}
function $862faa6cda49c095$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $862faa6cda49c095$var$Ma(a.type);
        case 16:
            return $862faa6cda49c095$var$Ma("Lazy");
        case 13:
            return $862faa6cda49c095$var$Ma("Suspense");
        case 19:
            return $862faa6cda49c095$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $862faa6cda49c095$var$Oa(a.type, !1), a;
        case 11:
            return a = $862faa6cda49c095$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $862faa6cda49c095$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $862faa6cda49c095$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $862faa6cda49c095$var$ya:
            return "Fragment";
        case $862faa6cda49c095$var$wa:
            return "Portal";
        case $862faa6cda49c095$var$Aa:
            return "Profiler";
        case $862faa6cda49c095$var$za:
            return "StrictMode";
        case $862faa6cda49c095$var$Ea:
            return "Suspense";
        case $862faa6cda49c095$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $862faa6cda49c095$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $862faa6cda49c095$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $862faa6cda49c095$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $862faa6cda49c095$var$Ga:
            return b = a.displayName || null, null !== b ? b : $862faa6cda49c095$var$Qa(a.type) || "Memo";
        case $862faa6cda49c095$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $862faa6cda49c095$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $862faa6cda49c095$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $862faa6cda49c095$var$Qa(b);
        case 8:
            return b === $862faa6cda49c095$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $862faa6cda49c095$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $862faa6cda49c095$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $862faa6cda49c095$var$Ua(a) {
    var b = $862faa6cda49c095$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $862faa6cda49c095$var$Va(a) {
    a._valueTracker || (a._valueTracker = $862faa6cda49c095$var$Ua(a));
}
function $862faa6cda49c095$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $862faa6cda49c095$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $862faa6cda49c095$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $862faa6cda49c095$var$Ya(a, b) {
    var c = b.checked;
    return $862faa6cda49c095$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $862faa6cda49c095$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $862faa6cda49c095$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $862faa6cda49c095$var$ab(a, b) {
    b = b.checked;
    null != b && $862faa6cda49c095$var$ta(a, "checked", b, !1);
}
function $862faa6cda49c095$var$bb(a, b) {
    $862faa6cda49c095$var$ab(a, b);
    var c = $862faa6cda49c095$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $862faa6cda49c095$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $862faa6cda49c095$var$cb(a, b.type, $862faa6cda49c095$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $862faa6cda49c095$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $862faa6cda49c095$var$cb(a, b, c) {
    if ("number" !== b || $862faa6cda49c095$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $862faa6cda49c095$var$eb = Array.isArray;
function $862faa6cda49c095$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $862faa6cda49c095$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $862faa6cda49c095$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($862faa6cda49c095$var$p(91));
    return $862faa6cda49c095$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $862faa6cda49c095$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($862faa6cda49c095$var$p(92));
            if ($862faa6cda49c095$var$eb(c)) {
                if (1 < c.length) throw Error($862faa6cda49c095$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $862faa6cda49c095$var$Sa(c)
    };
}
function $862faa6cda49c095$var$ib(a, b) {
    var c = $862faa6cda49c095$var$Sa(b.value), d = $862faa6cda49c095$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $862faa6cda49c095$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $862faa6cda49c095$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $862faa6cda49c095$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $862faa6cda49c095$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $862faa6cda49c095$var$mb, $862faa6cda49c095$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $862faa6cda49c095$var$mb = $862faa6cda49c095$var$mb || document.createElement("div");
        $862faa6cda49c095$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $862faa6cda49c095$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $862faa6cda49c095$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $862faa6cda49c095$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $862faa6cda49c095$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($862faa6cda49c095$var$pb).forEach(function(a) {
    $862faa6cda49c095$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $862faa6cda49c095$var$pb[b] = $862faa6cda49c095$var$pb[a];
    });
});
function $862faa6cda49c095$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $862faa6cda49c095$var$pb.hasOwnProperty(a) && $862faa6cda49c095$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $862faa6cda49c095$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $862faa6cda49c095$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $862faa6cda49c095$var$tb = $862faa6cda49c095$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $862faa6cda49c095$var$ub(a, b) {
    if (b) {
        if ($862faa6cda49c095$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($862faa6cda49c095$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($862faa6cda49c095$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($862faa6cda49c095$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($862faa6cda49c095$var$p(62));
    }
}
function $862faa6cda49c095$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $862faa6cda49c095$var$wb = null;
function $862faa6cda49c095$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $862faa6cda49c095$var$yb = null, $862faa6cda49c095$var$zb = null, $862faa6cda49c095$var$Ab = null;
function $862faa6cda49c095$var$Bb(a) {
    if (a = $862faa6cda49c095$var$Cb(a)) {
        if ("function" !== typeof $862faa6cda49c095$var$yb) throw Error($862faa6cda49c095$var$p(280));
        var b = a.stateNode;
        b && (b = $862faa6cda49c095$var$Db(b), $862faa6cda49c095$var$yb(a.stateNode, a.type, b));
    }
}
function $862faa6cda49c095$var$Eb(a) {
    $862faa6cda49c095$var$zb ? $862faa6cda49c095$var$Ab ? $862faa6cda49c095$var$Ab.push(a) : $862faa6cda49c095$var$Ab = [
        a
    ] : $862faa6cda49c095$var$zb = a;
}
function $862faa6cda49c095$var$Fb() {
    if ($862faa6cda49c095$var$zb) {
        var a = $862faa6cda49c095$var$zb, b = $862faa6cda49c095$var$Ab;
        $862faa6cda49c095$var$Ab = $862faa6cda49c095$var$zb = null;
        $862faa6cda49c095$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$862faa6cda49c095$var$Bb(b[a]);
    }
}
function $862faa6cda49c095$var$Gb(a, b) {
    return a(b);
}
function $862faa6cda49c095$var$Hb() {}
var $862faa6cda49c095$var$Ib = !1;
function $862faa6cda49c095$var$Jb(a, b, c) {
    if ($862faa6cda49c095$var$Ib) return a(b, c);
    $862faa6cda49c095$var$Ib = !0;
    try {
        return $862faa6cda49c095$var$Gb(a, b, c);
    } finally{
        if ($862faa6cda49c095$var$Ib = !1, null !== $862faa6cda49c095$var$zb || null !== $862faa6cda49c095$var$Ab) $862faa6cda49c095$var$Hb(), $862faa6cda49c095$var$Fb();
    }
}
function $862faa6cda49c095$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $862faa6cda49c095$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($862faa6cda49c095$var$p(231, b, typeof c));
    return c;
}
var $862faa6cda49c095$var$Lb = !1;
if ($862faa6cda49c095$var$ia) try {
    var $862faa6cda49c095$var$Mb = {};
    Object.defineProperty($862faa6cda49c095$var$Mb, "passive", {
        get: function() {
            $862faa6cda49c095$var$Lb = !0;
        }
    });
    window.addEventListener("test", $862faa6cda49c095$var$Mb, $862faa6cda49c095$var$Mb);
    window.removeEventListener("test", $862faa6cda49c095$var$Mb, $862faa6cda49c095$var$Mb);
} catch (a) {
    $862faa6cda49c095$var$Lb = !1;
}
function $862faa6cda49c095$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $862faa6cda49c095$var$Ob = !1, $862faa6cda49c095$var$Pb = null, $862faa6cda49c095$var$Qb = !1, $862faa6cda49c095$var$Rb = null, $862faa6cda49c095$var$Sb = {
    onError: function(a) {
        $862faa6cda49c095$var$Ob = !0;
        $862faa6cda49c095$var$Pb = a;
    }
};
function $862faa6cda49c095$var$Tb(a, b, c, d, e, f, g, h, k) {
    $862faa6cda49c095$var$Ob = !1;
    $862faa6cda49c095$var$Pb = null;
    $862faa6cda49c095$var$Nb.apply($862faa6cda49c095$var$Sb, arguments);
}
function $862faa6cda49c095$var$Ub(a, b, c, d, e, f, g, h, k) {
    $862faa6cda49c095$var$Tb.apply(this, arguments);
    if ($862faa6cda49c095$var$Ob) {
        if ($862faa6cda49c095$var$Ob) {
            var l = $862faa6cda49c095$var$Pb;
            $862faa6cda49c095$var$Ob = !1;
            $862faa6cda49c095$var$Pb = null;
        } else throw Error($862faa6cda49c095$var$p(198));
        $862faa6cda49c095$var$Qb || ($862faa6cda49c095$var$Qb = !0, $862faa6cda49c095$var$Rb = l);
    }
}
function $862faa6cda49c095$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $862faa6cda49c095$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $862faa6cda49c095$var$Xb(a) {
    if ($862faa6cda49c095$var$Vb(a) !== a) throw Error($862faa6cda49c095$var$p(188));
}
function $862faa6cda49c095$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $862faa6cda49c095$var$Vb(a);
        if (null === b) throw Error($862faa6cda49c095$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $862faa6cda49c095$var$Xb(e), a;
                if (f === d) return $862faa6cda49c095$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($862faa6cda49c095$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($862faa6cda49c095$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($862faa6cda49c095$var$p(190));
    }
    if (3 !== c.tag) throw Error($862faa6cda49c095$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $862faa6cda49c095$var$Zb(a) {
    a = $862faa6cda49c095$var$Yb(a);
    return null !== a ? $862faa6cda49c095$var$$b(a) : null;
}
function $862faa6cda49c095$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $862faa6cda49c095$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $862faa6cda49c095$var$ac = $8TTSu.unstable_scheduleCallback, $862faa6cda49c095$var$bc = $8TTSu.unstable_cancelCallback, $862faa6cda49c095$var$cc = $8TTSu.unstable_shouldYield, $862faa6cda49c095$var$dc = $8TTSu.unstable_requestPaint, $862faa6cda49c095$var$B = $8TTSu.unstable_now, $862faa6cda49c095$var$ec = $8TTSu.unstable_getCurrentPriorityLevel, $862faa6cda49c095$var$fc = $8TTSu.unstable_ImmediatePriority, $862faa6cda49c095$var$gc = $8TTSu.unstable_UserBlockingPriority, $862faa6cda49c095$var$hc = $8TTSu.unstable_NormalPriority, $862faa6cda49c095$var$ic = $8TTSu.unstable_LowPriority, $862faa6cda49c095$var$jc = $8TTSu.unstable_IdlePriority, $862faa6cda49c095$var$kc = null, $862faa6cda49c095$var$lc = null;
function $862faa6cda49c095$var$mc(a) {
    if ($862faa6cda49c095$var$lc && "function" === typeof $862faa6cda49c095$var$lc.onCommitFiberRoot) try {
        $862faa6cda49c095$var$lc.onCommitFiberRoot($862faa6cda49c095$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $862faa6cda49c095$var$oc = Math.clz32 ? Math.clz32 : $862faa6cda49c095$var$nc, $862faa6cda49c095$var$pc = Math.log, $862faa6cda49c095$var$qc = Math.LN2;
function $862faa6cda49c095$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($862faa6cda49c095$var$pc(a) / $862faa6cda49c095$var$qc | 0) | 0;
}
var $862faa6cda49c095$var$rc = 64, $862faa6cda49c095$var$sc = 4194304;
function $862faa6cda49c095$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $862faa6cda49c095$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $862faa6cda49c095$var$tc(h) : (f &= g, 0 !== f && (d = $862faa6cda49c095$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $862faa6cda49c095$var$tc(g) : 0 !== f && (d = $862faa6cda49c095$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $862faa6cda49c095$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $862faa6cda49c095$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $862faa6cda49c095$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $862faa6cda49c095$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $862faa6cda49c095$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $862faa6cda49c095$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $862faa6cda49c095$var$yc() {
    var a = $862faa6cda49c095$var$rc;
    $862faa6cda49c095$var$rc <<= 1;
    0 === ($862faa6cda49c095$var$rc & 4194240) && ($862faa6cda49c095$var$rc = 64);
    return a;
}
function $862faa6cda49c095$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $862faa6cda49c095$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $862faa6cda49c095$var$oc(b);
    a[b] = c;
}
function $862faa6cda49c095$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $862faa6cda49c095$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $862faa6cda49c095$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $862faa6cda49c095$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $862faa6cda49c095$var$C = 0;
function $862faa6cda49c095$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $862faa6cda49c095$var$Ec, $862faa6cda49c095$var$Fc, $862faa6cda49c095$var$Gc, $862faa6cda49c095$var$Hc, $862faa6cda49c095$var$Ic, $862faa6cda49c095$var$Jc = !1, $862faa6cda49c095$var$Kc = [], $862faa6cda49c095$var$Lc = null, $862faa6cda49c095$var$Mc = null, $862faa6cda49c095$var$Nc = null, $862faa6cda49c095$var$Oc = new Map, $862faa6cda49c095$var$Pc = new Map, $862faa6cda49c095$var$Qc = [], $862faa6cda49c095$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $862faa6cda49c095$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $862faa6cda49c095$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $862faa6cda49c095$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $862faa6cda49c095$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $862faa6cda49c095$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $862faa6cda49c095$var$Pc.delete(b.pointerId);
    }
}
function $862faa6cda49c095$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $862faa6cda49c095$var$Cb(b), null !== b && $862faa6cda49c095$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $862faa6cda49c095$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $862faa6cda49c095$var$Lc = $862faa6cda49c095$var$Tc($862faa6cda49c095$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $862faa6cda49c095$var$Mc = $862faa6cda49c095$var$Tc($862faa6cda49c095$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $862faa6cda49c095$var$Nc = $862faa6cda49c095$var$Tc($862faa6cda49c095$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $862faa6cda49c095$var$Oc.set(f, $862faa6cda49c095$var$Tc($862faa6cda49c095$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $862faa6cda49c095$var$Pc.set(f, $862faa6cda49c095$var$Tc($862faa6cda49c095$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $862faa6cda49c095$var$Vc(a) {
    var b = $862faa6cda49c095$var$Wc(a.target);
    if (null !== b) {
        var c = $862faa6cda49c095$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $862faa6cda49c095$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $862faa6cda49c095$var$Ic(a.priority, function() {
                        $862faa6cda49c095$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $862faa6cda49c095$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $862faa6cda49c095$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $862faa6cda49c095$var$wb = d;
            c.target.dispatchEvent(d);
            $862faa6cda49c095$var$wb = null;
        } else return b = $862faa6cda49c095$var$Cb(c), null !== b && $862faa6cda49c095$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $862faa6cda49c095$var$Zc(a, b, c) {
    $862faa6cda49c095$var$Xc(a) && c.delete(b);
}
function $862faa6cda49c095$var$$c() {
    $862faa6cda49c095$var$Jc = !1;
    null !== $862faa6cda49c095$var$Lc && $862faa6cda49c095$var$Xc($862faa6cda49c095$var$Lc) && ($862faa6cda49c095$var$Lc = null);
    null !== $862faa6cda49c095$var$Mc && $862faa6cda49c095$var$Xc($862faa6cda49c095$var$Mc) && ($862faa6cda49c095$var$Mc = null);
    null !== $862faa6cda49c095$var$Nc && $862faa6cda49c095$var$Xc($862faa6cda49c095$var$Nc) && ($862faa6cda49c095$var$Nc = null);
    $862faa6cda49c095$var$Oc.forEach($862faa6cda49c095$var$Zc);
    $862faa6cda49c095$var$Pc.forEach($862faa6cda49c095$var$Zc);
}
function $862faa6cda49c095$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $862faa6cda49c095$var$Jc || ($862faa6cda49c095$var$Jc = !0, $8TTSu.unstable_scheduleCallback($8TTSu.unstable_NormalPriority, $862faa6cda49c095$var$$c)));
}
function $862faa6cda49c095$var$bd(a) {
    function b(b) {
        return $862faa6cda49c095$var$ad(b, a);
    }
    if (0 < $862faa6cda49c095$var$Kc.length) {
        $862faa6cda49c095$var$ad($862faa6cda49c095$var$Kc[0], a);
        for(var c = 1; c < $862faa6cda49c095$var$Kc.length; c++){
            var d = $862faa6cda49c095$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $862faa6cda49c095$var$Lc && $862faa6cda49c095$var$ad($862faa6cda49c095$var$Lc, a);
    null !== $862faa6cda49c095$var$Mc && $862faa6cda49c095$var$ad($862faa6cda49c095$var$Mc, a);
    null !== $862faa6cda49c095$var$Nc && $862faa6cda49c095$var$ad($862faa6cda49c095$var$Nc, a);
    $862faa6cda49c095$var$Oc.forEach(b);
    $862faa6cda49c095$var$Pc.forEach(b);
    for(c = 0; c < $862faa6cda49c095$var$Qc.length; c++)d = $862faa6cda49c095$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $862faa6cda49c095$var$Qc.length && (c = $862faa6cda49c095$var$Qc[0], null === c.blockedOn);)$862faa6cda49c095$var$Vc(c), null === c.blockedOn && $862faa6cda49c095$var$Qc.shift();
}
var $862faa6cda49c095$var$cd = $862faa6cda49c095$var$ua.ReactCurrentBatchConfig, $862faa6cda49c095$var$dd = !0;
function $862faa6cda49c095$var$ed(a, b, c, d) {
    var e = $862faa6cda49c095$var$C, f = $862faa6cda49c095$var$cd.transition;
    $862faa6cda49c095$var$cd.transition = null;
    try {
        $862faa6cda49c095$var$C = 1, $862faa6cda49c095$var$fd(a, b, c, d);
    } finally{
        $862faa6cda49c095$var$C = e, $862faa6cda49c095$var$cd.transition = f;
    }
}
function $862faa6cda49c095$var$gd(a, b, c, d) {
    var e = $862faa6cda49c095$var$C, f = $862faa6cda49c095$var$cd.transition;
    $862faa6cda49c095$var$cd.transition = null;
    try {
        $862faa6cda49c095$var$C = 4, $862faa6cda49c095$var$fd(a, b, c, d);
    } finally{
        $862faa6cda49c095$var$C = e, $862faa6cda49c095$var$cd.transition = f;
    }
}
function $862faa6cda49c095$var$fd(a, b, c, d) {
    if ($862faa6cda49c095$var$dd) {
        var e = $862faa6cda49c095$var$Yc(a, b, c, d);
        if (null === e) $862faa6cda49c095$var$hd(a, b, d, $862faa6cda49c095$var$id, c), $862faa6cda49c095$var$Sc(a, d);
        else if ($862faa6cda49c095$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($862faa6cda49c095$var$Sc(a, d), b & 4 && -1 < $862faa6cda49c095$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $862faa6cda49c095$var$Cb(e);
                null !== f && $862faa6cda49c095$var$Ec(f);
                f = $862faa6cda49c095$var$Yc(a, b, c, d);
                null === f && $862faa6cda49c095$var$hd(a, b, d, $862faa6cda49c095$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $862faa6cda49c095$var$hd(a, b, d, null, c);
    }
}
var $862faa6cda49c095$var$id = null;
function $862faa6cda49c095$var$Yc(a, b, c, d) {
    $862faa6cda49c095$var$id = null;
    a = $862faa6cda49c095$var$xb(d);
    a = $862faa6cda49c095$var$Wc(a);
    if (null !== a) {
        if (b = $862faa6cda49c095$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $862faa6cda49c095$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $862faa6cda49c095$var$id = a;
    return null;
}
function $862faa6cda49c095$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($862faa6cda49c095$var$ec()){
                case $862faa6cda49c095$var$fc:
                    return 1;
                case $862faa6cda49c095$var$gc:
                    return 4;
                case $862faa6cda49c095$var$hc:
                case $862faa6cda49c095$var$ic:
                    return 16;
                case $862faa6cda49c095$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $862faa6cda49c095$var$kd = null, $862faa6cda49c095$var$ld = null, $862faa6cda49c095$var$md = null;
function $862faa6cda49c095$var$nd() {
    if ($862faa6cda49c095$var$md) return $862faa6cda49c095$var$md;
    var a, b = $862faa6cda49c095$var$ld, c = b.length, d, e = "value" in $862faa6cda49c095$var$kd ? $862faa6cda49c095$var$kd.value : $862faa6cda49c095$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $862faa6cda49c095$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $862faa6cda49c095$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $862faa6cda49c095$var$pd() {
    return !0;
}
function $862faa6cda49c095$var$qd() {
    return !1;
}
function $862faa6cda49c095$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $862faa6cda49c095$var$pd : $862faa6cda49c095$var$qd;
        this.isPropagationStopped = $862faa6cda49c095$var$qd;
        return this;
    }
    $862faa6cda49c095$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $862faa6cda49c095$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $862faa6cda49c095$var$pd);
        },
        persist: function() {},
        isPersistent: $862faa6cda49c095$var$pd
    });
    return b;
}
var $862faa6cda49c095$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $862faa6cda49c095$var$td = $862faa6cda49c095$var$rd($862faa6cda49c095$var$sd), $862faa6cda49c095$var$ud = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$sd, {
    view: 0,
    detail: 0
}), $862faa6cda49c095$var$vd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$ud), $862faa6cda49c095$var$wd, $862faa6cda49c095$var$xd, $862faa6cda49c095$var$yd, $862faa6cda49c095$var$Ad = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $862faa6cda49c095$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $862faa6cda49c095$var$yd && ($862faa6cda49c095$var$yd && "mousemove" === a.type ? ($862faa6cda49c095$var$wd = a.screenX - $862faa6cda49c095$var$yd.screenX, $862faa6cda49c095$var$xd = a.screenY - $862faa6cda49c095$var$yd.screenY) : $862faa6cda49c095$var$xd = $862faa6cda49c095$var$wd = 0, $862faa6cda49c095$var$yd = a);
        return $862faa6cda49c095$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $862faa6cda49c095$var$xd;
    }
}), $862faa6cda49c095$var$Bd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Ad), $862faa6cda49c095$var$Cd = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$Ad, {
    dataTransfer: 0
}), $862faa6cda49c095$var$Dd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Cd), $862faa6cda49c095$var$Ed = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$ud, {
    relatedTarget: 0
}), $862faa6cda49c095$var$Fd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Ed), $862faa6cda49c095$var$Gd = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $862faa6cda49c095$var$Hd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Gd), $862faa6cda49c095$var$Id = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $862faa6cda49c095$var$Jd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Id), $862faa6cda49c095$var$Kd = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$sd, {
    data: 0
}), $862faa6cda49c095$var$Ld = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Kd), $862faa6cda49c095$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $862faa6cda49c095$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $862faa6cda49c095$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $862faa6cda49c095$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $862faa6cda49c095$var$Od[a]) ? !!b[a] : !1;
}
function $862faa6cda49c095$var$zd() {
    return $862faa6cda49c095$var$Pd;
}
var $862faa6cda49c095$var$Qd = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $862faa6cda49c095$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $862faa6cda49c095$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $862faa6cda49c095$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $862faa6cda49c095$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $862faa6cda49c095$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $862faa6cda49c095$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $862faa6cda49c095$var$Rd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Qd), $862faa6cda49c095$var$Sd = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $862faa6cda49c095$var$Td = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Sd), $862faa6cda49c095$var$Ud = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $862faa6cda49c095$var$zd
}), $862faa6cda49c095$var$Vd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Ud), $862faa6cda49c095$var$Wd = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $862faa6cda49c095$var$Xd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Wd), $862faa6cda49c095$var$Yd = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $862faa6cda49c095$var$Zd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Yd), $862faa6cda49c095$var$$d = [
    9,
    13,
    27,
    32
], $862faa6cda49c095$var$ae = $862faa6cda49c095$var$ia && "CompositionEvent" in window, $862faa6cda49c095$var$be = null;
$862faa6cda49c095$var$ia && "documentMode" in document && ($862faa6cda49c095$var$be = document.documentMode);
var $862faa6cda49c095$var$ce = $862faa6cda49c095$var$ia && "TextEvent" in window && !$862faa6cda49c095$var$be, $862faa6cda49c095$var$de = $862faa6cda49c095$var$ia && (!$862faa6cda49c095$var$ae || $862faa6cda49c095$var$be && 8 < $862faa6cda49c095$var$be && 11 >= $862faa6cda49c095$var$be), $862faa6cda49c095$var$ee = String.fromCharCode(32), $862faa6cda49c095$var$fe = !1;
function $862faa6cda49c095$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $862faa6cda49c095$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $862faa6cda49c095$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $862faa6cda49c095$var$ie = !1;
function $862faa6cda49c095$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $862faa6cda49c095$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $862faa6cda49c095$var$fe = !0;
            return $862faa6cda49c095$var$ee;
        case "textInput":
            return a = b.data, a === $862faa6cda49c095$var$ee && $862faa6cda49c095$var$fe ? null : a;
        default:
            return null;
    }
}
function $862faa6cda49c095$var$ke(a, b) {
    if ($862faa6cda49c095$var$ie) return "compositionend" === a || !$862faa6cda49c095$var$ae && $862faa6cda49c095$var$ge(a, b) ? (a = $862faa6cda49c095$var$nd(), $862faa6cda49c095$var$md = $862faa6cda49c095$var$ld = $862faa6cda49c095$var$kd = null, $862faa6cda49c095$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $862faa6cda49c095$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $862faa6cda49c095$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $862faa6cda49c095$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$862faa6cda49c095$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $862faa6cda49c095$var$ne(a, b, c, d) {
    $862faa6cda49c095$var$Eb(d);
    b = $862faa6cda49c095$var$oe(b, "onChange");
    0 < b.length && (c = new $862faa6cda49c095$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $862faa6cda49c095$var$pe = null, $862faa6cda49c095$var$qe = null;
function $862faa6cda49c095$var$re(a) {
    $862faa6cda49c095$var$se(a, 0);
}
function $862faa6cda49c095$var$te(a) {
    var b = $862faa6cda49c095$var$ue(a);
    if ($862faa6cda49c095$var$Wa(b)) return a;
}
function $862faa6cda49c095$var$ve(a, b) {
    if ("change" === a) return b;
}
var $862faa6cda49c095$var$we = !1;
if ($862faa6cda49c095$var$ia) {
    var $862faa6cda49c095$var$xe;
    if ($862faa6cda49c095$var$ia) {
        var $862faa6cda49c095$var$ye = "oninput" in document;
        if (!$862faa6cda49c095$var$ye) {
            var $862faa6cda49c095$var$ze = document.createElement("div");
            $862faa6cda49c095$var$ze.setAttribute("oninput", "return;");
            $862faa6cda49c095$var$ye = "function" === typeof $862faa6cda49c095$var$ze.oninput;
        }
        $862faa6cda49c095$var$xe = $862faa6cda49c095$var$ye;
    } else $862faa6cda49c095$var$xe = !1;
    $862faa6cda49c095$var$we = $862faa6cda49c095$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $862faa6cda49c095$var$Ae() {
    $862faa6cda49c095$var$pe && ($862faa6cda49c095$var$pe.detachEvent("onpropertychange", $862faa6cda49c095$var$Be), $862faa6cda49c095$var$qe = $862faa6cda49c095$var$pe = null);
}
function $862faa6cda49c095$var$Be(a) {
    if ("value" === a.propertyName && $862faa6cda49c095$var$te($862faa6cda49c095$var$qe)) {
        var b = [];
        $862faa6cda49c095$var$ne(b, $862faa6cda49c095$var$qe, a, $862faa6cda49c095$var$xb(a));
        $862faa6cda49c095$var$Jb($862faa6cda49c095$var$re, b);
    }
}
function $862faa6cda49c095$var$Ce(a, b, c) {
    "focusin" === a ? ($862faa6cda49c095$var$Ae(), $862faa6cda49c095$var$pe = b, $862faa6cda49c095$var$qe = c, $862faa6cda49c095$var$pe.attachEvent("onpropertychange", $862faa6cda49c095$var$Be)) : "focusout" === a && $862faa6cda49c095$var$Ae();
}
function $862faa6cda49c095$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $862faa6cda49c095$var$te($862faa6cda49c095$var$qe);
}
function $862faa6cda49c095$var$Ee(a, b) {
    if ("click" === a) return $862faa6cda49c095$var$te(b);
}
function $862faa6cda49c095$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $862faa6cda49c095$var$te(b);
}
function $862faa6cda49c095$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $862faa6cda49c095$var$He = "function" === typeof Object.is ? Object.is : $862faa6cda49c095$var$Ge;
function $862faa6cda49c095$var$Ie(a, b) {
    if ($862faa6cda49c095$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$862faa6cda49c095$var$ja.call(b, e) || !$862faa6cda49c095$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $862faa6cda49c095$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $862faa6cda49c095$var$Ke(a, b) {
    var c = $862faa6cda49c095$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $862faa6cda49c095$var$Je(c);
    }
}
function $862faa6cda49c095$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $862faa6cda49c095$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $862faa6cda49c095$var$Me() {
    for(var a = window, b = $862faa6cda49c095$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $862faa6cda49c095$var$Xa(a.document);
    }
    return b;
}
function $862faa6cda49c095$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $862faa6cda49c095$var$Oe(a) {
    var b = $862faa6cda49c095$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $862faa6cda49c095$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $862faa6cda49c095$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $862faa6cda49c095$var$Ke(c, f);
                var g = $862faa6cda49c095$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $862faa6cda49c095$var$Pe = $862faa6cda49c095$var$ia && "documentMode" in document && 11 >= document.documentMode, $862faa6cda49c095$var$Qe = null, $862faa6cda49c095$var$Re = null, $862faa6cda49c095$var$Se = null, $862faa6cda49c095$var$Te = !1;
function $862faa6cda49c095$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $862faa6cda49c095$var$Te || null == $862faa6cda49c095$var$Qe || $862faa6cda49c095$var$Qe !== $862faa6cda49c095$var$Xa(d) || (d = $862faa6cda49c095$var$Qe, "selectionStart" in d && $862faa6cda49c095$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $862faa6cda49c095$var$Se && $862faa6cda49c095$var$Ie($862faa6cda49c095$var$Se, d) || ($862faa6cda49c095$var$Se = d, d = $862faa6cda49c095$var$oe($862faa6cda49c095$var$Re, "onSelect"), 0 < d.length && (b = new $862faa6cda49c095$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $862faa6cda49c095$var$Qe)));
}
function $862faa6cda49c095$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $862faa6cda49c095$var$We = {
    animationend: $862faa6cda49c095$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $862faa6cda49c095$var$Ve("Animation", "AnimationIteration"),
    animationstart: $862faa6cda49c095$var$Ve("Animation", "AnimationStart"),
    transitionend: $862faa6cda49c095$var$Ve("Transition", "TransitionEnd")
}, $862faa6cda49c095$var$Xe = {}, $862faa6cda49c095$var$Ye = {};
$862faa6cda49c095$var$ia && ($862faa6cda49c095$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $862faa6cda49c095$var$We.animationend.animation, delete $862faa6cda49c095$var$We.animationiteration.animation, delete $862faa6cda49c095$var$We.animationstart.animation), "TransitionEvent" in window || delete $862faa6cda49c095$var$We.transitionend.transition);
function $862faa6cda49c095$var$Ze(a) {
    if ($862faa6cda49c095$var$Xe[a]) return $862faa6cda49c095$var$Xe[a];
    if (!$862faa6cda49c095$var$We[a]) return a;
    var b = $862faa6cda49c095$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $862faa6cda49c095$var$Ye) return $862faa6cda49c095$var$Xe[a] = b[c];
    return a;
}
var $862faa6cda49c095$var$$e = $862faa6cda49c095$var$Ze("animationend"), $862faa6cda49c095$var$af = $862faa6cda49c095$var$Ze("animationiteration"), $862faa6cda49c095$var$bf = $862faa6cda49c095$var$Ze("animationstart"), $862faa6cda49c095$var$cf = $862faa6cda49c095$var$Ze("transitionend"), $862faa6cda49c095$var$df = new Map, $862faa6cda49c095$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $862faa6cda49c095$var$ff(a, b) {
    $862faa6cda49c095$var$df.set(a, b);
    $862faa6cda49c095$var$fa(b, [
        a
    ]);
}
for(var $862faa6cda49c095$var$gf = 0; $862faa6cda49c095$var$gf < $862faa6cda49c095$var$ef.length; $862faa6cda49c095$var$gf++){
    var $862faa6cda49c095$var$hf = $862faa6cda49c095$var$ef[$862faa6cda49c095$var$gf], $862faa6cda49c095$var$jf = $862faa6cda49c095$var$hf.toLowerCase(), $862faa6cda49c095$var$kf = $862faa6cda49c095$var$hf[0].toUpperCase() + $862faa6cda49c095$var$hf.slice(1);
    $862faa6cda49c095$var$ff($862faa6cda49c095$var$jf, "on" + $862faa6cda49c095$var$kf);
}
$862faa6cda49c095$var$ff($862faa6cda49c095$var$$e, "onAnimationEnd");
$862faa6cda49c095$var$ff($862faa6cda49c095$var$af, "onAnimationIteration");
$862faa6cda49c095$var$ff($862faa6cda49c095$var$bf, "onAnimationStart");
$862faa6cda49c095$var$ff("dblclick", "onDoubleClick");
$862faa6cda49c095$var$ff("focusin", "onFocus");
$862faa6cda49c095$var$ff("focusout", "onBlur");
$862faa6cda49c095$var$ff($862faa6cda49c095$var$cf, "onTransitionEnd");
$862faa6cda49c095$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$862faa6cda49c095$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$862faa6cda49c095$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$862faa6cda49c095$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$862faa6cda49c095$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$862faa6cda49c095$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$862faa6cda49c095$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$862faa6cda49c095$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$862faa6cda49c095$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$862faa6cda49c095$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $862faa6cda49c095$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $862faa6cda49c095$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($862faa6cda49c095$var$lf));
function $862faa6cda49c095$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $862faa6cda49c095$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $862faa6cda49c095$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $862faa6cda49c095$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $862faa6cda49c095$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($862faa6cda49c095$var$Qb) throw a = $862faa6cda49c095$var$Rb, $862faa6cda49c095$var$Qb = !1, $862faa6cda49c095$var$Rb = null, a;
}
function $862faa6cda49c095$var$D(a, b) {
    var c = b[$862faa6cda49c095$var$of];
    void 0 === c && (c = b[$862faa6cda49c095$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($862faa6cda49c095$var$pf(b, a, 2, !1), c.add(d));
}
function $862faa6cda49c095$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $862faa6cda49c095$var$pf(c, a, d, b);
}
var $862faa6cda49c095$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $862faa6cda49c095$var$sf(a) {
    if (!a[$862faa6cda49c095$var$rf]) {
        a[$862faa6cda49c095$var$rf] = !0;
        $862faa6cda49c095$var$da.forEach(function(b) {
            "selectionchange" !== b && ($862faa6cda49c095$var$mf.has(b) || $862faa6cda49c095$var$qf(b, !1, a), $862faa6cda49c095$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$862faa6cda49c095$var$rf] || (b[$862faa6cda49c095$var$rf] = !0, $862faa6cda49c095$var$qf("selectionchange", !1, b));
    }
}
function $862faa6cda49c095$var$pf(a, b, c, d) {
    switch($862faa6cda49c095$var$jd(b)){
        case 1:
            var e = $862faa6cda49c095$var$ed;
            break;
        case 4:
            e = $862faa6cda49c095$var$gd;
            break;
        default:
            e = $862faa6cda49c095$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$862faa6cda49c095$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $862faa6cda49c095$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $862faa6cda49c095$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $862faa6cda49c095$var$Jb(function() {
        var d = f, e = $862faa6cda49c095$var$xb(c), g = [];
        a: {
            var h = $862faa6cda49c095$var$df.get(a);
            if (void 0 !== h) {
                var k = $862faa6cda49c095$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $862faa6cda49c095$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $862faa6cda49c095$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $862faa6cda49c095$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $862faa6cda49c095$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $862faa6cda49c095$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $862faa6cda49c095$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $862faa6cda49c095$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $862faa6cda49c095$var$Vd;
                        break;
                    case $862faa6cda49c095$var$$e:
                    case $862faa6cda49c095$var$af:
                    case $862faa6cda49c095$var$bf:
                        k = $862faa6cda49c095$var$Hd;
                        break;
                    case $862faa6cda49c095$var$cf:
                        k = $862faa6cda49c095$var$Xd;
                        break;
                    case "scroll":
                        k = $862faa6cda49c095$var$vd;
                        break;
                    case "wheel":
                        k = $862faa6cda49c095$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $862faa6cda49c095$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $862faa6cda49c095$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $862faa6cda49c095$var$Kb(w, x), null != F && t.push($862faa6cda49c095$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $862faa6cda49c095$var$wb && (n = c.relatedTarget || c.fromElement) && ($862faa6cda49c095$var$Wc(n) || n[$862faa6cda49c095$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $862faa6cda49c095$var$Wc(n) : null, null !== n && (J = $862faa6cda49c095$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $862faa6cda49c095$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $862faa6cda49c095$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $862faa6cda49c095$var$ue(k);
                        u = null == n ? h : $862faa6cda49c095$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $862faa6cda49c095$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $862faa6cda49c095$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $862faa6cda49c095$var$vf(F))u++;
                            for(; 0 < w - u;)t = $862faa6cda49c095$var$vf(t), w--;
                            for(; 0 < u - w;)x = $862faa6cda49c095$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $862faa6cda49c095$var$vf(t);
                                x = $862faa6cda49c095$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $862faa6cda49c095$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $862faa6cda49c095$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $862faa6cda49c095$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $862faa6cda49c095$var$ve;
                else if ($862faa6cda49c095$var$me(h)) {
                    if ($862faa6cda49c095$var$we) na = $862faa6cda49c095$var$Fe;
                    else {
                        na = $862faa6cda49c095$var$De;
                        var xa = $862faa6cda49c095$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $862faa6cda49c095$var$Ee);
                if (na && (na = na(a, d))) {
                    $862faa6cda49c095$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $862faa6cda49c095$var$cb(h, "number", h.value);
            }
            xa = d ? $862faa6cda49c095$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($862faa6cda49c095$var$me(xa) || "true" === xa.contentEditable) $862faa6cda49c095$var$Qe = xa, $862faa6cda49c095$var$Re = d, $862faa6cda49c095$var$Se = null;
                    break;
                case "focusout":
                    $862faa6cda49c095$var$Se = $862faa6cda49c095$var$Re = $862faa6cda49c095$var$Qe = null;
                    break;
                case "mousedown":
                    $862faa6cda49c095$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $862faa6cda49c095$var$Te = !1;
                    $862faa6cda49c095$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($862faa6cda49c095$var$Pe) break;
                case "keydown":
                case "keyup":
                    $862faa6cda49c095$var$Ue(g, c, e);
            }
            var $a;
            if ($862faa6cda49c095$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $862faa6cda49c095$var$ie ? $862faa6cda49c095$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($862faa6cda49c095$var$de && "ko" !== c.locale && ($862faa6cda49c095$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $862faa6cda49c095$var$ie && ($a = $862faa6cda49c095$var$nd()) : ($862faa6cda49c095$var$kd = e, $862faa6cda49c095$var$ld = "value" in $862faa6cda49c095$var$kd ? $862faa6cda49c095$var$kd.value : $862faa6cda49c095$var$kd.textContent, $862faa6cda49c095$var$ie = !0)), xa = $862faa6cda49c095$var$oe(d, ba), 0 < xa.length && (ba = new $862faa6cda49c095$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $862faa6cda49c095$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $862faa6cda49c095$var$ce ? $862faa6cda49c095$var$je(a, c) : $862faa6cda49c095$var$ke(a, c)) d = $862faa6cda49c095$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $862faa6cda49c095$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $862faa6cda49c095$var$se(g, b);
    });
}
function $862faa6cda49c095$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $862faa6cda49c095$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $862faa6cda49c095$var$Kb(a, c), null != f && d.unshift($862faa6cda49c095$var$tf(a, f, e)), f = $862faa6cda49c095$var$Kb(a, b), null != f && d.push($862faa6cda49c095$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $862faa6cda49c095$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $862faa6cda49c095$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $862faa6cda49c095$var$Kb(c, f), null != k && g.unshift($862faa6cda49c095$var$tf(c, k, h))) : e || (k = $862faa6cda49c095$var$Kb(c, f), null != k && g.push($862faa6cda49c095$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $862faa6cda49c095$var$xf = /\r\n?/g, $862faa6cda49c095$var$yf = /\u0000|\uFFFD/g;
function $862faa6cda49c095$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($862faa6cda49c095$var$xf, "\n").replace($862faa6cda49c095$var$yf, "");
}
function $862faa6cda49c095$var$Af(a, b, c) {
    b = $862faa6cda49c095$var$zf(b);
    if ($862faa6cda49c095$var$zf(a) !== b && c) throw Error($862faa6cda49c095$var$p(425));
}
function $862faa6cda49c095$var$Bf() {}
var $862faa6cda49c095$var$Cf = null, $862faa6cda49c095$var$Df = null;
function $862faa6cda49c095$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $862faa6cda49c095$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $862faa6cda49c095$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $862faa6cda49c095$var$Hf = "function" === typeof Promise ? Promise : void 0, $862faa6cda49c095$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $862faa6cda49c095$var$Hf ? function(a) {
    return $862faa6cda49c095$var$Hf.resolve(null).then(a).catch($862faa6cda49c095$var$If);
} : $862faa6cda49c095$var$Ff;
function $862faa6cda49c095$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $862faa6cda49c095$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $862faa6cda49c095$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $862faa6cda49c095$var$bd(b);
}
function $862faa6cda49c095$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $862faa6cda49c095$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $862faa6cda49c095$var$Nf = Math.random().toString(36).slice(2), $862faa6cda49c095$var$Of = "__reactFiber$" + $862faa6cda49c095$var$Nf, $862faa6cda49c095$var$Pf = "__reactProps$" + $862faa6cda49c095$var$Nf, $862faa6cda49c095$var$uf = "__reactContainer$" + $862faa6cda49c095$var$Nf, $862faa6cda49c095$var$of = "__reactEvents$" + $862faa6cda49c095$var$Nf, $862faa6cda49c095$var$Qf = "__reactListeners$" + $862faa6cda49c095$var$Nf, $862faa6cda49c095$var$Rf = "__reactHandles$" + $862faa6cda49c095$var$Nf;
function $862faa6cda49c095$var$Wc(a) {
    var b = a[$862faa6cda49c095$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$862faa6cda49c095$var$uf] || c[$862faa6cda49c095$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $862faa6cda49c095$var$Mf(a); null !== a;){
                if (c = a[$862faa6cda49c095$var$Of]) return c;
                a = $862faa6cda49c095$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $862faa6cda49c095$var$Cb(a) {
    a = a[$862faa6cda49c095$var$Of] || a[$862faa6cda49c095$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $862faa6cda49c095$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($862faa6cda49c095$var$p(33));
}
function $862faa6cda49c095$var$Db(a) {
    return a[$862faa6cda49c095$var$Pf] || null;
}
var $862faa6cda49c095$var$Sf = [], $862faa6cda49c095$var$Tf = -1;
function $862faa6cda49c095$var$Uf(a) {
    return {
        current: a
    };
}
function $862faa6cda49c095$var$E(a) {
    0 > $862faa6cda49c095$var$Tf || (a.current = $862faa6cda49c095$var$Sf[$862faa6cda49c095$var$Tf], $862faa6cda49c095$var$Sf[$862faa6cda49c095$var$Tf] = null, $862faa6cda49c095$var$Tf--);
}
function $862faa6cda49c095$var$G(a, b) {
    $862faa6cda49c095$var$Tf++;
    $862faa6cda49c095$var$Sf[$862faa6cda49c095$var$Tf] = a.current;
    a.current = b;
}
var $862faa6cda49c095$var$Vf = {}, $862faa6cda49c095$var$H = $862faa6cda49c095$var$Uf($862faa6cda49c095$var$Vf), $862faa6cda49c095$var$Wf = $862faa6cda49c095$var$Uf(!1), $862faa6cda49c095$var$Xf = $862faa6cda49c095$var$Vf;
function $862faa6cda49c095$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $862faa6cda49c095$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $862faa6cda49c095$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $862faa6cda49c095$var$$f() {
    $862faa6cda49c095$var$E($862faa6cda49c095$var$Wf);
    $862faa6cda49c095$var$E($862faa6cda49c095$var$H);
}
function $862faa6cda49c095$var$ag(a, b, c) {
    if ($862faa6cda49c095$var$H.current !== $862faa6cda49c095$var$Vf) throw Error($862faa6cda49c095$var$p(168));
    $862faa6cda49c095$var$G($862faa6cda49c095$var$H, b);
    $862faa6cda49c095$var$G($862faa6cda49c095$var$Wf, c);
}
function $862faa6cda49c095$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($862faa6cda49c095$var$p(108, $862faa6cda49c095$var$Ra(a) || "Unknown", e));
    return $862faa6cda49c095$var$A({}, c, d);
}
function $862faa6cda49c095$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $862faa6cda49c095$var$Vf;
    $862faa6cda49c095$var$Xf = $862faa6cda49c095$var$H.current;
    $862faa6cda49c095$var$G($862faa6cda49c095$var$H, a);
    $862faa6cda49c095$var$G($862faa6cda49c095$var$Wf, $862faa6cda49c095$var$Wf.current);
    return !0;
}
function $862faa6cda49c095$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($862faa6cda49c095$var$p(169));
    c ? (a = $862faa6cda49c095$var$bg(a, b, $862faa6cda49c095$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $862faa6cda49c095$var$E($862faa6cda49c095$var$Wf), $862faa6cda49c095$var$E($862faa6cda49c095$var$H), $862faa6cda49c095$var$G($862faa6cda49c095$var$H, a)) : $862faa6cda49c095$var$E($862faa6cda49c095$var$Wf);
    $862faa6cda49c095$var$G($862faa6cda49c095$var$Wf, c);
}
var $862faa6cda49c095$var$eg = null, $862faa6cda49c095$var$fg = !1, $862faa6cda49c095$var$gg = !1;
function $862faa6cda49c095$var$hg(a) {
    null === $862faa6cda49c095$var$eg ? $862faa6cda49c095$var$eg = [
        a
    ] : $862faa6cda49c095$var$eg.push(a);
}
function $862faa6cda49c095$var$ig(a) {
    $862faa6cda49c095$var$fg = !0;
    $862faa6cda49c095$var$hg(a);
}
function $862faa6cda49c095$var$jg() {
    if (!$862faa6cda49c095$var$gg && null !== $862faa6cda49c095$var$eg) {
        $862faa6cda49c095$var$gg = !0;
        var a = 0, b = $862faa6cda49c095$var$C;
        try {
            var c = $862faa6cda49c095$var$eg;
            for($862faa6cda49c095$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $862faa6cda49c095$var$eg = null;
            $862faa6cda49c095$var$fg = !1;
        } catch (e) {
            throw null !== $862faa6cda49c095$var$eg && ($862faa6cda49c095$var$eg = $862faa6cda49c095$var$eg.slice(a + 1)), $862faa6cda49c095$var$ac($862faa6cda49c095$var$fc, $862faa6cda49c095$var$jg), e;
        } finally{
            $862faa6cda49c095$var$C = b, $862faa6cda49c095$var$gg = !1;
        }
    }
    return null;
}
var $862faa6cda49c095$var$kg = [], $862faa6cda49c095$var$lg = 0, $862faa6cda49c095$var$mg = null, $862faa6cda49c095$var$ng = 0, $862faa6cda49c095$var$og = [], $862faa6cda49c095$var$pg = 0, $862faa6cda49c095$var$qg = null, $862faa6cda49c095$var$rg = 1, $862faa6cda49c095$var$sg = "";
function $862faa6cda49c095$var$tg(a, b) {
    $862faa6cda49c095$var$kg[$862faa6cda49c095$var$lg++] = $862faa6cda49c095$var$ng;
    $862faa6cda49c095$var$kg[$862faa6cda49c095$var$lg++] = $862faa6cda49c095$var$mg;
    $862faa6cda49c095$var$mg = a;
    $862faa6cda49c095$var$ng = b;
}
function $862faa6cda49c095$var$ug(a, b, c) {
    $862faa6cda49c095$var$og[$862faa6cda49c095$var$pg++] = $862faa6cda49c095$var$rg;
    $862faa6cda49c095$var$og[$862faa6cda49c095$var$pg++] = $862faa6cda49c095$var$sg;
    $862faa6cda49c095$var$og[$862faa6cda49c095$var$pg++] = $862faa6cda49c095$var$qg;
    $862faa6cda49c095$var$qg = a;
    var d = $862faa6cda49c095$var$rg;
    a = $862faa6cda49c095$var$sg;
    var e = 32 - $862faa6cda49c095$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $862faa6cda49c095$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $862faa6cda49c095$var$rg = 1 << 32 - $862faa6cda49c095$var$oc(b) + e | c << e | d;
        $862faa6cda49c095$var$sg = f + a;
    } else $862faa6cda49c095$var$rg = 1 << f | c << e | d, $862faa6cda49c095$var$sg = a;
}
function $862faa6cda49c095$var$vg(a) {
    null !== a.return && ($862faa6cda49c095$var$tg(a, 1), $862faa6cda49c095$var$ug(a, 1, 0));
}
function $862faa6cda49c095$var$wg(a) {
    for(; a === $862faa6cda49c095$var$mg;)$862faa6cda49c095$var$mg = $862faa6cda49c095$var$kg[--$862faa6cda49c095$var$lg], $862faa6cda49c095$var$kg[$862faa6cda49c095$var$lg] = null, $862faa6cda49c095$var$ng = $862faa6cda49c095$var$kg[--$862faa6cda49c095$var$lg], $862faa6cda49c095$var$kg[$862faa6cda49c095$var$lg] = null;
    for(; a === $862faa6cda49c095$var$qg;)$862faa6cda49c095$var$qg = $862faa6cda49c095$var$og[--$862faa6cda49c095$var$pg], $862faa6cda49c095$var$og[$862faa6cda49c095$var$pg] = null, $862faa6cda49c095$var$sg = $862faa6cda49c095$var$og[--$862faa6cda49c095$var$pg], $862faa6cda49c095$var$og[$862faa6cda49c095$var$pg] = null, $862faa6cda49c095$var$rg = $862faa6cda49c095$var$og[--$862faa6cda49c095$var$pg], $862faa6cda49c095$var$og[$862faa6cda49c095$var$pg] = null;
}
var $862faa6cda49c095$var$xg = null, $862faa6cda49c095$var$yg = null, $862faa6cda49c095$var$I = !1, $862faa6cda49c095$var$zg = null;
function $862faa6cda49c095$var$Ag(a, b) {
    var c = $862faa6cda49c095$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $862faa6cda49c095$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $862faa6cda49c095$var$xg = a, $862faa6cda49c095$var$yg = $862faa6cda49c095$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $862faa6cda49c095$var$xg = a, $862faa6cda49c095$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $862faa6cda49c095$var$qg ? {
                id: $862faa6cda49c095$var$rg,
                overflow: $862faa6cda49c095$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $862faa6cda49c095$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $862faa6cda49c095$var$xg = a, $862faa6cda49c095$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $862faa6cda49c095$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $862faa6cda49c095$var$Eg(a) {
    if ($862faa6cda49c095$var$I) {
        var b = $862faa6cda49c095$var$yg;
        if (b) {
            var c = b;
            if (!$862faa6cda49c095$var$Cg(a, b)) {
                if ($862faa6cda49c095$var$Dg(a)) throw Error($862faa6cda49c095$var$p(418));
                b = $862faa6cda49c095$var$Lf(c.nextSibling);
                var d = $862faa6cda49c095$var$xg;
                b && $862faa6cda49c095$var$Cg(a, b) ? $862faa6cda49c095$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $862faa6cda49c095$var$I = !1, $862faa6cda49c095$var$xg = a);
            }
        } else {
            if ($862faa6cda49c095$var$Dg(a)) throw Error($862faa6cda49c095$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $862faa6cda49c095$var$I = !1;
            $862faa6cda49c095$var$xg = a;
        }
    }
}
function $862faa6cda49c095$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $862faa6cda49c095$var$xg = a;
}
function $862faa6cda49c095$var$Gg(a) {
    if (a !== $862faa6cda49c095$var$xg) return !1;
    if (!$862faa6cda49c095$var$I) return $862faa6cda49c095$var$Fg(a), $862faa6cda49c095$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$862faa6cda49c095$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $862faa6cda49c095$var$yg)) {
        if ($862faa6cda49c095$var$Dg(a)) throw $862faa6cda49c095$var$Hg(), Error($862faa6cda49c095$var$p(418));
        for(; b;)$862faa6cda49c095$var$Ag(a, b), b = $862faa6cda49c095$var$Lf(b.nextSibling);
    }
    $862faa6cda49c095$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($862faa6cda49c095$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $862faa6cda49c095$var$yg = $862faa6cda49c095$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $862faa6cda49c095$var$yg = null;
        }
    } else $862faa6cda49c095$var$yg = $862faa6cda49c095$var$xg ? $862faa6cda49c095$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $862faa6cda49c095$var$Hg() {
    for(var a = $862faa6cda49c095$var$yg; a;)a = $862faa6cda49c095$var$Lf(a.nextSibling);
}
function $862faa6cda49c095$var$Ig() {
    $862faa6cda49c095$var$yg = $862faa6cda49c095$var$xg = null;
    $862faa6cda49c095$var$I = !1;
}
function $862faa6cda49c095$var$Jg(a) {
    null === $862faa6cda49c095$var$zg ? $862faa6cda49c095$var$zg = [
        a
    ] : $862faa6cda49c095$var$zg.push(a);
}
var $862faa6cda49c095$var$Kg = $862faa6cda49c095$var$ua.ReactCurrentBatchConfig;
function $862faa6cda49c095$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($862faa6cda49c095$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($862faa6cda49c095$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($862faa6cda49c095$var$p(284));
        if (!c._owner) throw Error($862faa6cda49c095$var$p(290, a));
    }
    return a;
}
function $862faa6cda49c095$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($862faa6cda49c095$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $862faa6cda49c095$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $862faa6cda49c095$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $862faa6cda49c095$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $862faa6cda49c095$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $862faa6cda49c095$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $862faa6cda49c095$var$Ha && $862faa6cda49c095$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $862faa6cda49c095$var$Lg(a, b, c), d.return = a, d;
        d = $862faa6cda49c095$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $862faa6cda49c095$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $862faa6cda49c095$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $862faa6cda49c095$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $862faa6cda49c095$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $862faa6cda49c095$var$va:
                    return c = $862faa6cda49c095$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $862faa6cda49c095$var$Lg(a, null, b), c.return = a, c;
                case $862faa6cda49c095$var$wa:
                    return b = $862faa6cda49c095$var$Sg(b, a.mode, c), b.return = a, b;
                case $862faa6cda49c095$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($862faa6cda49c095$var$eb(b) || $862faa6cda49c095$var$Ka(b)) return b = $862faa6cda49c095$var$Tg(b, a.mode, c, null), b.return = a, b;
            $862faa6cda49c095$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $862faa6cda49c095$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $862faa6cda49c095$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $862faa6cda49c095$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($862faa6cda49c095$var$eb(c) || $862faa6cda49c095$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $862faa6cda49c095$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $862faa6cda49c095$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $862faa6cda49c095$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $862faa6cda49c095$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($862faa6cda49c095$var$eb(d) || $862faa6cda49c095$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $862faa6cda49c095$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $862faa6cda49c095$var$I && $862faa6cda49c095$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $862faa6cda49c095$var$I && $862faa6cda49c095$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $862faa6cda49c095$var$I && $862faa6cda49c095$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $862faa6cda49c095$var$Ka(h);
        if ("function" !== typeof l) throw Error($862faa6cda49c095$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($862faa6cda49c095$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $862faa6cda49c095$var$I && $862faa6cda49c095$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $862faa6cda49c095$var$I && $862faa6cda49c095$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $862faa6cda49c095$var$I && $862faa6cda49c095$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $862faa6cda49c095$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $862faa6cda49c095$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $862faa6cda49c095$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $862faa6cda49c095$var$Ha && $862faa6cda49c095$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $862faa6cda49c095$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $862faa6cda49c095$var$ya ? (d = $862faa6cda49c095$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $862faa6cda49c095$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $862faa6cda49c095$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $862faa6cda49c095$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $862faa6cda49c095$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $862faa6cda49c095$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($862faa6cda49c095$var$eb(f)) return n(a, d, f, h);
            if ($862faa6cda49c095$var$Ka(f)) return t(a, d, f, h);
            $862faa6cda49c095$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $862faa6cda49c095$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $862faa6cda49c095$var$Ug = $862faa6cda49c095$var$Og(!0), $862faa6cda49c095$var$Vg = $862faa6cda49c095$var$Og(!1), $862faa6cda49c095$var$Wg = $862faa6cda49c095$var$Uf(null), $862faa6cda49c095$var$Xg = null, $862faa6cda49c095$var$Yg = null, $862faa6cda49c095$var$Zg = null;
function $862faa6cda49c095$var$$g() {
    $862faa6cda49c095$var$Zg = $862faa6cda49c095$var$Yg = $862faa6cda49c095$var$Xg = null;
}
function $862faa6cda49c095$var$ah(a) {
    var b = $862faa6cda49c095$var$Wg.current;
    $862faa6cda49c095$var$E($862faa6cda49c095$var$Wg);
    a._currentValue = b;
}
function $862faa6cda49c095$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $862faa6cda49c095$var$ch(a, b) {
    $862faa6cda49c095$var$Xg = a;
    $862faa6cda49c095$var$Zg = $862faa6cda49c095$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($862faa6cda49c095$var$dh = !0), a.firstContext = null);
}
function $862faa6cda49c095$var$eh(a) {
    var b = a._currentValue;
    if ($862faa6cda49c095$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $862faa6cda49c095$var$Yg) {
            if (null === $862faa6cda49c095$var$Xg) throw Error($862faa6cda49c095$var$p(308));
            $862faa6cda49c095$var$Yg = a;
            $862faa6cda49c095$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $862faa6cda49c095$var$Yg = $862faa6cda49c095$var$Yg.next = a;
    }
    return b;
}
var $862faa6cda49c095$var$fh = null;
function $862faa6cda49c095$var$gh(a) {
    null === $862faa6cda49c095$var$fh ? $862faa6cda49c095$var$fh = [
        a
    ] : $862faa6cda49c095$var$fh.push(a);
}
function $862faa6cda49c095$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $862faa6cda49c095$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $862faa6cda49c095$var$ih(a, d);
}
function $862faa6cda49c095$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $862faa6cda49c095$var$jh = !1;
function $862faa6cda49c095$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $862faa6cda49c095$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $862faa6cda49c095$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $862faa6cda49c095$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($862faa6cda49c095$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $862faa6cda49c095$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $862faa6cda49c095$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $862faa6cda49c095$var$ih(a, c);
}
function $862faa6cda49c095$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $862faa6cda49c095$var$Cc(a, c);
    }
}
function $862faa6cda49c095$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $862faa6cda49c095$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $862faa6cda49c095$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $862faa6cda49c095$var$A({}, q, r);
                            break a;
                        case 2:
                            $862faa6cda49c095$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $862faa6cda49c095$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $862faa6cda49c095$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($862faa6cda49c095$var$p(191, e));
            e.call(d);
        }
    }
}
var $862faa6cda49c095$var$th = {}, $862faa6cda49c095$var$uh = $862faa6cda49c095$var$Uf($862faa6cda49c095$var$th), $862faa6cda49c095$var$vh = $862faa6cda49c095$var$Uf($862faa6cda49c095$var$th), $862faa6cda49c095$var$wh = $862faa6cda49c095$var$Uf($862faa6cda49c095$var$th);
function $862faa6cda49c095$var$xh(a) {
    if (a === $862faa6cda49c095$var$th) throw Error($862faa6cda49c095$var$p(174));
    return a;
}
function $862faa6cda49c095$var$yh(a, b) {
    $862faa6cda49c095$var$G($862faa6cda49c095$var$wh, b);
    $862faa6cda49c095$var$G($862faa6cda49c095$var$vh, a);
    $862faa6cda49c095$var$G($862faa6cda49c095$var$uh, $862faa6cda49c095$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $862faa6cda49c095$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $862faa6cda49c095$var$lb(b, a);
    }
    $862faa6cda49c095$var$E($862faa6cda49c095$var$uh);
    $862faa6cda49c095$var$G($862faa6cda49c095$var$uh, b);
}
function $862faa6cda49c095$var$zh() {
    $862faa6cda49c095$var$E($862faa6cda49c095$var$uh);
    $862faa6cda49c095$var$E($862faa6cda49c095$var$vh);
    $862faa6cda49c095$var$E($862faa6cda49c095$var$wh);
}
function $862faa6cda49c095$var$Ah(a) {
    $862faa6cda49c095$var$xh($862faa6cda49c095$var$wh.current);
    var b = $862faa6cda49c095$var$xh($862faa6cda49c095$var$uh.current);
    var c = $862faa6cda49c095$var$lb(b, a.type);
    b !== c && ($862faa6cda49c095$var$G($862faa6cda49c095$var$vh, a), $862faa6cda49c095$var$G($862faa6cda49c095$var$uh, c));
}
function $862faa6cda49c095$var$Bh(a) {
    $862faa6cda49c095$var$vh.current === a && ($862faa6cda49c095$var$E($862faa6cda49c095$var$uh), $862faa6cda49c095$var$E($862faa6cda49c095$var$vh));
}
var $862faa6cda49c095$var$L = $862faa6cda49c095$var$Uf(0);
function $862faa6cda49c095$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $862faa6cda49c095$var$Dh = [];
function $862faa6cda49c095$var$Eh() {
    for(var a = 0; a < $862faa6cda49c095$var$Dh.length; a++)$862faa6cda49c095$var$Dh[a]._workInProgressVersionPrimary = null;
    $862faa6cda49c095$var$Dh.length = 0;
}
var $862faa6cda49c095$var$Fh = $862faa6cda49c095$var$ua.ReactCurrentDispatcher, $862faa6cda49c095$var$Gh = $862faa6cda49c095$var$ua.ReactCurrentBatchConfig, $862faa6cda49c095$var$Hh = 0, $862faa6cda49c095$var$M = null, $862faa6cda49c095$var$N = null, $862faa6cda49c095$var$O = null, $862faa6cda49c095$var$Ih = !1, $862faa6cda49c095$var$Jh = !1, $862faa6cda49c095$var$Kh = 0, $862faa6cda49c095$var$Lh = 0;
function $862faa6cda49c095$var$P() {
    throw Error($862faa6cda49c095$var$p(321));
}
function $862faa6cda49c095$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$862faa6cda49c095$var$He(a[c], b[c])) return !1;
    return !0;
}
function $862faa6cda49c095$var$Nh(a, b, c, d, e, f) {
    $862faa6cda49c095$var$Hh = f;
    $862faa6cda49c095$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $862faa6cda49c095$var$Fh.current = null === a || null === a.memoizedState ? $862faa6cda49c095$var$Oh : $862faa6cda49c095$var$Ph;
    a = c(d, e);
    if ($862faa6cda49c095$var$Jh) {
        f = 0;
        do {
            $862faa6cda49c095$var$Jh = !1;
            $862faa6cda49c095$var$Kh = 0;
            if (25 <= f) throw Error($862faa6cda49c095$var$p(301));
            f += 1;
            $862faa6cda49c095$var$O = $862faa6cda49c095$var$N = null;
            b.updateQueue = null;
            $862faa6cda49c095$var$Fh.current = $862faa6cda49c095$var$Qh;
            a = c(d, e);
        }while ($862faa6cda49c095$var$Jh);
    }
    $862faa6cda49c095$var$Fh.current = $862faa6cda49c095$var$Rh;
    b = null !== $862faa6cda49c095$var$N && null !== $862faa6cda49c095$var$N.next;
    $862faa6cda49c095$var$Hh = 0;
    $862faa6cda49c095$var$O = $862faa6cda49c095$var$N = $862faa6cda49c095$var$M = null;
    $862faa6cda49c095$var$Ih = !1;
    if (b) throw Error($862faa6cda49c095$var$p(300));
    return a;
}
function $862faa6cda49c095$var$Sh() {
    var a = 0 !== $862faa6cda49c095$var$Kh;
    $862faa6cda49c095$var$Kh = 0;
    return a;
}
function $862faa6cda49c095$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $862faa6cda49c095$var$O ? $862faa6cda49c095$var$M.memoizedState = $862faa6cda49c095$var$O = a : $862faa6cda49c095$var$O = $862faa6cda49c095$var$O.next = a;
    return $862faa6cda49c095$var$O;
}
function $862faa6cda49c095$var$Uh() {
    if (null === $862faa6cda49c095$var$N) {
        var a = $862faa6cda49c095$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $862faa6cda49c095$var$N.next;
    var b = null === $862faa6cda49c095$var$O ? $862faa6cda49c095$var$M.memoizedState : $862faa6cda49c095$var$O.next;
    if (null !== b) $862faa6cda49c095$var$O = b, $862faa6cda49c095$var$N = a;
    else {
        if (null === a) throw Error($862faa6cda49c095$var$p(310));
        $862faa6cda49c095$var$N = a;
        a = {
            memoizedState: $862faa6cda49c095$var$N.memoizedState,
            baseState: $862faa6cda49c095$var$N.baseState,
            baseQueue: $862faa6cda49c095$var$N.baseQueue,
            queue: $862faa6cda49c095$var$N.queue,
            next: null
        };
        null === $862faa6cda49c095$var$O ? $862faa6cda49c095$var$M.memoizedState = $862faa6cda49c095$var$O = a : $862faa6cda49c095$var$O = $862faa6cda49c095$var$O.next = a;
    }
    return $862faa6cda49c095$var$O;
}
function $862faa6cda49c095$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $862faa6cda49c095$var$Wh(a) {
    var b = $862faa6cda49c095$var$Uh(), c = b.queue;
    if (null === c) throw Error($862faa6cda49c095$var$p(311));
    c.lastRenderedReducer = a;
    var d = $862faa6cda49c095$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($862faa6cda49c095$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $862faa6cda49c095$var$M.lanes |= m;
                $862faa6cda49c095$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $862faa6cda49c095$var$He(d, b.memoizedState) || ($862faa6cda49c095$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $862faa6cda49c095$var$M.lanes |= f, $862faa6cda49c095$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $862faa6cda49c095$var$Xh(a) {
    var b = $862faa6cda49c095$var$Uh(), c = b.queue;
    if (null === c) throw Error($862faa6cda49c095$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $862faa6cda49c095$var$He(f, b.memoizedState) || ($862faa6cda49c095$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $862faa6cda49c095$var$Yh() {}
function $862faa6cda49c095$var$Zh(a, b) {
    var c = $862faa6cda49c095$var$M, d = $862faa6cda49c095$var$Uh(), e = b(), f = !$862faa6cda49c095$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $862faa6cda49c095$var$dh = !0);
    d = d.queue;
    $862faa6cda49c095$var$$h($862faa6cda49c095$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $862faa6cda49c095$var$O && $862faa6cda49c095$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $862faa6cda49c095$var$bi(9, $862faa6cda49c095$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $862faa6cda49c095$var$Q) throw Error($862faa6cda49c095$var$p(349));
        0 !== ($862faa6cda49c095$var$Hh & 30) || $862faa6cda49c095$var$di(c, b, e);
    }
    return e;
}
function $862faa6cda49c095$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $862faa6cda49c095$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $862faa6cda49c095$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $862faa6cda49c095$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $862faa6cda49c095$var$ei(b) && $862faa6cda49c095$var$fi(a);
}
function $862faa6cda49c095$var$ai(a, b, c) {
    return c(function() {
        $862faa6cda49c095$var$ei(b) && $862faa6cda49c095$var$fi(a);
    });
}
function $862faa6cda49c095$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$862faa6cda49c095$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $862faa6cda49c095$var$fi(a) {
    var b = $862faa6cda49c095$var$ih(a, 1);
    null !== b && $862faa6cda49c095$var$gi(b, a, 1, -1);
}
function $862faa6cda49c095$var$hi(a) {
    var b = $862faa6cda49c095$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $862faa6cda49c095$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $862faa6cda49c095$var$ii.bind(null, $862faa6cda49c095$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $862faa6cda49c095$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $862faa6cda49c095$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $862faa6cda49c095$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $862faa6cda49c095$var$ji() {
    return $862faa6cda49c095$var$Uh().memoizedState;
}
function $862faa6cda49c095$var$ki(a, b, c, d) {
    var e = $862faa6cda49c095$var$Th();
    $862faa6cda49c095$var$M.flags |= a;
    e.memoizedState = $862faa6cda49c095$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $862faa6cda49c095$var$li(a, b, c, d) {
    var e = $862faa6cda49c095$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $862faa6cda49c095$var$N) {
        var g = $862faa6cda49c095$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $862faa6cda49c095$var$Mh(d, g.deps)) {
            e.memoizedState = $862faa6cda49c095$var$bi(b, c, f, d);
            return;
        }
    }
    $862faa6cda49c095$var$M.flags |= a;
    e.memoizedState = $862faa6cda49c095$var$bi(1 | b, c, f, d);
}
function $862faa6cda49c095$var$mi(a, b) {
    return $862faa6cda49c095$var$ki(8390656, 8, a, b);
}
function $862faa6cda49c095$var$$h(a, b) {
    return $862faa6cda49c095$var$li(2048, 8, a, b);
}
function $862faa6cda49c095$var$ni(a, b) {
    return $862faa6cda49c095$var$li(4, 2, a, b);
}
function $862faa6cda49c095$var$oi(a, b) {
    return $862faa6cda49c095$var$li(4, 4, a, b);
}
function $862faa6cda49c095$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $862faa6cda49c095$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $862faa6cda49c095$var$li(4, 4, $862faa6cda49c095$var$pi.bind(null, b, a), c);
}
function $862faa6cda49c095$var$ri() {}
function $862faa6cda49c095$var$si(a, b) {
    var c = $862faa6cda49c095$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $862faa6cda49c095$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $862faa6cda49c095$var$ti(a, b) {
    var c = $862faa6cda49c095$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $862faa6cda49c095$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $862faa6cda49c095$var$ui(a, b, c) {
    if (0 === ($862faa6cda49c095$var$Hh & 21)) return a.baseState && (a.baseState = !1, $862faa6cda49c095$var$dh = !0), a.memoizedState = c;
    $862faa6cda49c095$var$He(c, b) || (c = $862faa6cda49c095$var$yc(), $862faa6cda49c095$var$M.lanes |= c, $862faa6cda49c095$var$rh |= c, a.baseState = !0);
    return b;
}
function $862faa6cda49c095$var$vi(a, b) {
    var c = $862faa6cda49c095$var$C;
    $862faa6cda49c095$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $862faa6cda49c095$var$Gh.transition;
    $862faa6cda49c095$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $862faa6cda49c095$var$C = c, $862faa6cda49c095$var$Gh.transition = d;
    }
}
function $862faa6cda49c095$var$wi() {
    return $862faa6cda49c095$var$Uh().memoizedState;
}
function $862faa6cda49c095$var$xi(a, b, c) {
    var d = $862faa6cda49c095$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($862faa6cda49c095$var$zi(a)) $862faa6cda49c095$var$Ai(b, c);
    else if (c = $862faa6cda49c095$var$hh(a, b, c, d), null !== c) {
        var e = $862faa6cda49c095$var$R();
        $862faa6cda49c095$var$gi(c, a, d, e);
        $862faa6cda49c095$var$Bi(c, b, d);
    }
}
function $862faa6cda49c095$var$ii(a, b, c) {
    var d = $862faa6cda49c095$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($862faa6cda49c095$var$zi(a)) $862faa6cda49c095$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($862faa6cda49c095$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $862faa6cda49c095$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $862faa6cda49c095$var$hh(a, b, e, d);
        null !== c && (e = $862faa6cda49c095$var$R(), $862faa6cda49c095$var$gi(c, a, d, e), $862faa6cda49c095$var$Bi(c, b, d));
    }
}
function $862faa6cda49c095$var$zi(a) {
    var b = a.alternate;
    return a === $862faa6cda49c095$var$M || null !== b && b === $862faa6cda49c095$var$M;
}
function $862faa6cda49c095$var$Ai(a, b) {
    $862faa6cda49c095$var$Jh = $862faa6cda49c095$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $862faa6cda49c095$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $862faa6cda49c095$var$Cc(a, c);
    }
}
var $862faa6cda49c095$var$Rh = {
    readContext: $862faa6cda49c095$var$eh,
    useCallback: $862faa6cda49c095$var$P,
    useContext: $862faa6cda49c095$var$P,
    useEffect: $862faa6cda49c095$var$P,
    useImperativeHandle: $862faa6cda49c095$var$P,
    useInsertionEffect: $862faa6cda49c095$var$P,
    useLayoutEffect: $862faa6cda49c095$var$P,
    useMemo: $862faa6cda49c095$var$P,
    useReducer: $862faa6cda49c095$var$P,
    useRef: $862faa6cda49c095$var$P,
    useState: $862faa6cda49c095$var$P,
    useDebugValue: $862faa6cda49c095$var$P,
    useDeferredValue: $862faa6cda49c095$var$P,
    useTransition: $862faa6cda49c095$var$P,
    useMutableSource: $862faa6cda49c095$var$P,
    useSyncExternalStore: $862faa6cda49c095$var$P,
    useId: $862faa6cda49c095$var$P,
    unstable_isNewReconciler: !1
}, $862faa6cda49c095$var$Oh = {
    readContext: $862faa6cda49c095$var$eh,
    useCallback: function(a, b) {
        $862faa6cda49c095$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $862faa6cda49c095$var$eh,
    useEffect: $862faa6cda49c095$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $862faa6cda49c095$var$ki(4194308, 4, $862faa6cda49c095$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $862faa6cda49c095$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $862faa6cda49c095$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $862faa6cda49c095$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $862faa6cda49c095$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $862faa6cda49c095$var$xi.bind(null, $862faa6cda49c095$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $862faa6cda49c095$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $862faa6cda49c095$var$hi,
    useDebugValue: $862faa6cda49c095$var$ri,
    useDeferredValue: function(a) {
        return $862faa6cda49c095$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $862faa6cda49c095$var$hi(!1), b = a[0];
        a = $862faa6cda49c095$var$vi.bind(null, a[1]);
        $862faa6cda49c095$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $862faa6cda49c095$var$M, e = $862faa6cda49c095$var$Th();
        if ($862faa6cda49c095$var$I) {
            if (void 0 === c) throw Error($862faa6cda49c095$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $862faa6cda49c095$var$Q) throw Error($862faa6cda49c095$var$p(349));
            0 !== ($862faa6cda49c095$var$Hh & 30) || $862faa6cda49c095$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $862faa6cda49c095$var$mi($862faa6cda49c095$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $862faa6cda49c095$var$bi(9, $862faa6cda49c095$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $862faa6cda49c095$var$Th(), b = $862faa6cda49c095$var$Q.identifierPrefix;
        if ($862faa6cda49c095$var$I) {
            var c = $862faa6cda49c095$var$sg;
            var d = $862faa6cda49c095$var$rg;
            c = (d & ~(1 << 32 - $862faa6cda49c095$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $862faa6cda49c095$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $862faa6cda49c095$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $862faa6cda49c095$var$Ph = {
    readContext: $862faa6cda49c095$var$eh,
    useCallback: $862faa6cda49c095$var$si,
    useContext: $862faa6cda49c095$var$eh,
    useEffect: $862faa6cda49c095$var$$h,
    useImperativeHandle: $862faa6cda49c095$var$qi,
    useInsertionEffect: $862faa6cda49c095$var$ni,
    useLayoutEffect: $862faa6cda49c095$var$oi,
    useMemo: $862faa6cda49c095$var$ti,
    useReducer: $862faa6cda49c095$var$Wh,
    useRef: $862faa6cda49c095$var$ji,
    useState: function() {
        return $862faa6cda49c095$var$Wh($862faa6cda49c095$var$Vh);
    },
    useDebugValue: $862faa6cda49c095$var$ri,
    useDeferredValue: function(a) {
        var b = $862faa6cda49c095$var$Uh();
        return $862faa6cda49c095$var$ui(b, $862faa6cda49c095$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $862faa6cda49c095$var$Wh($862faa6cda49c095$var$Vh)[0], b = $862faa6cda49c095$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $862faa6cda49c095$var$Yh,
    useSyncExternalStore: $862faa6cda49c095$var$Zh,
    useId: $862faa6cda49c095$var$wi,
    unstable_isNewReconciler: !1
}, $862faa6cda49c095$var$Qh = {
    readContext: $862faa6cda49c095$var$eh,
    useCallback: $862faa6cda49c095$var$si,
    useContext: $862faa6cda49c095$var$eh,
    useEffect: $862faa6cda49c095$var$$h,
    useImperativeHandle: $862faa6cda49c095$var$qi,
    useInsertionEffect: $862faa6cda49c095$var$ni,
    useLayoutEffect: $862faa6cda49c095$var$oi,
    useMemo: $862faa6cda49c095$var$ti,
    useReducer: $862faa6cda49c095$var$Xh,
    useRef: $862faa6cda49c095$var$ji,
    useState: function() {
        return $862faa6cda49c095$var$Xh($862faa6cda49c095$var$Vh);
    },
    useDebugValue: $862faa6cda49c095$var$ri,
    useDeferredValue: function(a) {
        var b = $862faa6cda49c095$var$Uh();
        return null === $862faa6cda49c095$var$N ? b.memoizedState = a : $862faa6cda49c095$var$ui(b, $862faa6cda49c095$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $862faa6cda49c095$var$Xh($862faa6cda49c095$var$Vh)[0], b = $862faa6cda49c095$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $862faa6cda49c095$var$Yh,
    useSyncExternalStore: $862faa6cda49c095$var$Zh,
    useId: $862faa6cda49c095$var$wi,
    unstable_isNewReconciler: !1
};
function $862faa6cda49c095$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $862faa6cda49c095$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $862faa6cda49c095$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $862faa6cda49c095$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $862faa6cda49c095$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $862faa6cda49c095$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $862faa6cda49c095$var$R(), e = $862faa6cda49c095$var$yi(a), f = $862faa6cda49c095$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $862faa6cda49c095$var$nh(a, f, e);
        null !== b && ($862faa6cda49c095$var$gi(b, a, e, d), $862faa6cda49c095$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $862faa6cda49c095$var$R(), e = $862faa6cda49c095$var$yi(a), f = $862faa6cda49c095$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $862faa6cda49c095$var$nh(a, f, e);
        null !== b && ($862faa6cda49c095$var$gi(b, a, e, d), $862faa6cda49c095$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $862faa6cda49c095$var$R(), d = $862faa6cda49c095$var$yi(a), e = $862faa6cda49c095$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $862faa6cda49c095$var$nh(a, e, d);
        null !== b && ($862faa6cda49c095$var$gi(b, a, d, c), $862faa6cda49c095$var$oh(b, a, d));
    }
};
function $862faa6cda49c095$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$862faa6cda49c095$var$Ie(c, d) || !$862faa6cda49c095$var$Ie(e, f) : !0;
}
function $862faa6cda49c095$var$Gi(a, b, c) {
    var d = !1, e = $862faa6cda49c095$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $862faa6cda49c095$var$eh(f) : (e = $862faa6cda49c095$var$Zf(b) ? $862faa6cda49c095$var$Xf : $862faa6cda49c095$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $862faa6cda49c095$var$Yf(a, e) : $862faa6cda49c095$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $862faa6cda49c095$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $862faa6cda49c095$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $862faa6cda49c095$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $862faa6cda49c095$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $862faa6cda49c095$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $862faa6cda49c095$var$eh(f) : (f = $862faa6cda49c095$var$Zf(b) ? $862faa6cda49c095$var$Xf : $862faa6cda49c095$var$H.current, e.context = $862faa6cda49c095$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($862faa6cda49c095$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $862faa6cda49c095$var$Ei.enqueueReplaceState(e, e.state, null), $862faa6cda49c095$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $862faa6cda49c095$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $862faa6cda49c095$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $862faa6cda49c095$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $862faa6cda49c095$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $862faa6cda49c095$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $862faa6cda49c095$var$Ni(a, b, c) {
    c = $862faa6cda49c095$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $862faa6cda49c095$var$Oi || ($862faa6cda49c095$var$Oi = !0, $862faa6cda49c095$var$Pi = d);
        $862faa6cda49c095$var$Li(a, b);
    };
    return c;
}
function $862faa6cda49c095$var$Qi(a, b, c) {
    c = $862faa6cda49c095$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $862faa6cda49c095$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $862faa6cda49c095$var$Li(a, b);
        "function" !== typeof d && (null === $862faa6cda49c095$var$Ri ? $862faa6cda49c095$var$Ri = new Set([
            this
        ]) : $862faa6cda49c095$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $862faa6cda49c095$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $862faa6cda49c095$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $862faa6cda49c095$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $862faa6cda49c095$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $862faa6cda49c095$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $862faa6cda49c095$var$mh(-1, 1), b.tag = 2, $862faa6cda49c095$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $862faa6cda49c095$var$Wi = $862faa6cda49c095$var$ua.ReactCurrentOwner, $862faa6cda49c095$var$dh = !1;
function $862faa6cda49c095$var$Xi(a, b, c, d) {
    b.child = null === a ? $862faa6cda49c095$var$Vg(b, null, c, d) : $862faa6cda49c095$var$Ug(b, a.child, c, d);
}
function $862faa6cda49c095$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $862faa6cda49c095$var$ch(b, e);
    d = $862faa6cda49c095$var$Nh(a, b, c, d, f, e);
    c = $862faa6cda49c095$var$Sh();
    if (null !== a && !$862faa6cda49c095$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $862faa6cda49c095$var$Zi(a, b, e);
    $862faa6cda49c095$var$I && c && $862faa6cda49c095$var$vg(b);
    b.flags |= 1;
    $862faa6cda49c095$var$Xi(a, b, d, e);
    return b.child;
}
function $862faa6cda49c095$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$862faa6cda49c095$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $862faa6cda49c095$var$bj(a, b, f, d, e);
        a = $862faa6cda49c095$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $862faa6cda49c095$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $862faa6cda49c095$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $862faa6cda49c095$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $862faa6cda49c095$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($862faa6cda49c095$var$Ie(f, d) && a.ref === b.ref) {
            if ($862faa6cda49c095$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($862faa6cda49c095$var$dh = !0);
            else return b.lanes = a.lanes, $862faa6cda49c095$var$Zi(a, b, e);
        }
    }
    return $862faa6cda49c095$var$cj(a, b, c, d, e);
}
function $862faa6cda49c095$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $862faa6cda49c095$var$G($862faa6cda49c095$var$ej, $862faa6cda49c095$var$fj), $862faa6cda49c095$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $862faa6cda49c095$var$G($862faa6cda49c095$var$ej, $862faa6cda49c095$var$fj), $862faa6cda49c095$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $862faa6cda49c095$var$G($862faa6cda49c095$var$ej, $862faa6cda49c095$var$fj);
            $862faa6cda49c095$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $862faa6cda49c095$var$G($862faa6cda49c095$var$ej, $862faa6cda49c095$var$fj), $862faa6cda49c095$var$fj |= d;
    $862faa6cda49c095$var$Xi(a, b, e, c);
    return b.child;
}
function $862faa6cda49c095$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $862faa6cda49c095$var$cj(a, b, c, d, e) {
    var f = $862faa6cda49c095$var$Zf(c) ? $862faa6cda49c095$var$Xf : $862faa6cda49c095$var$H.current;
    f = $862faa6cda49c095$var$Yf(b, f);
    $862faa6cda49c095$var$ch(b, e);
    c = $862faa6cda49c095$var$Nh(a, b, c, d, f, e);
    d = $862faa6cda49c095$var$Sh();
    if (null !== a && !$862faa6cda49c095$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $862faa6cda49c095$var$Zi(a, b, e);
    $862faa6cda49c095$var$I && d && $862faa6cda49c095$var$vg(b);
    b.flags |= 1;
    $862faa6cda49c095$var$Xi(a, b, c, e);
    return b.child;
}
function $862faa6cda49c095$var$hj(a, b, c, d, e) {
    if ($862faa6cda49c095$var$Zf(c)) {
        var f = !0;
        $862faa6cda49c095$var$cg(b);
    } else f = !1;
    $862faa6cda49c095$var$ch(b, e);
    if (null === b.stateNode) $862faa6cda49c095$var$ij(a, b), $862faa6cda49c095$var$Gi(b, c, d), $862faa6cda49c095$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $862faa6cda49c095$var$eh(l) : (l = $862faa6cda49c095$var$Zf(c) ? $862faa6cda49c095$var$Xf : $862faa6cda49c095$var$H.current, l = $862faa6cda49c095$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $862faa6cda49c095$var$Hi(b, g, d, l);
        $862faa6cda49c095$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $862faa6cda49c095$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $862faa6cda49c095$var$Wf.current || $862faa6cda49c095$var$jh ? ("function" === typeof m && ($862faa6cda49c095$var$Di(b, c, m, d), k = b.memoizedState), (h = $862faa6cda49c095$var$jh || $862faa6cda49c095$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $862faa6cda49c095$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $862faa6cda49c095$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $862faa6cda49c095$var$eh(k) : (k = $862faa6cda49c095$var$Zf(c) ? $862faa6cda49c095$var$Xf : $862faa6cda49c095$var$H.current, k = $862faa6cda49c095$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $862faa6cda49c095$var$Hi(b, g, d, k);
        $862faa6cda49c095$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $862faa6cda49c095$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $862faa6cda49c095$var$Wf.current || $862faa6cda49c095$var$jh ? ("function" === typeof y && ($862faa6cda49c095$var$Di(b, c, y, d), n = b.memoizedState), (l = $862faa6cda49c095$var$jh || $862faa6cda49c095$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $862faa6cda49c095$var$jj(a, b, c, d, f, e);
}
function $862faa6cda49c095$var$jj(a, b, c, d, e, f) {
    $862faa6cda49c095$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $862faa6cda49c095$var$dg(b, c, !1), $862faa6cda49c095$var$Zi(a, b, f);
    d = b.stateNode;
    $862faa6cda49c095$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $862faa6cda49c095$var$Ug(b, a.child, null, f), b.child = $862faa6cda49c095$var$Ug(b, null, h, f)) : $862faa6cda49c095$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $862faa6cda49c095$var$dg(b, c, !0);
    return b.child;
}
function $862faa6cda49c095$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $862faa6cda49c095$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $862faa6cda49c095$var$ag(a, b.context, !1);
    $862faa6cda49c095$var$yh(a, b.containerInfo);
}
function $862faa6cda49c095$var$lj(a, b, c, d, e) {
    $862faa6cda49c095$var$Ig();
    $862faa6cda49c095$var$Jg(e);
    b.flags |= 256;
    $862faa6cda49c095$var$Xi(a, b, c, d);
    return b.child;
}
var $862faa6cda49c095$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $862faa6cda49c095$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $862faa6cda49c095$var$oj(a, b, c) {
    var d = b.pendingProps, e = $862faa6cda49c095$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $862faa6cda49c095$var$G($862faa6cda49c095$var$L, e & 1);
    if (null === a) {
        $862faa6cda49c095$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $862faa6cda49c095$var$pj(g, d, 0, null), a = $862faa6cda49c095$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $862faa6cda49c095$var$nj(c), b.memoizedState = $862faa6cda49c095$var$mj, a) : $862faa6cda49c095$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $862faa6cda49c095$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $862faa6cda49c095$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $862faa6cda49c095$var$Pg(h, f) : (f = $862faa6cda49c095$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $862faa6cda49c095$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $862faa6cda49c095$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $862faa6cda49c095$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $862faa6cda49c095$var$qj(a, b) {
    b = $862faa6cda49c095$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $862faa6cda49c095$var$sj(a, b, c, d) {
    null !== d && $862faa6cda49c095$var$Jg(d);
    $862faa6cda49c095$var$Ug(b, a.child, null, c);
    a = $862faa6cda49c095$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $862faa6cda49c095$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $862faa6cda49c095$var$Ki(Error($862faa6cda49c095$var$p(422))), $862faa6cda49c095$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $862faa6cda49c095$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $862faa6cda49c095$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $862faa6cda49c095$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $862faa6cda49c095$var$nj(g);
        b.memoizedState = $862faa6cda49c095$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $862faa6cda49c095$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($862faa6cda49c095$var$p(419));
        d = $862faa6cda49c095$var$Ki(f, d, void 0);
        return $862faa6cda49c095$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($862faa6cda49c095$var$dh || h) {
        d = $862faa6cda49c095$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $862faa6cda49c095$var$ih(a, e), $862faa6cda49c095$var$gi(d, a, e, -1));
        }
        $862faa6cda49c095$var$tj();
        d = $862faa6cda49c095$var$Ki(Error($862faa6cda49c095$var$p(421)));
        return $862faa6cda49c095$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $862faa6cda49c095$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $862faa6cda49c095$var$yg = $862faa6cda49c095$var$Lf(e.nextSibling);
    $862faa6cda49c095$var$xg = b;
    $862faa6cda49c095$var$I = !0;
    $862faa6cda49c095$var$zg = null;
    null !== a && ($862faa6cda49c095$var$og[$862faa6cda49c095$var$pg++] = $862faa6cda49c095$var$rg, $862faa6cda49c095$var$og[$862faa6cda49c095$var$pg++] = $862faa6cda49c095$var$sg, $862faa6cda49c095$var$og[$862faa6cda49c095$var$pg++] = $862faa6cda49c095$var$qg, $862faa6cda49c095$var$rg = a.id, $862faa6cda49c095$var$sg = a.overflow, $862faa6cda49c095$var$qg = b);
    b = $862faa6cda49c095$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $862faa6cda49c095$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $862faa6cda49c095$var$bh(a.return, b, c);
}
function $862faa6cda49c095$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $862faa6cda49c095$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $862faa6cda49c095$var$Xi(a, b, d.children, c);
    d = $862faa6cda49c095$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $862faa6cda49c095$var$vj(a, c, b);
            else if (19 === a.tag) $862faa6cda49c095$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $862faa6cda49c095$var$G($862faa6cda49c095$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $862faa6cda49c095$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $862faa6cda49c095$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $862faa6cda49c095$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $862faa6cda49c095$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $862faa6cda49c095$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $862faa6cda49c095$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $862faa6cda49c095$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $862faa6cda49c095$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($862faa6cda49c095$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $862faa6cda49c095$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $862faa6cda49c095$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $862faa6cda49c095$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $862faa6cda49c095$var$kj(b);
            $862faa6cda49c095$var$Ig();
            break;
        case 5:
            $862faa6cda49c095$var$Ah(b);
            break;
        case 1:
            $862faa6cda49c095$var$Zf(b.type) && $862faa6cda49c095$var$cg(b);
            break;
        case 4:
            $862faa6cda49c095$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $862faa6cda49c095$var$G($862faa6cda49c095$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $862faa6cda49c095$var$G($862faa6cda49c095$var$L, $862faa6cda49c095$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $862faa6cda49c095$var$oj(a, b, c);
                $862faa6cda49c095$var$G($862faa6cda49c095$var$L, $862faa6cda49c095$var$L.current & 1);
                a = $862faa6cda49c095$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $862faa6cda49c095$var$G($862faa6cda49c095$var$L, $862faa6cda49c095$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $862faa6cda49c095$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $862faa6cda49c095$var$G($862faa6cda49c095$var$L, $862faa6cda49c095$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $862faa6cda49c095$var$dj(a, b, c);
    }
    return $862faa6cda49c095$var$Zi(a, b, c);
}
var $862faa6cda49c095$var$zj, $862faa6cda49c095$var$Aj, $862faa6cda49c095$var$Bj, $862faa6cda49c095$var$Cj;
$862faa6cda49c095$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$862faa6cda49c095$var$Aj = function() {};
$862faa6cda49c095$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $862faa6cda49c095$var$xh($862faa6cda49c095$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $862faa6cda49c095$var$Ya(a, e);
                d = $862faa6cda49c095$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $862faa6cda49c095$var$A({}, e, {
                    value: void 0
                });
                d = $862faa6cda49c095$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $862faa6cda49c095$var$gb(a, e);
                d = $862faa6cda49c095$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $862faa6cda49c095$var$Bf);
        }
        $862faa6cda49c095$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($862faa6cda49c095$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($862faa6cda49c095$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $862faa6cda49c095$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$862faa6cda49c095$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $862faa6cda49c095$var$Dj(a, b) {
    if (!$862faa6cda49c095$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $862faa6cda49c095$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $862faa6cda49c095$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $862faa6cda49c095$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $862faa6cda49c095$var$S(b), null;
        case 1:
            return $862faa6cda49c095$var$Zf(b.type) && $862faa6cda49c095$var$$f(), $862faa6cda49c095$var$S(b), null;
        case 3:
            d = b.stateNode;
            $862faa6cda49c095$var$zh();
            $862faa6cda49c095$var$E($862faa6cda49c095$var$Wf);
            $862faa6cda49c095$var$E($862faa6cda49c095$var$H);
            $862faa6cda49c095$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $862faa6cda49c095$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $862faa6cda49c095$var$zg && ($862faa6cda49c095$var$Fj($862faa6cda49c095$var$zg), $862faa6cda49c095$var$zg = null));
            $862faa6cda49c095$var$Aj(a, b);
            $862faa6cda49c095$var$S(b);
            return null;
        case 5:
            $862faa6cda49c095$var$Bh(b);
            var e = $862faa6cda49c095$var$xh($862faa6cda49c095$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $862faa6cda49c095$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($862faa6cda49c095$var$p(166));
                    $862faa6cda49c095$var$S(b);
                    return null;
                }
                a = $862faa6cda49c095$var$xh($862faa6cda49c095$var$uh.current);
                if ($862faa6cda49c095$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$862faa6cda49c095$var$Of] = b;
                    d[$862faa6cda49c095$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $862faa6cda49c095$var$D("cancel", d);
                            $862faa6cda49c095$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $862faa6cda49c095$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $862faa6cda49c095$var$lf.length; e++)$862faa6cda49c095$var$D($862faa6cda49c095$var$lf[e], d);
                            break;
                        case "source":
                            $862faa6cda49c095$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $862faa6cda49c095$var$D("error", d);
                            $862faa6cda49c095$var$D("load", d);
                            break;
                        case "details":
                            $862faa6cda49c095$var$D("toggle", d);
                            break;
                        case "input":
                            $862faa6cda49c095$var$Za(d, f);
                            $862faa6cda49c095$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $862faa6cda49c095$var$D("invalid", d);
                            break;
                        case "textarea":
                            $862faa6cda49c095$var$hb(d, f), $862faa6cda49c095$var$D("invalid", d);
                    }
                    $862faa6cda49c095$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $862faa6cda49c095$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $862faa6cda49c095$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $862faa6cda49c095$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $862faa6cda49c095$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $862faa6cda49c095$var$Va(d);
                            $862faa6cda49c095$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $862faa6cda49c095$var$Va(d);
                            $862faa6cda49c095$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $862faa6cda49c095$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $862faa6cda49c095$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$862faa6cda49c095$var$Of] = b;
                    a[$862faa6cda49c095$var$Pf] = d;
                    $862faa6cda49c095$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $862faa6cda49c095$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $862faa6cda49c095$var$D("cancel", a);
                                $862faa6cda49c095$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $862faa6cda49c095$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $862faa6cda49c095$var$lf.length; e++)$862faa6cda49c095$var$D($862faa6cda49c095$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $862faa6cda49c095$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $862faa6cda49c095$var$D("error", a);
                                $862faa6cda49c095$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $862faa6cda49c095$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $862faa6cda49c095$var$Za(a, d);
                                e = $862faa6cda49c095$var$Ya(a, d);
                                $862faa6cda49c095$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $862faa6cda49c095$var$A({}, d, {
                                    value: void 0
                                });
                                $862faa6cda49c095$var$D("invalid", a);
                                break;
                            case "textarea":
                                $862faa6cda49c095$var$hb(a, d);
                                e = $862faa6cda49c095$var$gb(a, d);
                                $862faa6cda49c095$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $862faa6cda49c095$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $862faa6cda49c095$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $862faa6cda49c095$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $862faa6cda49c095$var$ob(a, k) : "number" === typeof k && $862faa6cda49c095$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($862faa6cda49c095$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $862faa6cda49c095$var$D("scroll", a) : null != k && $862faa6cda49c095$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $862faa6cda49c095$var$Va(a);
                                $862faa6cda49c095$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $862faa6cda49c095$var$Va(a);
                                $862faa6cda49c095$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $862faa6cda49c095$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $862faa6cda49c095$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $862faa6cda49c095$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $862faa6cda49c095$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $862faa6cda49c095$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $862faa6cda49c095$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($862faa6cda49c095$var$p(166));
                c = $862faa6cda49c095$var$xh($862faa6cda49c095$var$wh.current);
                $862faa6cda49c095$var$xh($862faa6cda49c095$var$uh.current);
                if ($862faa6cda49c095$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$862faa6cda49c095$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $862faa6cda49c095$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $862faa6cda49c095$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $862faa6cda49c095$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$862faa6cda49c095$var$Of] = b, b.stateNode = d;
            }
            $862faa6cda49c095$var$S(b);
            return null;
        case 13:
            $862faa6cda49c095$var$E($862faa6cda49c095$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($862faa6cda49c095$var$I && null !== $862faa6cda49c095$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $862faa6cda49c095$var$Hg(), $862faa6cda49c095$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $862faa6cda49c095$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($862faa6cda49c095$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($862faa6cda49c095$var$p(317));
                        f[$862faa6cda49c095$var$Of] = b;
                    } else $862faa6cda49c095$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $862faa6cda49c095$var$S(b);
                    f = !1;
                } else null !== $862faa6cda49c095$var$zg && ($862faa6cda49c095$var$Fj($862faa6cda49c095$var$zg), $862faa6cda49c095$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($862faa6cda49c095$var$L.current & 1) ? 0 === $862faa6cda49c095$var$T && ($862faa6cda49c095$var$T = 3) : $862faa6cda49c095$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $862faa6cda49c095$var$S(b);
            return null;
        case 4:
            return $862faa6cda49c095$var$zh(), $862faa6cda49c095$var$Aj(a, b), null === a && $862faa6cda49c095$var$sf(b.stateNode.containerInfo), $862faa6cda49c095$var$S(b), null;
        case 10:
            return $862faa6cda49c095$var$ah(b.type._context), $862faa6cda49c095$var$S(b), null;
        case 17:
            return $862faa6cda49c095$var$Zf(b.type) && $862faa6cda49c095$var$$f(), $862faa6cda49c095$var$S(b), null;
        case 19:
            $862faa6cda49c095$var$E($862faa6cda49c095$var$L);
            f = b.memoizedState;
            if (null === f) return $862faa6cda49c095$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $862faa6cda49c095$var$Dj(f, !1);
                else {
                    if (0 !== $862faa6cda49c095$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $862faa6cda49c095$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $862faa6cda49c095$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $862faa6cda49c095$var$G($862faa6cda49c095$var$L, $862faa6cda49c095$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $862faa6cda49c095$var$B() > $862faa6cda49c095$var$Gj && (b.flags |= 128, d = !0, $862faa6cda49c095$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $862faa6cda49c095$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $862faa6cda49c095$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$862faa6cda49c095$var$I) return $862faa6cda49c095$var$S(b), null;
                    } else 2 * $862faa6cda49c095$var$B() - f.renderingStartTime > $862faa6cda49c095$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $862faa6cda49c095$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $862faa6cda49c095$var$B(), b.sibling = null, c = $862faa6cda49c095$var$L.current, $862faa6cda49c095$var$G($862faa6cda49c095$var$L, d ? c & 1 | 2 : c & 1), b;
            $862faa6cda49c095$var$S(b);
            return null;
        case 22:
        case 23:
            return $862faa6cda49c095$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($862faa6cda49c095$var$fj & 1073741824) && ($862faa6cda49c095$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $862faa6cda49c095$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($862faa6cda49c095$var$p(156, b.tag));
}
function $862faa6cda49c095$var$Ij(a, b) {
    $862faa6cda49c095$var$wg(b);
    switch(b.tag){
        case 1:
            return $862faa6cda49c095$var$Zf(b.type) && $862faa6cda49c095$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $862faa6cda49c095$var$zh(), $862faa6cda49c095$var$E($862faa6cda49c095$var$Wf), $862faa6cda49c095$var$E($862faa6cda49c095$var$H), $862faa6cda49c095$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $862faa6cda49c095$var$Bh(b), null;
        case 13:
            $862faa6cda49c095$var$E($862faa6cda49c095$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($862faa6cda49c095$var$p(340));
                $862faa6cda49c095$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $862faa6cda49c095$var$E($862faa6cda49c095$var$L), null;
        case 4:
            return $862faa6cda49c095$var$zh(), null;
        case 10:
            return $862faa6cda49c095$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $862faa6cda49c095$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $862faa6cda49c095$var$Jj = !1, $862faa6cda49c095$var$U = !1, $862faa6cda49c095$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $862faa6cda49c095$var$V = null;
function $862faa6cda49c095$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $862faa6cda49c095$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $862faa6cda49c095$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $862faa6cda49c095$var$W(a, b, d);
    }
}
var $862faa6cda49c095$var$Nj = !1;
function $862faa6cda49c095$var$Oj(a, b) {
    $862faa6cda49c095$var$Cf = $862faa6cda49c095$var$dd;
    a = $862faa6cda49c095$var$Me();
    if ($862faa6cda49c095$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $862faa6cda49c095$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $862faa6cda49c095$var$dd = !1;
    for($862faa6cda49c095$var$V = b; null !== $862faa6cda49c095$var$V;)if (b = $862faa6cda49c095$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $862faa6cda49c095$var$V = a;
    else for(; null !== $862faa6cda49c095$var$V;){
        b = $862faa6cda49c095$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $862faa6cda49c095$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($862faa6cda49c095$var$p(163));
            }
        } catch (F) {
            $862faa6cda49c095$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $862faa6cda49c095$var$V = a;
            break;
        }
        $862faa6cda49c095$var$V = b.return;
    }
    n = $862faa6cda49c095$var$Nj;
    $862faa6cda49c095$var$Nj = !1;
    return n;
}
function $862faa6cda49c095$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $862faa6cda49c095$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $862faa6cda49c095$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $862faa6cda49c095$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $862faa6cda49c095$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $862faa6cda49c095$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$862faa6cda49c095$var$Of], delete b[$862faa6cda49c095$var$Pf], delete b[$862faa6cda49c095$var$of], delete b[$862faa6cda49c095$var$Qf], delete b[$862faa6cda49c095$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $862faa6cda49c095$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $862faa6cda49c095$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $862faa6cda49c095$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $862faa6cda49c095$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $862faa6cda49c095$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($862faa6cda49c095$var$Vj(a, b, c), a = a.sibling; null !== a;)$862faa6cda49c095$var$Vj(a, b, c), a = a.sibling;
}
function $862faa6cda49c095$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($862faa6cda49c095$var$Wj(a, b, c), a = a.sibling; null !== a;)$862faa6cda49c095$var$Wj(a, b, c), a = a.sibling;
}
var $862faa6cda49c095$var$X = null, $862faa6cda49c095$var$Xj = !1;
function $862faa6cda49c095$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$862faa6cda49c095$var$Zj(a, b, c), c = c.sibling;
}
function $862faa6cda49c095$var$Zj(a, b, c) {
    if ($862faa6cda49c095$var$lc && "function" === typeof $862faa6cda49c095$var$lc.onCommitFiberUnmount) try {
        $862faa6cda49c095$var$lc.onCommitFiberUnmount($862faa6cda49c095$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $862faa6cda49c095$var$U || $862faa6cda49c095$var$Lj(c, b);
        case 6:
            var d = $862faa6cda49c095$var$X, e = $862faa6cda49c095$var$Xj;
            $862faa6cda49c095$var$X = null;
            $862faa6cda49c095$var$Yj(a, b, c);
            $862faa6cda49c095$var$X = d;
            $862faa6cda49c095$var$Xj = e;
            null !== $862faa6cda49c095$var$X && ($862faa6cda49c095$var$Xj ? (a = $862faa6cda49c095$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $862faa6cda49c095$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $862faa6cda49c095$var$X && ($862faa6cda49c095$var$Xj ? (a = $862faa6cda49c095$var$X, c = c.stateNode, 8 === a.nodeType ? $862faa6cda49c095$var$Kf(a.parentNode, c) : 1 === a.nodeType && $862faa6cda49c095$var$Kf(a, c), $862faa6cda49c095$var$bd(a)) : $862faa6cda49c095$var$Kf($862faa6cda49c095$var$X, c.stateNode));
            break;
        case 4:
            d = $862faa6cda49c095$var$X;
            e = $862faa6cda49c095$var$Xj;
            $862faa6cda49c095$var$X = c.stateNode.containerInfo;
            $862faa6cda49c095$var$Xj = !0;
            $862faa6cda49c095$var$Yj(a, b, c);
            $862faa6cda49c095$var$X = d;
            $862faa6cda49c095$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$862faa6cda49c095$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $862faa6cda49c095$var$Mj(c, b, g) : 0 !== (f & 4) && $862faa6cda49c095$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $862faa6cda49c095$var$Yj(a, b, c);
            break;
        case 1:
            if (!$862faa6cda49c095$var$U && ($862faa6cda49c095$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $862faa6cda49c095$var$W(c, b, h);
            }
            $862faa6cda49c095$var$Yj(a, b, c);
            break;
        case 21:
            $862faa6cda49c095$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($862faa6cda49c095$var$U = (d = $862faa6cda49c095$var$U) || null !== c.memoizedState, $862faa6cda49c095$var$Yj(a, b, c), $862faa6cda49c095$var$U = d) : $862faa6cda49c095$var$Yj(a, b, c);
            break;
        default:
            $862faa6cda49c095$var$Yj(a, b, c);
    }
}
function $862faa6cda49c095$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $862faa6cda49c095$var$Kj);
        b.forEach(function(b) {
            var d = $862faa6cda49c095$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $862faa6cda49c095$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $862faa6cda49c095$var$X = h.stateNode;
                        $862faa6cda49c095$var$Xj = !1;
                        break a;
                    case 3:
                        $862faa6cda49c095$var$X = h.stateNode.containerInfo;
                        $862faa6cda49c095$var$Xj = !0;
                        break a;
                    case 4:
                        $862faa6cda49c095$var$X = h.stateNode.containerInfo;
                        $862faa6cda49c095$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $862faa6cda49c095$var$X) throw Error($862faa6cda49c095$var$p(160));
            $862faa6cda49c095$var$Zj(f, g, e);
            $862faa6cda49c095$var$X = null;
            $862faa6cda49c095$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $862faa6cda49c095$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$862faa6cda49c095$var$dk(b, a), b = b.sibling;
}
function $862faa6cda49c095$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $862faa6cda49c095$var$ck(b, a);
            $862faa6cda49c095$var$ek(a);
            if (d & 4) {
                try {
                    $862faa6cda49c095$var$Pj(3, a, a.return), $862faa6cda49c095$var$Qj(3, a);
                } catch (t) {
                    $862faa6cda49c095$var$W(a, a.return, t);
                }
                try {
                    $862faa6cda49c095$var$Pj(5, a, a.return);
                } catch (t) {
                    $862faa6cda49c095$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $862faa6cda49c095$var$ck(b, a);
            $862faa6cda49c095$var$ek(a);
            d & 512 && null !== c && $862faa6cda49c095$var$Lj(c, c.return);
            break;
        case 5:
            $862faa6cda49c095$var$ck(b, a);
            $862faa6cda49c095$var$ek(a);
            d & 512 && null !== c && $862faa6cda49c095$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $862faa6cda49c095$var$ob(e, "");
                } catch (t) {
                    $862faa6cda49c095$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $862faa6cda49c095$var$ab(e, f);
                    $862faa6cda49c095$var$vb(h, g);
                    var l = $862faa6cda49c095$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $862faa6cda49c095$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $862faa6cda49c095$var$nb(e, q) : "children" === m ? $862faa6cda49c095$var$ob(e, q) : $862faa6cda49c095$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $862faa6cda49c095$var$bb(e, f);
                            break;
                        case "textarea":
                            $862faa6cda49c095$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $862faa6cda49c095$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $862faa6cda49c095$var$fb(e, !!f.multiple, f.defaultValue, !0) : $862faa6cda49c095$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$862faa6cda49c095$var$Pf] = f;
                } catch (t) {
                    $862faa6cda49c095$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $862faa6cda49c095$var$ck(b, a);
            $862faa6cda49c095$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($862faa6cda49c095$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $862faa6cda49c095$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $862faa6cda49c095$var$ck(b, a);
            $862faa6cda49c095$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $862faa6cda49c095$var$bd(b.containerInfo);
            } catch (t) {
                $862faa6cda49c095$var$W(a, a.return, t);
            }
            break;
        case 4:
            $862faa6cda49c095$var$ck(b, a);
            $862faa6cda49c095$var$ek(a);
            break;
        case 13:
            $862faa6cda49c095$var$ck(b, a);
            $862faa6cda49c095$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($862faa6cda49c095$var$fk = $862faa6cda49c095$var$B()));
            d & 4 && $862faa6cda49c095$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($862faa6cda49c095$var$U = (l = $862faa6cda49c095$var$U) || m, $862faa6cda49c095$var$ck(b, a), $862faa6cda49c095$var$U = l) : $862faa6cda49c095$var$ck(b, a);
            $862faa6cda49c095$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($862faa6cda49c095$var$V = a, m = a.child; null !== m;){
                    for(q = $862faa6cda49c095$var$V = m; null !== $862faa6cda49c095$var$V;){
                        r = $862faa6cda49c095$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $862faa6cda49c095$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $862faa6cda49c095$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $862faa6cda49c095$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $862faa6cda49c095$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $862faa6cda49c095$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $862faa6cda49c095$var$V = y) : $862faa6cda49c095$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $862faa6cda49c095$var$rb("display", g));
                            } catch (t) {
                                $862faa6cda49c095$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $862faa6cda49c095$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $862faa6cda49c095$var$ck(b, a);
            $862faa6cda49c095$var$ek(a);
            d & 4 && $862faa6cda49c095$var$ak(a);
            break;
        case 21:
            break;
        default:
            $862faa6cda49c095$var$ck(b, a), $862faa6cda49c095$var$ek(a);
    }
}
function $862faa6cda49c095$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($862faa6cda49c095$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($862faa6cda49c095$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($862faa6cda49c095$var$ob(e, ""), d.flags &= -33);
                    var f = $862faa6cda49c095$var$Uj(a);
                    $862faa6cda49c095$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $862faa6cda49c095$var$Uj(a);
                    $862faa6cda49c095$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($862faa6cda49c095$var$p(161));
            }
        } catch (k) {
            $862faa6cda49c095$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $862faa6cda49c095$var$hk(a, b, c) {
    $862faa6cda49c095$var$V = a;
    $862faa6cda49c095$var$ik(a, b, c);
}
function $862faa6cda49c095$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $862faa6cda49c095$var$V;){
        var e = $862faa6cda49c095$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $862faa6cda49c095$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $862faa6cda49c095$var$U;
                h = $862faa6cda49c095$var$Jj;
                var l = $862faa6cda49c095$var$U;
                $862faa6cda49c095$var$Jj = g;
                if (($862faa6cda49c095$var$U = k) && !l) for($862faa6cda49c095$var$V = e; null !== $862faa6cda49c095$var$V;)g = $862faa6cda49c095$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $862faa6cda49c095$var$jk(e) : null !== k ? (k.return = g, $862faa6cda49c095$var$V = k) : $862faa6cda49c095$var$jk(e);
                for(; null !== f;)$862faa6cda49c095$var$V = f, $862faa6cda49c095$var$ik(f, b, c), f = f.sibling;
                $862faa6cda49c095$var$V = e;
                $862faa6cda49c095$var$Jj = h;
                $862faa6cda49c095$var$U = l;
            }
            $862faa6cda49c095$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $862faa6cda49c095$var$V = f) : $862faa6cda49c095$var$kk(a, b, c);
    }
}
function $862faa6cda49c095$var$kk(a) {
    for(; null !== $862faa6cda49c095$var$V;){
        var b = $862faa6cda49c095$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $862faa6cda49c095$var$U || $862faa6cda49c095$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$862faa6cda49c095$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $862faa6cda49c095$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $862faa6cda49c095$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $862faa6cda49c095$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $862faa6cda49c095$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($862faa6cda49c095$var$p(163));
                }
                $862faa6cda49c095$var$U || b.flags & 512 && $862faa6cda49c095$var$Rj(b);
            } catch (r) {
                $862faa6cda49c095$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $862faa6cda49c095$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $862faa6cda49c095$var$V = c;
            break;
        }
        $862faa6cda49c095$var$V = b.return;
    }
}
function $862faa6cda49c095$var$gk(a) {
    for(; null !== $862faa6cda49c095$var$V;){
        var b = $862faa6cda49c095$var$V;
        if (b === a) {
            $862faa6cda49c095$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $862faa6cda49c095$var$V = c;
            break;
        }
        $862faa6cda49c095$var$V = b.return;
    }
}
function $862faa6cda49c095$var$jk(a) {
    for(; null !== $862faa6cda49c095$var$V;){
        var b = $862faa6cda49c095$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $862faa6cda49c095$var$Qj(4, b);
                    } catch (k) {
                        $862faa6cda49c095$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $862faa6cda49c095$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $862faa6cda49c095$var$Rj(b);
                    } catch (k) {
                        $862faa6cda49c095$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $862faa6cda49c095$var$Rj(b);
                    } catch (k) {
                        $862faa6cda49c095$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $862faa6cda49c095$var$W(b, b.return, k);
        }
        if (b === a) {
            $862faa6cda49c095$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $862faa6cda49c095$var$V = h;
            break;
        }
        $862faa6cda49c095$var$V = b.return;
    }
}
var $862faa6cda49c095$var$lk = Math.ceil, $862faa6cda49c095$var$mk = $862faa6cda49c095$var$ua.ReactCurrentDispatcher, $862faa6cda49c095$var$nk = $862faa6cda49c095$var$ua.ReactCurrentOwner, $862faa6cda49c095$var$ok = $862faa6cda49c095$var$ua.ReactCurrentBatchConfig, $862faa6cda49c095$var$K = 0, $862faa6cda49c095$var$Q = null, $862faa6cda49c095$var$Y = null, $862faa6cda49c095$var$Z = 0, $862faa6cda49c095$var$fj = 0, $862faa6cda49c095$var$ej = $862faa6cda49c095$var$Uf(0), $862faa6cda49c095$var$T = 0, $862faa6cda49c095$var$pk = null, $862faa6cda49c095$var$rh = 0, $862faa6cda49c095$var$qk = 0, $862faa6cda49c095$var$rk = 0, $862faa6cda49c095$var$sk = null, $862faa6cda49c095$var$tk = null, $862faa6cda49c095$var$fk = 0, $862faa6cda49c095$var$Gj = Infinity, $862faa6cda49c095$var$uk = null, $862faa6cda49c095$var$Oi = !1, $862faa6cda49c095$var$Pi = null, $862faa6cda49c095$var$Ri = null, $862faa6cda49c095$var$vk = !1, $862faa6cda49c095$var$wk = null, $862faa6cda49c095$var$xk = 0, $862faa6cda49c095$var$yk = 0, $862faa6cda49c095$var$zk = null, $862faa6cda49c095$var$Ak = -1, $862faa6cda49c095$var$Bk = 0;
function $862faa6cda49c095$var$R() {
    return 0 !== ($862faa6cda49c095$var$K & 6) ? $862faa6cda49c095$var$B() : -1 !== $862faa6cda49c095$var$Ak ? $862faa6cda49c095$var$Ak : $862faa6cda49c095$var$Ak = $862faa6cda49c095$var$B();
}
function $862faa6cda49c095$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($862faa6cda49c095$var$K & 2) && 0 !== $862faa6cda49c095$var$Z) return $862faa6cda49c095$var$Z & -$862faa6cda49c095$var$Z;
    if (null !== $862faa6cda49c095$var$Kg.transition) return 0 === $862faa6cda49c095$var$Bk && ($862faa6cda49c095$var$Bk = $862faa6cda49c095$var$yc()), $862faa6cda49c095$var$Bk;
    a = $862faa6cda49c095$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $862faa6cda49c095$var$jd(a.type);
    return a;
}
function $862faa6cda49c095$var$gi(a, b, c, d) {
    if (50 < $862faa6cda49c095$var$yk) throw $862faa6cda49c095$var$yk = 0, $862faa6cda49c095$var$zk = null, Error($862faa6cda49c095$var$p(185));
    $862faa6cda49c095$var$Ac(a, c, d);
    if (0 === ($862faa6cda49c095$var$K & 2) || a !== $862faa6cda49c095$var$Q) a === $862faa6cda49c095$var$Q && (0 === ($862faa6cda49c095$var$K & 2) && ($862faa6cda49c095$var$qk |= c), 4 === $862faa6cda49c095$var$T && $862faa6cda49c095$var$Ck(a, $862faa6cda49c095$var$Z)), $862faa6cda49c095$var$Dk(a, d), 1 === c && 0 === $862faa6cda49c095$var$K && 0 === (b.mode & 1) && ($862faa6cda49c095$var$Gj = $862faa6cda49c095$var$B() + 500, $862faa6cda49c095$var$fg && $862faa6cda49c095$var$jg());
}
function $862faa6cda49c095$var$Dk(a, b) {
    var c = a.callbackNode;
    $862faa6cda49c095$var$wc(a, b);
    var d = $862faa6cda49c095$var$uc(a, a === $862faa6cda49c095$var$Q ? $862faa6cda49c095$var$Z : 0);
    if (0 === d) null !== c && $862faa6cda49c095$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $862faa6cda49c095$var$bc(c);
        if (1 === b) 0 === a.tag ? $862faa6cda49c095$var$ig($862faa6cda49c095$var$Ek.bind(null, a)) : $862faa6cda49c095$var$hg($862faa6cda49c095$var$Ek.bind(null, a)), $862faa6cda49c095$var$Jf(function() {
            0 === ($862faa6cda49c095$var$K & 6) && $862faa6cda49c095$var$jg();
        }), c = null;
        else {
            switch($862faa6cda49c095$var$Dc(d)){
                case 1:
                    c = $862faa6cda49c095$var$fc;
                    break;
                case 4:
                    c = $862faa6cda49c095$var$gc;
                    break;
                case 16:
                    c = $862faa6cda49c095$var$hc;
                    break;
                case 536870912:
                    c = $862faa6cda49c095$var$jc;
                    break;
                default:
                    c = $862faa6cda49c095$var$hc;
            }
            c = $862faa6cda49c095$var$Fk(c, $862faa6cda49c095$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $862faa6cda49c095$var$Gk(a, b) {
    $862faa6cda49c095$var$Ak = -1;
    $862faa6cda49c095$var$Bk = 0;
    if (0 !== ($862faa6cda49c095$var$K & 6)) throw Error($862faa6cda49c095$var$p(327));
    var c = a.callbackNode;
    if ($862faa6cda49c095$var$Hk() && a.callbackNode !== c) return null;
    var d = $862faa6cda49c095$var$uc(a, a === $862faa6cda49c095$var$Q ? $862faa6cda49c095$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $862faa6cda49c095$var$Ik(a, d);
    else {
        b = d;
        var e = $862faa6cda49c095$var$K;
        $862faa6cda49c095$var$K |= 2;
        var f = $862faa6cda49c095$var$Jk();
        if ($862faa6cda49c095$var$Q !== a || $862faa6cda49c095$var$Z !== b) $862faa6cda49c095$var$uk = null, $862faa6cda49c095$var$Gj = $862faa6cda49c095$var$B() + 500, $862faa6cda49c095$var$Kk(a, b);
        for(;;)try {
            $862faa6cda49c095$var$Lk();
            break;
        } catch (h) {
            $862faa6cda49c095$var$Mk(a, h);
        }
        $862faa6cda49c095$var$$g();
        $862faa6cda49c095$var$mk.current = f;
        $862faa6cda49c095$var$K = e;
        null !== $862faa6cda49c095$var$Y ? b = 0 : ($862faa6cda49c095$var$Q = null, $862faa6cda49c095$var$Z = 0, b = $862faa6cda49c095$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $862faa6cda49c095$var$xc(a), 0 !== e && (d = e, b = $862faa6cda49c095$var$Nk(a, e)));
        if (1 === b) throw c = $862faa6cda49c095$var$pk, $862faa6cda49c095$var$Kk(a, 0), $862faa6cda49c095$var$Ck(a, d), $862faa6cda49c095$var$Dk(a, $862faa6cda49c095$var$B()), c;
        if (6 === b) $862faa6cda49c095$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$862faa6cda49c095$var$Ok(e) && (b = $862faa6cda49c095$var$Ik(a, d), 2 === b && (f = $862faa6cda49c095$var$xc(a), 0 !== f && (d = f, b = $862faa6cda49c095$var$Nk(a, f))), 1 === b)) throw c = $862faa6cda49c095$var$pk, $862faa6cda49c095$var$Kk(a, 0), $862faa6cda49c095$var$Ck(a, d), $862faa6cda49c095$var$Dk(a, $862faa6cda49c095$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($862faa6cda49c095$var$p(345));
                case 2:
                    $862faa6cda49c095$var$Pk(a, $862faa6cda49c095$var$tk, $862faa6cda49c095$var$uk);
                    break;
                case 3:
                    $862faa6cda49c095$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $862faa6cda49c095$var$fk + 500 - $862faa6cda49c095$var$B(), 10 < b)) {
                        if (0 !== $862faa6cda49c095$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $862faa6cda49c095$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $862faa6cda49c095$var$Ff($862faa6cda49c095$var$Pk.bind(null, a, $862faa6cda49c095$var$tk, $862faa6cda49c095$var$uk), b);
                        break;
                    }
                    $862faa6cda49c095$var$Pk(a, $862faa6cda49c095$var$tk, $862faa6cda49c095$var$uk);
                    break;
                case 4:
                    $862faa6cda49c095$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $862faa6cda49c095$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $862faa6cda49c095$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $862faa6cda49c095$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $862faa6cda49c095$var$Ff($862faa6cda49c095$var$Pk.bind(null, a, $862faa6cda49c095$var$tk, $862faa6cda49c095$var$uk), d);
                        break;
                    }
                    $862faa6cda49c095$var$Pk(a, $862faa6cda49c095$var$tk, $862faa6cda49c095$var$uk);
                    break;
                case 5:
                    $862faa6cda49c095$var$Pk(a, $862faa6cda49c095$var$tk, $862faa6cda49c095$var$uk);
                    break;
                default:
                    throw Error($862faa6cda49c095$var$p(329));
            }
        }
    }
    $862faa6cda49c095$var$Dk(a, $862faa6cda49c095$var$B());
    return a.callbackNode === c ? $862faa6cda49c095$var$Gk.bind(null, a) : null;
}
function $862faa6cda49c095$var$Nk(a, b) {
    var c = $862faa6cda49c095$var$sk;
    a.current.memoizedState.isDehydrated && ($862faa6cda49c095$var$Kk(a, b).flags |= 256);
    a = $862faa6cda49c095$var$Ik(a, b);
    2 !== a && (b = $862faa6cda49c095$var$tk, $862faa6cda49c095$var$tk = c, null !== b && $862faa6cda49c095$var$Fj(b));
    return a;
}
function $862faa6cda49c095$var$Fj(a) {
    null === $862faa6cda49c095$var$tk ? $862faa6cda49c095$var$tk = a : $862faa6cda49c095$var$tk.push.apply($862faa6cda49c095$var$tk, a);
}
function $862faa6cda49c095$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$862faa6cda49c095$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $862faa6cda49c095$var$Ck(a, b) {
    b &= ~$862faa6cda49c095$var$rk;
    b &= ~$862faa6cda49c095$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $862faa6cda49c095$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $862faa6cda49c095$var$Ek(a) {
    if (0 !== ($862faa6cda49c095$var$K & 6)) throw Error($862faa6cda49c095$var$p(327));
    $862faa6cda49c095$var$Hk();
    var b = $862faa6cda49c095$var$uc(a, 0);
    if (0 === (b & 1)) return $862faa6cda49c095$var$Dk(a, $862faa6cda49c095$var$B()), null;
    var c = $862faa6cda49c095$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $862faa6cda49c095$var$xc(a);
        0 !== d && (b = d, c = $862faa6cda49c095$var$Nk(a, d));
    }
    if (1 === c) throw c = $862faa6cda49c095$var$pk, $862faa6cda49c095$var$Kk(a, 0), $862faa6cda49c095$var$Ck(a, b), $862faa6cda49c095$var$Dk(a, $862faa6cda49c095$var$B()), c;
    if (6 === c) throw Error($862faa6cda49c095$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $862faa6cda49c095$var$Pk(a, $862faa6cda49c095$var$tk, $862faa6cda49c095$var$uk);
    $862faa6cda49c095$var$Dk(a, $862faa6cda49c095$var$B());
    return null;
}
function $862faa6cda49c095$var$Qk(a, b) {
    var c = $862faa6cda49c095$var$K;
    $862faa6cda49c095$var$K |= 1;
    try {
        return a(b);
    } finally{
        $862faa6cda49c095$var$K = c, 0 === $862faa6cda49c095$var$K && ($862faa6cda49c095$var$Gj = $862faa6cda49c095$var$B() + 500, $862faa6cda49c095$var$fg && $862faa6cda49c095$var$jg());
    }
}
function $862faa6cda49c095$var$Rk(a) {
    null !== $862faa6cda49c095$var$wk && 0 === $862faa6cda49c095$var$wk.tag && 0 === ($862faa6cda49c095$var$K & 6) && $862faa6cda49c095$var$Hk();
    var b = $862faa6cda49c095$var$K;
    $862faa6cda49c095$var$K |= 1;
    var c = $862faa6cda49c095$var$ok.transition, d = $862faa6cda49c095$var$C;
    try {
        if ($862faa6cda49c095$var$ok.transition = null, $862faa6cda49c095$var$C = 1, a) return a();
    } finally{
        $862faa6cda49c095$var$C = d, $862faa6cda49c095$var$ok.transition = c, $862faa6cda49c095$var$K = b, 0 === ($862faa6cda49c095$var$K & 6) && $862faa6cda49c095$var$jg();
    }
}
function $862faa6cda49c095$var$Hj() {
    $862faa6cda49c095$var$fj = $862faa6cda49c095$var$ej.current;
    $862faa6cda49c095$var$E($862faa6cda49c095$var$ej);
}
function $862faa6cda49c095$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $862faa6cda49c095$var$Gf(c));
    if (null !== $862faa6cda49c095$var$Y) for(c = $862faa6cda49c095$var$Y.return; null !== c;){
        var d = c;
        $862faa6cda49c095$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $862faa6cda49c095$var$$f();
                break;
            case 3:
                $862faa6cda49c095$var$zh();
                $862faa6cda49c095$var$E($862faa6cda49c095$var$Wf);
                $862faa6cda49c095$var$E($862faa6cda49c095$var$H);
                $862faa6cda49c095$var$Eh();
                break;
            case 5:
                $862faa6cda49c095$var$Bh(d);
                break;
            case 4:
                $862faa6cda49c095$var$zh();
                break;
            case 13:
                $862faa6cda49c095$var$E($862faa6cda49c095$var$L);
                break;
            case 19:
                $862faa6cda49c095$var$E($862faa6cda49c095$var$L);
                break;
            case 10:
                $862faa6cda49c095$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $862faa6cda49c095$var$Hj();
        }
        c = c.return;
    }
    $862faa6cda49c095$var$Q = a;
    $862faa6cda49c095$var$Y = a = $862faa6cda49c095$var$Pg(a.current, null);
    $862faa6cda49c095$var$Z = $862faa6cda49c095$var$fj = b;
    $862faa6cda49c095$var$T = 0;
    $862faa6cda49c095$var$pk = null;
    $862faa6cda49c095$var$rk = $862faa6cda49c095$var$qk = $862faa6cda49c095$var$rh = 0;
    $862faa6cda49c095$var$tk = $862faa6cda49c095$var$sk = null;
    if (null !== $862faa6cda49c095$var$fh) {
        for(b = 0; b < $862faa6cda49c095$var$fh.length; b++)if (c = $862faa6cda49c095$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $862faa6cda49c095$var$fh = null;
    }
    return a;
}
function $862faa6cda49c095$var$Mk(a, b) {
    do {
        var c = $862faa6cda49c095$var$Y;
        try {
            $862faa6cda49c095$var$$g();
            $862faa6cda49c095$var$Fh.current = $862faa6cda49c095$var$Rh;
            if ($862faa6cda49c095$var$Ih) {
                for(var d = $862faa6cda49c095$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $862faa6cda49c095$var$Ih = !1;
            }
            $862faa6cda49c095$var$Hh = 0;
            $862faa6cda49c095$var$O = $862faa6cda49c095$var$N = $862faa6cda49c095$var$M = null;
            $862faa6cda49c095$var$Jh = !1;
            $862faa6cda49c095$var$Kh = 0;
            $862faa6cda49c095$var$nk.current = null;
            if (null === c || null === c.return) {
                $862faa6cda49c095$var$T = 1;
                $862faa6cda49c095$var$pk = b;
                $862faa6cda49c095$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $862faa6cda49c095$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $862faa6cda49c095$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $862faa6cda49c095$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $862faa6cda49c095$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $862faa6cda49c095$var$Si(f, l, b);
                            $862faa6cda49c095$var$tj();
                            break a;
                        }
                        k = Error($862faa6cda49c095$var$p(426));
                    }
                } else if ($862faa6cda49c095$var$I && h.mode & 1) {
                    var J = $862faa6cda49c095$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $862faa6cda49c095$var$Vi(J, g, h, f, b);
                        $862faa6cda49c095$var$Jg($862faa6cda49c095$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $862faa6cda49c095$var$Ji(k, h);
                4 !== $862faa6cda49c095$var$T && ($862faa6cda49c095$var$T = 2);
                null === $862faa6cda49c095$var$sk ? $862faa6cda49c095$var$sk = [
                    f
                ] : $862faa6cda49c095$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $862faa6cda49c095$var$Ni(f, k, b);
                            $862faa6cda49c095$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $862faa6cda49c095$var$Ri || !$862faa6cda49c095$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $862faa6cda49c095$var$Qi(f, h, b);
                                $862faa6cda49c095$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $862faa6cda49c095$var$Sk(c);
        } catch (na) {
            b = na;
            $862faa6cda49c095$var$Y === c && null !== c && ($862faa6cda49c095$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $862faa6cda49c095$var$Jk() {
    var a = $862faa6cda49c095$var$mk.current;
    $862faa6cda49c095$var$mk.current = $862faa6cda49c095$var$Rh;
    return null === a ? $862faa6cda49c095$var$Rh : a;
}
function $862faa6cda49c095$var$tj() {
    if (0 === $862faa6cda49c095$var$T || 3 === $862faa6cda49c095$var$T || 2 === $862faa6cda49c095$var$T) $862faa6cda49c095$var$T = 4;
    null === $862faa6cda49c095$var$Q || 0 === ($862faa6cda49c095$var$rh & 268435455) && 0 === ($862faa6cda49c095$var$qk & 268435455) || $862faa6cda49c095$var$Ck($862faa6cda49c095$var$Q, $862faa6cda49c095$var$Z);
}
function $862faa6cda49c095$var$Ik(a, b) {
    var c = $862faa6cda49c095$var$K;
    $862faa6cda49c095$var$K |= 2;
    var d = $862faa6cda49c095$var$Jk();
    if ($862faa6cda49c095$var$Q !== a || $862faa6cda49c095$var$Z !== b) $862faa6cda49c095$var$uk = null, $862faa6cda49c095$var$Kk(a, b);
    for(;;)try {
        $862faa6cda49c095$var$Tk();
        break;
    } catch (e) {
        $862faa6cda49c095$var$Mk(a, e);
    }
    $862faa6cda49c095$var$$g();
    $862faa6cda49c095$var$K = c;
    $862faa6cda49c095$var$mk.current = d;
    if (null !== $862faa6cda49c095$var$Y) throw Error($862faa6cda49c095$var$p(261));
    $862faa6cda49c095$var$Q = null;
    $862faa6cda49c095$var$Z = 0;
    return $862faa6cda49c095$var$T;
}
function $862faa6cda49c095$var$Tk() {
    for(; null !== $862faa6cda49c095$var$Y;)$862faa6cda49c095$var$Uk($862faa6cda49c095$var$Y);
}
function $862faa6cda49c095$var$Lk() {
    for(; null !== $862faa6cda49c095$var$Y && !$862faa6cda49c095$var$cc();)$862faa6cda49c095$var$Uk($862faa6cda49c095$var$Y);
}
function $862faa6cda49c095$var$Uk(a) {
    var b = $862faa6cda49c095$var$Vk(a.alternate, a, $862faa6cda49c095$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $862faa6cda49c095$var$Sk(a) : $862faa6cda49c095$var$Y = b;
    $862faa6cda49c095$var$nk.current = null;
}
function $862faa6cda49c095$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $862faa6cda49c095$var$Ej(c, b, $862faa6cda49c095$var$fj), null !== c) {
                $862faa6cda49c095$var$Y = c;
                return;
            }
        } else {
            c = $862faa6cda49c095$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $862faa6cda49c095$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $862faa6cda49c095$var$T = 6;
                $862faa6cda49c095$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $862faa6cda49c095$var$Y = b;
            return;
        }
        $862faa6cda49c095$var$Y = b = a;
    }while (null !== b);
    0 === $862faa6cda49c095$var$T && ($862faa6cda49c095$var$T = 5);
}
function $862faa6cda49c095$var$Pk(a, b, c) {
    var d = $862faa6cda49c095$var$C, e = $862faa6cda49c095$var$ok.transition;
    try {
        $862faa6cda49c095$var$ok.transition = null, $862faa6cda49c095$var$C = 1, $862faa6cda49c095$var$Wk(a, b, c, d);
    } finally{
        $862faa6cda49c095$var$ok.transition = e, $862faa6cda49c095$var$C = d;
    }
    return null;
}
function $862faa6cda49c095$var$Wk(a, b, c, d) {
    do $862faa6cda49c095$var$Hk();
    while (null !== $862faa6cda49c095$var$wk);
    if (0 !== ($862faa6cda49c095$var$K & 6)) throw Error($862faa6cda49c095$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($862faa6cda49c095$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $862faa6cda49c095$var$Bc(a, f);
    a === $862faa6cda49c095$var$Q && ($862faa6cda49c095$var$Y = $862faa6cda49c095$var$Q = null, $862faa6cda49c095$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $862faa6cda49c095$var$vk || ($862faa6cda49c095$var$vk = !0, $862faa6cda49c095$var$Fk($862faa6cda49c095$var$hc, function() {
        $862faa6cda49c095$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $862faa6cda49c095$var$ok.transition;
        $862faa6cda49c095$var$ok.transition = null;
        var g = $862faa6cda49c095$var$C;
        $862faa6cda49c095$var$C = 1;
        var h = $862faa6cda49c095$var$K;
        $862faa6cda49c095$var$K |= 4;
        $862faa6cda49c095$var$nk.current = null;
        $862faa6cda49c095$var$Oj(a, c);
        $862faa6cda49c095$var$dk(c, a);
        $862faa6cda49c095$var$Oe($862faa6cda49c095$var$Df);
        $862faa6cda49c095$var$dd = !!$862faa6cda49c095$var$Cf;
        $862faa6cda49c095$var$Df = $862faa6cda49c095$var$Cf = null;
        a.current = c;
        $862faa6cda49c095$var$hk(c, a, e);
        $862faa6cda49c095$var$dc();
        $862faa6cda49c095$var$K = h;
        $862faa6cda49c095$var$C = g;
        $862faa6cda49c095$var$ok.transition = f;
    } else a.current = c;
    $862faa6cda49c095$var$vk && ($862faa6cda49c095$var$vk = !1, $862faa6cda49c095$var$wk = a, $862faa6cda49c095$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($862faa6cda49c095$var$Ri = null);
    $862faa6cda49c095$var$mc(c.stateNode, d);
    $862faa6cda49c095$var$Dk(a, $862faa6cda49c095$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($862faa6cda49c095$var$Oi) throw $862faa6cda49c095$var$Oi = !1, a = $862faa6cda49c095$var$Pi, $862faa6cda49c095$var$Pi = null, a;
    0 !== ($862faa6cda49c095$var$xk & 1) && 0 !== a.tag && $862faa6cda49c095$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $862faa6cda49c095$var$zk ? $862faa6cda49c095$var$yk++ : ($862faa6cda49c095$var$yk = 0, $862faa6cda49c095$var$zk = a) : $862faa6cda49c095$var$yk = 0;
    $862faa6cda49c095$var$jg();
    return null;
}
function $862faa6cda49c095$var$Hk() {
    if (null !== $862faa6cda49c095$var$wk) {
        var a = $862faa6cda49c095$var$Dc($862faa6cda49c095$var$xk), b = $862faa6cda49c095$var$ok.transition, c = $862faa6cda49c095$var$C;
        try {
            $862faa6cda49c095$var$ok.transition = null;
            $862faa6cda49c095$var$C = 16 > a ? 16 : a;
            if (null === $862faa6cda49c095$var$wk) var d = !1;
            else {
                a = $862faa6cda49c095$var$wk;
                $862faa6cda49c095$var$wk = null;
                $862faa6cda49c095$var$xk = 0;
                if (0 !== ($862faa6cda49c095$var$K & 6)) throw Error($862faa6cda49c095$var$p(331));
                var e = $862faa6cda49c095$var$K;
                $862faa6cda49c095$var$K |= 4;
                for($862faa6cda49c095$var$V = a.current; null !== $862faa6cda49c095$var$V;){
                    var f = $862faa6cda49c095$var$V, g = f.child;
                    if (0 !== ($862faa6cda49c095$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($862faa6cda49c095$var$V = l; null !== $862faa6cda49c095$var$V;){
                                    var m = $862faa6cda49c095$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $862faa6cda49c095$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $862faa6cda49c095$var$V = q;
                                    else for(; null !== $862faa6cda49c095$var$V;){
                                        m = $862faa6cda49c095$var$V;
                                        var r = m.sibling, y = m.return;
                                        $862faa6cda49c095$var$Sj(m);
                                        if (m === l) {
                                            $862faa6cda49c095$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $862faa6cda49c095$var$V = r;
                                            break;
                                        }
                                        $862faa6cda49c095$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $862faa6cda49c095$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $862faa6cda49c095$var$V = g;
                    else b: for(; null !== $862faa6cda49c095$var$V;){
                        f = $862faa6cda49c095$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $862faa6cda49c095$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $862faa6cda49c095$var$V = x;
                            break b;
                        }
                        $862faa6cda49c095$var$V = f.return;
                    }
                }
                var w = a.current;
                for($862faa6cda49c095$var$V = w; null !== $862faa6cda49c095$var$V;){
                    g = $862faa6cda49c095$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $862faa6cda49c095$var$V = u;
                    else b: for(g = w; null !== $862faa6cda49c095$var$V;){
                        h = $862faa6cda49c095$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $862faa6cda49c095$var$Qj(9, h);
                            }
                        } catch (na) {
                            $862faa6cda49c095$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $862faa6cda49c095$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $862faa6cda49c095$var$V = F;
                            break b;
                        }
                        $862faa6cda49c095$var$V = h.return;
                    }
                }
                $862faa6cda49c095$var$K = e;
                $862faa6cda49c095$var$jg();
                if ($862faa6cda49c095$var$lc && "function" === typeof $862faa6cda49c095$var$lc.onPostCommitFiberRoot) try {
                    $862faa6cda49c095$var$lc.onPostCommitFiberRoot($862faa6cda49c095$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $862faa6cda49c095$var$C = c, $862faa6cda49c095$var$ok.transition = b;
        }
    }
    return !1;
}
function $862faa6cda49c095$var$Xk(a, b, c) {
    b = $862faa6cda49c095$var$Ji(c, b);
    b = $862faa6cda49c095$var$Ni(a, b, 1);
    a = $862faa6cda49c095$var$nh(a, b, 1);
    b = $862faa6cda49c095$var$R();
    null !== a && ($862faa6cda49c095$var$Ac(a, 1, b), $862faa6cda49c095$var$Dk(a, b));
}
function $862faa6cda49c095$var$W(a, b, c) {
    if (3 === a.tag) $862faa6cda49c095$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $862faa6cda49c095$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $862faa6cda49c095$var$Ri || !$862faa6cda49c095$var$Ri.has(d))) {
                a = $862faa6cda49c095$var$Ji(c, a);
                a = $862faa6cda49c095$var$Qi(b, a, 1);
                b = $862faa6cda49c095$var$nh(b, a, 1);
                a = $862faa6cda49c095$var$R();
                null !== b && ($862faa6cda49c095$var$Ac(b, 1, a), $862faa6cda49c095$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $862faa6cda49c095$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $862faa6cda49c095$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $862faa6cda49c095$var$Q === a && ($862faa6cda49c095$var$Z & c) === c && (4 === $862faa6cda49c095$var$T || 3 === $862faa6cda49c095$var$T && ($862faa6cda49c095$var$Z & 130023424) === $862faa6cda49c095$var$Z && 500 > $862faa6cda49c095$var$B() - $862faa6cda49c095$var$fk ? $862faa6cda49c095$var$Kk(a, 0) : $862faa6cda49c095$var$rk |= c);
    $862faa6cda49c095$var$Dk(a, b);
}
function $862faa6cda49c095$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $862faa6cda49c095$var$sc, $862faa6cda49c095$var$sc <<= 1, 0 === ($862faa6cda49c095$var$sc & 130023424) && ($862faa6cda49c095$var$sc = 4194304)));
    var c = $862faa6cda49c095$var$R();
    a = $862faa6cda49c095$var$ih(a, b);
    null !== a && ($862faa6cda49c095$var$Ac(a, b, c), $862faa6cda49c095$var$Dk(a, c));
}
function $862faa6cda49c095$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $862faa6cda49c095$var$Yk(a, c);
}
function $862faa6cda49c095$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($862faa6cda49c095$var$p(314));
    }
    null !== d && d.delete(b);
    $862faa6cda49c095$var$Yk(a, c);
}
var $862faa6cda49c095$var$Vk;
$862faa6cda49c095$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $862faa6cda49c095$var$Wf.current) $862faa6cda49c095$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $862faa6cda49c095$var$dh = !1, $862faa6cda49c095$var$yj(a, b, c);
            $862faa6cda49c095$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $862faa6cda49c095$var$dh = !1, $862faa6cda49c095$var$I && 0 !== (b.flags & 1048576) && $862faa6cda49c095$var$ug(b, $862faa6cda49c095$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $862faa6cda49c095$var$ij(a, b);
            a = b.pendingProps;
            var e = $862faa6cda49c095$var$Yf(b, $862faa6cda49c095$var$H.current);
            $862faa6cda49c095$var$ch(b, c);
            e = $862faa6cda49c095$var$Nh(null, b, d, a, e, c);
            var f = $862faa6cda49c095$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $862faa6cda49c095$var$Zf(d) ? (f = !0, $862faa6cda49c095$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $862faa6cda49c095$var$kh(b), e.updater = $862faa6cda49c095$var$Ei, b.stateNode = e, e._reactInternals = b, $862faa6cda49c095$var$Ii(b, d, a, c), b = $862faa6cda49c095$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $862faa6cda49c095$var$I && f && $862faa6cda49c095$var$vg(b), $862faa6cda49c095$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $862faa6cda49c095$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $862faa6cda49c095$var$Zk(d);
                a = $862faa6cda49c095$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $862faa6cda49c095$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $862faa6cda49c095$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $862faa6cda49c095$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $862faa6cda49c095$var$$i(null, b, d, $862faa6cda49c095$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($862faa6cda49c095$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $862faa6cda49c095$var$Ci(d, e), $862faa6cda49c095$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $862faa6cda49c095$var$Ci(d, e), $862faa6cda49c095$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $862faa6cda49c095$var$kj(b);
                if (null === a) throw Error($862faa6cda49c095$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $862faa6cda49c095$var$lh(a, b);
                $862faa6cda49c095$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $862faa6cda49c095$var$Ji(Error($862faa6cda49c095$var$p(423)), b);
                        b = $862faa6cda49c095$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $862faa6cda49c095$var$Ji(Error($862faa6cda49c095$var$p(424)), b);
                        b = $862faa6cda49c095$var$lj(a, b, d, c, e);
                        break a;
                    } else for($862faa6cda49c095$var$yg = $862faa6cda49c095$var$Lf(b.stateNode.containerInfo.firstChild), $862faa6cda49c095$var$xg = b, $862faa6cda49c095$var$I = !0, $862faa6cda49c095$var$zg = null, c = $862faa6cda49c095$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $862faa6cda49c095$var$Ig();
                    if (d === e) {
                        b = $862faa6cda49c095$var$Zi(a, b, c);
                        break a;
                    }
                    $862faa6cda49c095$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $862faa6cda49c095$var$Ah(b), null === a && $862faa6cda49c095$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $862faa6cda49c095$var$Ef(d, e) ? g = null : null !== f && $862faa6cda49c095$var$Ef(d, f) && (b.flags |= 32), $862faa6cda49c095$var$gj(a, b), $862faa6cda49c095$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $862faa6cda49c095$var$Eg(b), null;
        case 13:
            return $862faa6cda49c095$var$oj(a, b, c);
        case 4:
            return $862faa6cda49c095$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $862faa6cda49c095$var$Ug(b, null, d, c) : $862faa6cda49c095$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $862faa6cda49c095$var$Ci(d, e), $862faa6cda49c095$var$Yi(a, b, d, e, c);
        case 7:
            return $862faa6cda49c095$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $862faa6cda49c095$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $862faa6cda49c095$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $862faa6cda49c095$var$G($862faa6cda49c095$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($862faa6cda49c095$var$He(f.value, g)) {
                        if (f.children === e.children && !$862faa6cda49c095$var$Wf.current) {
                            b = $862faa6cda49c095$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $862faa6cda49c095$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $862faa6cda49c095$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($862faa6cda49c095$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $862faa6cda49c095$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $862faa6cda49c095$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $862faa6cda49c095$var$ch(b, c), e = $862faa6cda49c095$var$eh(e), d = d(e), b.flags |= 1, $862faa6cda49c095$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $862faa6cda49c095$var$Ci(d, b.pendingProps), e = $862faa6cda49c095$var$Ci(d.type, e), $862faa6cda49c095$var$$i(a, b, d, e, c);
        case 15:
            return $862faa6cda49c095$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $862faa6cda49c095$var$Ci(d, e), $862faa6cda49c095$var$ij(a, b), b.tag = 1, $862faa6cda49c095$var$Zf(d) ? (a = !0, $862faa6cda49c095$var$cg(b)) : a = !1, $862faa6cda49c095$var$ch(b, c), $862faa6cda49c095$var$Gi(b, d, e), $862faa6cda49c095$var$Ii(b, d, e, c), $862faa6cda49c095$var$jj(null, b, d, !0, a, c);
        case 19:
            return $862faa6cda49c095$var$xj(a, b, c);
        case 22:
            return $862faa6cda49c095$var$dj(a, b, c);
    }
    throw Error($862faa6cda49c095$var$p(156, b.tag));
};
function $862faa6cda49c095$var$Fk(a, b) {
    return $862faa6cda49c095$var$ac(a, b);
}
function $862faa6cda49c095$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $862faa6cda49c095$var$Bg(a, b, c, d) {
    return new $862faa6cda49c095$var$$k(a, b, c, d);
}
function $862faa6cda49c095$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $862faa6cda49c095$var$Zk(a) {
    if ("function" === typeof a) return $862faa6cda49c095$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $862faa6cda49c095$var$Da) return 11;
        if (a === $862faa6cda49c095$var$Ga) return 14;
    }
    return 2;
}
function $862faa6cda49c095$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $862faa6cda49c095$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $862faa6cda49c095$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $862faa6cda49c095$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $862faa6cda49c095$var$ya:
            return $862faa6cda49c095$var$Tg(c.children, e, f, b);
        case $862faa6cda49c095$var$za:
            g = 8;
            e |= 8;
            break;
        case $862faa6cda49c095$var$Aa:
            return a = $862faa6cda49c095$var$Bg(12, c, b, e | 2), a.elementType = $862faa6cda49c095$var$Aa, a.lanes = f, a;
        case $862faa6cda49c095$var$Ea:
            return a = $862faa6cda49c095$var$Bg(13, c, b, e), a.elementType = $862faa6cda49c095$var$Ea, a.lanes = f, a;
        case $862faa6cda49c095$var$Fa:
            return a = $862faa6cda49c095$var$Bg(19, c, b, e), a.elementType = $862faa6cda49c095$var$Fa, a.lanes = f, a;
        case $862faa6cda49c095$var$Ia:
            return $862faa6cda49c095$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $862faa6cda49c095$var$Ba:
                    g = 10;
                    break a;
                case $862faa6cda49c095$var$Ca:
                    g = 9;
                    break a;
                case $862faa6cda49c095$var$Da:
                    g = 11;
                    break a;
                case $862faa6cda49c095$var$Ga:
                    g = 14;
                    break a;
                case $862faa6cda49c095$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($862faa6cda49c095$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $862faa6cda49c095$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $862faa6cda49c095$var$Tg(a, b, c, d) {
    a = $862faa6cda49c095$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $862faa6cda49c095$var$pj(a, b, c, d) {
    a = $862faa6cda49c095$var$Bg(22, a, d, b);
    a.elementType = $862faa6cda49c095$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $862faa6cda49c095$var$Qg(a, b, c) {
    a = $862faa6cda49c095$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $862faa6cda49c095$var$Sg(a, b, c) {
    b = $862faa6cda49c095$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $862faa6cda49c095$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $862faa6cda49c095$var$zc(0);
    this.expirationTimes = $862faa6cda49c095$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $862faa6cda49c095$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $862faa6cda49c095$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $862faa6cda49c095$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $862faa6cda49c095$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $862faa6cda49c095$var$kh(f);
    return a;
}
function $862faa6cda49c095$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $862faa6cda49c095$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $862faa6cda49c095$var$dl(a) {
    if (!a) return $862faa6cda49c095$var$Vf;
    a = a._reactInternals;
    a: {
        if ($862faa6cda49c095$var$Vb(a) !== a || 1 !== a.tag) throw Error($862faa6cda49c095$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($862faa6cda49c095$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($862faa6cda49c095$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($862faa6cda49c095$var$Zf(c)) return $862faa6cda49c095$var$bg(a, c, b);
    }
    return b;
}
function $862faa6cda49c095$var$el(a, b, c, d, e, f, g, h, k) {
    a = $862faa6cda49c095$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $862faa6cda49c095$var$dl(null);
    c = a.current;
    d = $862faa6cda49c095$var$R();
    e = $862faa6cda49c095$var$yi(c);
    f = $862faa6cda49c095$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $862faa6cda49c095$var$nh(c, f, e);
    a.current.lanes = e;
    $862faa6cda49c095$var$Ac(a, e, d);
    $862faa6cda49c095$var$Dk(a, d);
    return a;
}
function $862faa6cda49c095$var$fl(a, b, c, d) {
    var e = b.current, f = $862faa6cda49c095$var$R(), g = $862faa6cda49c095$var$yi(e);
    c = $862faa6cda49c095$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $862faa6cda49c095$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $862faa6cda49c095$var$nh(e, b, g);
    null !== a && ($862faa6cda49c095$var$gi(a, e, g, f), $862faa6cda49c095$var$oh(a, e, g));
    return g;
}
function $862faa6cda49c095$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $862faa6cda49c095$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $862faa6cda49c095$var$il(a, b) {
    $862faa6cda49c095$var$hl(a, b);
    (a = a.alternate) && $862faa6cda49c095$var$hl(a, b);
}
function $862faa6cda49c095$var$jl() {
    return null;
}
var $862faa6cda49c095$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $862faa6cda49c095$var$ll(a) {
    this._internalRoot = a;
}
$862faa6cda49c095$var$ml.prototype.render = $862faa6cda49c095$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($862faa6cda49c095$var$p(409));
    $862faa6cda49c095$var$fl(a, b, null, null);
};
$862faa6cda49c095$var$ml.prototype.unmount = $862faa6cda49c095$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $862faa6cda49c095$var$Rk(function() {
            $862faa6cda49c095$var$fl(null, a, null, null);
        });
        b[$862faa6cda49c095$var$uf] = null;
    }
};
function $862faa6cda49c095$var$ml(a) {
    this._internalRoot = a;
}
$862faa6cda49c095$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $862faa6cda49c095$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $862faa6cda49c095$var$Qc.length && 0 !== b && b < $862faa6cda49c095$var$Qc[c].priority; c++);
        $862faa6cda49c095$var$Qc.splice(c, 0, a);
        0 === c && $862faa6cda49c095$var$Vc(a);
    }
};
function $862faa6cda49c095$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $862faa6cda49c095$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $862faa6cda49c095$var$pl() {}
function $862faa6cda49c095$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $862faa6cda49c095$var$gl(g);
                f.call(a);
            };
        }
        var g = $862faa6cda49c095$var$el(b, d, a, 0, null, !1, !1, "", $862faa6cda49c095$var$pl);
        a._reactRootContainer = g;
        a[$862faa6cda49c095$var$uf] = g.current;
        $862faa6cda49c095$var$sf(8 === a.nodeType ? a.parentNode : a);
        $862faa6cda49c095$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $862faa6cda49c095$var$gl(k);
            h.call(a);
        };
    }
    var k = $862faa6cda49c095$var$bl(a, 0, !1, null, null, !1, !1, "", $862faa6cda49c095$var$pl);
    a._reactRootContainer = k;
    a[$862faa6cda49c095$var$uf] = k.current;
    $862faa6cda49c095$var$sf(8 === a.nodeType ? a.parentNode : a);
    $862faa6cda49c095$var$Rk(function() {
        $862faa6cda49c095$var$fl(b, k, c, d);
    });
    return k;
}
function $862faa6cda49c095$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $862faa6cda49c095$var$gl(g);
                h.call(a);
            };
        }
        $862faa6cda49c095$var$fl(b, g, a, e);
    } else g = $862faa6cda49c095$var$ql(c, b, a, e, d);
    return $862faa6cda49c095$var$gl(g);
}
$862faa6cda49c095$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $862faa6cda49c095$var$tc(b.pendingLanes);
                0 !== c && ($862faa6cda49c095$var$Cc(b, c | 1), $862faa6cda49c095$var$Dk(b, $862faa6cda49c095$var$B()), 0 === ($862faa6cda49c095$var$K & 6) && ($862faa6cda49c095$var$Gj = $862faa6cda49c095$var$B() + 500, $862faa6cda49c095$var$jg()));
            }
            break;
        case 13:
            $862faa6cda49c095$var$Rk(function() {
                var b = $862faa6cda49c095$var$ih(a, 1);
                if (null !== b) {
                    var c = $862faa6cda49c095$var$R();
                    $862faa6cda49c095$var$gi(b, a, 1, c);
                }
            }), $862faa6cda49c095$var$il(a, 1);
    }
};
$862faa6cda49c095$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $862faa6cda49c095$var$ih(a, 134217728);
        if (null !== b) {
            var c = $862faa6cda49c095$var$R();
            $862faa6cda49c095$var$gi(b, a, 134217728, c);
        }
        $862faa6cda49c095$var$il(a, 134217728);
    }
};
$862faa6cda49c095$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $862faa6cda49c095$var$yi(a), c = $862faa6cda49c095$var$ih(a, b);
        if (null !== c) {
            var d = $862faa6cda49c095$var$R();
            $862faa6cda49c095$var$gi(c, a, b, d);
        }
        $862faa6cda49c095$var$il(a, b);
    }
};
$862faa6cda49c095$var$Hc = function() {
    return $862faa6cda49c095$var$C;
};
$862faa6cda49c095$var$Ic = function(a, b) {
    var c = $862faa6cda49c095$var$C;
    try {
        return $862faa6cda49c095$var$C = a, b();
    } finally{
        $862faa6cda49c095$var$C = c;
    }
};
$862faa6cda49c095$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $862faa6cda49c095$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $862faa6cda49c095$var$Db(d);
                        if (!e) throw Error($862faa6cda49c095$var$p(90));
                        $862faa6cda49c095$var$Wa(d);
                        $862faa6cda49c095$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $862faa6cda49c095$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $862faa6cda49c095$var$fb(a, !!c.multiple, b, !1);
    }
};
$862faa6cda49c095$var$Gb = $862faa6cda49c095$var$Qk;
$862faa6cda49c095$var$Hb = $862faa6cda49c095$var$Rk;
var $862faa6cda49c095$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $862faa6cda49c095$var$Cb,
        $862faa6cda49c095$var$ue,
        $862faa6cda49c095$var$Db,
        $862faa6cda49c095$var$Eb,
        $862faa6cda49c095$var$Fb,
        $862faa6cda49c095$var$Qk
    ]
}, $862faa6cda49c095$var$tl = {
    findFiberByHostInstance: $862faa6cda49c095$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $862faa6cda49c095$var$ul = {
    bundleType: $862faa6cda49c095$var$tl.bundleType,
    version: $862faa6cda49c095$var$tl.version,
    rendererPackageName: $862faa6cda49c095$var$tl.rendererPackageName,
    rendererConfig: $862faa6cda49c095$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $862faa6cda49c095$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $862faa6cda49c095$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $862faa6cda49c095$var$tl.findFiberByHostInstance || $862faa6cda49c095$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $862faa6cda49c095$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$862faa6cda49c095$var$vl.isDisabled && $862faa6cda49c095$var$vl.supportsFiber) try {
        $862faa6cda49c095$var$kc = $862faa6cda49c095$var$vl.inject($862faa6cda49c095$var$ul), $862faa6cda49c095$var$lc = $862faa6cda49c095$var$vl;
    } catch (a) {}
}
$862faa6cda49c095$export$ae55be85d98224ed = $862faa6cda49c095$var$sl;
$862faa6cda49c095$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$862faa6cda49c095$var$nl(b)) throw Error($862faa6cda49c095$var$p(200));
    return $862faa6cda49c095$var$cl(a, b, null, c);
};
$862faa6cda49c095$export$882461b6382ed46c = function(a, b) {
    if (!$862faa6cda49c095$var$nl(a)) throw Error($862faa6cda49c095$var$p(299));
    var c = !1, d = "", e = $862faa6cda49c095$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $862faa6cda49c095$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$862faa6cda49c095$var$uf] = b.current;
    $862faa6cda49c095$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $862faa6cda49c095$var$ll(b);
};
$862faa6cda49c095$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($862faa6cda49c095$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($862faa6cda49c095$var$p(268, a));
    }
    a = $862faa6cda49c095$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$862faa6cda49c095$export$cd75ccfd720a3cd4 = function(a) {
    return $862faa6cda49c095$var$Rk(a);
};
$862faa6cda49c095$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$862faa6cda49c095$var$ol(b)) throw Error($862faa6cda49c095$var$p(200));
    return $862faa6cda49c095$var$rl(null, a, b, !0, c);
};
$862faa6cda49c095$export$757ceba2d55c277e = function(a, b, c) {
    if (!$862faa6cda49c095$var$nl(a)) throw Error($862faa6cda49c095$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $862faa6cda49c095$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $862faa6cda49c095$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$862faa6cda49c095$var$uf] = b.current;
    $862faa6cda49c095$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $862faa6cda49c095$var$ml(b);
};
$862faa6cda49c095$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$862faa6cda49c095$var$ol(b)) throw Error($862faa6cda49c095$var$p(200));
    return $862faa6cda49c095$var$rl(null, a, b, !1, c);
};
$862faa6cda49c095$export$502457920280e6be = function(a) {
    if (!$862faa6cda49c095$var$ol(a)) throw Error($862faa6cda49c095$var$p(40));
    return a._reactRootContainer ? ($862faa6cda49c095$var$Rk(function() {
        $862faa6cda49c095$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$862faa6cda49c095$var$uf] = null;
        });
    }), !0) : !1;
};
$862faa6cda49c095$export$c78a37762a8d58e1 = $862faa6cda49c095$var$Qk;
$862faa6cda49c095$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$862faa6cda49c095$var$ol(c)) throw Error($862faa6cda49c095$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($862faa6cda49c095$var$p(38));
    return $862faa6cda49c095$var$rl(a, b, c, !1, d);
};
$862faa6cda49c095$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("8TTSu", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fYG2A"));

});
parcelRegister("fYG2A", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $ba1d120a78855737$export$c4744153514ff05d; }, function (v) { return $ba1d120a78855737$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $ba1d120a78855737$export$3e506c1ccc9cc1a7; }, function (v) { return $ba1d120a78855737$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $ba1d120a78855737$export$e26fe2ed2fa76875; }, function (v) { return $ba1d120a78855737$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $ba1d120a78855737$export$502329bbf4b505b1; }, function (v) { return $ba1d120a78855737$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $ba1d120a78855737$export$6e3807111c4874c4; }, function (v) { return $ba1d120a78855737$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $ba1d120a78855737$export$c27134553091fb3a; }, function (v) { return $ba1d120a78855737$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $ba1d120a78855737$export$33ee1acdc04fd2a2; }, function (v) { return $ba1d120a78855737$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $ba1d120a78855737$export$b00a404bbd5edef2; }, function (v) { return $ba1d120a78855737$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $ba1d120a78855737$export$8352ce38b91d0c62; }, function (v) { return $ba1d120a78855737$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $ba1d120a78855737$export$d66a1c1c77bd778b; }, function (v) { return $ba1d120a78855737$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $ba1d120a78855737$export$d3dfb8e4810cb555; }, function (v) { return $ba1d120a78855737$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $ba1d120a78855737$export$839f9183b0465a69; }, function (v) { return $ba1d120a78855737$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $ba1d120a78855737$export$72fdf0e06517287b; }, function (v) { return $ba1d120a78855737$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $ba1d120a78855737$export$4b844e58a3e414b4; }, function (v) { return $ba1d120a78855737$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $ba1d120a78855737$export$816d2913ae6b83b1; }, function (v) { return $ba1d120a78855737$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $ba1d120a78855737$export$61bcfe829111a1d0; }, function (v) { return $ba1d120a78855737$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $ba1d120a78855737$export$7ee8c9beb337bc3f; }, function (v) { return $ba1d120a78855737$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $ba1d120a78855737$export$b5836b71941fa3ed; }, function (v) { return $ba1d120a78855737$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $ba1d120a78855737$export$cf845f2c119da08a; }, function (v) { return $ba1d120a78855737$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ba1d120a78855737$export$c4744153514ff05d;
var $ba1d120a78855737$export$3e506c1ccc9cc1a7;
var $ba1d120a78855737$export$e26fe2ed2fa76875;
var $ba1d120a78855737$export$502329bbf4b505b1;
var $ba1d120a78855737$export$6e3807111c4874c4;
var $ba1d120a78855737$export$c27134553091fb3a;
var $ba1d120a78855737$export$33ee1acdc04fd2a2;
var $ba1d120a78855737$export$b00a404bbd5edef2;
var $ba1d120a78855737$export$8352ce38b91d0c62;
var $ba1d120a78855737$export$d66a1c1c77bd778b;
var $ba1d120a78855737$export$d3dfb8e4810cb555;
var $ba1d120a78855737$export$839f9183b0465a69;
var $ba1d120a78855737$export$72fdf0e06517287b;
var $ba1d120a78855737$export$4b844e58a3e414b4;
var $ba1d120a78855737$export$816d2913ae6b83b1;
var $ba1d120a78855737$export$61bcfe829111a1d0;
var $ba1d120a78855737$export$7ee8c9beb337bc3f;
var $ba1d120a78855737$export$b5836b71941fa3ed;
var $ba1d120a78855737$export$cf845f2c119da08a;
"use strict";
function $ba1d120a78855737$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $ba1d120a78855737$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $ba1d120a78855737$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $ba1d120a78855737$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $ba1d120a78855737$var$g(C, c)) n < e && 0 > $ba1d120a78855737$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $ba1d120a78855737$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $ba1d120a78855737$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $ba1d120a78855737$var$l = performance;
    $ba1d120a78855737$export$c4744153514ff05d = function() {
        return $ba1d120a78855737$var$l.now();
    };
} else {
    var $ba1d120a78855737$var$p = Date, $ba1d120a78855737$var$q = $ba1d120a78855737$var$p.now();
    $ba1d120a78855737$export$c4744153514ff05d = function() {
        return $ba1d120a78855737$var$p.now() - $ba1d120a78855737$var$q;
    };
}
var $ba1d120a78855737$var$r = [], $ba1d120a78855737$var$t = [], $ba1d120a78855737$var$u = 1, $ba1d120a78855737$var$v = null, $ba1d120a78855737$var$y = 3, $ba1d120a78855737$var$z = !1, $ba1d120a78855737$var$A = !1, $ba1d120a78855737$var$B = !1, $ba1d120a78855737$var$D = "function" === typeof setTimeout ? setTimeout : null, $ba1d120a78855737$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $ba1d120a78855737$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $ba1d120a78855737$var$G(a) {
    for(var b = $ba1d120a78855737$var$h($ba1d120a78855737$var$t); null !== b;){
        if (null === b.callback) $ba1d120a78855737$var$k($ba1d120a78855737$var$t);
        else if (b.startTime <= a) $ba1d120a78855737$var$k($ba1d120a78855737$var$t), b.sortIndex = b.expirationTime, $ba1d120a78855737$var$f($ba1d120a78855737$var$r, b);
        else break;
        b = $ba1d120a78855737$var$h($ba1d120a78855737$var$t);
    }
}
function $ba1d120a78855737$var$H(a) {
    $ba1d120a78855737$var$B = !1;
    $ba1d120a78855737$var$G(a);
    if (!$ba1d120a78855737$var$A) {
        if (null !== $ba1d120a78855737$var$h($ba1d120a78855737$var$r)) $ba1d120a78855737$var$A = !0, $ba1d120a78855737$var$I($ba1d120a78855737$var$J);
        else {
            var b = $ba1d120a78855737$var$h($ba1d120a78855737$var$t);
            null !== b && $ba1d120a78855737$var$K($ba1d120a78855737$var$H, b.startTime - a);
        }
    }
}
function $ba1d120a78855737$var$J(a, b) {
    $ba1d120a78855737$var$A = !1;
    $ba1d120a78855737$var$B && ($ba1d120a78855737$var$B = !1, $ba1d120a78855737$var$E($ba1d120a78855737$var$L), $ba1d120a78855737$var$L = -1);
    $ba1d120a78855737$var$z = !0;
    var c = $ba1d120a78855737$var$y;
    try {
        $ba1d120a78855737$var$G(b);
        for($ba1d120a78855737$var$v = $ba1d120a78855737$var$h($ba1d120a78855737$var$r); null !== $ba1d120a78855737$var$v && (!($ba1d120a78855737$var$v.expirationTime > b) || a && !$ba1d120a78855737$var$M());){
            var d = $ba1d120a78855737$var$v.callback;
            if ("function" === typeof d) {
                $ba1d120a78855737$var$v.callback = null;
                $ba1d120a78855737$var$y = $ba1d120a78855737$var$v.priorityLevel;
                var e = d($ba1d120a78855737$var$v.expirationTime <= b);
                b = $ba1d120a78855737$export$c4744153514ff05d();
                "function" === typeof e ? $ba1d120a78855737$var$v.callback = e : $ba1d120a78855737$var$v === $ba1d120a78855737$var$h($ba1d120a78855737$var$r) && $ba1d120a78855737$var$k($ba1d120a78855737$var$r);
                $ba1d120a78855737$var$G(b);
            } else $ba1d120a78855737$var$k($ba1d120a78855737$var$r);
            $ba1d120a78855737$var$v = $ba1d120a78855737$var$h($ba1d120a78855737$var$r);
        }
        if (null !== $ba1d120a78855737$var$v) var w = !0;
        else {
            var m = $ba1d120a78855737$var$h($ba1d120a78855737$var$t);
            null !== m && $ba1d120a78855737$var$K($ba1d120a78855737$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $ba1d120a78855737$var$v = null, $ba1d120a78855737$var$y = c, $ba1d120a78855737$var$z = !1;
    }
}
var $ba1d120a78855737$var$N = !1, $ba1d120a78855737$var$O = null, $ba1d120a78855737$var$L = -1, $ba1d120a78855737$var$P = 5, $ba1d120a78855737$var$Q = -1;
function $ba1d120a78855737$var$M() {
    return $ba1d120a78855737$export$c4744153514ff05d() - $ba1d120a78855737$var$Q < $ba1d120a78855737$var$P ? !1 : !0;
}
function $ba1d120a78855737$var$R() {
    if (null !== $ba1d120a78855737$var$O) {
        var a = $ba1d120a78855737$export$c4744153514ff05d();
        $ba1d120a78855737$var$Q = a;
        var b = !0;
        try {
            b = $ba1d120a78855737$var$O(!0, a);
        } finally{
            b ? $ba1d120a78855737$var$S() : ($ba1d120a78855737$var$N = !1, $ba1d120a78855737$var$O = null);
        }
    } else $ba1d120a78855737$var$N = !1;
}
var $ba1d120a78855737$var$S;
if ("function" === typeof $ba1d120a78855737$var$F) $ba1d120a78855737$var$S = function() {
    $ba1d120a78855737$var$F($ba1d120a78855737$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $ba1d120a78855737$var$T = new MessageChannel, $ba1d120a78855737$var$U = $ba1d120a78855737$var$T.port2;
    $ba1d120a78855737$var$T.port1.onmessage = $ba1d120a78855737$var$R;
    $ba1d120a78855737$var$S = function() {
        $ba1d120a78855737$var$U.postMessage(null);
    };
} else $ba1d120a78855737$var$S = function() {
    $ba1d120a78855737$var$D($ba1d120a78855737$var$R, 0);
};
function $ba1d120a78855737$var$I(a) {
    $ba1d120a78855737$var$O = a;
    $ba1d120a78855737$var$N || ($ba1d120a78855737$var$N = !0, $ba1d120a78855737$var$S());
}
function $ba1d120a78855737$var$K(a, b) {
    $ba1d120a78855737$var$L = $ba1d120a78855737$var$D(function() {
        a($ba1d120a78855737$export$c4744153514ff05d());
    }, b);
}
$ba1d120a78855737$export$3e506c1ccc9cc1a7 = 5;
$ba1d120a78855737$export$e26fe2ed2fa76875 = 1;
$ba1d120a78855737$export$502329bbf4b505b1 = 4;
$ba1d120a78855737$export$6e3807111c4874c4 = 3;
$ba1d120a78855737$export$c27134553091fb3a = null;
$ba1d120a78855737$export$33ee1acdc04fd2a2 = 2;
$ba1d120a78855737$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$ba1d120a78855737$export$8352ce38b91d0c62 = function() {
    $ba1d120a78855737$var$A || $ba1d120a78855737$var$z || ($ba1d120a78855737$var$A = !0, $ba1d120a78855737$var$I($ba1d120a78855737$var$J));
};
$ba1d120a78855737$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $ba1d120a78855737$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$ba1d120a78855737$export$d3dfb8e4810cb555 = function() {
    return $ba1d120a78855737$var$y;
};
$ba1d120a78855737$export$839f9183b0465a69 = function() {
    return $ba1d120a78855737$var$h($ba1d120a78855737$var$r);
};
$ba1d120a78855737$export$72fdf0e06517287b = function(a) {
    switch($ba1d120a78855737$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $ba1d120a78855737$var$y;
    }
    var c = $ba1d120a78855737$var$y;
    $ba1d120a78855737$var$y = b;
    try {
        return a();
    } finally{
        $ba1d120a78855737$var$y = c;
    }
};
$ba1d120a78855737$export$4b844e58a3e414b4 = function() {};
$ba1d120a78855737$export$816d2913ae6b83b1 = function() {};
$ba1d120a78855737$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $ba1d120a78855737$var$y;
    $ba1d120a78855737$var$y = a;
    try {
        return b();
    } finally{
        $ba1d120a78855737$var$y = c;
    }
};
$ba1d120a78855737$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $ba1d120a78855737$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $ba1d120a78855737$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $ba1d120a78855737$var$f($ba1d120a78855737$var$t, a), null === $ba1d120a78855737$var$h($ba1d120a78855737$var$r) && a === $ba1d120a78855737$var$h($ba1d120a78855737$var$t) && ($ba1d120a78855737$var$B ? ($ba1d120a78855737$var$E($ba1d120a78855737$var$L), $ba1d120a78855737$var$L = -1) : $ba1d120a78855737$var$B = !0, $ba1d120a78855737$var$K($ba1d120a78855737$var$H, c - d))) : (a.sortIndex = e, $ba1d120a78855737$var$f($ba1d120a78855737$var$r, a), $ba1d120a78855737$var$A || $ba1d120a78855737$var$z || ($ba1d120a78855737$var$A = !0, $ba1d120a78855737$var$I($ba1d120a78855737$var$J)));
    return a;
};
$ba1d120a78855737$export$b5836b71941fa3ed = $ba1d120a78855737$var$M;
$ba1d120a78855737$export$cf845f2c119da08a = function(a) {
    var b = $ba1d120a78855737$var$y;
    return function() {
        var c = $ba1d120a78855737$var$y;
        $ba1d120a78855737$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $ba1d120a78855737$var$y = c;
        }
    };
};

});



parcelRegister("kW665", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $2oZah = parcelRequire("2oZah");
function $f3ddf438b18efbb3$var$emptyFunction() {}
function $f3ddf438b18efbb3$var$emptyFunctionWithReset() {}
$f3ddf438b18efbb3$var$emptyFunctionWithReset.resetWarningCache = $f3ddf438b18efbb3$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $2oZah) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $f3ddf438b18efbb3$var$emptyFunctionWithReset,
        resetWarningCache: $f3ddf438b18efbb3$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("2oZah", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $1bfd44b9f9771892$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $1bfd44b9f9771892$var$ReactPropTypesSecret;

});


parcelRegister("3xlep", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $2934ec46166f7290$export$bf730a2d8bf68b42; }, function (v) { return $2934ec46166f7290$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2934ec46166f7290$export$bf730a2d8bf68b42;
"use strict";

var $4RFnf = parcelRequire("4RFnf");
function $2934ec46166f7290$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2934ec46166f7290$var$p = "function" === typeof Object.is ? Object.is : $2934ec46166f7290$var$n, $2934ec46166f7290$var$q = $4RFnf.useSyncExternalStore, $2934ec46166f7290$var$r = $4RFnf.useRef, $2934ec46166f7290$var$t = $4RFnf.useEffect, $2934ec46166f7290$var$u = $4RFnf.useMemo, $2934ec46166f7290$var$v = $4RFnf.useDebugValue;
$2934ec46166f7290$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $2934ec46166f7290$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $2934ec46166f7290$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var b = f.value;
                    if (h(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($2934ec46166f7290$var$p(d, a)) return b;
            var e = l(a);
            if (void 0 !== h && h(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $2934ec46166f7290$var$q(a, c[0], c[1]);
    $2934ec46166f7290$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $2934ec46166f7290$var$v(d);
    return d;
};

});

parcelRegister("lE2Lo", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $fc1f7a2668268381$export$2b8d127b894957b9; }, function (v) { return $fc1f7a2668268381$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $fc1f7a2668268381$export$cea3a54a6425200c; }, function (v) { return $fc1f7a2668268381$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $fc1f7a2668268381$export$a7c73072b1a182ae; }, function (v) { return $fc1f7a2668268381$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $fc1f7a2668268381$export$9f27bc3417b4524d; }, function (v) { return $fc1f7a2668268381$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $fc1f7a2668268381$export$db77ccec0bb4ccac; }, function (v) { return $fc1f7a2668268381$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $fc1f7a2668268381$export$8392c0c9d3dcbd35; }, function (v) { return $fc1f7a2668268381$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $fc1f7a2668268381$export$ffb0004e005737fa; }, function (v) { return $fc1f7a2668268381$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $fc1f7a2668268381$export$b624eff549462981; }, function (v) { return $fc1f7a2668268381$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $fc1f7a2668268381$export$7897aa7841a5380c; }, function (v) { return $fc1f7a2668268381$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $fc1f7a2668268381$export$602eac185826482c; }, function (v) { return $fc1f7a2668268381$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $fc1f7a2668268381$export$e2c29f18771995cb; }, function (v) { return $fc1f7a2668268381$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $fc1f7a2668268381$export$5f8d39834fd61797; }, function (v) { return $fc1f7a2668268381$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $fc1f7a2668268381$export$74bf444e3cd11ea5; }, function (v) { return $fc1f7a2668268381$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $fc1f7a2668268381$export$92387174baf9b227; }, function (v) { return $fc1f7a2668268381$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $fc1f7a2668268381$export$ec112efeb987d9c6; }, function (v) { return $fc1f7a2668268381$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $fc1f7a2668268381$export$b706b080d889d2c9; }, function (v) { return $fc1f7a2668268381$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $fc1f7a2668268381$export$5be5a87408f70ddc; }, function (v) { return $fc1f7a2668268381$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $fc1f7a2668268381$export$45a5e7f76e0caa8d; }, function (v) { return $fc1f7a2668268381$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $fc1f7a2668268381$export$455c2e768291efa6; }, function (v) { return $fc1f7a2668268381$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $fc1f7a2668268381$export$9522e17588c12572; }, function (v) { return $fc1f7a2668268381$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $fc1f7a2668268381$export$2110ac352bb060b9; }, function (v) { return $fc1f7a2668268381$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $fc1f7a2668268381$export$56885ab8b9c456ab; }, function (v) { return $fc1f7a2668268381$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $fc1f7a2668268381$export$d927fcb6adf8f9de; }, function (v) { return $fc1f7a2668268381$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $fc1f7a2668268381$export$b82d16f27459e05a; }, function (v) { return $fc1f7a2668268381$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $fc1f7a2668268381$export$522c17b4f5e123e8; }, function (v) { return $fc1f7a2668268381$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $fc1f7a2668268381$export$1aabd8a0274ecfd6; }, function (v) { return $fc1f7a2668268381$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $fc1f7a2668268381$export$9b621391a187a31a; }, function (v) { return $fc1f7a2668268381$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $fc1f7a2668268381$export$f5bbd400c2f4426f; }, function (v) { return $fc1f7a2668268381$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fc1f7a2668268381$export$2b8d127b894957b9;
var $fc1f7a2668268381$export$cea3a54a6425200c;
var $fc1f7a2668268381$export$a7c73072b1a182ae;
var $fc1f7a2668268381$export$9f27bc3417b4524d;
var $fc1f7a2668268381$export$db77ccec0bb4ccac;
var $fc1f7a2668268381$export$8392c0c9d3dcbd35;
var $fc1f7a2668268381$export$ffb0004e005737fa;
var $fc1f7a2668268381$export$b624eff549462981;
var $fc1f7a2668268381$export$7897aa7841a5380c;
var $fc1f7a2668268381$export$602eac185826482c;
var $fc1f7a2668268381$export$e2c29f18771995cb;
var $fc1f7a2668268381$export$5f8d39834fd61797;
var $fc1f7a2668268381$export$74bf444e3cd11ea5;
var $fc1f7a2668268381$export$92387174baf9b227;
var $fc1f7a2668268381$export$ec112efeb987d9c6;
var $fc1f7a2668268381$export$b706b080d889d2c9;
var $fc1f7a2668268381$export$5be5a87408f70ddc;
var $fc1f7a2668268381$export$45a5e7f76e0caa8d;
var $fc1f7a2668268381$export$455c2e768291efa6;
var $fc1f7a2668268381$export$9522e17588c12572;
var $fc1f7a2668268381$export$2110ac352bb060b9;
var $fc1f7a2668268381$export$56885ab8b9c456ab;
var $fc1f7a2668268381$export$d927fcb6adf8f9de;
var $fc1f7a2668268381$export$b82d16f27459e05a;
var $fc1f7a2668268381$export$522c17b4f5e123e8;
var $fc1f7a2668268381$export$1aabd8a0274ecfd6;
var $fc1f7a2668268381$export$9b621391a187a31a;
var $fc1f7a2668268381$export$f5bbd400c2f4426f;
"use strict";
var $fc1f7a2668268381$var$b = "function" === typeof Symbol && Symbol.for, $fc1f7a2668268381$var$c = $fc1f7a2668268381$var$b ? Symbol.for("react.element") : 60103, $fc1f7a2668268381$var$d = $fc1f7a2668268381$var$b ? Symbol.for("react.portal") : 60106, $fc1f7a2668268381$var$e = $fc1f7a2668268381$var$b ? Symbol.for("react.fragment") : 60107, $fc1f7a2668268381$var$f = $fc1f7a2668268381$var$b ? Symbol.for("react.strict_mode") : 60108, $fc1f7a2668268381$var$g = $fc1f7a2668268381$var$b ? Symbol.for("react.profiler") : 60114, $fc1f7a2668268381$var$h = $fc1f7a2668268381$var$b ? Symbol.for("react.provider") : 60109, $fc1f7a2668268381$var$k = $fc1f7a2668268381$var$b ? Symbol.for("react.context") : 60110, $fc1f7a2668268381$var$l = $fc1f7a2668268381$var$b ? Symbol.for("react.async_mode") : 60111, $fc1f7a2668268381$var$m = $fc1f7a2668268381$var$b ? Symbol.for("react.concurrent_mode") : 60111, $fc1f7a2668268381$var$n = $fc1f7a2668268381$var$b ? Symbol.for("react.forward_ref") : 60112, $fc1f7a2668268381$var$p = $fc1f7a2668268381$var$b ? Symbol.for("react.suspense") : 60113, $fc1f7a2668268381$var$q = $fc1f7a2668268381$var$b ? Symbol.for("react.suspense_list") : 60120, $fc1f7a2668268381$var$r = $fc1f7a2668268381$var$b ? Symbol.for("react.memo") : 60115, $fc1f7a2668268381$var$t = $fc1f7a2668268381$var$b ? Symbol.for("react.lazy") : 60116, $fc1f7a2668268381$var$v = $fc1f7a2668268381$var$b ? Symbol.for("react.block") : 60121, $fc1f7a2668268381$var$w = $fc1f7a2668268381$var$b ? Symbol.for("react.fundamental") : 60117, $fc1f7a2668268381$var$x = $fc1f7a2668268381$var$b ? Symbol.for("react.responder") : 60118, $fc1f7a2668268381$var$y = $fc1f7a2668268381$var$b ? Symbol.for("react.scope") : 60119;
function $fc1f7a2668268381$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $fc1f7a2668268381$var$c:
                switch(a = a.type, a){
                    case $fc1f7a2668268381$var$l:
                    case $fc1f7a2668268381$var$m:
                    case $fc1f7a2668268381$var$e:
                    case $fc1f7a2668268381$var$g:
                    case $fc1f7a2668268381$var$f:
                    case $fc1f7a2668268381$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $fc1f7a2668268381$var$k:
                            case $fc1f7a2668268381$var$n:
                            case $fc1f7a2668268381$var$t:
                            case $fc1f7a2668268381$var$r:
                            case $fc1f7a2668268381$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $fc1f7a2668268381$var$d:
                return u;
        }
    }
}
function $fc1f7a2668268381$var$A(a) {
    return $fc1f7a2668268381$var$z(a) === $fc1f7a2668268381$var$m;
}
$fc1f7a2668268381$export$2b8d127b894957b9 = $fc1f7a2668268381$var$l;
$fc1f7a2668268381$export$cea3a54a6425200c = $fc1f7a2668268381$var$m;
$fc1f7a2668268381$export$a7c73072b1a182ae = $fc1f7a2668268381$var$k;
$fc1f7a2668268381$export$9f27bc3417b4524d = $fc1f7a2668268381$var$h;
$fc1f7a2668268381$export$db77ccec0bb4ccac = $fc1f7a2668268381$var$c;
$fc1f7a2668268381$export$8392c0c9d3dcbd35 = $fc1f7a2668268381$var$n;
$fc1f7a2668268381$export$ffb0004e005737fa = $fc1f7a2668268381$var$e;
$fc1f7a2668268381$export$b624eff549462981 = $fc1f7a2668268381$var$t;
$fc1f7a2668268381$export$7897aa7841a5380c = $fc1f7a2668268381$var$r;
$fc1f7a2668268381$export$602eac185826482c = $fc1f7a2668268381$var$d;
$fc1f7a2668268381$export$e2c29f18771995cb = $fc1f7a2668268381$var$g;
$fc1f7a2668268381$export$5f8d39834fd61797 = $fc1f7a2668268381$var$f;
$fc1f7a2668268381$export$74bf444e3cd11ea5 = $fc1f7a2668268381$var$p;
$fc1f7a2668268381$export$92387174baf9b227 = function(a) {
    return $fc1f7a2668268381$var$A(a) || $fc1f7a2668268381$var$z(a) === $fc1f7a2668268381$var$l;
};
$fc1f7a2668268381$export$ec112efeb987d9c6 = $fc1f7a2668268381$var$A;
$fc1f7a2668268381$export$b706b080d889d2c9 = function(a) {
    return $fc1f7a2668268381$var$z(a) === $fc1f7a2668268381$var$k;
};
$fc1f7a2668268381$export$5be5a87408f70ddc = function(a) {
    return $fc1f7a2668268381$var$z(a) === $fc1f7a2668268381$var$h;
};
$fc1f7a2668268381$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $fc1f7a2668268381$var$c;
};
$fc1f7a2668268381$export$455c2e768291efa6 = function(a) {
    return $fc1f7a2668268381$var$z(a) === $fc1f7a2668268381$var$n;
};
$fc1f7a2668268381$export$9522e17588c12572 = function(a) {
    return $fc1f7a2668268381$var$z(a) === $fc1f7a2668268381$var$e;
};
$fc1f7a2668268381$export$2110ac352bb060b9 = function(a) {
    return $fc1f7a2668268381$var$z(a) === $fc1f7a2668268381$var$t;
};
$fc1f7a2668268381$export$56885ab8b9c456ab = function(a) {
    return $fc1f7a2668268381$var$z(a) === $fc1f7a2668268381$var$r;
};
$fc1f7a2668268381$export$d927fcb6adf8f9de = function(a) {
    return $fc1f7a2668268381$var$z(a) === $fc1f7a2668268381$var$d;
};
$fc1f7a2668268381$export$b82d16f27459e05a = function(a) {
    return $fc1f7a2668268381$var$z(a) === $fc1f7a2668268381$var$g;
};
$fc1f7a2668268381$export$522c17b4f5e123e8 = function(a) {
    return $fc1f7a2668268381$var$z(a) === $fc1f7a2668268381$var$f;
};
$fc1f7a2668268381$export$1aabd8a0274ecfd6 = function(a) {
    return $fc1f7a2668268381$var$z(a) === $fc1f7a2668268381$var$p;
};
$fc1f7a2668268381$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $fc1f7a2668268381$var$e || a === $fc1f7a2668268381$var$m || a === $fc1f7a2668268381$var$g || a === $fc1f7a2668268381$var$f || a === $fc1f7a2668268381$var$p || a === $fc1f7a2668268381$var$q || "object" === typeof a && null !== a && (a.$$typeof === $fc1f7a2668268381$var$t || a.$$typeof === $fc1f7a2668268381$var$r || a.$$typeof === $fc1f7a2668268381$var$h || a.$$typeof === $fc1f7a2668268381$var$k || a.$$typeof === $fc1f7a2668268381$var$n || a.$$typeof === $fc1f7a2668268381$var$w || a.$$typeof === $fc1f7a2668268381$var$x || a.$$typeof === $fc1f7a2668268381$var$y || a.$$typeof === $fc1f7a2668268381$var$v);
};
$fc1f7a2668268381$export$f5bbd400c2f4426f = $fc1f7a2668268381$var$z;

});

parcelRegister("bdAwF", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $82ad3ddd2a87c932$export$a7c73072b1a182ae; }, function (v) { return $82ad3ddd2a87c932$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $82ad3ddd2a87c932$export$9f27bc3417b4524d; }, function (v) { return $82ad3ddd2a87c932$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $82ad3ddd2a87c932$export$db77ccec0bb4ccac; }, function (v) { return $82ad3ddd2a87c932$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $82ad3ddd2a87c932$export$8392c0c9d3dcbd35; }, function (v) { return $82ad3ddd2a87c932$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $82ad3ddd2a87c932$export$ffb0004e005737fa; }, function (v) { return $82ad3ddd2a87c932$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $82ad3ddd2a87c932$export$b624eff549462981; }, function (v) { return $82ad3ddd2a87c932$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $82ad3ddd2a87c932$export$7897aa7841a5380c; }, function (v) { return $82ad3ddd2a87c932$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $82ad3ddd2a87c932$export$602eac185826482c; }, function (v) { return $82ad3ddd2a87c932$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $82ad3ddd2a87c932$export$e2c29f18771995cb; }, function (v) { return $82ad3ddd2a87c932$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $82ad3ddd2a87c932$export$5f8d39834fd61797; }, function (v) { return $82ad3ddd2a87c932$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $82ad3ddd2a87c932$export$74bf444e3cd11ea5; }, function (v) { return $82ad3ddd2a87c932$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $82ad3ddd2a87c932$export$92387174baf9b227; }, function (v) { return $82ad3ddd2a87c932$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $82ad3ddd2a87c932$export$ec112efeb987d9c6; }, function (v) { return $82ad3ddd2a87c932$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $82ad3ddd2a87c932$export$b706b080d889d2c9; }, function (v) { return $82ad3ddd2a87c932$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $82ad3ddd2a87c932$export$5be5a87408f70ddc; }, function (v) { return $82ad3ddd2a87c932$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $82ad3ddd2a87c932$export$45a5e7f76e0caa8d; }, function (v) { return $82ad3ddd2a87c932$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $82ad3ddd2a87c932$export$455c2e768291efa6; }, function (v) { return $82ad3ddd2a87c932$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $82ad3ddd2a87c932$export$9522e17588c12572; }, function (v) { return $82ad3ddd2a87c932$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $82ad3ddd2a87c932$export$2110ac352bb060b9; }, function (v) { return $82ad3ddd2a87c932$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $82ad3ddd2a87c932$export$56885ab8b9c456ab; }, function (v) { return $82ad3ddd2a87c932$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $82ad3ddd2a87c932$export$d927fcb6adf8f9de; }, function (v) { return $82ad3ddd2a87c932$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $82ad3ddd2a87c932$export$b82d16f27459e05a; }, function (v) { return $82ad3ddd2a87c932$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $82ad3ddd2a87c932$export$522c17b4f5e123e8; }, function (v) { return $82ad3ddd2a87c932$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $82ad3ddd2a87c932$export$1aabd8a0274ecfd6; }, function (v) { return $82ad3ddd2a87c932$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $82ad3ddd2a87c932$export$9b621391a187a31a; }, function (v) { return $82ad3ddd2a87c932$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $82ad3ddd2a87c932$export$f5bbd400c2f4426f; }, function (v) { return $82ad3ddd2a87c932$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $82ad3ddd2a87c932$export$a7c73072b1a182ae;
var $82ad3ddd2a87c932$export$9f27bc3417b4524d;
var $82ad3ddd2a87c932$export$db77ccec0bb4ccac;
var $82ad3ddd2a87c932$export$8392c0c9d3dcbd35;
var $82ad3ddd2a87c932$export$ffb0004e005737fa;
var $82ad3ddd2a87c932$export$b624eff549462981;
var $82ad3ddd2a87c932$export$7897aa7841a5380c;
var $82ad3ddd2a87c932$export$602eac185826482c;
var $82ad3ddd2a87c932$export$e2c29f18771995cb;
var $82ad3ddd2a87c932$export$5f8d39834fd61797;
var $82ad3ddd2a87c932$export$74bf444e3cd11ea5;
var $82ad3ddd2a87c932$export$92387174baf9b227;
var $82ad3ddd2a87c932$export$ec112efeb987d9c6;
var $82ad3ddd2a87c932$export$b706b080d889d2c9;
var $82ad3ddd2a87c932$export$5be5a87408f70ddc;
var $82ad3ddd2a87c932$export$45a5e7f76e0caa8d;
var $82ad3ddd2a87c932$export$455c2e768291efa6;
var $82ad3ddd2a87c932$export$9522e17588c12572;
var $82ad3ddd2a87c932$export$2110ac352bb060b9;
var $82ad3ddd2a87c932$export$56885ab8b9c456ab;
var $82ad3ddd2a87c932$export$d927fcb6adf8f9de;
var $82ad3ddd2a87c932$export$b82d16f27459e05a;
var $82ad3ddd2a87c932$export$522c17b4f5e123e8;
var $82ad3ddd2a87c932$export$1aabd8a0274ecfd6;
var $82ad3ddd2a87c932$export$9b621391a187a31a;
var $82ad3ddd2a87c932$export$f5bbd400c2f4426f;
"use strict";
var $82ad3ddd2a87c932$var$b = 60103, $82ad3ddd2a87c932$var$c = 60106, $82ad3ddd2a87c932$var$d = 60107, $82ad3ddd2a87c932$var$e = 60108, $82ad3ddd2a87c932$var$f = 60114, $82ad3ddd2a87c932$var$g = 60109, $82ad3ddd2a87c932$var$h = 60110, $82ad3ddd2a87c932$var$k = 60112, $82ad3ddd2a87c932$var$l = 60113, $82ad3ddd2a87c932$var$m = 60120, $82ad3ddd2a87c932$var$n = 60115, $82ad3ddd2a87c932$var$p = 60116, $82ad3ddd2a87c932$var$q = 60121, $82ad3ddd2a87c932$var$r = 60122, $82ad3ddd2a87c932$var$u = 60117, $82ad3ddd2a87c932$var$v = 60129, $82ad3ddd2a87c932$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $82ad3ddd2a87c932$var$x = Symbol.for;
    $82ad3ddd2a87c932$var$b = $82ad3ddd2a87c932$var$x("react.element");
    $82ad3ddd2a87c932$var$c = $82ad3ddd2a87c932$var$x("react.portal");
    $82ad3ddd2a87c932$var$d = $82ad3ddd2a87c932$var$x("react.fragment");
    $82ad3ddd2a87c932$var$e = $82ad3ddd2a87c932$var$x("react.strict_mode");
    $82ad3ddd2a87c932$var$f = $82ad3ddd2a87c932$var$x("react.profiler");
    $82ad3ddd2a87c932$var$g = $82ad3ddd2a87c932$var$x("react.provider");
    $82ad3ddd2a87c932$var$h = $82ad3ddd2a87c932$var$x("react.context");
    $82ad3ddd2a87c932$var$k = $82ad3ddd2a87c932$var$x("react.forward_ref");
    $82ad3ddd2a87c932$var$l = $82ad3ddd2a87c932$var$x("react.suspense");
    $82ad3ddd2a87c932$var$m = $82ad3ddd2a87c932$var$x("react.suspense_list");
    $82ad3ddd2a87c932$var$n = $82ad3ddd2a87c932$var$x("react.memo");
    $82ad3ddd2a87c932$var$p = $82ad3ddd2a87c932$var$x("react.lazy");
    $82ad3ddd2a87c932$var$q = $82ad3ddd2a87c932$var$x("react.block");
    $82ad3ddd2a87c932$var$r = $82ad3ddd2a87c932$var$x("react.server.block");
    $82ad3ddd2a87c932$var$u = $82ad3ddd2a87c932$var$x("react.fundamental");
    $82ad3ddd2a87c932$var$v = $82ad3ddd2a87c932$var$x("react.debug_trace_mode");
    $82ad3ddd2a87c932$var$w = $82ad3ddd2a87c932$var$x("react.legacy_hidden");
}
function $82ad3ddd2a87c932$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $82ad3ddd2a87c932$var$b:
                switch(a = a.type, a){
                    case $82ad3ddd2a87c932$var$d:
                    case $82ad3ddd2a87c932$var$f:
                    case $82ad3ddd2a87c932$var$e:
                    case $82ad3ddd2a87c932$var$l:
                    case $82ad3ddd2a87c932$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $82ad3ddd2a87c932$var$h:
                            case $82ad3ddd2a87c932$var$k:
                            case $82ad3ddd2a87c932$var$p:
                            case $82ad3ddd2a87c932$var$n:
                            case $82ad3ddd2a87c932$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $82ad3ddd2a87c932$var$c:
                return t;
        }
    }
}
var $82ad3ddd2a87c932$var$z = $82ad3ddd2a87c932$var$g, $82ad3ddd2a87c932$var$A = $82ad3ddd2a87c932$var$b, $82ad3ddd2a87c932$var$B = $82ad3ddd2a87c932$var$k, $82ad3ddd2a87c932$var$C = $82ad3ddd2a87c932$var$d, $82ad3ddd2a87c932$var$D = $82ad3ddd2a87c932$var$p, $82ad3ddd2a87c932$var$E = $82ad3ddd2a87c932$var$n, $82ad3ddd2a87c932$var$F = $82ad3ddd2a87c932$var$c, $82ad3ddd2a87c932$var$G = $82ad3ddd2a87c932$var$f, $82ad3ddd2a87c932$var$H = $82ad3ddd2a87c932$var$e, $82ad3ddd2a87c932$var$I = $82ad3ddd2a87c932$var$l;
$82ad3ddd2a87c932$export$a7c73072b1a182ae = $82ad3ddd2a87c932$var$h;
$82ad3ddd2a87c932$export$9f27bc3417b4524d = $82ad3ddd2a87c932$var$z;
$82ad3ddd2a87c932$export$db77ccec0bb4ccac = $82ad3ddd2a87c932$var$A;
$82ad3ddd2a87c932$export$8392c0c9d3dcbd35 = $82ad3ddd2a87c932$var$B;
$82ad3ddd2a87c932$export$ffb0004e005737fa = $82ad3ddd2a87c932$var$C;
$82ad3ddd2a87c932$export$b624eff549462981 = $82ad3ddd2a87c932$var$D;
$82ad3ddd2a87c932$export$7897aa7841a5380c = $82ad3ddd2a87c932$var$E;
$82ad3ddd2a87c932$export$602eac185826482c = $82ad3ddd2a87c932$var$F;
$82ad3ddd2a87c932$export$e2c29f18771995cb = $82ad3ddd2a87c932$var$G;
$82ad3ddd2a87c932$export$5f8d39834fd61797 = $82ad3ddd2a87c932$var$H;
$82ad3ddd2a87c932$export$74bf444e3cd11ea5 = $82ad3ddd2a87c932$var$I;
$82ad3ddd2a87c932$export$92387174baf9b227 = function() {
    return !1;
};
$82ad3ddd2a87c932$export$ec112efeb987d9c6 = function() {
    return !1;
};
$82ad3ddd2a87c932$export$b706b080d889d2c9 = function(a) {
    return $82ad3ddd2a87c932$var$y(a) === $82ad3ddd2a87c932$var$h;
};
$82ad3ddd2a87c932$export$5be5a87408f70ddc = function(a) {
    return $82ad3ddd2a87c932$var$y(a) === $82ad3ddd2a87c932$var$g;
};
$82ad3ddd2a87c932$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $82ad3ddd2a87c932$var$b;
};
$82ad3ddd2a87c932$export$455c2e768291efa6 = function(a) {
    return $82ad3ddd2a87c932$var$y(a) === $82ad3ddd2a87c932$var$k;
};
$82ad3ddd2a87c932$export$9522e17588c12572 = function(a) {
    return $82ad3ddd2a87c932$var$y(a) === $82ad3ddd2a87c932$var$d;
};
$82ad3ddd2a87c932$export$2110ac352bb060b9 = function(a) {
    return $82ad3ddd2a87c932$var$y(a) === $82ad3ddd2a87c932$var$p;
};
$82ad3ddd2a87c932$export$56885ab8b9c456ab = function(a) {
    return $82ad3ddd2a87c932$var$y(a) === $82ad3ddd2a87c932$var$n;
};
$82ad3ddd2a87c932$export$d927fcb6adf8f9de = function(a) {
    return $82ad3ddd2a87c932$var$y(a) === $82ad3ddd2a87c932$var$c;
};
$82ad3ddd2a87c932$export$b82d16f27459e05a = function(a) {
    return $82ad3ddd2a87c932$var$y(a) === $82ad3ddd2a87c932$var$f;
};
$82ad3ddd2a87c932$export$522c17b4f5e123e8 = function(a) {
    return $82ad3ddd2a87c932$var$y(a) === $82ad3ddd2a87c932$var$e;
};
$82ad3ddd2a87c932$export$1aabd8a0274ecfd6 = function(a) {
    return $82ad3ddd2a87c932$var$y(a) === $82ad3ddd2a87c932$var$l;
};
$82ad3ddd2a87c932$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $82ad3ddd2a87c932$var$d || a === $82ad3ddd2a87c932$var$f || a === $82ad3ddd2a87c932$var$v || a === $82ad3ddd2a87c932$var$e || a === $82ad3ddd2a87c932$var$l || a === $82ad3ddd2a87c932$var$m || a === $82ad3ddd2a87c932$var$w || "object" === typeof a && null !== a && (a.$$typeof === $82ad3ddd2a87c932$var$p || a.$$typeof === $82ad3ddd2a87c932$var$n || a.$$typeof === $82ad3ddd2a87c932$var$g || a.$$typeof === $82ad3ddd2a87c932$var$h || a.$$typeof === $82ad3ddd2a87c932$var$k || a.$$typeof === $82ad3ddd2a87c932$var$u || a.$$typeof === $82ad3ddd2a87c932$var$q || a[0] === $82ad3ddd2a87c932$var$r) ? !0 : !1;
};
$82ad3ddd2a87c932$export$f5bbd400c2f4426f = $82ad3ddd2a87c932$var$y;

});

parcelRegister("dTaMq", function(module, exports) {



































(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("cYuD7")), (parcelRequire("aYLLb")), (parcelRequire("6el64")), (parcelRequire("6dKab")), (parcelRequire("9Rbvf")), (parcelRequire("a0xnY")), (parcelRequire("wR7Wh")), (parcelRequire("lf1Ha")), (parcelRequire("7wuKR")), (parcelRequire("g7CXV")), (parcelRequire("f9M20")), (parcelRequire("kcWvP")), (parcelRequire("kEOlw")), (parcelRequire("aKIIo")), (parcelRequire("66hOO")), (parcelRequire("5WeOV")), (parcelRequire("64KR9")), (parcelRequire("hgJk2")), (parcelRequire("7gIE2")), (parcelRequire("jKwM4")), (parcelRequire("fRRhz")), (parcelRequire("58YYs")), (parcelRequire("1lYsS")), (parcelRequire("axDDs")), (parcelRequire("eKc4d")), (parcelRequire("5ntzk")), (parcelRequire("iUKZQ")), (parcelRequire("8joJf")), (parcelRequire("kAsNV")), (parcelRequire("c7Uaf")), (parcelRequire("61lhf")), (parcelRequire("2BDEU")), (parcelRequire("dUpKV")), (parcelRequire("6LwKF")));
})(this, function(CryptoJS) {
    return CryptoJS;
});

});
parcelRegister("8Z8Le", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== "undefined" && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== "undefined" && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("15aIS"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === "function") try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === "function") try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});
parcelRegister("15aIS", function(module, exports) {
"use strict";

});


parcelRegister("cYuD7", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;
        /**
	     * x64 namespace.
	     */ var C_x64 = C.x64 = {};
        /**
	     * A 64-bit word.
	     */ var X64Word = C_x64.Word = Base.extend({
            /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */ init: function(high, low) {
                this.high = high;
                this.low = low;
            }
        });
        /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var X64WordArray = C_x64.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 8;
            },
            /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */ toX32: function() {
                // Shortcuts
                var x64Words = this.words;
                var x64WordsLength = x64Words.length;
                // Convert
                var x32Words = [];
                for(var i = 0; i < x64WordsLength; i++){
                    var x64Word = x64Words[i];
                    x32Words.push(x64Word.high);
                    x32Words.push(x64Word.low);
                }
                return X32WordArray.create(x32Words, this.sigBytes);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                // Clone "words" array
                var words = clone.words = this.words.slice(0);
                // Clone each X64Word object
                var wordsLength = words.length;
                for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                return clone;
            }
        });
    })();
    return CryptoJS;
});

});

parcelRegister("aYLLb", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != "function") return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("6el64", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * UTF-16 BE encoding strategy.
	     */ var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
            /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        /**
	     * UTF-16 LE encoding strategy.
	     */ C_enc.Utf16LE = {
            /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        function swapEndian(word) {
            return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
        }
    })();
    return CryptoJS.enc.Utf16;
});

});

parcelRegister("6dKab", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("9Rbvf", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64url encoding strategy.
	     */ var Base64url = C_enc.Base64url = {
            /**
	         * Converts a word array to a Base64url string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {string} The Base64url string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
	         */ stringify: function(wordArray, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = urlSafe ? this._safe_map : this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64url string to a word array.
	         *
	         * @param {string} base64Str The Base64url string.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
	         */ parse: function(base64Str, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = urlSafe ? this._safe_map : this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
            _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64url;
});

});

parcelRegister("a0xnY", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

});

parcelRegister("wR7Wh", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Reusable object
        var W = [];
        /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476,
                    0xc3d2e1f0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                // Computation
                for(var i = 0; i < 80; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                    else t += (b ^ c ^ d) - 0x359d3e2a;
                    e = d;
                    d = c;
                    c = b << 30 | b >>> 2;
                    b = a;
                    a = t;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();
    return CryptoJS.SHA1;
});

});

parcelRegister("lf1Ha", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("7wuKR", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("lf1Ha")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        /**
	     * SHA-224 hash algorithm.
	     */ var SHA224 = C_algo.SHA224 = SHA256.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0xc1059ed8,
                    0x367cd507,
                    0x3070dd17,
                    0xf70e5939,
                    0xffc00b31,
                    0x68581511,
                    0x64f98fa7,
                    0xbefa4fa4
                ]);
            },
            _doFinalize: function() {
                var hash = SHA256._doFinalize.call(this);
                hash.sigBytes -= 4;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */ C.SHA224 = SHA256._createHelper(SHA224);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */ C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
    })();
    return CryptoJS.SHA224;
});

});

parcelRegister("g7CXV", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("cYuD7")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        function X64Word_create() {
            return X64Word.create.apply(X64Word, arguments);
        }
        // Constants
        var K = [
            X64Word_create(0x428a2f98, 0xd728ae22),
            X64Word_create(0x71374491, 0x23ef65cd),
            X64Word_create(0xb5c0fbcf, 0xec4d3b2f),
            X64Word_create(0xe9b5dba5, 0x8189dbbc),
            X64Word_create(0x3956c25b, 0xf348b538),
            X64Word_create(0x59f111f1, 0xb605d019),
            X64Word_create(0x923f82a4, 0xaf194f9b),
            X64Word_create(0xab1c5ed5, 0xda6d8118),
            X64Word_create(0xd807aa98, 0xa3030242),
            X64Word_create(0x12835b01, 0x45706fbe),
            X64Word_create(0x243185be, 0x4ee4b28c),
            X64Word_create(0x550c7dc3, 0xd5ffb4e2),
            X64Word_create(0x72be5d74, 0xf27b896f),
            X64Word_create(0x80deb1fe, 0x3b1696b1),
            X64Word_create(0x9bdc06a7, 0x25c71235),
            X64Word_create(0xc19bf174, 0xcf692694),
            X64Word_create(0xe49b69c1, 0x9ef14ad2),
            X64Word_create(0xefbe4786, 0x384f25e3),
            X64Word_create(0x0fc19dc6, 0x8b8cd5b5),
            X64Word_create(0x240ca1cc, 0x77ac9c65),
            X64Word_create(0x2de92c6f, 0x592b0275),
            X64Word_create(0x4a7484aa, 0x6ea6e483),
            X64Word_create(0x5cb0a9dc, 0xbd41fbd4),
            X64Word_create(0x76f988da, 0x831153b5),
            X64Word_create(0x983e5152, 0xee66dfab),
            X64Word_create(0xa831c66d, 0x2db43210),
            X64Word_create(0xb00327c8, 0x98fb213f),
            X64Word_create(0xbf597fc7, 0xbeef0ee4),
            X64Word_create(0xc6e00bf3, 0x3da88fc2),
            X64Word_create(0xd5a79147, 0x930aa725),
            X64Word_create(0x06ca6351, 0xe003826f),
            X64Word_create(0x14292967, 0x0a0e6e70),
            X64Word_create(0x27b70a85, 0x46d22ffc),
            X64Word_create(0x2e1b2138, 0x5c26c926),
            X64Word_create(0x4d2c6dfc, 0x5ac42aed),
            X64Word_create(0x53380d13, 0x9d95b3df),
            X64Word_create(0x650a7354, 0x8baf63de),
            X64Word_create(0x766a0abb, 0x3c77b2a8),
            X64Word_create(0x81c2c92e, 0x47edaee6),
            X64Word_create(0x92722c85, 0x1482353b),
            X64Word_create(0xa2bfe8a1, 0x4cf10364),
            X64Word_create(0xa81a664b, 0xbc423001),
            X64Word_create(0xc24b8b70, 0xd0f89791),
            X64Word_create(0xc76c51a3, 0x0654be30),
            X64Word_create(0xd192e819, 0xd6ef5218),
            X64Word_create(0xd6990624, 0x5565a910),
            X64Word_create(0xf40e3585, 0x5771202a),
            X64Word_create(0x106aa070, 0x32bbd1b8),
            X64Word_create(0x19a4c116, 0xb8d2d0c8),
            X64Word_create(0x1e376c08, 0x5141ab53),
            X64Word_create(0x2748774c, 0xdf8eeb99),
            X64Word_create(0x34b0bcb5, 0xe19b48a8),
            X64Word_create(0x391c0cb3, 0xc5c95a63),
            X64Word_create(0x4ed8aa4a, 0xe3418acb),
            X64Word_create(0x5b9cca4f, 0x7763e373),
            X64Word_create(0x682e6ff3, 0xd6b2b8a3),
            X64Word_create(0x748f82ee, 0x5defb2fc),
            X64Word_create(0x78a5636f, 0x43172f60),
            X64Word_create(0x84c87814, 0xa1f0ab72),
            X64Word_create(0x8cc70208, 0x1a6439ec),
            X64Word_create(0x90befffa, 0x23631e28),
            X64Word_create(0xa4506ceb, 0xde82bde9),
            X64Word_create(0xbef9a3f7, 0xb2c67915),
            X64Word_create(0xc67178f2, 0xe372532b),
            X64Word_create(0xca273ece, 0xea26619c),
            X64Word_create(0xd186b8c7, 0x21c0c207),
            X64Word_create(0xeada7dd6, 0xcde0eb1e),
            X64Word_create(0xf57d4f7f, 0xee6ed178),
            X64Word_create(0x06f067aa, 0x72176fba),
            X64Word_create(0x0a637dc5, 0xa2c898a6),
            X64Word_create(0x113f9804, 0xbef90dae),
            X64Word_create(0x1b710b35, 0x131c471b),
            X64Word_create(0x28db77f5, 0x23047d84),
            X64Word_create(0x32caab7b, 0x40c72493),
            X64Word_create(0x3c9ebe0a, 0x15c9bebc),
            X64Word_create(0x431d67c4, 0x9c100d4c),
            X64Word_create(0x4cc5d4be, 0xcb3e42b6),
            X64Word_create(0x597f299c, 0xfc657e2a),
            X64Word_create(0x5fcb6fab, 0x3ad6faec),
            X64Word_create(0x6c44198c, 0x4a475817)
        ];
        // Reusable objects
        var W = [];
        (function() {
            for(var i = 0; i < 80; i++)W[i] = X64Word_create();
        })();
        /**
	     * SHA-512 hash algorithm.
	     */ var SHA512 = C_algo.SHA512 = Hasher.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0x6a09e667, 0xf3bcc908),
                    new X64Word.init(0xbb67ae85, 0x84caa73b),
                    new X64Word.init(0x3c6ef372, 0xfe94f82b),
                    new X64Word.init(0xa54ff53a, 0x5f1d36f1),
                    new X64Word.init(0x510e527f, 0xade682d1),
                    new X64Word.init(0x9b05688c, 0x2b3e6c1f),
                    new X64Word.init(0x1f83d9ab, 0xfb41bd6b),
                    new X64Word.init(0x5be0cd19, 0x137e2179)
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var H = this._hash.words;
                var H0 = H[0];
                var H1 = H[1];
                var H2 = H[2];
                var H3 = H[3];
                var H4 = H[4];
                var H5 = H[5];
                var H6 = H[6];
                var H7 = H[7];
                var H0h = H0.high;
                var H0l = H0.low;
                var H1h = H1.high;
                var H1l = H1.low;
                var H2h = H2.high;
                var H2l = H2.low;
                var H3h = H3.high;
                var H3l = H3.low;
                var H4h = H4.high;
                var H4l = H4.low;
                var H5h = H5.high;
                var H5l = H5.low;
                var H6h = H6.high;
                var H6l = H6.low;
                var H7h = H7.high;
                var H7l = H7.low;
                // Working variables
                var ah = H0h;
                var al = H0l;
                var bh = H1h;
                var bl = H1l;
                var ch = H2h;
                var cl = H2l;
                var dh = H3h;
                var dl = H3l;
                var eh = H4h;
                var el = H4l;
                var fh = H5h;
                var fl = H5l;
                var gh = H6h;
                var gl = H6l;
                var hh = H7h;
                var hl = H7l;
                // Rounds
                for(var i = 0; i < 80; i++){
                    var Wil;
                    var Wih;
                    // Shortcut
                    var Wi = W[i];
                    // Extend message
                    if (i < 16) {
                        Wih = Wi.high = M[offset + i * 2] | 0;
                        Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                    } else {
                        // Gamma0
                        var gamma0x = W[i - 15];
                        var gamma0xh = gamma0x.high;
                        var gamma0xl = gamma0x.low;
                        var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                        var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
                        // Gamma1
                        var gamma1x = W[i - 2];
                        var gamma1xh = gamma1x.high;
                        var gamma1xl = gamma1x.low;
                        var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                        var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
                        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                        var Wi7 = W[i - 7];
                        var Wi7h = Wi7.high;
                        var Wi7l = Wi7.low;
                        var Wi16 = W[i - 16];
                        var Wi16h = Wi16.high;
                        var Wi16l = Wi16.low;
                        Wil = gamma0l + Wi7l;
                        Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                        Wil = Wil + gamma1l;
                        Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                        Wil = Wil + Wi16l;
                        Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                        Wi.high = Wih;
                        Wi.low = Wil;
                    }
                    var chh = eh & fh ^ ~eh & gh;
                    var chl = el & fl ^ ~el & gl;
                    var majh = ah & bh ^ ah & ch ^ bh & ch;
                    var majl = al & bl ^ al & cl ^ bl & cl;
                    var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                    var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                    var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                    var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
                    // t1 = h + sigma1 + ch + K[i] + W[i]
                    var Ki = K[i];
                    var Kih = Ki.high;
                    var Kil = Ki.low;
                    var t1l = hl + sigma1l;
                    var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                    var t1l = t1l + chl;
                    var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                    var t1l = t1l + Kil;
                    var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                    var t1l = t1l + Wil;
                    var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
                    // t2 = sigma0 + maj
                    var t2l = sigma0l + majl;
                    var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
                    // Update working variables
                    hh = gh;
                    hl = gl;
                    gh = fh;
                    gl = fl;
                    fh = eh;
                    fl = el;
                    el = dl + t1l | 0;
                    eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                    dh = ch;
                    dl = cl;
                    ch = bh;
                    cl = bl;
                    bh = ah;
                    bl = al;
                    al = t1l + t2l | 0;
                    ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
                }
                // Intermediate hash value
                H0l = H0.low = H0l + al;
                H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                H1l = H1.low = H1l + bl;
                H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                H2l = H2.low = H2l + cl;
                H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                H3l = H3.low = H3l + dl;
                H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                H4l = H4.low = H4l + el;
                H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                H5l = H5.low = H5l + fl;
                H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                H6l = H6.low = H6l + gl;
                H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                H7l = H7.low = H7l + hl;
                H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Convert hash to 32-bit word array before returning
                var hash = this._hash.toX32();
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            },
            blockSize: 32
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */ C.SHA512 = Hasher._createHelper(SHA512);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */ C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
    })();
    return CryptoJS.SHA512;
});

});

parcelRegister("f9M20", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("cYuD7")), (parcelRequire("g7CXV")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        var SHA512 = C_algo.SHA512;
        /**
	     * SHA-384 hash algorithm.
	     */ var SHA384 = C_algo.SHA384 = SHA512.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0xcbbb9d5d, 0xc1059ed8),
                    new X64Word.init(0x629a292a, 0x367cd507),
                    new X64Word.init(0x9159015a, 0x3070dd17),
                    new X64Word.init(0x152fecd8, 0xf70e5939),
                    new X64Word.init(0x67332667, 0xffc00b31),
                    new X64Word.init(0x8eb44a87, 0x68581511),
                    new X64Word.init(0xdb0c2e0d, 0x64f98fa7),
                    new X64Word.init(0x47b5481d, 0xbefa4fa4)
                ]);
            },
            _doFinalize: function() {
                var hash = SHA512._doFinalize.call(this);
                hash.sigBytes -= 16;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */ C.SHA384 = SHA512._createHelper(SHA384);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */ C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
    })();
    return CryptoJS.SHA384;
});

});

parcelRegister("kcWvP", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("cYuD7")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;
        // Constants tables
        var RHO_OFFSETS = [];
        var PI_INDEXES = [];
        var ROUND_CONSTANTS = [];
        // Compute Constants
        (function() {
            // Compute rho offset constants
            var x = 1, y = 0;
            for(var t = 0; t < 24; t++){
                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                var newX = y % 5;
                var newY = (2 * x + 3 * y) % 5;
                x = newX;
                y = newY;
            }
            // Compute pi index constants
            for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
            // Compute round constants
            var LFSR = 0x01;
            for(var i = 0; i < 24; i++){
                var roundConstantMsw = 0;
                var roundConstantLsw = 0;
                for(var j = 0; j < 7; j++){
                    if (LFSR & 0x01) {
                        var bitPosition = (1 << j) - 1;
                        if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                        else roundConstantMsw ^= 1 << bitPosition - 32;
                    }
                    // Compute next LFSR
                    if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                    LFSR = LFSR << 1 ^ 0x71;
                    else LFSR <<= 1;
                }
                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
            }
        })();
        // Reusable objects for temporary values
        var T = [];
        (function() {
            for(var i = 0; i < 25; i++)T[i] = X64Word.create();
        })();
        /**
	     * SHA-3 hash algorithm.
	     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */ cfg: Hasher.cfg.extend({
                outputLength: 512
            }),
            _doReset: function() {
                var state = this._state = [];
                for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var state = this._state;
                var nBlockSizeLanes = this.blockSize / 2;
                // Absorb
                for(var i = 0; i < nBlockSizeLanes; i++){
                    // Shortcuts
                    var M2i = M[offset + 2 * i];
                    var M2i1 = M[offset + 2 * i + 1];
                    // Swap endian
                    M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                    M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                    // Absorb message into state
                    var lane = state[i];
                    lane.high ^= M2i1;
                    lane.low ^= M2i;
                }
                // Rounds
                for(var round = 0; round < 24; round++){
                    // Theta
                    for(var x = 0; x < 5; x++){
                        // Mix column lanes
                        var tMsw = 0, tLsw = 0;
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            tMsw ^= lane.high;
                            tLsw ^= lane.low;
                        }
                        // Temporary values
                        var Tx = T[x];
                        Tx.high = tMsw;
                        Tx.low = tLsw;
                    }
                    for(var x = 0; x < 5; x++){
                        // Shortcuts
                        var Tx4 = T[(x + 4) % 5];
                        var Tx1 = T[(x + 1) % 5];
                        var Tx1Msw = Tx1.high;
                        var Tx1Lsw = Tx1.low;
                        // Mix surrounding columns
                        var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                        var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            lane.high ^= tMsw;
                            lane.low ^= tLsw;
                        }
                    }
                    // Rho Pi
                    for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                        var tMsw;
                        var tLsw;
                        // Shortcuts
                        var lane = state[laneIndex];
                        var laneMsw = lane.high;
                        var laneLsw = lane.low;
                        var rhoOffset = RHO_OFFSETS[laneIndex];
                        // Rotate lanes
                        if (rhoOffset < 32) {
                            tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                            tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                        } else /* if (rhoOffset >= 32) */ {
                            tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                            tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                        }
                        // Transpose lanes
                        var TPiLane = T[PI_INDEXES[laneIndex]];
                        TPiLane.high = tMsw;
                        TPiLane.low = tLsw;
                    }
                    // Rho pi at x = y = 0
                    var T0 = T[0];
                    var state0 = state[0];
                    T0.high = state0.high;
                    T0.low = state0.low;
                    // Chi
                    for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                        // Shortcuts
                        var laneIndex = x + 5 * y;
                        var lane = state[laneIndex];
                        var TLane = T[laneIndex];
                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                        // Mix rows
                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                    }
                    // Iota
                    var lane = state[0];
                    var roundConstant = ROUND_CONSTANTS[round];
                    lane.high ^= roundConstant.high;
                    lane.low ^= roundConstant.low;
                }
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                var blockSizeBits = this.blockSize * 32;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var state = this._state;
                var outputLengthBytes = this.cfg.outputLength / 8;
                var outputLengthLanes = outputLengthBytes / 8;
                // Squeeze
                var hashWords = [];
                for(var i = 0; i < outputLengthLanes; i++){
                    // Shortcuts
                    var lane = state[i];
                    var laneMsw = lane.high;
                    var laneLsw = lane.low;
                    // Swap endian
                    laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                    laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                    // Squeeze state to retrieve hash
                    hashWords.push(laneLsw);
                    hashWords.push(laneMsw);
                }
                // Return final computed hash
                return new WordArray.init(hashWords, outputLengthBytes);
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                var state = clone._state = this._state.slice(0);
                for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */ C.SHA3 = Hasher._createHelper(SHA3);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
    })(Math);
    return CryptoJS.SHA3;
});

});

parcelRegister("kEOlw", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")));
})(this, function(CryptoJS) {
    /** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/ (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var _zl = WordArray.create([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
        ]);
        var _zr = WordArray.create([
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
        ]);
        var _sl = WordArray.create([
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
        ]);
        var _sr = WordArray.create([
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
        ]);
        var _hl = WordArray.create([
            0x00000000,
            0x5A827999,
            0x6ED9EBA1,
            0x8F1BBCDC,
            0xA953FD4E
        ]);
        var _hr = WordArray.create([
            0x50A28BE6,
            0x5C4DD124,
            0x6D703EF3,
            0x7A6D76E9,
            0x00000000
        ]);
        /**
	     * RIPEMD160 hash algorithm.
	     */ var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
            _doReset: function() {
                this._hash = WordArray.create([
                    0x67452301,
                    0xEFCDAB89,
                    0x98BADCFE,
                    0x10325476,
                    0xC3D2E1F0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    // Swap
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcut
                var H = this._hash.words;
                var hl = _hl.words;
                var hr = _hr.words;
                var zl = _zl.words;
                var zr = _zr.words;
                var sl = _sl.words;
                var sr = _sr.words;
                // Working variables
                var al, bl, cl, dl, el;
                var ar, br, cr, dr, er;
                ar = al = H[0];
                br = bl = H[1];
                cr = cl = H[2];
                dr = dl = H[3];
                er = el = H[4];
                // Computation
                var t;
                for(var i = 0; i < 80; i += 1){
                    t = al + M[offset + zl[i]] | 0;
                    if (i < 16) t += f1(bl, cl, dl) + hl[0];
                    else if (i < 32) t += f2(bl, cl, dl) + hl[1];
                    else if (i < 48) t += f3(bl, cl, dl) + hl[2];
                    else if (i < 64) t += f4(bl, cl, dl) + hl[3];
                    else t += f5(bl, cl, dl) + hl[4];
                    t = t | 0;
                    t = rotl(t, sl[i]);
                    t = t + el | 0;
                    al = el;
                    el = dl;
                    dl = rotl(cl, 10);
                    cl = bl;
                    bl = t;
                    t = ar + M[offset + zr[i]] | 0;
                    if (i < 16) t += f5(br, cr, dr) + hr[0];
                    else if (i < 32) t += f4(br, cr, dr) + hr[1];
                    else if (i < 48) t += f3(br, cr, dr) + hr[2];
                    else if (i < 64) t += f2(br, cr, dr) + hr[3];
                    else t += f1(br, cr, dr) + hr[4];
                    t = t | 0;
                    t = rotl(t, sr[i]);
                    t = t + er | 0;
                    ar = er;
                    er = dr;
                    dr = rotl(cr, 10);
                    cr = br;
                    br = t;
                }
                // Intermediate hash value
                t = H[1] + cl + dr | 0;
                H[1] = H[2] + dl + er | 0;
                H[2] = H[3] + el + ar | 0;
                H[3] = H[4] + al + br | 0;
                H[4] = H[0] + bl + cr | 0;
                H[0] = t;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 5; i++){
                    // Shortcut
                    var H_i = H[i];
                    // Swap
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function f1(x, y, z) {
            return x ^ y ^ z;
        }
        function f2(x, y, z) {
            return x & y | ~x & z;
        }
        function f3(x, y, z) {
            return (x | ~y) ^ z;
        }
        function f4(x, y, z) {
            return x & z | y & ~z;
        }
        function f5(x, y, z) {
            return x ^ (y | ~z);
        }
        function rotl(x, n) {
            return x << n | x >>> 32 - n;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */ C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */ C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
    })(Math);
    return CryptoJS.RIPEMD160;
});

});

parcelRegister("aKIIo", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == "string") key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});

parcelRegister("66hOO", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("lf1Ha")), (parcelRequire("aKIIo")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        var HMAC = C_algo.HMAC;
        /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */ var PBKDF2 = C_algo.PBKDF2 = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA256
	         * @property {number} iterations The number of iterations to perform. Default: 250000
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: SHA256,
                iterations: 250000
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                // Shortcut
                var cfg = this.cfg;
                // Init HMAC
                var hmac = HMAC.create(cfg.hasher, password);
                // Initial values
                var derivedKey = WordArray.create();
                var blockIndex = WordArray.create([
                    0x00000001
                ]);
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var blockIndexWords = blockIndex.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    var block = hmac.update(salt).finalize(blockIndex);
                    hmac.reset();
                    // Shortcuts
                    var blockWords = block.words;
                    var blockWordsLength = blockWords.length;
                    // Iterations
                    var intermediate = block;
                    for(var i = 1; i < iterations; i++){
                        intermediate = hmac.finalize(intermediate);
                        hmac.reset();
                        // Shortcut
                        var intermediateWords = intermediate.words;
                        // XOR intermediate with block
                        for(var j = 0; j < blockWordsLength; j++)blockWords[j] ^= intermediateWords[j];
                    }
                    derivedKey.concat(block);
                    blockIndexWords[0]++;
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.PBKDF2 = function(password, salt, cfg) {
            return PBKDF2.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.PBKDF2;
});

});

parcelRegister("5WeOV", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("wR7Wh")), (parcelRequire("aKIIo")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: MD5,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                var block;
                // Shortcut
                var cfg = this.cfg;
                // Init hasher
                var hasher = cfg.hasher.create();
                // Initial values
                var derivedKey = WordArray.create();
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    if (block) hasher.update(block);
                    block = hasher.update(password).finalize(salt);
                    hasher.reset();
                    // Iterations
                    for(var i = 1; i < iterations; i++){
                        block = hasher.finalize(block);
                        hasher.reset();
                    }
                    derivedKey.concat(block);
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
            return EvpKDF.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.EvpKDF;
});

});

parcelRegister("64KR9", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("5WeOV")));
})(this, function(CryptoJS) {
    /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
            /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
            },
            /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
            },
            /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Store transform mode and key
                this._xformMode = xformMode;
                this._key = key;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-cipher logic
                this._doReset();
            },
            /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function(dataUpdate) {
                // Append
                this._append(dataUpdate);
                // Process available blocks
                return this._process();
            },
            /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function(dataUpdate) {
                // Final data update
                if (dataUpdate) this._append(dataUpdate);
                // Perform concrete-cipher logic
                var finalProcessedData = this._doFinalize();
                return finalProcessedData;
            },
            keySize: 4,
            ivSize: 4,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                function selectCipherStrategy(key) {
                    if (typeof key == "string") return PasswordBasedCipher;
                    else return SerializableCipher;
                }
                return function(cipher) {
                    return {
                        encrypt: function(message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                        },
                        decrypt: function(ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                        }
                    };
                };
            }()
        });
        /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
            _doFinalize: function() {
                // Process partial blocks
                var finalProcessedBlocks = this._process(true);
                return finalProcessedBlocks;
            },
            blockSize: 1
        });
        /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
        /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
            /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
            },
            /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
            },
            /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
            }
        });
        /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
            /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
            /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // XOR and encrypt
                    xorBlock.call(this, words, offset, blockSize);
                    cipher.encryptBlock(words, offset);
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                }
            });
            /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
                    // Decrypt and XOR
                    cipher.decryptBlock(words, offset);
                    xorBlock.call(this, words, offset, blockSize);
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                }
            });
            function xorBlock(words, offset, blockSize) {
                var block;
                // Shortcut
                var iv = this._iv;
                // Choose mixing block
                if (iv) {
                    block = iv;
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                } else block = this._prevBlock;
                // XOR blocks
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
            }
            return CBC;
        }();
        /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
        /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
            /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function(data, blockSize) {
                // Shortcut
                var blockSizeBytes = blockSize * 4;
                // Count padding bytes
                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                // Create padding word
                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                // Create padding
                var paddingWords = [];
                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                var padding = WordArray.create(paddingWords, nPaddingBytes);
                // Add padding
                data.concat(padding);
            },
            /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function(data) {
                // Get number of padding bytes from last byte
                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                // Remove padding
                data.sigBytes -= nPaddingBytes;
            }
        };
        /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7
            }),
            reset: function() {
                var modeCreator;
                // Reset cipher
                Cipher.reset.call(this);
                // Shortcuts
                var cfg = this.cfg;
                var iv = cfg.iv;
                var mode = cfg.mode;
                // Reset block mode
                if (this._xformMode == this._ENC_XFORM_MODE) modeCreator = mode.createEncryptor;
                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }
                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                else {
                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                    this._mode.__creator = modeCreator;
                }
            },
            _doProcessBlock: function(words, offset) {
                this._mode.processBlock(words, offset);
            },
            _doFinalize: function() {
                var finalProcessedBlocks;
                // Shortcut
                var padding = this.cfg.padding;
                // Finalize
                if (this._xformMode == this._ENC_XFORM_MODE) {
                    // Pad data
                    padding.pad(this._data, this.blockSize);
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }
                return finalProcessedBlocks;
            },
            blockSize: 4
        });
        /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
            /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function(cipherParams) {
                this.mixIn(cipherParams);
            },
            /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function(formatter) {
                return (formatter || this.formatter).stringify(this);
            }
        });
        /**
	     * Format namespace.
	     */ var C_format = C.format = {};
        /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
            /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                var wordArray;
                // Shortcuts
                var ciphertext = cipherParams.ciphertext;
                var salt = cipherParams.salt;
                // Format
                if (salt) wordArray = WordArray.create([
                    0x53616c74,
                    0x65645f5f
                ]).concat(salt).concat(ciphertext);
                else wordArray = ciphertext;
                return wordArray.toString(Base64);
            },
            /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function(openSSLStr) {
                var salt;
                // Parse base64
                var ciphertext = Base64.parse(openSSLStr);
                // Shortcut
                var ciphertextWords = ciphertext.words;
                // Test for salt
                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                    // Extract salt
                    salt = WordArray.create(ciphertextWords.slice(2, 4));
                    // Remove salt from ciphertext
                    ciphertextWords.splice(0, 4);
                    ciphertext.sigBytes -= 16;
                }
                return CipherParams.create({
                    ciphertext: ciphertext,
                    salt: salt
                });
            }
        };
        /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                format: OpenSSLFormatter
            }),
            /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Encrypt
                var encryptor = cipher.createEncryptor(key, cfg);
                var ciphertext = encryptor.finalize(message);
                // Shortcut
                var cipherCfg = encryptor.cfg;
                // Create and return serializable cipher params
                return CipherParams.create({
                    ciphertext: ciphertext,
                    key: key,
                    iv: cipherCfg.iv,
                    algorithm: cipher,
                    mode: cipherCfg.mode,
                    padding: cipherCfg.padding,
                    blockSize: cipher.blockSize,
                    formatter: cfg.format
                });
            },
            /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Decrypt
                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
            },
            /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function(ciphertext, format) {
                if (typeof ciphertext == "string") return format.parse(ciphertext, this);
                else return ciphertext;
            }
        });
        /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
        /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
            /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function(password, keySize, ivSize, salt, hasher) {
                // Generate random salt
                if (!salt) salt = WordArray.random(8);
                // Derive key and IV
                if (!hasher) var key = EvpKDF.create({
                    keySize: keySize + ivSize
                }).compute(password, salt);
                else var key = EvpKDF.create({
                    keySize: keySize + ivSize,
                    hasher: hasher
                }).compute(password, salt);
                // Separate key and IV
                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4;
                // Return params
                return CipherParams.create({
                    key: key,
                    iv: iv,
                    salt: salt
                });
            }
        };
        /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf
            }),
            /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Encrypt
                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                // Mix in derived params
                ciphertext.mixIn(derivedParams);
                return ciphertext;
            },
            /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Decrypt
                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
            }
        });
    }();
});

});

parcelRegister("hgJk2", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("64KR9")));
})(this, function(CryptoJS) {
    /**
	 * Cipher Feedback block mode.
	 */ CryptoJS.mode.CFB = function() {
        var CFB = CryptoJS.lib.BlockCipherMode.extend();
        CFB.Encryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // Remember this block to use with next block
                this._prevBlock = words.slice(offset, offset + blockSize);
            }
        });
        CFB.Decryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                // Remember this block to use with next block
                var thisBlock = words.slice(offset, offset + blockSize);
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // This block becomes the previous block
                this._prevBlock = thisBlock;
            }
        });
        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
            var keystream;
            // Shortcut
            var iv = this._iv;
            // Generate keystream
            if (iv) {
                keystream = iv.slice(0);
                // Remove IV for subsequent blocks
                this._iv = undefined;
            } else keystream = this._prevBlock;
            cipher.encryptBlock(keystream, 0);
            // Encrypt
            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
        }
        return CFB;
    }();
    return CryptoJS.mode.CFB;
});

});

parcelRegister("7gIE2", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("64KR9")));
})(this, function(CryptoJS) {
    /**
	 * Counter block mode.
	 */ CryptoJS.mode.CTR = function() {
        var CTR = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = CTR.Encryptor = CTR.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Increment counter
                counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTR.Decryptor = Encryptor;
        return CTR;
    }();
    return CryptoJS.mode.CTR;
});

});

parcelRegister("jKwM4", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("64KR9")));
})(this, function(CryptoJS) {
    /** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */ CryptoJS.mode.CTRGladman = function() {
        var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
        function incWord(word) {
            if ((word >> 24 & 0xff) === 0xff) {
                var b1 = word >> 16 & 0xff;
                var b2 = word >> 8 & 0xff;
                var b3 = word & 0xff;
                if (b1 === 0xff) {
                    b1 = 0;
                    if (b2 === 0xff) {
                        b2 = 0;
                        if (b3 === 0xff) b3 = 0;
                        else ++b3;
                    } else ++b2;
                } else ++b1;
                word = 0;
                word += b1 << 16;
                word += b2 << 8;
                word += b3;
            } else word += 16777216;
            return word;
        }
        function incCounter(counter) {
            if ((counter[0] = incWord(counter[0])) === 0) // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
            counter[1] = incWord(counter[1]);
            return counter;
        }
        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                incCounter(counter);
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTRGladman.Decryptor = Encryptor;
        return CTRGladman;
    }();
    return CryptoJS.mode.CTRGladman;
});

});

parcelRegister("fRRhz", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("64KR9")));
})(this, function(CryptoJS) {
    /**
	 * Output Feedback block mode.
	 */ CryptoJS.mode.OFB = function() {
        var OFB = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = OFB.Encryptor = OFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var keystream = this._keystream;
                // Generate keystream
                if (iv) {
                    keystream = this._keystream = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        OFB.Decryptor = Encryptor;
        return OFB;
    }();
    return CryptoJS.mode.OFB;
});

});

parcelRegister("58YYs", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("64KR9")));
})(this, function(CryptoJS) {
    /**
	 * Electronic Codebook block mode.
	 */ CryptoJS.mode.ECB = function() {
        var ECB = CryptoJS.lib.BlockCipherMode.extend();
        ECB.Encryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.encryptBlock(words, offset);
            }
        });
        ECB.Decryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.decryptBlock(words, offset);
            }
        });
        return ECB;
    }();
    return CryptoJS.mode.ECB;
});

});

parcelRegister("1lYsS", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("64KR9")));
})(this, function(CryptoJS) {
    /**
	 * ANSI X.923 padding strategy.
	 */ CryptoJS.pad.AnsiX923 = {
        pad: function(data, blockSize) {
            // Shortcuts
            var dataSigBytes = data.sigBytes;
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
            // Compute last byte position
            var lastBytePos = dataSigBytes + nPaddingBytes - 1;
            // Pad
            data.clamp();
            data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
            data.sigBytes += nPaddingBytes;
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Ansix923;
});

});

parcelRegister("axDDs", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("64KR9")));
})(this, function(CryptoJS) {
    /**
	 * ISO 10126 padding strategy.
	 */ CryptoJS.pad.Iso10126 = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
            // Pad
            data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([
                nPaddingBytes << 24
            ], 1));
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Iso10126;
});

});

parcelRegister("eKc4d", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("64KR9")));
})(this, function(CryptoJS) {
    /**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */ CryptoJS.pad.Iso97971 = {
        pad: function(data, blockSize) {
            // Add 0x80 byte
            data.concat(CryptoJS.lib.WordArray.create([
                0x80000000
            ], 1));
            // Zero pad the rest
            CryptoJS.pad.ZeroPadding.pad(data, blockSize);
        },
        unpad: function(data) {
            // Remove zero padding
            CryptoJS.pad.ZeroPadding.unpad(data);
            // Remove one more byte -- the 0x80 byte
            data.sigBytes--;
        }
    };
    return CryptoJS.pad.Iso97971;
});

});

parcelRegister("5ntzk", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("64KR9")));
})(this, function(CryptoJS) {
    /**
	 * Zero padding strategy.
	 */ CryptoJS.pad.ZeroPadding = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Pad
            data.clamp();
            data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
        },
        unpad: function(data) {
            // Shortcut
            var dataWords = data.words;
            // Unpad
            var i = data.sigBytes - 1;
            for(var i = data.sigBytes - 1; i >= 0; i--)if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
                data.sigBytes = i + 1;
                break;
            }
        }
    };
    return CryptoJS.pad.ZeroPadding;
});

});

parcelRegister("iUKZQ", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("64KR9")));
})(this, function(CryptoJS) {
    /**
	 * A noop padding strategy.
	 */ CryptoJS.pad.NoPadding = {
        pad: function() {},
        unpad: function() {}
    };
    return CryptoJS.pad.NoPadding;
});

});

parcelRegister("8joJf", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("64KR9")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var CipherParams = C_lib.CipherParams;
        var C_enc = C.enc;
        var Hex = C_enc.Hex;
        var C_format = C.format;
        var HexFormatter = C_format.Hex = {
            /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                return cipherParams.ciphertext.toString(Hex);
            },
            /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */ parse: function(input) {
                var ciphertext = Hex.parse(input);
                return CipherParams.create({
                    ciphertext: ciphertext
                });
            }
        };
    })();
    return CryptoJS.format.Hex;
});

});

parcelRegister("kAsNV", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("6dKab")), (parcelRequire("a0xnY")), (parcelRequire("5WeOV")), (parcelRequire("64KR9")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        // Compute lookup tables
        (function() {
            // Compute double table
            var d = [];
            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
            else d[i] = i << 1 ^ 0x11b;
            // Walk GF(2^8)
            var x = 0;
            var xi = 0;
            for(var i = 0; i < 256; i++){
                // Compute sbox
                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x;
                // Compute multiplication
                var x2 = d[x];
                var x4 = d[x2];
                var x8 = d[x4];
                // Compute sub bytes, mix columns tables
                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t;
                // Compute inv sub bytes, inv mix columns tables
                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t;
                // Compute next counter
                if (!x) x = xi = 1;
                else {
                    x = x2 ^ d[d[d[x8 ^ x2]]];
                    xi ^= d[d[xi]];
                }
            }
        })();
        // Precomputed Rcon lookup
        var RCON = [
            0x00,
            0x01,
            0x02,
            0x04,
            0x08,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
            _doReset: function() {
                var t;
                // Skip reset of nRounds has been set before and key did not change
                if (this._nRounds && this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                // Compute number of rounds
                var nRounds = this._nRounds = keySize + 6;
                // Compute number of key schedule rows
                var ksRows = (nRounds + 1) * 4;
                // Compute key schedule
                var keySchedule = this._keySchedule = [];
                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                else {
                    t = keySchedule[ksRow - 1];
                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
                // Compute inv key schedule
                var invKeySchedule = this._invKeySchedule = [];
                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                    var ksRow = ksRows - invKsRow;
                    if (invKsRow % 4) var t = keySchedule[ksRow];
                    else var t = keySchedule[ksRow - 4];
                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
            },
            decryptBlock: function(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                // Inv swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
            },
            _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                var nRounds = this._nRounds;
                // Get input, add round key
                var s0 = M[offset] ^ keySchedule[0];
                var s1 = M[offset + 1] ^ keySchedule[1];
                var s2 = M[offset + 2] ^ keySchedule[2];
                var s3 = M[offset + 3] ^ keySchedule[3];
                // Key schedule row counter
                var ksRow = 4;
                // Rounds
                for(var round = 1; round < nRounds; round++){
                    // Shift rows, sub bytes, mix columns, add round key
                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                    // Update state
                    s0 = t0;
                    s1 = t1;
                    s2 = t2;
                    s3 = t3;
                }
                // Shift rows, sub bytes, add round key
                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                // Set output
                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
            },
            keySize: 8
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
    })();
    return CryptoJS.AES;
});

});

parcelRegister("c7Uaf", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("6dKab")), (parcelRequire("a0xnY")), (parcelRequire("5WeOV")), (parcelRequire("64KR9")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Permuted Choice 1 constants
        var PC1 = [
            57,
            49,
            41,
            33,
            25,
            17,
            9,
            1,
            58,
            50,
            42,
            34,
            26,
            18,
            10,
            2,
            59,
            51,
            43,
            35,
            27,
            19,
            11,
            3,
            60,
            52,
            44,
            36,
            63,
            55,
            47,
            39,
            31,
            23,
            15,
            7,
            62,
            54,
            46,
            38,
            30,
            22,
            14,
            6,
            61,
            53,
            45,
            37,
            29,
            21,
            13,
            5,
            28,
            20,
            12,
            4
        ];
        // Permuted Choice 2 constants
        var PC2 = [
            14,
            17,
            11,
            24,
            1,
            5,
            3,
            28,
            15,
            6,
            21,
            10,
            23,
            19,
            12,
            4,
            26,
            8,
            16,
            7,
            27,
            20,
            13,
            2,
            41,
            52,
            31,
            37,
            47,
            55,
            30,
            40,
            51,
            45,
            33,
            48,
            44,
            49,
            39,
            56,
            34,
            53,
            46,
            42,
            50,
            36,
            29,
            32
        ];
        // Cumulative bit shift constants
        var BIT_SHIFTS = [
            1,
            2,
            4,
            6,
            8,
            10,
            12,
            14,
            15,
            17,
            19,
            21,
            23,
            25,
            27,
            28
        ];
        // SBOXes and round permutation constants
        var SBOX_P = [
            {
                0x0: 0x808200,
                0x10000000: 0x8000,
                0x20000000: 0x808002,
                0x30000000: 0x2,
                0x40000000: 0x200,
                0x50000000: 0x808202,
                0x60000000: 0x800202,
                0x70000000: 0x800000,
                0x80000000: 0x202,
                0x90000000: 0x800200,
                0xa0000000: 0x8200,
                0xb0000000: 0x808000,
                0xc0000000: 0x8002,
                0xd0000000: 0x800002,
                0xe0000000: 0x0,
                0xf0000000: 0x8202,
                0x8000000: 0x0,
                0x18000000: 0x808202,
                0x28000000: 0x8202,
                0x38000000: 0x8000,
                0x48000000: 0x808200,
                0x58000000: 0x200,
                0x68000000: 0x808002,
                0x78000000: 0x2,
                0x88000000: 0x800200,
                0x98000000: 0x8200,
                0xa8000000: 0x808000,
                0xb8000000: 0x800202,
                0xc8000000: 0x800002,
                0xd8000000: 0x8002,
                0xe8000000: 0x202,
                0xf8000000: 0x800000,
                0x1: 0x8000,
                0x10000001: 0x2,
                0x20000001: 0x808200,
                0x30000001: 0x800000,
                0x40000001: 0x808002,
                0x50000001: 0x8200,
                0x60000001: 0x200,
                0x70000001: 0x800202,
                0x80000001: 0x808202,
                0x90000001: 0x808000,
                0xa0000001: 0x800002,
                0xb0000001: 0x8202,
                0xc0000001: 0x202,
                0xd0000001: 0x800200,
                0xe0000001: 0x8002,
                0xf0000001: 0x0,
                0x8000001: 0x808202,
                0x18000001: 0x808000,
                0x28000001: 0x800000,
                0x38000001: 0x200,
                0x48000001: 0x8000,
                0x58000001: 0x800002,
                0x68000001: 0x2,
                0x78000001: 0x8202,
                0x88000001: 0x8002,
                0x98000001: 0x800202,
                0xa8000001: 0x202,
                0xb8000001: 0x808200,
                0xc8000001: 0x800200,
                0xd8000001: 0x0,
                0xe8000001: 0x8200,
                0xf8000001: 0x808002
            },
            {
                0x0: 0x40084010,
                0x1000000: 0x4000,
                0x2000000: 0x80000,
                0x3000000: 0x40080010,
                0x4000000: 0x40000010,
                0x5000000: 0x40084000,
                0x6000000: 0x40004000,
                0x7000000: 0x10,
                0x8000000: 0x84000,
                0x9000000: 0x40004010,
                0xa000000: 0x40000000,
                0xb000000: 0x84010,
                0xc000000: 0x80010,
                0xd000000: 0x0,
                0xe000000: 0x4010,
                0xf000000: 0x40080000,
                0x800000: 0x40004000,
                0x1800000: 0x84010,
                0x2800000: 0x10,
                0x3800000: 0x40004010,
                0x4800000: 0x40084010,
                0x5800000: 0x40000000,
                0x6800000: 0x80000,
                0x7800000: 0x40080010,
                0x8800000: 0x80010,
                0x9800000: 0x0,
                0xa800000: 0x4000,
                0xb800000: 0x40080000,
                0xc800000: 0x40000010,
                0xd800000: 0x84000,
                0xe800000: 0x40084000,
                0xf800000: 0x4010,
                0x10000000: 0x0,
                0x11000000: 0x40080010,
                0x12000000: 0x40004010,
                0x13000000: 0x40084000,
                0x14000000: 0x40080000,
                0x15000000: 0x10,
                0x16000000: 0x84010,
                0x17000000: 0x4000,
                0x18000000: 0x4010,
                0x19000000: 0x80000,
                0x1a000000: 0x80010,
                0x1b000000: 0x40000010,
                0x1c000000: 0x84000,
                0x1d000000: 0x40004000,
                0x1e000000: 0x40000000,
                0x1f000000: 0x40084010,
                0x10800000: 0x84010,
                0x11800000: 0x80000,
                0x12800000: 0x40080000,
                0x13800000: 0x4000,
                0x14800000: 0x40004000,
                0x15800000: 0x40084010,
                0x16800000: 0x10,
                0x17800000: 0x40000000,
                0x18800000: 0x40084000,
                0x19800000: 0x40000010,
                0x1a800000: 0x40004010,
                0x1b800000: 0x80010,
                0x1c800000: 0x0,
                0x1d800000: 0x4010,
                0x1e800000: 0x40080010,
                0x1f800000: 0x84000
            },
            {
                0x0: 0x104,
                0x100000: 0x0,
                0x200000: 0x4000100,
                0x300000: 0x10104,
                0x400000: 0x10004,
                0x500000: 0x4000004,
                0x600000: 0x4010104,
                0x700000: 0x4010000,
                0x800000: 0x4000000,
                0x900000: 0x4010100,
                0xa00000: 0x10100,
                0xb00000: 0x4010004,
                0xc00000: 0x4000104,
                0xd00000: 0x10000,
                0xe00000: 0x4,
                0xf00000: 0x100,
                0x80000: 0x4010100,
                0x180000: 0x4010004,
                0x280000: 0x0,
                0x380000: 0x4000100,
                0x480000: 0x4000004,
                0x580000: 0x10000,
                0x680000: 0x10004,
                0x780000: 0x104,
                0x880000: 0x4,
                0x980000: 0x100,
                0xa80000: 0x4010000,
                0xb80000: 0x10104,
                0xc80000: 0x10100,
                0xd80000: 0x4000104,
                0xe80000: 0x4010104,
                0xf80000: 0x4000000,
                0x1000000: 0x4010100,
                0x1100000: 0x10004,
                0x1200000: 0x10000,
                0x1300000: 0x4000100,
                0x1400000: 0x100,
                0x1500000: 0x4010104,
                0x1600000: 0x4000004,
                0x1700000: 0x0,
                0x1800000: 0x4000104,
                0x1900000: 0x4000000,
                0x1a00000: 0x4,
                0x1b00000: 0x10100,
                0x1c00000: 0x4010000,
                0x1d00000: 0x104,
                0x1e00000: 0x10104,
                0x1f00000: 0x4010004,
                0x1080000: 0x4000000,
                0x1180000: 0x104,
                0x1280000: 0x4010100,
                0x1380000: 0x0,
                0x1480000: 0x10004,
                0x1580000: 0x4000100,
                0x1680000: 0x100,
                0x1780000: 0x4010004,
                0x1880000: 0x10000,
                0x1980000: 0x4010104,
                0x1a80000: 0x10104,
                0x1b80000: 0x4000004,
                0x1c80000: 0x4000104,
                0x1d80000: 0x4010000,
                0x1e80000: 0x4,
                0x1f80000: 0x10100
            },
            {
                0x0: 0x80401000,
                0x10000: 0x80001040,
                0x20000: 0x401040,
                0x30000: 0x80400000,
                0x40000: 0x0,
                0x50000: 0x401000,
                0x60000: 0x80000040,
                0x70000: 0x400040,
                0x80000: 0x80000000,
                0x90000: 0x400000,
                0xa0000: 0x40,
                0xb0000: 0x80001000,
                0xc0000: 0x80400040,
                0xd0000: 0x1040,
                0xe0000: 0x1000,
                0xf0000: 0x80401040,
                0x8000: 0x80001040,
                0x18000: 0x40,
                0x28000: 0x80400040,
                0x38000: 0x80001000,
                0x48000: 0x401000,
                0x58000: 0x80401040,
                0x68000: 0x0,
                0x78000: 0x80400000,
                0x88000: 0x1000,
                0x98000: 0x80401000,
                0xa8000: 0x400000,
                0xb8000: 0x1040,
                0xc8000: 0x80000000,
                0xd8000: 0x400040,
                0xe8000: 0x401040,
                0xf8000: 0x80000040,
                0x100000: 0x400040,
                0x110000: 0x401000,
                0x120000: 0x80000040,
                0x130000: 0x0,
                0x140000: 0x1040,
                0x150000: 0x80400040,
                0x160000: 0x80401000,
                0x170000: 0x80001040,
                0x180000: 0x80401040,
                0x190000: 0x80000000,
                0x1a0000: 0x80400000,
                0x1b0000: 0x401040,
                0x1c0000: 0x80001000,
                0x1d0000: 0x400000,
                0x1e0000: 0x40,
                0x1f0000: 0x1000,
                0x108000: 0x80400000,
                0x118000: 0x80401040,
                0x128000: 0x0,
                0x138000: 0x401000,
                0x148000: 0x400040,
                0x158000: 0x80000000,
                0x168000: 0x80001040,
                0x178000: 0x40,
                0x188000: 0x80000040,
                0x198000: 0x1000,
                0x1a8000: 0x80001000,
                0x1b8000: 0x80400040,
                0x1c8000: 0x1040,
                0x1d8000: 0x80401000,
                0x1e8000: 0x400000,
                0x1f8000: 0x401040
            },
            {
                0x0: 0x80,
                0x1000: 0x1040000,
                0x2000: 0x40000,
                0x3000: 0x20000000,
                0x4000: 0x20040080,
                0x5000: 0x1000080,
                0x6000: 0x21000080,
                0x7000: 0x40080,
                0x8000: 0x1000000,
                0x9000: 0x20040000,
                0xa000: 0x20000080,
                0xb000: 0x21040080,
                0xc000: 0x21040000,
                0xd000: 0x0,
                0xe000: 0x1040080,
                0xf000: 0x21000000,
                0x800: 0x1040080,
                0x1800: 0x21000080,
                0x2800: 0x80,
                0x3800: 0x1040000,
                0x4800: 0x40000,
                0x5800: 0x20040080,
                0x6800: 0x21040000,
                0x7800: 0x20000000,
                0x8800: 0x20040000,
                0x9800: 0x0,
                0xa800: 0x21040080,
                0xb800: 0x1000080,
                0xc800: 0x20000080,
                0xd800: 0x21000000,
                0xe800: 0x1000000,
                0xf800: 0x40080,
                0x10000: 0x40000,
                0x11000: 0x80,
                0x12000: 0x20000000,
                0x13000: 0x21000080,
                0x14000: 0x1000080,
                0x15000: 0x21040000,
                0x16000: 0x20040080,
                0x17000: 0x1000000,
                0x18000: 0x21040080,
                0x19000: 0x21000000,
                0x1a000: 0x1040000,
                0x1b000: 0x20040000,
                0x1c000: 0x40080,
                0x1d000: 0x20000080,
                0x1e000: 0x0,
                0x1f000: 0x1040080,
                0x10800: 0x21000080,
                0x11800: 0x1000000,
                0x12800: 0x1040000,
                0x13800: 0x20040080,
                0x14800: 0x20000000,
                0x15800: 0x1040080,
                0x16800: 0x80,
                0x17800: 0x21040000,
                0x18800: 0x40080,
                0x19800: 0x21040080,
                0x1a800: 0x0,
                0x1b800: 0x21000000,
                0x1c800: 0x1000080,
                0x1d800: 0x40000,
                0x1e800: 0x20040000,
                0x1f800: 0x20000080
            },
            {
                0x0: 0x10000008,
                0x100: 0x2000,
                0x200: 0x10200000,
                0x300: 0x10202008,
                0x400: 0x10002000,
                0x500: 0x200000,
                0x600: 0x200008,
                0x700: 0x10000000,
                0x800: 0x0,
                0x900: 0x10002008,
                0xa00: 0x202000,
                0xb00: 0x8,
                0xc00: 0x10200008,
                0xd00: 0x202008,
                0xe00: 0x2008,
                0xf00: 0x10202000,
                0x80: 0x10200000,
                0x180: 0x10202008,
                0x280: 0x8,
                0x380: 0x200000,
                0x480: 0x202008,
                0x580: 0x10000008,
                0x680: 0x10002000,
                0x780: 0x2008,
                0x880: 0x200008,
                0x980: 0x2000,
                0xa80: 0x10002008,
                0xb80: 0x10200008,
                0xc80: 0x0,
                0xd80: 0x10202000,
                0xe80: 0x202000,
                0xf80: 0x10000000,
                0x1000: 0x10002000,
                0x1100: 0x10200008,
                0x1200: 0x10202008,
                0x1300: 0x2008,
                0x1400: 0x200000,
                0x1500: 0x10000000,
                0x1600: 0x10000008,
                0x1700: 0x202000,
                0x1800: 0x202008,
                0x1900: 0x0,
                0x1a00: 0x8,
                0x1b00: 0x10200000,
                0x1c00: 0x2000,
                0x1d00: 0x10002008,
                0x1e00: 0x10202000,
                0x1f00: 0x200008,
                0x1080: 0x8,
                0x1180: 0x202000,
                0x1280: 0x200000,
                0x1380: 0x10000008,
                0x1480: 0x10002000,
                0x1580: 0x2008,
                0x1680: 0x10202008,
                0x1780: 0x10200000,
                0x1880: 0x10202000,
                0x1980: 0x10200008,
                0x1a80: 0x2000,
                0x1b80: 0x202008,
                0x1c80: 0x200008,
                0x1d80: 0x0,
                0x1e80: 0x10000000,
                0x1f80: 0x10002008
            },
            {
                0x0: 0x100000,
                0x10: 0x2000401,
                0x20: 0x400,
                0x30: 0x100401,
                0x40: 0x2100401,
                0x50: 0x0,
                0x60: 0x1,
                0x70: 0x2100001,
                0x80: 0x2000400,
                0x90: 0x100001,
                0xa0: 0x2000001,
                0xb0: 0x2100400,
                0xc0: 0x2100000,
                0xd0: 0x401,
                0xe0: 0x100400,
                0xf0: 0x2000000,
                0x8: 0x2100001,
                0x18: 0x0,
                0x28: 0x2000401,
                0x38: 0x2100400,
                0x48: 0x100000,
                0x58: 0x2000001,
                0x68: 0x2000000,
                0x78: 0x401,
                0x88: 0x100401,
                0x98: 0x2000400,
                0xa8: 0x2100000,
                0xb8: 0x100001,
                0xc8: 0x400,
                0xd8: 0x2100401,
                0xe8: 0x1,
                0xf8: 0x100400,
                0x100: 0x2000000,
                0x110: 0x100000,
                0x120: 0x2000401,
                0x130: 0x2100001,
                0x140: 0x100001,
                0x150: 0x2000400,
                0x160: 0x2100400,
                0x170: 0x100401,
                0x180: 0x401,
                0x190: 0x2100401,
                0x1a0: 0x100400,
                0x1b0: 0x1,
                0x1c0: 0x0,
                0x1d0: 0x2100000,
                0x1e0: 0x2000001,
                0x1f0: 0x400,
                0x108: 0x100400,
                0x118: 0x2000401,
                0x128: 0x2100001,
                0x138: 0x1,
                0x148: 0x2000000,
                0x158: 0x100000,
                0x168: 0x401,
                0x178: 0x2100400,
                0x188: 0x2000001,
                0x198: 0x2100000,
                0x1a8: 0x0,
                0x1b8: 0x2100401,
                0x1c8: 0x100401,
                0x1d8: 0x400,
                0x1e8: 0x2000400,
                0x1f8: 0x100001
            },
            {
                0x0: 0x8000820,
                0x1: 0x20000,
                0x2: 0x8000000,
                0x3: 0x20,
                0x4: 0x20020,
                0x5: 0x8020820,
                0x6: 0x8020800,
                0x7: 0x800,
                0x8: 0x8020000,
                0x9: 0x8000800,
                0xa: 0x20800,
                0xb: 0x8020020,
                0xc: 0x820,
                0xd: 0x0,
                0xe: 0x8000020,
                0xf: 0x20820,
                0x80000000: 0x800,
                0x80000001: 0x8020820,
                0x80000002: 0x8000820,
                0x80000003: 0x8000000,
                0x80000004: 0x8020000,
                0x80000005: 0x20800,
                0x80000006: 0x20820,
                0x80000007: 0x20,
                0x80000008: 0x8000020,
                0x80000009: 0x820,
                0x8000000a: 0x20020,
                0x8000000b: 0x8020800,
                0x8000000c: 0x0,
                0x8000000d: 0x8020020,
                0x8000000e: 0x8000800,
                0x8000000f: 0x20000,
                0x10: 0x20820,
                0x11: 0x8020800,
                0x12: 0x20,
                0x13: 0x800,
                0x14: 0x8000800,
                0x15: 0x8000020,
                0x16: 0x8020020,
                0x17: 0x20000,
                0x18: 0x0,
                0x19: 0x20020,
                0x1a: 0x8020000,
                0x1b: 0x8000820,
                0x1c: 0x8020820,
                0x1d: 0x20800,
                0x1e: 0x820,
                0x1f: 0x8000000,
                0x80000010: 0x20000,
                0x80000011: 0x800,
                0x80000012: 0x8020020,
                0x80000013: 0x20820,
                0x80000014: 0x20,
                0x80000015: 0x8020000,
                0x80000016: 0x8000000,
                0x80000017: 0x8000820,
                0x80000018: 0x8020820,
                0x80000019: 0x8000020,
                0x8000001a: 0x8000800,
                0x8000001b: 0x0,
                0x8000001c: 0x20800,
                0x8000001d: 0x820,
                0x8000001e: 0x20020,
                0x8000001f: 0x8020800
            }
        ];
        // Masks that select the SBOX input
        var SBOX_MASK = [
            0xf8000001,
            0x1f800000,
            0x01f80000,
            0x001f8000,
            0x0001f800,
            0x00001f80,
            0x000001f8,
            0x8000001f
        ];
        /**
	     * DES block cipher algorithm.
	     */ var DES = C_algo.DES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Select 56 bits according to PC1
                var keyBits = [];
                for(var i = 0; i < 56; i++){
                    var keyBitPos = PC1[i] - 1;
                    keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
                }
                // Assemble 16 subkeys
                var subKeys = this._subKeys = [];
                for(var nSubKey = 0; nSubKey < 16; nSubKey++){
                    // Create subkey
                    var subKey = subKeys[nSubKey] = [];
                    // Shortcut
                    var bitShift = BIT_SHIFTS[nSubKey];
                    // Select 48 bits according to PC2
                    for(var i = 0; i < 24; i++){
                        // Select from the left 28 key bits
                        subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
                        // Select from the right 28 key bits
                        subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                    }
                    // Since each subkey is applied to an expanded 32-bit input,
                    // the subkey can be broken into 8 values scaled to 32-bits,
                    // which allows the key to be used without expansion
                    subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
                    for(var i = 1; i < 7; i++)subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                    subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
                }
                // Compute inverse subkeys
                var invSubKeys = this._invSubKeys = [];
                for(var i = 0; i < 16; i++)invSubKeys[i] = subKeys[15 - i];
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._subKeys);
            },
            decryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._invSubKeys);
            },
            _doCryptBlock: function(M, offset, subKeys) {
                // Get input
                this._lBlock = M[offset];
                this._rBlock = M[offset + 1];
                // Initial permutation
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeLR.call(this, 1, 0x55555555);
                // Rounds
                for(var round = 0; round < 16; round++){
                    // Shortcuts
                    var subKey = subKeys[round];
                    var lBlock = this._lBlock;
                    var rBlock = this._rBlock;
                    // Feistel function
                    var f = 0;
                    for(var i = 0; i < 8; i++)f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                    this._lBlock = rBlock;
                    this._rBlock = lBlock ^ f;
                }
                // Undo swap from last round
                var t = this._lBlock;
                this._lBlock = this._rBlock;
                this._rBlock = t;
                // Final permutation
                exchangeLR.call(this, 1, 0x55555555);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                // Set output
                M[offset] = this._lBlock;
                M[offset + 1] = this._rBlock;
            },
            keySize: 2,
            ivSize: 2,
            blockSize: 2
        });
        // Swap bits across the left and right words
        function exchangeLR(offset, mask) {
            var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
            this._rBlock ^= t;
            this._lBlock ^= t << offset;
        }
        function exchangeRL(offset, mask) {
            var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
            this._lBlock ^= t;
            this._rBlock ^= t << offset;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */ C.DES = BlockCipher._createHelper(DES);
        /**
	     * Triple-DES block cipher algorithm.
	     */ var TripleDES = C_algo.TripleDES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Make sure the key length is valid (64, 128 or >= 192 bit)
                if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
                // Extend the key according to the keying options defined in 3DES standard
                var key1 = keyWords.slice(0, 2);
                var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
                var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
                // Create DES instances
                this._des1 = DES.createEncryptor(WordArray.create(key1));
                this._des2 = DES.createEncryptor(WordArray.create(key2));
                this._des3 = DES.createEncryptor(WordArray.create(key3));
            },
            encryptBlock: function(M, offset) {
                this._des1.encryptBlock(M, offset);
                this._des2.decryptBlock(M, offset);
                this._des3.encryptBlock(M, offset);
            },
            decryptBlock: function(M, offset) {
                this._des3.decryptBlock(M, offset);
                this._des2.encryptBlock(M, offset);
                this._des1.decryptBlock(M, offset);
            },
            keySize: 6,
            ivSize: 2,
            blockSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */ C.TripleDES = BlockCipher._createHelper(TripleDES);
    })();
    return CryptoJS.TripleDES;
});

});

parcelRegister("61lhf", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("6dKab")), (parcelRequire("a0xnY")), (parcelRequire("5WeOV")), (parcelRequire("64KR9")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        /**
	     * RC4 stream cipher algorithm.
	     */ var RC4 = C_algo.RC4 = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                var keySigBytes = key.sigBytes;
                // Init sbox
                var S = this._S = [];
                for(var i = 0; i < 256; i++)S[i] = i;
                // Key setup
                for(var i = 0, j = 0; i < 256; i++){
                    var keyByteIndex = i % keySigBytes;
                    var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
                    j = (j + S[i] + keyByte) % 256;
                    // Swap
                    var t = S[i];
                    S[i] = S[j];
                    S[j] = t;
                }
                // Counters
                this._i = this._j = 0;
            },
            _doProcessBlock: function(M, offset) {
                M[offset] ^= generateKeystreamWord.call(this);
            },
            keySize: 8,
            ivSize: 0
        });
        function generateKeystreamWord() {
            // Shortcuts
            var S = this._S;
            var i = this._i;
            var j = this._j;
            // Generate keystream word
            var keystreamWord = 0;
            for(var n = 0; n < 4; n++){
                i = (i + 1) % 256;
                j = (j + S[i]) % 256;
                // Swap
                var t = S[i];
                S[i] = S[j];
                S[j] = t;
                keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
            }
            // Update counters
            this._i = i;
            this._j = j;
            return keystreamWord;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */ C.RC4 = StreamCipher._createHelper(RC4);
        /**
	     * Modified RC4 stream cipher algorithm.
	     */ var RC4Drop = C_algo.RC4Drop = RC4.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */ cfg: RC4.cfg.extend({
                drop: 192
            }),
            _doReset: function() {
                RC4._doReset.call(this);
                // Drop
                for(var i = this.cfg.drop; i > 0; i--)generateKeystreamWord.call(this);
            }
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */ C.RC4Drop = StreamCipher._createHelper(RC4Drop);
    })();
    return CryptoJS.RC4;
});

});

parcelRegister("2BDEU", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("6dKab")), (parcelRequire("a0xnY")), (parcelRequire("5WeOV")), (parcelRequire("64KR9")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm
	     */ var Rabbit = C_algo.Rabbit = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Swap endian
                for(var i = 0; i < 4; i++)K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */ C.Rabbit = StreamCipher._createHelper(Rabbit);
    })();
    return CryptoJS.Rabbit;
});

});

parcelRegister("dUpKV", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("6dKab")), (parcelRequire("a0xnY")), (parcelRequire("5WeOV")), (parcelRequire("64KR9")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */ var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */ C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
    })();
    return CryptoJS.RabbitLegacy;
});

});

parcelRegister("6LwKF", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("8Z8Le")), (parcelRequire("6dKab")), (parcelRequire("a0xnY")), (parcelRequire("5WeOV")), (parcelRequire("64KR9")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        const N = 16;
        //Origin pbox and sbox, derived from PI
        const ORIG_P = [
            0x243F6A88,
            0x85A308D3,
            0x13198A2E,
            0x03707344,
            0xA4093822,
            0x299F31D0,
            0x082EFA98,
            0xEC4E6C89,
            0x452821E6,
            0x38D01377,
            0xBE5466CF,
            0x34E90C6C,
            0xC0AC29B7,
            0xC97C50DD,
            0x3F84D5B5,
            0xB5470917,
            0x9216D5D9,
            0x8979FB1B
        ];
        const ORIG_S = [
            [
                0xD1310BA6,
                0x98DFB5AC,
                0x2FFD72DB,
                0xD01ADFB7,
                0xB8E1AFED,
                0x6A267E96,
                0xBA7C9045,
                0xF12C7F99,
                0x24A19947,
                0xB3916CF7,
                0x0801F2E2,
                0x858EFC16,
                0x636920D8,
                0x71574E69,
                0xA458FEA3,
                0xF4933D7E,
                0x0D95748F,
                0x728EB658,
                0x718BCD58,
                0x82154AEE,
                0x7B54A41D,
                0xC25A59B5,
                0x9C30D539,
                0x2AF26013,
                0xC5D1B023,
                0x286085F0,
                0xCA417918,
                0xB8DB38EF,
                0x8E79DCB0,
                0x603A180E,
                0x6C9E0E8B,
                0xB01E8A3E,
                0xD71577C1,
                0xBD314B27,
                0x78AF2FDA,
                0x55605C60,
                0xE65525F3,
                0xAA55AB94,
                0x57489862,
                0x63E81440,
                0x55CA396A,
                0x2AAB10B6,
                0xB4CC5C34,
                0x1141E8CE,
                0xA15486AF,
                0x7C72E993,
                0xB3EE1411,
                0x636FBC2A,
                0x2BA9C55D,
                0x741831F6,
                0xCE5C3E16,
                0x9B87931E,
                0xAFD6BA33,
                0x6C24CF5C,
                0x7A325381,
                0x28958677,
                0x3B8F4898,
                0x6B4BB9AF,
                0xC4BFE81B,
                0x66282193,
                0x61D809CC,
                0xFB21A991,
                0x487CAC60,
                0x5DEC8032,
                0xEF845D5D,
                0xE98575B1,
                0xDC262302,
                0xEB651B88,
                0x23893E81,
                0xD396ACC5,
                0x0F6D6FF3,
                0x83F44239,
                0x2E0B4482,
                0xA4842004,
                0x69C8F04A,
                0x9E1F9B5E,
                0x21C66842,
                0xF6E96C9A,
                0x670C9C61,
                0xABD388F0,
                0x6A51A0D2,
                0xD8542F68,
                0x960FA728,
                0xAB5133A3,
                0x6EEF0B6C,
                0x137A3BE4,
                0xBA3BF050,
                0x7EFB2A98,
                0xA1F1651D,
                0x39AF0176,
                0x66CA593E,
                0x82430E88,
                0x8CEE8619,
                0x456F9FB4,
                0x7D84A5C3,
                0x3B8B5EBE,
                0xE06F75D8,
                0x85C12073,
                0x401A449F,
                0x56C16AA6,
                0x4ED3AA62,
                0x363F7706,
                0x1BFEDF72,
                0x429B023D,
                0x37D0D724,
                0xD00A1248,
                0xDB0FEAD3,
                0x49F1C09B,
                0x075372C9,
                0x80991B7B,
                0x25D479D8,
                0xF6E8DEF7,
                0xE3FE501A,
                0xB6794C3B,
                0x976CE0BD,
                0x04C006BA,
                0xC1A94FB6,
                0x409F60C4,
                0x5E5C9EC2,
                0x196A2463,
                0x68FB6FAF,
                0x3E6C53B5,
                0x1339B2EB,
                0x3B52EC6F,
                0x6DFC511F,
                0x9B30952C,
                0xCC814544,
                0xAF5EBD09,
                0xBEE3D004,
                0xDE334AFD,
                0x660F2807,
                0x192E4BB3,
                0xC0CBA857,
                0x45C8740F,
                0xD20B5F39,
                0xB9D3FBDB,
                0x5579C0BD,
                0x1A60320A,
                0xD6A100C6,
                0x402C7279,
                0x679F25FE,
                0xFB1FA3CC,
                0x8EA5E9F8,
                0xDB3222F8,
                0x3C7516DF,
                0xFD616B15,
                0x2F501EC8,
                0xAD0552AB,
                0x323DB5FA,
                0xFD238760,
                0x53317B48,
                0x3E00DF82,
                0x9E5C57BB,
                0xCA6F8CA0,
                0x1A87562E,
                0xDF1769DB,
                0xD542A8F6,
                0x287EFFC3,
                0xAC6732C6,
                0x8C4F5573,
                0x695B27B0,
                0xBBCA58C8,
                0xE1FFA35D,
                0xB8F011A0,
                0x10FA3D98,
                0xFD2183B8,
                0x4AFCB56C,
                0x2DD1D35B,
                0x9A53E479,
                0xB6F84565,
                0xD28E49BC,
                0x4BFB9790,
                0xE1DDF2DA,
                0xA4CB7E33,
                0x62FB1341,
                0xCEE4C6E8,
                0xEF20CADA,
                0x36774C01,
                0xD07E9EFE,
                0x2BF11FB4,
                0x95DBDA4D,
                0xAE909198,
                0xEAAD8E71,
                0x6B93D5A0,
                0xD08ED1D0,
                0xAFC725E0,
                0x8E3C5B2F,
                0x8E7594B7,
                0x8FF6E2FB,
                0xF2122B64,
                0x8888B812,
                0x900DF01C,
                0x4FAD5EA0,
                0x688FC31C,
                0xD1CFF191,
                0xB3A8C1AD,
                0x2F2F2218,
                0xBE0E1777,
                0xEA752DFE,
                0x8B021FA1,
                0xE5A0CC0F,
                0xB56F74E8,
                0x18ACF3D6,
                0xCE89E299,
                0xB4A84FE0,
                0xFD13E0B7,
                0x7CC43B81,
                0xD2ADA8D9,
                0x165FA266,
                0x80957705,
                0x93CC7314,
                0x211A1477,
                0xE6AD2065,
                0x77B5FA86,
                0xC75442F5,
                0xFB9D35CF,
                0xEBCDAF0C,
                0x7B3E89A0,
                0xD6411BD3,
                0xAE1E7E49,
                0x00250E2D,
                0x2071B35E,
                0x226800BB,
                0x57B8E0AF,
                0x2464369B,
                0xF009B91E,
                0x5563911D,
                0x59DFA6AA,
                0x78C14389,
                0xD95A537F,
                0x207D5BA2,
                0x02E5B9C5,
                0x83260376,
                0x6295CFA9,
                0x11C81968,
                0x4E734A41,
                0xB3472DCA,
                0x7B14A94A,
                0x1B510052,
                0x9A532915,
                0xD60F573F,
                0xBC9BC6E4,
                0x2B60A476,
                0x81E67400,
                0x08BA6FB5,
                0x571BE91F,
                0xF296EC6B,
                0x2A0DD915,
                0xB6636521,
                0xE7B9F9B6,
                0xFF34052E,
                0xC5855664,
                0x53B02D5D,
                0xA99F8FA1,
                0x08BA4799,
                0x6E85076A
            ],
            [
                0x4B7A70E9,
                0xB5B32944,
                0xDB75092E,
                0xC4192623,
                0xAD6EA6B0,
                0x49A7DF7D,
                0x9CEE60B8,
                0x8FEDB266,
                0xECAA8C71,
                0x699A17FF,
                0x5664526C,
                0xC2B19EE1,
                0x193602A5,
                0x75094C29,
                0xA0591340,
                0xE4183A3E,
                0x3F54989A,
                0x5B429D65,
                0x6B8FE4D6,
                0x99F73FD6,
                0xA1D29C07,
                0xEFE830F5,
                0x4D2D38E6,
                0xF0255DC1,
                0x4CDD2086,
                0x8470EB26,
                0x6382E9C6,
                0x021ECC5E,
                0x09686B3F,
                0x3EBAEFC9,
                0x3C971814,
                0x6B6A70A1,
                0x687F3584,
                0x52A0E286,
                0xB79C5305,
                0xAA500737,
                0x3E07841C,
                0x7FDEAE5C,
                0x8E7D44EC,
                0x5716F2B8,
                0xB03ADA37,
                0xF0500C0D,
                0xF01C1F04,
                0x0200B3FF,
                0xAE0CF51A,
                0x3CB574B2,
                0x25837A58,
                0xDC0921BD,
                0xD19113F9,
                0x7CA92FF6,
                0x94324773,
                0x22F54701,
                0x3AE5E581,
                0x37C2DADC,
                0xC8B57634,
                0x9AF3DDA7,
                0xA9446146,
                0x0FD0030E,
                0xECC8C73E,
                0xA4751E41,
                0xE238CD99,
                0x3BEA0E2F,
                0x3280BBA1,
                0x183EB331,
                0x4E548B38,
                0x4F6DB908,
                0x6F420D03,
                0xF60A04BF,
                0x2CB81290,
                0x24977C79,
                0x5679B072,
                0xBCAF89AF,
                0xDE9A771F,
                0xD9930810,
                0xB38BAE12,
                0xDCCF3F2E,
                0x5512721F,
                0x2E6B7124,
                0x501ADDE6,
                0x9F84CD87,
                0x7A584718,
                0x7408DA17,
                0xBC9F9ABC,
                0xE94B7D8C,
                0xEC7AEC3A,
                0xDB851DFA,
                0x63094366,
                0xC464C3D2,
                0xEF1C1847,
                0x3215D908,
                0xDD433B37,
                0x24C2BA16,
                0x12A14D43,
                0x2A65C451,
                0x50940002,
                0x133AE4DD,
                0x71DFF89E,
                0x10314E55,
                0x81AC77D6,
                0x5F11199B,
                0x043556F1,
                0xD7A3C76B,
                0x3C11183B,
                0x5924A509,
                0xF28FE6ED,
                0x97F1FBFA,
                0x9EBABF2C,
                0x1E153C6E,
                0x86E34570,
                0xEAE96FB1,
                0x860E5E0A,
                0x5A3E2AB3,
                0x771FE71C,
                0x4E3D06FA,
                0x2965DCB9,
                0x99E71D0F,
                0x803E89D6,
                0x5266C825,
                0x2E4CC978,
                0x9C10B36A,
                0xC6150EBA,
                0x94E2EA78,
                0xA5FC3C53,
                0x1E0A2DF4,
                0xF2F74EA7,
                0x361D2B3D,
                0x1939260F,
                0x19C27960,
                0x5223A708,
                0xF71312B6,
                0xEBADFE6E,
                0xEAC31F66,
                0xE3BC4595,
                0xA67BC883,
                0xB17F37D1,
                0x018CFF28,
                0xC332DDEF,
                0xBE6C5AA5,
                0x65582185,
                0x68AB9802,
                0xEECEA50F,
                0xDB2F953B,
                0x2AEF7DAD,
                0x5B6E2F84,
                0x1521B628,
                0x29076170,
                0xECDD4775,
                0x619F1510,
                0x13CCA830,
                0xEB61BD96,
                0x0334FE1E,
                0xAA0363CF,
                0xB5735C90,
                0x4C70A239,
                0xD59E9E0B,
                0xCBAADE14,
                0xEECC86BC,
                0x60622CA7,
                0x9CAB5CAB,
                0xB2F3846E,
                0x648B1EAF,
                0x19BDF0CA,
                0xA02369B9,
                0x655ABB50,
                0x40685A32,
                0x3C2AB4B3,
                0x319EE9D5,
                0xC021B8F7,
                0x9B540B19,
                0x875FA099,
                0x95F7997E,
                0x623D7DA8,
                0xF837889A,
                0x97E32D77,
                0x11ED935F,
                0x16681281,
                0x0E358829,
                0xC7E61FD6,
                0x96DEDFA1,
                0x7858BA99,
                0x57F584A5,
                0x1B227263,
                0x9B83C3FF,
                0x1AC24696,
                0xCDB30AEB,
                0x532E3054,
                0x8FD948E4,
                0x6DBC3128,
                0x58EBF2EF,
                0x34C6FFEA,
                0xFE28ED61,
                0xEE7C3C73,
                0x5D4A14D9,
                0xE864B7E3,
                0x42105D14,
                0x203E13E0,
                0x45EEE2B6,
                0xA3AAABEA,
                0xDB6C4F15,
                0xFACB4FD0,
                0xC742F442,
                0xEF6ABBB5,
                0x654F3B1D,
                0x41CD2105,
                0xD81E799E,
                0x86854DC7,
                0xE44B476A,
                0x3D816250,
                0xCF62A1F2,
                0x5B8D2646,
                0xFC8883A0,
                0xC1C7B6A3,
                0x7F1524C3,
                0x69CB7492,
                0x47848A0B,
                0x5692B285,
                0x095BBF00,
                0xAD19489D,
                0x1462B174,
                0x23820E00,
                0x58428D2A,
                0x0C55F5EA,
                0x1DADF43E,
                0x233F7061,
                0x3372F092,
                0x8D937E41,
                0xD65FECF1,
                0x6C223BDB,
                0x7CDE3759,
                0xCBEE7460,
                0x4085F2A7,
                0xCE77326E,
                0xA6078084,
                0x19F8509E,
                0xE8EFD855,
                0x61D99735,
                0xA969A7AA,
                0xC50C06C2,
                0x5A04ABFC,
                0x800BCADC,
                0x9E447A2E,
                0xC3453484,
                0xFDD56705,
                0x0E1E9EC9,
                0xDB73DBD3,
                0x105588CD,
                0x675FDA79,
                0xE3674340,
                0xC5C43465,
                0x713E38D8,
                0x3D28F89E,
                0xF16DFF20,
                0x153E21E7,
                0x8FB03D4A,
                0xE6E39F2B,
                0xDB83ADF7
            ],
            [
                0xE93D5A68,
                0x948140F7,
                0xF64C261C,
                0x94692934,
                0x411520F7,
                0x7602D4F7,
                0xBCF46B2E,
                0xD4A20068,
                0xD4082471,
                0x3320F46A,
                0x43B7D4B7,
                0x500061AF,
                0x1E39F62E,
                0x97244546,
                0x14214F74,
                0xBF8B8840,
                0x4D95FC1D,
                0x96B591AF,
                0x70F4DDD3,
                0x66A02F45,
                0xBFBC09EC,
                0x03BD9785,
                0x7FAC6DD0,
                0x31CB8504,
                0x96EB27B3,
                0x55FD3941,
                0xDA2547E6,
                0xABCA0A9A,
                0x28507825,
                0x530429F4,
                0x0A2C86DA,
                0xE9B66DFB,
                0x68DC1462,
                0xD7486900,
                0x680EC0A4,
                0x27A18DEE,
                0x4F3FFEA2,
                0xE887AD8C,
                0xB58CE006,
                0x7AF4D6B6,
                0xAACE1E7C,
                0xD3375FEC,
                0xCE78A399,
                0x406B2A42,
                0x20FE9E35,
                0xD9F385B9,
                0xEE39D7AB,
                0x3B124E8B,
                0x1DC9FAF7,
                0x4B6D1856,
                0x26A36631,
                0xEAE397B2,
                0x3A6EFA74,
                0xDD5B4332,
                0x6841E7F7,
                0xCA7820FB,
                0xFB0AF54E,
                0xD8FEB397,
                0x454056AC,
                0xBA489527,
                0x55533A3A,
                0x20838D87,
                0xFE6BA9B7,
                0xD096954B,
                0x55A867BC,
                0xA1159A58,
                0xCCA92963,
                0x99E1DB33,
                0xA62A4A56,
                0x3F3125F9,
                0x5EF47E1C,
                0x9029317C,
                0xFDF8E802,
                0x04272F70,
                0x80BB155C,
                0x05282CE3,
                0x95C11548,
                0xE4C66D22,
                0x48C1133F,
                0xC70F86DC,
                0x07F9C9EE,
                0x41041F0F,
                0x404779A4,
                0x5D886E17,
                0x325F51EB,
                0xD59BC0D1,
                0xF2BCC18F,
                0x41113564,
                0x257B7834,
                0x602A9C60,
                0xDFF8E8A3,
                0x1F636C1B,
                0x0E12B4C2,
                0x02E1329E,
                0xAF664FD1,
                0xCAD18115,
                0x6B2395E0,
                0x333E92E1,
                0x3B240B62,
                0xEEBEB922,
                0x85B2A20E,
                0xE6BA0D99,
                0xDE720C8C,
                0x2DA2F728,
                0xD0127845,
                0x95B794FD,
                0x647D0862,
                0xE7CCF5F0,
                0x5449A36F,
                0x877D48FA,
                0xC39DFD27,
                0xF33E8D1E,
                0x0A476341,
                0x992EFF74,
                0x3A6F6EAB,
                0xF4F8FD37,
                0xA812DC60,
                0xA1EBDDF8,
                0x991BE14C,
                0xDB6E6B0D,
                0xC67B5510,
                0x6D672C37,
                0x2765D43B,
                0xDCD0E804,
                0xF1290DC7,
                0xCC00FFA3,
                0xB5390F92,
                0x690FED0B,
                0x667B9FFB,
                0xCEDB7D9C,
                0xA091CF0B,
                0xD9155EA3,
                0xBB132F88,
                0x515BAD24,
                0x7B9479BF,
                0x763BD6EB,
                0x37392EB3,
                0xCC115979,
                0x8026E297,
                0xF42E312D,
                0x6842ADA7,
                0xC66A2B3B,
                0x12754CCC,
                0x782EF11C,
                0x6A124237,
                0xB79251E7,
                0x06A1BBE6,
                0x4BFB6350,
                0x1A6B1018,
                0x11CAEDFA,
                0x3D25BDD8,
                0xE2E1C3C9,
                0x44421659,
                0x0A121386,
                0xD90CEC6E,
                0xD5ABEA2A,
                0x64AF674E,
                0xDA86A85F,
                0xBEBFE988,
                0x64E4C3FE,
                0x9DBC8057,
                0xF0F7C086,
                0x60787BF8,
                0x6003604D,
                0xD1FD8346,
                0xF6381FB0,
                0x7745AE04,
                0xD736FCCC,
                0x83426B33,
                0xF01EAB71,
                0xB0804187,
                0x3C005E5F,
                0x77A057BE,
                0xBDE8AE24,
                0x55464299,
                0xBF582E61,
                0x4E58F48F,
                0xF2DDFDA2,
                0xF474EF38,
                0x8789BDC2,
                0x5366F9C3,
                0xC8B38E74,
                0xB475F255,
                0x46FCD9B9,
                0x7AEB2661,
                0x8B1DDF84,
                0x846A0E79,
                0x915F95E2,
                0x466E598E,
                0x20B45770,
                0x8CD55591,
                0xC902DE4C,
                0xB90BACE1,
                0xBB8205D0,
                0x11A86248,
                0x7574A99E,
                0xB77F19B6,
                0xE0A9DC09,
                0x662D09A1,
                0xC4324633,
                0xE85A1F02,
                0x09F0BE8C,
                0x4A99A025,
                0x1D6EFE10,
                0x1AB93D1D,
                0x0BA5A4DF,
                0xA186F20F,
                0x2868F169,
                0xDCB7DA83,
                0x573906FE,
                0xA1E2CE9B,
                0x4FCD7F52,
                0x50115E01,
                0xA70683FA,
                0xA002B5C4,
                0x0DE6D027,
                0x9AF88C27,
                0x773F8641,
                0xC3604C06,
                0x61A806B5,
                0xF0177A28,
                0xC0F586E0,
                0x006058AA,
                0x30DC7D62,
                0x11E69ED7,
                0x2338EA63,
                0x53C2DD94,
                0xC2C21634,
                0xBBCBEE56,
                0x90BCB6DE,
                0xEBFC7DA1,
                0xCE591D76,
                0x6F05E409,
                0x4B7C0188,
                0x39720A3D,
                0x7C927C24,
                0x86E3725F,
                0x724D9DB9,
                0x1AC15BB4,
                0xD39EB8FC,
                0xED545578,
                0x08FCA5B5,
                0xD83D7CD3,
                0x4DAD0FC4,
                0x1E50EF5E,
                0xB161E6F8,
                0xA28514D9,
                0x6C51133C,
                0x6FD5C7E7,
                0x56E14EC4,
                0x362ABFCE,
                0xDDC6C837,
                0xD79A3234,
                0x92638212,
                0x670EFA8E,
                0x406000E0
            ],
            [
                0x3A39CE37,
                0xD3FAF5CF,
                0xABC27737,
                0x5AC52D1B,
                0x5CB0679E,
                0x4FA33742,
                0xD3822740,
                0x99BC9BBE,
                0xD5118E9D,
                0xBF0F7315,
                0xD62D1C7E,
                0xC700C47B,
                0xB78C1B6B,
                0x21A19045,
                0xB26EB1BE,
                0x6A366EB4,
                0x5748AB2F,
                0xBC946E79,
                0xC6A376D2,
                0x6549C2C8,
                0x530FF8EE,
                0x468DDE7D,
                0xD5730A1D,
                0x4CD04DC6,
                0x2939BBDB,
                0xA9BA4650,
                0xAC9526E8,
                0xBE5EE304,
                0xA1FAD5F0,
                0x6A2D519A,
                0x63EF8CE2,
                0x9A86EE22,
                0xC089C2B8,
                0x43242EF6,
                0xA51E03AA,
                0x9CF2D0A4,
                0x83C061BA,
                0x9BE96A4D,
                0x8FE51550,
                0xBA645BD6,
                0x2826A2F9,
                0xA73A3AE1,
                0x4BA99586,
                0xEF5562E9,
                0xC72FEFD3,
                0xF752F7DA,
                0x3F046F69,
                0x77FA0A59,
                0x80E4A915,
                0x87B08601,
                0x9B09E6AD,
                0x3B3EE593,
                0xE990FD5A,
                0x9E34D797,
                0x2CF0B7D9,
                0x022B8B51,
                0x96D5AC3A,
                0x017DA67D,
                0xD1CF3ED6,
                0x7C7D2D28,
                0x1F9F25CF,
                0xADF2B89B,
                0x5AD6B472,
                0x5A88F54C,
                0xE029AC71,
                0xE019A5E6,
                0x47B0ACFD,
                0xED93FA9B,
                0xE8D3C48D,
                0x283B57CC,
                0xF8D56629,
                0x79132E28,
                0x785F0191,
                0xED756055,
                0xF7960E44,
                0xE3D35E8C,
                0x15056DD4,
                0x88F46DBA,
                0x03A16125,
                0x0564F0BD,
                0xC3EB9E15,
                0x3C9057A2,
                0x97271AEC,
                0xA93A072A,
                0x1B3F6D9B,
                0x1E6321F5,
                0xF59C66FB,
                0x26DCF319,
                0x7533D928,
                0xB155FDF5,
                0x03563482,
                0x8ABA3CBB,
                0x28517711,
                0xC20AD9F8,
                0xABCC5167,
                0xCCAD925F,
                0x4DE81751,
                0x3830DC8E,
                0x379D5862,
                0x9320F991,
                0xEA7A90C2,
                0xFB3E7BCE,
                0x5121CE64,
                0x774FBE32,
                0xA8B6E37E,
                0xC3293D46,
                0x48DE5369,
                0x6413E680,
                0xA2AE0810,
                0xDD6DB224,
                0x69852DFD,
                0x09072166,
                0xB39A460A,
                0x6445C0DD,
                0x586CDECF,
                0x1C20C8AE,
                0x5BBEF7DD,
                0x1B588D40,
                0xCCD2017F,
                0x6BB4E3BB,
                0xDDA26A7E,
                0x3A59FF45,
                0x3E350A44,
                0xBCB4CDD5,
                0x72EACEA8,
                0xFA6484BB,
                0x8D6612AE,
                0xBF3C6F47,
                0xD29BE463,
                0x542F5D9E,
                0xAEC2771B,
                0xF64E6370,
                0x740E0D8D,
                0xE75B1357,
                0xF8721671,
                0xAF537D5D,
                0x4040CB08,
                0x4EB4E2CC,
                0x34D2466A,
                0x0115AF84,
                0xE1B00428,
                0x95983A1D,
                0x06B89FB4,
                0xCE6EA048,
                0x6F3F3B82,
                0x3520AB82,
                0x011A1D4B,
                0x277227F8,
                0x611560B1,
                0xE7933FDC,
                0xBB3A792B,
                0x344525BD,
                0xA08839E1,
                0x51CE794B,
                0x2F32C9B7,
                0xA01FBAC9,
                0xE01CC87E,
                0xBCC7D1F6,
                0xCF0111C3,
                0xA1E8AAC7,
                0x1A908749,
                0xD44FBD9A,
                0xD0DADECB,
                0xD50ADA38,
                0x0339C32A,
                0xC6913667,
                0x8DF9317C,
                0xE0B12B4F,
                0xF79E59B7,
                0x43F5BB3A,
                0xF2D519FF,
                0x27D9459C,
                0xBF97222C,
                0x15E6FC2A,
                0x0F91FC71,
                0x9B941525,
                0xFAE59361,
                0xCEB69CEB,
                0xC2A86459,
                0x12BAA8D1,
                0xB6C1075E,
                0xE3056A0C,
                0x10D25065,
                0xCB03A442,
                0xE0EC6E0E,
                0x1698DB3B,
                0x4C98A0BE,
                0x3278E964,
                0x9F1F9532,
                0xE0D392DF,
                0xD3A0342B,
                0x8971F21E,
                0x1B0A7441,
                0x4BA3348C,
                0xC5BE7120,
                0xC37632D8,
                0xDF359F8D,
                0x9B992F2E,
                0xE60B6F47,
                0x0FE3F11D,
                0xE54CDA54,
                0x1EDAD891,
                0xCE6279CF,
                0xCD3E7E6F,
                0x1618B166,
                0xFD2C1D05,
                0x848FD2C5,
                0xF6FB2299,
                0xF523F357,
                0xA6327623,
                0x93A83531,
                0x56CCCD02,
                0xACF08162,
                0x5A75EBB5,
                0x6E163697,
                0x88D273CC,
                0xDE966292,
                0x81B949D0,
                0x4C50901B,
                0x71C65614,
                0xE6C6C7BD,
                0x327A140A,
                0x45E1D006,
                0xC3F27B9A,
                0xC9AA53FD,
                0x62A80F00,
                0xBB25BFE2,
                0x35BDD2F6,
                0x71126905,
                0xB2040222,
                0xB6CBCF7C,
                0xCD769C2B,
                0x53113EC0,
                0x1640E3D3,
                0x38ABBD60,
                0x2547ADF0,
                0xBA38209C,
                0xF746CE76,
                0x77AFA1C5,
                0x20756060,
                0x85CBFE4E,
                0x8AE88DD8,
                0x7AAAF9B0,
                0x4CF9AA7E,
                0x1948C25C,
                0x02FB8A8C,
                0x01C36AE4,
                0xD6EBE1F9,
                0x90D4F869,
                0xA65CDEA0,
                0x3F09252D,
                0xC208E69F,
                0xB74E6132,
                0xCE77E25B,
                0x578FDFE3,
                0x3AC372E6
            ]
        ];
        var BLOWFISH_CTX = {
            pbox: [],
            sbox: []
        };
        function F(ctx, x) {
            let a = x >> 24 & 0xFF;
            let b = x >> 16 & 0xFF;
            let c = x >> 8 & 0xFF;
            let d = x & 0xFF;
            let y = ctx.sbox[0][a] + ctx.sbox[1][b];
            y = y ^ ctx.sbox[2][c];
            y = y + ctx.sbox[3][d];
            return y;
        }
        function BlowFish_Encrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = 0; i < N; ++i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[N];
            Xl = Xl ^ ctx.pbox[N + 1];
            return {
                left: Xl,
                right: Xr
            };
        }
        function BlowFish_Decrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = N + 1; i > 1; --i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[1];
            Xl = Xl ^ ctx.pbox[0];
            return {
                left: Xl,
                right: Xr
            };
        }
        /**
	     * Initialization ctx's pbox and sbox.
	     *
	     * @param {Object} ctx The object has pbox and sbox.
	     * @param {Array} key An array of 32-bit words.
	     * @param {int} keysize The length of the key.
	     *
	     * @example
	     *
	     *     BlowFishInit(BLOWFISH_CTX, key, 128/32);
	     */ function BlowFishInit(ctx, key, keysize) {
            for(let Row = 0; Row < 4; Row++){
                ctx.sbox[Row] = [];
                for(let Col = 0; Col < 256; Col++)ctx.sbox[Row][Col] = ORIG_S[Row][Col];
            }
            let keyIndex = 0;
            for(let index = 0; index < N + 2; index++){
                ctx.pbox[index] = ORIG_P[index] ^ key[keyIndex];
                keyIndex++;
                if (keyIndex >= keysize) keyIndex = 0;
            }
            let Data1 = 0;
            let Data2 = 0;
            let res = 0;
            for(let i = 0; i < N + 2; i += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.pbox[i] = Data1;
                ctx.pbox[i + 1] = Data2;
            }
            for(let i = 0; i < 4; i++)for(let j = 0; j < 256; j += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.sbox[i][j] = Data1;
                ctx.sbox[i][j + 1] = Data2;
            }
            return true;
        }
        /**
	     * Blowfish block cipher algorithm.
	     */ var Blowfish = C_algo.Blowfish = BlockCipher.extend({
            _doReset: function() {
                // Skip reset of nRounds has been set before and key did not change
                if (this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                //Initialization pbox and sbox
                BlowFishInit(BLOWFISH_CTX, keyWords, keySize);
            },
            encryptBlock: function(M, offset) {
                var res = BlowFish_Encrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            decryptBlock: function(M, offset) {
                var res = BlowFish_Decrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            blockSize: 2,
            keySize: 4,
            ivSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Blowfish.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Blowfish.decrypt(ciphertext, key, cfg);
	     */ C.Blowfish = BlockCipher._createHelper(Blowfish);
    })();
    return CryptoJS.Blowfish;
});

});


var $e1117946e7cdcf39$exports = {};
"use strict";

$e1117946e7cdcf39$exports = (parcelRequire("abGvd"));



var $4RFnf = parcelRequire("4RFnf");
var $e6901a497e5ba7f6$exports = {};

$parcel$export($e6901a497e5ba7f6$exports, "createRoot", function () { return $e6901a497e5ba7f6$export$882461b6382ed46c; }, function (v) { return $e6901a497e5ba7f6$export$882461b6382ed46c = v; });
$parcel$export($e6901a497e5ba7f6$exports, "hydrateRoot", function () { return $e6901a497e5ba7f6$export$757ceba2d55c277e; }, function (v) { return $e6901a497e5ba7f6$export$757ceba2d55c277e = v; });
var $e6901a497e5ba7f6$export$882461b6382ed46c;
var $e6901a497e5ba7f6$export$757ceba2d55c277e;
"use strict";
var $6ce1434187f7101c$exports = {};
"use strict";
function $6ce1434187f7101c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6ce1434187f7101c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6ce1434187f7101c$var$checkDCE();

$6ce1434187f7101c$exports = (parcelRequire("bwgJJ"));


var $e6901a497e5ba7f6$var$i;
$e6901a497e5ba7f6$export$882461b6382ed46c = $6ce1434187f7101c$exports.createRoot;
$e6901a497e5ba7f6$export$757ceba2d55c277e = $6ce1434187f7101c$exports.hydrateRoot;




var $7c1640fa2a797e49$exports = {};
$7c1640fa2a797e49$exports = new URL("profile.cb628fc0.jpeg", import.meta.url).toString();


var $d11a3ce0e6c269c4$exports = {};
var $e665ce22324f295c$exports = {};
// shim for using process in browser
var $e665ce22324f295c$var$process = $e665ce22324f295c$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $e665ce22324f295c$var$cachedSetTimeout;
var $e665ce22324f295c$var$cachedClearTimeout;
function $e665ce22324f295c$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $e665ce22324f295c$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $e665ce22324f295c$var$cachedSetTimeout = setTimeout;
        else $e665ce22324f295c$var$cachedSetTimeout = $e665ce22324f295c$var$defaultSetTimout;
    } catch (e) {
        $e665ce22324f295c$var$cachedSetTimeout = $e665ce22324f295c$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $e665ce22324f295c$var$cachedClearTimeout = clearTimeout;
        else $e665ce22324f295c$var$cachedClearTimeout = $e665ce22324f295c$var$defaultClearTimeout;
    } catch (e) {
        $e665ce22324f295c$var$cachedClearTimeout = $e665ce22324f295c$var$defaultClearTimeout;
    }
})();
function $e665ce22324f295c$var$runTimeout(fun) {
    if ($e665ce22324f295c$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($e665ce22324f295c$var$cachedSetTimeout === $e665ce22324f295c$var$defaultSetTimout || !$e665ce22324f295c$var$cachedSetTimeout) && setTimeout) {
        $e665ce22324f295c$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e665ce22324f295c$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $e665ce22324f295c$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $e665ce22324f295c$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $e665ce22324f295c$var$runClearTimeout(marker) {
    if ($e665ce22324f295c$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($e665ce22324f295c$var$cachedClearTimeout === $e665ce22324f295c$var$defaultClearTimeout || !$e665ce22324f295c$var$cachedClearTimeout) && clearTimeout) {
        $e665ce22324f295c$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e665ce22324f295c$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $e665ce22324f295c$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $e665ce22324f295c$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $e665ce22324f295c$var$queue = [];
var $e665ce22324f295c$var$draining = false;
var $e665ce22324f295c$var$currentQueue;
var $e665ce22324f295c$var$queueIndex = -1;
function $e665ce22324f295c$var$cleanUpNextTick() {
    if (!$e665ce22324f295c$var$draining || !$e665ce22324f295c$var$currentQueue) return;
    $e665ce22324f295c$var$draining = false;
    if ($e665ce22324f295c$var$currentQueue.length) $e665ce22324f295c$var$queue = $e665ce22324f295c$var$currentQueue.concat($e665ce22324f295c$var$queue);
    else $e665ce22324f295c$var$queueIndex = -1;
    if ($e665ce22324f295c$var$queue.length) $e665ce22324f295c$var$drainQueue();
}
function $e665ce22324f295c$var$drainQueue() {
    if ($e665ce22324f295c$var$draining) return;
    var timeout = $e665ce22324f295c$var$runTimeout($e665ce22324f295c$var$cleanUpNextTick);
    $e665ce22324f295c$var$draining = true;
    var len = $e665ce22324f295c$var$queue.length;
    while(len){
        $e665ce22324f295c$var$currentQueue = $e665ce22324f295c$var$queue;
        $e665ce22324f295c$var$queue = [];
        while(++$e665ce22324f295c$var$queueIndex < len)if ($e665ce22324f295c$var$currentQueue) $e665ce22324f295c$var$currentQueue[$e665ce22324f295c$var$queueIndex].run();
        $e665ce22324f295c$var$queueIndex = -1;
        len = $e665ce22324f295c$var$queue.length;
    }
    $e665ce22324f295c$var$currentQueue = null;
    $e665ce22324f295c$var$draining = false;
    $e665ce22324f295c$var$runClearTimeout(timeout);
}
$e665ce22324f295c$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $e665ce22324f295c$var$queue.push(new $e665ce22324f295c$var$Item(fun, args));
    if ($e665ce22324f295c$var$queue.length === 1 && !$e665ce22324f295c$var$draining) $e665ce22324f295c$var$runTimeout($e665ce22324f295c$var$drainQueue);
};
// v8 likes predictible objects
function $e665ce22324f295c$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$e665ce22324f295c$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$e665ce22324f295c$var$process.title = "browser";
$e665ce22324f295c$var$process.browser = true;
$e665ce22324f295c$var$process.env = {};
$e665ce22324f295c$var$process.argv = [];
$e665ce22324f295c$var$process.version = ""; // empty string to avoid regexp issues
$e665ce22324f295c$var$process.versions = {};
function $e665ce22324f295c$var$noop() {}
$e665ce22324f295c$var$process.on = $e665ce22324f295c$var$noop;
$e665ce22324f295c$var$process.addListener = $e665ce22324f295c$var$noop;
$e665ce22324f295c$var$process.once = $e665ce22324f295c$var$noop;
$e665ce22324f295c$var$process.off = $e665ce22324f295c$var$noop;
$e665ce22324f295c$var$process.removeListener = $e665ce22324f295c$var$noop;
$e665ce22324f295c$var$process.removeAllListeners = $e665ce22324f295c$var$noop;
$e665ce22324f295c$var$process.emit = $e665ce22324f295c$var$noop;
$e665ce22324f295c$var$process.prependListener = $e665ce22324f295c$var$noop;
$e665ce22324f295c$var$process.prependOnceListener = $e665ce22324f295c$var$noop;
$e665ce22324f295c$var$process.listeners = function(name) {
    return [];
};
$e665ce22324f295c$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$e665ce22324f295c$var$process.cwd = function() {
    return "/";
};
$e665ce22324f295c$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$e665ce22324f295c$var$process.umask = function() {
    return 0;
};



!function(e, t) {
    $d11a3ce0e6c269c4$exports = t((parcelRequire("4RFnf")));
}("undefined" != typeof self ? self : $d11a3ce0e6c269c4$exports, (e)=>(()=>{
        var t = {
            7403: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    default: ()=>S
                });
                var n = r(4087), o = r.n(n);
                const a = function(e) {
                    return new RegExp(/<[a-z][\s\S]*>/i).test(e);
                }, i = function(e, t) {
                    return Math.floor(Math.random() * (t - e + 1)) + e;
                };
                var s = "TYPE_CHARACTER", u = "REMOVE_CHARACTER", c = "REMOVE_ALL", p = "REMOVE_LAST_VISIBLE_NODE", l = "PAUSE_FOR", f = "CALL_FUNCTION", v = "ADD_HTML_TAG_ELEMENT", d = "CHANGE_DELETE_SPEED", h = "CHANGE_DELAY", y = "CHANGE_CURSOR", b = "PASTE_STRING", m = "HTML_TAG";
                function _(e) {
                    return _ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, _(e);
                }
                function g(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function w(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? g(Object(r), !0).forEach(function(t) {
                            O(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : g(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function x(e) {
                    return function(e) {
                        if (Array.isArray(e)) return j(e);
                    }(e) || function(e) {
                        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                    }(e) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return j(e, t);
                            var r = Object.prototype.toString.call(e).slice(8, -1);
                            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? j(e, t) : void 0;
                        }
                    }(e) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function j(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                function E(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, T(n.key), n);
                    }
                }
                function O(e, t, r) {
                    return (t = T(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function T(e) {
                    var t = function(e, t) {
                        if ("object" !== _(e) || null === e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, "string");
                            if ("object" !== _(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(e);
                    return "symbol" === _(t) ? t : String(t);
                }
                const S = function() {
                    function e(t, r) {
                        var _ = this;
                        if (function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), O(this, "state", {
                            cursorAnimation: null,
                            lastFrameTime: null,
                            pauseUntil: null,
                            eventQueue: [],
                            eventLoop: null,
                            eventLoopPaused: !1,
                            reverseCalledEvents: [],
                            calledEvents: [],
                            visibleNodes: [],
                            initialOptions: null,
                            elements: {
                                container: null,
                                wrapper: document.createElement("span"),
                                cursor: document.createElement("span")
                            }
                        }), O(this, "options", {
                            strings: null,
                            cursor: "|",
                            delay: "natural",
                            pauseFor: 1500,
                            deleteSpeed: "natural",
                            loop: !1,
                            autoStart: !1,
                            devMode: !1,
                            skipAddStyles: !1,
                            wrapperClassName: "Typewriter__wrapper",
                            cursorClassName: "Typewriter__cursor",
                            stringSplitter: null,
                            onCreateTextNode: null,
                            onRemoveNode: null
                        }), O(this, "setupWrapperElement", function() {
                            _.state.elements.container && (_.state.elements.wrapper.className = _.options.wrapperClassName, _.state.elements.cursor.className = _.options.cursorClassName, _.state.elements.cursor.innerHTML = _.options.cursor, _.state.elements.container.innerHTML = "", _.state.elements.container.appendChild(_.state.elements.wrapper), _.state.elements.container.appendChild(_.state.elements.cursor));
                        }), O(this, "start", function() {
                            return _.state.eventLoopPaused = !1, _.runEventLoop(), _;
                        }), O(this, "pause", function() {
                            return _.state.eventLoopPaused = !0, _;
                        }), O(this, "stop", function() {
                            return _.state.eventLoop && ((0, n.cancel)(_.state.eventLoop), _.state.eventLoop = null), _;
                        }), O(this, "pauseFor", function(e) {
                            return _.addEventToQueue(l, {
                                ms: e
                            }), _;
                        }), O(this, "typeOutAllStrings", function() {
                            return "string" == typeof _.options.strings ? (_.typeString(_.options.strings).pauseFor(_.options.pauseFor), _) : (_.options.strings.forEach(function(e) {
                                _.typeString(e).pauseFor(_.options.pauseFor).deleteAll(_.options.deleteSpeed);
                            }), _);
                        }), O(this, "typeString", function(e) {
                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                            if (a(e)) return _.typeOutHTMLString(e, t);
                            if (e) {
                                var r = (_.options || {}).stringSplitter, n = "function" == typeof r ? r(e) : e.split("");
                                _.typeCharacters(n, t);
                            }
                            return _;
                        }), O(this, "pasteString", function(e) {
                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                            return a(e) ? _.typeOutHTMLString(e, t, !0) : (e && _.addEventToQueue(b, {
                                character: e,
                                node: t
                            }), _);
                        }), O(this, "typeOutHTMLString", function(e) {
                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, r = arguments.length > 2 ? arguments[2] : void 0, n = function(e) {
                                var t = document.createElement("div");
                                return t.innerHTML = e, t.childNodes;
                            }(e);
                            if (n.length > 0) for(var o = 0; o < n.length; o++){
                                var a = n[o], i = a.innerHTML;
                                a && 3 !== a.nodeType ? (a.innerHTML = "", _.addEventToQueue(v, {
                                    node: a,
                                    parentNode: t
                                }), r ? _.pasteString(i, a) : _.typeString(i, a)) : a.textContent && (r ? _.pasteString(a.textContent, t) : _.typeString(a.textContent, t));
                            }
                            return _;
                        }), O(this, "deleteAll", function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "natural";
                            return _.addEventToQueue(c, {
                                speed: e
                            }), _;
                        }), O(this, "changeDeleteSpeed", function(e) {
                            if (!e) throw new Error("Must provide new delete speed");
                            return _.addEventToQueue(d, {
                                speed: e
                            }), _;
                        }), O(this, "changeDelay", function(e) {
                            if (!e) throw new Error("Must provide new delay");
                            return _.addEventToQueue(h, {
                                delay: e
                            }), _;
                        }), O(this, "changeCursor", function(e) {
                            if (!e) throw new Error("Must provide new cursor");
                            return _.addEventToQueue(y, {
                                cursor: e
                            }), _;
                        }), O(this, "deleteChars", function(e) {
                            if (!e) throw new Error("Must provide amount of characters to delete");
                            for(var t = 0; t < e; t++)_.addEventToQueue(u);
                            return _;
                        }), O(this, "callFunction", function(e, t) {
                            if (!e || "function" != typeof e) throw new Error("Callback must be a function");
                            return _.addEventToQueue(f, {
                                cb: e,
                                thisArg: t
                            }), _;
                        }), O(this, "typeCharacters", function(e) {
                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                            if (!e || !Array.isArray(e)) throw new Error("Characters must be an array");
                            return e.forEach(function(e) {
                                _.addEventToQueue(s, {
                                    character: e,
                                    node: t
                                });
                            }), _;
                        }), O(this, "removeCharacters", function(e) {
                            if (!e || !Array.isArray(e)) throw new Error("Characters must be an array");
                            return e.forEach(function() {
                                _.addEventToQueue(u);
                            }), _;
                        }), O(this, "addEventToQueue", function(e, t) {
                            var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                            return _.addEventToStateProperty(e, t, r, "eventQueue");
                        }), O(this, "addReverseCalledEvent", function(e, t) {
                            var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                            return _.options.loop ? _.addEventToStateProperty(e, t, r, "reverseCalledEvents") : _;
                        }), O(this, "addEventToStateProperty", function(e, t) {
                            var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = arguments.length > 3 ? arguments[3] : void 0, o = {
                                eventName: e,
                                eventArgs: t || {}
                            };
                            return _.state[n] = r ? [
                                o
                            ].concat(x(_.state[n])) : [].concat(x(_.state[n]), [
                                o
                            ]), _;
                        }), O(this, "runEventLoop", function() {
                            _.state.lastFrameTime || (_.state.lastFrameTime = Date.now());
                            var e = Date.now(), t = e - _.state.lastFrameTime;
                            if (!_.state.eventQueue.length) {
                                if (!_.options.loop) return;
                                _.state.eventQueue = x(_.state.calledEvents), _.state.calledEvents = [], _.options = w({}, _.state.initialOptions);
                            }
                            if (_.state.eventLoop = o()(_.runEventLoop), !_.state.eventLoopPaused) {
                                if (_.state.pauseUntil) {
                                    if (e < _.state.pauseUntil) return;
                                    _.state.pauseUntil = null;
                                }
                                var r, n = x(_.state.eventQueue), a = n.shift();
                                if (!(t <= (r = a.eventName === p || a.eventName === u ? "natural" === _.options.deleteSpeed ? i(40, 80) : _.options.deleteSpeed : "natural" === _.options.delay ? i(120, 160) : _.options.delay))) {
                                    var g = a.eventName, j = a.eventArgs;
                                    switch(_.logInDevMode({
                                        currentEvent: a,
                                        state: _.state,
                                        delay: r
                                    }), g){
                                        case b:
                                        case s:
                                            var E = j.character, O = j.node, T = document.createTextNode(E), S = T;
                                            _.options.onCreateTextNode && "function" == typeof _.options.onCreateTextNode && (S = _.options.onCreateTextNode(E, T)), S && (O ? O.appendChild(S) : _.state.elements.wrapper.appendChild(S)), _.state.visibleNodes = [].concat(x(_.state.visibleNodes), [
                                                {
                                                    type: "TEXT_NODE",
                                                    character: E,
                                                    node: S
                                                }
                                            ]);
                                            break;
                                        case u:
                                            n.unshift({
                                                eventName: p,
                                                eventArgs: {
                                                    removingCharacterNode: !0
                                                }
                                            });
                                            break;
                                        case l:
                                            var A = a.eventArgs.ms;
                                            _.state.pauseUntil = Date.now() + parseInt(A);
                                            break;
                                        case f:
                                            var P = a.eventArgs, N = P.cb, C = P.thisArg;
                                            N.call(C, {
                                                elements: _.state.elements
                                            });
                                            break;
                                        case v:
                                            var L = a.eventArgs, k = L.node, D = L.parentNode;
                                            D ? D.appendChild(k) : _.state.elements.wrapper.appendChild(k), _.state.visibleNodes = [].concat(x(_.state.visibleNodes), [
                                                {
                                                    type: m,
                                                    node: k,
                                                    parentNode: D || _.state.elements.wrapper
                                                }
                                            ]);
                                            break;
                                        case c:
                                            var M = _.state.visibleNodes, R = j.speed, F = [];
                                            R && F.push({
                                                eventName: d,
                                                eventArgs: {
                                                    speed: R,
                                                    temp: !0
                                                }
                                            });
                                            for(var z = 0, Q = M.length; z < Q; z++)F.push({
                                                eventName: p,
                                                eventArgs: {
                                                    removingCharacterNode: !1
                                                }
                                            });
                                            R && F.push({
                                                eventName: d,
                                                eventArgs: {
                                                    speed: _.options.deleteSpeed,
                                                    temp: !0
                                                }
                                            }), n.unshift.apply(n, F);
                                            break;
                                        case p:
                                            var I = a.eventArgs.removingCharacterNode;
                                            if (_.state.visibleNodes.length) {
                                                var U = _.state.visibleNodes.pop(), H = U.type, q = U.node, B = U.character;
                                                _.options.onRemoveNode && "function" == typeof _.options.onRemoveNode && _.options.onRemoveNode({
                                                    node: q,
                                                    character: B
                                                }), q && q.parentNode.removeChild(q), H === m && I && n.unshift({
                                                    eventName: p,
                                                    eventArgs: {}
                                                });
                                            }
                                            break;
                                        case d:
                                            _.options.deleteSpeed = a.eventArgs.speed;
                                            break;
                                        case h:
                                            _.options.delay = a.eventArgs.delay;
                                            break;
                                        case y:
                                            _.options.cursor = a.eventArgs.cursor, _.state.elements.cursor.innerHTML = a.eventArgs.cursor;
                                    }
                                    _.options.loop && (a.eventName === p || a.eventArgs && a.eventArgs.temp || (_.state.calledEvents = [].concat(x(_.state.calledEvents), [
                                        a
                                    ]))), _.state.eventQueue = n, _.state.lastFrameTime = e;
                                }
                            }
                        }), t) {
                            if ("string" == typeof t) {
                                var g = document.querySelector(t);
                                if (!g) throw new Error("Could not find container element");
                                this.state.elements.container = g;
                            } else this.state.elements.container = t;
                        }
                        r && (this.options = w(w({}, this.options), r)), this.state.initialOptions = w({}, this.options), this.init();
                    }
                    var t, r;
                    return t = e, r = [
                        {
                            key: "init",
                            value: function() {
                                var e, t;
                                this.setupWrapperElement(), this.addEventToQueue(y, {
                                    cursor: this.options.cursor
                                }, !0), this.addEventToQueue(c, null, !0), !window || window.___TYPEWRITER_JS_STYLES_ADDED___ || this.options.skipAddStyles || (e = ".Typewriter__cursor{-webkit-animation:Typewriter-cursor 1s infinite;animation:Typewriter-cursor 1s infinite;margin-left:1px}@-webkit-keyframes Typewriter-cursor{0%{opacity:0}50%{opacity:1}100%{opacity:0}}@keyframes Typewriter-cursor{0%{opacity:0}50%{opacity:1}100%{opacity:0}}", (t = document.createElement("style")).appendChild(document.createTextNode(e)), document.head.appendChild(t), window.___TYPEWRITER_JS_STYLES_ADDED___ = !0), !0 === this.options.autoStart && this.options.strings && this.typeOutAllStrings().start();
                            }
                        },
                        {
                            key: "logInDevMode",
                            value: function(e) {
                                this.options.devMode && console.log(e);
                            }
                        }
                    ], E(t.prototype, r), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
            },
            8552: (e, t, r)=>{
                var n = r(852)(r(5639), "DataView");
                e.exports = n;
            },
            1989: (e, t, r)=>{
                var n = r(1789), o = r(401), a = r(7667), i = r(1327), s = r(1866);
                function u(e) {
                    var t = -1, r = null == e ? 0 : e.length;
                    for(this.clear(); ++t < r;){
                        var n = e[t];
                        this.set(n[0], n[1]);
                    }
                }
                u.prototype.clear = n, u.prototype.delete = o, u.prototype.get = a, u.prototype.has = i, u.prototype.set = s, e.exports = u;
            },
            8407: (e, t, r)=>{
                var n = r(7040), o = r(4125), a = r(2117), i = r(7518), s = r(4705);
                function u(e) {
                    var t = -1, r = null == e ? 0 : e.length;
                    for(this.clear(); ++t < r;){
                        var n = e[t];
                        this.set(n[0], n[1]);
                    }
                }
                u.prototype.clear = n, u.prototype.delete = o, u.prototype.get = a, u.prototype.has = i, u.prototype.set = s, e.exports = u;
            },
            7071: (e, t, r)=>{
                var n = r(852)(r(5639), "Map");
                e.exports = n;
            },
            3369: (e, t, r)=>{
                var n = r(4785), o = r(1285), a = r(6e3), i = r(9916), s = r(5265);
                function u(e) {
                    var t = -1, r = null == e ? 0 : e.length;
                    for(this.clear(); ++t < r;){
                        var n = e[t];
                        this.set(n[0], n[1]);
                    }
                }
                u.prototype.clear = n, u.prototype.delete = o, u.prototype.get = a, u.prototype.has = i, u.prototype.set = s, e.exports = u;
            },
            3818: (e, t, r)=>{
                var n = r(852)(r(5639), "Promise");
                e.exports = n;
            },
            8525: (e, t, r)=>{
                var n = r(852)(r(5639), "Set");
                e.exports = n;
            },
            8668: (e, t, r)=>{
                var n = r(3369), o = r(619), a = r(2385);
                function i(e) {
                    var t = -1, r = null == e ? 0 : e.length;
                    for(this.__data__ = new n; ++t < r;)this.add(e[t]);
                }
                i.prototype.add = i.prototype.push = o, i.prototype.has = a, e.exports = i;
            },
            6384: (e, t, r)=>{
                var n = r(8407), o = r(7465), a = r(3779), i = r(7599), s = r(4758), u = r(4309);
                function c(e) {
                    var t = this.__data__ = new n(e);
                    this.size = t.size;
                }
                c.prototype.clear = o, c.prototype.delete = a, c.prototype.get = i, c.prototype.has = s, c.prototype.set = u, e.exports = c;
            },
            2705: (e, t, r)=>{
                var n = r(5639).Symbol;
                e.exports = n;
            },
            1149: (e, t, r)=>{
                var n = r(5639).Uint8Array;
                e.exports = n;
            },
            577: (e, t, r)=>{
                var n = r(852)(r(5639), "WeakMap");
                e.exports = n;
            },
            4963: (e)=>{
                e.exports = function(e, t) {
                    for(var r = -1, n = null == e ? 0 : e.length, o = 0, a = []; ++r < n;){
                        var i = e[r];
                        t(i, r, e) && (a[o++] = i);
                    }
                    return a;
                };
            },
            4636: (e, t, r)=>{
                var n = r(2545), o = r(5694), a = r(1469), i = r(4144), s = r(5776), u = r(6719), c = Object.prototype.hasOwnProperty;
                e.exports = function(e, t) {
                    var r = a(e), p = !r && o(e), l = !r && !p && i(e), f = !r && !p && !l && u(e), v = r || p || l || f, d = v ? n(e.length, String) : [], h = d.length;
                    for(var y in e)!t && !c.call(e, y) || v && ("length" == y || l && ("offset" == y || "parent" == y) || f && ("buffer" == y || "byteLength" == y || "byteOffset" == y) || s(y, h)) || d.push(y);
                    return d;
                };
            },
            2488: (e)=>{
                e.exports = function(e, t) {
                    for(var r = -1, n = t.length, o = e.length; ++r < n;)e[o + r] = t[r];
                    return e;
                };
            },
            2908: (e)=>{
                e.exports = function(e, t) {
                    for(var r = -1, n = null == e ? 0 : e.length; ++r < n;)if (t(e[r], r, e)) return !0;
                    return !1;
                };
            },
            8470: (e, t, r)=>{
                var n = r(7813);
                e.exports = function(e, t) {
                    for(var r = e.length; r--;)if (n(e[r][0], t)) return r;
                    return -1;
                };
            },
            8866: (e, t, r)=>{
                var n = r(2488), o = r(1469);
                e.exports = function(e, t, r) {
                    var a = t(e);
                    return o(e) ? a : n(a, r(e));
                };
            },
            4239: (e, t, r)=>{
                var n = r(2705), o = r(9607), a = r(2333), i = n ? n.toStringTag : void 0;
                e.exports = function(e) {
                    return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : i && i in Object(e) ? o(e) : a(e);
                };
            },
            9454: (e, t, r)=>{
                var n = r(4239), o = r(7005);
                e.exports = function(e) {
                    return o(e) && "[object Arguments]" == n(e);
                };
            },
            939: (e, t, r)=>{
                var n = r(2492), o = r(7005);
                e.exports = function e(t, r, a, i, s) {
                    return t === r || (null == t || null == r || !o(t) && !o(r) ? t != t && r != r : n(t, r, a, i, e, s));
                };
            },
            2492: (e, t, r)=>{
                var n = r(6384), o = r(7114), a = r(8351), i = r(6096), s = r(4160), u = r(1469), c = r(4144), p = r(6719), l = "[object Arguments]", f = "[object Array]", v = "[object Object]", d = Object.prototype.hasOwnProperty;
                e.exports = function(e, t, r, h, y, b) {
                    var m = u(e), _ = u(t), g = m ? f : s(e), w = _ ? f : s(t), x = (g = g == l ? v : g) == v, j = (w = w == l ? v : w) == v, E = g == w;
                    if (E && c(e)) {
                        if (!c(t)) return !1;
                        m = !0, x = !1;
                    }
                    if (E && !x) return b || (b = new n), m || p(e) ? o(e, t, r, h, y, b) : a(e, t, g, r, h, y, b);
                    if (!(1 & r)) {
                        var O = x && d.call(e, "__wrapped__"), T = j && d.call(t, "__wrapped__");
                        if (O || T) {
                            var S = O ? e.value() : e, A = T ? t.value() : t;
                            return b || (b = new n), y(S, A, r, h, b);
                        }
                    }
                    return !!E && (b || (b = new n), i(e, t, r, h, y, b));
                };
            },
            8458: (e, t, r)=>{
                var n = r(3560), o = r(5346), a = r(3218), i = r(346), s = /^\[object .+?Constructor\]$/, u = Function.prototype, c = Object.prototype, p = u.toString, l = c.hasOwnProperty, f = RegExp("^" + p.call(l).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
                e.exports = function(e) {
                    return !(!a(e) || o(e)) && (n(e) ? f : s).test(i(e));
                };
            },
            8749: (e, t, r)=>{
                var n = r(4239), o = r(1780), a = r(7005), i = {};
                i["[object Float32Array]"] = i["[object Float64Array]"] = i["[object Int8Array]"] = i["[object Int16Array]"] = i["[object Int32Array]"] = i["[object Uint8Array]"] = i["[object Uint8ClampedArray]"] = i["[object Uint16Array]"] = i["[object Uint32Array]"] = !0, i["[object Arguments]"] = i["[object Array]"] = i["[object ArrayBuffer]"] = i["[object Boolean]"] = i["[object DataView]"] = i["[object Date]"] = i["[object Error]"] = i["[object Function]"] = i["[object Map]"] = i["[object Number]"] = i["[object Object]"] = i["[object RegExp]"] = i["[object Set]"] = i["[object String]"] = i["[object WeakMap]"] = !1, e.exports = function(e) {
                    return a(e) && o(e.length) && !!i[n(e)];
                };
            },
            280: (e, t, r)=>{
                var n = r(5726), o = r(6916), a = Object.prototype.hasOwnProperty;
                e.exports = function(e) {
                    if (!n(e)) return o(e);
                    var t = [];
                    for(var r in Object(e))a.call(e, r) && "constructor" != r && t.push(r);
                    return t;
                };
            },
            2545: (e)=>{
                e.exports = function(e, t) {
                    for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
                    return n;
                };
            },
            1717: (e)=>{
                e.exports = function(e) {
                    return function(t) {
                        return e(t);
                    };
                };
            },
            4757: (e)=>{
                e.exports = function(e, t) {
                    return e.has(t);
                };
            },
            4429: (e, t, r)=>{
                var n = r(5639)["__core-js_shared__"];
                e.exports = n;
            },
            7114: (e, t, r)=>{
                var n = r(8668), o = r(2908), a = r(4757);
                e.exports = function(e, t, r, i, s, u) {
                    var c = 1 & r, p = e.length, l = t.length;
                    if (p != l && !(c && l > p)) return !1;
                    var f = u.get(e), v = u.get(t);
                    if (f && v) return f == t && v == e;
                    var d = -1, h = !0, y = 2 & r ? new n : void 0;
                    for(u.set(e, t), u.set(t, e); ++d < p;){
                        var b = e[d], m = t[d];
                        if (i) var _ = c ? i(m, b, d, t, e, u) : i(b, m, d, e, t, u);
                        if (void 0 !== _) {
                            if (_) continue;
                            h = !1;
                            break;
                        }
                        if (y) {
                            if (!o(t, function(e, t) {
                                if (!a(y, t) && (b === e || s(b, e, r, i, u))) return y.push(t);
                            })) {
                                h = !1;
                                break;
                            }
                        } else if (b !== m && !s(b, m, r, i, u)) {
                            h = !1;
                            break;
                        }
                    }
                    return u.delete(e), u.delete(t), h;
                };
            },
            8351: (e, t, r)=>{
                var n = r(2705), o = r(1149), a = r(7813), i = r(7114), s = r(8776), u = r(1814), c = n ? n.prototype : void 0, p = c ? c.valueOf : void 0;
                e.exports = function(e, t, r, n, c, l, f) {
                    switch(r){
                        case "[object DataView]":
                            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                            e = e.buffer, t = t.buffer;
                        case "[object ArrayBuffer]":
                            return !(e.byteLength != t.byteLength || !l(new o(e), new o(t)));
                        case "[object Boolean]":
                        case "[object Date]":
                        case "[object Number]":
                            return a(+e, +t);
                        case "[object Error]":
                            return e.name == t.name && e.message == t.message;
                        case "[object RegExp]":
                        case "[object String]":
                            return e == t + "";
                        case "[object Map]":
                            var v = s;
                        case "[object Set]":
                            var d = 1 & n;
                            if (v || (v = u), e.size != t.size && !d) return !1;
                            var h = f.get(e);
                            if (h) return h == t;
                            n |= 2, f.set(e, t);
                            var y = i(v(e), v(t), n, c, l, f);
                            return f.delete(e), y;
                        case "[object Symbol]":
                            if (p) return p.call(e) == p.call(t);
                    }
                    return !1;
                };
            },
            6096: (e, t, r)=>{
                var n = r(8234), o = Object.prototype.hasOwnProperty;
                e.exports = function(e, t, r, a, i, s) {
                    var u = 1 & r, c = n(e), p = c.length;
                    if (p != n(t).length && !u) return !1;
                    for(var l = p; l--;){
                        var f = c[l];
                        if (!(u ? f in t : o.call(t, f))) return !1;
                    }
                    var v = s.get(e), d = s.get(t);
                    if (v && d) return v == t && d == e;
                    var h = !0;
                    s.set(e, t), s.set(t, e);
                    for(var y = u; ++l < p;){
                        var b = e[f = c[l]], m = t[f];
                        if (a) var _ = u ? a(m, b, f, t, e, s) : a(b, m, f, e, t, s);
                        if (!(void 0 === _ ? b === m || i(b, m, r, a, s) : _)) {
                            h = !1;
                            break;
                        }
                        y || (y = "constructor" == f);
                    }
                    if (h && !y) {
                        var g = e.constructor, w = t.constructor;
                        g == w || !("constructor" in e) || !("constructor" in t) || "function" == typeof g && g instanceof g && "function" == typeof w && w instanceof w || (h = !1);
                    }
                    return s.delete(e), s.delete(t), h;
                };
            },
            1957: (e, t, r)=>{
                var n = "object" == typeof r.g && r.g && r.g.Object === Object && r.g;
                e.exports = n;
            },
            8234: (e, t, r)=>{
                var n = r(8866), o = r(9551), a = r(3674);
                e.exports = function(e) {
                    return n(e, a, o);
                };
            },
            5050: (e, t, r)=>{
                var n = r(7019);
                e.exports = function(e, t) {
                    var r = e.__data__;
                    return n(t) ? r["string" == typeof t ? "string" : "hash"] : r.map;
                };
            },
            852: (e, t, r)=>{
                var n = r(8458), o = r(7801);
                e.exports = function(e, t) {
                    var r = o(e, t);
                    return n(r) ? r : void 0;
                };
            },
            9607: (e, t, r)=>{
                var n = r(2705), o = Object.prototype, a = o.hasOwnProperty, i = o.toString, s = n ? n.toStringTag : void 0;
                e.exports = function(e) {
                    var t = a.call(e, s), r = e[s];
                    try {
                        e[s] = void 0;
                        var n = !0;
                    } catch (e) {}
                    var o = i.call(e);
                    return n && (t ? e[s] = r : delete e[s]), o;
                };
            },
            9551: (e, t, r)=>{
                var n = r(4963), o = r(479), a = Object.prototype.propertyIsEnumerable, i = Object.getOwnPropertySymbols, s = i ? function(e) {
                    return null == e ? [] : (e = Object(e), n(i(e), function(t) {
                        return a.call(e, t);
                    }));
                } : o;
                e.exports = s;
            },
            4160: (e, t, r)=>{
                var n = r(8552), o = r(7071), a = r(3818), i = r(8525), s = r(577), u = r(4239), c = r(346), p = "[object Map]", l = "[object Promise]", f = "[object Set]", v = "[object WeakMap]", d = "[object DataView]", h = c(n), y = c(o), b = c(a), m = c(i), _ = c(s), g = u;
                (n && g(new n(new ArrayBuffer(1))) != d || o && g(new o) != p || a && g(a.resolve()) != l || i && g(new i) != f || s && g(new s) != v) && (g = function(e) {
                    var t = u(e), r = "[object Object]" == t ? e.constructor : void 0, n = r ? c(r) : "";
                    if (n) switch(n){
                        case h:
                            return d;
                        case y:
                            return p;
                        case b:
                            return l;
                        case m:
                            return f;
                        case _:
                            return v;
                    }
                    return t;
                }), e.exports = g;
            },
            7801: (e)=>{
                e.exports = function(e, t) {
                    return null == e ? void 0 : e[t];
                };
            },
            1789: (e, t, r)=>{
                var n = r(4536);
                e.exports = function() {
                    this.__data__ = n ? n(null) : {}, this.size = 0;
                };
            },
            401: (e)=>{
                e.exports = function(e) {
                    var t = this.has(e) && delete this.__data__[e];
                    return this.size -= t ? 1 : 0, t;
                };
            },
            7667: (e, t, r)=>{
                var n = r(4536), o = Object.prototype.hasOwnProperty;
                e.exports = function(e) {
                    var t = this.__data__;
                    if (n) {
                        var r = t[e];
                        return "__lodash_hash_undefined__" === r ? void 0 : r;
                    }
                    return o.call(t, e) ? t[e] : void 0;
                };
            },
            1327: (e, t, r)=>{
                var n = r(4536), o = Object.prototype.hasOwnProperty;
                e.exports = function(e) {
                    var t = this.__data__;
                    return n ? void 0 !== t[e] : o.call(t, e);
                };
            },
            1866: (e, t, r)=>{
                var n = r(4536);
                e.exports = function(e, t) {
                    var r = this.__data__;
                    return this.size += this.has(e) ? 0 : 1, r[e] = n && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                };
            },
            5776: (e)=>{
                var t = /^(?:0|[1-9]\d*)$/;
                e.exports = function(e, r) {
                    var n = typeof e;
                    return !!(r = null == r ? 9007199254740991 : r) && ("number" == n || "symbol" != n && t.test(e)) && e > -1 && e % 1 == 0 && e < r;
                };
            },
            7019: (e)=>{
                e.exports = function(e) {
                    var t = typeof e;
                    return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
                };
            },
            5346: (e, t, r)=>{
                var n, o = r(4429), a = (n = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + n : "";
                e.exports = function(e) {
                    return !!a && a in e;
                };
            },
            5726: (e)=>{
                var t = Object.prototype;
                e.exports = function(e) {
                    var r = e && e.constructor;
                    return e === ("function" == typeof r && r.prototype || t);
                };
            },
            7040: (e)=>{
                e.exports = function() {
                    this.__data__ = [], this.size = 0;
                };
            },
            4125: (e, t, r)=>{
                var n = r(8470), o = Array.prototype.splice;
                e.exports = function(e) {
                    var t = this.__data__, r = n(t, e);
                    return !(r < 0 || (r == t.length - 1 ? t.pop() : o.call(t, r, 1), --this.size, 0));
                };
            },
            2117: (e, t, r)=>{
                var n = r(8470);
                e.exports = function(e) {
                    var t = this.__data__, r = n(t, e);
                    return r < 0 ? void 0 : t[r][1];
                };
            },
            7518: (e, t, r)=>{
                var n = r(8470);
                e.exports = function(e) {
                    return n(this.__data__, e) > -1;
                };
            },
            4705: (e, t, r)=>{
                var n = r(8470);
                e.exports = function(e, t) {
                    var r = this.__data__, o = n(r, e);
                    return o < 0 ? (++this.size, r.push([
                        e,
                        t
                    ])) : r[o][1] = t, this;
                };
            },
            4785: (e, t, r)=>{
                var n = r(1989), o = r(8407), a = r(7071);
                e.exports = function() {
                    this.size = 0, this.__data__ = {
                        hash: new n,
                        map: new (a || o),
                        string: new n
                    };
                };
            },
            1285: (e, t, r)=>{
                var n = r(5050);
                e.exports = function(e) {
                    var t = n(this, e).delete(e);
                    return this.size -= t ? 1 : 0, t;
                };
            },
            6e3: (e, t, r)=>{
                var n = r(5050);
                e.exports = function(e) {
                    return n(this, e).get(e);
                };
            },
            9916: (e, t, r)=>{
                var n = r(5050);
                e.exports = function(e) {
                    return n(this, e).has(e);
                };
            },
            5265: (e, t, r)=>{
                var n = r(5050);
                e.exports = function(e, t) {
                    var r = n(this, e), o = r.size;
                    return r.set(e, t), this.size += r.size == o ? 0 : 1, this;
                };
            },
            8776: (e)=>{
                e.exports = function(e) {
                    var t = -1, r = Array(e.size);
                    return e.forEach(function(e, n) {
                        r[++t] = [
                            n,
                            e
                        ];
                    }), r;
                };
            },
            4536: (e, t, r)=>{
                var n = r(852)(Object, "create");
                e.exports = n;
            },
            6916: (e, t, r)=>{
                var n = r(5569)(Object.keys, Object);
                e.exports = n;
            },
            1167: (e, t, r)=>{
                e = r.nmd(e);
                var n = r(1957), o = t && !t.nodeType && t, a = o && e && !e.nodeType && e, i = a && a.exports === o && n.process, s = function() {
                    try {
                        return a && a.require && a.require("util").types || i && i.binding && i.binding("util");
                    } catch (e) {}
                }();
                e.exports = s;
            },
            2333: (e)=>{
                var t = Object.prototype.toString;
                e.exports = function(e) {
                    return t.call(e);
                };
            },
            5569: (e)=>{
                e.exports = function(e, t) {
                    return function(r) {
                        return e(t(r));
                    };
                };
            },
            5639: (e, t, r)=>{
                var n = r(1957), o = "object" == typeof self && self && self.Object === Object && self, a = n || o || Function("return this")();
                e.exports = a;
            },
            619: (e)=>{
                e.exports = function(e) {
                    return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                };
            },
            2385: (e)=>{
                e.exports = function(e) {
                    return this.__data__.has(e);
                };
            },
            1814: (e)=>{
                e.exports = function(e) {
                    var t = -1, r = Array(e.size);
                    return e.forEach(function(e) {
                        r[++t] = e;
                    }), r;
                };
            },
            7465: (e, t, r)=>{
                var n = r(8407);
                e.exports = function() {
                    this.__data__ = new n, this.size = 0;
                };
            },
            3779: (e)=>{
                e.exports = function(e) {
                    var t = this.__data__, r = t.delete(e);
                    return this.size = t.size, r;
                };
            },
            7599: (e)=>{
                e.exports = function(e) {
                    return this.__data__.get(e);
                };
            },
            4758: (e)=>{
                e.exports = function(e) {
                    return this.__data__.has(e);
                };
            },
            4309: (e, t, r)=>{
                var n = r(8407), o = r(7071), a = r(3369);
                e.exports = function(e, t) {
                    var r = this.__data__;
                    if (r instanceof n) {
                        var i = r.__data__;
                        if (!o || i.length < 199) return i.push([
                            e,
                            t
                        ]), this.size = ++r.size, this;
                        r = this.__data__ = new a(i);
                    }
                    return r.set(e, t), this.size = r.size, this;
                };
            },
            346: (e)=>{
                var t = Function.prototype.toString;
                e.exports = function(e) {
                    if (null != e) {
                        try {
                            return t.call(e);
                        } catch (e) {}
                        try {
                            return e + "";
                        } catch (e) {}
                    }
                    return "";
                };
            },
            7813: (e)=>{
                e.exports = function(e, t) {
                    return e === t || e != e && t != t;
                };
            },
            5694: (e, t, r)=>{
                var n = r(9454), o = r(7005), a = Object.prototype, i = a.hasOwnProperty, s = a.propertyIsEnumerable, u = n(function() {
                    return arguments;
                }()) ? n : function(e) {
                    return o(e) && i.call(e, "callee") && !s.call(e, "callee");
                };
                e.exports = u;
            },
            1469: (e)=>{
                var t = Array.isArray;
                e.exports = t;
            },
            8612: (e, t, r)=>{
                var n = r(3560), o = r(1780);
                e.exports = function(e) {
                    return null != e && o(e.length) && !n(e);
                };
            },
            4144: (e, t, r)=>{
                e = r.nmd(e);
                var n = r(5639), o = r(5062), a = t && !t.nodeType && t, i = a && e && !e.nodeType && e, s = i && i.exports === a ? n.Buffer : void 0, u = (s ? s.isBuffer : void 0) || o;
                e.exports = u;
            },
            8446: (e, t, r)=>{
                var n = r(939);
                e.exports = function(e, t) {
                    return n(e, t);
                };
            },
            3560: (e, t, r)=>{
                var n = r(4239), o = r(3218);
                e.exports = function(e) {
                    if (!o(e)) return !1;
                    var t = n(e);
                    return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
                };
            },
            1780: (e)=>{
                e.exports = function(e) {
                    return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
                };
            },
            3218: (e)=>{
                e.exports = function(e) {
                    var t = typeof e;
                    return null != e && ("object" == t || "function" == t);
                };
            },
            7005: (e)=>{
                e.exports = function(e) {
                    return null != e && "object" == typeof e;
                };
            },
            6719: (e, t, r)=>{
                var n = r(8749), o = r(1717), a = r(1167), i = a && a.isTypedArray, s = i ? o(i) : n;
                e.exports = s;
            },
            3674: (e, t, r)=>{
                var n = r(4636), o = r(280), a = r(8612);
                e.exports = function(e) {
                    return a(e) ? n(e) : o(e);
                };
            },
            479: (e)=>{
                e.exports = function() {
                    return [];
                };
            },
            5062: (e)=>{
                e.exports = function() {
                    return !1;
                };
            },
            75: function(e) {
                (function() {
                    var t, r, n, o, a, i;
                    "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function() {
                        return performance.now();
                    } : "undefined" != typeof $e665ce22324f295c$exports && null !== $e665ce22324f295c$exports && $e665ce22324f295c$exports.hrtime ? (e.exports = function() {
                        return (t() - a) / 1e6;
                    }, r = $e665ce22324f295c$exports.hrtime, o = (t = function() {
                        var e;
                        return 1e9 * (e = r())[0] + e[1];
                    })(), i = 1e9 * $e665ce22324f295c$exports.uptime(), a = o - i) : Date.now ? (e.exports = function() {
                        return Date.now() - n;
                    }, n = Date.now()) : (e.exports = function() {
                        return (new Date).getTime() - n;
                    }, n = (new Date).getTime());
                }).call(this);
            },
            4087: (e, t, r)=>{
                for(var n = r(75), o = "undefined" == typeof window ? r.g : window, a = [
                    "moz",
                    "webkit"
                ], i = "AnimationFrame", s = o["request" + i], u = o["cancel" + i] || o["cancelRequest" + i], c = 0; !s && c < a.length; c++)s = o[a[c] + "Request" + i], u = o[a[c] + "Cancel" + i] || o[a[c] + "CancelRequest" + i];
                if (!s || !u) {
                    var p = 0, l = 0, f = [];
                    s = function(e) {
                        if (0 === f.length) {
                            var t = n(), r = Math.max(0, 16.666666666666668 - (t - p));
                            p = r + t, setTimeout(function() {
                                var e = f.slice(0);
                                f.length = 0;
                                for(var t = 0; t < e.length; t++)if (!e[t].cancelled) try {
                                    e[t].callback(p);
                                } catch (e) {
                                    setTimeout(function() {
                                        throw e;
                                    }, 0);
                                }
                            }, Math.round(r));
                        }
                        return f.push({
                            handle: ++l,
                            callback: e,
                            cancelled: !1
                        }), l;
                    }, u = function(e) {
                        for(var t = 0; t < f.length; t++)f[t].handle === e && (f[t].cancelled = !0);
                    };
                }
                e.exports = function(e) {
                    return s.call(o, e);
                }, e.exports.cancel = function() {
                    u.apply(o, arguments);
                }, e.exports.polyfill = function(e) {
                    e || (e = o), e.requestAnimationFrame = s, e.cancelAnimationFrame = u;
                };
            },
            8156: (t)=>{
                "use strict";
                t.exports = e;
            }
        }, r = {};
        function n(e) {
            var o = r[e];
            if (void 0 !== o) return o.exports;
            var a = r[e] = {
                id: e,
                loaded: !1,
                exports: {}
            };
            return t[e].call(a.exports, a, a.exports, n), a.loaded = !0, a.exports;
        }
        n.n = (e)=>{
            var t = e && e.__esModule ? ()=>e.default : ()=>e;
            return n.d(t, {
                a: t
            }), t;
        }, n.d = (e, t)=>{
            for(var r in t)n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
                enumerable: !0,
                get: t[r]
            });
        }, n.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        }(), n.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), n.nmd = (e)=>(e.paths = [], e.children || (e.children = []), e);
        var o = {};
        return (()=>{
            "use strict";
            n.d(o, {
                default: ()=>d
            });
            var e = n(8156), t = n.n(e), r = n(7403), a = n(8446), i = n.n(a);
            function s(e) {
                return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, s(e);
            }
            function u(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, f(n.key), n);
                }
            }
            function c(e, t) {
                return c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                    return e.__proto__ = t, e;
                }, c(e, t);
            }
            function p(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }
            function l(e) {
                return l = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                }, l(e);
            }
            function f(e) {
                var t = function(e, t) {
                    if ("object" !== s(e) || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, "string");
                        if ("object" !== s(n)) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" === s(t) ? t : String(t);
            }
            var v = function(e) {
                !function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && c(e, t);
                }(h, e);
                var n, o, a, v, d = (a = h, v = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, t = l(a);
                    if (v) {
                        var r = l(this).constructor;
                        e = Reflect.construct(t, arguments, r);
                    } else e = t.apply(this, arguments);
                    return function(e, t) {
                        if (t && ("object" === s(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return p(e);
                    }(this, e);
                });
                function h() {
                    var e, t, r, n;
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, h);
                    for(var o = arguments.length, a = new Array(o), i = 0; i < o; i++)a[i] = arguments[i];
                    return t = p(e = d.call.apply(d, [
                        this
                    ].concat(a))), n = {
                        instance: null
                    }, (r = f(r = "state")) in t ? Object.defineProperty(t, r, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t[r] = n, e;
                }
                return n = h, o = [
                    {
                        key: "componentDidMount",
                        value: function() {
                            var e = this, t = new r.default(this.typewriter, this.props.options);
                            this.setState({
                                instance: t
                            }, function() {
                                var r = e.props.onInit;
                                r && r(t);
                            });
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function(e) {
                            i()(this.props.options, e.options) || this.setState({
                                instance: new r.default(this.typewriter, this.props.options)
                            });
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.state.instance && this.state.instance.stop();
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e = this, r = this.props.component;
                            return t().createElement(r, {
                                ref: function(t) {
                                    return e.typewriter = t;
                                },
                                className: "Typewriter",
                                "data-testid": "typewriter-wrapper"
                            });
                        }
                    }
                ], u(n.prototype, o), Object.defineProperty(n, "prototype", {
                    writable: !1
                }), h;
            }(e.Component);
            v.defaultProps = {
                component: "div"
            };
            const d = v;
        })(), o.default;
    })());


const $f19114865e4e8ab7$var$Intro = ()=>{
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
        className: "h-screen md:h-[calc(100vh-80px)] mt-5 flex justify-center items-center",
        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
            className: "flex flex-col lg:flex-row xl:mx-12 lg:gap-4 ",
            children: [
                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                    className: "lg:px-10 w-full lg:w-8/12 flex flex-col items-center justify-center",
                    children: [
                        /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                            className: "font-poppins align-middle text-center lg:pb-8 pb-4 text-4xl md:text-6xl font-bold text-[#333333] dark:text-[#e0e0e0] leading-tight lg:leading-normal",
                            children: "Damyant Jain"
                        }),
                        /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                            className: "lg:pb-8 pb-4 tracking-wider font-poppins text-2xl md:text-4xl font-bold text-[#e53939]",
                            children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d11a3ce0e6c269c4$exports))), {
                                options: {
                                    strings: [
                                        "Programmer",
                                        "Developer",
                                        "Student",
                                        "Innovator",
                                        "Curious"
                                    ],
                                    autoStart: true,
                                    loop: true,
                                    deleteSpeed: 50
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                            className: "align-middle text-center font-poppins dark:text-[#e0e0e0] text-[#333333]",
                            children: "I'm all about turning cool ideas into awesome products and exploring the ever-evolving tech world. With over 3 years of experience, I'm passionate about solving real-world problems. When I'm not coding, you can find me enjoying sports."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                    className: "p-5 w-full pt-20 lg:pt-0 lg:w-4/12 flex justify-center items-center",
                    children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("img", {
                        className: "rounded-full shadow-2xl object-cover dark:shadow-[#e53939] h-56 w-56  lg:h-72 lg:w-72",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7c1640fa2a797e49$exports))),
                        alt: "Damyant Jain"
                    })
                })
            ]
        })
    });
};
var $f19114865e4e8ab7$export$2e2bcd8739ae039 = $f19114865e4e8ab7$var$Intro;




var $4RFnf = parcelRequire("4RFnf");
"use client";
var $14f8ebced7a82fe2$var$__defProp = Object.defineProperty;
var $14f8ebced7a82fe2$var$__defNormalProp = (obj, key, value)=>key in obj ? $14f8ebced7a82fe2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $14f8ebced7a82fe2$var$__publicField = (obj, key, value)=>$14f8ebced7a82fe2$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/observe.ts
var $14f8ebced7a82fe2$var$observerMap = /* @__PURE__ */ new Map();
var $14f8ebced7a82fe2$var$RootIds = /* @__PURE__ */ new WeakMap();
var $14f8ebced7a82fe2$var$rootId = 0;
var $14f8ebced7a82fe2$var$unsupportedValue = void 0;
function $14f8ebced7a82fe2$export$2ef3a60ee1f37bec(inView) {
    $14f8ebced7a82fe2$var$unsupportedValue = inView;
}
function $14f8ebced7a82fe2$var$getRootId(root) {
    if (!root) return "0";
    if ($14f8ebced7a82fe2$var$RootIds.has(root)) return $14f8ebced7a82fe2$var$RootIds.get(root);
    $14f8ebced7a82fe2$var$rootId += 1;
    $14f8ebced7a82fe2$var$RootIds.set(root, $14f8ebced7a82fe2$var$rootId.toString());
    return $14f8ebced7a82fe2$var$RootIds.get(root);
}
function $14f8ebced7a82fe2$var$optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? $14f8ebced7a82fe2$var$getRootId(options.root) : options[key]}`;
    }).toString();
}
function $14f8ebced7a82fe2$var$createObserver(options) {
    const id = $14f8ebced7a82fe2$var$optionsToId(options);
    let instance = $14f8ebced7a82fe2$var$observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $14f8ebced7a82fe2$var$observerMap.set(id, instance);
    }
    return instance;
}
function $14f8ebced7a82fe2$export$d1203567a167490e(element, callback, options = {}, fallbackInView = $14f8ebced7a82fe2$var$unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id: id, observer: observer, elements: elements } = $14f8ebced7a82fe2$var$createObserver(options);
    const callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            $14f8ebced7a82fe2$var$observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function $14f8ebced7a82fe2$var$isPlainChildren(props) {
    return typeof props.children !== "function";
}
var $14f8ebced7a82fe2$export$a62107ca74432f44 = class extends $4RFnf.Component {
    constructor(props){
        super(props);
        $14f8ebced7a82fe2$var$__publicField(this, "node", null);
        $14f8ebced7a82fe2$var$__publicField(this, "_unobserveCb", null);
        $14f8ebced7a82fe2$var$__publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        $14f8ebced7a82fe2$var$__publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!$14f8ebced7a82fe2$var$isPlainChildren(this.props)) this.setState({
                inView: inView,
                entry: entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
    componentDidMount() {
        this.unobserve();
        this.observeNode();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold: threshold, root: root, rootMargin: rootMargin, trackVisibility: trackVisibility, delay: delay, fallbackInView: fallbackInView } = this.props;
        this._unobserveCb = $14f8ebced7a82fe2$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children: children } = this.props;
        if (typeof children === "function") {
            const { inView: inView, entry: entry } = this.state;
            return children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        const { as: as, triggerOnce: triggerOnce, threshold: threshold, root: root, rootMargin: rootMargin, onChange: onChange, skip: skip, trackVisibility: trackVisibility, delay: delay, initialInView: initialInView, fallbackInView: fallbackInView, ...props } = this.props;
        return $4RFnf.createElement(as || "div", {
            ref: this.handleNode,
            ...props
        }, children);
    }
};
function $14f8ebced7a82fe2$export$2f62ee6831462844({ threshold: threshold, delay: delay, trackVisibility: trackVisibility, rootMargin: rootMargin, root: root, triggerOnce: triggerOnce, skip: skip, initialInView: initialInView, fallbackInView: fallbackInView, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = $4RFnf.useState(null);
    const callback = $4RFnf.useRef();
    const [state, setState] = $4RFnf.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    $4RFnf.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = $14f8ebced7a82fe2$export$d1203567a167490e(ref, (inView, entry)=>{
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = $4RFnf.useRef();
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}
 //# sourceMappingURL=index.mjs.map




var $4RFnf = parcelRequire("4RFnf");

var $4RFnf = parcelRequire("4RFnf");
/**
 * @public
 */ const $ef5f4beec67f2aae$export$22a697fb29aac98d = (0, $4RFnf.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $4RFnf = parcelRequire("4RFnf");
const $2b5e1f3d2bd5bb63$export$2285bbca2c666415 = (0, $4RFnf.createContext)({});



var $4RFnf = parcelRequire("4RFnf");

var $4RFnf = parcelRequire("4RFnf");
/**
 * @public
 */ const $33070f4719eb5d51$export$f224e4635b6f8ce2 = (0, $4RFnf.createContext)(null);




var $4RFnf = parcelRequire("4RFnf");
const $5794b0c359c0df2a$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $a43a8f7089d31bc5$export$700979bc83e7db82 = (0, $5794b0c359c0df2a$export$4e09c449d6c407f7) ? (0, $4RFnf.useLayoutEffect) : (0, $4RFnf.useEffect);



var $4RFnf = parcelRequire("4RFnf");
const $046171cebbf4e6c8$export$40f10139ecf1f171 = (0, $4RFnf.createContext)({
    strict: false
});



/**
 * Convert camelCase to dash-case properties.
 */ const $9d19f5cf96f60af5$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();


const $df031e97d26f68b8$export$ed7b8fa9dbf0105d = "framerAppearId";
const $df031e97d26f68b8$export$8592e1c077c890a6 = "data-" + (0, $9d19f5cf96f60af5$export$9fd24a634729c672)($df031e97d26f68b8$export$ed7b8fa9dbf0105d);


const $2fe7e731675c3a42$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};


function $6b19639ff75ae9c7$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $f9a1e11c81165c0a$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $f9a1e11c81165c0a$var$maxElapsed = 40;
function $f9a1e11c81165c0a$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = $f9a1e11c81165c0a$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $6b19639ff75ae9c7$export$b995e5e85f5c8289)(flagRunNextFrame);
        return acc;
    }, {});
    const { read: read, resolveKeyframes: resolveKeyframes, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $2fe7e731675c3a42$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $f9a1e11c81165c0a$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $f9a1e11c81165c0a$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < $f9a1e11c81165c0a$export$71ecace0a033b35a.length; i++)steps[$f9a1e11c81165c0a$export$71ecace0a033b35a[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $10dd0c6adeec3fc8$export$bb76eed83315504c, cancel: $10dd0c6adeec3fc8$export$3252729004b8456e } = (0, $f9a1e11c81165c0a$export$510b0596a933801a)(queueMicrotask, false);


function $6b5ba073424e98cd$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}



var $4RFnf = parcelRequire("4RFnf");
/**
 * Internal, exported only for usage in Framer
 */ const $37266df23f37f7d4$export$da5f7b802957459a = (0, $4RFnf.createContext)({});


let $4d549596f18734ca$var$scheduleHandoffComplete = false;
function $4d549596f18734ca$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    const { visualElement: parent } = (0, $4RFnf.useContext)((0, $2b5e1f3d2bd5bb63$export$2285bbca2c666415));
    const lazyContext = (0, $4RFnf.useContext)((0, $046171cebbf4e6c8$export$40f10139ecf1f171));
    const presenceContext = (0, $4RFnf.useContext)((0, $33070f4719eb5d51$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $4RFnf.useContext)((0, $ef5f4beec67f2aae$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $4RFnf.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $4RFnf.useContext)((0, $37266df23f37f7d4$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $4d549596f18734ca$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    (0, $4RFnf.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const wantsHandoff = (0, $4RFnf.useRef)(Boolean(props[0, $df031e97d26f68b8$export$8592e1c077c890a6] && !window.HandoffComplete));
    (0, $a43a8f7089d31bc5$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        (0, $10dd0c6adeec3fc8$export$bb76eed83315504c).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $4RFnf.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            wantsHandoff.current = false;
            // This ensures all future calls to animateChanges() will run in useEffect
            if (!$4d549596f18734ca$var$scheduleHandoffComplete) {
                $4d549596f18734ca$var$scheduleHandoffComplete = true;
                queueMicrotask($4d549596f18734ca$var$completeHandoff);
            }
        }
    });
    return visualElement;
}
function $4d549596f18734ca$var$completeHandoff() {
    window.HandoffComplete = true;
}
function $4d549596f18734ca$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $4d549596f18734ca$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $6b5ba073424e98cd$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        scheduleRender: ()=>visualElement.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $4d549596f18734ca$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $4d549596f18734ca$var$getClosestProjectingNode(visualElement.parent);
}



var $4RFnf = parcelRequire("4RFnf");

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $6d0bb4d2ccf61e66$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $4RFnf.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $6b5ba073424e98cd$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $4RFnf = parcelRequire("4RFnf");

/**
 * Decides if the supplied variable is variant label
 */ function $fb2b5f30e3d4bd58$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $6de7b8f399463036$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}



const $cc43113dbc6ff27b$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $cc43113dbc6ff27b$export$1405a65085f40b9 = [
    "initial",
    ...$cc43113dbc6ff27b$export$16e45afcc206d3a8
];


function $76a579e54fd11ded$export$4b3c3bd8d910d78d(props) {
    return (0, $6de7b8f399463036$export$aa71198ceeaf53ce)(props.animate) || (0, $cc43113dbc6ff27b$export$1405a65085f40b9).some((name)=>(0, $fb2b5f30e3d4bd58$export$720b90e312cea233)(props[name]));
}
function $76a579e54fd11ded$export$ce46fa4165cdec40(props) {
    return Boolean($76a579e54fd11ded$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $1e6acd731a549f5e$export$12fc32fc096a04a3(props, context) {
    if ((0, $76a579e54fd11ded$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $fb2b5f30e3d4bd58$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $fb2b5f30e3d4bd58$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $71a9351d8c0f9fb1$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $1e6acd731a549f5e$export$12fc32fc096a04a3)(props, (0, $4RFnf.useContext)((0, $2b5e1f3d2bd5bb63$export$2285bbca2c666415)));
    return (0, $4RFnf.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $71a9351d8c0f9fb1$var$variantLabelsAsDependency(initial),
        $71a9351d8c0f9fb1$var$variantLabelsAsDependency(animate)
    ]);
}
function $71a9351d8c0f9fb1$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $5a0a8051c4f35b34$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $5a0a8051c4f35b34$export$65570e08d843624d = {};
for(const key in $5a0a8051c4f35b34$var$featureProps)$5a0a8051c4f35b34$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$5a0a8051c4f35b34$var$featureProps[key].some((name)=>!!props[name])
};


function $8a22383981c5eae9$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $5a0a8051c4f35b34$export$65570e08d843624d)[key] = {
        ...(0, $5a0a8051c4f35b34$export$65570e08d843624d)[key],
        ...features[key]
    };
}




var $4RFnf = parcelRequire("4RFnf");
const $2de44706e31e5789$export$a3579ca508007a95 = (0, $4RFnf.createContext)({});



const $8f6dbd7fc1728432$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");




/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $2cb52b0cccdc54dc$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $8a22383981c5eae9$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $4RFnf.useContext)((0, $ef5f4beec67f2aae$export$22a697fb29aac98d)),
            ...props,
            layoutId: $2cb52b0cccdc54dc$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $71a9351d8c0f9fb1$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $5794b0c359c0df2a$export$4e09c449d6c407f7)) {
            $2cb52b0cccdc54dc$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $2cb52b0cccdc54dc$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $4d549596f18734ca$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $e1117946e7cdcf39$exports.jsxs)((0, $2b5e1f3d2bd5bb63$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $e1117946e7cdcf39$exports.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $6d0bb4d2ccf61e66$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    const ForwardRefComponent = (0, $4RFnf.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $8f6dbd7fc1728432$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $2cb52b0cccdc54dc$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $4RFnf.useContext)((0, $2de44706e31e5789$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $2cb52b0cccdc54dc$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $4RFnf.useContext)((0, $046171cebbf4e6c8$export$40f10139ecf1f171)).strict;
}
function $2cb52b0cccdc54dc$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $5a0a8051c4f35b34$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $9d8e855a38cc3448$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $2cb52b0cccdc54dc$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $f4ff0cd227438508$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $f867a3460fb2aef6$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $f4ff0cd227438508$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}



var $4RFnf = parcelRequire("4RFnf");

var $4RFnf = parcelRequire("4RFnf");
const $41f30b85fcd25e73$export$91ddd985b97788d1 = {};
function $41f30b85fcd25e73$export$de9e7791c71225fd(correctors) {
    Object.assign($41f30b85fcd25e73$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $17110d08ed946c2c$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $17110d08ed946c2c$export$7b42a0094fb00b6e = new Set($17110d08ed946c2c$export$280dc01950909d86);


function $29fb33cbac1ecf16$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $17110d08ed946c2c$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $41f30b85fcd25e73$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $5bb9897aefac9639$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $fd33b87c502a2306$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $fd33b87c502a2306$var$numTransforms = (0, $17110d08ed946c2c$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $fd33b87c502a2306$export$bdc96e0d5c8f914(transform, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $fd33b87c502a2306$var$numTransforms; i++){
        const key = (0, $17110d08ed946c2c$export$280dc01950909d86)[i];
        if (transform[key] !== undefined) {
            const transformName = $fd33b87c502a2306$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}


const $63727cc16d554888$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $63727cc16d554888$export$9de1236619d9e756 = $63727cc16d554888$var$checkStringStartsWith("--");
const $63727cc16d554888$var$startsAsVariableToken = $63727cc16d554888$var$checkStringStartsWith("var(--");
const $63727cc16d554888$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $63727cc16d554888$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $63727cc16d554888$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $63727cc16d554888$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $4b9826b10c266110$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $425c0dd3dbc437ab$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $c9efb063f6075658$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $c9efb063f6075658$export$58f0f39f63f3cf42 = {
    ...$c9efb063f6075658$export$98e628dec113755e,
    transform: (v)=>(0, $425c0dd3dbc437ab$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $c9efb063f6075658$export$dcdf75081b88279d = {
    ...$c9efb063f6075658$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $8658b707f7e92ab3$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $8658b707f7e92ab3$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
const $8658b707f7e92ab3$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
const $8658b707f7e92ab3$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
function $8658b707f7e92ab3$export$844ec244b1367d54(v) {
    return typeof v === "string";
}
function $8658b707f7e92ab3$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $4bffd8618d4c58e8$var$createUnitType = (unit)=>({
        test: (v)=>(0, $8658b707f7e92ab3$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $4bffd8618d4c58e8$export$41fc368e1a942b97 = $4bffd8618d4c58e8$var$createUnitType("deg");
const $4bffd8618d4c58e8$export$626336c2cd4b14de = $4bffd8618d4c58e8$var$createUnitType("%");
const $4bffd8618d4c58e8$export$91c0eda1d06bf008 = $4bffd8618d4c58e8$var$createUnitType("px");
const $4bffd8618d4c58e8$export$f91e8c45a95a32f2 = $4bffd8618d4c58e8$var$createUnitType("vh");
const $4bffd8618d4c58e8$export$aed3d7b7d206c196 = $4bffd8618d4c58e8$var$createUnitType("vw");
const $4bffd8618d4c58e8$export$44e2e1705876d7ed = {
    ...$4bffd8618d4c58e8$export$626336c2cd4b14de,
    parse: (v)=>$4bffd8618d4c58e8$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$4bffd8618d4c58e8$export$626336c2cd4b14de.transform(v * 100)
};



const $ffa66b6f120c6801$export$7d260a2a5f8bc19e = {
    ...(0, $c9efb063f6075658$export$98e628dec113755e),
    transform: Math.round
};


const $b3a4c2a5fee28b04$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    borderTopWidth: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    borderRightWidth: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    borderRadius: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    radius: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    maxWidth: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    height: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    maxHeight: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    size: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    top: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    right: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    bottom: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    left: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    paddingTop: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    paddingRight: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    paddingBottom: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    paddingLeft: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    margin: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    marginTop: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    marginRight: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    marginBottom: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    marginLeft: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $4bffd8618d4c58e8$export$41fc368e1a942b97),
    rotateX: (0, $4bffd8618d4c58e8$export$41fc368e1a942b97),
    rotateY: (0, $4bffd8618d4c58e8$export$41fc368e1a942b97),
    rotateZ: (0, $4bffd8618d4c58e8$export$41fc368e1a942b97),
    scale: $c9efb063f6075658$export$dcdf75081b88279d,
    scaleX: (0, $c9efb063f6075658$export$dcdf75081b88279d),
    scaleY: (0, $c9efb063f6075658$export$dcdf75081b88279d),
    scaleZ: (0, $c9efb063f6075658$export$dcdf75081b88279d),
    skew: (0, $4bffd8618d4c58e8$export$41fc368e1a942b97),
    skewX: (0, $4bffd8618d4c58e8$export$41fc368e1a942b97),
    skewY: (0, $4bffd8618d4c58e8$export$41fc368e1a942b97),
    distance: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    translateX: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    translateY: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    translateZ: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    x: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    y: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    z: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    perspective: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    transformPerspective: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    opacity: (0, $c9efb063f6075658$export$58f0f39f63f3cf42),
    originX: (0, $4bffd8618d4c58e8$export$44e2e1705876d7ed),
    originY: (0, $4bffd8618d4c58e8$export$44e2e1705876d7ed),
    originZ: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $ffa66b6f120c6801$export$7d260a2a5f8bc19e),
    backgroundPositionX: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    // SVG
    fillOpacity: (0, $c9efb063f6075658$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $c9efb063f6075658$export$58f0f39f63f3cf42),
    numOctaves: (0, $ffa66b6f120c6801$export$7d260a2a5f8bc19e)
};


function $bb2ff539a6497bd3$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $63727cc16d554888$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $b3a4c2a5fee28b04$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $4b9826b10c266110$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $17110d08ed946c2c$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $fd33b87c502a2306$export$bdc96e0d5c8f914)(state.transform, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $e4cd2c6d0ce69070$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $929ac80712208d7c$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $5bb9897aefac9639$export$605d60a2578142d3)(source[key]) && !(0, $29fb33cbac1ecf16$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $929ac80712208d7c$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $4RFnf.useMemo)(()=>{
        const state = (0, $e4cd2c6d0ce69070$export$8940b483cf52eeda)();
        (0, $bb2ff539a6497bd3$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $929ac80712208d7c$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $929ac80712208d7c$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $929ac80712208d7c$var$useInitialMotionValues(props, visualState));
    return style;
}
function $929ac80712208d7c$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $929ac80712208d7c$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $a55e81fe15c42ece$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $a55e81fe15c42ece$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $a55e81fe15c42ece$var$validMotionProps.has(key);
}


let $6c11f3121eec2b22$var$shouldForward = (key)=>!(0, $a55e81fe15c42ece$export$2f9c46555243bf04)(key);
function $6c11f3121eec2b22$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $6c11f3121eec2b22$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $a55e81fe15c42ece$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $6c11f3121eec2b22$export$59d6962c470509a5($6c11f3121eec2b22$import$c6bce8c37c642938$2e2bcd8739ae039);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $6c11f3121eec2b22$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($6c11f3121eec2b22$var$shouldForward(key) || forwardMotionProps === true && (0, $a55e81fe15c42ece$export$2f9c46555243bf04)(key) || !isDom && !(0, $a55e81fe15c42ece$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $4RFnf = parcelRequire("4RFnf");



function $76c21f3f8f456ce0$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $76c21f3f8f456ce0$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $76c21f3f8f456ce0$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $76c21f3f8f456ce0$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $af1ff9d40e11cf7f$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $af1ff9d40e11cf7f$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $af1ff9d40e11cf7f$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $af1ff9d40e11cf7f$var$dashKeys : $af1ff9d40e11cf7f$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $141f6c79619d2142$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $bb2ff539a6497bd3$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $76c21f3f8f456ce0$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $af1ff9d40e11cf7f$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $c0a966449f99707b$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $e4cd2c6d0ce69070$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $e69de4800068261b$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $9789da8f3e687c4c$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $4RFnf.useMemo)(()=>{
        const state = (0, $c0a966449f99707b$export$41be8b43e1c4d4f9)();
        (0, $141f6c79619d2142$export$5475d24f125d7053)(state, visualState, (0, $e69de4800068261b$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $929ac80712208d7c$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $e687c8eab649fd83$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $f867a3460fb2aef6$export$88f3fc2fd3766989)(Component) ? (0, $9789da8f3e687c4c$export$84309c4f53cb1bd5) : (0, $929ac80712208d7c$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $6c11f3121eec2b22$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $4RFnf.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $4RFnf.useMemo)(()=>(0, $5bb9897aefac9639$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $4RFnf.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}



function $3ecf9aae399587e0$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $534092b423d71182$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $470552e8fe1b0157$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $3ecf9aae399587e0$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $534092b423d71182$export$28931db5d57958e5).has(key) ? (0, $9d19f5cf96f60af5$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $3bb8b534de1ab8f4$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $5bb9897aefac9639$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $5bb9897aefac9639$export$605d60a2578142d3)(prevProps.style[key]) || (0, $29fb33cbac1ecf16$export$6d27ce8e3de1c3cf)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    /**
     * If the willChange style has been manually set as a string, set
     * applyWillChange to false to prevent it from automatically being applied.
     */ if (visualElement && style && typeof style.willChange === "string") visualElement.applyWillChange = false;
    return newValues;
}



function $096669d855871313$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $3bb8b534de1ab8f4$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $5bb9897aefac9639$export$605d60a2578142d3)(props[key]) || (0, $5bb9897aefac9639$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $17110d08ed946c2c$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $4RFnf = parcelRequire("4RFnf");


function $ebca2401632df166$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $ebca2401632df166$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $ebca2401632df166$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $ebca2401632df166$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}



var $4RFnf = parcelRequire("4RFnf");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $bbfe989948ce7b0e$export$fe4300aa8eebea86(init) {
    const ref = (0, $4RFnf.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}


const $984866fe7468a54b$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $6ef756b90adb5bf1$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $6ef756b90adb5bf1$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $984866fe7468a54b$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $818473550fb5c068$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $5bb9897aefac9639$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $6ef756b90adb5bf1$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




/**
 * A list of values that can be hardware-accelerated.
 */ const $f2a36ae8e7a26884$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);




function $181035e7fe449def$export$b3f9dd865b560c6(name) {
    if ((0, $17110d08ed946c2c$export$7b42a0094fb00b6e).has(name)) return "transform";
    else if ((0, $f2a36ae8e7a26884$export$a27eefbd8fb5e404).has(name)) return (0, $9d19f5cf96f60af5$export$9fd24a634729c672)(name);
}


function $5c5fd901d02dc784$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $5c5fd901d02dc784$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $5c5fd901d02dc784$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


function $9d1ea57b959a61bc$var$makeState({ applyWillChange: applyWillChange = false, scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext, isStatic) {
    const state = {
        latestValues: $9d1ea57b959a61bc$var$makeLatestValues(props, context, presenceContext, isStatic ? false : applyWillChange, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $9d1ea57b959a61bc$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $4RFnf.useContext)((0, $2b5e1f3d2bd5bb63$export$2285bbca2c666415));
        const presenceContext = (0, $4RFnf.useContext)((0, $33070f4719eb5d51$export$f224e4635b6f8ce2));
        const make = ()=>$9d1ea57b959a61bc$var$makeState(config, props, context, presenceContext, isStatic);
        return isStatic ? make() : (0, $bbfe989948ce7b0e$export$fe4300aa8eebea86)(make);
    };
function $9d1ea57b959a61bc$var$addWillChange(willChange, name) {
    const memberName = (0, $181035e7fe449def$export$b3f9dd865b560c6)(name);
    if (memberName) (0, $5c5fd901d02dc784$export$20e507e47fae79fd)(willChange, memberName);
}
function $9d1ea57b959a61bc$var$forEachDefinition(props, definition, callback) {
    const list = Array.isArray(definition) ? definition : [
        definition
    ];
    for(let i = 0; i < list.length; i++){
        const resolved = (0, $ebca2401632df166$export$d68f140c4d9b48bc)(props, list[i]);
        if (resolved) {
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            callback(target, transitionEnd);
        }
    }
}
function $9d1ea57b959a61bc$var$makeLatestValues(props, context, presenceContext, shouldApplyWillChange, scrapeMotionValues) {
    var _a;
    const values = {};
    const willChange = [];
    const applyWillChange = shouldApplyWillChange && ((_a = props.style) === null || _a === void 0 ? void 0 : _a.willChange) === undefined;
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $818473550fb5c068$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $76a579e54fd11ded$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $76a579e54fd11ded$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $6de7b8f399463036$export$aa71198ceeaf53ce)(variantToSet)) $9d1ea57b959a61bc$var$forEachDefinition(props, variantToSet, (target, transitionEnd)=>{
        for(const key in target){
            let valueTarget = target[key];
            if (Array.isArray(valueTarget)) {
                /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                valueTarget = valueTarget[index];
            }
            if (valueTarget !== null) values[key] = valueTarget;
        }
        for(const key in transitionEnd)values[key] = transitionEnd[key];
    });
    // Add animating values to will-change
    if (applyWillChange) {
        if (animate && initial !== false && !(0, $6de7b8f399463036$export$aa71198ceeaf53ce)(animate)) $9d1ea57b959a61bc$var$forEachDefinition(props, animate, (target)=>{
            for(const key in target)$9d1ea57b959a61bc$var$addWillChange(willChange, key);
        });
        if (willChange.length) values.willChange = willChange.join(",");
    }
    return values;
}





const $d81aa8ade7f2f415$export$8793edee2d425525 = (any)=>any;



const { schedule: $073638039b5c3242$export$2cef06c20297c17d, cancel: $073638039b5c3242$export$ec99c0ef4978dccb, state: $073638039b5c3242$export$fff89137e9e818ce, steps: $073638039b5c3242$export$be3f796aed065412 } = (0, $f9a1e11c81165c0a$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $d81aa8ade7f2f415$export$8793edee2d425525), true);


const $ad4042e90ef9611a$export$44dabd3fae512e85 = {
    useVisualState: (0, $9d1ea57b959a61bc$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $096669d855871313$export$16da615486abaa45),
        createRenderState: (0, $c0a966449f99707b$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $073638039b5c3242$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $073638039b5c3242$export$2cef06c20297c17d).render(()=>{
                (0, $141f6c79619d2142$export$5475d24f125d7053)(renderState, latestValues, (0, $e69de4800068261b$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $470552e8fe1b0157$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $8b17683067dc33ef$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $9d1ea57b959a61bc$export$e91e107bc6d03a8e)({
        applyWillChange: true,
        scrapeMotionValuesFromProps: $3bb8b534de1ab8f4$export$16da615486abaa45,
        createRenderState: (0, $e4cd2c6d0ce69070$export$8940b483cf52eeda)
    })
};


function $d6c56f7e74dbe870$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $f867a3460fb2aef6$export$88f3fc2fd3766989)(Component) ? (0, $ad4042e90ef9611a$export$44dabd3fae512e85) : (0, $8b17683067dc33ef$export$e13ea21d87ea57c8);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $e687c8eab649fd83$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}


function $77e2c87f7317172d$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $0754deefc232711c$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $352f162696a87216$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[`${pointType}X`],
            y: event[`${pointType}Y`]
        }
    };
}
const $352f162696a87216$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $0754deefc232711c$export$a4cf9c8a4b063a6e)(event) && handler(event, $352f162696a87216$export$12f84bb882d06e1a(event));
};


function $0249e0418812713d$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $77e2c87f7317172d$export$b1d829ddf82884aa)(target, eventName, (0, $352f162696a87216$export$c404e80f92c98d29)(handler), options);
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $ef7ddc8200fa1246$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $ef7ddc8200fa1246$export$a4627e546088548d = (...transformers)=>transformers.reduce($ef7ddc8200fa1246$var$combineFunctions);


function $f802f932cf2cfb3d$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $f802f932cf2cfb3d$var$globalHorizontalLock = $f802f932cf2cfb3d$export$518c5fc2dcb7974b("dragHorizontal");
const $f802f932cf2cfb3d$var$globalVerticalLock = $f802f932cf2cfb3d$export$518c5fc2dcb7974b("dragVertical");
function $f802f932cf2cfb3d$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $f802f932cf2cfb3d$var$globalVerticalLock();
    else if (drag === "x") lock = $f802f932cf2cfb3d$var$globalHorizontalLock();
    else {
        const openHorizontal = $f802f932cf2cfb3d$var$globalHorizontalLock();
        const openVertical = $f802f932cf2cfb3d$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $f802f932cf2cfb3d$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $f802f932cf2cfb3d$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


class $eb8e3110567b1372$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}



function $6922ef6f005de1cb$var$addHoverEvent(node, isActive) {
    const eventName = isActive ? "pointerenter" : "pointerleave";
    const callbackName = isActive ? "onHoverStart" : "onHoverEnd";
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $f802f932cf2cfb3d$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        const callback = props[callbackName];
        if (callback) (0, $073638039b5c3242$export$2cef06c20297c17d).postRender(()=>callback(event, info));
    };
    return (0, $0249e0418812713d$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $6922ef6f005de1cb$export$93a81ea037eac456 extends (0, $eb8e3110567b1372$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $ef7ddc8200fa1246$export$a4627e546088548d)($6922ef6f005de1cb$var$addHoverEvent(this.node, true), $6922ef6f005de1cb$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $0eb79481ee574ab9$export$d4826db40d47595b extends (0, $eb8e3110567b1372$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $ef7ddc8200fa1246$export$a4627e546088548d)((0, $77e2c87f7317172d$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $77e2c87f7317172d$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $bdbb7717cd1ca0bd$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $bdbb7717cd1ca0bd$export$e841ada32ff745b(parent, child.parentElement);
};




function $d909611b2456935b$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $352f162696a87216$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $d909611b2456935b$export$f026abdbba7f0c9e extends (0, $eb8e3110567b1372$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $d81aa8ade7f2f415$export$8793edee2d425525);
        this.removeEndListeners = (0, $d81aa8ade7f2f415$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $d81aa8ade7f2f415$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                /**
                 * We only count this as a tap gesture if the event.target is the same
                 * as, or a child of, this component's element
                 */ const handler = !globalTapTarget && !(0, $bdbb7717cd1ca0bd$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel : onTap;
                if (handler) (0, $073638039b5c3242$export$2cef06c20297c17d).update(()=>handler(endEvent, endInfo));
            };
            const removePointerUpListener = (0, $0249e0418812713d$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $0249e0418812713d$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $ef7ddc8200fa1246$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $d909611b2456935b$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $073638039b5c3242$export$2cef06c20297c17d).postRender(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $77e2c87f7317172d$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $d909611b2456935b$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $77e2c87f7317172d$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $d909611b2456935b$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $77e2c87f7317172d$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $ef7ddc8200fa1246$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $073638039b5c3242$export$2cef06c20297c17d).postRender(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $f802f932cf2cfb3d$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $073638039b5c3242$export$2cef06c20297c17d).postRender(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $0249e0418812713d$export$fcff2e64e6676b81)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $77e2c87f7317172d$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $ef7ddc8200fa1246$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $6691a380ec8073ef$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $6691a380ec8073ef$var$observers = new WeakMap();
const $6691a380ec8073ef$var$fireObserverCallback = (entry)=>{
    const callback = $6691a380ec8073ef$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $6691a380ec8073ef$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($6691a380ec8073ef$var$fireObserverCallback);
};
function $6691a380ec8073ef$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$6691a380ec8073ef$var$observers.has(lookupRoot)) $6691a380ec8073ef$var$observers.set(lookupRoot, {});
    const rootObservers = $6691a380ec8073ef$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($6691a380ec8073ef$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $6691a380ec8073ef$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $6691a380ec8073ef$var$initIntersectionObserver(options);
    $6691a380ec8073ef$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $6691a380ec8073ef$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $16d57ecf081a35f6$var$thresholdNames = {
    some: 0,
    all: 1
};
class $16d57ecf081a35f6$export$150851c8cc2f0c72 extends (0, $eb8e3110567b1372$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $16d57ecf081a35f6$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $6691a380ec8073ef$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($16d57ecf081a35f6$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $16d57ecf081a35f6$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $cb98cd5a424f6ffb$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $16d57ecf081a35f6$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $d909611b2456935b$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $0eb79481ee574ab9$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $6922ef6f005de1cb$export$93a81ea037eac456)
    }
};





function $87a8e5322f11d485$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




function $b8ebc3db4383a2c6$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $ebca2401632df166$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}





/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $daff969e58919caf$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $daff969e58919caf$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;



const $7e9801037a423de8$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $7e9801037a423de8$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $7e9801037a423de8$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $7e9801037a423de8$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $7e9801037a423de8$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $7e9801037a423de8$var$keyframesTransition;
    else if ((0, $17110d08ed946c2c$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $7e9801037a423de8$var$criticallyDampedSpring(keyframes[1]) : $7e9801037a423de8$var$underDampedSpring;
    return $7e9801037a423de8$var$ease;
};


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $47d990dd221c18f3$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $47d990dd221c18f3$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $be70ac6d402ef836$export$888a3d84909f9e3d = {
    current: false
};


const $0ad09dba1569a4f5$var$isNotNull = (value)=>value !== null;
function $0ad09dba1569a4f5$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($0ad09dba1569a4f5$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}





let $c71752571d3222d1$var$now;
function $c71752571d3222d1$var$clearTime() {
    $c71752571d3222d1$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $c71752571d3222d1$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($c71752571d3222d1$var$now === undefined) $c71752571d3222d1$export$2da9be4cfdb689b1.set((0, $073638039b5c3242$export$fff89137e9e818ce).isProcessing || (0, $2fe7e731675c3a42$export$dd826089e3c5e502).useManualTiming ? (0, $073638039b5c3242$export$fff89137e9e818ce).timestamp : performance.now());
        return $c71752571d3222d1$var$now;
    },
    set: (newTime)=>{
        $c71752571d3222d1$var$now = newTime;
        queueMicrotask($c71752571d3222d1$var$clearTime);
    }
};


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $daa7605d61a2bd5a$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $063ee0675b796c8b$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $daa7605d61a2bd5a$export$ade84c85e44a6cb1)(value);
    else return true;
}



let $c1f8ad6ee5250104$export$491112666e282270 = (0, $d81aa8ade7f2f415$export$8793edee2d425525);
let $c1f8ad6ee5250104$export$f5708dca728d7177 = (0, $d81aa8ade7f2f415$export$8793edee2d425525);
var $c1f8ad6ee5250104$var$check, $c1f8ad6ee5250104$var$message, $c1f8ad6ee5250104$var$check1, $c1f8ad6ee5250104$var$message1;


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $baada50f8d446403$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);



/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $671b88ebe7fdf0e6$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $671b88ebe7fdf0e6$export$b9f0c1f373aee2b0(current) {
    const match = $671b88ebe7fdf0e6$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $671b88ebe7fdf0e6$var$maxDepth = 4;
function $671b88ebe7fdf0e6$export$289398774300c991(current, element, depth = 1) {
    (0, $c1f8ad6ee5250104$export$f5708dca728d7177)(depth <= $671b88ebe7fdf0e6$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $671b88ebe7fdf0e6$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $baada50f8d446403$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $63727cc16d554888$export$31f9caa2600b5723)(fallback) ? $671b88ebe7fdf0e6$export$289398774300c991(fallback, element, depth + 1) : fallback;
}






const $f19e6a62f83ab7da$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $f19e6a62f83ab7da$export$8e5250d1aa9bf370 = (v)=>v === (0, $c9efb063f6075658$export$98e628dec113755e) || v === (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008);
const $f19e6a62f83ab7da$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $f19e6a62f83ab7da$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $f19e6a62f83ab7da$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $f19e6a62f83ab7da$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $f19e6a62f83ab7da$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $f19e6a62f83ab7da$var$nonTranslationalTransformKeys = (0, $17110d08ed946c2c$export$280dc01950909d86).filter((key)=>!$f19e6a62f83ab7da$var$transformKeys.has(key));
function $f19e6a62f83ab7da$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $f19e6a62f83ab7da$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $f19e6a62f83ab7da$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $f19e6a62f83ab7da$var$getTranslateFromMatrix(4, 13),
    y: $f19e6a62f83ab7da$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$f19e6a62f83ab7da$export$781d46a8aa670d52.translateX = $f19e6a62f83ab7da$export$781d46a8aa670d52.x;
$f19e6a62f83ab7da$export$781d46a8aa670d52.translateY = $f19e6a62f83ab7da$export$781d46a8aa670d52.y;




/**
 * Tests a provided value against a ValueType
 */ const $74c0832e09926aa5$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $6174922bda336792$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $f8954ccb803929cf$export$d176691c1998a1f5 = [
    (0, $c9efb063f6075658$export$98e628dec113755e),
    (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008),
    (0, $4bffd8618d4c58e8$export$626336c2cd4b14de),
    (0, $4bffd8618d4c58e8$export$41fc368e1a942b97),
    (0, $4bffd8618d4c58e8$export$aed3d7b7d206c196),
    (0, $4bffd8618d4c58e8$export$f91e8c45a95a32f2),
    (0, $6174922bda336792$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $f8954ccb803929cf$export$eefdd52e3ccae428 = (v)=>$f8954ccb803929cf$export$d176691c1998a1f5.find((0, $74c0832e09926aa5$export$6eae4d0a6a7ca7cd)(v));




const $972382d27fdd3beb$var$toResolve = new Set();
let $972382d27fdd3beb$var$isScheduled = false;
let $972382d27fdd3beb$var$anyNeedsMeasurement = false;
function $972382d27fdd3beb$var$measureAllKeyframes() {
    if ($972382d27fdd3beb$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($972382d27fdd3beb$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $f19e6a62f83ab7da$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $972382d27fdd3beb$var$anyNeedsMeasurement = false;
    $972382d27fdd3beb$var$isScheduled = false;
    $972382d27fdd3beb$var$toResolve.forEach((resolver)=>resolver.complete());
    $972382d27fdd3beb$var$toResolve.clear();
}
function $972382d27fdd3beb$var$readAllKeyframes() {
    $972382d27fdd3beb$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $972382d27fdd3beb$var$anyNeedsMeasurement = true;
    });
}
function $972382d27fdd3beb$export$78b96d2a12593b05() {
    $972382d27fdd3beb$var$readAllKeyframes();
    $972382d27fdd3beb$var$measureAllKeyframes();
}
class $972382d27fdd3beb$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $972382d27fdd3beb$var$toResolve.add(this);
            if (!$972382d27fdd3beb$var$isScheduled) {
                $972382d27fdd3beb$var$isScheduled = true;
                (0, $073638039b5c3242$export$2cef06c20297c17d).read($972382d27fdd3beb$var$readAllKeyframes);
                (0, $073638039b5c3242$export$2cef06c20297c17d).resolveKeyframes($972382d27fdd3beb$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $972382d27fdd3beb$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $972382d27fdd3beb$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}







/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $1ae09ca233409ea4$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $8658b707f7e92ab3$export$844ec244b1367d54)(v) && (0, $8658b707f7e92ab3$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $8658b707f7e92ab3$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $1ae09ca233409ea4$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $8658b707f7e92ab3$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $8658b707f7e92ab3$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $5a098f609654e066$var$clampRgbUnit = (v)=>(0, $425c0dd3dbc437ab$export$7d15b64cf5a3a4c4)(0, 255, v);
const $5a098f609654e066$export$7a99c86b5b1f4c9e = {
    ...(0, $c9efb063f6075658$export$98e628dec113755e),
    transform: (v)=>Math.round($5a098f609654e066$var$clampRgbUnit(v))
};
const $5a098f609654e066$export$4e46ac54fc82cf3b = {
    test: (0, $1ae09ca233409ea4$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $1ae09ca233409ea4$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $5a098f609654e066$export$7a99c86b5b1f4c9e.transform(red) + ", " + $5a098f609654e066$export$7a99c86b5b1f4c9e.transform(green) + ", " + $5a098f609654e066$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $8658b707f7e92ab3$export$83d2e9e3e4ee39ed)((0, $c9efb063f6075658$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $6e255d2c4e68ad6d$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $6e255d2c4e68ad6d$export$834dfc94dde4b3d8 = {
    test: (0, $1ae09ca233409ea4$export$2c8400d58aca05e)("#"),
    parse: $6e255d2c4e68ad6d$var$parseHex,
    transform: (0, $5a098f609654e066$export$4e46ac54fc82cf3b).transform
};






const $ad7483922d99fcab$export$810b04175080204c = {
    test: (0, $1ae09ca233409ea4$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $1ae09ca233409ea4$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $4bffd8618d4c58e8$export$626336c2cd4b14de).transform((0, $8658b707f7e92ab3$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $4bffd8618d4c58e8$export$626336c2cd4b14de).transform((0, $8658b707f7e92ab3$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $8658b707f7e92ab3$export$83d2e9e3e4ee39ed)((0, $c9efb063f6075658$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $68474cc45903281c$export$35e9368ef982300f = {
    test: (v)=>(0, $5a098f609654e066$export$4e46ac54fc82cf3b).test(v) || (0, $6e255d2c4e68ad6d$export$834dfc94dde4b3d8).test(v) || (0, $ad7483922d99fcab$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $5a098f609654e066$export$4e46ac54fc82cf3b).test(v)) return (0, $5a098f609654e066$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $ad7483922d99fcab$export$810b04175080204c).test(v)) return (0, $ad7483922d99fcab$export$810b04175080204c).parse(v);
        else return (0, $6e255d2c4e68ad6d$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $8658b707f7e92ab3$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $5a098f609654e066$export$4e46ac54fc82cf3b).transform(v) : (0, $ad7483922d99fcab$export$810b04175080204c).transform(v);
    }
};



function $4a80ace3056a7432$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $8658b707f7e92ab3$export$844ec244b1367d54)(v) && (((_a = v.match((0, $8658b707f7e92ab3$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $8658b707f7e92ab3$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $4a80ace3056a7432$var$NUMBER_TOKEN = "number";
const $4a80ace3056a7432$var$COLOR_TOKEN = "color";
const $4a80ace3056a7432$var$VAR_TOKEN = "var";
const $4a80ace3056a7432$var$VAR_FUNCTION_TOKEN = "var(";
const $4a80ace3056a7432$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $4a80ace3056a7432$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $4a80ace3056a7432$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($4a80ace3056a7432$var$complexRegex, (parsedValue)=>{
        if ((0, $68474cc45903281c$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($4a80ace3056a7432$var$COLOR_TOKEN);
            values.push((0, $68474cc45903281c$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($4a80ace3056a7432$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($4a80ace3056a7432$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($4a80ace3056a7432$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $4a80ace3056a7432$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($4a80ace3056a7432$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $4a80ace3056a7432$var$parseComplexValue(v) {
    return $4a80ace3056a7432$export$b61fc7c44bf646d5(v).values;
}
function $4a80ace3056a7432$var$createTransformer(source) {
    const { split: split, types: types } = $4a80ace3056a7432$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $4a80ace3056a7432$var$NUMBER_TOKEN) output += (0, $8658b707f7e92ab3$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $4a80ace3056a7432$var$COLOR_TOKEN) output += (0, $68474cc45903281c$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $4a80ace3056a7432$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $4a80ace3056a7432$var$getAnimatableNone(v) {
    const parsed = $4a80ace3056a7432$var$parseComplexValue(v);
    const transformer = $4a80ace3056a7432$var$createTransformer(v);
    return transformer(parsed.map($4a80ace3056a7432$var$convertNumbersToZero));
}
const $4a80ace3056a7432$export$83a0e34f1302825b = {
    test: $4a80ace3056a7432$var$test,
    parse: $4a80ace3056a7432$var$parseComplexValue,
    createTransformer: $4a80ace3056a7432$var$createTransformer,
    getAnimatableNone: $4a80ace3056a7432$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $b1d70604b7d2d339$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $b1d70604b7d2d339$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $8658b707f7e92ab3$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $b1d70604b7d2d339$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $b1d70604b7d2d339$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $b1d70604b7d2d339$export$3dea766d36a8935f = {
    ...(0, $4a80ace3056a7432$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($b1d70604b7d2d339$var$functionRegex);
        return functions ? functions.map($b1d70604b7d2d339$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $2bc47ae9d01af1d2$export$98cd7c72c5a731fb = {
    ...(0, $b3a4c2a5fee28b04$export$eec14432cd1cb67b),
    color: // Color props
    $68474cc45903281c$export$35e9368ef982300f,
    backgroundColor: (0, $68474cc45903281c$export$35e9368ef982300f),
    outlineColor: (0, $68474cc45903281c$export$35e9368ef982300f),
    fill: (0, $68474cc45903281c$export$35e9368ef982300f),
    stroke: (0, $68474cc45903281c$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $68474cc45903281c$export$35e9368ef982300f),
    borderTopColor: (0, $68474cc45903281c$export$35e9368ef982300f),
    borderRightColor: (0, $68474cc45903281c$export$35e9368ef982300f),
    borderBottomColor: (0, $68474cc45903281c$export$35e9368ef982300f),
    borderLeftColor: (0, $68474cc45903281c$export$35e9368ef982300f),
    filter: $b1d70604b7d2d339$export$3dea766d36a8935f,
    WebkitFilter: (0, $b1d70604b7d2d339$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $2bc47ae9d01af1d2$export$67d1babe0338d23b = (key)=>$2bc47ae9d01af1d2$export$98cd7c72c5a731fb[key];


function $dace61e98ccf6cef$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $2bc47ae9d01af1d2$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $b1d70604b7d2d339$export$3dea766d36a8935f)) defaultValueType = (0, $4a80ace3056a7432$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $0ea15672fa7bfd55$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $0ea15672fa7bfd55$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$0ea15672fa7bfd55$var$invalidTemplates.has(keyframe) && (0, $4a80ace3056a7432$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $dace61e98ccf6cef$export$cea0cedcb94873b5)(name, animatableTemplate);
}


class $ca2a566b2b632029$export$4983792d11b61017 extends (0, $972382d27fdd3beb$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue){
        super(unresolvedKeyframes, onComplete, name, motionValue, motionValue === null || motionValue === void 0 ? void 0 : motionValue.owner, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $63727cc16d554888$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $671b88ebe7fdf0e6$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $f19e6a62f83ab7da$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $f8954ccb803929cf$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $f8954ccb803929cf$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $f19e6a62f83ab7da$export$8e5250d1aa9bf370)(originType) && (0, $f19e6a62f83ab7da$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $063ee0675b796c8b$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $0ea15672fa7bfd55$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $f19e6a62f83ab7da$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $f19e6a62f83ab7da$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}


function $0b06b616fbc4e9f8$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}








/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $9ba855df1eb2164b$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $4a80ace3056a7432$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $3d8a025b2dc1a260$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $3d8a025b2dc1a260$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $9ba855df1eb2164b$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $9ba855df1eb2164b$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $c1f8ad6ee5250104$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $3d8a025b2dc1a260$var$hasKeyframesChanged(keyframes) || type === "spring" && velocity;
}



class $299f2e68fd3817d6$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $972382d27fdd3beb$export$78b96d2a12593b05)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $3d8a025b2dc1a260$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $be70ac6d402ef836$export$888a3d84909f9e3d).current || !delay) {
                onUpdate === null || onUpdate === void 0 || onUpdate((0, $0ad09dba1569a4f5$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 || onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}




/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $e4611aae4c64b672$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $9953701bd41a41e3$var$velocitySampleDuration = 5; // ms
function $9953701bd41a41e3$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $9953701bd41a41e3$var$velocitySampleDuration, 0);
    return (0, $e4611aae4c64b672$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $9ab4484b18b039c9$var$safeMin = 0.001;
const $9ab4484b18b039c9$export$a3cdb76e84ee608e = 0.01;
const $9ab4484b18b039c9$export$1824b851fad8862b = 10.0;
const $9ab4484b18b039c9$export$ff08f2d53484465 = 0.05;
const $9ab4484b18b039c9$export$201ca48e54038115 = 1;
function $9ab4484b18b039c9$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $c1f8ad6ee5250104$export$491112666e282270)(duration <= (0, $daff969e58919caf$export$fc3e7e8557f8c8c7)($9ab4484b18b039c9$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $425c0dd3dbc437ab$export$7d15b64cf5a3a4c4)($9ab4484b18b039c9$export$ff08f2d53484465, $9ab4484b18b039c9$export$201ca48e54038115, dampingRatio);
    duration = (0, $425c0dd3dbc437ab$export$7d15b64cf5a3a4c4)($9ab4484b18b039c9$export$a3cdb76e84ee608e, $9ab4484b18b039c9$export$1824b851fad8862b, (0, $daff969e58919caf$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $9ab4484b18b039c9$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $9ab4484b18b039c9$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $9ab4484b18b039c9$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $9ab4484b18b039c9$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$9ab4484b18b039c9$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $9ab4484b18b039c9$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $daff969e58919caf$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $9ab4484b18b039c9$var$rootIterations = 12;
function $9ab4484b18b039c9$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $9ab4484b18b039c9$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $9ab4484b18b039c9$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $78f61a7cdfd43570$var$durationKeys = [
    "duration",
    "bounce"
];
const $78f61a7cdfd43570$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $78f61a7cdfd43570$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $78f61a7cdfd43570$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$78f61a7cdfd43570$var$isSpringType(options, $78f61a7cdfd43570$var$physicsKeys) && $78f61a7cdfd43570$var$isSpringType(options, $78f61a7cdfd43570$var$durationKeys)) {
        const derived = (0, $9ab4484b18b039c9$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $78f61a7cdfd43570$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $78f61a7cdfd43570$var$getSpringOptions({
        ...options,
        velocity: -(0, $daff969e58919caf$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $daff969e58919caf$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $9ab4484b18b039c9$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $9953701bd41a41e3$export$854187271d233eb5)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $7b0693f1987ef6cd$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $78f61a7cdfd43570$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $9953701bd41a41e3$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $d8855fe1d763b0e5$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $d8855fe1d763b0e5$var$subdivisionPrecision = 0.0000001;
const $d8855fe1d763b0e5$var$subdivisionMaxIterations = 12;
function $d8855fe1d763b0e5$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $d8855fe1d763b0e5$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $d8855fe1d763b0e5$var$subdivisionPrecision && ++i < $d8855fe1d763b0e5$var$subdivisionMaxIterations);
    return currentT;
}
function $d8855fe1d763b0e5$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $d81aa8ade7f2f415$export$8793edee2d425525;
    const getTForX = (aX)=>$d8855fe1d763b0e5$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $d8855fe1d763b0e5$var$calcBezier(getTForX(t), mY1, mY2);
}


const $2c2b180fb36062c9$export$929e5a82286172a6 = (0, $d8855fe1d763b0e5$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $2c2b180fb36062c9$export$57636bb43b1ccbb0 = (0, $d8855fe1d763b0e5$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $2c2b180fb36062c9$export$c07234257a03d5e9 = (0, $d8855fe1d763b0e5$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $4cd386f51b78fe9b$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $02e5ab9051eb90f8$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $8633bcf2078b6e5d$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $32662b3cf66eb88e$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $32662b3cf66eb88e$export$c8d67a19199d1a50 = (0, $8633bcf2078b6e5d$export$2c07eeff45156d4d)($32662b3cf66eb88e$export$e444123e42d03385);
const $32662b3cf66eb88e$export$30d3455eee55bed5 = (0, $02e5ab9051eb90f8$export$f946554fb8aeaf0d)($32662b3cf66eb88e$export$e444123e42d03385);





const $fbd64817bd6f3235$export$77edfce482316a60 = (0, $d8855fe1d763b0e5$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $fbd64817bd6f3235$export$b01116c84cdfe1a2 = (0, $8633bcf2078b6e5d$export$2c07eeff45156d4d)($fbd64817bd6f3235$export$77edfce482316a60);
const $fbd64817bd6f3235$export$ddc5fd596f6c71b2 = (0, $02e5ab9051eb90f8$export$f946554fb8aeaf0d)($fbd64817bd6f3235$export$b01116c84cdfe1a2);



const $996acb5905a5e962$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $fbd64817bd6f3235$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $e4abc4df248d528e$var$easingLookup = {
    linear: (0, $d81aa8ade7f2f415$export$8793edee2d425525),
    easeIn: $2c2b180fb36062c9$export$929e5a82286172a6,
    easeInOut: $2c2b180fb36062c9$export$c07234257a03d5e9,
    easeOut: $2c2b180fb36062c9$export$57636bb43b1ccbb0,
    circIn: $32662b3cf66eb88e$export$e444123e42d03385,
    circInOut: $32662b3cf66eb88e$export$30d3455eee55bed5,
    circOut: $32662b3cf66eb88e$export$c8d67a19199d1a50,
    backIn: $fbd64817bd6f3235$export$b01116c84cdfe1a2,
    backInOut: $fbd64817bd6f3235$export$ddc5fd596f6c71b2,
    backOut: $fbd64817bd6f3235$export$77edfce482316a60,
    anticipate: $996acb5905a5e962$export$6b0af63b873d419e
};
const $e4abc4df248d528e$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $c1f8ad6ee5250104$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $d8855fe1d763b0e5$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $c1f8ad6ee5250104$export$f5708dca728d7177)($e4abc4df248d528e$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $e4abc4df248d528e$var$easingLookup[definition];
    }
    return definition;
};





/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $dc74c92b58bc81d7$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $15debcaf5334b27a$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};




// Adapted from https://gist.github.com/mjackson/5311256
function $f88c1fd70256608c$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $f88c1fd70256608c$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $f88c1fd70256608c$var$hueToRgb(p, q, hue + 1 / 3);
        green = $f88c1fd70256608c$var$hueToRgb(p, q, hue);
        blue = $f88c1fd70256608c$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





function $d85fff2e18f77780$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}


// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $0bb5e4466ec364a1$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $0bb5e4466ec364a1$var$colorTypes = [
    (0, $6e255d2c4e68ad6d$export$834dfc94dde4b3d8),
    (0, $5a098f609654e066$export$4e46ac54fc82cf3b),
    (0, $ad7483922d99fcab$export$810b04175080204c)
];
const $0bb5e4466ec364a1$var$getColorType = (v)=>$0bb5e4466ec364a1$var$colorTypes.find((type)=>type.test(v));
function $0bb5e4466ec364a1$var$asRGBA(color) {
    const type = $0bb5e4466ec364a1$var$getColorType(color);
    (0, $c1f8ad6ee5250104$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $ad7483922d99fcab$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $f88c1fd70256608c$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $0bb5e4466ec364a1$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $0bb5e4466ec364a1$var$asRGBA(from);
    const toRGBA = $0bb5e4466ec364a1$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $d85fff2e18f77780$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $0bb5e4466ec364a1$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $0bb5e4466ec364a1$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $0bb5e4466ec364a1$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $5a098f609654e066$export$4e46ac54fc82cf3b).transform(blended);
    };
};







const $1259ca81b5b11804$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $1259ca81b5b11804$export$fed62ccc3fb1a568(origin, target) {
    if ($1259ca81b5b11804$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}



function $ef5b353f0971dc24$var$mixNumber(a, b) {
    return (p)=>(0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $ef5b353f0971dc24$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $ef5b353f0971dc24$var$mixNumber;
    else if (typeof a === "string") return (0, $63727cc16d554888$export$31f9caa2600b5723)(a) ? (0, $d85fff2e18f77780$export$a6f92d4bae65c0f1) : (0, $68474cc45903281c$export$35e9368ef982300f).test(a) ? (0, $0bb5e4466ec364a1$export$51e568cf5c039bac) : $ef5b353f0971dc24$export$65516310a87d8205;
    else if (Array.isArray(a)) return $ef5b353f0971dc24$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $68474cc45903281c$export$35e9368ef982300f).test(a) ? (0, $0bb5e4466ec364a1$export$51e568cf5c039bac) : $ef5b353f0971dc24$export$ebc23b6840c51ba1;
    return 0, $d85fff2e18f77780$export$a6f92d4bae65c0f1;
}
function $ef5b353f0971dc24$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$ef5b353f0971dc24$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $ef5b353f0971dc24$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $ef5b353f0971dc24$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $ef5b353f0971dc24$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $ef5b353f0971dc24$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $4a80ace3056a7432$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $4a80ace3056a7432$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $4a80ace3056a7432$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $1259ca81b5b11804$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $1259ca81b5b11804$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $1259ca81b5b11804$export$fed62ccc3fb1a568)(origin, target);
        return (0, $ef7ddc8200fa1246$export$a4627e546088548d)($ef5b353f0971dc24$export$3bbefa2f402845c4($ef5b353f0971dc24$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $c1f8ad6ee5250104$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $d85fff2e18f77780$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $0878fb2b3987e5e3$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $ef5b353f0971dc24$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}


function $f89041bb4869da80$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $0878fb2b3987e5e3$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $d81aa8ade7f2f415$export$8793edee2d425525) : ease;
            mixer = (0, $ef7ddc8200fa1246$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $f89041bb4869da80$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $c1f8ad6ee5250104$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && input[0] === input[1]) return ()=>output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $f89041bb4869da80$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $dc74c92b58bc81d7$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $425c0dd3dbc437ab$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $484826167cb76359$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $dc74c92b58bc81d7$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $a4f64f3329f8f842$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $484826167cb76359$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $a7bc7670b41ec6c7$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $f0c8d55e46cb0fea$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $2c2b180fb36062c9$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $f0c8d55e46cb0fea$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $4cd386f51b78fe9b$export$216948827bbdc797)(ease) ? ease.map((0, $e4abc4df248d528e$export$ef97fe084f156ca4)) : (0, $e4abc4df248d528e$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $a7bc7670b41ec6c7$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $a4f64f3329f8f842$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $f89041bb4869da80$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $f0c8d55e46cb0fea$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $907bb939dab744a4$export$f4ff70a5b4808fd8 = 20000;
function $907bb939dab744a4$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $907bb939dab744a4$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $907bb939dab744a4$export$f4ff70a5b4808fd8 ? Infinity : duration;
}







const $bf038126ceefdee3$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $073638039b5c3242$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $073638039b5c3242$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $073638039b5c3242$export$fff89137e9e818ce).isProcessing ? (0, $073638039b5c3242$export$fff89137e9e818ce).timestamp : (0, $c71752571d3222d1$export$2da9be4cfdb689b1).now()
    };
};



const $eee36e1fa991bbbb$var$generators = {
    decay: (0, $7b0693f1987ef6cd$export$ee3ff3a17106998),
    inertia: $7b0693f1987ef6cd$export$ee3ff3a17106998,
    tween: (0, $f0c8d55e46cb0fea$export$d25ddfdf17c3ad3e),
    keyframes: (0, $f0c8d55e46cb0fea$export$d25ddfdf17c3ad3e),
    spring: $78f61a7cdfd43570$export$b36281d89752ae66
};
const $eee36e1fa991bbbb$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $eee36e1fa991bbbb$export$fd98d9cca67a58bc extends (0, $299f2e68fd3817d6$export$d1e4f34b9c2550c1) {
    constructor({ KeyframeResolver: KeyframeResolver$1 = (0, $972382d27fdd3beb$export$74d34ca3182f1750), ...options }){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, keyframes: keyframes } = this.options;
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        if (name && motionValue && motionValue.owner) this.resolver = motionValue.owner.resolveKeyframes(keyframes, onResolved, name, motionValue);
        else this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = $eee36e1fa991bbbb$var$generators[type] || (0, $f0c8d55e46cb0fea$export$d25ddfdf17c3ad3e);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $f0c8d55e46cb0fea$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $ef7ddc8200fa1246$export$a4627e546088548d)($eee36e1fa991bbbb$var$percentToProgress, (0, $0878fb2b3987e5e3$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $907bb939dab744a4$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $425c0dd3dbc437ab$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $0ad09dba1569a4f5$export$14de59408fad90b)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $daff969e58919caf$export$f64c3bfbc58eec0f)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $daff969e58919caf$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $daff969e58919caf$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $daff969e58919caf$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $bf038126ceefdee3$export$c1033964b5ad7fef), onPlay: onPlay } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime || this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $eee36e1fa991bbbb$export$ee9b76de7353d815(options) {
    return new $eee36e1fa991bbbb$export$fd98d9cca67a58bc(options);
}



const $d20b1bc9b5c40b65$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $a342ef1079406d76$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && easing in $a342ef1079406d76$export$2cf569f5e2221176 || (0, $d20b1bc9b5c40b65$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($a342ef1079406d76$export$fcdd8f3f2160beda));
}
const $a342ef1079406d76$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $a342ef1079406d76$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $a342ef1079406d76$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $a342ef1079406d76$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $a342ef1079406d76$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $a342ef1079406d76$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $a342ef1079406d76$var$mapEasingToNativeEasingWithDefault(easing) {
    return $a342ef1079406d76$export$916ea73bcd3a6030(easing) || $a342ef1079406d76$export$2cf569f5e2221176.easeOut;
}
function $a342ef1079406d76$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    else if ((0, $d20b1bc9b5c40b65$export$ff43f99925d7366b)(easing)) return $a342ef1079406d76$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map($a342ef1079406d76$var$mapEasingToNativeEasingWithDefault);
    else return $a342ef1079406d76$export$2cf569f5e2221176[easing];
}


function $d735e3e3c270b6b6$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $a342ef1079406d76$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}




const $492190b44e1dee1c$var$supportsWaapi = (0, $0b06b616fbc4e9f8$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $492190b44e1dee1c$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $492190b44e1dee1c$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $492190b44e1dee1c$var$requiresPregeneratedKeyframes(options) {
    return options.type === "spring" || !(0, $a342ef1079406d76$export$fcdd8f3f2160beda)(options.ease);
}
function $492190b44e1dee1c$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $eee36e1fa991bbbb$export$fd98d9cca67a58bc)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $492190b44e1dee1c$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $492190b44e1dee1c$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $492190b44e1dee1c$var$sampleDelta,
        ease: "linear"
    };
}
class $492190b44e1dee1c$export$2a45abb4e6513325 extends (0, $299f2e68fd3817d6$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, keyframes: keyframes } = this.options;
        this.resolver = new (0, $ca2a566b2b632029$export$4983792d11b61017)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($492190b44e1dee1c$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, ...options } = this.options;
            const pregeneratedAnimation = $492190b44e1dee1c$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $d735e3e3c270b6b6$export$c76cd972d26986f9)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = (0, $c71752571d3222d1$export$2da9be4cfdb689b1).now();
        if (this.pendingTimeline) {
            animation.timeline = this.pendingTimeline;
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $0ad09dba1569a4f5$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $daff969e58919caf$export$f64c3bfbc58eec0f)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $daff969e58919caf$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $daff969e58919caf$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $d81aa8ade7f2f415$export$8793edee2d425525;
            const { animation: animation } = resolved;
            animation.timeline = timeline;
            animation.onfinish = null;
        }
        return 0, $d81aa8ade7f2f415$export$8793edee2d425525;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, ...options } = this.options;
            const sampleAnimation = new (0, $eee36e1fa991bbbb$export$fd98d9cca67a58bc)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $daff969e58919caf$export$fc3e7e8557f8c8c7)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $492190b44e1dee1c$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $492190b44e1dee1c$var$sampleDelta);
        }
        const { onStop: onStop } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        return $492190b44e1dee1c$var$supportsWaapi() && name && (0, $f2a36ae8e7a26884$export$a27eefbd8fb5e404).has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}




function $d877813a4a3404e6$export$b4f1bbab0c442a76(update, timeline) {
    let prevProgress;
    const onFrame = ()=>{
        const { currentTime: currentTime } = timeline;
        const percentage = currentTime === null ? 0 : currentTime.value;
        const progress = percentage / 100;
        if (prevProgress !== progress) update(progress);
        prevProgress = progress;
    };
    (0, $073638039b5c3242$export$2cef06c20297c17d).update(onFrame, true);
    return ()=>(0, $073638039b5c3242$export$ec99c0ef4978dccb)(onFrame);
}



const $cedc907cd49322a4$export$20d68f04f30763a5 = (0, $0b06b616fbc4e9f8$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);


class $5e8923456f90ca08$export$c1e41718f71efe41 {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline) {
        const cancelAll = this.animations.map((animation)=>{
            if ((0, $cedc907cd49322a4$export$20d68f04f30763a5)() && animation.attachTimeline) animation.attachTimeline(timeline);
            else {
                animation.pause();
                return (0, $d877813a4a3404e6$export$b4f1bbab0c442a76)((progress)=>{
                    animation.time = animation.duration * progress;
                }, timeline);
            }
        });
        return ()=>{
            cancelAll.forEach((cancelTimeline, i)=>{
                if (cancelTimeline) cancelTimeline();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}


const $b134bb1b8e4b9341$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff, /**
 * Currently used to remove values from will-change when an animation ends.
 * Preferably this would be handled by event listeners on the MotionValue
 * but these aren't consistent enough yet when considering the different ways
 * an animation can be cancelled.
 */ onEnd)=>(onComplete)=>{
        const valueTransition = (0, $47d990dd221c18f3$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $daff969e58919caf$export$fc3e7e8557f8c8c7)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
                onEnd && onEnd();
            },
            onStop: onEnd,
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $47d990dd221c18f3$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $7e9801037a423de8$export$262124b154b9f1c0)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $daff969e58919caf$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $daff969e58919caf$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $be70ac6d402ef836$export$888a3d84909f9e3d).current || (0, $2fe7e731675c3a42$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $0ad09dba1569a4f5$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $073638039b5c3242$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $5e8923456f90ca08$export$c1e41718f71efe41)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $492190b44e1dee1c$export$2a45abb4e6513325).supports(options)) return new (0, $492190b44e1dee1c$export$2a45abb4e6513325)(options);
        else return new (0, $eee36e1fa991bbbb$export$fd98d9cca67a58bc)(options);
    };




class $25152e99ef72a76d$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $5c5fd901d02dc784$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $5c5fd901d02dc784$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}






/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $4448ea3d1f333bf9$var$MAX_VELOCITY_DELTA = 30;
const $4448ea3d1f333bf9$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $4448ea3d1f333bf9$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $4448ea3d1f333bf9$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.3.6";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $c71752571d3222d1$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $c71752571d3222d1$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $4448ea3d1f333bf9$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $25152e99ef72a76d$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $073638039b5c3242$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($4448ea3d1f333bf9$export$67fcd818a264039d.current) $4448ea3d1f333bf9$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $c71752571d3222d1$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $4448ea3d1f333bf9$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $4448ea3d1f333bf9$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $e4611aae4c64b672$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $4448ea3d1f333bf9$export$ce8bdc721e76545f(init, options) {
    return new $4448ea3d1f333bf9$export$8cea36d14ee64562(init, options);
}



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $7eb8bf720ccae412$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $4448ea3d1f333bf9$export$ce8bdc721e76545f)(value));
}
function $7eb8bf720ccae412$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $b8ebc3db4383a2c6$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $6ef756b90adb5bf1$export$5485128c47bd48bb)(target[key]);
        $7eb8bf720ccae412$var$setMotionValue(visualElement, key, value);
    }
}




function $ad8903e341d31927$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.getProps()[0, $df031e97d26f68b8$export$8592e1c077c890a6];
}






class $21e9bdf71a411d44$export$3fe5fa490af65f85 extends (0, $4448ea3d1f333bf9$export$8cea36d14ee64562) {
    constructor(){
        super(...arguments);
        this.output = [];
        this.counts = new Map();
    }
    add(name) {
        const styleName = (0, $181035e7fe449def$export$b3f9dd865b560c6)(name);
        if (!styleName) return;
        /**
         * Update counter. Each value has an indepdent counter
         * as multiple sources could be requesting the same value
         * gets added to will-change.
         */ const prevCount = this.counts.get(styleName) || 0;
        this.counts.set(styleName, prevCount + 1);
        if (prevCount === 0) {
            this.output.push(styleName);
            this.update();
        }
        /**
         * Prevents the remove function from being called multiple times.
         */ let hasRemoved = false;
        return ()=>{
            if (hasRemoved) return;
            hasRemoved = true;
            const newCount = this.counts.get(styleName) - 1;
            this.counts.set(styleName, newCount);
            if (newCount === 0) {
                (0, $5c5fd901d02dc784$export$fe2d9b4e03920b4c)(this.output, styleName);
                this.update();
            }
        };
    }
    update() {
        this.set(this.output.length ? this.output.join(", ") : "auto");
    }
}
function $21e9bdf71a411d44$export$384afe146fc0c056() {
    return (0, $bbfe989948ce7b0e$export$fe4300aa8eebea86)(()=>new $21e9bdf71a411d44$export$3fe5fa490af65f85("auto"));
}



function $e313938ce597c753$export$98397f3adbf6259f(value) {
    return Boolean((0, $5bb9897aefac9639$export$605d60a2578142d3)(value) && value.add);
}


function $74ae58d3f5b35b52$export$3ac5aed310be0bee(visualElement, key) {
    var _a;
    if (!visualElement.applyWillChange) return;
    let willChange = visualElement.getValue("willChange");
    /**
     * If we haven't created a willChange MotionValue, and the we haven't been
     * manually provided one, create one.
     */ if (!willChange && !((_a = visualElement.props.style) === null || _a === void 0 ? void 0 : _a.willChange)) {
        willChange = new (0, $21e9bdf71a411d44$export$3fe5fa490af65f85)("auto");
        visualElement.addValue("willChange", willChange);
    }
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $e313938ce597c753$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $c4f6463525e634b3$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $c4f6463525e634b3$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $c4f6463525e634b3$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...(0, $47d990dd221c18f3$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.HandoffAppearAnimations) {
            const appearId = (0, $ad8903e341d31927$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $073638039b5c3242$export$2cef06c20297c17d));
                if (elapsed !== null) {
                    valueTransition.elapsed = elapsed;
                    isHandoff = true;
                }
            }
        }
        value.start((0, $b134bb1b8e4b9341$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $17110d08ed946c2c$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff, (0, $74ae58d3f5b35b52$export$3ac5aed310be0bee)(visualElement, key)));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $073638039b5c3242$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $7eb8bf720ccae412$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}




function $6d3995c96783b8b9$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $b8ebc3db4383a2c6$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $c4f6463525e634b3$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $6d3995c96783b8b9$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $6d3995c96783b8b9$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($6d3995c96783b8b9$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($6d3995c96783b8b9$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $6d3995c96783b8b9$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}



function $bfef505f1f3b948a$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $6d3995c96783b8b9$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $6d3995c96783b8b9$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $b8ebc3db4383a2c6$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $c4f6463525e634b3$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        (0, $073638039b5c3242$export$2cef06c20297c17d).postRender(()=>{
            visualElement.notify("AnimationComplete", definition);
        });
    });
}


const $ec8b1ae01cf402c0$var$reversePriorityOrder = [
    ...(0, $cc43113dbc6ff27b$export$16e45afcc206d3a8)
].reverse();
const $ec8b1ae01cf402c0$var$numAnimationTypes = (0, $cc43113dbc6ff27b$export$16e45afcc206d3a8).length;
function $ec8b1ae01cf402c0$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $bfef505f1f3b948a$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $ec8b1ae01cf402c0$export$bb53502b7a672aa8(visualElement) {
    let animate = $ec8b1ae01cf402c0$var$animateList(visualElement);
    let state = $ec8b1ae01cf402c0$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $b8ebc3db4383a2c6$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $ec8b1ae01cf402c0$var$numAnimationTypes; i++){
            const type = $ec8b1ae01cf402c0$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $fb2b5f30e3d4bd58$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $6de7b8f399463036$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $ec8b1ae01cf402c0$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $984866fe7468a54b$export$9153ad4c4999f4a0)(next) && (0, $984866fe7468a54b$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $87a8e5322f11d485$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             */ if (shouldAnimateType && (!isInherited || handledRemovedValues)) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $ec8b1ae01cf402c0$var$createState();
            isInitialRender = true;
        }
    };
}
function $ec8b1ae01cf402c0$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $87a8e5322f11d485$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $ec8b1ae01cf402c0$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $ec8b1ae01cf402c0$var$createState() {
    return {
        animate: $ec8b1ae01cf402c0$var$createTypeState(true),
        whileInView: $ec8b1ae01cf402c0$var$createTypeState(),
        whileHover: $ec8b1ae01cf402c0$var$createTypeState(),
        whileTap: $ec8b1ae01cf402c0$var$createTypeState(),
        whileDrag: $ec8b1ae01cf402c0$var$createTypeState(),
        whileFocus: $ec8b1ae01cf402c0$var$createTypeState(),
        exit: $ec8b1ae01cf402c0$var$createTypeState()
    };
}



class $f2a5eb3c79767bd8$export$b45b3fe5caabdca extends (0, $eb8e3110567b1372$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $ec8b1ae01cf402c0$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $6de7b8f399463036$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
}



let $1ee6d4ab4a7be431$var$id = 0;
class $1ee6d4ab4a7be431$export$4989d1eb6104cc6c extends (0, $eb8e3110567b1372$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $1ee6d4ab4a7be431$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $9aaae9da0b269148$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $f2a5eb3c79767bd8$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $1ee6d4ab4a7be431$export$4989d1eb6104cc6c)
    }
};









const $243d4ba06004d04f$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $243d4ba06004d04f$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $243d4ba06004d04f$export$9f17032d917177de(a.x, b.x);
    const yDelta = $243d4ba06004d04f$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $a96c951350c710a6$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $a96c951350c710a6$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $243d4ba06004d04f$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $073638039b5c3242$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $a96c951350c710a6$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $073638039b5c3242$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $a96c951350c710a6$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $a96c951350c710a6$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $0754deefc232711c$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $352f162696a87216$export$12f84bb882d06e1a)(event);
        const initialInfo = $a96c951350c710a6$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $073638039b5c3242$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $a96c951350c710a6$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $ef7ddc8200fa1246$export$a4627e546088548d)((0, $0249e0418812713d$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $0249e0418812713d$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $0249e0418812713d$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $073638039b5c3242$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $a96c951350c710a6$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $a96c951350c710a6$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $a96c951350c710a6$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $a96c951350c710a6$var$subtractPoint(point, $a96c951350c710a6$var$lastDevicePoint(history)),
        offset: $a96c951350c710a6$var$subtractPoint(point, $a96c951350c710a6$var$startDevicePoint(history)),
        velocity: $a96c951350c710a6$var$getVelocity(history, 0.1)
    };
}
function $a96c951350c710a6$var$startDevicePoint(history) {
    return history[0];
}
function $a96c951350c710a6$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $a96c951350c710a6$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $a96c951350c710a6$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $daff969e58919caf$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $daff969e58919caf$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







const $fbf8656879722a5e$var$SCALE_PRECISION = 0.0001;
const $fbf8656879722a5e$var$SCALE_MIN = 1 - $fbf8656879722a5e$var$SCALE_PRECISION;
const $fbf8656879722a5e$var$SCALE_MAX = 1 + $fbf8656879722a5e$var$SCALE_PRECISION;
const $fbf8656879722a5e$var$TRANSLATE_PRECISION = 0.01;
const $fbf8656879722a5e$var$TRANSLATE_MIN = 0 - $fbf8656879722a5e$var$TRANSLATE_PRECISION;
const $fbf8656879722a5e$var$TRANSLATE_MAX = 0 + $fbf8656879722a5e$var$TRANSLATE_PRECISION;
function $fbf8656879722a5e$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $fbf8656879722a5e$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $fbf8656879722a5e$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $fbf8656879722a5e$export$c1c127004b72a37(target) / $fbf8656879722a5e$export$c1c127004b72a37(source);
    delta.translate = (0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $fbf8656879722a5e$var$SCALE_MIN && delta.scale <= $fbf8656879722a5e$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1;
    if (delta.translate >= $fbf8656879722a5e$var$TRANSLATE_MIN && delta.translate <= $fbf8656879722a5e$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0;
}
function $fbf8656879722a5e$export$c0d25e96fc67d310(delta, source, target, origin) {
    $fbf8656879722a5e$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $fbf8656879722a5e$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $fbf8656879722a5e$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $fbf8656879722a5e$export$c1c127004b72a37(relative);
}
function $fbf8656879722a5e$export$426154f9d100f99(target, relative, parent) {
    $fbf8656879722a5e$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $fbf8656879722a5e$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $fbf8656879722a5e$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $fbf8656879722a5e$export$c1c127004b72a37(layout);
}
function $fbf8656879722a5e$export$2785bfcc929c5650(target, layout, parent) {
    $fbf8656879722a5e$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $fbf8656879722a5e$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $98bb42ec913936c2$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $98bb42ec913936c2$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $98bb42ec913936c2$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $98bb42ec913936c2$export$690c180aa5775042(layoutBox.x, left, right),
        y: $98bb42ec913936c2$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $98bb42ec913936c2$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $98bb42ec913936c2$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $98bb42ec913936c2$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $98bb42ec913936c2$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $98bb42ec913936c2$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $fbf8656879722a5e$export$c1c127004b72a37)(source);
    const targetLength = (0, $fbf8656879722a5e$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $dc74c92b58bc81d7$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $dc74c92b58bc81d7$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $425c0dd3dbc437ab$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $98bb42ec913936c2$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $98bb42ec913936c2$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $98bb42ec913936c2$export$7c5eaef8f4723d22(dragElastic = $98bb42ec913936c2$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $98bb42ec913936c2$export$a3366d3bac43a742;
    return {
        x: $98bb42ec913936c2$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $98bb42ec913936c2$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $98bb42ec913936c2$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $98bb42ec913936c2$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $98bb42ec913936c2$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $98bb42ec913936c2$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $b09b56b69fb45a2e$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $b09b56b69fb45a2e$export$3d227df54007d73a = ()=>({
        x: $b09b56b69fb45a2e$export$ff25708b37f72782(),
        y: $b09b56b69fb45a2e$export$ff25708b37f72782()
    });
const $b09b56b69fb45a2e$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $b09b56b69fb45a2e$export$6459fc9e86be362e = ()=>({
        x: $b09b56b69fb45a2e$export$6db76765312617ac(),
        y: $b09b56b69fb45a2e$export$6db76765312617ac()
    });


function $b328923997b880e2$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $52c3c04007ac61d0$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $52c3c04007ac61d0$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $52c3c04007ac61d0$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $cd7697370eec385d$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $cd7697370eec385d$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$cd7697370eec385d$var$isIdentityScale(scale) || !$cd7697370eec385d$var$isIdentityScale(scaleX) || !$cd7697370eec385d$var$isIdentityScale(scaleY);
}
function $cd7697370eec385d$export$a545127cf1fbb600(values) {
    return $cd7697370eec385d$export$bdf30dca883ea463(values) || $cd7697370eec385d$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $cd7697370eec385d$export$bf80f5f8f4dc327f(values) {
    return $cd7697370eec385d$var$is2DTranslate(values.x) || $cd7697370eec385d$var$is2DTranslate(values.y);
}
function $cd7697370eec385d$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $6cd9900eb68fa7b5$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $6cd9900eb68fa7b5$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $6cd9900eb68fa7b5$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $6cd9900eb68fa7b5$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $6cd9900eb68fa7b5$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $6cd9900eb68fa7b5$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $6cd9900eb68fa7b5$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $6cd9900eb68fa7b5$export$d80074982803af5c(box, { x: x, y: y }) {
    $6cd9900eb68fa7b5$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $6cd9900eb68fa7b5$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $6cd9900eb68fa7b5$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $6cd9900eb68fa7b5$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $6cd9900eb68fa7b5$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $cd7697370eec385d$export$a545127cf1fbb600)(node.latestValues)) $6cd9900eb68fa7b5$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $6cd9900eb68fa7b5$var$snapToDefault(treeScale.x);
    treeScale.y = $6cd9900eb68fa7b5$var$snapToDefault(treeScale.y);
}
function $6cd9900eb68fa7b5$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $6cd9900eb68fa7b5$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $6cd9900eb68fa7b5$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $6cd9900eb68fa7b5$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $6cd9900eb68fa7b5$export$58b16271041fbfb(box, transform) {
    $6cd9900eb68fa7b5$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $6cd9900eb68fa7b5$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $fd45c157b82e0231$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $52c3c04007ac61d0$export$d3955c6a8f65a36b)((0, $52c3c04007ac61d0$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $fd45c157b82e0231$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $fd45c157b82e0231$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $6cd9900eb68fa7b5$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $6cd9900eb68fa7b5$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/framer/motion/issues/2270
const $619c36f92ed2d250$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};




const $3ac618b544678fdd$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $3ac618b544678fdd$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $352f162696a87216$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            var _a;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $f802f932cf2cfb3d$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $b328923997b880e2$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $4bffd8618d4c58e8$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $fbf8656879722a5e$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $073638039b5c3242$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            (_a = this.removeWillChange) === null || _a === void 0 || _a.call(this);
            this.removeWillChange = (0, $74ae58d3f5b35b52$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $3ac618b544678fdd$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $b328923997b880e2$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $a96c951350c710a6$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $619c36f92ed2d250$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        var _a;
        (_a = this.removeWillChange) === null || _a === void 0 || _a.call(this);
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $073638039b5c3242$export$2cef06c20297c17d).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$3ac618b544678fdd$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $98bb42ec913936c2$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $6b5ba073424e98cd$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $98bb42ec913936c2$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $98bb42ec913936c2$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $b328923997b880e2$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $98bb42ec913936c2$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $6b5ba073424e98cd$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $c1f8ad6ee5250104$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $fd45c157b82e0231$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $98bb42ec913936c2$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $52c3c04007ac61d0$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $52c3c04007ac61d0$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $b328923997b880e2$export$b789de563eb43b1)((axis)=>{
            if (!$3ac618b544678fdd$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $b134bb1b8e4b9341$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false, (0, $74ae58d3f5b35b52$export$3ac5aed310be0bee)(this.visualElement, axis)));
    }
    stopAnimation() {
        (0, $b328923997b880e2$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $b328923997b880e2$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $b328923997b880e2$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$3ac618b544678fdd$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $6b5ba073424e98cd$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $b328923997b880e2$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $98bb42ec913936c2$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $b328923997b880e2$export$b789de563eb43b1)((axis)=>{
            if (!$3ac618b544678fdd$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $3ac618b544678fdd$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $0249e0418812713d$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $6b5ba073424e98cd$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $073638039b5c3242$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $77e2c87f7317172d$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $b328923997b880e2$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $98bb42ec913936c2$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $3ac618b544678fdd$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $3ac618b544678fdd$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $5797968f0551daae$export$5d97dc2872682820 extends (0, $eb8e3110567b1372$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $d81aa8ade7f2f415$export$8793edee2d425525);
        this.removeListeners = (0, $d81aa8ade7f2f415$export$8793edee2d425525);
        this.controls = new (0, $3ac618b544678fdd$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $d81aa8ade7f2f415$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $11464e390de2be0d$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $073638039b5c3242$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $11464e390de2be0d$export$b4f8f1ee75ce5859 extends (0, $eb8e3110567b1372$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $d81aa8ade7f2f415$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $a96c951350c710a6$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $619c36f92ed2d250$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $11464e390de2be0d$var$asyncHandler(onPanSessionStart),
            onStart: $11464e390de2be0d$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $073638039b5c3242$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $0249e0418812713d$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}




var $4RFnf = parcelRequire("4RFnf");

var $4RFnf = parcelRequire("4RFnf");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $d632bff0bbad0e32$export$2a8c16d82a0a0e26() {
    const context = (0, $4RFnf.useContext)((0, $33070f4719eb5d51$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $4RFnf.useId)();
    (0, $4RFnf.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $d632bff0bbad0e32$export$8249053f690ea39a() {
    return $d632bff0bbad0e32$export$ee27c052bca048fb((0, $4RFnf.useContext)((0, $33070f4719eb5d51$export$f224e4635b6f8ce2)));
}
function $d632bff0bbad0e32$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $8aa27fa37088906f$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $c4d275920599678f$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $c4d275920599678f$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $4bffd8618d4c58e8$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $c4d275920599678f$export$fafff692be55225d(latest, node.target.x);
        const y = $c4d275920599678f$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $835000cc4fd674da$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $4a80ace3056a7432$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $4a80ace3056a7432$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};





class $370ac8a012d5732d$var$MeasureLayoutWithContext extends (0, $4RFnf.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $41f30b85fcd25e73$export$de9e7791c71225fd)($370ac8a012d5732d$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $8aa27fa37088906f$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $073638039b5c3242$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $10dd0c6adeec3fc8$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $370ac8a012d5732d$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $d632bff0bbad0e32$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $4RFnf.useContext)((0, $2de44706e31e5789$export$a3579ca508007a95));
    return (0, $e1117946e7cdcf39$exports.jsx)($370ac8a012d5732d$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $4RFnf.useContext)((0, $37266df23f37f7d4$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $370ac8a012d5732d$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $c4d275920599678f$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $c4d275920599678f$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $c4d275920599678f$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $c4d275920599678f$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $c4d275920599678f$export$5eafb6257a5844c),
    boxShadow: (0, $835000cc4fd674da$export$eb0bc629e74dcf8)
};








const $b8b8ef99307b7dfb$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $b8b8ef99307b7dfb$var$numBorders = $b8b8ef99307b7dfb$var$borders.length;
const $b8b8ef99307b7dfb$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $b8b8ef99307b7dfb$var$isPx = (value)=>typeof value === "number" || (0, $4bffd8618d4c58e8$export$91c0eda1d06bf008).test(value);
function $b8b8ef99307b7dfb$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $b8b8ef99307b7dfb$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, 0, $b8b8ef99307b7dfb$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $b8b8ef99307b7dfb$var$numBorders; i++){
        const borderLabel = `border${$b8b8ef99307b7dfb$var$borders[i]}Radius`;
        let followRadius = $b8b8ef99307b7dfb$var$getRadius(follow, borderLabel);
        let leadRadius = $b8b8ef99307b7dfb$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $b8b8ef99307b7dfb$var$isPx(followRadius) === $b8b8ef99307b7dfb$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)($b8b8ef99307b7dfb$var$asNumber(followRadius), $b8b8ef99307b7dfb$var$asNumber(leadRadius), progress), 0);
            if ((0, $4bffd8618d4c58e8$export$626336c2cd4b14de).test(leadRadius) || (0, $4bffd8618d4c58e8$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $b8b8ef99307b7dfb$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $b8b8ef99307b7dfb$var$easeCrossfadeIn = $b8b8ef99307b7dfb$var$compress(0, 0.5, (0, $32662b3cf66eb88e$export$c8d67a19199d1a50));
const $b8b8ef99307b7dfb$var$easeCrossfadeOut = $b8b8ef99307b7dfb$var$compress(0.5, 0.95, (0, $d81aa8ade7f2f415$export$8793edee2d425525));
function $b8b8ef99307b7dfb$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $dc74c92b58bc81d7$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $6012b031071d0197$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $6012b031071d0197$export$c53fd88f45d77e4b(box, originBox) {
    $6012b031071d0197$export$a0230ae482601ae8(box.x, originBox.x);
    $6012b031071d0197$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $052337095e55c9d7$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $6cd9900eb68fa7b5$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $6cd9900eb68fa7b5$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $052337095e55c9d7$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $4bffd8618d4c58e8$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $052337095e55c9d7$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $052337095e55c9d7$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $052337095e55c9d7$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $052337095e55c9d7$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $052337095e55c9d7$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $052337095e55c9d7$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $052337095e55c9d7$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $052337095e55c9d7$export$42b76f1d0d16d5b(box.x, transforms, $052337095e55c9d7$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $052337095e55c9d7$export$42b76f1d0d16d5b(box.y, transforms, $052337095e55c9d7$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}





function $356b7218a819f537$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $356b7218a819f537$export$a7ec7642fe550fb6(delta) {
    return $356b7218a819f537$var$isAxisDeltaZero(delta.x) && $356b7218a819f537$var$isAxisDeltaZero(delta.y);
}
function $356b7218a819f537$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $356b7218a819f537$export$ef641b782d85522(a, b) {
    return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function $356b7218a819f537$export$c5706146bc63213(box) {
    return (0, $fbf8656879722a5e$export$c1c127004b72a37)(box.x) / (0, $fbf8656879722a5e$export$c1c127004b72a37)(box.y);
}



class $cc70679c2b0a68c5$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $5c5fd901d02dc784$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $5c5fd901d02dc784$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $aac13bd7ac0878d9$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $be5918dc4ca5c398$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $557b65fe81ce40e5$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $5c5fd901d02dc784$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $5c5fd901d02dc784$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $be5918dc4ca5c398$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}






/**
 * Timeout defined in ms
 */ function $60b54120d33b237f$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $c71752571d3222d1$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $073638039b5c3242$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $073638039b5c3242$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $073638039b5c3242$export$ec99c0ef4978dccb)(checkElapsed);
}



function $3d9eb15adb0b4324$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}


function $4a8eda27b575cfcb$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $2938f13b80cc579c$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $5bb9897aefac9639$export$605d60a2578142d3)(value) ? value : (0, $4448ea3d1f333bf9$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $b134bb1b8e4b9341$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}








const $1a5f10f811306b92$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $1a5f10f811306b92$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $1a5f10f811306b92$var$animationTarget = 1000;
let $1a5f10f811306b92$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const $1a5f10f811306b92$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $1a5f10f811306b92$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $1a5f10f811306b92$var$isOptimisedAppearTree(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return false;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return false;
    else if ((0, $ad8903e341d31927$export$5f8d21e84d1d84fc)(visualElement)) return true;
    else if (projectionNode.parent && !projectionNode.parent.hasCheckedOptimisedAppear) return $1a5f10f811306b92$var$isOptimisedAppearTree(projectionNode.parent);
    else return false;
}
function $1a5f10f811306b92$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $1a5f10f811306b92$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $1a5f10f811306b92$var$projectionFrameData.totalNodes = $1a5f10f811306b92$var$projectionFrameData.resolvedTargetDeltas = $1a5f10f811306b92$var$projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach($1a5f10f811306b92$export$131f2f0cc5fe9609);
                this.nodes.forEach($1a5f10f811306b92$var$resolveTargetDelta);
                this.nodes.forEach($1a5f10f811306b92$var$calcProjection);
                this.nodes.forEach($1a5f10f811306b92$export$c2664f37bc951031);
                (0, $3d9eb15adb0b4324$export$e5185e241753e543)($1a5f10f811306b92$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $557b65fe81ce40e5$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $25152e99ef72a76d$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $4a8eda27b575cfcb$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $60b54120d33b237f$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $8aa27fa37088906f$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $8aa27fa37088906f$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($1a5f10f811306b92$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $1a5f10f811306b92$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $356b7218a819f537$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $47d990dd221c18f3$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $1a5f10f811306b92$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $073638039b5c3242$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($1a5f10f811306b92$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.HandoffCancelAllAnimations && $1a5f10f811306b92$var$isOptimisedAppearTree(this)) window.HandoffCancelAllAnimations();
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($1a5f10f811306b92$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($1a5f10f811306b92$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($1a5f10f811306b92$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($1a5f10f811306b92$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($1a5f10f811306b92$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $c71752571d3222d1$export$2da9be4cfdb689b1).now();
            (0, $073638039b5c3242$export$fff89137e9e818ce).delta = (0, $425c0dd3dbc437ab$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $073638039b5c3242$export$fff89137e9e818ce).timestamp);
            (0, $073638039b5c3242$export$fff89137e9e818ce).timestamp = now;
            (0, $073638039b5c3242$export$fff89137e9e818ce).isProcessing = true;
            (0, $073638039b5c3242$export$be3f796aed065412).update.process((0, $073638039b5c3242$export$fff89137e9e818ce));
            (0, $073638039b5c3242$export$be3f796aed065412).preRender.process((0, $073638039b5c3242$export$fff89137e9e818ce));
            (0, $073638039b5c3242$export$be3f796aed065412).render.process((0, $073638039b5c3242$export$fff89137e9e818ce));
            (0, $073638039b5c3242$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $10dd0c6adeec3fc8$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($1a5f10f811306b92$var$clearSnapshot);
            this.sharedNodes.forEach($1a5f10f811306b92$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $073638039b5c3242$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $073638039b5c3242$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $356b7218a819f537$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $cd7697370eec385d$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $1a5f10f811306b92$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $6cd9900eb68fa7b5$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                (0, $6cd9900eb68fa7b5$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
            (0, $6012b031071d0197$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $6012b031071d0197$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $6cd9900eb68fa7b5$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $6cd9900eb68fa7b5$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $6cd9900eb68fa7b5$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $6cd9900eb68fa7b5$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
            (0, $6012b031071d0197$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $6cd9900eb68fa7b5$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $cd7697370eec385d$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $6cd9900eb68fa7b5$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $cd7697370eec385d$export$a545127cf1fbb600)(this.latestValues)) (0, $6cd9900eb68fa7b5$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
            (0, $6012b031071d0197$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $cd7697370eec385d$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $cd7697370eec385d$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $6012b031071d0197$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $052337095e55c9d7$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $cd7697370eec385d$export$a545127cf1fbb600)(this.latestValues)) (0, $052337095e55c9d7$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $073638039b5c3242$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $073638039b5c3242$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
                    (0, $fbf8656879722a5e$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $6012b031071d0197$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $fbf8656879722a5e$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $6012b031071d0197$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $6cd9900eb68fa7b5$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $6012b031071d0197$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
                    (0, $fbf8656879722a5e$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $6012b031071d0197$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ $1a5f10f811306b92$var$projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $cd7697370eec385d$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $cd7697370eec385d$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $073638039b5c3242$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $6012b031071d0197$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $6cd9900eb68fa7b5$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                    this.projectionDelta = (0, $b09b56b69fb45a2e$export$3d227df54007d73a)();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $b09b56b69fb45a2e$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $b09b56b69fb45a2e$export$3d227df54007d73a)();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $fbf8656879722a5e$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $aac13bd7ac0878d9$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ $1a5f10f811306b92$var$projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $b09b56b69fb45a2e$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($1a5f10f811306b92$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $1a5f10f811306b92$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $1a5f10f811306b92$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $fbf8656879722a5e$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $1a5f10f811306b92$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $356b7218a819f537$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
                    (0, $6012b031071d0197$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $b8b8ef99307b7dfb$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $073638039b5c3242$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $073638039b5c3242$export$2cef06c20297c17d).update(()=>{
                (0, $8aa27fa37088906f$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $2938f13b80cc579c$export$335a17c977067b99)(0, $1a5f10f811306b92$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($1a5f10f811306b92$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $1a5f10f811306b92$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
                const xLength = (0, $fbf8656879722a5e$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $fbf8656879722a5e$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $6012b031071d0197$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $6cd9900eb68fa7b5$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $fbf8656879722a5e$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $cc70679c2b0a68c5$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $1a5f10f811306b92$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $1a5f10f811306b92$var$transformAxes.length; i++){
                $1a5f10f811306b92$var$resetDistortingTransform(`rotate${$1a5f10f811306b92$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $1a5f10f811306b92$var$resetDistortingTransform(`skew${$1a5f10f811306b92$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $1a5f10f811306b92$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $818473550fb5c068$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $818473550fb5c068$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $cd7697370eec385d$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $aac13bd7ac0878d9$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $41f30b85fcd25e73$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $41f30b85fcd25e73$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $818473550fb5c068$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($1a5f10f811306b92$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $1a5f10f811306b92$var$updateLayout(node) {
    node.updateLayout();
}
function $1a5f10f811306b92$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $b328923997b880e2$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $fbf8656879722a5e$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($1a5f10f811306b92$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $b328923997b880e2$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $fbf8656879722a5e$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $b09b56b69fb45a2e$export$3d227df54007d73a)();
        (0, $fbf8656879722a5e$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $b09b56b69fb45a2e$export$3d227df54007d73a)();
        if (isShared) (0, $fbf8656879722a5e$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $fbf8656879722a5e$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $356b7218a819f537$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
                    (0, $fbf8656879722a5e$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
                    (0, $fbf8656879722a5e$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $356b7218a819f537$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $1a5f10f811306b92$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $1a5f10f811306b92$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $1a5f10f811306b92$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $1a5f10f811306b92$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $1a5f10f811306b92$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $1a5f10f811306b92$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $1a5f10f811306b92$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $1a5f10f811306b92$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $1a5f10f811306b92$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $1a5f10f811306b92$var$calcProjection(node) {
    node.calcProjection();
}
function $1a5f10f811306b92$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $1a5f10f811306b92$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $1a5f10f811306b92$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $1a5f10f811306b92$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $15debcaf5334b27a$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $1a5f10f811306b92$export$6ffd3e6ae339a132(output, from, to, p) {
    $1a5f10f811306b92$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $1a5f10f811306b92$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $1a5f10f811306b92$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $1a5f10f811306b92$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $1a5f10f811306b92$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $1a5f10f811306b92$var$roundPoint = $1a5f10f811306b92$var$userAgentContains("applewebkit/") && !$1a5f10f811306b92$var$userAgentContains("chrome/") ? Math.round : (0, $d81aa8ade7f2f415$export$8793edee2d425525);
function $1a5f10f811306b92$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $1a5f10f811306b92$var$roundPoint(axis.min);
    axis.max = $1a5f10f811306b92$var$roundPoint(axis.max);
}
function $1a5f10f811306b92$var$roundBox(box) {
    $1a5f10f811306b92$var$roundAxis(box.x);
    $1a5f10f811306b92$var$roundAxis(box.y);
}
function $1a5f10f811306b92$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $fbf8656879722a5e$export$28d0384c4b79bde2)((0, $356b7218a819f537$export$c5706146bc63213)(snapshot), (0, $356b7218a819f537$export$c5706146bc63213)(layout), 0.2);
}




const $355591a4cde6cb1c$export$2d029a49a09b6177 = (0, $1a5f10f811306b92$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $77e2c87f7317172d$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $ba7872bc9d278845$export$b91509fcf893b648 = {
    current: undefined
};
const $ba7872bc9d278845$export$b61a9eb3dbde8858 = (0, $1a5f10f811306b92$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$ba7872bc9d278845$export$b91509fcf893b648.current) {
            const documentNode = new (0, $355591a4cde6cb1c$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $ba7872bc9d278845$export$b91509fcf893b648.current = documentNode;
        }
        return $ba7872bc9d278845$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $111e6a15a4275ca3$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $11464e390de2be0d$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $5797968f0551daae$export$5d97dc2872682820),
        ProjectionNode: (0, $ba7872bc9d278845$export$b61a9eb3dbde8858),
        MeasureLayout: $370ac8a012d5732d$export$779f5fb01ad751cd
    }
};



var $4RFnf = parcelRequire("4RFnf");









// Does this device prefer reduced motion? Returns `null` server-side.
const $bb31c45a6f3715cb$export$ff7706047246b98b = {
    current: null
};
const $bb31c45a6f3715cb$export$6476d16e2fd2d0db = {
    current: false
};


function $ad2f41dcb12ec678$export$ca9f41fb23dded3d() {
    (0, $bb31c45a6f3715cb$export$6476d16e2fd2d0db).current = true;
    if (!(0, $5794b0c359c0df2a$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $bb31c45a6f3715cb$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $bb31c45a6f3715cb$export$ff7706047246b98b).current = false;
}












function $c0d5e9da87b63ca5$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $5bb9897aefac9639$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $5bb9897aefac9639$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $4448ea3d1f333bf9$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $4448ea3d1f333bf9$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $5692ab780c90094f$export$bc2a978a17abfdde = new WeakMap();









/**
 * A list of all ValueTypes
 */ const $7b8e5bc402f18ad5$var$valueTypes = [
    ...(0, $f8954ccb803929cf$export$d176691c1998a1f5),
    (0, $68474cc45903281c$export$35e9368ef982300f),
    (0, $4a80ace3056a7432$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $7b8e5bc402f18ad5$export$950e7e59ea1ffed7 = (v)=>$7b8e5bc402f18ad5$var$valueTypes.find((0, $74c0832e09926aa5$export$6eae4d0a6a7ca7cd)(v));





const $adc4c987989bb6aa$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $adc4c987989bb6aa$var$numVariantProps = (0, $cc43113dbc6ff27b$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $adc4c987989bb6aa$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * If true, will-change will be applied to the element. Only HTMLVisualElements
         * currently support this.
         */ this.applyWillChange = false;
        this.resolveKeyframes = (keyframes, // We use an onComplete callback here rather than a Promise as a Promise
        // resolution is a microtask and we want to retain the ability to force
        // the resolution of keyframes synchronously.
        onComplete, name, value)=>{
            return new this.KeyframeResolver(keyframes, onComplete, name, value, this);
        };
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $972382d27fdd3beb$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $073638039b5c3242$export$2cef06c20297c17d).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $76a579e54fd11ded$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $76a579e54fd11ded$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $5bb9897aefac9639$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $5692ab780c90094f$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $bb31c45a6f3715cb$export$6476d16e2fd2d0db).current) (0, $ad2f41dcb12ec678$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $bb31c45a6f3715cb$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $5692ab780c90094f$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $073638039b5c3242$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $073638039b5c3242$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $17110d08ed946c2c$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $073638039b5c3242$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $5a0a8051c4f35b34$export$65570e08d843624d){
            const featureDefinition = (0, $5a0a8051c4f35b34$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $adc4c987989bb6aa$var$propEventHandlers.length; i++){
            const key = $adc4c987989bb6aa$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $c0d5e9da87b63ca5$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $adc4c987989bb6aa$var$numVariantProps; i++){
            const name = (0, $cc43113dbc6ff27b$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $fb2b5f30e3d4bd58$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $4448ea3d1f333bf9$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $baada50f8d446403$export$65583ed5a868f2d9)(value) || (0, $daa7605d61a2bd5a$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $7b8e5bc402f18ad5$export$950e7e59ea1ffed7)(value) && (0, $4a80ace3056a7432$export$83a0e34f1302825b).test(target)) value = (0, $dace61e98ccf6cef$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $5bb9897aefac9639$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $5bb9897aefac9639$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $ebca2401632df166$export$d68f140c4d9b48bc)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $5bb9897aefac9639$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $25152e99ef72a76d$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}



class $ac6f4802411cfd4a$export$e49735c2a366bdc7 extends (0, $adc4c987989bb6aa$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $ca2a566b2b632029$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
}



function $9737f2a37c9863dd$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $9737f2a37c9863dd$export$23fea75b03ac16b3 extends (0, $ac6f4802411cfd4a$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.applyWillChange = true;
    }
    readValueFromInstance(instance, key) {
        if ((0, $17110d08ed946c2c$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $2bc47ae9d01af1d2$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $9737f2a37c9863dd$export$3735103072e4a80(instance);
            const value = ((0, $63727cc16d554888$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $fd45c157b82e0231$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $bb2ff539a6497bd3$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $3bb8b534de1ab8f4$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $5bb9897aefac9639$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $3ecf9aae399587e0$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}












class $c06cda96db12d24d$export$86bcdffbaf733d84 extends (0, $ac6f4802411cfd4a$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $17110d08ed946c2c$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $2bc47ae9d01af1d2$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $534092b423d71182$export$28931db5d57958e5).has(key) ? (0, $9d19f5cf96f60af5$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $b09b56b69fb45a2e$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $096669d855871313$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $141f6c79619d2142$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $470552e8fe1b0157$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $e69de4800068261b$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $3f34675d01ef4842$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $f867a3460fb2aef6$export$88f3fc2fd3766989)(Component) ? new (0, $c06cda96db12d24d$export$86bcdffbaf733d84)(options) : new (0, $9737f2a37c9863dd$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $4RFnf.Fragment)
    });
};




const $ee379c5f20422af9$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $ba7872bc9d278845$export$b61a9eb3dbde8858),
        MeasureLayout: $370ac8a012d5732d$export$779f5fb01ad751cd
    }
};


const $749ba68a8b02b1b2$var$preloadedFeatures = {
    ...(0, $9aaae9da0b269148$export$7f9953c70dacfd7f),
    ...(0, $cb98cd5a424f6ffb$export$e5b72898e5a201f1),
    ...(0, $111e6a15a4275ca3$export$d7d5d435647ed5a0),
    ...(0, $ee379c5f20422af9$export$b3219800bda33a1f)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $749ba68a8b02b1b2$export$e25e478948902b8b = /*@__PURE__*/ (0, $9d8e855a38cc3448$export$a28d6df673050e18)((Component, config)=>(0, $d6c56f7e74dbe870$export$732916c0e88175fb)(Component, config, $749ba68a8b02b1b2$var$preloadedFeatures, (0, $3f34675d01ef4842$export$56ba0183203348f5)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $749ba68a8b02b1b2$export$546614c4a05701f9(key) {
    return (0, $2cb52b0cccdc54dc$export$46b7e4b9dc6110c3)((0, $d6c56f7e74dbe870$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $749ba68a8b02b1b2$var$preloadedFeatures, (0, $3f34675d01ef4842$export$56ba0183203348f5)));
}


const $526405b2d3b1b39f$var$projects = [
    {
        title: "Kanbas",
        description: "A robust Learning Management System (LMS) inspired by Canvas, designed to streamline the management of courses, assignments, grades, and modules in an educational setting. ",
        image: "kanbas",
        link: "https://github.com/damyantjain/kanbas-react-web-app"
    },
    {
        title: "Jiffy",
        description: "A comprehensive food delivery application built with React.js, Redux, and TailwindCSS . Integrates live APIs from Swiggy offering real-time ordering experience.",
        image: "jiffy",
        link: "https://github.com/damyantjain/jiffy"
    },
    {
        title: "Admitly",
        description: "A unified admission portal for rapid admission process for both students and universities. Powered by Spring Boot and deployed on Azure Web Apps",
        image: "admitly",
        link: "https://github.com/gauravtejwani24/UniversityApplicationPortal"
    },
    {
        title: "Customer Manager",
        description: "A powerful WPF-based client for managing customer data, leveraging gRPC services for high performance and scalability utilizing streaming and asynchronous communication.",
        image: "customerManagement",
        link: "https://github.com/damyantjain/WPF-Customer-App"
    },
    {
        title: "useFormAutoSave",
        description: "A lightweight, customizable React hook that automatically saves form data to prevent loss during user sessions. Provides configurable save intervals, state persistence, and seamless integration with form libraries.",
        image: "useFormAutoSave",
        link: "https://github.com/damyantjain/use-form-auto-save"
    },
    {
        title: "Portfolio Website",
        description: "A responsive personal portfolio built with React, Tailwind CSS, and Framer Motion. Features interactive animations, dark mode support, and a clean, modern design to showcase my projects and skills.",
        image: "portfolio",
        link: "https://github.com/damyantjain/portfolio-website"
    },
    {
        title: "CoralCake",
        description: "A benchmarking platform for Large Language Models (LLMs). Run a single prompt across multiple LLMs (OpenAI, Mistral, etc.) and compare latency, token usage, and cost in real time. Export results as CSV/JSON and review historical runs side-by-side to pick the best model for your use case.",
        image: "coralcake",
        link: "https://github.com/damyantjain/CoralCake",
        demo: "https://coralcake.vercel.app"
    },
    {
        title: "NeatMeet",
        description: "A community event discovery app that allows users to explore events happening around them, filter events by location, search for events, and interact with the event community through voting and creating events.",
        image: "neatmeet",
        link: "https://github.com/damyantjain/NeatMeet"
    }
];
var $526405b2d3b1b39f$export$2e2bcd8739ae039 = $526405b2d3b1b39f$var$projects;




var $107435a99128293d$exports = {};
$107435a99128293d$exports = new URL("kanbas.06923b96.png", import.meta.url).toString();


var $e1023c7296a9a45a$exports = {};
$e1023c7296a9a45a$exports = new URL("customerManagement.8dd4aebf.png", import.meta.url).toString();


var $fdfd7409be7138fe$exports = {};
$fdfd7409be7138fe$exports = new URL("jiffy.0f68bce1.png", import.meta.url).toString();


var $d2498c7834ed3748$exports = {};
$d2498c7834ed3748$exports = new URL("admitly.ac94ca29.png", import.meta.url).toString();


var $b809697d5561eef5$exports = {};
$b809697d5561eef5$exports = new URL("useFormAutoSave.a2222892.png", import.meta.url).toString();


var $c600384dfd2dfbe8$exports = {};
$c600384dfd2dfbe8$exports = new URL("portfolio.468ea1f8.png", import.meta.url).toString();


var $9f28751ef718751e$exports = {};
$9f28751ef718751e$exports = new URL("coralcake.d91a0f37.png", import.meta.url).toString();


var $44175f03a92c4c96$exports = {};
$44175f03a92c4c96$exports = new URL("neatmeet.6262e700.png", import.meta.url).toString();



var $4RFnf = parcelRequire("4RFnf");

var $4RFnf = parcelRequire("4RFnf");
const $1039ae88e8de639f$var$ThemeContext = /*#__PURE__*/ (0, $4RFnf.createContext)({
    darkMode: false
});
var $1039ae88e8de639f$export$2e2bcd8739ae039 = $1039ae88e8de639f$var$ThemeContext;


const $dee753fa99b2f698$var$ProjectCard = ({ project: project })=>{
    const { darkMode: darkMode } = (0, $4RFnf.useContext)((0, $1039ae88e8de639f$export$2e2bcd8739ae039));
    const imageMap = {
        kanbas: (0, (/*@__PURE__*/$parcel$interopDefault($107435a99128293d$exports))),
        customerManagement: (0, (/*@__PURE__*/$parcel$interopDefault($e1023c7296a9a45a$exports))),
        jiffy: (0, (/*@__PURE__*/$parcel$interopDefault($fdfd7409be7138fe$exports))),
        admitly: (0, (/*@__PURE__*/$parcel$interopDefault($d2498c7834ed3748$exports))),
        useFormAutoSave: (0, (/*@__PURE__*/$parcel$interopDefault($b809697d5561eef5$exports))),
        portfolio: (0, (/*@__PURE__*/$parcel$interopDefault($c600384dfd2dfbe8$exports))),
        coralcake: (0, (/*@__PURE__*/$parcel$interopDefault($9f28751ef718751e$exports))),
        neatmeet: (0, (/*@__PURE__*/$parcel$interopDefault($44175f03a92c4c96$exports)))
    };
    const itemVariants = {
        hidden: {
            opacity: 0,
            y: 20
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 1.5,
                ease: "easeOut"
            }
        }
    };
    const handleProjectClick = (link)=>{
        window.open(link, "_blank");
    };
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $749ba68a8b02b1b2$export$e25e478948902b8b).div, {
        variants: itemVariants,
        className: "flex flex-col h-full",
        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
            className: "hover:cursor-pointer hover:scale-95 transition-transform duration-500 ease-in-out transform h-full",
            onClick: ()=>handleProjectClick(project.link),
            children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                className: "flex flex-col h-full rounded-xl shadow-lg shadow-[#b3b3b3] dark:shadow-[#1a1919] overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                        className: "relative w-full h-48 md:h-52 lg:h-48 xl:h-56",
                        children: [
                            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("img", {
                                className: "w-full h-full object-cover",
                                src: imageMap[project.image],
                                alt: project.name
                            }),
                            darkMode && /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                                className: "absolute inset-0 bg-black opacity-20"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                        className: "p-4 flex-grow",
                        children: [
                            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("h3", {
                                className: "font-bold text-xl mb-2",
                                children: project.title
                            }),
                            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("p", {
                                className: "text-sm font-poppins dark:text-gray-400 text-gray-500",
                                children: project.description
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $dee753fa99b2f698$export$2e2bcd8739ae039 = $dee753fa99b2f698$var$ProjectCard;


const $1d2038d9bcf741e5$var$Projects = ()=>{
    const { ref: ref, inView: inView } = (0, $14f8ebced7a82fe2$export$2f62ee6831462844)({
        threshold: 0.3,
        triggerOnce: true
    });
    const containerVariants = {
        hidden: {
            opacity: 0,
            y: 20
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                staggerChildren: 0.3,
                duration: 1,
                ease: "easeOut"
            }
        }
    };
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        ref: ref,
        className: "align-middle text-4xl text-[#333333] dark:text-[#e0e0e0]",
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                className: "text-center font-poppins",
                children: "My Projects"
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $749ba68a8b02b1b2$export$e25e478948902b8b).div, {
                className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4 md:mt-20",
                initial: "hidden",
                animate: inView ? "visible" : "hidden",
                variants: containerVariants,
                children: (0, $526405b2d3b1b39f$export$2e2bcd8739ae039).map((project, index)=>/*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $dee753fa99b2f698$export$2e2bcd8739ae039), {
                        project: project
                    }, index))
            })
        ]
    });
};
var $1d2038d9bcf741e5$export$2e2bcd8739ae039 = $1d2038d9bcf741e5$var$Projects;



parcelRequire("4RFnf");
// src/db/skills.js
const $99afb025a9f47a77$var$skillList = [
    {
        title: "Languages",
        skills: [
            {
                name: "C#",
                imageUrlName: "csharp"
            },
            {
                name: "JavaScript",
                imageUrlName: "javascript"
            },
            {
                name: "Java",
                imageUrlName: "java"
            },
            {
                name: "Python",
                imageUrlName: "python"
            }
        ]
    },
    {
        title: "Web Development",
        skills: [
            {
                name: "React.js",
                imageUrlName: "react"
            },
            {
                name: "Node.js",
                imageUrlName: "nodejs"
            },
            {
                name: "HTML",
                imageUrlName: "html5"
            },
            {
                name: "CSS",
                imageUrlName: "css3"
            },
            {
                name: "Bootstrap",
                imageUrlName: "bootstrap"
            },
            {
                name: "Redux",
                imageUrlName: "redux"
            },
            {
                name: "Tailwind",
                imageUrlName: "tailwind"
            },
            {
                name: "JavaScript",
                imageUrlName: "javascript"
            },
            {
                name: "TypeScript",
                imageUrlName: "typescript"
            }
        ]
    },
    {
        title: "Cloud and Database",
        skills: [
            {
                name: "AWS",
                imageUrlName: "aws"
            },
            {
                name: "Azure",
                imageUrlName: "azure"
            },
            {
                name: "Azure DevOps",
                imageUrlName: "azuredevops"
            },
            {
                name: "MySQL",
                imageUrlName: "mysql"
            },
            {
                name: "MongoDB",
                imageUrlName: "mongodb"
            },
            {
                name: "SQLite",
                imageUrlName: "sqlite"
            }
        ]
    },
    {
        title: "Frameworks",
        skills: [
            {
                name: "Xamarin.Forms",
                imageUrlName: "xamarin"
            },
            {
                name: "Spring",
                imageUrlName: "spring"
            },
            {
                name: "Junit",
                imageUrlName: "junit5"
            },
            {
                name: "Dotnet",
                imageUrlName: "dotnet"
            }
        ]
    }
];
var $99afb025a9f47a77$export$2e2bcd8739ae039 = $99afb025a9f47a77$var$skillList;



var $3314e1f5939f9d8e$exports = {};
$3314e1f5939f9d8e$exports = new URL("dotnet.02029abf.svg", import.meta.url).toString();


var $627a700140ec74d9$exports = {};
$627a700140ec74d9$exports = new URL("java.e0175a7d.svg", import.meta.url).toString();


var $3a333bae06f4ec93$exports = {};
$3a333bae06f4ec93$exports = new URL("react.9e5ba8ab.svg", import.meta.url).toString();


var $bdd27164b149e9ec$exports = {};
$bdd27164b149e9ec$exports = new URL("python.45b561f4.svg", import.meta.url).toString();


var $d943663f78d1d218$exports = {};
$d943663f78d1d218$exports = new URL("javascript.79e4a46d.svg", import.meta.url).toString();


var $1551da1a79a2ba95$exports = {};
$1551da1a79a2ba95$exports = new URL("typescript.2089fcca.svg", import.meta.url).toString();


var $e9332885093d4667$exports = {};
$e9332885093d4667$exports = new URL("html5.432a41f1.svg", import.meta.url).toString();


var $a54764bd60ba8536$exports = {};
$a54764bd60ba8536$exports = new URL("css3.a135f09d.svg", import.meta.url).toString();


var $0cd3654631574bff$exports = {};
$0cd3654631574bff$exports = new URL("aws.1e2d6103.svg", import.meta.url).toString();


var $56e3b270d14a7158$exports = {};
$56e3b270d14a7158$exports = new URL("azure.61731310.svg", import.meta.url).toString();


var $47fd817dfbb84b05$exports = {};
$47fd817dfbb84b05$exports = new URL("azuredevops.df3ceb76.svg", import.meta.url).toString();


var $b975251525907ee4$exports = {};
$b975251525907ee4$exports = new URL("bootstrap.d7fa268d.svg", import.meta.url).toString();


var $b73a3583d11b057b$exports = {};
$b73a3583d11b057b$exports = new URL("csharp.e8446547.svg", import.meta.url).toString();


var $5f080b73ab11da9e$exports = {};
$5f080b73ab11da9e$exports = new URL("junit5.d1e23702.svg", import.meta.url).toString();


var $89eb2852d3056054$exports = {};
$89eb2852d3056054$exports = new URL("mysql.65a80f62.svg", import.meta.url).toString();


var $4c1cf3ef5a259772$exports = {};
$4c1cf3ef5a259772$exports = new URL("mongodb.01769c4f.svg", import.meta.url).toString();


var $9af509375ba0b13f$exports = {};
$9af509375ba0b13f$exports = new URL("nodejs.19f2f559.svg", import.meta.url).toString();


var $bc2f1f4c327e49dc$exports = {};
$bc2f1f4c327e49dc$exports = new URL("redux.703d4e86.svg", import.meta.url).toString();


var $7e8c59a6c0a5731d$exports = {};
$7e8c59a6c0a5731d$exports = new URL("spring.2a2fc67a.svg", import.meta.url).toString();


var $ed751330103b591b$exports = {};
$ed751330103b591b$exports = new URL("sqlite.3fdd19c3.svg", import.meta.url).toString();


var $33e1f9fbf9fa9794$exports = {};
$33e1f9fbf9fa9794$exports = new URL("tailwind.f90b662a.svg", import.meta.url).toString();


var $d12804bca669ca5f$exports = {};
$d12804bca669ca5f$exports = new URL("xamarin.ec1d6634.svg", import.meta.url).toString();


const $144af6b103cd43e4$var$svgIcons = {
    dotnet: (0, (/*@__PURE__*/$parcel$interopDefault($3314e1f5939f9d8e$exports))),
    java: (0, (/*@__PURE__*/$parcel$interopDefault($627a700140ec74d9$exports))),
    react: (0, (/*@__PURE__*/$parcel$interopDefault($3a333bae06f4ec93$exports))),
    python: (0, (/*@__PURE__*/$parcel$interopDefault($bdd27164b149e9ec$exports))),
    javascript: (0, (/*@__PURE__*/$parcel$interopDefault($d943663f78d1d218$exports))),
    typescript: (0, (/*@__PURE__*/$parcel$interopDefault($1551da1a79a2ba95$exports))),
    html5: (0, (/*@__PURE__*/$parcel$interopDefault($e9332885093d4667$exports))),
    css3: (0, (/*@__PURE__*/$parcel$interopDefault($a54764bd60ba8536$exports))),
    aws: (0, (/*@__PURE__*/$parcel$interopDefault($0cd3654631574bff$exports))),
    azure: (0, (/*@__PURE__*/$parcel$interopDefault($56e3b270d14a7158$exports))),
    azuredevops: (0, (/*@__PURE__*/$parcel$interopDefault($47fd817dfbb84b05$exports))),
    bootstrap: (0, (/*@__PURE__*/$parcel$interopDefault($b975251525907ee4$exports))),
    csharp: (0, (/*@__PURE__*/$parcel$interopDefault($b73a3583d11b057b$exports))),
    junit5: (0, (/*@__PURE__*/$parcel$interopDefault($5f080b73ab11da9e$exports))),
    mysql: (0, (/*@__PURE__*/$parcel$interopDefault($89eb2852d3056054$exports))),
    mongodb: (0, (/*@__PURE__*/$parcel$interopDefault($4c1cf3ef5a259772$exports))),
    nodejs: (0, (/*@__PURE__*/$parcel$interopDefault($9af509375ba0b13f$exports))),
    redux: (0, (/*@__PURE__*/$parcel$interopDefault($bc2f1f4c327e49dc$exports))),
    spring: (0, (/*@__PURE__*/$parcel$interopDefault($7e8c59a6c0a5731d$exports))),
    sqlite: (0, (/*@__PURE__*/$parcel$interopDefault($ed751330103b591b$exports))),
    tailwind: (0, (/*@__PURE__*/$parcel$interopDefault($33e1f9fbf9fa9794$exports))),
    xamarin: (0, (/*@__PURE__*/$parcel$interopDefault($d12804bca669ca5f$exports)))
};
const $144af6b103cd43e4$var$TechIcons = ({ imageUrlName: imageUrlName, name: name })=>{
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("img", {
        src: $144af6b103cd43e4$var$svgIcons[imageUrlName],
        alt: name,
        title: name,
        className: "h-8 w-8 mb-4 md:h-10 md:w10 lg:h-12 lg:w-12 mr-2 lg:mr-5"
    });
};
var $144af6b103cd43e4$export$2e2bcd8739ae039 = $144af6b103cd43e4$var$TechIcons;




const $d5b66711870655fa$var$Skills = ()=>{
    const { ref: ref, inView: inView } = (0, $14f8ebced7a82fe2$export$2f62ee6831462844)({
        threshold: 0.1,
        triggerOnce: true
    });
    const containerVariants = {
        hidden: {
            opacity: 0,
            y: 20
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                staggerChildren: 0.06,
                duration: 0.1,
                ease: "easeInOut"
            }
        }
    };
    const itemVariants = {
        hidden: {
            opacity: 0,
            y: 20
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.5,
                ease: "easeOut"
            }
        }
    };
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        className: "py-12",
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                className: "align-middle text-center font-poppins text-4xl text-[#333333] dark:text-[#e0e0e0]",
                children: "Skills & Technologies"
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $749ba68a8b02b1b2$export$e25e478948902b8b).div, {
                ref: ref,
                initial: "hidden",
                animate: inView ? "visible" : "hidden",
                variants: containerVariants,
                className: "mt-10 container mx-auto px-4 bg-gradient-to-br from-gray-100 to-white w-full dark:from-[#1e1e1e] dark:to-[#2222222d] shadow-lg rounded-xl p-6 pt-16 border border-gray-200 dark:border-0 mb-6",
                children: (0, $99afb025a9f47a77$export$2e2bcd8739ae039).map((skillCategory, index)=>/*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                        className: "mb-10",
                        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                            className: "flex flex-col md:flex-row gap-4",
                            children: [
                                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                                    className: "md:w-4/12 lg:w-3/12 flex items-center",
                                    children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                                        className: "font-poppins md:ml-3 dark:text-[#e0e0e0] text-[#333333] text-xl whitespace-nowrap",
                                        children: skillCategory.title
                                    })
                                }),
                                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                                    className: "md:w-8/12 lg:w-9/12 flex flex-wrap gap-4",
                                    children: skillCategory.skills.map((skill, skillIndex)=>/*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $749ba68a8b02b1b2$export$e25e478948902b8b).div, {
                                            className: "flex items-center",
                                            variants: itemVariants,
                                            children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $144af6b103cd43e4$export$2e2bcd8739ae039), {
                                                imageUrlName: skill.imageUrlName,
                                                name: skill.name
                                            })
                                        }, skillIndex))
                                })
                            ]
                        })
                    }, index))
            })
        ]
    });
};
var $d5b66711870655fa$export$2e2bcd8739ae039 = $d5b66711870655fa$var$Skills;




const $3b2fb2abc51080d5$var$experience = [
    {
        company: "Philips",
        position: "Software Engineer Co-op",
        location: "Cambridge, MA",
        duration: "Jan 2025 \u2013 Present",
        description: [
            "Architected and engineered a side-by-side installation for PIC-iX (WinForms/.NET) enabling concurrent patch deployment, reducing production downtime by 65%.",
            "Developed a Python-based automation tool to generate Release Requirement Documents by programmatically ingesting, transforming, and validating Azure DevOps work item data, ensuring accuracy and consistency across releases.",
            "Reduced document processing time from days to minutes (99% reduction) by automating revision history, delta generation, and structured upload to DevOps",
            "Streamlined CI pipelines by enhancing GitHub workflows to run automated smoke tests and linting on pull requests.",
            "Created workflows to enhance developer experience, like flagging unused NuGet package references of .NET projects."
        ]
    },
    {
        company: "West Pharmaceutical Services",
        position: "Software Engineer",
        location: "Bengaluru, India",
        duration: "Oct 2022 \u2013 July 2023",
        description: [
            "Developed C# backend services for a manufacturing platform, containerized them with Docker, and deployed to Kubernetes.",
            "Implemented GraphQL endpoints over existing manufacturing data services, enabling operators to fetch complex nested datasets (production orders, machine states, quality logs) in a single query \u2014 reducing API round trips by 40%.",
            "Re-engineered manufacturing data storage by migrating time-series production logs from MongoDB to PostgreSQL with partitioned tables, improving analytical query speed by 35% for reporting dashboards.",
            "Created a Jenkins + Azure DevOps hybrid CI/CD pipeline to run automated integration tests, build Docker images, and roll out updates to Kubernetes \u2014 reducing release lead time from 1 week to under 2 days."
        ]
    },
    {
        company: "West Pharmaceutical Services",
        position: "Associate Software Engineer",
        location: "Bengaluru, India",
        duration: "July 2020 \u2013 Sep 2022",
        description: [
            "Designed and implemented a Digital Manufacturing application using .NET framework, Xamarin.Forms and MAUI",
            "Followed MVVM architecture and Object-Oriented Programming (OOP) for creating robust application.",
            "Implemented design patterns such as Command, Decorator, and Builder to enhance the software architecture.",
            "Integrated MQTT brokers with backend services to stream live sensor data into PostgreSQL-backed queues, achieving sub-second processing for shop-floor dashboards.",
            "Implemented a SignalR-based connection to efficiently route orders across the manufacturing plant."
        ]
    },
    {
        company: "West Pharmaceutical Services",
        position: "Graduate Software Engineer",
        location: "Bengaluru, India",
        duration: "Jan 2020 \u2013 July 2020",
        description: [
            "Team lead for an Asset management application to digitize the handling of all organization's assets.",
            "Developed both frontend (MAUI) and backend (SQL) of the application, based on .NET framework.",
            "Leveraged Azure to create web apps to host APIs, blob storage for file management, and SQL database for the application."
        ]
    },
    {
        company: "Chatbotsa",
        position: "Software Developer Intern",
        location: "Cairo, Egypt",
        duration: "June 2018 - July 2018",
        description: [
            "Developed and deployed chatbots using Node.js into Facebook Messenger.",
            "Utilized Dialogflow NLP for efficient user query handling."
        ]
    }
];
var $3b2fb2abc51080d5$export$2e2bcd8739ae039 = $3b2fb2abc51080d5$var$experience;


var $dbbc5cbb9113aeaa$exports = {};
$dbbc5cbb9113aeaa$exports = new URL("external_black.8a4a545a.svg", import.meta.url).toString();


var $22f3e6cd18bd16bf$exports = {};
$22f3e6cd18bd16bf$exports = new URL("external_white.533a6ff9.svg", import.meta.url).toString();



var $4RFnf = parcelRequire("4RFnf");

const $d917e396793ddcf3$var$Experience = ()=>{
    const { darkMode: darkMode, setDarkMode: setDarkMode } = (0, $4RFnf.useContext)((0, $1039ae88e8de639f$export$2e2bcd8739ae039));
    const viewResume = ()=>{
        window.open("https://drive.google.com/file/d/1r-rFWGjE1SSHM-x6_2ZXL-BrtP2hwVGs/view?usp=drive_link", "_blank");
    };
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        className: "mt-10",
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                className: "font-poppins flex justify-between mb-10 text-2xl text-[#333333] dark:text-[#e0e0e0]",
                children: [
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                        children: "Experience"
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("button", {
                            title: "View Resume",
                            onClick: ()=>viewResume(),
                            children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("img", {
                                className: "h-8 w-8",
                                src: darkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($22f3e6cd18bd16bf$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($dbbc5cbb9113aeaa$exports)))
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                children: (0, $3b2fb2abc51080d5$export$2e2bcd8739ae039).map((exp, index)=>/*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                        className: "bg-gradient-to-br from-gray-100 to-white dark:from-[#1e1e1e] dark:to-[#2222222d] shadow-lg rounded-xl p-6 border border-gray-200 dark:border-0 mb-6",
                        children: [
                            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                                className: "md:flex md:flex-row",
                                children: [
                                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                                        className: "md:w-9/12",
                                        children: [
                                            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                                                className: "font-bold md:text-lg text-[#333333] dark:text-[#e0e0e0]",
                                                children: exp.company
                                            }),
                                            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                                                className: "text-sm text-gray-500 dark:text-gray-400",
                                                children: exp.position
                                            }),
                                            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                                                className: "text-sm text-gray-500 dark:text-gray-400",
                                                children: exp.location
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                                        className: "md:w-3/12 text-sm md:text-end text-gray-500 dark:text-gray-400",
                                        children: exp.duration
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("ul", {
                                className: "mt-2 text-gray-500 dark:text-gray-400 list-disc list-inside",
                                children: exp.description.map((item, i)=>/*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("li", {
                                        children: item
                                    }, i))
                            })
                        ]
                    }, index))
            })
        ]
    });
};
var $d917e396793ddcf3$export$2e2bcd8739ae039 = $d917e396793ddcf3$var$Experience;



const $c80e797659005758$var$education = [
    {
        university: "Northeastern University",
        school: "Khoury College of Computer Sciences",
        location: "Boston, Massachusetts",
        degree: "MS Computer Science",
        duration: "2023 - Dec 2025",
        major: "Computer Science"
    },
    {
        university: "Vellore Institute of Technology",
        school: "School of Computer Science and Engineering (SCOPE)",
        location: "Vellore, Tamil Nadu",
        degree: "B.Tech Computer Science",
        duration: "2016 - 2020",
        major: "Computer Science"
    }
];
var $c80e797659005758$export$2e2bcd8739ae039 = $c80e797659005758$var$education;


const $6fde251d90142602$var$Education = ()=>{
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        className: "mt-10",
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                className: "font-poppins mb-10 text-2xl text-[#333333] dark:text-[#e0e0e0]",
                children: "Education"
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                className: "md:flex md:flex-row gap-8",
                children: (0, $c80e797659005758$export$2e2bcd8739ae039).map((edu, index)=>/*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                        className: "bg-gradient-to-br from-gray-100 to-white w-full dark:from-[#1e1e1e] dark:to-[#2222222d] shadow-lg rounded-xl p-6 border border-gray-200 dark:border-0 mb-6",
                        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                            className: "xl:flex xl:flex-row",
                            children: [
                                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                                    className: "xl:w-8/12",
                                    children: [
                                        /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                                            className: "font-bold text-[#333333] dark:text-[#e0e0e0] md:text-lg",
                                            children: edu.university
                                        }),
                                        /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                                            className: "text-sm dark:text-gray-400 text-gray-500",
                                            children: edu.school
                                        }),
                                        /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                                            className: "text-sm dark:text-gray-400 text-gray-500",
                                            children: edu.degree
                                        }),
                                        /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                                            className: "text-sm dark:text-gray-400 text-gray-500",
                                            children: edu.location
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                                    className: "xl:w-4/12 text-sm text-gray-500 dark:text-gray-400 xl:text-end",
                                    children: edu.duration
                                })
                            ]
                        })
                    }, index))
            })
        ]
    });
};
var $6fde251d90142602$export$2e2bcd8739ae039 = $6fde251d90142602$var$Education;


const $497233f801911003$var$Resume = ()=>{
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $d917e396793ddcf3$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $6fde251d90142602$export$2e2bcd8739ae039), {})
        ]
    });
};
var $497233f801911003$export$2e2bcd8739ae039 = $497233f801911003$var$Resume;




var $4RFnf = parcelRequire("4RFnf");

const $c30866d045584b89$var$Contact = ()=>{
    const { darkMode: darkMode } = (0, $4RFnf.useContext)((0, $1039ae88e8de639f$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        className: "flex flex-wrap justify-end items-center gap-10 px-4 ",
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                className: "text-right text-[#333333] dark:text-[#e0e0e0]",
                children: [
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                        className: "font-poppins text-lg",
                        children: "E-mail"
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                        className: "text-sm",
                        children: "jain.dam@northeastern.edu"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                className: "text-right text-[#333333] dark:text-[#e0e0e0]",
                children: [
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                        className: "font-poppins text-lg",
                        children: "City"
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                        className: "text-sm",
                        children: "Boston, MA"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                className: "flex gap-10",
                children: [
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("a", {
                            href: "https://github.com/damyantjain",
                            target: "_blank",
                            children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("i", {
                                className: "fa-brands fa-github fa-3x",
                                style: {
                                    color: darkMode ? "white" : "black"
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("a", {
                            href: "https://linkedin.com/in/damyant",
                            target: "_blank",
                            children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("i", {
                                className: "fa-brands fa-linkedin fa-3x",
                                style: {
                                    color: darkMode ? "white" : "#0077B5"
                                }
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $c30866d045584b89$export$2e2bcd8739ae039 = $c30866d045584b89$var$Contact;



var $a2c2034c49841d6d$exports = {};
"use strict";
Object.defineProperty($a2c2034c49841d6d$exports, "__esModule", {
    value: true
});
$a2c2034c49841d6d$exports.Helpers = $a2c2034c49841d6d$exports.ScrollElement = $a2c2034c49841d6d$exports.ScrollLink = $a2c2034c49841d6d$exports.animateScroll = $a2c2034c49841d6d$exports.scrollSpy = $a2c2034c49841d6d$exports.Events = $a2c2034c49841d6d$exports.scroller = $a2c2034c49841d6d$exports.Element = $a2c2034c49841d6d$exports.Button = $a2c2034c49841d6d$exports.Link = undefined;
var $e04709a490bd9456$exports = {};
"use strict";
Object.defineProperty($e04709a490bd9456$exports, "__esModule", {
    value: true
});

var $4RFnf = parcelRequire("4RFnf");
var $e04709a490bd9456$var$_react2 = $e04709a490bd9456$var$_interopRequireDefault($4RFnf);
var $86aa1a05565412c2$exports = {};
"use strict";
Object.defineProperty($86aa1a05565412c2$exports, "__esModule", {
    value: true
});
var $86aa1a05565412c2$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $86aa1a05565412c2$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $4RFnf = parcelRequire("4RFnf");
var $86aa1a05565412c2$var$_react2 = $86aa1a05565412c2$var$_interopRequireDefault($4RFnf);
var $6764d9ed537cea08$exports = {};
"use strict";
Object.defineProperty($6764d9ed537cea08$exports, "__esModule", {
    value: true
});
var $317cc93bb04145ec$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $317cc93bb04145ec$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $317cc93bb04145ec$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $317cc93bb04145ec$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $317cc93bb04145ec$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $317cc93bb04145ec$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $317cc93bb04145ec$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $317cc93bb04145ec$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $317cc93bb04145ec$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $317cc93bb04145ec$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $317cc93bb04145ec$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $317cc93bb04145ec$var$root = $317cc93bb04145ec$var$freeGlobal || $317cc93bb04145ec$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $317cc93bb04145ec$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $317cc93bb04145ec$var$objectToString = $317cc93bb04145ec$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $317cc93bb04145ec$var$nativeMax = Math.max, $317cc93bb04145ec$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $317cc93bb04145ec$var$now = function() {
    return $317cc93bb04145ec$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $317cc93bb04145ec$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($317cc93bb04145ec$var$FUNC_ERROR_TEXT);
    wait = $317cc93bb04145ec$var$toNumber(wait) || 0;
    if ($317cc93bb04145ec$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $317cc93bb04145ec$var$nativeMax($317cc93bb04145ec$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $317cc93bb04145ec$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $317cc93bb04145ec$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($317cc93bb04145ec$var$now());
    }
    function debounced() {
        var time = $317cc93bb04145ec$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $317cc93bb04145ec$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($317cc93bb04145ec$var$FUNC_ERROR_TEXT);
    if ($317cc93bb04145ec$var$isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $317cc93bb04145ec$var$debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $317cc93bb04145ec$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $317cc93bb04145ec$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $317cc93bb04145ec$var$isSymbol(value) {
    return typeof value == "symbol" || $317cc93bb04145ec$var$isObjectLike(value) && $317cc93bb04145ec$var$objectToString.call(value) == $317cc93bb04145ec$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $317cc93bb04145ec$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($317cc93bb04145ec$var$isSymbol(value)) return $317cc93bb04145ec$var$NAN;
    if ($317cc93bb04145ec$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $317cc93bb04145ec$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($317cc93bb04145ec$var$reTrim, "");
    var isBinary = $317cc93bb04145ec$var$reIsBinary.test(value);
    return isBinary || $317cc93bb04145ec$var$reIsOctal.test(value) ? $317cc93bb04145ec$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $317cc93bb04145ec$var$reIsBadHex.test(value) ? $317cc93bb04145ec$var$NAN : +value;
}
$317cc93bb04145ec$exports = $317cc93bb04145ec$var$throttle;


var $6764d9ed537cea08$var$_lodash2 = $6764d9ed537cea08$var$_interopRequireDefault($317cc93bb04145ec$exports);
var $b4760782627bf536$exports = {};
"use strict";
Object.defineProperty($b4760782627bf536$exports, "__esModule", {
    value: true
});
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */ var $b4760782627bf536$var$addPassiveEventListener = $b4760782627bf536$exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
    var listenerName = listener.name;
    if (!listenerName) {
        listenerName = eventName;
        console.warn("Listener must be a named function.");
    }
    if (!$b4760782627bf536$var$attachedListeners.has(eventName)) $b4760782627bf536$var$attachedListeners.set(eventName, new Set());
    var listeners = $b4760782627bf536$var$attachedListeners.get(eventName);
    if (listeners.has(listenerName)) return;
    var supportsPassiveOption = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, "passive", {
                get: function get() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener("test", null, opts);
        } catch (e) {}
        return supportsPassiveOption;
    }();
    target.addEventListener(eventName, listener, supportsPassiveOption ? {
        passive: true
    } : false);
    listeners.add(listenerName);
};
var $b4760782627bf536$var$removePassiveEventListener = $b4760782627bf536$exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
    target.removeEventListener(eventName, listener);
    $b4760782627bf536$var$attachedListeners.get(eventName).delete(listener.name || eventName);
};
var $b4760782627bf536$var$attachedListeners = new Map();


function $6764d9ed537cea08$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// The eventHandler will execute at a rate of 15fps by default
var $6764d9ed537cea08$var$eventThrottler = function eventThrottler(eventHandler) {
    var throttleAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 66;
    return (0, $6764d9ed537cea08$var$_lodash2.default)(eventHandler, throttleAmount);
};
var $6764d9ed537cea08$var$scrollSpy = {
    spyCallbacks: [],
    spySetState: [],
    scrollSpyContainers: [],
    mount: function mount(scrollSpyContainer, throttle) {
        if (scrollSpyContainer) {
            var eventHandler = $6764d9ed537cea08$var$eventThrottler(function(event) {
                $6764d9ed537cea08$var$scrollSpy.scrollHandler(scrollSpyContainer);
            }, throttle);
            $6764d9ed537cea08$var$scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
            (0, $b4760782627bf536$exports.addPassiveEventListener)(scrollSpyContainer, "scroll", eventHandler);
        }
    },
    isMounted: function isMounted(scrollSpyContainer) {
        return $6764d9ed537cea08$var$scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
    },
    currentPositionX: function currentPositionX(scrollSpyContainer) {
        if (scrollSpyContainer === document) {
            var supportPageOffset = window.pageYOffset !== undefined;
            var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
            return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
        } else return scrollSpyContainer.scrollLeft;
    },
    currentPositionY: function currentPositionY(scrollSpyContainer) {
        if (scrollSpyContainer === document) {
            var supportPageOffset = window.pageXOffset !== undefined;
            var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
            return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
        } else return scrollSpyContainer.scrollTop;
    },
    scrollHandler: function scrollHandler(scrollSpyContainer) {
        var callbacks = $6764d9ed537cea08$var$scrollSpy.scrollSpyContainers[$6764d9ed537cea08$var$scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
        callbacks.forEach(function(c) {
            return c($6764d9ed537cea08$var$scrollSpy.currentPositionX(scrollSpyContainer), $6764d9ed537cea08$var$scrollSpy.currentPositionY(scrollSpyContainer));
        });
    },
    addStateHandler: function addStateHandler(handler) {
        $6764d9ed537cea08$var$scrollSpy.spySetState.push(handler);
    },
    addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
        var container = $6764d9ed537cea08$var$scrollSpy.scrollSpyContainers[$6764d9ed537cea08$var$scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];
        if (!container.spyCallbacks) container.spyCallbacks = [];
        container.spyCallbacks.push(handler);
        handler($6764d9ed537cea08$var$scrollSpy.currentPositionX(scrollSpyContainer), $6764d9ed537cea08$var$scrollSpy.currentPositionY(scrollSpyContainer));
    },
    updateStates: function updateStates() {
        $6764d9ed537cea08$var$scrollSpy.spySetState.forEach(function(s) {
            return s();
        });
    },
    unmount: function unmount(stateHandler, spyHandler) {
        $6764d9ed537cea08$var$scrollSpy.scrollSpyContainers.forEach(function(c) {
            return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.indexOf(spyHandler) > -1 && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
        });
        if ($6764d9ed537cea08$var$scrollSpy.spySetState && $6764d9ed537cea08$var$scrollSpy.spySetState.length && $6764d9ed537cea08$var$scrollSpy.spySetState.indexOf(stateHandler) > -1) $6764d9ed537cea08$var$scrollSpy.spySetState.splice($6764d9ed537cea08$var$scrollSpy.spySetState.indexOf(stateHandler), 1);
        document.removeEventListener("scroll", $6764d9ed537cea08$var$scrollSpy.scrollHandler);
    },
    update: function update() {
        return $6764d9ed537cea08$var$scrollSpy.scrollSpyContainers.forEach(function(c) {
            return $6764d9ed537cea08$var$scrollSpy.scrollHandler(c);
        });
    }
};
$6764d9ed537cea08$exports.default = $6764d9ed537cea08$var$scrollSpy;


var $86aa1a05565412c2$var$_scrollSpy2 = $86aa1a05565412c2$var$_interopRequireDefault($6764d9ed537cea08$exports);
var $99220e484bceaab2$exports = {};
"use strict";
Object.defineProperty($99220e484bceaab2$exports, "__esModule", {
    value: true
});
var $99220e484bceaab2$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $70dfa4a5c9bb578a$exports = {};
"use strict";
Object.defineProperty($70dfa4a5c9bb578a$exports, "__esModule", {
    value: true
});
var $70dfa4a5c9bb578a$var$updateHash = function updateHash(hash, historyUpdate) {
    var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
    var hashToUpdate = hashVal ? "#" + hashVal : "";
    var curLoc = window && window.location;
    var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
    historyUpdate ? history.pushState(history.state, "", urlToPush) : history.replaceState(history.state, "", urlToPush);
};
var $70dfa4a5c9bb578a$var$getHash = function getHash() {
    return window.location.hash.replace(/^#/, "");
};
var $70dfa4a5c9bb578a$var$filterElementInContainer = function filterElementInContainer(container) {
    return function(element) {
        return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
    };
};
var $70dfa4a5c9bb578a$var$isPositioned = function isPositioned(element) {
    return getComputedStyle(element).position !== "static";
};
var $70dfa4a5c9bb578a$var$getElementOffsetInfoUntil = function getElementOffsetInfoUntil(element, predicate) {
    var offsetTop = element.offsetTop;
    var currentOffsetParent = element.offsetParent;
    while(currentOffsetParent && !predicate(currentOffsetParent)){
        offsetTop += currentOffsetParent.offsetTop;
        currentOffsetParent = currentOffsetParent.offsetParent;
    }
    return {
        offsetTop: offsetTop,
        offsetParent: currentOffsetParent
    };
};
var $70dfa4a5c9bb578a$var$scrollOffset = function scrollOffset(c, t, horizontal) {
    if (horizontal) return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
    else {
        if (c === document) return t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
        // The offsetParent of an element, according to MDN, is its nearest positioned
        // (an element whose position is anything other than static) ancestor. The offsetTop
        // of an element is taken with respect to its offsetParent which may not neccessarily
        // be its parentElement except the parent itself is positioned.
        // So if containerElement is positioned, then it must be an offsetParent somewhere
        // If it happens that targetElement is a descendant of the containerElement, and there
        // is not intermediate positioned element between the two of them, i.e.
        // targetElement"s offsetParent is the same as the containerElement, then the
        // distance between the two will be the offsetTop of the targetElement.
        // If, on the other hand, there are intermediate positioned elements between the
        // two entities, the distance between the targetElement and the containerElement
        // will be the accumulation of the offsetTop of the element and that of its
        // subsequent offsetParent until the containerElement is reached, since it
        // will also be an offsetParent at some point due to the fact that it is positioned.
        // If the containerElement is not positioned, then it can"t be an offsetParent,
        // which means that the offsetTop of the targetElement would not be with respect to it.
        // However, if the two of them happen to have the same offsetParent, then
        // the distance between them will be the difference between their offsetTop
        // since they are both taken with respect to the same entity.
        // The last resort would be to accumulate their offsetTop until a common
        // offsetParent is reached (usually the document) and taking the difference
        // between the accumulated offsetTops
        if ($70dfa4a5c9bb578a$var$isPositioned(c)) {
            if (t.offsetParent !== c) {
                var isContainerElementOrDocument = function isContainerElementOrDocument(e) {
                    return e === c || e === document;
                };
                var _getElementOffsetInfo = $70dfa4a5c9bb578a$var$getElementOffsetInfoUntil(t, isContainerElementOrDocument), offsetTop = _getElementOffsetInfo.offsetTop, offsetParent = _getElementOffsetInfo.offsetParent;
                if (offsetParent !== c) throw new Error("Seems containerElement is not an ancestor of the Element");
                return offsetTop;
            }
            return t.offsetTop;
        }
        if (t.offsetParent === c.offsetParent) return t.offsetTop - c.offsetTop;
        var isDocument = function isDocument(e) {
            return e === document;
        };
        return $70dfa4a5c9bb578a$var$getElementOffsetInfoUntil(t, isDocument).offsetTop - $70dfa4a5c9bb578a$var$getElementOffsetInfoUntil(c, isDocument).offsetTop;
    }
};
$70dfa4a5c9bb578a$exports.default = {
    updateHash: $70dfa4a5c9bb578a$var$updateHash,
    getHash: $70dfa4a5c9bb578a$var$getHash,
    filterElementInContainer: $70dfa4a5c9bb578a$var$filterElementInContainer,
    scrollOffset: $70dfa4a5c9bb578a$var$scrollOffset
};


var $99220e484bceaab2$var$_utils2 = $99220e484bceaab2$var$_interopRequireDefault($70dfa4a5c9bb578a$exports);
var $e295770be29ab0ab$exports = {};
"use strict";
Object.defineProperty($e295770be29ab0ab$exports, "__esModule", {
    value: true
});
var $e295770be29ab0ab$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $e295770be29ab0ab$var$_utils2 = $e295770be29ab0ab$var$_interopRequireDefault($70dfa4a5c9bb578a$exports);
var $fe8d99d955295300$exports = {};
"use strict";
Object.defineProperty($fe8d99d955295300$exports, "__esModule", {
    value: true
});
$fe8d99d955295300$exports.default = {
    /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */ defaultEasing: function defaultEasing(x) {
        if (x < 0.5) return Math.pow(x * 2, 2) / 2;
        return 1 - Math.pow((1 - x) * 2, 2) / 2;
    },
    /*
   * https://gist.github.com/gre/1650294
   */ // no easing, no acceleration
    linear: function linear(x) {
        return x;
    },
    // accelerating from zero velocity
    easeInQuad: function easeInQuad(x) {
        return x * x;
    },
    // decelerating to zero velocity
    easeOutQuad: function easeOutQuad(x) {
        return x * (2 - x);
    },
    // acceleration until halfway, then deceleration
    easeInOutQuad: function easeInOutQuad(x) {
        return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
    },
    // accelerating from zero velocity 
    easeInCubic: function easeInCubic(x) {
        return x * x * x;
    },
    // decelerating to zero velocity π
    easeOutCubic: function easeOutCubic(x) {
        return --x * x * x + 1;
    },
    // acceleration until halfway, then deceleration 
    easeInOutCubic: function easeInOutCubic(x) {
        return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
    },
    // accelerating from zero velocity 
    easeInQuart: function easeInQuart(x) {
        return x * x * x * x;
    },
    // decelerating to zero velocity 
    easeOutQuart: function easeOutQuart(x) {
        return 1 - --x * x * x * x;
    },
    // acceleration until halfway, then deceleration
    easeInOutQuart: function easeInOutQuart(x) {
        return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
    },
    // accelerating from zero velocity
    easeInQuint: function easeInQuint(x) {
        return x * x * x * x * x;
    },
    // decelerating to zero velocity
    easeOutQuint: function easeOutQuint(x) {
        return 1 + --x * x * x * x * x;
    },
    // acceleration until halfway, then deceleration 
    easeInOutQuint: function easeInOutQuint(x) {
        return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
    }
};


var $e295770be29ab0ab$var$_smooth2 = $e295770be29ab0ab$var$_interopRequireDefault($fe8d99d955295300$exports);
var $94b8c10e6b37ca6b$exports = {};
"use strict";
Object.defineProperty($94b8c10e6b37ca6b$exports, "__esModule", {
    value: true
});

var $94b8c10e6b37ca6b$var$events = [
    "mousedown",
    "mousewheel",
    "touchmove",
    "keydown"
];
$94b8c10e6b37ca6b$exports.default = {
    subscribe: function subscribe(cancelEvent) {
        return typeof document !== "undefined" && $94b8c10e6b37ca6b$var$events.forEach(function(event) {
            return (0, $b4760782627bf536$exports.addPassiveEventListener)(document, event, cancelEvent);
        });
    }
};


var $e295770be29ab0ab$var$_cancelEvents2 = $e295770be29ab0ab$var$_interopRequireDefault($94b8c10e6b37ca6b$exports);
var $0acfeb05094780be$exports = {};
"use strict";
Object.defineProperty($0acfeb05094780be$exports, "__esModule", {
    value: true
});
var $0acfeb05094780be$var$Events = {
    registered: {},
    scrollEvent: {
        register: function register(evtName, callback) {
            $0acfeb05094780be$var$Events.registered[evtName] = callback;
        },
        remove: function remove(evtName) {
            $0acfeb05094780be$var$Events.registered[evtName] = null;
        }
    }
};
$0acfeb05094780be$exports.default = $0acfeb05094780be$var$Events;


var $e295770be29ab0ab$var$_scrollEvents2 = $e295770be29ab0ab$var$_interopRequireDefault($0acfeb05094780be$exports);
function $e295770be29ab0ab$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
 * Gets the easing type from the smooth prop within options.
 */ var $e295770be29ab0ab$var$getAnimationType = function getAnimationType(options) {
    return $e295770be29ab0ab$var$_smooth2.default[options.smooth] || $e295770be29ab0ab$var$_smooth2.default.defaultEasing;
};
/*
 * Function helper
 */ var $e295770be29ab0ab$var$functionWrapper = function functionWrapper(value) {
    return typeof value === "function" ? value : function() {
        return value;
    };
};
/*
 * Wraps window properties to allow server side rendering
 */ var $e295770be29ab0ab$var$currentWindowProperties = function currentWindowProperties() {
    if (typeof window !== "undefined") return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
};
/*
 * Helper function to never extend 60fps on the webpage.
 */ var $e295770be29ab0ab$var$requestAnimationFrameHelper = function() {
    return $e295770be29ab0ab$var$currentWindowProperties() || function(callback, element, delay) {
        window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
    };
}();
var $e295770be29ab0ab$var$makeData = function makeData() {
    return {
        currentPosition: 0,
        startPosition: 0,
        targetPosition: 0,
        progress: 0,
        duration: 0,
        cancel: false,
        target: null,
        containerElement: null,
        to: null,
        start: null,
        delta: null,
        percent: null,
        delayTimeout: null
    };
};
var $e295770be29ab0ab$var$currentPositionX = function currentPositionX(options) {
    var containerElement = options.data.containerElement;
    if (containerElement && containerElement !== document && containerElement !== document.body) return containerElement.scrollLeft;
    else {
        var supportPageOffset = window.pageXOffset !== undefined;
        var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
        return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
    }
};
var $e295770be29ab0ab$var$currentPositionY = function currentPositionY(options) {
    var containerElement = options.data.containerElement;
    if (containerElement && containerElement !== document && containerElement !== document.body) return containerElement.scrollTop;
    else {
        var supportPageOffset = window.pageXOffset !== undefined;
        var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
        return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    }
};
var $e295770be29ab0ab$var$scrollContainerWidth = function scrollContainerWidth(options) {
    var containerElement = options.data.containerElement;
    if (containerElement && containerElement !== document && containerElement !== document.body) return containerElement.scrollWidth - containerElement.offsetWidth;
    else {
        var body = document.body;
        var html = document.documentElement;
        return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
    }
};
var $e295770be29ab0ab$var$scrollContainerHeight = function scrollContainerHeight(options) {
    var containerElement = options.data.containerElement;
    if (containerElement && containerElement !== document && containerElement !== document.body) return containerElement.scrollHeight - containerElement.offsetHeight;
    else {
        var body = document.body;
        var html = document.documentElement;
        return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    }
};
var $e295770be29ab0ab$var$animateScroll = function animateScroll(easing, options, timestamp) {
    var data = options.data;
    // Cancel on specific events
    if (!options.ignoreCancelEvents && data.cancel) {
        if ($e295770be29ab0ab$var$_scrollEvents2.default.registered["end"]) $e295770be29ab0ab$var$_scrollEvents2.default.registered["end"](data.to, data.target, data.currentPositionY);
        return;
    }
    data.delta = Math.round(data.targetPosition - data.startPosition);
    if (data.start === null) data.start = timestamp;
    data.progress = timestamp - data.start;
    data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);
    data.currentPosition = data.startPosition + Math.ceil(data.delta * data.percent);
    if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
        if (options.horizontal) data.containerElement.scrollLeft = data.currentPosition;
        else data.containerElement.scrollTop = data.currentPosition;
    } else if (options.horizontal) window.scrollTo(data.currentPosition, 0);
    else window.scrollTo(0, data.currentPosition);
    if (data.percent < 1) {
        var easedAnimate = animateScroll.bind(null, easing, options);
        $e295770be29ab0ab$var$requestAnimationFrameHelper.call(window, easedAnimate);
        return;
    }
    if ($e295770be29ab0ab$var$_scrollEvents2.default.registered["end"]) $e295770be29ab0ab$var$_scrollEvents2.default.registered["end"](data.to, data.target, data.currentPosition);
};
var $e295770be29ab0ab$var$setContainer = function setContainer(options) {
    options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};
var $e295770be29ab0ab$var$animateTopScroll = function animateTopScroll(scrollOffset, options, to, target) {
    options.data = options.data || $e295770be29ab0ab$var$makeData();
    window.clearTimeout(options.data.delayTimeout);
    var setCancel = function setCancel() {
        options.data.cancel = true;
    };
    $e295770be29ab0ab$var$_cancelEvents2.default.subscribe(setCancel);
    $e295770be29ab0ab$var$setContainer(options);
    options.data.start = null;
    options.data.cancel = false;
    options.data.startPosition = options.horizontal ? $e295770be29ab0ab$var$currentPositionX(options) : $e295770be29ab0ab$var$currentPositionY(options);
    options.data.targetPosition = options.absolute ? scrollOffset : scrollOffset + options.data.startPosition;
    if (options.data.startPosition === options.data.targetPosition) {
        if ($e295770be29ab0ab$var$_scrollEvents2.default.registered["end"]) $e295770be29ab0ab$var$_scrollEvents2.default.registered["end"](options.data.to, options.data.target, options.data.currentPosition);
        return;
    }
    options.data.delta = Math.round(options.data.targetPosition - options.data.startPosition);
    options.data.duration = $e295770be29ab0ab$var$functionWrapper(options.duration)(options.data.delta);
    options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
    options.data.to = to;
    options.data.target = target;
    var easing = $e295770be29ab0ab$var$getAnimationType(options);
    var easedAnimate = $e295770be29ab0ab$var$animateScroll.bind(null, easing, options);
    if (options && options.delay > 0) {
        options.data.delayTimeout = window.setTimeout(function() {
            if ($e295770be29ab0ab$var$_scrollEvents2.default.registered["begin"]) $e295770be29ab0ab$var$_scrollEvents2.default.registered["begin"](options.data.to, options.data.target);
            $e295770be29ab0ab$var$requestAnimationFrameHelper.call(window, easedAnimate);
        }, options.delay);
        return;
    }
    if ($e295770be29ab0ab$var$_scrollEvents2.default.registered["begin"]) $e295770be29ab0ab$var$_scrollEvents2.default.registered["begin"](options.data.to, options.data.target);
    $e295770be29ab0ab$var$requestAnimationFrameHelper.call(window, easedAnimate);
};
var $e295770be29ab0ab$var$proceedOptions = function proceedOptions(options) {
    options = $e295770be29ab0ab$var$_extends({}, options);
    options.data = options.data || $e295770be29ab0ab$var$makeData();
    options.absolute = true;
    return options;
};
var $e295770be29ab0ab$var$scrollToTop = function scrollToTop(options) {
    $e295770be29ab0ab$var$animateTopScroll(0, $e295770be29ab0ab$var$proceedOptions(options));
};
var $e295770be29ab0ab$var$scrollTo = function scrollTo(toPosition, options) {
    $e295770be29ab0ab$var$animateTopScroll(toPosition, $e295770be29ab0ab$var$proceedOptions(options));
};
var $e295770be29ab0ab$var$scrollToBottom = function scrollToBottom(options) {
    options = $e295770be29ab0ab$var$proceedOptions(options);
    $e295770be29ab0ab$var$setContainer(options);
    $e295770be29ab0ab$var$animateTopScroll(options.horizontal ? $e295770be29ab0ab$var$scrollContainerWidth(options) : $e295770be29ab0ab$var$scrollContainerHeight(options), options);
};
var $e295770be29ab0ab$var$scrollMore = function scrollMore(toPosition, options) {
    options = $e295770be29ab0ab$var$proceedOptions(options);
    $e295770be29ab0ab$var$setContainer(options);
    var currentPosition = options.horizontal ? $e295770be29ab0ab$var$currentPositionX(options) : $e295770be29ab0ab$var$currentPositionY(options);
    $e295770be29ab0ab$var$animateTopScroll(toPosition + currentPosition, options);
};
$e295770be29ab0ab$exports.default = {
    animateTopScroll: $e295770be29ab0ab$var$animateTopScroll,
    getAnimationType: $e295770be29ab0ab$var$getAnimationType,
    scrollToTop: $e295770be29ab0ab$var$scrollToTop,
    scrollToBottom: $e295770be29ab0ab$var$scrollToBottom,
    scrollTo: $e295770be29ab0ab$var$scrollTo,
    scrollMore: $e295770be29ab0ab$var$scrollMore
};


var $99220e484bceaab2$var$_animateScroll2 = $99220e484bceaab2$var$_interopRequireDefault($e295770be29ab0ab$exports);

var $99220e484bceaab2$var$_scrollEvents2 = $99220e484bceaab2$var$_interopRequireDefault($0acfeb05094780be$exports);
function $99220e484bceaab2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $99220e484bceaab2$var$__mapped = {};
var $99220e484bceaab2$var$__activeLink = void 0;
$99220e484bceaab2$exports.default = {
    unmount: function unmount() {
        $99220e484bceaab2$var$__mapped = {};
    },
    register: function register(name, element) {
        $99220e484bceaab2$var$__mapped[name] = element;
    },
    unregister: function unregister(name) {
        delete $99220e484bceaab2$var$__mapped[name];
    },
    get: function get(name) {
        return $99220e484bceaab2$var$__mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
    },
    setActiveLink: function setActiveLink(link) {
        return $99220e484bceaab2$var$__activeLink = link;
    },
    getActiveLink: function getActiveLink() {
        return $99220e484bceaab2$var$__activeLink;
    },
    scrollTo: function scrollTo(to, props) {
        var target = this.get(to);
        if (!target) {
            console.warn("target Element not found");
            return;
        }
        props = $99220e484bceaab2$var$_extends({}, props, {
            absolute: false
        });
        var containerId = props.containerId;
        var container = props.container;
        var containerElement = void 0;
        if (containerId) containerElement = document.getElementById(containerId);
        else if (container && container.nodeType) containerElement = container;
        else containerElement = document;
        props.absolute = true;
        var horizontal = props.horizontal;
        var scrollOffset = $99220e484bceaab2$var$_utils2.default.scrollOffset(containerElement, target, horizontal) + (props.offset || 0);
        /*
     * if animate is not provided just scroll into the view
     */ if (!props.smooth) {
            if ($99220e484bceaab2$var$_scrollEvents2.default.registered["begin"]) $99220e484bceaab2$var$_scrollEvents2.default.registered["begin"](to, target);
            if (containerElement === document) {
                if (props.horizontal) window.scrollTo(scrollOffset, 0);
                else window.scrollTo(0, scrollOffset);
            } else containerElement.scrollTop = scrollOffset;
            if ($99220e484bceaab2$var$_scrollEvents2.default.registered["end"]) $99220e484bceaab2$var$_scrollEvents2.default.registered["end"](to, target);
            return;
        }
        /*
     * Animate scrolling
     */ $99220e484bceaab2$var$_animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
    }
};


var $86aa1a05565412c2$var$_scroller2 = $86aa1a05565412c2$var$_interopRequireDefault($99220e484bceaab2$exports);
var $83b60b9412ae0b7d$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $83b60b9412ae0b7d$var$ReactIs, $83b60b9412ae0b7d$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$83b60b9412ae0b7d$exports = (parcelRequire("kW665"))();


var $86aa1a05565412c2$var$_propTypes2 = $86aa1a05565412c2$var$_interopRequireDefault($83b60b9412ae0b7d$exports);
var $f50ac55a9b0ecdf7$exports = {};
"use strict";
Object.defineProperty($f50ac55a9b0ecdf7$exports, "__esModule", {
    value: true
});


var $f50ac55a9b0ecdf7$var$_utils2 = $f50ac55a9b0ecdf7$var$_interopRequireDefault($70dfa4a5c9bb578a$exports);
function $f50ac55a9b0ecdf7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f50ac55a9b0ecdf7$var$scrollHash = {
    mountFlag: false,
    initialized: false,
    scroller: null,
    containers: {},
    mount: function mount(scroller) {
        this.scroller = scroller;
        this.handleHashChange = this.handleHashChange.bind(this);
        window.addEventListener("hashchange", this.handleHashChange);
        this.initStateFromHash();
        this.mountFlag = true;
    },
    mapContainer: function mapContainer(to, container) {
        this.containers[to] = container;
    },
    isMounted: function isMounted() {
        return this.mountFlag;
    },
    isInitialized: function isInitialized() {
        return this.initialized;
    },
    initStateFromHash: function initStateFromHash() {
        var _this = this;
        var hash = this.getHash();
        if (hash) window.setTimeout(function() {
            _this.scrollTo(hash, true);
            _this.initialized = true;
        }, 10);
        else this.initialized = true;
    },
    scrollTo: function scrollTo(to, isInit) {
        var scroller = this.scroller;
        var element = scroller.get(to);
        if (element && (isInit || to !== scroller.getActiveLink())) {
            var container = this.containers[to] || document;
            scroller.scrollTo(to, {
                container: container
            });
        }
    },
    getHash: function getHash() {
        return $f50ac55a9b0ecdf7$var$_utils2.default.getHash();
    },
    changeHash: function changeHash(to, saveHashHistory) {
        if (this.isInitialized() && $f50ac55a9b0ecdf7$var$_utils2.default.getHash() !== to) $f50ac55a9b0ecdf7$var$_utils2.default.updateHash(to, saveHashHistory);
    },
    handleHashChange: function handleHashChange() {
        this.scrollTo(this.getHash());
    },
    unmount: function unmount() {
        this.scroller = null;
        this.containers = null;
        window.removeEventListener("hashchange", this.handleHashChange);
    }
};
$f50ac55a9b0ecdf7$exports.default = $f50ac55a9b0ecdf7$var$scrollHash;


var $86aa1a05565412c2$var$_scrollHash2 = $86aa1a05565412c2$var$_interopRequireDefault($f50ac55a9b0ecdf7$exports);
function $86aa1a05565412c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $86aa1a05565412c2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $86aa1a05565412c2$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $86aa1a05565412c2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $86aa1a05565412c2$var$protoTypes = {
    to: $86aa1a05565412c2$var$_propTypes2.default.string.isRequired,
    containerId: $86aa1a05565412c2$var$_propTypes2.default.string,
    container: $86aa1a05565412c2$var$_propTypes2.default.object,
    activeClass: $86aa1a05565412c2$var$_propTypes2.default.string,
    activeStyle: $86aa1a05565412c2$var$_propTypes2.default.object,
    spy: $86aa1a05565412c2$var$_propTypes2.default.bool,
    horizontal: $86aa1a05565412c2$var$_propTypes2.default.bool,
    smooth: $86aa1a05565412c2$var$_propTypes2.default.oneOfType([
        $86aa1a05565412c2$var$_propTypes2.default.bool,
        $86aa1a05565412c2$var$_propTypes2.default.string
    ]),
    offset: $86aa1a05565412c2$var$_propTypes2.default.number,
    delay: $86aa1a05565412c2$var$_propTypes2.default.number,
    isDynamic: $86aa1a05565412c2$var$_propTypes2.default.bool,
    onClick: $86aa1a05565412c2$var$_propTypes2.default.func,
    duration: $86aa1a05565412c2$var$_propTypes2.default.oneOfType([
        $86aa1a05565412c2$var$_propTypes2.default.number,
        $86aa1a05565412c2$var$_propTypes2.default.func
    ]),
    absolute: $86aa1a05565412c2$var$_propTypes2.default.bool,
    onSetActive: $86aa1a05565412c2$var$_propTypes2.default.func,
    onSetInactive: $86aa1a05565412c2$var$_propTypes2.default.func,
    ignoreCancelEvents: $86aa1a05565412c2$var$_propTypes2.default.bool,
    hashSpy: $86aa1a05565412c2$var$_propTypes2.default.bool,
    saveHashHistory: $86aa1a05565412c2$var$_propTypes2.default.bool,
    spyThrottle: $86aa1a05565412c2$var$_propTypes2.default.number
};
$86aa1a05565412c2$exports.default = function(Component, customScroller) {
    var scroller = customScroller || $86aa1a05565412c2$var$_scroller2.default;
    var Link = function(_React$PureComponent) {
        $86aa1a05565412c2$var$_inherits(Link, _React$PureComponent);
        function Link(props) {
            $86aa1a05565412c2$var$_classCallCheck(this, Link);
            var _this = $86aa1a05565412c2$var$_possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));
            _initialiseProps.call(_this);
            _this.state = {
                active: false
            };
            return _this;
        }
        $86aa1a05565412c2$var$_createClass(Link, [
            {
                key: "getScrollSpyContainer",
                value: function getScrollSpyContainer() {
                    var containerId = this.props.containerId;
                    var container = this.props.container;
                    if (containerId && !container) return document.getElementById(containerId);
                    if (container && container.nodeType) return container;
                    return document;
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (this.props.spy || this.props.hashSpy) {
                        var scrollSpyContainer = this.getScrollSpyContainer();
                        if (!$86aa1a05565412c2$var$_scrollSpy2.default.isMounted(scrollSpyContainer)) $86aa1a05565412c2$var$_scrollSpy2.default.mount(scrollSpyContainer, this.props.spyThrottle);
                        if (this.props.hashSpy) {
                            if (!$86aa1a05565412c2$var$_scrollHash2.default.isMounted()) $86aa1a05565412c2$var$_scrollHash2.default.mount(scroller);
                            $86aa1a05565412c2$var$_scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
                        }
                        $86aa1a05565412c2$var$_scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);
                        this.setState({
                            container: scrollSpyContainer
                        });
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    $86aa1a05565412c2$var$_scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
                }
            },
            {
                key: "render",
                value: function render() {
                    var className = "";
                    if (this.state && this.state.active) className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
                    else className = this.props.className;
                    var style = {};
                    if (this.state && this.state.active) style = $86aa1a05565412c2$var$_extends({}, this.props.style, this.props.activeStyle);
                    else style = $86aa1a05565412c2$var$_extends({}, this.props.style);
                    var props = $86aa1a05565412c2$var$_extends({}, this.props);
                    for(var prop in $86aa1a05565412c2$var$protoTypes)if (props.hasOwnProperty(prop)) delete props[prop];
                    props.className = className;
                    props.style = style;
                    props.onClick = this.handleClick;
                    return $86aa1a05565412c2$var$_react2.default.createElement(Component, props);
                }
            }
        ]);
        return Link;
    }($86aa1a05565412c2$var$_react2.default.PureComponent);
    var _initialiseProps = function _initialiseProps() {
        var _this2 = this;
        this.scrollTo = function(to, props) {
            scroller.scrollTo(to, $86aa1a05565412c2$var$_extends({}, _this2.state, props));
        };
        this.handleClick = function(event) {
            /*
       * give the posibility to override onClick
       */ if (_this2.props.onClick) _this2.props.onClick(event);
            /*
       * dont bubble the navigation
       */ if (event.stopPropagation) event.stopPropagation();
            if (event.preventDefault) event.preventDefault();
            /*
       * do the magic!
       */ _this2.scrollTo(_this2.props.to, _this2.props);
        };
        this.spyHandler = function(x, y) {
            var scrollSpyContainer = _this2.getScrollSpyContainer();
            if ($86aa1a05565412c2$var$_scrollHash2.default.isMounted() && !$86aa1a05565412c2$var$_scrollHash2.default.isInitialized()) return;
            var horizontal = _this2.props.horizontal;
            var to = _this2.props.to;
            var element = null;
            var isInside = void 0;
            var isOutside = void 0;
            if (horizontal) {
                var elemLeftBound = 0;
                var elemRightBound = 0;
                var containerLeft = 0;
                if (scrollSpyContainer.getBoundingClientRect) {
                    var containerCords = scrollSpyContainer.getBoundingClientRect();
                    containerLeft = containerCords.left;
                }
                if (!element || _this2.props.isDynamic) {
                    element = scroller.get(to);
                    if (!element) return;
                    var cords = element.getBoundingClientRect();
                    elemLeftBound = cords.left - containerLeft + x;
                    elemRightBound = elemLeftBound + cords.width;
                }
                var offsetX = x - _this2.props.offset;
                isInside = offsetX >= Math.floor(elemLeftBound) && offsetX < Math.floor(elemRightBound);
                isOutside = offsetX < Math.floor(elemLeftBound) || offsetX >= Math.floor(elemRightBound);
            } else {
                var elemTopBound = 0;
                var elemBottomBound = 0;
                var containerTop = 0;
                if (scrollSpyContainer.getBoundingClientRect) {
                    var _containerCords = scrollSpyContainer.getBoundingClientRect();
                    containerTop = _containerCords.top;
                }
                if (!element || _this2.props.isDynamic) {
                    element = scroller.get(to);
                    if (!element) return;
                    var _cords = element.getBoundingClientRect();
                    elemTopBound = _cords.top - containerTop + y;
                    elemBottomBound = elemTopBound + _cords.height;
                }
                var offsetY = y - _this2.props.offset;
                isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
                isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
            }
            var activeLink = scroller.getActiveLink();
            if (isOutside) {
                if (to === activeLink) scroller.setActiveLink(void 0);
                if (_this2.props.hashSpy && $86aa1a05565412c2$var$_scrollHash2.default.getHash() === to) {
                    var _props$saveHashHistor = _this2.props.saveHashHistory, saveHashHistory = _props$saveHashHistor === undefined ? false : _props$saveHashHistor;
                    $86aa1a05565412c2$var$_scrollHash2.default.changeHash("", saveHashHistory);
                }
                if (_this2.props.spy && _this2.state.active) {
                    _this2.setState({
                        active: false
                    });
                    _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
                }
            }
            if (isInside && (activeLink !== to || _this2.state.active === false)) {
                scroller.setActiveLink(to);
                var _props$saveHashHistor2 = _this2.props.saveHashHistory, _saveHashHistory = _props$saveHashHistor2 === undefined ? false : _props$saveHashHistor2;
                _this2.props.hashSpy && $86aa1a05565412c2$var$_scrollHash2.default.changeHash(to, _saveHashHistory);
                if (_this2.props.spy) {
                    _this2.setState({
                        active: true
                    });
                    _this2.props.onSetActive && _this2.props.onSetActive(to, element);
                }
            }
        };
    };
    Link.propTypes = $86aa1a05565412c2$var$protoTypes;
    Link.defaultProps = {
        offset: 0
    };
    return Link;
};


var $e04709a490bd9456$var$_scrollLink2 = $e04709a490bd9456$var$_interopRequireDefault($86aa1a05565412c2$exports);
function $e04709a490bd9456$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e04709a490bd9456$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e04709a490bd9456$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e04709a490bd9456$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $e04709a490bd9456$var$LinkElement = function(_React$Component) {
    $e04709a490bd9456$var$_inherits(LinkElement, _React$Component);
    function LinkElement() {
        var _ref;
        var _temp, _this, _ret;
        $e04709a490bd9456$var$_classCallCheck(this, LinkElement);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $e04709a490bd9456$var$_possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.render = function() {
            return $e04709a490bd9456$var$_react2.default.createElement("a", _this.props, _this.props.children);
        }, _temp), $e04709a490bd9456$var$_possibleConstructorReturn(_this, _ret);
    }
    return LinkElement;
}($e04709a490bd9456$var$_react2.default.Component);
$e04709a490bd9456$exports.default = (0, $e04709a490bd9456$var$_scrollLink2.default)($e04709a490bd9456$var$LinkElement);


var $a2c2034c49841d6d$var$_Link2 = $a2c2034c49841d6d$var$_interopRequireDefault($e04709a490bd9456$exports);
var $4d193c205a0c4e68$exports = {};
"use strict";
Object.defineProperty($4d193c205a0c4e68$exports, "__esModule", {
    value: true
});
var $4d193c205a0c4e68$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $4RFnf = parcelRequire("4RFnf");
var $4d193c205a0c4e68$var$_react2 = $4d193c205a0c4e68$var$_interopRequireDefault($4RFnf);

var $4d193c205a0c4e68$var$_scrollLink2 = $4d193c205a0c4e68$var$_interopRequireDefault($86aa1a05565412c2$exports);
function $4d193c205a0c4e68$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4d193c205a0c4e68$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4d193c205a0c4e68$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $4d193c205a0c4e68$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $4d193c205a0c4e68$var$ButtonElement = function(_React$Component) {
    $4d193c205a0c4e68$var$_inherits(ButtonElement, _React$Component);
    function ButtonElement() {
        $4d193c205a0c4e68$var$_classCallCheck(this, ButtonElement);
        return $4d193c205a0c4e68$var$_possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
    }
    $4d193c205a0c4e68$var$_createClass(ButtonElement, [
        {
            key: "render",
            value: function render() {
                return $4d193c205a0c4e68$var$_react2.default.createElement("button", this.props, this.props.children);
            }
        }
    ]);
    return ButtonElement;
}($4d193c205a0c4e68$var$_react2.default.Component);
$4d193c205a0c4e68$exports.default = (0, $4d193c205a0c4e68$var$_scrollLink2.default)($4d193c205a0c4e68$var$ButtonElement);


var $a2c2034c49841d6d$var$_Button2 = $a2c2034c49841d6d$var$_interopRequireDefault($4d193c205a0c4e68$exports);
var $fc4ffabc696ca138$exports = {};
"use strict";
Object.defineProperty($fc4ffabc696ca138$exports, "__esModule", {
    value: true
});
var $fc4ffabc696ca138$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $fc4ffabc696ca138$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $4RFnf = parcelRequire("4RFnf");
var $fc4ffabc696ca138$var$_react2 = $fc4ffabc696ca138$var$_interopRequireDefault($4RFnf);
var $9fe95fe82c3296a0$exports = {};
"use strict";
Object.defineProperty($9fe95fe82c3296a0$exports, "__esModule", {
    value: true
});
var $9fe95fe82c3296a0$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $9fe95fe82c3296a0$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $4RFnf = parcelRequire("4RFnf");
var $9fe95fe82c3296a0$var$_react2 = $9fe95fe82c3296a0$var$_interopRequireDefault($4RFnf);

var $9fe95fe82c3296a0$var$_reactDom2 = $9fe95fe82c3296a0$var$_interopRequireDefault($6ce1434187f7101c$exports);

var $9fe95fe82c3296a0$var$_scroller2 = $9fe95fe82c3296a0$var$_interopRequireDefault($99220e484bceaab2$exports);

var $9fe95fe82c3296a0$var$_propTypes2 = $9fe95fe82c3296a0$var$_interopRequireDefault($83b60b9412ae0b7d$exports);
function $9fe95fe82c3296a0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9fe95fe82c3296a0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9fe95fe82c3296a0$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9fe95fe82c3296a0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
$9fe95fe82c3296a0$exports.default = function(Component) {
    var Element = function(_React$Component) {
        $9fe95fe82c3296a0$var$_inherits(Element, _React$Component);
        function Element(props) {
            $9fe95fe82c3296a0$var$_classCallCheck(this, Element);
            var _this = $9fe95fe82c3296a0$var$_possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));
            _this.childBindings = {
                domNode: null
            };
            return _this;
        }
        $9fe95fe82c3296a0$var$_createClass(Element, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (typeof window === "undefined") return false;
                    this.registerElems(this.props.name);
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (this.props.name !== prevProps.name) this.registerElems(this.props.name);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (typeof window === "undefined") return false;
                    $9fe95fe82c3296a0$var$_scroller2.default.unregister(this.props.name);
                }
            },
            {
                key: "registerElems",
                value: function registerElems(name) {
                    $9fe95fe82c3296a0$var$_scroller2.default.register(name, this.childBindings.domNode);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $9fe95fe82c3296a0$var$_react2.default.createElement(Component, $9fe95fe82c3296a0$var$_extends({}, this.props, {
                        parentBindings: this.childBindings
                    }));
                }
            }
        ]);
        return Element;
    }($9fe95fe82c3296a0$var$_react2.default.Component);
    Element.propTypes = {
        name: $9fe95fe82c3296a0$var$_propTypes2.default.string,
        id: $9fe95fe82c3296a0$var$_propTypes2.default.string
    };
    return Element;
};


var $fc4ffabc696ca138$var$_scrollElement2 = $fc4ffabc696ca138$var$_interopRequireDefault($9fe95fe82c3296a0$exports);

var $fc4ffabc696ca138$var$_propTypes2 = $fc4ffabc696ca138$var$_interopRequireDefault($83b60b9412ae0b7d$exports);
function $fc4ffabc696ca138$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fc4ffabc696ca138$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fc4ffabc696ca138$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $fc4ffabc696ca138$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $fc4ffabc696ca138$var$ElementWrapper = function(_React$Component) {
    $fc4ffabc696ca138$var$_inherits(ElementWrapper, _React$Component);
    function ElementWrapper() {
        $fc4ffabc696ca138$var$_classCallCheck(this, ElementWrapper);
        return $fc4ffabc696ca138$var$_possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
    }
    $fc4ffabc696ca138$var$_createClass(ElementWrapper, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                // Remove `parentBindings` and `name` from props
                var newProps = $fc4ffabc696ca138$var$_extends({}, this.props);
                delete newProps.name;
                if (newProps.parentBindings) delete newProps.parentBindings;
                return $fc4ffabc696ca138$var$_react2.default.createElement("div", $fc4ffabc696ca138$var$_extends({}, newProps, {
                    ref: function ref(el) {
                        _this2.props.parentBindings.domNode = el;
                    }
                }), this.props.children);
            }
        }
    ]);
    return ElementWrapper;
}($fc4ffabc696ca138$var$_react2.default.Component);
$fc4ffabc696ca138$var$ElementWrapper.propTypes = {
    name: $fc4ffabc696ca138$var$_propTypes2.default.string,
    id: $fc4ffabc696ca138$var$_propTypes2.default.string
};
$fc4ffabc696ca138$exports.default = (0, $fc4ffabc696ca138$var$_scrollElement2.default)($fc4ffabc696ca138$var$ElementWrapper);


var $a2c2034c49841d6d$var$_Element2 = $a2c2034c49841d6d$var$_interopRequireDefault($fc4ffabc696ca138$exports);

var $a2c2034c49841d6d$var$_scroller2 = $a2c2034c49841d6d$var$_interopRequireDefault($99220e484bceaab2$exports);

var $a2c2034c49841d6d$var$_scrollEvents2 = $a2c2034c49841d6d$var$_interopRequireDefault($0acfeb05094780be$exports);

var $a2c2034c49841d6d$var$_scrollSpy2 = $a2c2034c49841d6d$var$_interopRequireDefault($6764d9ed537cea08$exports);

var $a2c2034c49841d6d$var$_animateScroll2 = $a2c2034c49841d6d$var$_interopRequireDefault($e295770be29ab0ab$exports);

var $a2c2034c49841d6d$var$_scrollLink2 = $a2c2034c49841d6d$var$_interopRequireDefault($86aa1a05565412c2$exports);

var $a2c2034c49841d6d$var$_scrollElement2 = $a2c2034c49841d6d$var$_interopRequireDefault($9fe95fe82c3296a0$exports);
var $90b0d4faa5627c8f$exports = {};
"use strict";
/* DEPRECATED */ var $90b0d4faa5627c8f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $90b0d4faa5627c8f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $90b0d4faa5627c8f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $90b0d4faa5627c8f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $90b0d4faa5627c8f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $4RFnf = parcelRequire("4RFnf");






var $90b0d4faa5627c8f$var$protoTypes = {
    to: $83b60b9412ae0b7d$exports.string.isRequired,
    containerId: $83b60b9412ae0b7d$exports.string,
    container: $83b60b9412ae0b7d$exports.object,
    activeClass: $83b60b9412ae0b7d$exports.string,
    spy: $83b60b9412ae0b7d$exports.bool,
    smooth: $83b60b9412ae0b7d$exports.oneOfType([
        $83b60b9412ae0b7d$exports.bool,
        $83b60b9412ae0b7d$exports.string
    ]),
    offset: $83b60b9412ae0b7d$exports.number,
    delay: $83b60b9412ae0b7d$exports.number,
    isDynamic: $83b60b9412ae0b7d$exports.bool,
    onClick: $83b60b9412ae0b7d$exports.func,
    duration: $83b60b9412ae0b7d$exports.oneOfType([
        $83b60b9412ae0b7d$exports.number,
        $83b60b9412ae0b7d$exports.func
    ]),
    absolute: $83b60b9412ae0b7d$exports.bool,
    onSetActive: $83b60b9412ae0b7d$exports.func,
    onSetInactive: $83b60b9412ae0b7d$exports.func,
    ignoreCancelEvents: $83b60b9412ae0b7d$exports.bool,
    hashSpy: $83b60b9412ae0b7d$exports.bool,
    spyThrottle: $83b60b9412ae0b7d$exports.number
};
var $90b0d4faa5627c8f$var$Helpers = {
    Scroll: function Scroll(Component, customScroller) {
        console.warn("Helpers.Scroll is deprecated since v1.7.0");
        var scroller = customScroller || $99220e484bceaab2$exports;
        var Scroll = function(_React$Component) {
            $90b0d4faa5627c8f$var$_inherits(Scroll, _React$Component);
            function Scroll(props) {
                $90b0d4faa5627c8f$var$_classCallCheck(this, Scroll);
                var _this = $90b0d4faa5627c8f$var$_possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));
                _initialiseProps.call(_this);
                _this.state = {
                    active: false
                };
                return _this;
            }
            $90b0d4faa5627c8f$var$_createClass(Scroll, [
                {
                    key: "getScrollSpyContainer",
                    value: function getScrollSpyContainer() {
                        var containerId = this.props.containerId;
                        var container = this.props.container;
                        if (containerId) return document.getElementById(containerId);
                        if (container && container.nodeType) return container;
                        return document;
                    }
                },
                {
                    key: "componentDidMount",
                    value: function componentDidMount() {
                        if (this.props.spy || this.props.hashSpy) {
                            var scrollSpyContainer = this.getScrollSpyContainer();
                            if (!$6764d9ed537cea08$exports.isMounted(scrollSpyContainer)) $6764d9ed537cea08$exports.mount(scrollSpyContainer, this.props.spyThrottle);
                            if (this.props.hashSpy) {
                                if (!$f50ac55a9b0ecdf7$exports.isMounted()) $f50ac55a9b0ecdf7$exports.mount(scroller);
                                $f50ac55a9b0ecdf7$exports.mapContainer(this.props.to, scrollSpyContainer);
                            }
                            if (this.props.spy) $6764d9ed537cea08$exports.addStateHandler(this.stateHandler);
                            $6764d9ed537cea08$exports.addSpyHandler(this.spyHandler, scrollSpyContainer);
                            this.setState({
                                container: scrollSpyContainer
                            });
                        }
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function componentWillUnmount() {
                        $6764d9ed537cea08$exports.unmount(this.stateHandler, this.spyHandler);
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        var className = "";
                        if (this.state && this.state.active) className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
                        else className = this.props.className;
                        var props = $90b0d4faa5627c8f$var$_extends({}, this.props);
                        for(var prop in $90b0d4faa5627c8f$var$protoTypes)if (props.hasOwnProperty(prop)) delete props[prop];
                        props.className = className;
                        props.onClick = this.handleClick;
                        return $4RFnf.createElement(Component, props);
                    }
                }
            ]);
            return Scroll;
        }($4RFnf.Component);
        var _initialiseProps = function _initialiseProps() {
            var _this2 = this;
            this.scrollTo = function(to, props) {
                scroller.scrollTo(to, $90b0d4faa5627c8f$var$_extends({}, _this2.state, props));
            };
            this.handleClick = function(event) {
                /*
         * give the posibility to override onClick
         */ if (_this2.props.onClick) _this2.props.onClick(event);
                /*
         * dont bubble the navigation
         */ if (event.stopPropagation) event.stopPropagation();
                if (event.preventDefault) event.preventDefault();
                /*
         * do the magic!
         */ _this2.scrollTo(_this2.props.to, _this2.props);
            };
            this.stateHandler = function() {
                if (scroller.getActiveLink() !== _this2.props.to) {
                    if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) _this2.props.onSetInactive();
                    _this2.setState({
                        active: false
                    });
                }
            };
            this.spyHandler = function(y) {
                var scrollSpyContainer = _this2.getScrollSpyContainer();
                if ($f50ac55a9b0ecdf7$exports.isMounted() && !$f50ac55a9b0ecdf7$exports.isInitialized()) return;
                var to = _this2.props.to;
                var element = null;
                var elemTopBound = 0;
                var elemBottomBound = 0;
                var containerTop = 0;
                if (scrollSpyContainer.getBoundingClientRect) {
                    var containerCords = scrollSpyContainer.getBoundingClientRect();
                    containerTop = containerCords.top;
                }
                if (!element || _this2.props.isDynamic) {
                    element = scroller.get(to);
                    if (!element) return;
                    var cords = element.getBoundingClientRect();
                    elemTopBound = cords.top - containerTop + y;
                    elemBottomBound = elemTopBound + cords.height;
                }
                var offsetY = y - _this2.props.offset;
                var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
                var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
                var activeLink = scroller.getActiveLink();
                if (isOutside) {
                    if (to === activeLink) scroller.setActiveLink(void 0);
                    if (_this2.props.hashSpy && $f50ac55a9b0ecdf7$exports.getHash() === to) $f50ac55a9b0ecdf7$exports.changeHash();
                    if (_this2.props.spy && _this2.state.active) {
                        _this2.setState({
                            active: false
                        });
                        _this2.props.onSetInactive && _this2.props.onSetInactive();
                    }
                    return $6764d9ed537cea08$exports.updateStates();
                }
                if (isInside && activeLink !== to) {
                    scroller.setActiveLink(to);
                    _this2.props.hashSpy && $f50ac55a9b0ecdf7$exports.changeHash(to);
                    if (_this2.props.spy) {
                        _this2.setState({
                            active: true
                        });
                        _this2.props.onSetActive && _this2.props.onSetActive(to);
                    }
                    return $6764d9ed537cea08$exports.updateStates();
                }
            };
        };
        Scroll.propTypes = $90b0d4faa5627c8f$var$protoTypes;
        Scroll.defaultProps = {
            offset: 0
        };
        return Scroll;
    },
    Element: function Element(Component) {
        console.warn("Helpers.Element is deprecated since v1.7.0");
        var Element = function(_React$Component2) {
            $90b0d4faa5627c8f$var$_inherits(Element, _React$Component2);
            function Element(props) {
                $90b0d4faa5627c8f$var$_classCallCheck(this, Element);
                var _this3 = $90b0d4faa5627c8f$var$_possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));
                _this3.childBindings = {
                    domNode: null
                };
                return _this3;
            }
            $90b0d4faa5627c8f$var$_createClass(Element, [
                {
                    key: "componentDidMount",
                    value: function componentDidMount() {
                        if (typeof window === "undefined") return false;
                        this.registerElems(this.props.name);
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function componentDidUpdate(prevProps) {
                        if (this.props.name !== prevProps.name) this.registerElems(this.props.name);
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function componentWillUnmount() {
                        if (typeof window === "undefined") return false;
                        $99220e484bceaab2$exports.unregister(this.props.name);
                    }
                },
                {
                    key: "registerElems",
                    value: function registerElems(name) {
                        $99220e484bceaab2$exports.register(name, this.childBindings.domNode);
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        return $4RFnf.createElement(Component, $90b0d4faa5627c8f$var$_extends({}, this.props, {
                            parentBindings: this.childBindings
                        }));
                    }
                }
            ]);
            return Element;
        }($4RFnf.Component);
        Element.propTypes = {
            name: $83b60b9412ae0b7d$exports.string,
            id: $83b60b9412ae0b7d$exports.string
        };
        return Element;
    }
};
$90b0d4faa5627c8f$exports = $90b0d4faa5627c8f$var$Helpers;


var $a2c2034c49841d6d$var$_Helpers2 = $a2c2034c49841d6d$var$_interopRequireDefault($90b0d4faa5627c8f$exports);
function $a2c2034c49841d6d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$a2c2034c49841d6d$exports.Link = $a2c2034c49841d6d$var$_Link2.default;
$a2c2034c49841d6d$exports.Button = $a2c2034c49841d6d$var$_Button2.default;
$a2c2034c49841d6d$exports.Element = $a2c2034c49841d6d$var$_Element2.default;
$a2c2034c49841d6d$exports.scroller = $a2c2034c49841d6d$var$_scroller2.default;
$a2c2034c49841d6d$exports.Events = $a2c2034c49841d6d$var$_scrollEvents2.default;
$a2c2034c49841d6d$exports.scrollSpy = $a2c2034c49841d6d$var$_scrollSpy2.default;
$a2c2034c49841d6d$exports.animateScroll = $a2c2034c49841d6d$var$_animateScroll2.default;
$a2c2034c49841d6d$exports.ScrollLink = $a2c2034c49841d6d$var$_scrollLink2.default;
$a2c2034c49841d6d$exports.ScrollElement = $a2c2034c49841d6d$var$_scrollElement2.default;
$a2c2034c49841d6d$exports.Helpers = $a2c2034c49841d6d$var$_Helpers2.default;
$a2c2034c49841d6d$exports.default = {
    Link: $a2c2034c49841d6d$var$_Link2.default,
    Button: $a2c2034c49841d6d$var$_Button2.default,
    Element: $a2c2034c49841d6d$var$_Element2.default,
    scroller: $a2c2034c49841d6d$var$_scroller2.default,
    Events: $a2c2034c49841d6d$var$_scrollEvents2.default,
    scrollSpy: $a2c2034c49841d6d$var$_scrollSpy2.default,
    animateScroll: $a2c2034c49841d6d$var$_animateScroll2.default,
    ScrollLink: $a2c2034c49841d6d$var$_scrollLink2.default,
    ScrollElement: $a2c2034c49841d6d$var$_scrollElement2.default,
    Helpers: $a2c2034c49841d6d$var$_Helpers2.default
};


/**
 * React Router DOM v6.25.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4RFnf = parcelRequire("4RFnf");

/**
 * @remix-run/router v1.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $e352e4bbcb5a39c7$var$_extends() {
    $e352e4bbcb5a39c7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e352e4bbcb5a39c7$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $e352e4bbcb5a39c7$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($e352e4bbcb5a39c7$export$e19cd5f9376f8cee || ($e352e4bbcb5a39c7$export$e19cd5f9376f8cee = {}));
const $e352e4bbcb5a39c7$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $e352e4bbcb5a39c7$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $e352e4bbcb5a39c7$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $e352e4bbcb5a39c7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $e352e4bbcb5a39c7$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $e352e4bbcb5a39c7$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $e352e4bbcb5a39c7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $e352e4bbcb5a39c7$export$fe53371bee54353d(to);
    }
    return $e352e4bbcb5a39c7$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $e352e4bbcb5a39c7$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $e352e4bbcb5a39c7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $e352e4bbcb5a39c7$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $e352e4bbcb5a39c7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $e352e4bbcb5a39c7$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $e352e4bbcb5a39c7$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $e352e4bbcb5a39c7$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $e352e4bbcb5a39c7$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $e352e4bbcb5a39c7$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $e352e4bbcb5a39c7$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $e352e4bbcb5a39c7$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $e352e4bbcb5a39c7$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $e352e4bbcb5a39c7$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $e352e4bbcb5a39c7$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($e352e4bbcb5a39c7$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Push;
        let location = $e352e4bbcb5a39c7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $e352e4bbcb5a39c7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Replace;
        let location = $e352e4bbcb5a39c7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $e352e4bbcb5a39c7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $e352e4bbcb5a39c7$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($e352e4bbcb5a39c7$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($e352e4bbcb5a39c7$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $e352e4bbcb5a39c7$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($e352e4bbcb5a39c7$var$ResultType || ($e352e4bbcb5a39c7$var$ResultType = {}));
const $e352e4bbcb5a39c7$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $e352e4bbcb5a39c7$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $e352e4bbcb5a39c7$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($e352e4bbcb5a39c7$var$isIndexRoute(route)) {
            let indexRoute = $e352e4bbcb5a39c7$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $e352e4bbcb5a39c7$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $e352e4bbcb5a39c7$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $e352e4bbcb5a39c7$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $e352e4bbcb5a39c7$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $e352e4bbcb5a39c7$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $e352e4bbcb5a39c7$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $e352e4bbcb5a39c7$var$flattenRoutes(routes);
    $e352e4bbcb5a39c7$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $e352e4bbcb5a39c7$export$30d21fd6d7295f52(pathname);
        matches = $e352e4bbcb5a39c7$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $e352e4bbcb5a39c7$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $e352e4bbcb5a39c7$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $e352e4bbcb5a39c7$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $e352e4bbcb5a39c7$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $e352e4bbcb5a39c7$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $e352e4bbcb5a39c7$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $e352e4bbcb5a39c7$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $e352e4bbcb5a39c7$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $e352e4bbcb5a39c7$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $e352e4bbcb5a39c7$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $e352e4bbcb5a39c7$var$paramRe = /^:[\w-]+$/;
const $e352e4bbcb5a39c7$var$dynamicSegmentValue = 3;
const $e352e4bbcb5a39c7$var$indexRouteValue = 2;
const $e352e4bbcb5a39c7$var$emptySegmentValue = 1;
const $e352e4bbcb5a39c7$var$staticSegmentValue = 10;
const $e352e4bbcb5a39c7$var$splatPenalty = -2;
const $e352e4bbcb5a39c7$var$isSplat = (s)=>s === "*";
function $e352e4bbcb5a39c7$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($e352e4bbcb5a39c7$var$isSplat)) initialScore += $e352e4bbcb5a39c7$var$splatPenalty;
    if (index) initialScore += $e352e4bbcb5a39c7$var$indexRouteValue;
    return segments.filter((s)=>!$e352e4bbcb5a39c7$var$isSplat(s)).reduce((score, segment)=>score + ($e352e4bbcb5a39c7$var$paramRe.test(segment) ? $e352e4bbcb5a39c7$var$dynamicSegmentValue : segment === "" ? $e352e4bbcb5a39c7$var$emptySegmentValue : $e352e4bbcb5a39c7$var$staticSegmentValue), initialScore);
}
function $e352e4bbcb5a39c7$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $e352e4bbcb5a39c7$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $e352e4bbcb5a39c7$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $e352e4bbcb5a39c7$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $e352e4bbcb5a39c7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $e352e4bbcb5a39c7$export$a5c6d149b50c1d86($e352e4bbcb5a39c7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $e352e4bbcb5a39c7$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $e352e4bbcb5a39c7$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $e352e4bbcb5a39c7$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $e352e4bbcb5a39c7$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $e352e4bbcb5a39c7$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $e352e4bbcb5a39c7$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $e352e4bbcb5a39c7$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $e352e4bbcb5a39c7$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $e352e4bbcb5a39c7$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $e352e4bbcb5a39c7$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $e352e4bbcb5a39c7$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $e352e4bbcb5a39c7$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $e352e4bbcb5a39c7$var$normalizeSearch(search),
        hash: $e352e4bbcb5a39c7$var$normalizeHash(hash)
    };
}
function $e352e4bbcb5a39c7$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $e352e4bbcb5a39c7$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $e352e4bbcb5a39c7$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $e352e4bbcb5a39c7$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $e352e4bbcb5a39c7$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $e352e4bbcb5a39c7$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(toArg);
    else {
        to = $e352e4bbcb5a39c7$var$_extends({}, toArg);
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $e352e4bbcb5a39c7$var$getInvalidPathError("?", "pathname", "search", to));
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $e352e4bbcb5a39c7$var$getInvalidPathError("#", "pathname", "hash", to));
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $e352e4bbcb5a39c7$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $e352e4bbcb5a39c7$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $e352e4bbcb5a39c7$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $e352e4bbcb5a39c7$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $e352e4bbcb5a39c7$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $e352e4bbcb5a39c7$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $e352e4bbcb5a39c7$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $e352e4bbcb5a39c7$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $e352e4bbcb5a39c7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $e352e4bbcb5a39c7$export$42a99a7a4bc0e76a extends Error {
}
class $e352e4bbcb5a39c7$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $e352e4bbcb5a39c7$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $e352e4bbcb5a39c7$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $e352e4bbcb5a39c7$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $e352e4bbcb5a39c7$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $e352e4bbcb5a39c7$var$unwrapTrackedPromise(value) {
    if (!$e352e4bbcb5a39c7$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $e352e4bbcb5a39c7$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $e352e4bbcb5a39c7$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e352e4bbcb5a39c7$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $e352e4bbcb5a39c7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e352e4bbcb5a39c7$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $e352e4bbcb5a39c7$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $e352e4bbcb5a39c7$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $e352e4bbcb5a39c7$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $e352e4bbcb5a39c7$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $e352e4bbcb5a39c7$var$validMutationMethods = new Set($e352e4bbcb5a39c7$var$validMutationMethodsArr);
const $e352e4bbcb5a39c7$var$validRequestMethodsArr = [
    "get",
    ...$e352e4bbcb5a39c7$var$validMutationMethodsArr
];
const $e352e4bbcb5a39c7$var$validRequestMethods = new Set($e352e4bbcb5a39c7$var$validRequestMethodsArr);
const $e352e4bbcb5a39c7$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $e352e4bbcb5a39c7$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $e352e4bbcb5a39c7$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $e352e4bbcb5a39c7$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $e352e4bbcb5a39c7$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $e352e4bbcb5a39c7$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $e352e4bbcb5a39c7$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $e352e4bbcb5a39c7$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $e352e4bbcb5a39c7$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $e352e4bbcb5a39c7$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $e352e4bbcb5a39c7$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $e352e4bbcb5a39c7$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $e352e4bbcb5a39c7$var$defaultDataStrategy;
    let patchRoutesOnMissImpl = init.unstable_patchRoutesOnMiss;
    // Config driven behavior flags
    let future = $e352e4bbcb5a39c7$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $e352e4bbcb5a39c7$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnMissImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $e352e4bbcb5a39c7$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnMiss implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && patchRoutesOnMissImpl && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        // We need to run patchRoutesOnMiss in initialize()
        initialized = false;
        initialMatches = [];
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $e352e4bbcb5a39c7$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Map of pending patchRoutesOnMiss() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    let pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $e352e4bbcb5a39c7$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $e352e4bbcb5a39c7$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $e352e4bbcb5a39c7$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$e352e4bbcb5a39c7$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $e352e4bbcb5a39c7$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $e352e4bbcb5a39c7$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $e352e4bbcb5a39c7$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $e352e4bbcb5a39c7$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $e352e4bbcb5a39c7$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($e352e4bbcb5a39c7$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $e352e4bbcb5a39c7$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $e352e4bbcb5a39c7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $e352e4bbcb5a39c7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $e352e4bbcb5a39c7$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $e352e4bbcb5a39c7$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $e352e4bbcb5a39c7$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $e352e4bbcb5a39c7$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $e352e4bbcb5a39c7$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $e352e4bbcb5a39c7$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $e352e4bbcb5a39c7$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $e352e4bbcb5a39c7$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $e352e4bbcb5a39c7$var$findNearestBoundary(matches).route.id,
            {
                type: $e352e4bbcb5a39c7$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $e352e4bbcb5a39c7$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($e352e4bbcb5a39c7$var$isErrorResult(result) && $e352e4bbcb5a39c7$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $e352e4bbcb5a39c7$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $e352e4bbcb5a39c7$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $e352e4bbcb5a39c7$var$_extends({
            matches: updatedMatches || matches
        }, $e352e4bbcb5a39c7$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $e352e4bbcb5a39c7$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $e352e4bbcb5a39c7$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $e352e4bbcb5a39c7$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $e352e4bbcb5a39c7$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $e352e4bbcb5a39c7$var$ResultType.error,
            error: $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($e352e4bbcb5a39c7$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $e352e4bbcb5a39c7$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($e352e4bbcb5a39c7$var$isDeferredResult(result)) throw $e352e4bbcb5a39c7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($e352e4bbcb5a39c7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $e352e4bbcb5a39c7$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $e352e4bbcb5a39c7$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $e352e4bbcb5a39c7$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($e352e4bbcb5a39c7$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $e352e4bbcb5a39c7$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $e352e4bbcb5a39c7$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $e352e4bbcb5a39c7$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $e352e4bbcb5a39c7$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $e352e4bbcb5a39c7$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $e352e4bbcb5a39c7$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $e352e4bbcb5a39c7$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $e352e4bbcb5a39c7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $e352e4bbcb5a39c7$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $e352e4bbcb5a39c7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $e352e4bbcb5a39c7$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $e352e4bbcb5a39c7$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $e352e4bbcb5a39c7$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $e352e4bbcb5a39c7$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $e352e4bbcb5a39c7$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($e352e4bbcb5a39c7$var$isRedirectResult(actionResult) || $e352e4bbcb5a39c7$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $e352e4bbcb5a39c7$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($e352e4bbcb5a39c7$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $e352e4bbcb5a39c7$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $e352e4bbcb5a39c7$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($e352e4bbcb5a39c7$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($e352e4bbcb5a39c7$var$isDeferredResult(actionResult)) throw $e352e4bbcb5a39c7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $e352e4bbcb5a39c7$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $e352e4bbcb5a39c7$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $e352e4bbcb5a39c7$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $e352e4bbcb5a39c7$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $e352e4bbcb5a39c7$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $e352e4bbcb5a39c7$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $e352e4bbcb5a39c7$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $e352e4bbcb5a39c7$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $e352e4bbcb5a39c7$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $e352e4bbcb5a39c7$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $e352e4bbcb5a39c7$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $e352e4bbcb5a39c7$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($e352e4bbcb5a39c7$var$isDeferredResult(result)) result = await $e352e4bbcb5a39c7$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $e352e4bbcb5a39c7$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($e352e4bbcb5a39c7$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $e352e4bbcb5a39c7$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($e352e4bbcb5a39c7$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(!$e352e4bbcb5a39c7$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $e352e4bbcb5a39c7$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $e352e4bbcb5a39c7$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $e352e4bbcb5a39c7$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($e352e4bbcb5a39c7$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $e352e4bbcb5a39c7$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Replace : $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $e352e4bbcb5a39c7$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($e352e4bbcb5a39c7$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $e352e4bbcb5a39c7$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $e352e4bbcb5a39c7$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $e352e4bbcb5a39c7$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $e352e4bbcb5a39c7$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($e352e4bbcb5a39c7$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $e352e4bbcb5a39c7$var$ResultType.redirect,
                        response: $e352e4bbcb5a39c7$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $e352e4bbcb5a39c7$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $e352e4bbcb5a39c7$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $e352e4bbcb5a39c7$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $e352e4bbcb5a39c7$var$ResultType.error,
                    error: $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $e352e4bbcb5a39c7$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $e352e4bbcb5a39c7$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $e352e4bbcb5a39c7$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $e352e4bbcb5a39c7$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $e352e4bbcb5a39c7$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $e352e4bbcb5a39c7$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $e352e4bbcb5a39c7$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $e352e4bbcb5a39c7$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $e352e4bbcb5a39c7$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        return {
            boundaryId: $e352e4bbcb5a39c7$var$findNearestBoundary(discoverResult.partialMatches).route.id,
            error: $e352e4bbcb5a39c7$var$getInternalRouterError(400, {
                type: "route-discovery",
                pathname: pathname,
                message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
            })
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $e352e4bbcb5a39c7$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$e352e4bbcb5a39c7$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnMissImpl) {
            if (!matches) {
                let fogMatches = $e352e4bbcb5a39c7$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else {
                let leafRoute = matches[matches.length - 1].route;
                if (leafRoute.path && (leafRoute.path === "*" || leafRoute.path.endsWith("/*"))) {
                    // If we matched a splat, it might only be because we haven't yet fetched
                    // the children that would match with a higher score, so let's fetch
                    // around and find out
                    let partialMatches = $e352e4bbcb5a39c7$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    return {
                        active: true,
                        matches: partialMatches
                    };
                }
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        let partialMatches = matches;
        let route = partialMatches.length > 0 ? partialMatches[partialMatches.length - 1].route : null;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            try {
                await $e352e4bbcb5a39c7$var$loadLazyRouteChildren(patchRoutesOnMissImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal);
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $e352e4bbcb5a39c7$export$2708184779ceb39d(routesToUse, pathname, basename);
            let matchedSplat = false;
            if (newMatches) {
                let leafRoute = newMatches[newMatches.length - 1].route;
                if (leafRoute.index) // If we found an index route, we can stop
                return {
                    type: "success",
                    matches: newMatches
                };
                if (leafRoute.path && leafRoute.path.length > 0) {
                    if (leafRoute.path === "*") // If we found a splat route, we can't be sure there's not a
                    // higher-scoring route down some partial matches trail so we need
                    // to check that out
                    matchedSplat = true;
                    else // If we found a non-splat route, we can stop
                    return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            let newPartialMatches = $e352e4bbcb5a39c7$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // If we are no longer partially matching anything, this was either a
            // legit splat match above, or it's a 404.  Also avoid loops if the
            // second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.map((m)=>m.route.id).join("-") === newPartialMatches.map((m)=>m.route.id).join("-")) return {
                type: "success",
                matches: matchedSplat ? newMatches : null
            };
            partialMatches = newPartialMatches;
            route = partialMatches[partialMatches.length - 1].route;
            if (route.path === "*") // The splat is still our most accurate partial, so run with it
            return {
                type: "success",
                matches: partialMatches
            };
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $e352e4bbcb5a39c7$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $e352e4bbcb5a39c7$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $e352e4bbcb5a39c7$export$4d0306f8f6a4585b = Symbol("deferred");
function $e352e4bbcb5a39c7$export$3336b097a6fbc59a(routes, opts) {
    $e352e4bbcb5a39c7$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $e352e4bbcb5a39c7$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $e352e4bbcb5a39c7$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $e352e4bbcb5a39c7$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $e352e4bbcb5a39c7$var$createLocation("", $e352e4bbcb5a39c7$export$fe53371bee54353d(url), null, "default");
        let matches = $e352e4bbcb5a39c7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$e352e4bbcb5a39c7$var$isValidMethod(method) && method !== "HEAD") {
            let error = $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $e352e4bbcb5a39c7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $e352e4bbcb5a39c7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($e352e4bbcb5a39c7$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $e352e4bbcb5a39c7$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $e352e4bbcb5a39c7$var$createLocation("", $e352e4bbcb5a39c7$export$fe53371bee54353d(url), null, "default");
        let matches = $e352e4bbcb5a39c7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$e352e4bbcb5a39c7$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $e352e4bbcb5a39c7$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $e352e4bbcb5a39c7$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($e352e4bbcb5a39c7$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$e352e4bbcb5a39c7$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($e352e4bbcb5a39c7$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $e352e4bbcb5a39c7$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $e352e4bbcb5a39c7$var$isResponse(result) ? result : $e352e4bbcb5a39c7$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($e352e4bbcb5a39c7$var$isHandlerResult(e) && $e352e4bbcb5a39c7$var$isResponse(e.result)) {
                if (e.type === $e352e4bbcb5a39c7$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($e352e4bbcb5a39c7$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $e352e4bbcb5a39c7$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $e352e4bbcb5a39c7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($e352e4bbcb5a39c7$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($e352e4bbcb5a39c7$var$isDeferredResult(result)) {
            let error = $e352e4bbcb5a39c7$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $e352e4bbcb5a39c7$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($e352e4bbcb5a39c7$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($e352e4bbcb5a39c7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $e352e4bbcb5a39c7$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $e352e4bbcb5a39c7$var$_extends({}, context, {
                statusCode: $e352e4bbcb5a39c7$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $e352e4bbcb5a39c7$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $e352e4bbcb5a39c7$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $e352e4bbcb5a39c7$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1]) ? $e352e4bbcb5a39c7$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $e352e4bbcb5a39c7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $e352e4bbcb5a39c7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $e352e4bbcb5a39c7$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $e352e4bbcb5a39c7$var$callDataStrategyImpl(unstable_dataStrategy || $e352e4bbcb5a39c7$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($e352e4bbcb5a39c7$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $e352e4bbcb5a39c7$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($e352e4bbcb5a39c7$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $e352e4bbcb5a39c7$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $e352e4bbcb5a39c7$export$fec11da027c70692(routes, context, error) {
    let newContext = $e352e4bbcb5a39c7$var$_extends({}, context, {
        statusCode: $e352e4bbcb5a39c7$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $e352e4bbcb5a39c7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $e352e4bbcb5a39c7$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $e352e4bbcb5a39c7$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $e352e4bbcb5a39c7$export$cae722b0cc860f13(to ? to : ".", $e352e4bbcb5a39c7$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $e352e4bbcb5a39c7$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$e352e4bbcb5a39c7$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $e352e4bbcb5a39c7$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $e352e4bbcb5a39c7$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $e352e4bbcb5a39c7$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$e352e4bbcb5a39c7$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$e352e4bbcb5a39c7$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $e352e4bbcb5a39c7$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $e352e4bbcb5a39c7$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$e352e4bbcb5a39c7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$e352e4bbcb5a39c7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $e352e4bbcb5a39c7$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $e352e4bbcb5a39c7$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $e352e4bbcb5a39c7$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $e352e4bbcb5a39c7$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $e352e4bbcb5a39c7$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($e352e4bbcb5a39c7$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $e352e4bbcb5a39c7$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $e352e4bbcb5a39c7$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $e352e4bbcb5a39c7$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $e352e4bbcb5a39c7$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $e352e4bbcb5a39c7$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($e352e4bbcb5a39c7$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $e352e4bbcb5a39c7$var$shouldRevalidateLoader(match, $e352e4bbcb5a39c7$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $e352e4bbcb5a39c7$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $e352e4bbcb5a39c7$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $e352e4bbcb5a39c7$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $e352e4bbcb5a39c7$var$shouldRevalidateLoader(fetcherMatch, $e352e4bbcb5a39c7$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $e352e4bbcb5a39c7$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $e352e4bbcb5a39c7$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $e352e4bbcb5a39c7$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Idempotent utility to execute patchRoutesOnMiss() to lazily load route
 * definitions and update the routes/routeManifest
 */ async function $e352e4bbcb5a39c7$var$loadLazyRouteChildren(patchRoutesOnMissImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    let key = [
        path,
        ...matches.map((m)=>m.route.id)
    ].join("-");
    try {
        let pending = pendingRouteChildren.get(key);
        if (!pending) {
            pending = patchRoutesOnMissImpl({
                path: path,
                matches: matches,
                patch: (routeId, children)=>{
                    if (!signal.aborted) $e352e4bbcb5a39c7$var$patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                }
            });
            pendingRouteChildren.set(key, pending);
        }
        if (pending && $e352e4bbcb5a39c7$var$isPromise(pending)) await pending;
    } finally{
        pendingRouteChildren.delete(key);
    }
}
function $e352e4bbcb5a39c7$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route$children;
        let route = manifest[routeId];
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        let dataChildren = $e352e4bbcb5a39c7$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) route.children.push(...dataChildren);
        else route.children = dataChildren;
    } else {
        let dataChildren = $e352e4bbcb5a39c7$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        routesToUse.push(...dataChildren);
    }
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $e352e4bbcb5a39c7$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $e352e4bbcb5a39c7$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $e352e4bbcb5a39c7$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$e352e4bbcb5a39c7$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $e352e4bbcb5a39c7$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $e352e4bbcb5a39c7$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $e352e4bbcb5a39c7$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $e352e4bbcb5a39c7$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $e352e4bbcb5a39c7$var$ResultType.data,
                    result: undefined
                });
            };
            return $e352e4bbcb5a39c7$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$e352e4bbcb5a39c7$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $e352e4bbcb5a39c7$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $e352e4bbcb5a39c7$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $e352e4bbcb5a39c7$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $e352e4bbcb5a39c7$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $e352e4bbcb5a39c7$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $e352e4bbcb5a39c7$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($e352e4bbcb5a39c7$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $e352e4bbcb5a39c7$var$ResultType.error,
                error: e
            };
        }
        if (type === $e352e4bbcb5a39c7$var$ResultType.error) return {
            type: $e352e4bbcb5a39c7$var$ResultType.error,
            error: new $e352e4bbcb5a39c7$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $e352e4bbcb5a39c7$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $e352e4bbcb5a39c7$var$ResultType.error) return {
        type: $e352e4bbcb5a39c7$var$ResultType.error,
        error: result,
        statusCode: $e352e4bbcb5a39c7$export$972111febbeef05b(result) ? result.status : status
    };
    if ($e352e4bbcb5a39c7$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $e352e4bbcb5a39c7$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $e352e4bbcb5a39c7$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $e352e4bbcb5a39c7$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $e352e4bbcb5a39c7$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$e352e4bbcb5a39c7$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $e352e4bbcb5a39c7$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $e352e4bbcb5a39c7$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($e352e4bbcb5a39c7$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $e352e4bbcb5a39c7$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $e352e4bbcb5a39c7$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($e352e4bbcb5a39c7$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $e352e4bbcb5a39c7$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $e352e4bbcb5a39c7$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $e352e4bbcb5a39c7$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $e352e4bbcb5a39c7$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $e352e4bbcb5a39c7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(!$e352e4bbcb5a39c7$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($e352e4bbcb5a39c7$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $e352e4bbcb5a39c7$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $e352e4bbcb5a39c7$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($e352e4bbcb5a39c7$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $e352e4bbcb5a39c7$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $e352e4bbcb5a39c7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($e352e4bbcb5a39c7$var$isErrorResult(result)) {
            let boundaryMatch = $e352e4bbcb5a39c7$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $e352e4bbcb5a39c7$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($e352e4bbcb5a39c7$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($e352e4bbcb5a39c7$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $e352e4bbcb5a39c7$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $e352e4bbcb5a39c7$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $e352e4bbcb5a39c7$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $e352e4bbcb5a39c7$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $e352e4bbcb5a39c7$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $e352e4bbcb5a39c7$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $e352e4bbcb5a39c7$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `unstable_patchRoutesOnMiss()` ' + ("function threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $e352e4bbcb5a39c7$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $e352e4bbcb5a39c7$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($e352e4bbcb5a39c7$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $e352e4bbcb5a39c7$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(path) : path;
    return $e352e4bbcb5a39c7$export$fe53371bee54353d($e352e4bbcb5a39c7$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $e352e4bbcb5a39c7$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $e352e4bbcb5a39c7$var$isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function $e352e4bbcb5a39c7$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $e352e4bbcb5a39c7$var$ResultType.data || result.type === $e352e4bbcb5a39c7$var$ResultType.error);
}
function $e352e4bbcb5a39c7$var$isRedirectHandlerResult(result) {
    return $e352e4bbcb5a39c7$var$isResponse(result.result) && $e352e4bbcb5a39c7$var$redirectStatusCodes.has(result.result.status);
}
function $e352e4bbcb5a39c7$var$isDeferredResult(result) {
    return result.type === $e352e4bbcb5a39c7$var$ResultType.deferred;
}
function $e352e4bbcb5a39c7$var$isErrorResult(result) {
    return result.type === $e352e4bbcb5a39c7$var$ResultType.error;
}
function $e352e4bbcb5a39c7$var$isRedirectResult(result) {
    return (result && result.type) === $e352e4bbcb5a39c7$var$ResultType.redirect;
}
function $e352e4bbcb5a39c7$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $e352e4bbcb5a39c7$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $e352e4bbcb5a39c7$var$isRedirectResponse(result) {
    if (!$e352e4bbcb5a39c7$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $e352e4bbcb5a39c7$var$isValidMethod(method) {
    return $e352e4bbcb5a39c7$var$validRequestMethods.has(method.toLowerCase());
}
function $e352e4bbcb5a39c7$var$isMutationMethod(method) {
    return $e352e4bbcb5a39c7$var$validMutationMethods.has(method.toLowerCase());
}
async function $e352e4bbcb5a39c7$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$e352e4bbcb5a39c7$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($e352e4bbcb5a39c7$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $e352e4bbcb5a39c7$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $e352e4bbcb5a39c7$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $e352e4bbcb5a39c7$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $e352e4bbcb5a39c7$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $e352e4bbcb5a39c7$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $e352e4bbcb5a39c7$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $e352e4bbcb5a39c7$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $e352e4bbcb5a39c7$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $e352e4bbcb5a39c7$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $e352e4bbcb5a39c7$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $e352e4bbcb5a39c7$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $e352e4bbcb5a39c7$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $e352e4bbcb5a39c7$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $e352e4bbcb5a39c7$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $e352e4bbcb5a39c7$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $e352e4bbcb5a39c7$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($e352e4bbcb5a39c7$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $e352e4bbcb5a39c7$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($e352e4bbcb5a39c7$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $e352e4bbcb5a39c7$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.25.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4RFnf = parcelRequire("4RFnf");

function $2dda13c5d6544900$var$_extends() {
    $2dda13c5d6544900$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2dda13c5d6544900$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $2dda13c5d6544900$export$3add0d5dce533e2e = /*#__PURE__*/ $4RFnf.createContext(null);
const $2dda13c5d6544900$export$145dfa71566a64dc = /*#__PURE__*/ $4RFnf.createContext(null);
const $2dda13c5d6544900$var$AwaitContext = /*#__PURE__*/ $4RFnf.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $2dda13c5d6544900$export$26749e8557646306 = /*#__PURE__*/ $4RFnf.createContext(null);
const $2dda13c5d6544900$export$c7914228fb69b0f5 = /*#__PURE__*/ $4RFnf.createContext(null);
const $2dda13c5d6544900$export$9072aa6dd1f93057 = /*#__PURE__*/ $4RFnf.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $2dda13c5d6544900$var$RouteErrorContext = /*#__PURE__*/ $4RFnf.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $2dda13c5d6544900$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $4RFnf.useContext($2dda13c5d6544900$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $2dda13c5d6544900$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $e352e4bbcb5a39c7$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $2dda13c5d6544900$export$9c954a9d03d32f4a() {
    return $4RFnf.useContext($2dda13c5d6544900$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $2dda13c5d6544900$export$45d76561a5302f2b() {
    !$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    return $4RFnf.useContext($2dda13c5d6544900$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $2dda13c5d6544900$export$1b3f31771c5d07c() {
    return $4RFnf.useContext($2dda13c5d6544900$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $2dda13c5d6544900$export$6c330e8992e8a295(pattern) {
    !$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $2dda13c5d6544900$export$45d76561a5302f2b();
    return $4RFnf.useMemo(()=>(0, $e352e4bbcb5a39c7$export$81336c211d5ff295)(pattern, (0, $e352e4bbcb5a39c7$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $2dda13c5d6544900$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $2dda13c5d6544900$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $4RFnf.useContext($2dda13c5d6544900$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $4RFnf.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $2dda13c5d6544900$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $2dda13c5d6544900$var$useNavigateStable() : $2dda13c5d6544900$var$useNavigateUnstable();
}
function $2dda13c5d6544900$var$useNavigateUnstable() {
    !$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    let dataRouterContext = $4RFnf.useContext($2dda13c5d6544900$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $4RFnf.useContext($2dda13c5d6544900$export$26749e8557646306);
    let { matches: matches } = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2dda13c5d6544900$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $e352e4bbcb5a39c7$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $4RFnf.useRef(false);
    $2dda13c5d6544900$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4RFnf.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $e352e4bbcb5a39c7$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $e352e4bbcb5a39c7$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $2dda13c5d6544900$var$OutletContext = /*#__PURE__*/ $4RFnf.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $2dda13c5d6544900$export$4138103a3ae699cc() {
    return $4RFnf.useContext($2dda13c5d6544900$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $2dda13c5d6544900$export$a3be3530d8e40d0b(context) {
    let outlet = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $2dda13c5d6544900$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $2dda13c5d6544900$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $4RFnf.useContext($2dda13c5d6544900$export$26749e8557646306);
    let { matches: matches } = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2dda13c5d6544900$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $e352e4bbcb5a39c7$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $4RFnf.useMemo(()=>(0, $e352e4bbcb5a39c7$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $2dda13c5d6544900$export$5d3fca4a98652595(routes, locationArg) {
    return $2dda13c5d6544900$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $2dda13c5d6544900$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $4RFnf.useContext($2dda13c5d6544900$export$26749e8557646306);
    let { matches: parentMatches } = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $2dda13c5d6544900$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $e352e4bbcb5a39c7$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $e352e4bbcb5a39c7$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $2dda13c5d6544900$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $e352e4bbcb5a39c7$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $e352e4bbcb5a39c7$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $2dda13c5d6544900$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $e352e4bbcb5a39c7$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $2dda13c5d6544900$var$DefaultErrorComponent() {
    let error = $2dda13c5d6544900$export$ed527bf60f6e05f2();
    let message = (0, $e352e4bbcb5a39c7$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $4RFnf.createElement($4RFnf.Fragment, null, /*#__PURE__*/ $4RFnf.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $4RFnf.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $4RFnf.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $2dda13c5d6544900$var$defaultErrorElement = /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$DefaultErrorComponent, null);
class $2dda13c5d6544900$var$RenderErrorBoundary extends $4RFnf.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $2dda13c5d6544900$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $4RFnf.useContext($2dda13c5d6544900$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $2dda13c5d6544900$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $2dda13c5d6544900$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $2dda13c5d6544900$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $4RFnf.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $2dda13c5d6544900$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($2dda13c5d6544900$var$DataRouterHook || {});
var $2dda13c5d6544900$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($2dda13c5d6544900$var$DataRouterStateHook || {});
function $2dda13c5d6544900$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $2dda13c5d6544900$var$useDataRouterContext(hookName) {
    let ctx = $4RFnf.useContext($2dda13c5d6544900$export$3add0d5dce533e2e);
    !ctx && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    return ctx;
}
function $2dda13c5d6544900$var$useDataRouterState(hookName) {
    let state = $4RFnf.useContext($2dda13c5d6544900$export$145dfa71566a64dc);
    !state && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    return state;
}
function $2dda13c5d6544900$var$useRouteContext(hookName) {
    let route = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    !route && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $2dda13c5d6544900$var$useCurrentRouteId(hookName) {
    let route = $2dda13c5d6544900$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $2dda13c5d6544900$export$5fc8298006ad9e58() {
    return $2dda13c5d6544900$var$useCurrentRouteId($2dda13c5d6544900$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $2dda13c5d6544900$export$d0fd4b7106de2769() {
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $2dda13c5d6544900$export$600dc272ed516c15() {
    let dataRouterContext = $2dda13c5d6544900$var$useDataRouterContext($2dda13c5d6544900$var$DataRouterHook.UseRevalidator);
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseRevalidator);
    return $4RFnf.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $2dda13c5d6544900$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseMatches);
    return $4RFnf.useMemo(()=>matches.map((m)=>(0, $e352e4bbcb5a39c7$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $2dda13c5d6544900$export$1448a5050d252c4d() {
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseLoaderData);
    let routeId = $2dda13c5d6544900$var$useCurrentRouteId($2dda13c5d6544900$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $2dda13c5d6544900$export$fd5d37484eab868d(routeId) {
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $2dda13c5d6544900$export$fdc00f3f26066d5e() {
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseActionData);
    let routeId = $2dda13c5d6544900$var$useCurrentRouteId($2dda13c5d6544900$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $2dda13c5d6544900$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $4RFnf.useContext($2dda13c5d6544900$var$RouteErrorContext);
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseRouteError);
    let routeId = $2dda13c5d6544900$var$useCurrentRouteId($2dda13c5d6544900$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $2dda13c5d6544900$export$78a72ddb39bdd145() {
    let value = $4RFnf.useContext($2dda13c5d6544900$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $2dda13c5d6544900$export$17f53340677d5831() {
    let value = $4RFnf.useContext($2dda13c5d6544900$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $2dda13c5d6544900$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $2dda13c5d6544900$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $2dda13c5d6544900$var$useDataRouterContext($2dda13c5d6544900$var$DataRouterHook.UseBlocker);
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $4RFnf.useState("");
    let blockerFunction = $4RFnf.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $2dda13c5d6544900$var$_extends({}, currentLocation, {
                pathname: (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $2dda13c5d6544900$var$_extends({}, nextLocation, {
                pathname: (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $4RFnf.useEffect(()=>{
        let key = String(++$2dda13c5d6544900$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $4RFnf.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $e352e4bbcb5a39c7$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $2dda13c5d6544900$var$useNavigateStable() {
    let { router: router } = $2dda13c5d6544900$var$useDataRouterContext($2dda13c5d6544900$var$DataRouterHook.UseNavigateStable);
    let id = $2dda13c5d6544900$var$useCurrentRouteId($2dda13c5d6544900$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $4RFnf.useRef(false);
    $2dda13c5d6544900$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4RFnf.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $2dda13c5d6544900$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $2dda13c5d6544900$var$alreadyWarned = {};
function $2dda13c5d6544900$var$warningOnce(key, cond, message) {
    if (!cond && !$2dda13c5d6544900$var$alreadyWarned[key]) $2dda13c5d6544900$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $2dda13c5d6544900$var$START_TRANSITION = "startTransition";
const $2dda13c5d6544900$var$startTransitionImpl = $4RFnf[$2dda13c5d6544900$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $2dda13c5d6544900$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $4RFnf.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4RFnf.useCallback((newState)=>{
        if (v7_startTransition && $2dda13c5d6544900$var$startTransitionImpl) $2dda13c5d6544900$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $4RFnf.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $4RFnf.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $4RFnf.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4RFnf.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4RFnf.createElement($4RFnf.Fragment, null, /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $2dda13c5d6544900$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $2dda13c5d6544900$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $2dda13c5d6544900$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $4RFnf.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e352e4bbcb5a39c7$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4RFnf.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4RFnf.useCallback((newState)=>{
        v7_startTransition && $2dda13c5d6544900$var$startTransitionImpl ? $2dda13c5d6544900$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4RFnf.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $2dda13c5d6544900$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $4RFnf.useContext($2dda13c5d6544900$export$26749e8557646306);
    let { matches: matches } = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2dda13c5d6544900$export$45d76561a5302f2b();
    let navigate = $2dda13c5d6544900$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $e352e4bbcb5a39c7$export$cae722b0cc860f13)(to, (0, $e352e4bbcb5a39c7$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $4RFnf.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $2dda13c5d6544900$export$910ae8079b2c2852(props) {
    return $2dda13c5d6544900$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $2dda13c5d6544900$export$e7b0ac011bb776c6(_props) {
    (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $2dda13c5d6544900$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $e352e4bbcb5a39c7$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $4RFnf.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $2dda13c5d6544900$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $e352e4bbcb5a39c7$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $4RFnf.useMemo(()=>{
        let trailingPathname = (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $2dda13c5d6544900$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $2dda13c5d6544900$export$5d3fca4a98652595($2dda13c5d6544900$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $2dda13c5d6544900$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$ResolveAwait, null, children));
}
var $2dda13c5d6544900$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($2dda13c5d6544900$var$AwaitRenderStatus || {});
const $2dda13c5d6544900$var$neverSettledPromise = new Promise(()=>{});
class $2dda13c5d6544900$var$AwaitErrorBoundary extends $4RFnf.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $2dda13c5d6544900$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $2dda13c5d6544900$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $2dda13c5d6544900$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $2dda13c5d6544900$var$AwaitRenderStatus.error : "_data" in promise ? $2dda13c5d6544900$var$AwaitRenderStatus.success : $2dda13c5d6544900$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $2dda13c5d6544900$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $2dda13c5d6544900$var$AwaitRenderStatus.error && promise._error instanceof (0, $e352e4bbcb5a39c7$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $2dda13c5d6544900$var$neverSettledPromise;
        if (status === $2dda13c5d6544900$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $2dda13c5d6544900$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $2dda13c5d6544900$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $2dda13c5d6544900$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $2dda13c5d6544900$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $4RFnf.createElement($4RFnf.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $2dda13c5d6544900$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $4RFnf.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $4RFnf.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $4RFnf.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $2dda13c5d6544900$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $2dda13c5d6544900$export$e7b0ac011bb776c6) && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $2dda13c5d6544900$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $2dda13c5d6544900$export$daf73786167a7f72(matches) {
    return $2dda13c5d6544900$var$_renderMatches(matches);
}
function $2dda13c5d6544900$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $4RFnf.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $4RFnf.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $4RFnf.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $2dda13c5d6544900$export$f30f7e456d254e83(routes, opts) {
    return (0, $e352e4bbcb5a39c7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2dda13c5d6544900$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e352e4bbcb5a39c7$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $2dda13c5d6544900$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss
    }).initialize();
}



function $ab1c2d1a5ff1b7e8$var$_extends() {
    $ab1c2d1a5ff1b7e8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ab1c2d1a5ff1b7e8$var$_extends.apply(this, arguments);
}
function $ab1c2d1a5ff1b7e8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $ab1c2d1a5ff1b7e8$var$defaultMethod = "get";
const $ab1c2d1a5ff1b7e8$var$defaultEncType = "application/x-www-form-urlencoded";
function $ab1c2d1a5ff1b7e8$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $ab1c2d1a5ff1b7e8$var$isButtonElement(object) {
    return $ab1c2d1a5ff1b7e8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $ab1c2d1a5ff1b7e8$var$isFormElement(object) {
    return $ab1c2d1a5ff1b7e8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $ab1c2d1a5ff1b7e8$var$isInputElement(object) {
    return $ab1c2d1a5ff1b7e8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $ab1c2d1a5ff1b7e8$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $ab1c2d1a5ff1b7e8$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$ab1c2d1a5ff1b7e8$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $ab1c2d1a5ff1b7e8$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $ab1c2d1a5ff1b7e8$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $ab1c2d1a5ff1b7e8$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $ab1c2d1a5ff1b7e8$var$_formDataSupportsSubmitter = null;
function $ab1c2d1a5ff1b7e8$var$isFormDataSubmitterSupported() {
    if ($ab1c2d1a5ff1b7e8$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $ab1c2d1a5ff1b7e8$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $ab1c2d1a5ff1b7e8$var$_formDataSupportsSubmitter = true;
    }
    return $ab1c2d1a5ff1b7e8$var$_formDataSupportsSubmitter;
}
const $ab1c2d1a5ff1b7e8$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $ab1c2d1a5ff1b7e8$var$getFormEncType(encType) {
    if (encType != null && !$ab1c2d1a5ff1b7e8$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $ab1c2d1a5ff1b7e8$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($ab1c2d1a5ff1b7e8$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $ab1c2d1a5ff1b7e8$var$defaultMethod;
        encType = $ab1c2d1a5ff1b7e8$var$getFormEncType(target.getAttribute("enctype")) || $ab1c2d1a5ff1b7e8$var$defaultEncType;
        formData = new FormData(target);
    } else if ($ab1c2d1a5ff1b7e8$var$isButtonElement(target) || $ab1c2d1a5ff1b7e8$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $ab1c2d1a5ff1b7e8$var$defaultMethod;
        encType = $ab1c2d1a5ff1b7e8$var$getFormEncType(target.getAttribute("formenctype")) || $ab1c2d1a5ff1b7e8$var$getFormEncType(form.getAttribute("enctype")) || $ab1c2d1a5ff1b7e8$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$ab1c2d1a5ff1b7e8$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($ab1c2d1a5ff1b7e8$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $ab1c2d1a5ff1b7e8$var$defaultMethod;
        action = null;
        encType = $ab1c2d1a5ff1b7e8$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $ab1c2d1a5ff1b7e8$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $ab1c2d1a5ff1b7e8$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $ab1c2d1a5ff1b7e8$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $ab1c2d1a5ff1b7e8$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $ab1c2d1a5ff1b7e8$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $ab1c2d1a5ff1b7e8$export$1f3f55432a00e06d(routes, opts) {
    return (0, $e352e4bbcb5a39c7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $ab1c2d1a5ff1b7e8$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e352e4bbcb5a39c7$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $ab1c2d1a5ff1b7e8$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $2dda13c5d6544900$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $ab1c2d1a5ff1b7e8$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $e352e4bbcb5a39c7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $ab1c2d1a5ff1b7e8$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e352e4bbcb5a39c7$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $ab1c2d1a5ff1b7e8$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $2dda13c5d6544900$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $ab1c2d1a5ff1b7e8$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $ab1c2d1a5ff1b7e8$var$_extends({}, state, {
        errors: $ab1c2d1a5ff1b7e8$var$deserializeErrors(state.errors)
    });
    return state;
}
function $ab1c2d1a5ff1b7e8$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $e352e4bbcb5a39c7$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $ab1c2d1a5ff1b7e8$export$7ad602f0e94e62d1 = /*#__PURE__*/ $4RFnf.createContext({
    isTransitioning: false
});
const $ab1c2d1a5ff1b7e8$export$148fd98d095596d4 = /*#__PURE__*/ $4RFnf.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $ab1c2d1a5ff1b7e8$var$START_TRANSITION = "startTransition";
const $ab1c2d1a5ff1b7e8$var$startTransitionImpl = $4RFnf[$ab1c2d1a5ff1b7e8$var$START_TRANSITION];
const $ab1c2d1a5ff1b7e8$var$FLUSH_SYNC = "flushSync";
const $ab1c2d1a5ff1b7e8$var$flushSyncImpl = $6ce1434187f7101c$exports[$ab1c2d1a5ff1b7e8$var$FLUSH_SYNC];
const $ab1c2d1a5ff1b7e8$var$USE_ID = "useId";
const $ab1c2d1a5ff1b7e8$var$useIdImpl = $4RFnf[$ab1c2d1a5ff1b7e8$var$USE_ID];
function $ab1c2d1a5ff1b7e8$var$startTransitionSafe(cb) {
    if ($ab1c2d1a5ff1b7e8$var$startTransitionImpl) $ab1c2d1a5ff1b7e8$var$startTransitionImpl(cb);
    else cb();
}
function $ab1c2d1a5ff1b7e8$var$flushSyncSafe(cb) {
    if ($ab1c2d1a5ff1b7e8$var$flushSyncImpl) $ab1c2d1a5ff1b7e8$var$flushSyncImpl(cb);
    else cb();
}
class $ab1c2d1a5ff1b7e8$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $ab1c2d1a5ff1b7e8$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $4RFnf.useState(router.state);
    let [pendingState, setPendingState] = $4RFnf.useState();
    let [vtContext, setVtContext] = $4RFnf.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $4RFnf.useState();
    let [transition, setTransition] = $4RFnf.useState();
    let [interruption, setInterruption] = $4RFnf.useState();
    let fetcherData = $4RFnf.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $4RFnf.useCallback((cb)=>{
        if (v7_startTransition) $ab1c2d1a5ff1b7e8$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $4RFnf.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $ab1c2d1a5ff1b7e8$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $ab1c2d1a5ff1b7e8$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $ab1c2d1a5ff1b7e8$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $ab1c2d1a5ff1b7e8$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $ab1c2d1a5ff1b7e8$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $4RFnf.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $4RFnf.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $ab1c2d1a5ff1b7e8$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $4RFnf.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $4RFnf.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $4RFnf.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $4RFnf.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $4RFnf.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4RFnf.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $4RFnf.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4RFnf.createElement($4RFnf.Fragment, null, /*#__PURE__*/ $4RFnf.createElement((0, $2dda13c5d6544900$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4RFnf.createElement((0, $2dda13c5d6544900$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $4RFnf.createElement($ab1c2d1a5ff1b7e8$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $4RFnf.createElement($ab1c2d1a5ff1b7e8$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $4RFnf.createElement((0, $2dda13c5d6544900$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $4RFnf.createElement($ab1c2d1a5ff1b7e8$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $ab1c2d1a5ff1b7e8$var$MemoizedDataRoutes = /*#__PURE__*/ $4RFnf.memo($ab1c2d1a5ff1b7e8$var$DataRoutes);
function $ab1c2d1a5ff1b7e8$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $2dda13c5d6544900$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $ab1c2d1a5ff1b7e8$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $4RFnf.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e352e4bbcb5a39c7$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4RFnf.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4RFnf.useCallback((newState)=>{
        v7_startTransition && $ab1c2d1a5ff1b7e8$var$startTransitionImpl ? $ab1c2d1a5ff1b7e8$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4RFnf.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4RFnf.createElement((0, $2dda13c5d6544900$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $ab1c2d1a5ff1b7e8$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $4RFnf.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e352e4bbcb5a39c7$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4RFnf.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4RFnf.useCallback((newState)=>{
        v7_startTransition && $ab1c2d1a5ff1b7e8$var$startTransitionImpl ? $ab1c2d1a5ff1b7e8$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4RFnf.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4RFnf.createElement((0, $2dda13c5d6544900$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $ab1c2d1a5ff1b7e8$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $4RFnf.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4RFnf.useCallback((newState)=>{
        v7_startTransition && $ab1c2d1a5ff1b7e8$var$startTransitionImpl ? $ab1c2d1a5ff1b7e8$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4RFnf.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4RFnf.createElement((0, $2dda13c5d6544900$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $ab1c2d1a5ff1b7e8$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $ab1c2d1a5ff1b7e8$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $ab1c2d1a5ff1b7e8$export$a6c7ac8248d6e38a = /*#__PURE__*/ $4RFnf.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $ab1c2d1a5ff1b7e8$var$_objectWithoutPropertiesLoose(_ref7, $ab1c2d1a5ff1b7e8$var$_excluded);
    let { basename: basename } = $4RFnf.useContext((0, $2dda13c5d6544900$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $ab1c2d1a5ff1b7e8$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($ab1c2d1a5ff1b7e8$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $2dda13c5d6544900$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $ab1c2d1a5ff1b7e8$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $4RFnf.createElement("a", $ab1c2d1a5ff1b7e8$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $ab1c2d1a5ff1b7e8$export$b0d92dbee9b5b60d = /*#__PURE__*/ $4RFnf.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $ab1c2d1a5ff1b7e8$var$_objectWithoutPropertiesLoose(_ref8, $ab1c2d1a5ff1b7e8$var$_excluded2);
    let path = (0, $2dda13c5d6544900$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $2dda13c5d6544900$export$45d76561a5302f2b)();
    let routerState = $4RFnf.useContext((0, $2dda13c5d6544900$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $4RFnf.useContext((0, $2dda13c5d6544900$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $ab1c2d1a5ff1b7e8$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $4RFnf.createElement($ab1c2d1a5ff1b7e8$export$a6c7ac8248d6e38a, $ab1c2d1a5ff1b7e8$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $ab1c2d1a5ff1b7e8$export$a7fed597f4b8afd8 = /*#__PURE__*/ $4RFnf.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $ab1c2d1a5ff1b7e8$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $ab1c2d1a5ff1b7e8$var$_objectWithoutPropertiesLoose(_ref9, $ab1c2d1a5ff1b7e8$var$_excluded3);
    let submit = $ab1c2d1a5ff1b7e8$export$47c85c6e3a081d3();
    let formAction = $ab1c2d1a5ff1b7e8$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $4RFnf.createElement("form", $ab1c2d1a5ff1b7e8$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $ab1c2d1a5ff1b7e8$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $ab1c2d1a5ff1b7e8$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $ab1c2d1a5ff1b7e8$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($ab1c2d1a5ff1b7e8$var$DataRouterHook || ($ab1c2d1a5ff1b7e8$var$DataRouterHook = {}));
var $ab1c2d1a5ff1b7e8$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($ab1c2d1a5ff1b7e8$var$DataRouterStateHook || ($ab1c2d1a5ff1b7e8$var$DataRouterStateHook = {}));
// Internal hooks
function $ab1c2d1a5ff1b7e8$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $ab1c2d1a5ff1b7e8$var$useDataRouterContext(hookName) {
    let ctx = $4RFnf.useContext((0, $2dda13c5d6544900$export$3add0d5dce533e2e));
    !ctx && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    return ctx;
}
function $ab1c2d1a5ff1b7e8$var$useDataRouterState(hookName) {
    let state = $4RFnf.useContext((0, $2dda13c5d6544900$export$145dfa71566a64dc));
    !state && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $ab1c2d1a5ff1b7e8$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $2dda13c5d6544900$export$9770f232ac06a008)();
    let location = (0, $2dda13c5d6544900$export$45d76561a5302f2b)();
    let path = (0, $2dda13c5d6544900$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $4RFnf.useCallback((event)=>{
        if ($ab1c2d1a5ff1b7e8$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $e352e4bbcb5a39c7$export$fe53371bee54353d)(location) === (0, $e352e4bbcb5a39c7$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $ab1c2d1a5ff1b7e8$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $4RFnf.useRef($ab1c2d1a5ff1b7e8$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $4RFnf.useRef(false);
    let location = (0, $2dda13c5d6544900$export$45d76561a5302f2b)();
    let searchParams = $4RFnf.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $ab1c2d1a5ff1b7e8$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $2dda13c5d6544900$export$9770f232ac06a008)();
    let setSearchParams = $4RFnf.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $ab1c2d1a5ff1b7e8$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $ab1c2d1a5ff1b7e8$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $ab1c2d1a5ff1b7e8$var$fetcherId = 0;
let $ab1c2d1a5ff1b7e8$var$getUniqueFetcherId = ()=>"__" + String(++$ab1c2d1a5ff1b7e8$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $ab1c2d1a5ff1b7e8$export$47c85c6e3a081d3() {
    let { router: router } = $ab1c2d1a5ff1b7e8$var$useDataRouterContext($ab1c2d1a5ff1b7e8$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $4RFnf.useContext((0, $2dda13c5d6544900$export$26749e8557646306));
    let currentRouteId = (0, $2dda13c5d6544900$export$5fc8298006ad9e58)();
    return $4RFnf.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $ab1c2d1a5ff1b7e8$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $ab1c2d1a5ff1b7e8$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $ab1c2d1a5ff1b7e8$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $ab1c2d1a5ff1b7e8$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $4RFnf.useContext((0, $2dda13c5d6544900$export$26749e8557646306));
    let routeContext = $4RFnf.useContext((0, $2dda13c5d6544900$export$9072aa6dd1f93057));
    !routeContext && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $ab1c2d1a5ff1b7e8$var$_extends({}, (0, $2dda13c5d6544900$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $2dda13c5d6544900$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $e352e4bbcb5a39c7$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $e352e4bbcb5a39c7$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $ab1c2d1a5ff1b7e8$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $ab1c2d1a5ff1b7e8$var$useDataRouterContext($ab1c2d1a5ff1b7e8$var$DataRouterHook.UseFetcher);
    let state = $ab1c2d1a5ff1b7e8$var$useDataRouterState($ab1c2d1a5ff1b7e8$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $4RFnf.useContext($ab1c2d1a5ff1b7e8$export$148fd98d095596d4);
    let route = $4RFnf.useContext((0, $2dda13c5d6544900$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    !route && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $ab1c2d1a5ff1b7e8$var$useIdImpl ? $ab1c2d1a5ff1b7e8$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $4RFnf.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($ab1c2d1a5ff1b7e8$var$getUniqueFetcherId());
    // Registration/cleanup
    $4RFnf.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $4RFnf.useCallback((href, opts)=>{
        !routeId && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $ab1c2d1a5ff1b7e8$export$47c85c6e3a081d3();
    let submit = $4RFnf.useCallback((target, opts)=>{
        submitImpl(target, $ab1c2d1a5ff1b7e8$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $4RFnf.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $4RFnf.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $4RFnf.createElement($ab1c2d1a5ff1b7e8$export$a7fed597f4b8afd8, $ab1c2d1a5ff1b7e8$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $e352e4bbcb5a39c7$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $4RFnf.useMemo(()=>$ab1c2d1a5ff1b7e8$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $ab1c2d1a5ff1b7e8$export$fa996778a3a31087() {
    let state = $ab1c2d1a5ff1b7e8$var$useDataRouterState($ab1c2d1a5ff1b7e8$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $ab1c2d1a5ff1b7e8$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $ab1c2d1a5ff1b7e8$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $ab1c2d1a5ff1b7e8$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $ab1c2d1a5ff1b7e8$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $ab1c2d1a5ff1b7e8$var$useDataRouterContext($ab1c2d1a5ff1b7e8$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $ab1c2d1a5ff1b7e8$var$useDataRouterState($ab1c2d1a5ff1b7e8$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $4RFnf.useContext((0, $2dda13c5d6544900$export$26749e8557646306));
    let location = (0, $2dda13c5d6544900$export$45d76561a5302f2b)();
    let matches = (0, $2dda13c5d6544900$export$2378eb7f5ff86053)();
    let navigation = (0, $2dda13c5d6544900$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $4RFnf.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $ab1c2d1a5ff1b7e8$var$usePageHide($4RFnf.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $ab1c2d1a5ff1b7e8$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $ab1c2d1a5ff1b7e8$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($ab1c2d1a5ff1b7e8$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4RFnf.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $ab1c2d1a5ff1b7e8$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $ab1c2d1a5ff1b7e8$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4RFnf.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($ab1c2d1a5ff1b7e8$var$_extends({}, location, {
                    pathname: (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($ab1c2d1a5ff1b7e8$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4RFnf.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $ab1c2d1a5ff1b7e8$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $4RFnf.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $ab1c2d1a5ff1b7e8$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $4RFnf.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $ab1c2d1a5ff1b7e8$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $2dda13c5d6544900$export$b273b3273281a049)(when);
    $4RFnf.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $4RFnf.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $ab1c2d1a5ff1b7e8$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $4RFnf.useContext($ab1c2d1a5ff1b7e8$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    let { basename: basename } = $ab1c2d1a5ff1b7e8$var$useDataRouterContext($ab1c2d1a5ff1b7e8$var$DataRouterHook.useViewTransitionState);
    let path = (0, $2dda13c5d6544900$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $e352e4bbcb5a39c7$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $e352e4bbcb5a39c7$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


var $dc4ca06a614fc543$exports = {};
$dc4ca06a614fc543$exports = new URL("dj.d8b8b825.png", import.meta.url).toString();



var $4RFnf = parcelRequire("4RFnf");
var $97e1373e5f5ddb8e$exports = {};
$97e1373e5f5ddb8e$exports = new URL("dj_dark.84954af9.png", import.meta.url).toString();






const $6bad0b840ce9b205$var$useCalculateDuration = (target)=>{
    const targetPosition = document.querySelector(target).offsetTop;
    const startPosition = window.scrollY;
    const distance = Math.abs(startPosition - targetPosition);
    const baseDuration = 400;
    const additionalDuration = Math.log(distance + 1) * 100;
    let duration = baseDuration + additionalDuration;
    const minDuration = 400;
    const maxDuration = 2000;
    duration = Math.min(Math.max(duration, minDuration), maxDuration);
    return duration;
};
var $6bad0b840ce9b205$export$2e2bcd8739ae039 = $6bad0b840ce9b205$var$useCalculateDuration;



var $4RFnf = parcelRequire("4RFnf");

const $95bb79beeda0a3f5$var$NavBarMobile = ({ nav: nav, isOpen: isOpen, setIsOpen: setIsOpen })=>{
    const { darkMode: darkMode, setDarkMode: setDarkMode } = (0, $4RFnf.useContext)((0, $1039ae88e8de639f$export$2e2bcd8739ae039));
    const toggleMenu = ()=>{
        setIsOpen(!isOpen);
    };
    const handleThemeToggle = ()=>{
        setDarkMode(!darkMode);
        toggleMenu();
    };
    if (isOpen) return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        className: "fixed inset-0 dark:bg-[#121212]  bg-white z-50 flex flex-col justify-center items-center",
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("button", {
                onClick: toggleMenu,
                className: "dark:text-white text-3xl font-extralight absolute top-4 right-4",
                children: "X"
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("ul", {
                className: "font-poppins text-[#333333] text-2xl space-y-6 dark:text-[#e0e0e0]",
                children: nav.map((item, index)=>/*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("li", {
                        className: "transition-colors hover:text-[#9d9d9d]",
                        children: item.external ? /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $ab1c2d1a5ff1b7e8$export$a6c7ac8248d6e38a), {
                            onClick: toggleMenu,
                            to: item.link,
                            children: item.title
                        }) : /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $a2c2034c49841d6d$exports.Link), {
                            onClick: toggleMenu,
                            to: item.link,
                            smooth: "easeInOutQuad",
                            duration: ()=>(0, $6bad0b840ce9b205$export$2e2bcd8739ae039)(`#${item.link}`),
                            children: item.title
                        })
                    }, index))
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("button", {
                onClick: handleThemeToggle,
                className: "mt-6 p-2 bg-gray-800 dark:bg-gray-200 dark:text-[#333333] text-[#e0e0e0]",
                children: darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"
            })
        ]
    });
};
var $95bb79beeda0a3f5$export$2e2bcd8739ae039 = $95bb79beeda0a3f5$var$NavBarMobile;



const $1473df7d36a8dff2$var$NavBar = ({ nav: nav })=>{
    const [isOpen, setIsOpen] = (0, $4RFnf.useState)(false);
    const navigate = (0, $2dda13c5d6544900$export$9770f232ac06a008)();
    const { darkMode: darkMode, setDarkMode: setDarkMode } = (0, $4RFnf.useContext)((0, $1039ae88e8de639f$export$2e2bcd8739ae039));
    const toggleDarkMode = ()=>{
        setDarkMode(!darkMode);
    };
    (0, $4RFnf.useEffect)(()=>{
        if (isOpen) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "auto";
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("nav", {
                className: "hidden items-center fixed top-0 left-0 w-full dark:bg-[#121212] bg-white shadow-lg dark:shadow-[#e53939] z-50 md:flex px-16 dark:text-[#e0e0e0]",
                children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                    className: "w-full grid  grid-cols-3 items-center",
                    style: {
                        gridTemplateColumns: "1fr auto 1fr"
                    },
                    children: [
                        /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                            children: darkMode ? /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("img", {
                                onClick: ()=>{
                                    navigate("/");
                                },
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($97e1373e5f5ddb8e$exports))),
                                className: "h-20 w-20 bg-black hover:cursor-pointer"
                            }) : /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("img", {
                                onClick: ()=>{
                                    navigate("/");
                                },
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($dc4ca06a614fc543$exports))),
                                className: "h-20 w-20 hover:cursor-pointer"
                            })
                        }),
                        /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                            className: "md:flex justify-center dark:text-[#e0e0e0]",
                            children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("ul", {
                                className: "flex font-poppins text-[#333333] items-center space-x-10 dark:text-[#e0e0e0] h-20",
                                children: nav.map((item, index)=>/*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("li", {
                                        className: "transition-colors hover:text-[#9d9d9d] hover:cursor-pointer",
                                        children: item.external ? /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $ab1c2d1a5ff1b7e8$export$a6c7ac8248d6e38a), {
                                            to: item.link,
                                            children: item.title
                                        }) : /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $a2c2034c49841d6d$exports.Link), {
                                            to: item.link,
                                            smooth: "easeInOutQuad",
                                            duration: ()=>(0, $6bad0b840ce9b205$export$2e2bcd8739ae039)(`#${item.link}`),
                                            children: item.title
                                        })
                                    }, index))
                            })
                        }),
                        /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                            className: `flex justify-end relative`,
                            children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                                onClick: toggleDarkMode,
                                className: ` hover:cursor-pointer ${darkMode ? `text-[#f0f0f0]` : `text-[#333333]`} text-xl`,
                                children: "\u2600"
                            })
                        })
                    ]
                })
            }),
            !isOpen && /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                className: "md:hidden shadow-lg z-50 dark:shadow-[#e53939] pt-2  px-5",
                children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                            children: darkMode ? /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($97e1373e5f5ddb8e$exports))),
                                className: "h-16 w-16"
                            }) : /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($dc4ca06a614fc543$exports))),
                                className: "h-16 w-16"
                            })
                        }),
                        /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("i", {
                                style: {
                                    color: darkMode ? "#f0f0f0" : "#333333"
                                },
                                onClick: ()=>setIsOpen(true),
                                className: "fa-solid fa-bars fa-2x"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $95bb79beeda0a3f5$export$2e2bcd8739ae039), {
                nav: nav,
                isOpen: isOpen,
                setIsOpen: setIsOpen
            })
        ]
    });
};
var $1473df7d36a8dff2$export$2e2bcd8739ae039 = $1473df7d36a8dff2$var$NavBar;


const $71fffbba1262c84f$var$nav = [
    {
        title: "Home",
        link: "home"
    },
    {
        title: "Projects",
        link: "projects"
    },
    {
        title: "Resume",
        link: "resume"
    },
    {
        title: "Skills",
        link: "skills"
    },
    {
        title: "Contact",
        link: "contact"
    }
];
var $71fffbba1262c84f$export$2e2bcd8739ae039 = $71fffbba1262c84f$var$nav;



var $983340a819dc0d30$exports = {};
"use strict";
function $983340a819dc0d30$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $4RFnf = parcelRequire("4RFnf");
var $983340a819dc0d30$var$React__default = $983340a819dc0d30$var$_interopDefault($4RFnf);
function $983340a819dc0d30$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $983340a819dc0d30$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $983340a819dc0d30$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $983340a819dc0d30$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $983340a819dc0d30$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $983340a819dc0d30$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($4RFnf.PureComponent);
        $983340a819dc0d30$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $983340a819dc0d30$var$_defineProperty(SideEffect, "canUseDOM", $983340a819dc0d30$var$canUseDOM);
        return SideEffect;
    };
}
$983340a819dc0d30$exports = $983340a819dc0d30$var$withSideEffect;


var $0c38d3c81f56f7c3$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $0c38d3c81f56f7c3$var$hasElementType = typeof Element !== "undefined";
var $0c38d3c81f56f7c3$var$hasMap = typeof Map === "function";
var $0c38d3c81f56f7c3$var$hasSet = typeof Set === "function";
var $0c38d3c81f56f7c3$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $0c38d3c81f56f7c3$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$0c38d3c81f56f7c3$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($0c38d3c81f56f7c3$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$0c38d3c81f56f7c3$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($0c38d3c81f56f7c3$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($0c38d3c81f56f7c3$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($0c38d3c81f56f7c3$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$0c38d3c81f56f7c3$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$0c38d3c81f56f7c3$exports = function isEqual(a, b) {
    try {
        return $0c38d3c81f56f7c3$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $4RFnf = parcelRequire("4RFnf");
var $cf543c2a459e61aa$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $cf543c2a459e61aa$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $cf543c2a459e61aa$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $cf543c2a459e61aa$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $cf543c2a459e61aa$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $cf543c2a459e61aa$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$cf543c2a459e61aa$exports = $cf543c2a459e61aa$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $cf543c2a459e61aa$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($cf543c2a459e61aa$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($cf543c2a459e61aa$var$getOwnPropertySymbols) {
            symbols = $cf543c2a459e61aa$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($cf543c2a459e61aa$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


var $12350d549f974864$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $12350d549f974864$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $12350d549f974864$var$VALID_TAG_NAMES = Object.keys($12350d549f974864$var$TAG_NAMES).map(function(name) {
    return $12350d549f974864$var$TAG_NAMES[name];
});
var $12350d549f974864$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $12350d549f974864$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $12350d549f974864$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $12350d549f974864$var$HTML_TAG_MAP = Object.keys($12350d549f974864$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$12350d549f974864$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $12350d549f974864$var$SELF_CLOSING_TAGS = [
    $12350d549f974864$var$TAG_NAMES.NOSCRIPT,
    $12350d549f974864$var$TAG_NAMES.SCRIPT,
    $12350d549f974864$var$TAG_NAMES.STYLE
];
var $12350d549f974864$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $12350d549f974864$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $12350d549f974864$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $12350d549f974864$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $12350d549f974864$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $12350d549f974864$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $12350d549f974864$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $12350d549f974864$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $12350d549f974864$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $12350d549f974864$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $12350d549f974864$var$getInnermostProperty(propsList, $12350d549f974864$var$TAG_NAMES.TITLE);
    var innermostTemplate = $12350d549f974864$var$getInnermostProperty(propsList, $12350d549f974864$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $12350d549f974864$var$getInnermostProperty(propsList, $12350d549f974864$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $12350d549f974864$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $12350d549f974864$var$getInnermostProperty(propsList, $12350d549f974864$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $12350d549f974864$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $12350d549f974864$var$_extends({}, tagAttrs, current);
    }, {});
};
var $12350d549f974864$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$12350d549f974864$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$12350d549f974864$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $12350d549f974864$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $12350d549f974864$var$warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + $12350d549f974864$var$_typeof(props[tagName]) + '"');
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $12350d549f974864$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $12350d549f974864$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $12350d549f974864$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $12350d549f974864$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $12350d549f974864$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($cf543c2a459e61aa$exports)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $12350d549f974864$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $12350d549f974864$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $12350d549f974864$var$getBaseTagFromPropsList([
            $12350d549f974864$var$TAG_PROPERTIES.HREF,
            $12350d549f974864$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $12350d549f974864$var$getAttributesFromPropsList($12350d549f974864$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $12350d549f974864$var$getInnermostProperty(propsList, $12350d549f974864$var$HELMET_PROPS.DEFER),
        encode: $12350d549f974864$var$getInnermostProperty(propsList, $12350d549f974864$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $12350d549f974864$var$getAttributesFromPropsList($12350d549f974864$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $12350d549f974864$var$getTagsFromPropsList($12350d549f974864$var$TAG_NAMES.LINK, [
            $12350d549f974864$var$TAG_PROPERTIES.REL,
            $12350d549f974864$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $12350d549f974864$var$getTagsFromPropsList($12350d549f974864$var$TAG_NAMES.META, [
            $12350d549f974864$var$TAG_PROPERTIES.NAME,
            $12350d549f974864$var$TAG_PROPERTIES.CHARSET,
            $12350d549f974864$var$TAG_PROPERTIES.HTTPEQUIV,
            $12350d549f974864$var$TAG_PROPERTIES.PROPERTY,
            $12350d549f974864$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $12350d549f974864$var$getTagsFromPropsList($12350d549f974864$var$TAG_NAMES.NOSCRIPT, [
            $12350d549f974864$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $12350d549f974864$var$getOnChangeClientState(propsList),
        scriptTags: $12350d549f974864$var$getTagsFromPropsList($12350d549f974864$var$TAG_NAMES.SCRIPT, [
            $12350d549f974864$var$TAG_PROPERTIES.SRC,
            $12350d549f974864$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $12350d549f974864$var$getTagsFromPropsList($12350d549f974864$var$TAG_NAMES.STYLE, [
            $12350d549f974864$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $12350d549f974864$var$getTitleFromPropsList(propsList),
        titleAttributes: $12350d549f974864$var$getAttributesFromPropsList($12350d549f974864$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $12350d549f974864$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $12350d549f974864$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $12350d549f974864$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $12350d549f974864$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $12350d549f974864$var$rafPolyfill : $parcel$global.requestAnimationFrame || $12350d549f974864$var$rafPolyfill;
var $12350d549f974864$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $12350d549f974864$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $12350d549f974864$var$cafPolyfill;
var $12350d549f974864$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $12350d549f974864$var$_helmetCallback = null;
var $12350d549f974864$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($12350d549f974864$var$_helmetCallback) $12350d549f974864$var$cancelAnimationFrame($12350d549f974864$var$_helmetCallback);
    if (newState.defer) $12350d549f974864$var$_helmetCallback = $12350d549f974864$var$requestAnimationFrame(function() {
        $12350d549f974864$var$commitTagChanges(newState, function() {
            $12350d549f974864$var$_helmetCallback = null;
        });
    });
    else {
        $12350d549f974864$var$commitTagChanges(newState);
        $12350d549f974864$var$_helmetCallback = null;
    }
};
var $12350d549f974864$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $12350d549f974864$var$updateAttributes($12350d549f974864$var$TAG_NAMES.BODY, bodyAttributes);
    $12350d549f974864$var$updateAttributes($12350d549f974864$var$TAG_NAMES.HTML, htmlAttributes);
    $12350d549f974864$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $12350d549f974864$var$updateTags($12350d549f974864$var$TAG_NAMES.BASE, baseTag),
        linkTags: $12350d549f974864$var$updateTags($12350d549f974864$var$TAG_NAMES.LINK, linkTags),
        metaTags: $12350d549f974864$var$updateTags($12350d549f974864$var$TAG_NAMES.META, metaTags),
        noscriptTags: $12350d549f974864$var$updateTags($12350d549f974864$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $12350d549f974864$var$updateTags($12350d549f974864$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $12350d549f974864$var$updateTags($12350d549f974864$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $12350d549f974864$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $12350d549f974864$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $12350d549f974864$var$flattenArray(title);
    $12350d549f974864$var$updateAttributes($12350d549f974864$var$TAG_NAMES.TITLE, attributes);
};
var $12350d549f974864$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($12350d549f974864$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($12350d549f974864$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($12350d549f974864$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($12350d549f974864$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $12350d549f974864$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($12350d549f974864$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $12350d549f974864$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $12350d549f974864$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $12350d549f974864$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($12350d549f974864$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $12350d549f974864$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $12350d549f974864$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $12350d549f974864$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $12350d549f974864$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $12350d549f974864$var$HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + $12350d549f974864$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $12350d549f974864$var$HELMET_ATTRIBUTE + '="true">' + $12350d549f974864$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $12350d549f974864$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $12350d549f974864$var$TAG_PROPERTIES.INNER_HTML || attribute === $12350d549f974864$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + $12350d549f974864$var$encodeSpecialCharacters(tag[attribute], encode) + '"';
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $12350d549f974864$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $12350d549f974864$var$HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $12350d549f974864$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$12350d549f974864$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $12350d549f974864$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$12350d549f974864$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $12350d549f974864$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$12350d549f974864$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $12350d549f974864$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createElement($12350d549f974864$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $12350d549f974864$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$12350d549f974864$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $12350d549f974864$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $12350d549f974864$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $12350d549f974864$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createElement(type, mappedTag);
    });
};
var $12350d549f974864$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $12350d549f974864$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $12350d549f974864$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $12350d549f974864$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $12350d549f974864$var$ATTRIBUTE_NAMES.BODY:
        case $12350d549f974864$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $12350d549f974864$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $12350d549f974864$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $12350d549f974864$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $12350d549f974864$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $12350d549f974864$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $12350d549f974864$var$getMethodsForTag($12350d549f974864$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $12350d549f974864$var$getMethodsForTag($12350d549f974864$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $12350d549f974864$var$getMethodsForTag($12350d549f974864$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $12350d549f974864$var$getMethodsForTag($12350d549f974864$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $12350d549f974864$var$getMethodsForTag($12350d549f974864$var$TAG_NAMES.META, metaTags, encode),
        noscript: $12350d549f974864$var$getMethodsForTag($12350d549f974864$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $12350d549f974864$var$getMethodsForTag($12350d549f974864$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $12350d549f974864$var$getMethodsForTag($12350d549f974864$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $12350d549f974864$var$getMethodsForTag($12350d549f974864$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $12350d549f974864$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $12350d549f974864$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $12350d549f974864$var$classCallCheck(this, HelmetWrapper);
            return $12350d549f974864$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($0c38d3c81f56f7c3$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $12350d549f974864$var$TAG_NAMES.SCRIPT:
                case $12350d549f974864$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $12350d549f974864$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $12350d549f974864$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $12350d549f974864$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $12350d549f974864$var$TAG_NAMES.TITLE:
                    return $12350d549f974864$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $12350d549f974864$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $12350d549f974864$var$TAG_NAMES.BODY:
                    return $12350d549f974864$var$_extends({}, newProps, {
                        bodyAttributes: $12350d549f974864$var$_extends({}, newChildProps)
                    });
                case $12350d549f974864$var$TAG_NAMES.HTML:
                    return $12350d549f974864$var$_extends({}, newProps, {
                        htmlAttributes: $12350d549f974864$var$_extends({}, newChildProps)
                    });
            }
            return $12350d549f974864$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $12350d549f974864$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $12350d549f974864$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $12350d549f974864$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $12350d549f974864$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $12350d549f974864$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $12350d549f974864$var$TAG_NAMES.LINK:
                    case $12350d549f974864$var$TAG_NAMES.META:
                    case $12350d549f974864$var$TAG_NAMES.NOSCRIPT:
                    case $12350d549f974864$var$TAG_NAMES.SCRIPT:
                    case $12350d549f974864$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $12350d549f974864$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $12350d549f974864$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createElement(Component, newProps);
        };
        $12350d549f974864$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($83b60b9412ae0b7d$exports))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $12350d549f974864$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $12350d549f974864$var$NullComponent = function NullComponent() {
    return null;
};
var $12350d549f974864$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($983340a819dc0d30$exports)))($12350d549f974864$var$reducePropsToState, $12350d549f974864$var$handleClientStateChange, $12350d549f974864$var$mapStateOnServer)($12350d549f974864$var$NullComponent);
var $12350d549f974864$export$dcef8f9bb9a41431 = $12350d549f974864$var$Helmet($12350d549f974864$var$HelmetSideEffects);
$12350d549f974864$export$dcef8f9bb9a41431.renderStatic = $12350d549f974864$export$dcef8f9bb9a41431.rewind;
var $12350d549f974864$export$2e2bcd8739ae039 = $12350d549f974864$export$dcef8f9bb9a41431;


parcelRequire("4RFnf");
const $949f23ee69f32f96$export$ca6dda5263526f75 = "https://api.damyantjain.com";
const $949f23ee69f32f96$export$923ea8233b386e99 = `${$949f23ee69f32f96$export$ca6dda5263526f75}/api`;
const $949f23ee69f32f96$export$97d45f9fe2ff7963 = `${$949f23ee69f32f96$export$923ea8233b386e99}/analytics/home-visitor-count`;
const $949f23ee69f32f96$export$33946c87f7d00129 = `${$949f23ee69f32f96$export$923ea8233b386e99}/blogs`;
const $949f23ee69f32f96$export$ef523d22e5e75d61 = `${$949f23ee69f32f96$export$923ea8233b386e99}/publishedblogs`;
const $949f23ee69f32f96$export$86dcaf45db3d1606 = `${$949f23ee69f32f96$export$923ea8233b386e99}/login`;
const $949f23ee69f32f96$export$2a2261c5a58ac0 = `${$949f23ee69f32f96$export$923ea8233b386e99}/refresh-token`;


const $bffff0e09a609a2b$var$Portfolio = ()=>{
    // useEffect(() => {
    //   fetch(UPDATE_VIEWS, {
    //     method: "POST",
    //   });
    // }, []);
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)((0, $12350d549f974864$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("title", {
                        children: "Damyant Jain"
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("meta", {
                        name: "description",
                        content: "I'm all about turning cool ideas into awesome products and exploring the ever-evolving tech world. With over 3 years of experience, I'm passionate about solving real-world problems. When I'm not coding, you can find me enjoying sports."
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("meta", {
                        name: "keywords",
                        content: "Damyant Jain, portfolio, blog, React, developer, resume, programmer"
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("meta", {
                        property: "og:title",
                        content: "Damyant Jain"
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("meta", {
                        property: "og:description",
                        content: "I'm all about turning cool ideas into awesome products and exploring the ever-evolving tech world. With over 3 years of experience, I'm passionate about solving real-world problems. When I'm not coding, you can find me enjoying sports."
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("meta", {
                        property: "og:url",
                        content: "https://damyantjain.com/"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $1473df7d36a8dff2$export$2e2bcd8739ae039), {
                nav: (0, $71fffbba1262c84f$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                className: "mx-5 md:mx-24 mb-5 lg:mx-44 dark:bg-[#121212]",
                children: [
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                        id: "home",
                        className: "md:pt-24",
                        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $f19114865e4e8ab7$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                        id: "projects",
                        className: "md:pt-24",
                        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $1d2038d9bcf741e5$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                        id: "resume",
                        className: "md:pt-24",
                        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $497233f801911003$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                        id: "skills",
                        className: "md:pt-20",
                        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $d5b66711870655fa$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                        id: "contact",
                        className: "md:pt-40",
                        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $c30866d045584b89$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        ]
    });
};
var $bffff0e09a609a2b$export$2e2bcd8739ae039 = $bffff0e09a609a2b$var$Portfolio;





var $4RFnf = parcelRequire("4RFnf");





const $41132c70be51da54$var$formatTitleForURL = (title)=>{
    return title.toLowerCase().replace(/\s+/g, "-");
};
const $41132c70be51da54$var$BlogCard = ({ post: post })=>{
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)((0, $ab1c2d1a5ff1b7e8$export$a6c7ac8248d6e38a), {
            to: `${$41132c70be51da54$var$formatTitleForURL(post?.title)}-${post._id}`,
            children: [
                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                    className: "flex justify-between hover:cursor-pointer",
                    children: [
                        /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("h2", {
                                    className: "text-xl md:text-2xl text-[#333333] dark:text-[#e0e0e0] font-bold",
                                    children: post?.title
                                }),
                                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("p", {
                                    className: "font-poppins text-gray-500 dark:text-gray-400 line-clamp-2",
                                    children: post?.description
                                }),
                                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("p", {
                                    className: "mt-5 text-gray-500 text-sm dark:text-gray-400",
                                    children: new Date(post?.updatedAt).toLocaleDateString("en-US", {
                                        day: "numeric",
                                        month: "short",
                                        year: "numeric"
                                    })
                                })
                            ]
                        }),
                        post?.image && /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("img", {
                            className: "w-[80px] ml-5 md:ml-8 h-[53px] md:w-[160px] md:h-[107px] object-cover",
                            src: post?.image
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                    className: "h-[1px] mt-10 bg-[#e2e2e2]"
                })
            ]
        })
    });
};
var $41132c70be51da54$export$2e2bcd8739ae039 = $41132c70be51da54$var$BlogCard;


const $9c54885fd1343cb6$var$BlogCardList = ({ posts: posts })=>{
    const sortedPosts = posts.sort((a, b)=>new Date(b.updatedAt) - new Date(a.updatedAt));
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
        className: "pb-56",
        children: sortedPosts.map((post)=>{
            return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                className: "pt-10",
                children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $41132c70be51da54$export$2e2bcd8739ae039), {
                    post: post
                })
            }, post?._id);
        })
    });
};
var $9c54885fd1343cb6$export$2e2bcd8739ae039 = $9c54885fd1343cb6$var$BlogCardList;



const $7579c0da0d45f3f5$var$Shimmer = ()=>{
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        className: "pt-10",
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                                className: "shimmer-line bg-gradient-to-r from-gray-200 to-gray-300 dark:from-zinc-800 dark:to-zinc-900 w-4/12 h-4 mt-3"
                            }),
                            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                                className: "shimmer-line bg-gradient-to-r from-gray-200 to-gray-300 dark:from-zinc-800 dark:to-zinc-900 w-7/12 h-3 mt-3"
                            }),
                            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                                className: "bg-gradient-to-r from-gray-200 to-gray-300 dark:from-zinc-800 dark:to-zinc-900 w-1/12 h-3 mt-8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                        className: "bg-gradient-to-r from-gray-200 to-gray-300 dark:from-zinc-800 dark:to-zinc-900 w-[80px] ml-5 md:ml-8 h-[53px] md:w-[160px] md:h-[107px]"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                className: "h-[1px] mt-10 bg-gray-300  dark:bg-zinc-700"
            })
        ]
    });
};
const $7579c0da0d45f3f5$var$BlogListShimmer = ()=>{
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)($7579c0da0d45f3f5$var$Shimmer, {}),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)($7579c0da0d45f3f5$var$Shimmer, {}),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)($7579c0da0d45f3f5$var$Shimmer, {})
        ]
    });
};
var $7579c0da0d45f3f5$export$2e2bcd8739ae039 = $7579c0da0d45f3f5$var$BlogListShimmer;


const $554228b811351d1d$var$BlogHome = ()=>{
    const [posts, setPosts] = (0, $4RFnf.useState)([]);
    (0, $4RFnf.useEffect)(()=>{
        getBlogs();
    }, []);
    const getBlogs = async ()=>{
        var response = await fetch((0, $949f23ee69f32f96$export$ef523d22e5e75d61));
        if (!response.ok) {
            setPosts([]);
            return;
        } else {
            var data = await response.json();
            setPosts(data);
        }
    };
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
            className: "mx-5 md:mx-16 lg:mx-32 xl:mx-44",
            children: [
                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("h1", {
                    className: "text-xl md:text-2xl text-[#333333] dark:text-[#e0e0e0] font-poppins mt-5 mb-10",
                    children: "Reads"
                }),
                posts === null || posts.length === 0 ? /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $7579c0da0d45f3f5$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $9c54885fd1343cb6$export$2e2bcd8739ae039), {
                    posts: posts
                })
            ]
        })
    });
};
var $554228b811351d1d$export$2e2bcd8739ae039 = $554228b811351d1d$var$BlogHome;





var $4RFnf = parcelRequire("4RFnf");


const $f4af3c15f6cce367$var$BlogContent = ({ blog: blog })=>{
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
        children: blog?.contentBlocks?.map((block)=>/*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                className: "mb-10",
                children: [
                    block.type === "text" && /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("p", {
                        className: "text-[20px] font-serif antialiased mt-4",
                        children: block.content
                    }),
                    block.type === "image" && /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                        className: "text-center flex flex-col items-center",
                        children: [
                            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("img", {
                                className: "",
                                src: block.content
                            }),
                            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("p", {
                                className: "text-sm font-poppins text-gray-500 mt-2",
                                children: block.caption
                            })
                        ]
                    })
                ]
            }, block._id))
    });
};
var $f4af3c15f6cce367$export$2e2bcd8739ae039 = $f4af3c15f6cce367$var$BlogContent;



const $3ae5dfd3aef929fc$var$BlogView = ()=>{
    const { titleAndId: titleAndId } = (0, $2dda13c5d6544900$export$99eaa27ddbbb95ef)();
    const id = titleAndId.split("-").pop();
    const [blog, setBlog] = (0, $4RFnf.useState)({});
    const [blogNotFound, setBlogNotFound] = (0, $4RFnf.useState)(false);
    (0, $4RFnf.useEffect)(()=>{
        getBlog();
    }, []);
    const getBlog = async ()=>{
        var response = await fetch(`${(0, $949f23ee69f32f96$export$33946c87f7d00129)}/${id}`);
        if (!response.ok) {
            setBlogNotFound(true);
            return;
        }
        var data = await response.json();
        setBlog(data);
        updateBlogViews(id);
    };
    const updateBlogViews = async (id)=>{
        await fetch(`${(0, $949f23ee69f32f96$export$33946c87f7d00129)}/${id}/visitor-count`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            }
        });
    };
    if (blogNotFound) return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
        className: "",
        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("h1", {
            className: "text-3xl font-poppins text-[#333333] dark:text-[#e0e0e0] text-center mt-10",
            children: "Blog not found"
        })
    });
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        className: "w-full flex items-center justify-center",
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)((0, $12350d549f974864$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("title", {
                        children: blog.title || "Loading..."
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("meta", {
                        name: "description",
                        content: blog.description || "Blog post description"
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("meta", {
                        name: "keywords",
                        content: blog.keywords || "blog, tech, React"
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("meta", {
                        property: "og:title",
                        content: blog.title || "Blog Post Title"
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("meta", {
                        property: "og:description",
                        content: blog.description || "Description of the blog post."
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("meta", {
                        property: "og:type",
                        content: "article"
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("meta", {
                        property: "og:url",
                        content: `https://damyantjain.com/blog/${id}`
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("meta", {
                        property: "og:image",
                        content: blog.image
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                className: "dark:bg-[#121212] text-[#333333] dark:text-[#e0e0e0] md:mx-0 sm:mx-10 mx-5 w-full md:w-[680px]",
                children: [
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("h1", {
                        className: "text-[42px] font-bold",
                        children: blog.title
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("p", {
                        className: "text-sm text-gray-500",
                        children: new Date(blog.updatedAt).toLocaleDateString("en-US", {
                            day: "numeric",
                            month: "short",
                            year: "numeric"
                        })
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $f4af3c15f6cce367$export$2e2bcd8739ae039), {
                        blog: blog
                    })
                ]
            })
        ]
    });
};
var $3ae5dfd3aef929fc$export$2e2bcd8739ae039 = $3ae5dfd3aef929fc$var$BlogView;



parcelRequire("4RFnf");



const $ef26f297f078fa4a$var$BlogLayout = ()=>{
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        className: "flex flex-col min-h-screen",
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $1473df7d36a8dff2$export$2e2bcd8739ae039), {
                nav: []
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                className: "flex-grow md:pt-32 mb-20 mt-6 dark:bg-[#121212]",
                children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $2dda13c5d6544900$export$910ae8079b2c2852), {})
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                className: "mx-5 mt-auto mb-5 lg:mx-44",
                children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $c30866d045584b89$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $ef26f297f078fa4a$export$2e2bcd8739ae039 = $ef26f297f078fa4a$var$BlogLayout;




var $4RFnf = parcelRequire("4RFnf");



var $4RFnf = parcelRequire("4RFnf");
var $bd80854d1f7ebeed$exports = {};
"use strict";

$bd80854d1f7ebeed$exports = (parcelRequire("3xlep"));


var $99aed3ab2dc6c7d9$var$__defProp = Object.defineProperty;
var $99aed3ab2dc6c7d9$var$__defProps = Object.defineProperties;
var $99aed3ab2dc6c7d9$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $99aed3ab2dc6c7d9$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $99aed3ab2dc6c7d9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $99aed3ab2dc6c7d9$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $99aed3ab2dc6c7d9$var$__defNormalProp = (obj, key, value)=>key in obj ? $99aed3ab2dc6c7d9$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $99aed3ab2dc6c7d9$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($99aed3ab2dc6c7d9$var$__hasOwnProp.call(b, prop)) $99aed3ab2dc6c7d9$var$__defNormalProp(a, prop, b[prop]);
    if ($99aed3ab2dc6c7d9$var$__getOwnPropSymbols) {
        for (var prop of $99aed3ab2dc6c7d9$var$__getOwnPropSymbols(b))if ($99aed3ab2dc6c7d9$var$__propIsEnum.call(b, prop)) $99aed3ab2dc6c7d9$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $99aed3ab2dc6c7d9$var$__spreadProps = (a, b)=>$99aed3ab2dc6c7d9$var$__defProps(a, $99aed3ab2dc6c7d9$var$__getOwnPropDescs(b));
var $99aed3ab2dc6c7d9$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($99aed3ab2dc6c7d9$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $99aed3ab2dc6c7d9$var$__getOwnPropSymbols) {
        for (var prop of $99aed3ab2dc6c7d9$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $99aed3ab2dc6c7d9$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $99aed3ab2dc6c7d9$var$React = // prettier-ignore
// @ts-ignore
"default" in $4RFnf ? $4RFnf["default"] : $4RFnf;
// src/components/Context.ts
var $99aed3ab2dc6c7d9$var$ContextKey = Symbol.for(`react-redux-context`);
var $99aed3ab2dc6c7d9$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $99aed3ab2dc6c7d9$var$getContext() {
    var _a;
    if (!$99aed3ab2dc6c7d9$var$React.createContext) return {};
    const contextMap = (_a = $99aed3ab2dc6c7d9$var$gT[$99aed3ab2dc6c7d9$var$ContextKey]) != null ? _a : $99aed3ab2dc6c7d9$var$gT[$99aed3ab2dc6c7d9$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($99aed3ab2dc6c7d9$var$React.createContext);
    if (!realContext) {
        realContext = $99aed3ab2dc6c7d9$var$React.createContext(null);
        contextMap.set($99aed3ab2dc6c7d9$var$React.createContext, realContext);
    }
    return realContext;
}
var $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00 = /* @__PURE__ */ $99aed3ab2dc6c7d9$var$getContext();
// src/utils/useSyncExternalStore.ts
var $99aed3ab2dc6c7d9$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $99aed3ab2dc6c7d9$var$createReduxContextHook(context = $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $99aed3ab2dc6c7d9$var$React.useContext(context);
        return contextValue;
    };
}
var $99aed3ab2dc6c7d9$var$useReduxContext = /* @__PURE__ */ $99aed3ab2dc6c7d9$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $99aed3ab2dc6c7d9$var$useSyncExternalStoreWithSelector = $99aed3ab2dc6c7d9$var$notInitialized;
var $99aed3ab2dc6c7d9$var$initializeUseSelector = (fn)=>{
    $99aed3ab2dc6c7d9$var$useSyncExternalStoreWithSelector = fn;
};
var $99aed3ab2dc6c7d9$var$refEquality = (a, b)=>a === b;
function $99aed3ab2dc6c7d9$export$2b53f90d2bd1cbfb(context = $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00 ? $99aed3ab2dc6c7d9$var$useReduxContext : $99aed3ab2dc6c7d9$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $99aed3ab2dc6c7d9$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $99aed3ab2dc6c7d9$var$React.useRef(true);
        const wrappedSelector = $99aed3ab2dc6c7d9$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $99aed3ab2dc6c7d9$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $99aed3ab2dc6c7d9$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $99aed3ab2dc6c7d9$export$2105062e25df4afe = /* @__PURE__ */ $99aed3ab2dc6c7d9$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $99aed3ab2dc6c7d9$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $99aed3ab2dc6c7d9$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $99aed3ab2dc6c7d9$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $99aed3ab2dc6c7d9$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $99aed3ab2dc6c7d9$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $99aed3ab2dc6c7d9$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $99aed3ab2dc6c7d9$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $99aed3ab2dc6c7d9$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $99aed3ab2dc6c7d9$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $99aed3ab2dc6c7d9$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $99aed3ab2dc6c7d9$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $99aed3ab2dc6c7d9$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $99aed3ab2dc6c7d9$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $99aed3ab2dc6c7d9$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $99aed3ab2dc6c7d9$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $99aed3ab2dc6c7d9$var$ForwardRef = $99aed3ab2dc6c7d9$var$REACT_FORWARD_REF_TYPE;
var $99aed3ab2dc6c7d9$var$Memo = $99aed3ab2dc6c7d9$var$REACT_MEMO_TYPE;
function $99aed3ab2dc6c7d9$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $99aed3ab2dc6c7d9$var$REACT_FRAGMENT_TYPE || type === $99aed3ab2dc6c7d9$var$REACT_PROFILER_TYPE || type === $99aed3ab2dc6c7d9$var$REACT_STRICT_MODE_TYPE || type === $99aed3ab2dc6c7d9$var$REACT_SUSPENSE_TYPE || type === $99aed3ab2dc6c7d9$var$REACT_SUSPENSE_LIST_TYPE || type === $99aed3ab2dc6c7d9$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $99aed3ab2dc6c7d9$var$REACT_LAZY_TYPE || type.$$typeof === $99aed3ab2dc6c7d9$var$REACT_MEMO_TYPE || type.$$typeof === $99aed3ab2dc6c7d9$var$REACT_PROVIDER_TYPE || type.$$typeof === $99aed3ab2dc6c7d9$var$REACT_CONTEXT_TYPE || type.$$typeof === $99aed3ab2dc6c7d9$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $99aed3ab2dc6c7d9$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $99aed3ab2dc6c7d9$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $99aed3ab2dc6c7d9$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $99aed3ab2dc6c7d9$var$REACT_FRAGMENT_TYPE:
                        case $99aed3ab2dc6c7d9$var$REACT_PROFILER_TYPE:
                        case $99aed3ab2dc6c7d9$var$REACT_STRICT_MODE_TYPE:
                        case $99aed3ab2dc6c7d9$var$REACT_SUSPENSE_TYPE:
                        case $99aed3ab2dc6c7d9$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $99aed3ab2dc6c7d9$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $99aed3ab2dc6c7d9$var$REACT_CONTEXT_TYPE:
                                    case $99aed3ab2dc6c7d9$var$REACT_FORWARD_REF_TYPE:
                                    case $99aed3ab2dc6c7d9$var$REACT_LAZY_TYPE:
                                    case $99aed3ab2dc6c7d9$var$REACT_MEMO_TYPE:
                                    case $99aed3ab2dc6c7d9$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $99aed3ab2dc6c7d9$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $99aed3ab2dc6c7d9$var$isContextConsumer(object) {
    return $99aed3ab2dc6c7d9$var$typeOf(object) === $99aed3ab2dc6c7d9$var$REACT_CONTEXT_TYPE;
}
function $99aed3ab2dc6c7d9$var$isMemo(object) {
    return $99aed3ab2dc6c7d9$var$typeOf(object) === $99aed3ab2dc6c7d9$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $99aed3ab2dc6c7d9$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $99aed3ab2dc6c7d9$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $99aed3ab2dc6c7d9$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $99aed3ab2dc6c7d9$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $99aed3ab2dc6c7d9$var$verify(mapStateToProps, "mapStateToProps");
    $99aed3ab2dc6c7d9$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $99aed3ab2dc6c7d9$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $99aed3ab2dc6c7d9$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $99aed3ab2dc6c7d9$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $99aed3ab2dc6c7d9$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $99aed3ab2dc6c7d9$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $99aed3ab2dc6c7d9$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $99aed3ab2dc6c7d9$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $99aed3ab2dc6c7d9$var$verifyPlainObject(value, displayName, methodName) {
    if (!$99aed3ab2dc6c7d9$var$isPlainObject(value)) $99aed3ab2dc6c7d9$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $99aed3ab2dc6c7d9$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $99aed3ab2dc6c7d9$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $99aed3ab2dc6c7d9$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $99aed3ab2dc6c7d9$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $99aed3ab2dc6c7d9$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $99aed3ab2dc6c7d9$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $99aed3ab2dc6c7d9$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $99aed3ab2dc6c7d9$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $99aed3ab2dc6c7d9$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $99aed3ab2dc6c7d9$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $99aed3ab2dc6c7d9$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $99aed3ab2dc6c7d9$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $99aed3ab2dc6c7d9$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $99aed3ab2dc6c7d9$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $99aed3ab2dc6c7d9$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $99aed3ab2dc6c7d9$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $99aed3ab2dc6c7d9$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $99aed3ab2dc6c7d9$var$__spreadValues($99aed3ab2dc6c7d9$var$__spreadValues($99aed3ab2dc6c7d9$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $99aed3ab2dc6c7d9$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $99aed3ab2dc6c7d9$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$99aed3ab2dc6c7d9$var$defaultMergeProps : typeof mergeProps === "function" ? $99aed3ab2dc6c7d9$var$wrapMergePropsFunc(mergeProps) : $99aed3ab2dc6c7d9$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $99aed3ab2dc6c7d9$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $99aed3ab2dc6c7d9$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $99aed3ab2dc6c7d9$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $99aed3ab2dc6c7d9$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $99aed3ab2dc6c7d9$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $99aed3ab2dc6c7d9$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $99aed3ab2dc6c7d9$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $99aed3ab2dc6c7d9$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $99aed3ab2dc6c7d9$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $99aed3ab2dc6c7d9$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffect = $99aed3ab2dc6c7d9$var$canUseDOM || $99aed3ab2dc6c7d9$var$isReactNative ? $99aed3ab2dc6c7d9$var$React.useLayoutEffect : $99aed3ab2dc6c7d9$var$React.useEffect;
// src/utils/shallowEqual.ts
function $99aed3ab2dc6c7d9$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $99aed3ab2dc6c7d9$export$d36bdfa510afb180(objA, objB) {
    if ($99aed3ab2dc6c7d9$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$99aed3ab2dc6c7d9$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $99aed3ab2dc6c7d9$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $99aed3ab2dc6c7d9$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $99aed3ab2dc6c7d9$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $99aed3ab2dc6c7d9$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $99aed3ab2dc6c7d9$var$TYPE_STATICS = {
    [$99aed3ab2dc6c7d9$var$ForwardRef]: $99aed3ab2dc6c7d9$var$FORWARD_REF_STATICS,
    [$99aed3ab2dc6c7d9$var$Memo]: $99aed3ab2dc6c7d9$var$MEMO_STATICS
};
function $99aed3ab2dc6c7d9$var$getStatics(component) {
    if ($99aed3ab2dc6c7d9$var$isMemo(component)) return $99aed3ab2dc6c7d9$var$MEMO_STATICS;
    return $99aed3ab2dc6c7d9$var$TYPE_STATICS[component["$$typeof"]] || $99aed3ab2dc6c7d9$var$REACT_STATICS;
}
var $99aed3ab2dc6c7d9$var$defineProperty = Object.defineProperty;
var $99aed3ab2dc6c7d9$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $99aed3ab2dc6c7d9$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $99aed3ab2dc6c7d9$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $99aed3ab2dc6c7d9$var$getPrototypeOf = Object.getPrototypeOf;
var $99aed3ab2dc6c7d9$var$objectPrototype = Object.prototype;
function $99aed3ab2dc6c7d9$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($99aed3ab2dc6c7d9$var$objectPrototype) {
            const inheritedComponent = $99aed3ab2dc6c7d9$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $99aed3ab2dc6c7d9$var$objectPrototype) $99aed3ab2dc6c7d9$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $99aed3ab2dc6c7d9$var$getOwnPropertyNames(sourceComponent);
        if ($99aed3ab2dc6c7d9$var$getOwnPropertySymbols) keys = keys.concat($99aed3ab2dc6c7d9$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $99aed3ab2dc6c7d9$var$getStatics(targetComponent);
        const sourceStatics = $99aed3ab2dc6c7d9$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$99aed3ab2dc6c7d9$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $99aed3ab2dc6c7d9$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $99aed3ab2dc6c7d9$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $99aed3ab2dc6c7d9$var$useSyncExternalStore = $99aed3ab2dc6c7d9$var$notInitialized;
var $99aed3ab2dc6c7d9$var$initializeConnect = (fn)=>{
    $99aed3ab2dc6c7d9$var$useSyncExternalStore = fn;
};
var $99aed3ab2dc6c7d9$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $99aed3ab2dc6c7d9$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $99aed3ab2dc6c7d9$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $99aed3ab2dc6c7d9$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $99aed3ab2dc6c7d9$var$strictEqual(a, b) {
    return a === b;
}
var $99aed3ab2dc6c7d9$var$hasWarnedAboutDeprecatedPureOption = false;
function $99aed3ab2dc6c7d9$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $99aed3ab2dc6c7d9$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $99aed3ab2dc6c7d9$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $99aed3ab2dc6c7d9$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $99aed3ab2dc6c7d9$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $99aed3ab2dc6c7d9$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $99aed3ab2dc6c7d9$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $99aed3ab2dc6c7d9$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $99aed3ab2dc6c7d9$var$React.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $99aed3ab2dc6c7d9$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $99aed3ab2dc6c7d9$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $99aed3ab2dc6c7d9$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $99aed3ab2dc6c7d9$var$React.useMemo(()=>{
                return $99aed3ab2dc6c7d9$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $99aed3ab2dc6c7d9$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $99aed3ab2dc6c7d9$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $99aed3ab2dc6c7d9$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $99aed3ab2dc6c7d9$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $99aed3ab2dc6c7d9$var$__spreadProps($99aed3ab2dc6c7d9$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $99aed3ab2dc6c7d9$var$React.useRef(void 0);
            const lastWrapperProps = $99aed3ab2dc6c7d9$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $99aed3ab2dc6c7d9$var$React.useRef(void 0);
            const renderIsScheduled = $99aed3ab2dc6c7d9$var$React.useRef(false);
            const isMounted = $99aed3ab2dc6c7d9$var$React.useRef(false);
            const latestSubscriptionCallbackError = $99aed3ab2dc6c7d9$var$React.useRef(void 0);
            $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $99aed3ab2dc6c7d9$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $99aed3ab2dc6c7d9$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $99aed3ab2dc6c7d9$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffectWithArgs($99aed3ab2dc6c7d9$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $99aed3ab2dc6c7d9$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $99aed3ab2dc6c7d9$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $99aed3ab2dc6c7d9$var$React.createElement(WrappedComponent, $99aed3ab2dc6c7d9$var$__spreadProps($99aed3ab2dc6c7d9$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $99aed3ab2dc6c7d9$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $99aed3ab2dc6c7d9$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $99aed3ab2dc6c7d9$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $99aed3ab2dc6c7d9$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $99aed3ab2dc6c7d9$var$React.createElement(Connect, $99aed3ab2dc6c7d9$var$__spreadProps($99aed3ab2dc6c7d9$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $99aed3ab2dc6c7d9$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $99aed3ab2dc6c7d9$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $99aed3ab2dc6c7d9$export$64605811ab45167f = $99aed3ab2dc6c7d9$var$connect;
// src/components/Provider.tsx
function $99aed3ab2dc6c7d9$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $99aed3ab2dc6c7d9$var$React.useMemo(()=>{
        const subscription = $99aed3ab2dc6c7d9$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $99aed3ab2dc6c7d9$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $99aed3ab2dc6c7d9$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $99aed3ab2dc6c7d9$export$2881499e37b75b9a = $99aed3ab2dc6c7d9$var$Provider;
// src/hooks/useStore.ts
function $99aed3ab2dc6c7d9$export$671dba69185d0304(context = $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00 ? $99aed3ab2dc6c7d9$var$useReduxContext : // @ts-ignore
    $99aed3ab2dc6c7d9$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $99aed3ab2dc6c7d9$export$6ccbb43953eebf8 = /* @__PURE__ */ $99aed3ab2dc6c7d9$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $99aed3ab2dc6c7d9$export$bc9b55530897c558(context = $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00) {
    const useStore2 = context === $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00 ? $99aed3ab2dc6c7d9$export$6ccbb43953eebf8 : $99aed3ab2dc6c7d9$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $99aed3ab2dc6c7d9$export$8ad76b76a4c905f8 = /* @__PURE__ */ $99aed3ab2dc6c7d9$export$bc9b55530897c558();
// src/exports.ts
var $99aed3ab2dc6c7d9$export$712ea50be43a7858 = $99aed3ab2dc6c7d9$var$defaultNoopBatch;
// src/index.ts
$99aed3ab2dc6c7d9$var$initializeUseSelector((0, $bd80854d1f7ebeed$exports.useSyncExternalStoreWithSelector));
$99aed3ab2dc6c7d9$var$initializeConnect($4RFnf.useSyncExternalStore);


// src/utils/formatProdErrorMessage.ts
function $876d8277641f3cc3$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $876d8277641f3cc3$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $876d8277641f3cc3$var$symbol_observable_default = $876d8277641f3cc3$var$$$observable;
// src/utils/actionTypes.ts
var $876d8277641f3cc3$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $876d8277641f3cc3$var$ActionTypes = {
    INIT: `@@redux/INIT${$876d8277641f3cc3$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$876d8277641f3cc3$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$876d8277641f3cc3$var$randomString()}`
};
var $876d8277641f3cc3$export$4219e499db7ca678 = $876d8277641f3cc3$var$ActionTypes;
// src/utils/isPlainObject.ts
function $876d8277641f3cc3$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $876d8277641f3cc3$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($876d8277641f3cc3$var$isDate(val)) return "date";
    if ($876d8277641f3cc3$var$isError(val)) return "error";
    const constructorName = $876d8277641f3cc3$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $876d8277641f3cc3$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $876d8277641f3cc3$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $876d8277641f3cc3$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $876d8277641f3cc3$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $876d8277641f3cc3$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(1));
        return enhancer($876d8277641f3cc3$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$876d8277641f3cc3$export$53b83ca8eaab0383(action)) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $876d8277641f3cc3$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$876d8277641f3cc3$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $876d8277641f3cc3$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$876d8277641f3cc3$var$symbol_observable_default]: observable
    };
    return store;
}
function $876d8277641f3cc3$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $876d8277641f3cc3$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $876d8277641f3cc3$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $876d8277641f3cc3$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $876d8277641f3cc3$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$876d8277641f3cc3$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$876d8277641f3cc3$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $876d8277641f3cc3$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $876d8277641f3cc3$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $876d8277641f3cc3$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $876d8277641f3cc3$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(13));
    });
}
function $876d8277641f3cc3$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $876d8277641f3cc3$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $876d8277641f3cc3$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $876d8277641f3cc3$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $876d8277641f3cc3$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $876d8277641f3cc3$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $876d8277641f3cc3$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $876d8277641f3cc3$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $876d8277641f3cc3$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $876d8277641f3cc3$export$b956e38827fca970(action) {
    return $876d8277641f3cc3$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $3fcdd01f4bd90a60$var$__defProp = Object.defineProperty;
var $3fcdd01f4bd90a60$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3fcdd01f4bd90a60$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3fcdd01f4bd90a60$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3fcdd01f4bd90a60$var$__defNormalProp = (obj, key, value)=>key in obj ? $3fcdd01f4bd90a60$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3fcdd01f4bd90a60$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($3fcdd01f4bd90a60$var$__hasOwnProp.call(b, prop)) $3fcdd01f4bd90a60$var$__defNormalProp(a, prop, b[prop]);
    if ($3fcdd01f4bd90a60$var$__getOwnPropSymbols) {
        for (var prop of $3fcdd01f4bd90a60$var$__getOwnPropSymbols(b))if ($3fcdd01f4bd90a60$var$__propIsEnum.call(b, prop)) $3fcdd01f4bd90a60$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $3fcdd01f4bd90a60$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $3fcdd01f4bd90a60$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $3fcdd01f4bd90a60$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $3fcdd01f4bd90a60$var$errors = [];
function $3fcdd01f4bd90a60$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $3fcdd01f4bd90a60$var$getPrototypeOf = Object.getPrototypeOf;
function $3fcdd01f4bd90a60$export$541ac630993a4c84(value) {
    return !!value && !!value[$3fcdd01f4bd90a60$var$DRAFT_STATE];
}
function $3fcdd01f4bd90a60$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $3fcdd01f4bd90a60$var$isPlainObject(value) || Array.isArray(value) || !!value[$3fcdd01f4bd90a60$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$3fcdd01f4bd90a60$export$6ee2082928bcb0ee]) || $3fcdd01f4bd90a60$var$isMap(value) || $3fcdd01f4bd90a60$var$isSet(value);
}
var $3fcdd01f4bd90a60$var$objectCtorString = Object.prototype.constructor.toString();
function $3fcdd01f4bd90a60$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $3fcdd01f4bd90a60$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $3fcdd01f4bd90a60$var$objectCtorString;
}
function $3fcdd01f4bd90a60$export$22e8af3f75a010e3(value) {
    if (!$3fcdd01f4bd90a60$export$541ac630993a4c84(value)) $3fcdd01f4bd90a60$var$die(15, value);
    return value[$3fcdd01f4bd90a60$var$DRAFT_STATE].base_;
}
function $3fcdd01f4bd90a60$var$each(obj, iter) {
    if ($3fcdd01f4bd90a60$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $3fcdd01f4bd90a60$var$getArchtype(thing) {
    const state = thing[$3fcdd01f4bd90a60$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $3fcdd01f4bd90a60$var$isMap(thing) ? 2 /* Map */  : $3fcdd01f4bd90a60$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $3fcdd01f4bd90a60$var$has(thing, prop) {
    return $3fcdd01f4bd90a60$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $3fcdd01f4bd90a60$var$get(thing, prop) {
    return $3fcdd01f4bd90a60$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $3fcdd01f4bd90a60$var$set(thing, propOrOldValue, value) {
    const t = $3fcdd01f4bd90a60$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $3fcdd01f4bd90a60$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $3fcdd01f4bd90a60$var$isMap(target) {
    return target instanceof Map;
}
function $3fcdd01f4bd90a60$var$isSet(target) {
    return target instanceof Set;
}
function $3fcdd01f4bd90a60$var$latest(state) {
    return state.copy_ || state.base_;
}
function $3fcdd01f4bd90a60$var$shallowCopy(base, strict) {
    if ($3fcdd01f4bd90a60$var$isMap(base)) return new Map(base);
    if ($3fcdd01f4bd90a60$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $3fcdd01f4bd90a60$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$3fcdd01f4bd90a60$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($3fcdd01f4bd90a60$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $3fcdd01f4bd90a60$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $3fcdd01f4bd90a60$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $3fcdd01f4bd90a60$export$792f3d81ea979f55(obj, deep = false) {
    if ($3fcdd01f4bd90a60$var$isFrozen(obj) || $3fcdd01f4bd90a60$export$541ac630993a4c84(obj) || !$3fcdd01f4bd90a60$export$16e3aed3edb85946(obj)) return obj;
    if ($3fcdd01f4bd90a60$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $3fcdd01f4bd90a60$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$3fcdd01f4bd90a60$export$792f3d81ea979f55(value, true));
    return obj;
}
function $3fcdd01f4bd90a60$var$dontMutateFrozenCollections() {
    $3fcdd01f4bd90a60$var$die(2);
}
function $3fcdd01f4bd90a60$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $3fcdd01f4bd90a60$var$plugins = {};
function $3fcdd01f4bd90a60$var$getPlugin(pluginKey) {
    const plugin = $3fcdd01f4bd90a60$var$plugins[pluginKey];
    if (!plugin) $3fcdd01f4bd90a60$var$die(0, pluginKey);
    return plugin;
}
function $3fcdd01f4bd90a60$var$loadPlugin(pluginKey, implementation) {
    if (!$3fcdd01f4bd90a60$var$plugins[pluginKey]) $3fcdd01f4bd90a60$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $3fcdd01f4bd90a60$var$currentScope;
function $3fcdd01f4bd90a60$var$getCurrentScope() {
    return $3fcdd01f4bd90a60$var$currentScope;
}
function $3fcdd01f4bd90a60$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $3fcdd01f4bd90a60$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $3fcdd01f4bd90a60$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $3fcdd01f4bd90a60$var$revokeScope(scope) {
    $3fcdd01f4bd90a60$var$leaveScope(scope);
    scope.drafts_.forEach($3fcdd01f4bd90a60$var$revokeDraft);
    scope.drafts_ = null;
}
function $3fcdd01f4bd90a60$var$leaveScope(scope) {
    if (scope === $3fcdd01f4bd90a60$var$currentScope) $3fcdd01f4bd90a60$var$currentScope = scope.parent_;
}
function $3fcdd01f4bd90a60$var$enterScope(immer2) {
    return $3fcdd01f4bd90a60$var$currentScope = $3fcdd01f4bd90a60$var$createScope($3fcdd01f4bd90a60$var$currentScope, immer2);
}
function $3fcdd01f4bd90a60$var$revokeDraft(draft) {
    const state = draft[$3fcdd01f4bd90a60$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $3fcdd01f4bd90a60$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$3fcdd01f4bd90a60$var$DRAFT_STATE].modified_) {
            $3fcdd01f4bd90a60$var$revokeScope(scope);
            $3fcdd01f4bd90a60$var$die(4);
        }
        if ($3fcdd01f4bd90a60$export$16e3aed3edb85946(result)) {
            result = $3fcdd01f4bd90a60$var$finalize(scope, result);
            if (!scope.parent_) $3fcdd01f4bd90a60$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $3fcdd01f4bd90a60$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$3fcdd01f4bd90a60$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $3fcdd01f4bd90a60$var$finalize(scope, baseDraft, []);
    $3fcdd01f4bd90a60$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $3fcdd01f4bd90a60$export$45b790e32b2810ee ? result : void 0;
}
function $3fcdd01f4bd90a60$var$finalize(rootScope, value, path) {
    if ($3fcdd01f4bd90a60$var$isFrozen(value)) return value;
    const state = value[$3fcdd01f4bd90a60$var$DRAFT_STATE];
    if (!state) {
        $3fcdd01f4bd90a60$var$each(value, (key, childValue)=>$3fcdd01f4bd90a60$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $3fcdd01f4bd90a60$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $3fcdd01f4bd90a60$var$each(resultEach, (key, childValue)=>$3fcdd01f4bd90a60$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $3fcdd01f4bd90a60$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $3fcdd01f4bd90a60$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $3fcdd01f4bd90a60$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($3fcdd01f4bd90a60$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$3fcdd01f4bd90a60$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $3fcdd01f4bd90a60$var$finalize(rootScope, childValue, path);
        $3fcdd01f4bd90a60$var$set(targetObject, prop, res);
        if ($3fcdd01f4bd90a60$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($3fcdd01f4bd90a60$export$16e3aed3edb85946(childValue) && !$3fcdd01f4bd90a60$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $3fcdd01f4bd90a60$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $3fcdd01f4bd90a60$var$maybeFreeze(rootScope, childValue);
    }
}
function $3fcdd01f4bd90a60$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $3fcdd01f4bd90a60$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $3fcdd01f4bd90a60$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $3fcdd01f4bd90a60$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $3fcdd01f4bd90a60$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $3fcdd01f4bd90a60$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $3fcdd01f4bd90a60$var$objectTraps = {
    get (state, prop) {
        if (prop === $3fcdd01f4bd90a60$var$DRAFT_STATE) return state;
        const source = $3fcdd01f4bd90a60$var$latest(state);
        if (!$3fcdd01f4bd90a60$var$has(source, prop)) return $3fcdd01f4bd90a60$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$3fcdd01f4bd90a60$export$16e3aed3edb85946(value)) return value;
        if (value === $3fcdd01f4bd90a60$var$peek(state.base_, prop)) {
            $3fcdd01f4bd90a60$var$prepareCopy(state);
            return state.copy_[prop] = $3fcdd01f4bd90a60$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $3fcdd01f4bd90a60$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($3fcdd01f4bd90a60$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $3fcdd01f4bd90a60$var$getDescriptorFromProto($3fcdd01f4bd90a60$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $3fcdd01f4bd90a60$var$peek($3fcdd01f4bd90a60$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($3fcdd01f4bd90a60$var$is(value, current2) && (value !== void 0 || $3fcdd01f4bd90a60$var$has(state.base_, prop))) return true;
            $3fcdd01f4bd90a60$var$prepareCopy(state);
            $3fcdd01f4bd90a60$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($3fcdd01f4bd90a60$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $3fcdd01f4bd90a60$var$prepareCopy(state);
            $3fcdd01f4bd90a60$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $3fcdd01f4bd90a60$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $3fcdd01f4bd90a60$var$die(11);
    },
    getPrototypeOf (state) {
        return $3fcdd01f4bd90a60$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $3fcdd01f4bd90a60$var$die(12);
    }
};
var $3fcdd01f4bd90a60$var$arrayTraps = {};
$3fcdd01f4bd90a60$var$each($3fcdd01f4bd90a60$var$objectTraps, (key, fn)=>{
    $3fcdd01f4bd90a60$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$3fcdd01f4bd90a60$var$arrayTraps.deleteProperty = function(state, prop) {
    return $3fcdd01f4bd90a60$var$arrayTraps.set.call(this, state, prop, void 0);
};
$3fcdd01f4bd90a60$var$arrayTraps.set = function(state, prop, value) {
    return $3fcdd01f4bd90a60$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $3fcdd01f4bd90a60$var$peek(draft, prop) {
    const state = draft[$3fcdd01f4bd90a60$var$DRAFT_STATE];
    const source = state ? $3fcdd01f4bd90a60$var$latest(state) : draft;
    return source[prop];
}
function $3fcdd01f4bd90a60$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $3fcdd01f4bd90a60$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $3fcdd01f4bd90a60$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $3fcdd01f4bd90a60$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $3fcdd01f4bd90a60$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $3fcdd01f4bd90a60$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $3fcdd01f4bd90a60$var$markChanged(state.parent_);
    }
}
function $3fcdd01f4bd90a60$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $3fcdd01f4bd90a60$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $3fcdd01f4bd90a60$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $3fcdd01f4bd90a60$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $3fcdd01f4bd90a60$var$die(7);
            let result;
            if ($3fcdd01f4bd90a60$export$16e3aed3edb85946(base)) {
                const scope = $3fcdd01f4bd90a60$var$enterScope(this);
                const proxy = $3fcdd01f4bd90a60$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $3fcdd01f4bd90a60$var$revokeScope(scope);
                    else $3fcdd01f4bd90a60$var$leaveScope(scope);
                }
                $3fcdd01f4bd90a60$var$usePatchesInScope(scope, patchListener);
                return $3fcdd01f4bd90a60$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $3fcdd01f4bd90a60$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $3fcdd01f4bd90a60$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $3fcdd01f4bd90a60$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $3fcdd01f4bd90a60$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$3fcdd01f4bd90a60$export$16e3aed3edb85946(base)) $3fcdd01f4bd90a60$var$die(8);
        if ($3fcdd01f4bd90a60$export$541ac630993a4c84(base)) base = $3fcdd01f4bd90a60$export$97aac956da55dae9(base);
        const scope = $3fcdd01f4bd90a60$var$enterScope(this);
        const proxy = $3fcdd01f4bd90a60$var$createProxy(base, void 0);
        proxy[$3fcdd01f4bd90a60$var$DRAFT_STATE].isManual_ = true;
        $3fcdd01f4bd90a60$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$3fcdd01f4bd90a60$var$DRAFT_STATE];
        if (!state || !state.isManual_) $3fcdd01f4bd90a60$var$die(9);
        const { scope_: scope } = state;
        $3fcdd01f4bd90a60$var$usePatchesInScope(scope, patchListener);
        return $3fcdd01f4bd90a60$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $3fcdd01f4bd90a60$var$getPlugin("Patches").applyPatches_;
        if ($3fcdd01f4bd90a60$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $3fcdd01f4bd90a60$var$createProxy(value, parent) {
    const draft = $3fcdd01f4bd90a60$var$isMap(value) ? $3fcdd01f4bd90a60$var$getPlugin("MapSet").proxyMap_(value, parent) : $3fcdd01f4bd90a60$var$isSet(value) ? $3fcdd01f4bd90a60$var$getPlugin("MapSet").proxySet_(value, parent) : $3fcdd01f4bd90a60$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $3fcdd01f4bd90a60$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $3fcdd01f4bd90a60$export$97aac956da55dae9(value) {
    if (!$3fcdd01f4bd90a60$export$541ac630993a4c84(value)) $3fcdd01f4bd90a60$var$die(10, value);
    return $3fcdd01f4bd90a60$var$currentImpl(value);
}
function $3fcdd01f4bd90a60$var$currentImpl(value) {
    if (!$3fcdd01f4bd90a60$export$16e3aed3edb85946(value) || $3fcdd01f4bd90a60$var$isFrozen(value)) return value;
    const state = value[$3fcdd01f4bd90a60$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $3fcdd01f4bd90a60$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $3fcdd01f4bd90a60$var$shallowCopy(value, true);
    $3fcdd01f4bd90a60$var$each(copy, (key, childValue)=>{
        $3fcdd01f4bd90a60$var$set(copy, key, $3fcdd01f4bd90a60$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $3fcdd01f4bd90a60$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $3fcdd01f4bd90a60$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $3fcdd01f4bd90a60$var$get(base_, key);
            const value = $3fcdd01f4bd90a60$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $3fcdd01f4bd90a60$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $3fcdd01f4bd90a60$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $3fcdd01f4bd90a60$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $3fcdd01f4bd90a60$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $3fcdd01f4bd90a60$var$die(errorOffset + 3);
                base = $3fcdd01f4bd90a60$var$get(base, p);
                if (typeof base !== "object") $3fcdd01f4bd90a60$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $3fcdd01f4bd90a60$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $3fcdd01f4bd90a60$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $3fcdd01f4bd90a60$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$3fcdd01f4bd90a60$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($3fcdd01f4bd90a60$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($3fcdd01f4bd90a60$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($3fcdd01f4bd90a60$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($3fcdd01f4bd90a60$var$has(obj, $3fcdd01f4bd90a60$export$6ee2082928bcb0ee)) cloned[$3fcdd01f4bd90a60$export$6ee2082928bcb0ee] = obj[$3fcdd01f4bd90a60$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($3fcdd01f4bd90a60$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $3fcdd01f4bd90a60$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $3fcdd01f4bd90a60$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$3fcdd01f4bd90a60$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $3fcdd01f4bd90a60$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $3fcdd01f4bd90a60$var$latest(this[$3fcdd01f4bd90a60$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $3fcdd01f4bd90a60$var$latest(this[$3fcdd01f4bd90a60$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$3fcdd01f4bd90a60$var$latest(state).has(key) || $3fcdd01f4bd90a60$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $3fcdd01f4bd90a60$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $3fcdd01f4bd90a60$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($3fcdd01f4bd90a60$var$latest(state).size) {
                prepareMapCopy(state);
                $3fcdd01f4bd90a60$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $3fcdd01f4bd90a60$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            $3fcdd01f4bd90a60$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $3fcdd01f4bd90a60$var$latest(state).get(key);
            if (state.finalized_ || !$3fcdd01f4bd90a60$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $3fcdd01f4bd90a60$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $3fcdd01f4bd90a60$var$latest(this[$3fcdd01f4bd90a60$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($3fcdd01f4bd90a60$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$3fcdd01f4bd90a60$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $3fcdd01f4bd90a60$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $3fcdd01f4bd90a60$var$latest(this[$3fcdd01f4bd90a60$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $3fcdd01f4bd90a60$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $3fcdd01f4bd90a60$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($3fcdd01f4bd90a60$var$latest(state).size) {
                prepareSetCopy(state);
                $3fcdd01f4bd90a60$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($3fcdd01f4bd90a60$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($3fcdd01f4bd90a60$export$16e3aed3edb85946(value)) {
                    const draft = $3fcdd01f4bd90a60$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $3fcdd01f4bd90a60$var$die(3, JSON.stringify($3fcdd01f4bd90a60$var$latest(state)));
    }
    $3fcdd01f4bd90a60$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $3fcdd01f4bd90a60$var$immer = new $3fcdd01f4bd90a60$export$aaadc6ff0f822719();
var $3fcdd01f4bd90a60$export$b46cabe22e78bc00 = $3fcdd01f4bd90a60$var$immer.produce;
var $3fcdd01f4bd90a60$export$4da66d41c9492c78 = $3fcdd01f4bd90a60$var$immer.produceWithPatches.bind($3fcdd01f4bd90a60$var$immer);
var $3fcdd01f4bd90a60$export$573f26f60825c493 = $3fcdd01f4bd90a60$var$immer.setAutoFreeze.bind($3fcdd01f4bd90a60$var$immer);
var $3fcdd01f4bd90a60$export$333ce65961cbe047 = $3fcdd01f4bd90a60$var$immer.setUseStrictShallowCopy.bind($3fcdd01f4bd90a60$var$immer);
var $3fcdd01f4bd90a60$export$a8b8e03e6bbe5473 = $3fcdd01f4bd90a60$var$immer.applyPatches.bind($3fcdd01f4bd90a60$var$immer);
var $3fcdd01f4bd90a60$export$3c3214997190395f = $3fcdd01f4bd90a60$var$immer.createDraft.bind($3fcdd01f4bd90a60$var$immer);
var $3fcdd01f4bd90a60$export$c60f5e69c521b528 = $3fcdd01f4bd90a60$var$immer.finishDraft.bind($3fcdd01f4bd90a60$var$immer);
function $3fcdd01f4bd90a60$export$c05b21e3257751e5(value) {
    return value;
}
function $3fcdd01f4bd90a60$export$20f911b3f8cf0b74(value) {
    return value;
}


var $9ed9907f1a4dda7a$var$__defProp = Object.defineProperty;
var $9ed9907f1a4dda7a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $9ed9907f1a4dda7a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $9ed9907f1a4dda7a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $9ed9907f1a4dda7a$var$__defNormalProp = (obj, key, value)=>key in obj ? $9ed9907f1a4dda7a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $9ed9907f1a4dda7a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($9ed9907f1a4dda7a$var$__hasOwnProp.call(b, prop)) $9ed9907f1a4dda7a$var$__defNormalProp(a, prop, b[prop]);
    if ($9ed9907f1a4dda7a$var$__getOwnPropSymbols) {
        for (var prop of $9ed9907f1a4dda7a$var$__getOwnPropSymbols(b))if ($9ed9907f1a4dda7a$var$__propIsEnum.call(b, prop)) $9ed9907f1a4dda7a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $9ed9907f1a4dda7a$var$__publicField = (obj, key, value)=>{
    $9ed9907f1a4dda7a$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $9ed9907f1a4dda7a$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $9ed9907f1a4dda7a$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $9ed9907f1a4dda7a$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $9ed9907f1a4dda7a$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($9ed9907f1a4dda7a$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $9ed9907f1a4dda7a$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $9ed9907f1a4dda7a$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $9ed9907f1a4dda7a$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $9ed9907f1a4dda7a$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $9ed9907f1a4dda7a$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $9ed9907f1a4dda7a$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $9ed9907f1a4dda7a$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $9ed9907f1a4dda7a$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $9ed9907f1a4dda7a$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $9ed9907f1a4dda7a$var$__spreadValues($9ed9907f1a4dda7a$var$__spreadValues({}, $9ed9907f1a4dda7a$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $9ed9907f1a4dda7a$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $9ed9907f1a4dda7a$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $9ed9907f1a4dda7a$var$$REVISION = 0;
var $9ed9907f1a4dda7a$var$CURRENT_TRACKER = null;
var $9ed9907f1a4dda7a$var$Cell = class {
    constructor(initialValue, isEqual = $9ed9907f1a4dda7a$var$tripleEq){
        $9ed9907f1a4dda7a$var$__publicField(this, "revision", $9ed9907f1a4dda7a$var$$REVISION);
        $9ed9907f1a4dda7a$var$__publicField(this, "_value");
        $9ed9907f1a4dda7a$var$__publicField(this, "_lastValue");
        $9ed9907f1a4dda7a$var$__publicField(this, "_isEqual", $9ed9907f1a4dda7a$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $9ed9907f1a4dda7a$var$CURRENT_TRACKER == null || $9ed9907f1a4dda7a$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$9ed9907f1a4dda7a$var$$REVISION;
    }
};
function $9ed9907f1a4dda7a$var$tripleEq(a, b) {
    return a === b;
}
var $9ed9907f1a4dda7a$var$TrackingCache = class {
    constructor(fn){
        $9ed9907f1a4dda7a$var$__publicField(this, "_cachedValue");
        $9ed9907f1a4dda7a$var$__publicField(this, "_cachedRevision", -1);
        $9ed9907f1a4dda7a$var$__publicField(this, "_deps", []);
        $9ed9907f1a4dda7a$var$__publicField(this, "hits", 0);
        $9ed9907f1a4dda7a$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $9ed9907f1a4dda7a$var$CURRENT_TRACKER;
            $9ed9907f1a4dda7a$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $9ed9907f1a4dda7a$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $9ed9907f1a4dda7a$var$CURRENT_TRACKER == null || $9ed9907f1a4dda7a$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $9ed9907f1a4dda7a$var$getValue(cell) {
    if (!(cell instanceof $9ed9907f1a4dda7a$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $9ed9907f1a4dda7a$var$setValue(storage, value) {
    if (!(storage instanceof $9ed9907f1a4dda7a$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $9ed9907f1a4dda7a$var$createCell(initialValue, isEqual = $9ed9907f1a4dda7a$var$tripleEq) {
    return new $9ed9907f1a4dda7a$var$Cell(initialValue, isEqual);
}
function $9ed9907f1a4dda7a$var$createCache(fn) {
    $9ed9907f1a4dda7a$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $9ed9907f1a4dda7a$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $9ed9907f1a4dda7a$var$neverEq = (a, b)=>false;
function $9ed9907f1a4dda7a$var$createTag() {
    return $9ed9907f1a4dda7a$var$createCell(null, $9ed9907f1a4dda7a$var$neverEq);
}
function $9ed9907f1a4dda7a$var$dirtyTag(tag, value) {
    $9ed9907f1a4dda7a$var$setValue(tag, value);
}
var $9ed9907f1a4dda7a$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $9ed9907f1a4dda7a$var$createTag();
    $9ed9907f1a4dda7a$var$getValue(tag);
};
var $9ed9907f1a4dda7a$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $9ed9907f1a4dda7a$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $9ed9907f1a4dda7a$var$REDUX_PROXY_LABEL = Symbol();
var $9ed9907f1a4dda7a$var$nextId = 0;
var $9ed9907f1a4dda7a$var$proto = Object.getPrototypeOf({});
var $9ed9907f1a4dda7a$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $9ed9907f1a4dda7a$var$__publicField(this, "proxy", new Proxy(this, $9ed9907f1a4dda7a$var$objectProxyHandler));
        $9ed9907f1a4dda7a$var$__publicField(this, "tag", $9ed9907f1a4dda7a$var$createTag());
        $9ed9907f1a4dda7a$var$__publicField(this, "tags", {});
        $9ed9907f1a4dda7a$var$__publicField(this, "children", {});
        $9ed9907f1a4dda7a$var$__publicField(this, "collectionTag", null);
        $9ed9907f1a4dda7a$var$__publicField(this, "id", $9ed9907f1a4dda7a$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $9ed9907f1a4dda7a$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $9ed9907f1a4dda7a$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $9ed9907f1a4dda7a$var$createNode(childValue);
                if (childNode.tag) $9ed9907f1a4dda7a$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $9ed9907f1a4dda7a$var$createTag();
                    tag.value = childValue;
                }
                $9ed9907f1a4dda7a$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $9ed9907f1a4dda7a$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $9ed9907f1a4dda7a$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $9ed9907f1a4dda7a$var$__publicField(this, "proxy", new Proxy([
            this
        ], $9ed9907f1a4dda7a$var$arrayProxyHandler));
        $9ed9907f1a4dda7a$var$__publicField(this, "tag", $9ed9907f1a4dda7a$var$createTag());
        $9ed9907f1a4dda7a$var$__publicField(this, "tags", {});
        $9ed9907f1a4dda7a$var$__publicField(this, "children", {});
        $9ed9907f1a4dda7a$var$__publicField(this, "collectionTag", null);
        $9ed9907f1a4dda7a$var$__publicField(this, "id", $9ed9907f1a4dda7a$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $9ed9907f1a4dda7a$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $9ed9907f1a4dda7a$var$consumeCollection(node);
        return $9ed9907f1a4dda7a$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $9ed9907f1a4dda7a$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $9ed9907f1a4dda7a$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $9ed9907f1a4dda7a$var$objectProxyHandler.has(node, prop);
    }
};
function $9ed9907f1a4dda7a$var$createNode(value) {
    if (Array.isArray(value)) return new $9ed9907f1a4dda7a$var$ArrayTreeNode(value);
    return new $9ed9907f1a4dda7a$var$ObjectTreeNode(value);
}
function $9ed9907f1a4dda7a$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $9ed9907f1a4dda7a$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $9ed9907f1a4dda7a$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $9ed9907f1a4dda7a$var$dirtyCollection(node);
            $9ed9907f1a4dda7a$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $9ed9907f1a4dda7a$var$updateNode(childNode, newChildValue);
        else {
            $9ed9907f1a4dda7a$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $9ed9907f1a4dda7a$var$deleteNode(node) {
    if (node.tag) $9ed9907f1a4dda7a$var$dirtyTag(node.tag, null);
    $9ed9907f1a4dda7a$var$dirtyCollection(node);
    for(const key in node.tags)$9ed9907f1a4dda7a$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$9ed9907f1a4dda7a$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $9ed9907f1a4dda7a$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $9ed9907f1a4dda7a$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $9ed9907f1a4dda7a$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $9ed9907f1a4dda7a$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $9ed9907f1a4dda7a$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $9ed9907f1a4dda7a$export$3f025202a230c6dd = (a, b)=>a === b;
function $9ed9907f1a4dda7a$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $9ed9907f1a4dda7a$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $9ed9907f1a4dda7a$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $9ed9907f1a4dda7a$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $9ed9907f1a4dda7a$var$createSingletonCache(comparator) : $9ed9907f1a4dda7a$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $9ed9907f1a4dda7a$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $9ed9907f1a4dda7a$export$c8f9cf88d9fdee55(func) {
    const node = $9ed9907f1a4dda7a$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $9ed9907f1a4dda7a$var$createCacheKeyComparator($9ed9907f1a4dda7a$export$3f025202a230c6dd);
    const cache = $9ed9907f1a4dda7a$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $9ed9907f1a4dda7a$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $9ed9907f1a4dda7a$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $9ed9907f1a4dda7a$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $9ed9907f1a4dda7a$var$StrongRef;
var $9ed9907f1a4dda7a$var$UNTERMINATED = 0;
var $9ed9907f1a4dda7a$var$TERMINATED = 1;
function $9ed9907f1a4dda7a$var$createCacheNode() {
    return {
        s: $9ed9907f1a4dda7a$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $9ed9907f1a4dda7a$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $9ed9907f1a4dda7a$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $9ed9907f1a4dda7a$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $9ed9907f1a4dda7a$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $9ed9907f1a4dda7a$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $9ed9907f1a4dda7a$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $9ed9907f1a4dda7a$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $9ed9907f1a4dda7a$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $9ed9907f1a4dda7a$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $9ed9907f1a4dda7a$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $9ed9907f1a4dda7a$var$__spreadValues($9ed9907f1a4dda7a$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $9ed9907f1a4dda7a$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $9ed9907f1a4dda7a$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $9ed9907f1a4dda7a$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $9ed9907f1a4dda7a$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $9ed9907f1a4dda7a$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $9ed9907f1a4dda7a$export$595d22ed68ca2841 = /* @__PURE__ */ $9ed9907f1a4dda7a$export$5943f4447f6ef248($9ed9907f1a4dda7a$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $9ed9907f1a4dda7a$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $9ed9907f1a4dda7a$export$595d22ed68ca2841)=>{
    $9ed9907f1a4dda7a$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$9ed9907f1a4dda7a$export$75979cfcd91bf38f
});


// src/index.ts
function $7c2f93b225350c5e$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $7c2f93b225350c5e$export$dd164f5517779f15 = $7c2f93b225350c5e$var$createThunkMiddleware();
var $7c2f93b225350c5e$export$16d06542a1949d9e = $7c2f93b225350c5e$var$createThunkMiddleware;



var $6d3bbb1da5d24806$var$__defProp = Object.defineProperty;
var $6d3bbb1da5d24806$var$__defProps = Object.defineProperties;
var $6d3bbb1da5d24806$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $6d3bbb1da5d24806$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $6d3bbb1da5d24806$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $6d3bbb1da5d24806$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $6d3bbb1da5d24806$var$__defNormalProp = (obj, key, value)=>key in obj ? $6d3bbb1da5d24806$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $6d3bbb1da5d24806$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($6d3bbb1da5d24806$var$__hasOwnProp.call(b, prop)) $6d3bbb1da5d24806$var$__defNormalProp(a, prop, b[prop]);
    if ($6d3bbb1da5d24806$var$__getOwnPropSymbols) {
        for (var prop of $6d3bbb1da5d24806$var$__getOwnPropSymbols(b))if ($6d3bbb1da5d24806$var$__propIsEnum.call(b, prop)) $6d3bbb1da5d24806$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $6d3bbb1da5d24806$var$__spreadProps = (a, b)=>$6d3bbb1da5d24806$var$__defProps(a, $6d3bbb1da5d24806$var$__getOwnPropDescs(b));
var $6d3bbb1da5d24806$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($6d3bbb1da5d24806$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $6d3bbb1da5d24806$var$__getOwnPropSymbols) {
        for (var prop of $6d3bbb1da5d24806$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $6d3bbb1da5d24806$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $6d3bbb1da5d24806$var$__publicField = (obj, key, value)=>{
    $6d3bbb1da5d24806$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
var $6d3bbb1da5d24806$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $9ed9907f1a4dda7a$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $3fcdd01f4bd90a60$export$541ac630993a4c84)(value) ? (0, $3fcdd01f4bd90a60$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $6d3bbb1da5d24806$export$a5d3c27355e35910 = $6d3bbb1da5d24806$export$aab6de9e3dbb1473((0, $9ed9907f1a4dda7a$export$8402dc26d96f6902));
var $6d3bbb1da5d24806$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $876d8277641f3cc3$export$f672e0b6f7222cd7;
    return (0, $876d8277641f3cc3$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $6d3bbb1da5d24806$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $6d3bbb1da5d24806$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $6d3bbb1da5d24806$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(0));
            return $6d3bbb1da5d24806$var$__spreadValues($6d3bbb1da5d24806$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $876d8277641f3cc3$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $6d3bbb1da5d24806$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $6d3bbb1da5d24806$var$hasMatchFunction(action);
}
function $6d3bbb1da5d24806$export$ebd532f9034651f3(action) {
    return (0, $876d8277641f3cc3$export$b956e38827fca970)(action) && Object.keys(action).every($6d3bbb1da5d24806$var$isValidKey);
}
function $6d3bbb1da5d24806$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $6d3bbb1da5d24806$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $6d3bbb1da5d24806$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $6d3bbb1da5d24806$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
function $6d3bbb1da5d24806$var$find(iterable, comparator) {
    for (const entry of iterable){
        if (comparator(entry)) return entry;
    }
    return void 0;
}
var $6d3bbb1da5d24806$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $6d3bbb1da5d24806$var$freezeDraftable(val) {
    return (0, $3fcdd01f4bd90a60$export$16e3aed3edb85946)(val) ? (0, $3fcdd01f4bd90a60$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $6d3bbb1da5d24806$var$emplace(map, key, handler) {
    if (map.has(key)) {
        let value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(10));
    const inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $6d3bbb1da5d24806$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $6d3bbb1da5d24806$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $6d3bbb1da5d24806$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $6d3bbb1da5d24806$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $6d3bbb1da5d24806$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $6d3bbb1da5d24806$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $6d3bbb1da5d24806$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $6d3bbb1da5d24806$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $6d3bbb1da5d24806$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $6d3bbb1da5d24806$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $876d8277641f3cc3$export$53b83ca8eaab0383)(val);
}
function $6d3bbb1da5d24806$export$ada5dca0b571bc7(value, path = "", isSerializable = $6d3bbb1da5d24806$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $6d3bbb1da5d24806$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $6d3bbb1da5d24806$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $6d3bbb1da5d24806$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$6d3bbb1da5d24806$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $6d3bbb1da5d24806$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $6d3bbb1da5d24806$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $6d3bbb1da5d24806$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $6d3bbb1da5d24806$export$1908877435b1d5e9();
        if (thunk) {
            if ($6d3bbb1da5d24806$var$isBoolean(thunk)) middlewareArray.push((0, $7c2f93b225350c5e$export$dd164f5517779f15));
            else middlewareArray.push((0, $7c2f93b225350c5e$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $6d3bbb1da5d24806$export$8fb31c0f05df007b = "RTK_autoBatch";
var $6d3bbb1da5d24806$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$6d3bbb1da5d24806$export$8fb31c0f05df007b]: true
            }
        });
var $6d3bbb1da5d24806$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $6d3bbb1da5d24806$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $6d3bbb1da5d24806$var$createQueueWithTimer(10);
var $6d3bbb1da5d24806$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $6d3bbb1da5d24806$var$rAF : options.type === "callback" ? options.queueNotification : $6d3bbb1da5d24806$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$6d3bbb1da5d24806$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $6d3bbb1da5d24806$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $6d3bbb1da5d24806$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($6d3bbb1da5d24806$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
var $6d3bbb1da5d24806$var$IS_PRODUCTION = true;
function $6d3bbb1da5d24806$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $6d3bbb1da5d24806$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $876d8277641f3cc3$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $876d8277641f3cc3$export$66e4520cdb265d18)(reducer);
    else throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(1));
    if (!$6d3bbb1da5d24806$var$IS_PRODUCTION && middleware && typeof middleware !== "function") throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(2));
    let finalMiddleware;
    if (typeof middleware === "function") {
        finalMiddleware = middleware(getDefaultMiddleware);
        if (!$6d3bbb1da5d24806$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(3));
    } else finalMiddleware = getDefaultMiddleware();
    if (!$6d3bbb1da5d24806$var$IS_PRODUCTION && finalMiddleware.some((item)=>typeof item !== "function")) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(4));
    let finalCompose = (0, $876d8277641f3cc3$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $6d3bbb1da5d24806$var$composeWithDevTools($6d3bbb1da5d24806$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: !$6d3bbb1da5d24806$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $876d8277641f3cc3$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $6d3bbb1da5d24806$var$buildGetDefaultEnhancers(middlewareEnhancer);
    if (!$6d3bbb1da5d24806$var$IS_PRODUCTION && enhancers && typeof enhancers !== "function") throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(5));
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    if (!$6d3bbb1da5d24806$var$IS_PRODUCTION && !Array.isArray(storeEnhancers)) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(6));
    if (!$6d3bbb1da5d24806$var$IS_PRODUCTION && storeEnhancers.some((item)=>typeof item !== "function")) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(7));
    if (!$6d3bbb1da5d24806$var$IS_PRODUCTION && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $876d8277641f3cc3$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $6d3bbb1da5d24806$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $6d3bbb1da5d24806$var$isStateFunction(x) {
    return typeof x === "function";
}
function $6d3bbb1da5d24806$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $6d3bbb1da5d24806$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($6d3bbb1da5d24806$var$isStateFunction(initialState)) getInitialState = ()=>$6d3bbb1da5d24806$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $6d3bbb1da5d24806$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $3fcdd01f4bd90a60$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $3fcdd01f4bd90a60$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(9));
                    }
                    return result;
                } else return (0, $3fcdd01f4bd90a60$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/nanoid.ts
var $6d3bbb1da5d24806$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $6d3bbb1da5d24806$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $6d3bbb1da5d24806$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/matchers.ts
var $6d3bbb1da5d24806$var$matches = (matcher, action)=>{
    if ($6d3bbb1da5d24806$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $6d3bbb1da5d24806$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$6d3bbb1da5d24806$var$matches(matcher, action));
    };
}
function $6d3bbb1da5d24806$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$6d3bbb1da5d24806$var$matches(matcher, action));
    };
}
function $6d3bbb1da5d24806$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $6d3bbb1da5d24806$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $6d3bbb1da5d24806$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$6d3bbb1da5d24806$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$6d3bbb1da5d24806$var$isAsyncThunkArray(asyncThunks)) return $6d3bbb1da5d24806$export$872dec21e9a69476()(asyncThunks[0]);
    return $6d3bbb1da5d24806$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $6d3bbb1da5d24806$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$6d3bbb1da5d24806$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$6d3bbb1da5d24806$var$isAsyncThunkArray(asyncThunks)) return $6d3bbb1da5d24806$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $6d3bbb1da5d24806$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $6d3bbb1da5d24806$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $6d3bbb1da5d24806$export$9dd1fb32974da385($6d3bbb1da5d24806$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$6d3bbb1da5d24806$var$isAsyncThunkArray(asyncThunks)) return $6d3bbb1da5d24806$export$fcc3388fb56de601()(asyncThunks[0]);
    return $6d3bbb1da5d24806$export$9dd1fb32974da385($6d3bbb1da5d24806$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $6d3bbb1da5d24806$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$6d3bbb1da5d24806$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$6d3bbb1da5d24806$var$isAsyncThunkArray(asyncThunks)) return $6d3bbb1da5d24806$export$1da80a6ef1307441()(asyncThunks[0]);
    return $6d3bbb1da5d24806$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $6d3bbb1da5d24806$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$6d3bbb1da5d24806$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$6d3bbb1da5d24806$var$isAsyncThunkArray(asyncThunks)) return $6d3bbb1da5d24806$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $6d3bbb1da5d24806$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/createAsyncThunk.ts
var $6d3bbb1da5d24806$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $6d3bbb1da5d24806$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $6d3bbb1da5d24806$var$__publicField(this, "_type");
    }
};
var $6d3bbb1da5d24806$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $6d3bbb1da5d24806$var$__publicField(this, "_type");
    }
};
var $6d3bbb1da5d24806$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $6d3bbb1da5d24806$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $6d3bbb1da5d24806$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $6d3bbb1da5d24806$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $6d3bbb1da5d24806$var$__spreadProps($6d3bbb1da5d24806$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $6d3bbb1da5d24806$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $6d3bbb1da5d24806$var$__spreadProps($6d3bbb1da5d24806$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $6d3bbb1da5d24806$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $6d3bbb1da5d24806$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $6d3bbb1da5d24806$var$__spreadProps($6d3bbb1da5d24806$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $6d3bbb1da5d24806$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($6d3bbb1da5d24806$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $6d3bbb1da5d24806$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $6d3bbb1da5d24806$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $6d3bbb1da5d24806$var$RejectWithValue) throw result;
                                if (result instanceof $6d3bbb1da5d24806$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $6d3bbb1da5d24806$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($6d3bbb1da5d24806$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $6d3bbb1da5d24806$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $6d3bbb1da5d24806$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $6d3bbb1da5d24806$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $6d3bbb1da5d24806$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $6d3bbb1da5d24806$export$343355ed40c51c46 = {
    [$6d3bbb1da5d24806$var$asyncThunkSymbol]: $6d3bbb1da5d24806$export$6abd22dc03e5063f
};
var $6d3bbb1da5d24806$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($6d3bbb1da5d24806$export$23a094319a4b586 || {});
function $6d3bbb1da5d24806$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $6d3bbb1da5d24806$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$6d3bbb1da5d24806$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(11));
        typeof $e665ce22324f295c$exports;
        const reducers = (typeof options.reducers === "function" ? options.reducers($6d3bbb1da5d24806$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $6d3bbb1da5d24806$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($6d3bbb1da5d24806$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $6d3bbb1da5d24806$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $6d3bbb1da5d24806$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $6d3bbb1da5d24806$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $6d3bbb1da5d24806$var$__spreadValues($6d3bbb1da5d24806$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $6d3bbb1da5d24806$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $6d3bbb1da5d24806$var$emplace(injectedSelectorCache, injected, {
                    insert: ()=>/* @__PURE__ */ new WeakMap()
                });
                return $6d3bbb1da5d24806$var$emplace(selectorCache, selectState, {
                    insert: ()=>{
                        var _a2;
                        const map = {};
                        for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $6d3bbb1da5d24806$var$wrapSelector(selector, selectState, getInitialState, injected);
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $6d3bbb1da5d24806$var$__spreadProps($6d3bbb1da5d24806$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $6d3bbb1da5d24806$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $6d3bbb1da5d24806$var$__spreadValues($6d3bbb1da5d24806$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $6d3bbb1da5d24806$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $6d3bbb1da5d24806$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $6d3bbb1da5d24806$export$affdea4146de9cf5();
function $6d3bbb1da5d24806$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $6d3bbb1da5d24806$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $6d3bbb1da5d24806$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$6d3bbb1da5d24806$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $6d3bbb1da5d24806$export$309c7a02b0b0bc62(type, prepareCallback) : $6d3bbb1da5d24806$export$309c7a02b0b0bc62(type));
}
function $6d3bbb1da5d24806$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $6d3bbb1da5d24806$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $6d3bbb1da5d24806$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $6d3bbb1da5d24806$var$noop,
        pending: pending || $6d3bbb1da5d24806$var$noop,
        rejected: rejected || $6d3bbb1da5d24806$var$noop,
        settled: settled || $6d3bbb1da5d24806$var$noop
    });
}
function $6d3bbb1da5d24806$var$noop() {}
// src/entities/entity_state.ts
function $6d3bbb1da5d24806$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $6d3bbb1da5d24806$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($6d3bbb1da5d24806$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $6d3bbb1da5d24806$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $6d3bbb1da5d24806$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $6d3bbb1da5d24806$var$isDraftTyped = (0, $3fcdd01f4bd90a60$export$541ac630993a4c84);
function $6d3bbb1da5d24806$var$createSingleArgumentStateOperator(mutator) {
    const operator = $6d3bbb1da5d24806$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $6d3bbb1da5d24806$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $6d3bbb1da5d24806$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($6d3bbb1da5d24806$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $3fcdd01f4bd90a60$export$b46cabe22e78bc00)(state, runMutator);
    };
}
function $6d3bbb1da5d24806$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $6d3bbb1da5d24806$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $6d3bbb1da5d24806$var$getCurrent(value) {
    return (0, $3fcdd01f4bd90a60$export$541ac630993a4c84)(value) ? (0, $3fcdd01f4bd90a60$export$97aac956da55dae9)(value) : value;
}
function $6d3bbb1da5d24806$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $6d3bbb1da5d24806$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $6d3bbb1da5d24806$var$selectIdValue(entity, selectId);
        if (existingIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $6d3bbb1da5d24806$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $6d3bbb1da5d24806$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $6d3bbb1da5d24806$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $6d3bbb1da5d24806$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $6d3bbb1da5d24806$var$__spreadValues($6d3bbb1da5d24806$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$6d3bbb1da5d24806$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $6d3bbb1da5d24806$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $6d3bbb1da5d24806$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $6d3bbb1da5d24806$var$createStateOperator(addOneMutably),
        addMany: $6d3bbb1da5d24806$var$createStateOperator(addManyMutably),
        setOne: $6d3bbb1da5d24806$var$createStateOperator(setOneMutably),
        setMany: $6d3bbb1da5d24806$var$createStateOperator(setManyMutably),
        setAll: $6d3bbb1da5d24806$var$createStateOperator(setAllMutably),
        updateOne: $6d3bbb1da5d24806$var$createStateOperator(updateOneMutably),
        updateMany: $6d3bbb1da5d24806$var$createStateOperator(updateManyMutably),
        upsertOne: $6d3bbb1da5d24806$var$createStateOperator(upsertOneMutably),
        upsertMany: $6d3bbb1da5d24806$var$createStateOperator(upsertManyMutably),
        removeOne: $6d3bbb1da5d24806$var$createStateOperator(removeOneMutably),
        removeMany: $6d3bbb1da5d24806$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $6d3bbb1da5d24806$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $6d3bbb1da5d24806$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $6d3bbb1da5d24806$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $6d3bbb1da5d24806$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $6d3bbb1da5d24806$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $6d3bbb1da5d24806$var$getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has($6d3bbb1da5d24806$var$selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $6d3bbb1da5d24806$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $6d3bbb1da5d24806$var$getCurrent(state.entities);
        const currentIds = $6d3bbb1da5d24806$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $6d3bbb1da5d24806$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $6d3bbb1da5d24806$var$createStateOperator(addOneMutably),
        updateOne: $6d3bbb1da5d24806$var$createStateOperator(updateOneMutably),
        upsertOne: $6d3bbb1da5d24806$var$createStateOperator(upsertOneMutably),
        setOne: $6d3bbb1da5d24806$var$createStateOperator(setOneMutably),
        setMany: $6d3bbb1da5d24806$var$createStateOperator(setManyMutably),
        setAll: $6d3bbb1da5d24806$var$createStateOperator(setAllMutably),
        addMany: $6d3bbb1da5d24806$var$createStateOperator(addManyMutably),
        updateMany: $6d3bbb1da5d24806$var$createStateOperator(updateManyMutably),
        upsertMany: $6d3bbb1da5d24806$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $6d3bbb1da5d24806$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $6d3bbb1da5d24806$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $6d3bbb1da5d24806$var$createSortedStateAdapter(selectId, sortComparer) : $6d3bbb1da5d24806$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $6d3bbb1da5d24806$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $6d3bbb1da5d24806$var$createSelectorsFactory();
    return $6d3bbb1da5d24806$var$__spreadValues($6d3bbb1da5d24806$var$__spreadValues($6d3bbb1da5d24806$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $6d3bbb1da5d24806$var$task = "task";
var $6d3bbb1da5d24806$var$listener = "listener";
var $6d3bbb1da5d24806$var$completed = "completed";
var $6d3bbb1da5d24806$var$cancelled = "cancelled";
var $6d3bbb1da5d24806$var$taskCancelled = `task-${$6d3bbb1da5d24806$var$cancelled}`;
var $6d3bbb1da5d24806$var$taskCompleted = `task-${$6d3bbb1da5d24806$var$completed}`;
var $6d3bbb1da5d24806$var$listenerCancelled = `${$6d3bbb1da5d24806$var$listener}-${$6d3bbb1da5d24806$var$cancelled}`;
var $6d3bbb1da5d24806$var$listenerCompleted = `${$6d3bbb1da5d24806$var$listener}-${$6d3bbb1da5d24806$var$completed}`;
var $6d3bbb1da5d24806$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $6d3bbb1da5d24806$var$__publicField(this, "name", "TaskAbortError");
        $6d3bbb1da5d24806$var$__publicField(this, "message");
        this.message = `${$6d3bbb1da5d24806$var$task} ${$6d3bbb1da5d24806$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $6d3bbb1da5d24806$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(32));
};
var $6d3bbb1da5d24806$var$noop2 = ()=>{};
var $6d3bbb1da5d24806$var$catchRejection = (promise, onError = $6d3bbb1da5d24806$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $6d3bbb1da5d24806$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $6d3bbb1da5d24806$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $6d3bbb1da5d24806$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $6d3bbb1da5d24806$export$cb1bdac908fed7f(reason);
    }
};
function $6d3bbb1da5d24806$var$raceWithSignal(signal, promise) {
    let cleanup = $6d3bbb1da5d24806$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $6d3bbb1da5d24806$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $6d3bbb1da5d24806$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $6d3bbb1da5d24806$var$noop2;
    });
}
var $6d3bbb1da5d24806$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $6d3bbb1da5d24806$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $6d3bbb1da5d24806$var$createPause = (signal)=>{
    return (promise)=>{
        return $6d3bbb1da5d24806$var$catchRejection($6d3bbb1da5d24806$var$raceWithSignal(signal, promise).then((output)=>{
            $6d3bbb1da5d24806$var$validateActive(signal);
            return output;
        }));
    };
};
var $6d3bbb1da5d24806$var$createDelay = (signal)=>{
    const pause = $6d3bbb1da5d24806$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $6d3bbb1da5d24806$var$assign } = Object;
var $6d3bbb1da5d24806$var$INTERNAL_NIL_TOKEN = {};
var $6d3bbb1da5d24806$var$alm = "listenerMiddleware";
var $6d3bbb1da5d24806$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$6d3bbb1da5d24806$var$addAbortSignalListener(parentAbortSignal, ()=>$6d3bbb1da5d24806$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $6d3bbb1da5d24806$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $6d3bbb1da5d24806$var$runTask(async ()=>{
            $6d3bbb1da5d24806$var$validateActive(parentAbortSignal);
            $6d3bbb1da5d24806$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $6d3bbb1da5d24806$var$createPause(childAbortController.signal),
                delay: $6d3bbb1da5d24806$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $6d3bbb1da5d24806$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$6d3bbb1da5d24806$var$abortControllerWithReason(childAbortController, $6d3bbb1da5d24806$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($6d3bbb1da5d24806$var$noop2));
        return {
            result: $6d3bbb1da5d24806$var$createPause(parentAbortSignal)(result),
            cancel () {
                $6d3bbb1da5d24806$var$abortControllerWithReason(childAbortController, $6d3bbb1da5d24806$var$taskCancelled);
            }
        };
    };
};
var $6d3bbb1da5d24806$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $6d3bbb1da5d24806$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $6d3bbb1da5d24806$var$raceWithSignal(signal, Promise.race(promises));
            $6d3bbb1da5d24806$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$6d3bbb1da5d24806$var$catchRejection(take(predicate, timeout));
};
var $6d3bbb1da5d24806$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $6d3bbb1da5d24806$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(21));
    $6d3bbb1da5d24806$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $6d3bbb1da5d24806$var$createListenerEntry = Object.assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $6d3bbb1da5d24806$var$getListenerEntryPropsFrom(options);
    const id = $6d3bbb1da5d24806$export$ac4959f4f1338dfc();
    const entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$6d3bbb1da5d24806$var$createListenerEntry
});
var $6d3bbb1da5d24806$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $6d3bbb1da5d24806$var$abortControllerWithReason(controller, $6d3bbb1da5d24806$var$listenerCancelled);
    });
};
var $6d3bbb1da5d24806$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($6d3bbb1da5d24806$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $6d3bbb1da5d24806$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $6d3bbb1da5d24806$export$f03a6b845d3fb58b = Object.assign($6d3bbb1da5d24806$export$309c7a02b0b0bc62(`${$6d3bbb1da5d24806$var$alm}/add`), {
    withTypes: ()=>$6d3bbb1da5d24806$export$f03a6b845d3fb58b
});
var $6d3bbb1da5d24806$export$b1b8022855fb2b71 = $6d3bbb1da5d24806$export$309c7a02b0b0bc62(`${$6d3bbb1da5d24806$var$alm}/removeAll`);
var $6d3bbb1da5d24806$export$b03e9483f936dccb = Object.assign($6d3bbb1da5d24806$export$309c7a02b0b0bc62(`${$6d3bbb1da5d24806$var$alm}/remove`), {
    withTypes: ()=>$6d3bbb1da5d24806$export$b03e9483f936dccb
});
var $6d3bbb1da5d24806$var$defaultErrorHandler = (...args)=>{
    console.error(`${$6d3bbb1da5d24806$var$alm}/error`, ...args);
};
var $6d3bbb1da5d24806$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $6d3bbb1da5d24806$var$defaultErrorHandler } = middlewareOptions;
    $6d3bbb1da5d24806$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $6d3bbb1da5d24806$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        let entry = $6d3bbb1da5d24806$var$find(Array.from(listenerMap.values()), (existingEntry)=>existingEntry.effect === options.effect);
        if (!entry) entry = $6d3bbb1da5d24806$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    Object.assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const { type: type, effect: effect, predicate: predicate } = $6d3bbb1da5d24806$var$getListenerEntryPropsFrom(options);
        const entry = $6d3bbb1da5d24806$var$find(Array.from(listenerMap.values()), (entry2)=>{
            const matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $6d3bbb1da5d24806$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    Object.assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $6d3bbb1da5d24806$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $6d3bbb1da5d24806$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $6d3bbb1da5d24806$var$createDelay(internalTaskController.signal),
                pause: $6d3bbb1da5d24806$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $6d3bbb1da5d24806$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $6d3bbb1da5d24806$var$abortControllerWithReason(controller, $6d3bbb1da5d24806$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $6d3bbb1da5d24806$var$abortControllerWithReason(internalTaskController, $6d3bbb1da5d24806$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $6d3bbb1da5d24806$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $6d3bbb1da5d24806$export$cb1bdac908fed7f)) $6d3bbb1da5d24806$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $6d3bbb1da5d24806$var$abortControllerWithReason(internalTaskController, $6d3bbb1da5d24806$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $6d3bbb1da5d24806$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $876d8277641f3cc3$export$b956e38827fca970)(action)) return next(action);
                if ($6d3bbb1da5d24806$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($6d3bbb1da5d24806$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($6d3bbb1da5d24806$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $6d3bbb1da5d24806$var$INTERNAL_NIL_TOKEN) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $6d3bbb1da5d24806$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $6d3bbb1da5d24806$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $6d3bbb1da5d24806$var$createMiddlewareEntry = (middleware)=>({
        id: $6d3bbb1da5d24806$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $6d3bbb1da5d24806$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $6d3bbb1da5d24806$export$4bb1606a79445586 = ()=>{
    const instanceId = $6d3bbb1da5d24806$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($6d3bbb1da5d24806$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            let entry = $6d3bbb1da5d24806$var$find(Array.from(middlewareMap.values()), (entry2)=>entry2.middleware === middleware2);
            if (!entry) entry = $6d3bbb1da5d24806$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$6d3bbb1da5d24806$var$emplace(entry.applied, api, {
                insert: ()=>entry.middleware(api)
            }));
        return (0, $876d8277641f3cc3$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $6d3bbb1da5d24806$export$9dd1fb32974da385(withMiddleware, $6d3bbb1da5d24806$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $6d3bbb1da5d24806$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $6d3bbb1da5d24806$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$6d3bbb1da5d24806$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $6d3bbb1da5d24806$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $6d3bbb1da5d24806$var$isStateProxy = (value)=>!!value && !!value[$6d3bbb1da5d24806$var$ORIGINAL_STATE];
var $6d3bbb1da5d24806$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $6d3bbb1da5d24806$var$createStateProxy = (state, reducerMap)=>$6d3bbb1da5d24806$var$emplace($6d3bbb1da5d24806$var$stateProxyMap, state, {
        insert: ()=>new Proxy(state, {
                get: (target, prop, receiver)=>{
                    if (prop === $6d3bbb1da5d24806$var$ORIGINAL_STATE) return target;
                    const result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        const reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            const reducerResult = reducer(void 0, {
                                type: $6d3bbb1da5d24806$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            })
    });
var $6d3bbb1da5d24806$var$original = (state)=>{
    if (!$6d3bbb1da5d24806$var$isStateProxy(state)) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(25));
    return state[$6d3bbb1da5d24806$var$ORIGINAL_STATE];
};
var $6d3bbb1da5d24806$var$noopReducer = (state = {})=>state;
function $6d3bbb1da5d24806$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($6d3bbb1da5d24806$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $876d8277641f3cc3$export$66e4520cdb265d18)(reducerMap) : $6d3bbb1da5d24806$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $e665ce22324f295c$exports;
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($6d3bbb1da5d24806$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $6d3bbb1da5d24806$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $6d3bbb1da5d24806$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


var $1e55f2c0f29b24b5$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $1e55f2c0f29b24b5$export$2e2bcd8739ae039 = {
    randomUUID: $1e55f2c0f29b24b5$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $3341e1565c8325e2$var$getRandomValues;
var $3341e1565c8325e2$var$rnds8 = new Uint8Array(16);
function $3341e1565c8325e2$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$3341e1565c8325e2$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $3341e1565c8325e2$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$3341e1565c8325e2$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $3341e1565c8325e2$var$getRandomValues($3341e1565c8325e2$var$rnds8);
}


var $4c162cb51f4c2e25$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $b259a66a6ac27fc1$var$validate(uuid) {
    return typeof uuid === "string" && (0, $4c162cb51f4c2e25$export$2e2bcd8739ae039).test(uuid);
}
var $b259a66a6ac27fc1$export$2e2bcd8739ae039 = $b259a66a6ac27fc1$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $9801e9dbece12cf3$var$byteToHex = [];
for(var $9801e9dbece12cf3$var$i = 0; $9801e9dbece12cf3$var$i < 256; ++$9801e9dbece12cf3$var$i)$9801e9dbece12cf3$var$byteToHex.push(($9801e9dbece12cf3$var$i + 0x100).toString(16).slice(1));
function $9801e9dbece12cf3$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return ($9801e9dbece12cf3$var$byteToHex[arr[offset + 0]] + $9801e9dbece12cf3$var$byteToHex[arr[offset + 1]] + $9801e9dbece12cf3$var$byteToHex[arr[offset + 2]] + $9801e9dbece12cf3$var$byteToHex[arr[offset + 3]] + "-" + $9801e9dbece12cf3$var$byteToHex[arr[offset + 4]] + $9801e9dbece12cf3$var$byteToHex[arr[offset + 5]] + "-" + $9801e9dbece12cf3$var$byteToHex[arr[offset + 6]] + $9801e9dbece12cf3$var$byteToHex[arr[offset + 7]] + "-" + $9801e9dbece12cf3$var$byteToHex[arr[offset + 8]] + $9801e9dbece12cf3$var$byteToHex[arr[offset + 9]] + "-" + $9801e9dbece12cf3$var$byteToHex[arr[offset + 10]] + $9801e9dbece12cf3$var$byteToHex[arr[offset + 11]] + $9801e9dbece12cf3$var$byteToHex[arr[offset + 12]] + $9801e9dbece12cf3$var$byteToHex[arr[offset + 13]] + $9801e9dbece12cf3$var$byteToHex[arr[offset + 14]] + $9801e9dbece12cf3$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $9801e9dbece12cf3$var$stringify(arr, offset = 0) {
    var uuid = $9801e9dbece12cf3$export$8fb373d660548968(arr, offset);
    // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $b259a66a6ac27fc1$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $9801e9dbece12cf3$export$2e2bcd8739ae039 = $9801e9dbece12cf3$var$stringify;


function $3e07122f1bd8bfc9$var$v4(options, buf, offset) {
    if ((0, $1e55f2c0f29b24b5$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $1e55f2c0f29b24b5$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, $3341e1565c8325e2$export$2e2bcd8739ae039))();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $9801e9dbece12cf3$export$8fb373d660548968)(rnds);
}
var $3e07122f1bd8bfc9$export$2e2bcd8739ae039 = $3e07122f1bd8bfc9$var$v4;


const $69f4e9eaa71aaec3$var$initialState = {
    blog: {
        title: "",
        description: ""
    },
    editedBlog: {
        title: "",
        description: "",
        image: "",
        contentBlocks: [],
        keywords: ""
    }
};
const $69f4e9eaa71aaec3$var$blogSlice = (0, $6d3bbb1da5d24806$export$4d8d9bd83c24ae8b)({
    name: "blogSlice",
    initialState: {
        blog: {
            title: "",
            description: ""
        },
        editedBlog: {
            title: "",
            description: "",
            image: "",
            contentBlocks: [],
            keywords: ""
        }
    },
    reducers: {
        //blog
        addBlog: (state, action)=>{
            state.blog = action.payload;
            state.editedBlog = action.payload;
        },
        updateTitle: (state, action)=>{
            state.editedBlog.title = action.payload;
        },
        updateDescription: (state, action)=>{
            state.editedBlog.description = action.payload;
        },
        updatePreviewImage: (state, action)=>{
            state.editedBlog.image = action.payload;
        },
        updateKeywords: (state, action)=>{
            state.editedBlog.keywords = action.payload;
        },
        updateContent: (state, action)=>{
            var index = state.editedBlog.contentBlocks.findIndex((x)=>x._id === action.payload._id);
            state.editedBlog.contentBlocks[index].content = action.payload.content;
        },
        updateCaption: (state, action)=>{
            var index = state.editedBlog.contentBlocks.findIndex((x)=>x._id === action.payload._id);
            state.editedBlog.contentBlocks[index].caption = action.payload.caption;
        },
        resetEditedBlog: (state)=>{
            state.editedBlog = $69f4e9eaa71aaec3$var$initialState.editedBlog;
        },
        //block
        addBlock: (state, action)=>{
            action.payload = {
                ...action.payload,
                _id: (0, $3e07122f1bd8bfc9$export$2e2bcd8739ae039)()
            };
            if (state.editedBlog.contentBlocks === undefined) state.editedBlog.contentBlocks = [];
            state.editedBlog.contentBlocks.push(action.payload);
        },
        deleteBlock: (state, action)=>{
            state.editedBlog.contentBlocks = state.editedBlog.contentBlocks.filter((x)=>x._id !== action.payload);
        },
        reorderBlocks: (state, action)=>{
            state.editedBlog.contentBlocks = action.payload;
        }
    }
});
const { addBlog: $69f4e9eaa71aaec3$export$a36094bd725add13, updateTitle: $69f4e9eaa71aaec3$export$bf6f7165e46e2479, updateDescription: $69f4e9eaa71aaec3$export$989a858ef0c8fda5, updateContent: $69f4e9eaa71aaec3$export$5143cc956eb9d8f6, addBlock: $69f4e9eaa71aaec3$export$af077dbfc4682e93, deleteBlock: $69f4e9eaa71aaec3$export$ed8baed65308f4ef, updateCaption: $69f4e9eaa71aaec3$export$624c2ec9f2cded85, updatePreviewImage: $69f4e9eaa71aaec3$export$afbaf9de62621d7b, updateKeywords: $69f4e9eaa71aaec3$export$9c6f66d1d405561d, reorderBlocks: $69f4e9eaa71aaec3$export$3c22e49343768f0d, resetEditedBlog: $69f4e9eaa71aaec3$export$b1e61d1688165092 } = $69f4e9eaa71aaec3$var$blogSlice.actions;
var $69f4e9eaa71aaec3$export$2e2bcd8739ae039 = $69f4e9eaa71aaec3$var$blogSlice.reducer;





const $b3f9c969751deef6$var$DescriptionEditor = ()=>{
    const dispatch = (0, $99aed3ab2dc6c7d9$export$8ad76b76a4c905f8)();
    const editedBlog = (0, $99aed3ab2dc6c7d9$export$2105062e25df4afe)((state)=>state.blog.editedBlog);
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        className: "mb-5",
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("label", {
                className: "block text-gray-700 dark:text-gray-300 text-sm font-bold mb-2",
                children: "Description"
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("textarea", {
                value: editedBlog?.description,
                onChange: (e)=>dispatch((0, $69f4e9eaa71aaec3$export$989a858ef0c8fda5)(e.target.value)),
                className: "border-2 border-gray-300 dark:border-gray-700 p-2 w-full rounded-lg focus:outline-none focus:border-blue-500",
                placeholder: "Enter the description",
                rows: "3"
            })
        ]
    });
};
var $b3f9c969751deef6$export$2e2bcd8739ae039 = $b3f9c969751deef6$var$DescriptionEditor;





const $c54a04eed4aca5e2$var$TitleEditor = ()=>{
    const dispatch = (0, $99aed3ab2dc6c7d9$export$8ad76b76a4c905f8)();
    const editedBlog = (0, $99aed3ab2dc6c7d9$export$2105062e25df4afe)((state)=>state.blog.editedBlog);
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        className: "mb-5",
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("label", {
                className: "block text-gray-700 dark:text-gray-300 text-sm font-bold mb-2",
                children: "Title"
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("input", {
                type: "text",
                value: editedBlog?.title,
                onChange: (e)=>dispatch((0, $69f4e9eaa71aaec3$export$bf6f7165e46e2479)(e.target.value)),
                className: "border-2 border-gray-300 dark:border-gray-700 p-2 w-full rounded-lg focus:outline-none focus:border-blue-500",
                placeholder: "Enter the title"
            })
        ]
    });
};
var $c54a04eed4aca5e2$export$2e2bcd8739ae039 = $c54a04eed4aca5e2$var$TitleEditor;











const $cbce52e433eb7d35$var$EditorOption = ({ blockId: blockId })=>{
    const dispatch = (0, $99aed3ab2dc6c7d9$export$8ad76b76a4c905f8)();
    const handleDeleteClick = ()=>{
        const confirmation = confirm("Are you sure you want to delete this block?");
        if (confirmation) {
            console.log("Deleting block with ID: ", blockId);
            dispatch((0, $69f4e9eaa71aaec3$export$ed8baed65308f4ef)(blockId));
        }
    };
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("i", {
            onClick: handleDeleteClick,
            className: "fas fa-trash-alt text-red-600"
        })
    });
};
var $cbce52e433eb7d35$export$2e2bcd8739ae039 = $cbce52e433eb7d35$var$EditorOption;


const $889a70f304b7970e$var$TextBlock = ({ contentBlock: contentBlock })=>{
    const dispatch = (0, $99aed3ab2dc6c7d9$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        className: "mb-5",
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                className: "flex justify-between items-center mb-3",
                children: [
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("label", {
                        className: "block text-gray-700 dark:text-gray-300 text-sm font-bold",
                        children: "Text Block"
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $cbce52e433eb7d35$export$2e2bcd8739ae039), {
                        blockId: contentBlock._id
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("textarea", {
                className: "border-2 border-gray-300 dark:border-gray-700 p-2 w-full rounded-lg focus:outline-none focus:border-blue-500",
                value: contentBlock?.content,
                onChange: (e)=>{
                    dispatch((0, $69f4e9eaa71aaec3$export$5143cc956eb9d8f6)({
                        content: e.target.value,
                        _id: contentBlock._id
                    }));
                },
                placeholder: "Enter text here",
                rows: "5"
            })
        ]
    });
};
var $889a70f304b7970e$export$2e2bcd8739ae039 = $889a70f304b7970e$var$TextBlock;






const $c0c7719e62524337$var$ImageBlock = ({ contentBlock: contentBlock })=>{
    const dispatch = (0, $99aed3ab2dc6c7d9$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        className: "mb-5",
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                className: "flex justify-between items-center mb-3",
                children: [
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("label", {
                        className: "block text-gray-700 dark:text-gray-300 text-sm font-bold",
                        children: "Image Block"
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $cbce52e433eb7d35$export$2e2bcd8739ae039), {
                        blockId: contentBlock._id
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("label", {
                        className: "block text-gray-700 dark:text-gray-300 text-sm font-bold mb-1",
                        children: "URL"
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("input", {
                        type: "text",
                        placeholder: "https://example.com/image.jpg",
                        value: contentBlock?.content,
                        onChange: (e)=>{
                            dispatch((0, $69f4e9eaa71aaec3$export$5143cc956eb9d8f6)({
                                content: e.target.value,
                                _id: contentBlock._id
                            }));
                        },
                        className: "border-2 border-gray-300 dark:border-gray-700 p-2 w-full rounded-lg focus:outline-none focus:border-blue-500"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("label", {
                        className: "block text-gray-700 dark:text-gray-300 text-sm font-bold mb-1",
                        children: "Caption"
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("input", {
                        type: "text",
                        placeholder: "Image Caption",
                        value: contentBlock?.caption,
                        onChange: (e)=>{
                            dispatch((0, $69f4e9eaa71aaec3$export$624c2ec9f2cded85)({
                                caption: e.target.value,
                                _id: contentBlock._id
                            }));
                        },
                        className: "border-2 border-gray-300 dark:border-gray-700 p-2 w-full rounded-lg focus:outline-none focus:border-blue-500"
                    })
                ]
            })
        ]
    });
};
var $c0c7719e62524337$export$2e2bcd8739ae039 = $c0c7719e62524337$var$ImageBlock;




var $4RFnf = parcelRequire("4RFnf");
function $893608ed902c7a17$export$2e2bcd8739ae039(t, e) {
    return $893608ed902c7a17$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $893608ed902c7a17$export$2e2bcd8739ae039(t, e);
}


function $6690d7c47859749b$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $893608ed902c7a17$export$2e2bcd8739ae039)(t, o);
}


function $c8d7680d3e4d6453$export$2e2bcd8739ae039() {
    return $c8d7680d3e4d6453$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c8d7680d3e4d6453$export$2e2bcd8739ae039.apply(null, arguments);
}


function $b34ae4194c325aef$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b34ae4194c325aef$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b34ae4194c325aef$export$2e2bcd8739ae039(o);
}



function $13a1a6c9b9a2daed$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $b34ae4194c325aef$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $b34ae4194c325aef$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $3525b12b8f7e87f8$export$2e2bcd8739ae039(t) {
    var i = (0, $13a1a6c9b9a2daed$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $b34ae4194c325aef$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $e561b703cf9a31f2$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3525b12b8f7e87f8$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $a78350201d5d1b60$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a78350201d5d1b60$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a78350201d5d1b60$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $e561b703cf9a31f2$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a78350201d5d1b60$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $f8baa4858faeac49$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $f8baa4858faeac49$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $f8baa4858faeac49$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $f8baa4858faeac49$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $f8baa4858faeac49$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $f8baa4858faeac49$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $f8baa4858faeac49$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $f8baa4858faeac49$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $f8baa4858faeac49$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($f8baa4858faeac49$var$isDate(val)) return "date";
    if ($f8baa4858faeac49$var$isError(val)) return "error";
    var constructorName = $f8baa4858faeac49$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $f8baa4858faeac49$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $f8baa4858faeac49$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $f8baa4858faeac49$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $f8baa4858faeac49$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $f8baa4858faeac49$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($f8baa4858faeac49$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($f8baa4858faeac49$var$formatProdErrorMessage(1));
        return enhancer($f8baa4858faeac49$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($f8baa4858faeac49$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($f8baa4858faeac49$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($f8baa4858faeac49$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($f8baa4858faeac49$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($f8baa4858faeac49$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$f8baa4858faeac49$var$isPlainObject(action)) throw new Error($f8baa4858faeac49$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($f8baa4858faeac49$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($f8baa4858faeac49$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($f8baa4858faeac49$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $f8baa4858faeac49$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($f8baa4858faeac49$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$f8baa4858faeac49$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $f8baa4858faeac49$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$f8baa4858faeac49$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $f8baa4858faeac49$export$8928921ea2d3b126 = $f8baa4858faeac49$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $f8baa4858faeac49$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $f8baa4858faeac49$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $f8baa4858faeac49$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$f8baa4858faeac49$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $f8baa4858faeac49$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $f8baa4858faeac49$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $f8baa4858faeac49$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $f8baa4858faeac49$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($f8baa4858faeac49$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $f8baa4858faeac49$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($f8baa4858faeac49$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $f8baa4858faeac49$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $f8baa4858faeac49$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($f8baa4858faeac49$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $f8baa4858faeac49$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $f8baa4858faeac49$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $f8baa4858faeac49$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($f8baa4858faeac49$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $f8baa4858faeac49$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $f8baa4858faeac49$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $f8baa4858faeac49$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($f8baa4858faeac49$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $f8baa4858faeac49$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $a78350201d5d1b60$export$2e2bcd8739ae039)((0, $a78350201d5d1b60$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}



var $4RFnf = parcelRequire("4RFnf");


var $4RFnf = parcelRequire("4RFnf");
var $2eee2c2cab82370e$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createContext(null);
var $2eee2c2cab82370e$export$2e2bcd8739ae039 = $2eee2c2cab82370e$export$cc80c08dc91f1c00;


// Default to a dummy "batch" implementation that just runs the callback
function $37fa9a645e36e985$var$defaultNoopBatch(callback) {
    callback();
}
var $37fa9a645e36e985$var$batch = $37fa9a645e36e985$var$defaultNoopBatch; // Allow injecting another batching function later
var $37fa9a645e36e985$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $37fa9a645e36e985$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $37fa9a645e36e985$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $37fa9a645e36e985$var$batch;
};


// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $88a3843493a3e1a0$var$createListenerCollection() {
    var batch = (0, $37fa9a645e36e985$export$fc47d4c0ba3bd2c6)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $88a3843493a3e1a0$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $88a3843493a3e1a0$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $88a3843493a3e1a0$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $88a3843493a3e1a0$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $88a3843493a3e1a0$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}



var $4RFnf = parcelRequire("4RFnf");
var $873311b549de7d7b$export$700979bc83e7db82 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $4RFnf.useLayoutEffect) : (0, $4RFnf.useEffect);


function $6d47983a1d0d2cfb$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $4RFnf.useMemo)(function() {
        var subscription = (0, $88a3843493a3e1a0$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $4RFnf.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $873311b549de7d7b$export$700979bc83e7db82)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $2eee2c2cab82370e$export$cc80c08dc91f1c00);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $6d47983a1d0d2cfb$export$2e2bcd8739ae039 = $6d47983a1d0d2cfb$var$Provider;



function $21e94090c440b449$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}


var $3775968e7e49670b$exports = {};
"use strict";
var $3241559b3283d9b7$exports = {};
"use strict";

$3241559b3283d9b7$exports = (parcelRequire("lE2Lo"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $3775968e7e49670b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $3775968e7e49670b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $3775968e7e49670b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $3775968e7e49670b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $3775968e7e49670b$var$TYPE_STATICS = {};
$3775968e7e49670b$var$TYPE_STATICS[$3241559b3283d9b7$exports.ForwardRef] = $3775968e7e49670b$var$FORWARD_REF_STATICS;
$3775968e7e49670b$var$TYPE_STATICS[$3241559b3283d9b7$exports.Memo] = $3775968e7e49670b$var$MEMO_STATICS;
function $3775968e7e49670b$var$getStatics(component) {
    // React v16.11 and below
    if ($3241559b3283d9b7$exports.isMemo(component)) return $3775968e7e49670b$var$MEMO_STATICS;
     // React v16.12 and above
    return $3775968e7e49670b$var$TYPE_STATICS[component["$$typeof"]] || $3775968e7e49670b$var$REACT_STATICS;
}
var $3775968e7e49670b$var$defineProperty = Object.defineProperty;
var $3775968e7e49670b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $3775968e7e49670b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3775968e7e49670b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $3775968e7e49670b$var$getPrototypeOf = Object.getPrototypeOf;
var $3775968e7e49670b$var$objectPrototype = Object.prototype;
function $3775968e7e49670b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($3775968e7e49670b$var$objectPrototype) {
            var inheritedComponent = $3775968e7e49670b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $3775968e7e49670b$var$objectPrototype) $3775968e7e49670b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $3775968e7e49670b$var$getOwnPropertyNames(sourceComponent);
        if ($3775968e7e49670b$var$getOwnPropertySymbols) keys = keys.concat($3775968e7e49670b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $3775968e7e49670b$var$getStatics(targetComponent);
        var sourceStatics = $3775968e7e49670b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$3775968e7e49670b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $3775968e7e49670b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $3775968e7e49670b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$3775968e7e49670b$exports = $3775968e7e49670b$var$hoistNonReactStatics;



var $4RFnf = parcelRequire("4RFnf");
var $0419447d5025ca30$exports = {};
"use strict";

$0419447d5025ca30$exports = (parcelRequire("bdAwF"));





var $78e50cf601c3ca4d$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $78e50cf601c3ca4d$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $78e50cf601c3ca4d$var$EMPTY_ARRAY = [];
var $78e50cf601c3ca4d$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $78e50cf601c3ca4d$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $78e50cf601c3ca4d$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $78e50cf601c3ca4d$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $873311b549de7d7b$export$700979bc83e7db82)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $78e50cf601c3ca4d$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $78e50cf601c3ca4d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: "STORE_UPDATED",
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $78e50cf601c3ca4d$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $78e50cf601c3ca4d$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $2eee2c2cab82370e$export$cc80c08dc91f1c00) : _ref2$context, connectOptions = (0, $21e94090c440b449$export$2e2bcd8739ae039)(_ref2, $78e50cf601c3ca4d$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $4RFnf.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $4RFnf.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $21e94090c440b449$export$2e2bcd8739ae039)(props, $78e50cf601c3ca4d$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $4RFnf.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $0419447d5025ca30$exports.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $4RFnf.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $4RFnf.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $4RFnf.useMemo)(function() {
                if (!shouldHandleStateChanges) return $78e50cf601c3ca4d$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $88a3843493a3e1a0$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $4RFnf.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $4RFnf.useReducer)($78e50cf601c3ca4d$var$storeStateUpdatesReducer, $78e50cf601c3ca4d$var$EMPTY_ARRAY, $78e50cf601c3ca4d$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $4RFnf.useRef)();
            var lastWrapperProps = (0, $4RFnf.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $4RFnf.useRef)();
            var renderIsScheduled = (0, $4RFnf.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $78e50cf601c3ca4d$var$useIsomorphicLayoutEffectWithArgs($78e50cf601c3ca4d$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $78e50cf601c3ca4d$var$useIsomorphicLayoutEffectWithArgs($78e50cf601c3ca4d$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $4RFnf.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createElement(WrappedComponent, (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $4RFnf.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createElement(Connect, (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($3775968e7e49670b$exports)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($3775968e7e49670b$exports)))(Connect, WrappedComponent);
    };
}






function $ee440052da96bd00$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $ee440052da96bd00$export$2e2bcd8739ae039(objA, objB) {
    if ($ee440052da96bd00$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$ee440052da96bd00$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $33d65233376b96dc$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $4bcfc660b8cb37bc$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $c31e5bd5be7bc748$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $c0b2969f2c3bcbb1$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $4bcfc660b8cb37bc$export$2e2bcd8739ae039)(value)) (0, $c31e5bd5be7bc748$export$2e2bcd8739ae039)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}


function $7e2ced9335a87c38$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $7e2ced9335a87c38$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $7e2ced9335a87c38$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $7e2ced9335a87c38$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $7e2ced9335a87c38$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $edf547c39ea7003c$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, $7e2ced9335a87c38$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function $edf547c39ea7003c$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $7e2ced9335a87c38$export$710f7c60f68acd3e)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $edf547c39ea7003c$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $7e2ced9335a87c38$export$710f7c60f68acd3e)(function(dispatch) {
        return (0, $33d65233376b96dc$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $edf547c39ea7003c$export$2e2bcd8739ae039 = [
    $edf547c39ea7003c$export$a9f27b4b187c1166,
    $edf547c39ea7003c$export$ba20d1a7aa0c4a90,
    $edf547c39ea7003c$export$94a6e55709d4d961
];



function $611f87d01f84172e$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, $7e2ced9335a87c38$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : undefined;
}
function $611f87d01f84172e$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $7e2ced9335a87c38$export$710f7c60f68acd3e)(function() {
        return {};
    }) : undefined;
}
var $611f87d01f84172e$export$2e2bcd8739ae039 = [
    $611f87d01f84172e$export$23fc470827b14aa,
    $611f87d01f84172e$export$514bc8c1a53c1d66
];




function $8935892388856edf$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $8935892388856edf$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $8935892388856edf$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === "function" ? $8935892388856edf$export$5b105939c84b5234(mergeProps) : undefined;
}
function $8935892388856edf$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $8935892388856edf$export$691c327fc30bc857;
    } : undefined;
}
var $8935892388856edf$export$2e2bcd8739ae039 = [
    $8935892388856edf$export$d61b680184bc3f00,
    $8935892388856edf$export$a13ba70ef50dda6d
];




function $1f246fa0a51b39cf$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $c31e5bd5be7bc748$export$2e2bcd8739ae039)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $1f246fa0a51b39cf$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $1f246fa0a51b39cf$var$verify(mapStateToProps, "mapStateToProps", displayName);
    $1f246fa0a51b39cf$var$verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    $1f246fa0a51b39cf$var$verify(mergeProps, "mergeProps", displayName);
}


var $8ca308ab3fe75ced$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $8ca308ab3fe75ced$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $8ca308ab3fe75ced$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $8ca308ab3fe75ced$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $21e94090c440b449$export$2e2bcd8739ae039)(_ref2, $8ca308ab3fe75ced$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $8ca308ab3fe75ced$export$d20c0c2ca6eb2b6f : $8ca308ab3fe75ced$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


var $21fa3a388fd530f0$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $21fa3a388fd530f0$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $21fa3a388fd530f0$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $21fa3a388fd530f0$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $78e50cf601c3ca4d$export$2e2bcd8739ae039) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $611f87d01f84172e$export$2e2bcd8739ae039) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $edf547c39ea7003c$export$2e2bcd8739ae039) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $8935892388856edf$export$2e2bcd8739ae039) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $8ca308ab3fe75ced$export$2e2bcd8739ae039) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $21fa3a388fd530f0$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $ee440052da96bd00$export$2e2bcd8739ae039) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $ee440052da96bd00$export$2e2bcd8739ae039) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $ee440052da96bd00$export$2e2bcd8739ae039) : _ref3$areMergedPropsE, extraOptions = (0, $21e94090c440b449$export$2e2bcd8739ae039)(_ref3, $21fa3a388fd530f0$var$_excluded);
        var initMapStateToProps = $21fa3a388fd530f0$var$match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = $21fa3a388fd530f0$var$match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = $21fa3a388fd530f0$var$match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $21fa3a388fd530f0$export$2e2bcd8739ae039 = /*#__PURE__*/ $21fa3a388fd530f0$export$9f9feb656dec1fc4();




var $4RFnf = parcelRequire("4RFnf");


var $4RFnf = parcelRequire("4RFnf");

function $30062ab25cefd390$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $4RFnf.useContext)((0, $2eee2c2cab82370e$export$cc80c08dc91f1c00));
    return contextValue;
}


function $bae230a88ed82e06$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $2eee2c2cab82370e$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $2eee2c2cab82370e$export$cc80c08dc91f1c00) ? (0, $30062ab25cefd390$export$c1275ca9a6fd3ec5) : function() {
        return (0, $4RFnf.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $bae230a88ed82e06$export$6ccbb43953eebf8 = /*#__PURE__*/ $bae230a88ed82e06$export$671dba69185d0304();


function $f03bb3dfea1c8d52$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $2eee2c2cab82370e$export$cc80c08dc91f1c00);
    var useStore = context === (0, $2eee2c2cab82370e$export$cc80c08dc91f1c00) ? (0, $bae230a88ed82e06$export$6ccbb43953eebf8) : (0, $bae230a88ed82e06$export$671dba69185d0304)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $f03bb3dfea1c8d52$export$8ad76b76a4c905f8 = /*#__PURE__*/ $f03bb3dfea1c8d52$export$bc9b55530897c558();



var $4RFnf = parcelRequire("4RFnf");




var $45f330a008d2fd9f$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $45f330a008d2fd9f$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $4RFnf.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $4RFnf.useMemo)(function() {
        return (0, $88a3843493a3e1a0$export$d567d2b9af322f8f)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $4RFnf.useRef)();
    var latestSelector = (0, $4RFnf.useRef)();
    var latestStoreState = (0, $4RFnf.useRef)();
    var latestSelectedState = (0, $4RFnf.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $873311b549de7d7b$export$700979bc83e7db82)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $873311b549de7d7b$export$700979bc83e7db82)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $45f330a008d2fd9f$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $2eee2c2cab82370e$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $2eee2c2cab82370e$export$cc80c08dc91f1c00) ? (0, $30062ab25cefd390$export$c1275ca9a6fd3ec5) : function() {
        return (0, $4RFnf.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $45f330a008d2fd9f$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $45f330a008d2fd9f$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $4RFnf.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $45f330a008d2fd9f$export$2105062e25df4afe = /*#__PURE__*/ $45f330a008d2fd9f$export$2b53f90d2bd1cbfb();






/* eslint-disable import/no-unresolved */ 



// with standard React renderers (ReactDOM, React Native)
(0, $37fa9a645e36e985$export$4b9874722d0da7bc)((0, $6ce1434187f7101c$exports.unstable_batchedUpdates));



var $4RFnf = parcelRequire("4RFnf");
function $e4b050ab5f92332c$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $e4b050ab5f92332c$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $4RFnf.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $4RFnf.useRef)(true);
    var committed = (0, $4RFnf.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $e4b050ab5f92332c$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $4RFnf.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $e4b050ab5f92332c$export$33752cf3ee811995(callback, inputs) {
    return $e4b050ab5f92332c$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $e4b050ab5f92332c$export$1538c33de8887b59 = $e4b050ab5f92332c$export$b6feb8998cd9b342;
var $e4b050ab5f92332c$export$35808ee640e87ca7 = $e4b050ab5f92332c$export$33752cf3ee811995;


var $b669501dfbbef118$var$isProduction = true;
var $b669501dfbbef118$var$prefix = "Invariant failed";
function $b669501dfbbef118$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($b669501dfbbef118$var$isProduction) throw new Error($b669501dfbbef118$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($b669501dfbbef118$var$prefix, ": ").concat(provided) : $b669501dfbbef118$var$prefix;
    throw new Error(value);
}


var $23492784bb53e9d7$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $23492784bb53e9d7$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $23492784bb53e9d7$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $23492784bb53e9d7$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $23492784bb53e9d7$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $23492784bb53e9d7$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $23492784bb53e9d7$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $23492784bb53e9d7$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $23492784bb53e9d7$var$noSpacing : _ref2$padding;
    var marginBox = $23492784bb53e9d7$export$4b834cebd9e5cebe($23492784bb53e9d7$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $23492784bb53e9d7$export$4b834cebd9e5cebe($23492784bb53e9d7$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $23492784bb53e9d7$export$4b834cebd9e5cebe($23492784bb53e9d7$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $23492784bb53e9d7$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $23492784bb53e9d7$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== "px") return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $b669501dfbbef118$export$2e2bcd8739ae039)(false);
    return result;
};
var $23492784bb53e9d7$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $23492784bb53e9d7$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $23492784bb53e9d7$var$shift(borderBox, change);
    return $23492784bb53e9d7$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $23492784bb53e9d7$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $23492784bb53e9d7$var$getWindowScroll();
    return $23492784bb53e9d7$export$cc800923e997bb8(original, scroll);
};
var $23492784bb53e9d7$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $23492784bb53e9d7$var$parse(styles.marginTop),
        right: $23492784bb53e9d7$var$parse(styles.marginRight),
        bottom: $23492784bb53e9d7$var$parse(styles.marginBottom),
        left: $23492784bb53e9d7$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $23492784bb53e9d7$var$parse(styles.paddingTop),
        right: $23492784bb53e9d7$var$parse(styles.paddingRight),
        bottom: $23492784bb53e9d7$var$parse(styles.paddingBottom),
        left: $23492784bb53e9d7$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $23492784bb53e9d7$var$parse(styles.borderTopWidth),
        right: $23492784bb53e9d7$var$parse(styles.borderRightWidth),
        bottom: $23492784bb53e9d7$var$parse(styles.borderBottomWidth),
        left: $23492784bb53e9d7$var$parse(styles.borderLeftWidth)
    };
    return $23492784bb53e9d7$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $23492784bb53e9d7$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $23492784bb53e9d7$export$b8dfc5d4e552b8e1(borderBox, styles);
};


var $7ecb05d430698c92$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $7ecb05d430698c92$var$isEqual(first, second) {
    if (first === second) return true;
    if ($7ecb05d430698c92$var$safeIsNaN(first) && $7ecb05d430698c92$var$safeIsNaN(second)) return true;
    return false;
}
function $7ecb05d430698c92$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$7ecb05d430698c92$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $7ecb05d430698c92$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $7ecb05d430698c92$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $7ecb05d430698c92$export$2e2bcd8739ae039 = $7ecb05d430698c92$var$memoizeOne;


var $c4876ac90ad9a21f$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $c4876ac90ad9a21f$export$2e2bcd8739ae039 = $c4876ac90ad9a21f$var$rafSchd;



var $e9d71c4f80416d0e$var$isProduction = true;
var $e9d71c4f80416d0e$var$spacesAndTabs = /[ \t]{2,}/g;
var $e9d71c4f80416d0e$var$lineStartWithSpaces = /^[ \t]*/gm;
var $e9d71c4f80416d0e$var$clean = function clean(value) {
    return value.replace($e9d71c4f80416d0e$var$spacesAndTabs, " ").replace($e9d71c4f80416d0e$var$lineStartWithSpaces, "").trim();
};
var $e9d71c4f80416d0e$var$getDevMessage = function getDevMessage(message) {
    return $e9d71c4f80416d0e$var$clean("\n  %creact-beautiful-dnd\n\n  %c" + $e9d71c4f80416d0e$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};
var $e9d71c4f80416d0e$var$getFormattedMessage = function getFormattedMessage(message) {
    return [
        $e9d71c4f80416d0e$var$getDevMessage(message),
        "color: #00C584; font-size: 1.2em; font-weight: bold;",
        "line-height: 1.5",
        "color: #723874;"
    ];
};
var $e9d71c4f80416d0e$var$isDisabledFlag = "__react-beautiful-dnd-disable-dev-warnings";
function $e9d71c4f80416d0e$var$log(type, message) {
    var _console;
    if ($e9d71c4f80416d0e$var$isProduction) return;
    if (typeof window !== "undefined" && window[$e9d71c4f80416d0e$var$isDisabledFlag]) return;
    (_console = console)[type].apply(_console, $e9d71c4f80416d0e$var$getFormattedMessage(message));
}
var $e9d71c4f80416d0e$var$warning = $e9d71c4f80416d0e$var$log.bind(null, "warn");
var $e9d71c4f80416d0e$var$error = $e9d71c4f80416d0e$var$log.bind(null, "error");
function $e9d71c4f80416d0e$var$noop() {}
function $e9d71c4f80416d0e$var$getOptions(shared, fromBinding) {
    return (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, shared, {}, fromBinding);
}
function $e9d71c4f80416d0e$var$bindEvents(el, bindings, sharedOptions) {
    var unbindings = bindings.map(function(binding) {
        var options = $e9d71c4f80416d0e$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach(function(unbind) {
            unbind();
        });
    };
}
var $e9d71c4f80416d0e$var$isProduction$1 = true;
var $e9d71c4f80416d0e$var$prefix = "Invariant failed";
function $e9d71c4f80416d0e$var$RbdInvariant(message) {
    this.message = message;
}
$e9d71c4f80416d0e$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $e9d71c4f80416d0e$var$invariant(condition, message) {
    if (condition) return;
    if ($e9d71c4f80416d0e$var$isProduction$1) throw new $e9d71c4f80416d0e$var$RbdInvariant($e9d71c4f80416d0e$var$prefix);
    else throw new $e9d71c4f80416d0e$var$RbdInvariant($e9d71c4f80416d0e$var$prefix + ": " + (message || ""));
}
var $e9d71c4f80416d0e$var$ErrorBoundary = function(_React$Component) {
    (0, $6690d7c47859749b$export$2e2bcd8739ae039)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.callbacks = null;
        _this.unbind = $e9d71c4f80416d0e$var$noop;
        _this.onWindowError = function(event) {
            var callbacks = _this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            var err = event.error;
            if (err instanceof $e9d71c4f80416d0e$var$RbdInvariant) event.preventDefault();
        };
        _this.getCallbacks = function() {
            if (!_this.callbacks) throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
            return _this.callbacks;
        };
        _this.setCallbacks = function(callbacks) {
            _this.callbacks = callbacks;
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.unbind = $e9d71c4f80416d0e$var$bindEvents(window, [
            {
                eventName: "error",
                fn: this.onWindowError
            }
        ]);
    };
    _proto.componentDidCatch = function componentDidCatch(err) {
        if (err instanceof $e9d71c4f80416d0e$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unbind();
    };
    _proto.render = function render() {
        return this.props.children(this.setCallbacks);
    };
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).Component);
var $e9d71c4f80416d0e$var$dragHandleUsageInstructions = "\n  Press space bar to start a drag.\n  When dragging you can use the arrow keys to move the item around and escape to cancel.\n  Some screen readers may require you to be in focus mode or to use your pass through key\n";
var $e9d71c4f80416d0e$var$position = function position(index) {
    return index + 1;
};
var $e9d71c4f80416d0e$var$onDragStart = function onDragStart(start) {
    return "\n  You have lifted an item in position " + $e9d71c4f80416d0e$var$position(start.source.index) + "\n";
};
var $e9d71c4f80416d0e$var$withLocation = function withLocation(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = $e9d71c4f80416d0e$var$position(source.index);
    var endPosition = $e9d71c4f80416d0e$var$position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
    return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var $e9d71c4f80416d0e$var$withCombine = function withCombine(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
    return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};
var $e9d71c4f80416d0e$var$onDragUpdate = function onDragUpdate(update) {
    var location = update.destination;
    if (location) return $e9d71c4f80416d0e$var$withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return $e9d71c4f80416d0e$var$withCombine(update.draggableId, update.source, combine);
    return "You are over an area that cannot be dropped on";
};
var $e9d71c4f80416d0e$var$returnedToStart = function returnedToStart(source) {
    return "\n  The item has returned to its starting position\n  of " + $e9d71c4f80416d0e$var$position(source.index) + "\n";
};
var $e9d71c4f80416d0e$var$onDragEnd = function onDragEnd(result) {
    if (result.reason === "CANCEL") return "\n      Movement cancelled.\n      " + $e9d71c4f80416d0e$var$returnedToStart(result.source) + "\n    ";
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      " + $e9d71c4f80416d0e$var$withLocation(result.source, location) + "\n    ";
    if (combine) return "\n      You have dropped the item.\n      " + $e9d71c4f80416d0e$var$withCombine(result.draggableId, result.source, combine) + "\n    ";
    return "\n    The item has been dropped while not over a drop area.\n    " + $e9d71c4f80416d0e$var$returnedToStart(result.source) + "\n  ";
};
var $e9d71c4f80416d0e$var$preset = {
    dragHandleUsageInstructions: $e9d71c4f80416d0e$var$dragHandleUsageInstructions,
    onDragStart: $e9d71c4f80416d0e$var$onDragStart,
    onDragUpdate: $e9d71c4f80416d0e$var$onDragUpdate,
    onDragEnd: $e9d71c4f80416d0e$var$onDragEnd
};
var $e9d71c4f80416d0e$var$origin = {
    x: 0,
    y: 0
};
var $e9d71c4f80416d0e$var$add = function add(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var $e9d71c4f80416d0e$var$subtract = function subtract(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var $e9d71c4f80416d0e$var$isEqual = function isEqual(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var $e9d71c4f80416d0e$var$negate = function negate(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var $e9d71c4f80416d0e$var$patch = function patch(line, value, otherValue) {
    var _ref;
    if (otherValue === void 0) otherValue = 0;
    return _ref = {}, _ref[line] = value, _ref[line === "x" ? "y" : "x"] = otherValue, _ref;
};
var $e9d71c4f80416d0e$var$distance = function distance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var $e9d71c4f80416d0e$var$closest = function closest(target, points) {
    return Math.min.apply(Math, points.map(function(point) {
        return $e9d71c4f80416d0e$var$distance(target, point);
    }));
};
var $e9d71c4f80416d0e$var$apply = function apply(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var $e9d71c4f80416d0e$var$executeClip = function(frame, subject) {
    var result = (0, $23492784bb53e9d7$export$4b834cebd9e5cebe)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var $e9d71c4f80416d0e$var$offsetByPosition = function offsetByPosition(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var $e9d71c4f80416d0e$var$getCorners = function getCorners(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var $e9d71c4f80416d0e$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $e9d71c4f80416d0e$var$scroll = function scroll(target, frame) {
    if (!frame) return target;
    return $e9d71c4f80416d0e$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
var $e9d71c4f80416d0e$var$increase = function increase(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) {
        var _extends2;
        return (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
    }
    return target;
};
var $e9d71c4f80416d0e$var$clip = function clip(target, frame) {
    if (frame && frame.shouldClipSubject) return $e9d71c4f80416d0e$var$executeClip(frame.pageMarginBox, target);
    return (0, $23492784bb53e9d7$export$4b834cebd9e5cebe)(target);
};
var $e9d71c4f80416d0e$var$getSubject = function(_ref) {
    var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
    var scrolled = $e9d71c4f80416d0e$var$scroll(page.marginBox, frame);
    var increased = $e9d71c4f80416d0e$var$increase(scrolled, axis, withPlaceholder);
    var clipped = $e9d71c4f80416d0e$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $e9d71c4f80416d0e$var$scrollDroppable = function(droppable, newScroll) {
    !droppable.frame && $e9d71c4f80416d0e$var$invariant(false);
    var scrollable = droppable.frame;
    var scrollDiff = $e9d71c4f80416d0e$var$subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = $e9d71c4f80416d0e$var$negate(scrollDiff);
    var frame = (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, scrollable, {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = $e9d71c4f80416d0e$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, droppable, {
        frame: frame,
        subject: subject
    });
    return result;
};
function $e9d71c4f80416d0e$var$isInteger(value) {
    if (Number.isInteger) return Number.isInteger(value);
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
function $e9d71c4f80416d0e$var$values(map) {
    if (Object.values) return Object.values(map);
    return Object.keys(map).map(function(key) {
        return map[key];
    });
}
function $e9d71c4f80416d0e$var$findIndex(list, predicate) {
    if (list.findIndex) return list.findIndex(predicate);
    for(var i = 0; i < list.length; i++){
        if (predicate(list[i])) return i;
    }
    return -1;
}
function $e9d71c4f80416d0e$var$find(list, predicate) {
    if (list.find) return list.find(predicate);
    var index = $e9d71c4f80416d0e$var$findIndex(list, predicate);
    if (index !== -1) return list[index];
    return undefined;
}
function $e9d71c4f80416d0e$var$toArray(list) {
    return Array.prototype.slice.call(list);
}
var $e9d71c4f80416d0e$var$toDroppableMap = (0, $7ecb05d430698c92$export$2e2bcd8739ae039)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $e9d71c4f80416d0e$var$toDraggableMap = (0, $7ecb05d430698c92$export$2e2bcd8739ae039)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $e9d71c4f80416d0e$var$toDroppableList = (0, $7ecb05d430698c92$export$2e2bcd8739ae039)(function(droppables) {
    return $e9d71c4f80416d0e$var$values(droppables);
});
var $e9d71c4f80416d0e$var$toDraggableList = (0, $7ecb05d430698c92$export$2e2bcd8739ae039)(function(draggables) {
    return $e9d71c4f80416d0e$var$values(draggables);
});
var $e9d71c4f80416d0e$var$getDraggablesInsideDroppable = (0, $7ecb05d430698c92$export$2e2bcd8739ae039)(function(droppableId, draggables) {
    var result = $e9d71c4f80416d0e$var$toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
function $e9d71c4f80416d0e$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === "REORDER") return impact.at.destination;
    return null;
}
function $e9d71c4f80416d0e$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === "COMBINE") return impact.at.combine;
    return null;
}
var $e9d71c4f80416d0e$var$removeDraggableFromList = (0, $7ecb05d430698c92$export$2e2bcd8739ae039)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var $e9d71c4f80416d0e$var$moveToNextCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
    if (!destination.isCombineEnabled) return null;
    var location = $e9d71c4f80416d0e$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        var at = {
            type: "COMBINE",
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, previousImpact, {
            at: at
        });
    }
    var all = previousImpact.displaced.all;
    var closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    var withoutDraggable = $e9d71c4f80416d0e$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        var last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    var indexOfClosest = $e9d71c4f80416d0e$var$findIndex(withoutDraggable, function(d) {
        return d.descriptor.id === closestId;
    });
    !(indexOfClosest !== -1) && $e9d71c4f80416d0e$var$invariant(false);
    var proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    var before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $e9d71c4f80416d0e$var$isHomeOf = function(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var $e9d71c4f80416d0e$var$noDisplacedBy = {
    point: $e9d71c4f80416d0e$var$origin,
    value: 0
};
var $e9d71c4f80416d0e$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
var $e9d71c4f80416d0e$var$noImpact = {
    displaced: $e9d71c4f80416d0e$var$emptyGroups,
    displacedBy: $e9d71c4f80416d0e$var$noDisplacedBy,
    at: null
};
var $e9d71c4f80416d0e$var$isWithin = function(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var $e9d71c4f80416d0e$var$isPartiallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $e9d71c4f80416d0e$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $e9d71c4f80416d0e$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $e9d71c4f80416d0e$var$isTotallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $e9d71c4f80416d0e$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $e9d71c4f80416d0e$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var $e9d71c4f80416d0e$var$vertical = {
    direction: "vertical",
    line: "y",
    crossAxisLine: "x",
    start: "top",
    end: "bottom",
    size: "height",
    crossAxisStart: "left",
    crossAxisEnd: "right",
    crossAxisSize: "width"
};
var $e9d71c4f80416d0e$var$horizontal = {
    direction: "horizontal",
    line: "x",
    crossAxisLine: "y",
    start: "left",
    end: "right",
    size: "width",
    crossAxisStart: "top",
    crossAxisEnd: "bottom",
    crossAxisSize: "height"
};
var $e9d71c4f80416d0e$var$isTotallyVisibleThroughFrameOnAxis = function(axis) {
    return function(frame) {
        var isWithinVertical = $e9d71c4f80416d0e$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $e9d71c4f80416d0e$var$isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === $e9d71c4f80416d0e$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var $e9d71c4f80416d0e$var$getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : $e9d71c4f80416d0e$var$origin;
    return $e9d71c4f80416d0e$var$offsetByPosition(target, displacement);
};
var $e9d71c4f80416d0e$var$isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var $e9d71c4f80416d0e$var$isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var $e9d71c4f80416d0e$var$isVisible = function isVisible(_ref) {
    var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? $e9d71c4f80416d0e$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $e9d71c4f80416d0e$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $e9d71c4f80416d0e$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var $e9d71c4f80416d0e$var$isPartiallyVisible = function isPartiallyVisible(args) {
    return $e9d71c4f80416d0e$var$isVisible((0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, args, {
        isVisibleThroughFrameFn: $e9d71c4f80416d0e$var$isPartiallyVisibleThroughFrame
    }));
};
var $e9d71c4f80416d0e$var$isTotallyVisible = function isTotallyVisible(args) {
    return $e9d71c4f80416d0e$var$isVisible((0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, args, {
        isVisibleThroughFrameFn: $e9d71c4f80416d0e$var$isTotallyVisibleThroughFrame
    }));
};
var $e9d71c4f80416d0e$var$isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
    return $e9d71c4f80416d0e$var$isVisible((0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, args, {
        isVisibleThroughFrameFn: $e9d71c4f80416d0e$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var $e9d71c4f80416d0e$var$getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
    if (typeof forceShouldAnimate === "boolean") return forceShouldAnimate;
    if (!last) return true;
    var invisible = last.invisible, visible = last.visible;
    if (invisible[id]) return false;
    var previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $e9d71c4f80416d0e$var$getTarget(draggable, displacedBy) {
    var marginBox = draggable.page.marginBox;
    var expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $23492784bb53e9d7$export$4b834cebd9e5cebe)((0, $23492784bb53e9d7$export$9f77e0932fb78f72)(marginBox, expandBy));
}
function $e9d71c4f80416d0e$var$getDisplacementGroups(_ref) {
    var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
    return afterDragging.reduce(function process(groups, draggable) {
        var target = $e9d71c4f80416d0e$var$getTarget(draggable, displacedBy);
        var id = draggable.descriptor.id;
        groups.all.push(id);
        var isVisible = $e9d71c4f80416d0e$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        var shouldAnimate = $e9d71c4f80416d0e$var$getShouldAnimate(id, last, forceShouldAnimate);
        var displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $e9d71c4f80416d0e$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $e9d71c4f80416d0e$var$goAtEnd(_ref) {
    var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
    var newIndex = $e9d71c4f80416d0e$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $e9d71c4f80416d0e$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $e9d71c4f80416d0e$var$calculateReorderImpact(_ref2) {
    var draggable = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
    var inHomeList = $e9d71c4f80416d0e$var$isHomeOf(draggable, destination);
    if (index == null) return $e9d71c4f80416d0e$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var match = $e9d71c4f80416d0e$var$find(insideDestination, function(item) {
        return item.descriptor.index === index;
    });
    if (!match) return $e9d71c4f80416d0e$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var withoutDragging = $e9d71c4f80416d0e$var$removeDraggableFromList(draggable, insideDestination);
    var sliceFrom = insideDestination.indexOf(match);
    var impacted = withoutDragging.slice(sliceFrom);
    var displaced = $e9d71c4f80416d0e$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $e9d71c4f80416d0e$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $e9d71c4f80416d0e$var$fromCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine = _ref.combine, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var combineId = combine.draggableId;
    var combineWith = draggables[combineId];
    var combineWithIndex = combineWith.descriptor.index;
    var didCombineWithStartAfterCritical = $e9d71c4f80416d0e$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $e9d71c4f80416d0e$var$fromReorder = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
    if (!insideDestination.length) return null;
    var currentIndex = location.index;
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    var firstIndex = insideDestination[0].descriptor.index;
    var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $e9d71c4f80416d0e$var$moveToNextIndex = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var wasAt = previousImpact.at;
    !wasAt && $e9d71c4f80416d0e$var$invariant(false);
    if (wasAt.type === "REORDER") {
        var _newIndex = $e9d71c4f80416d0e$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (_newIndex == null) return null;
        return $e9d71c4f80416d0e$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: _newIndex
        });
    }
    var newIndex = $e9d71c4f80416d0e$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $e9d71c4f80416d0e$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $e9d71c4f80416d0e$var$getCombinedItemDisplacement = function(_ref) {
    var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
    var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($e9d71c4f80416d0e$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $e9d71c4f80416d0e$var$origin : $e9d71c4f80416d0e$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $e9d71c4f80416d0e$var$origin;
};
var $e9d71c4f80416d0e$var$whenCombining = function(_ref) {
    var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
    var combine = $e9d71c4f80416d0e$var$tryGetCombine(impact);
    !combine && $e9d71c4f80416d0e$var$invariant(false);
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = $e9d71c4f80416d0e$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $e9d71c4f80416d0e$var$add(center, displaceBy);
};
var $e9d71c4f80416d0e$var$distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var $e9d71c4f80416d0e$var$distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var $e9d71c4f80416d0e$var$getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var $e9d71c4f80416d0e$var$goAfter = function goAfter(_ref) {
    var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
    return $e9d71c4f80416d0e$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $e9d71c4f80416d0e$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $e9d71c4f80416d0e$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $e9d71c4f80416d0e$var$goBefore = function goBefore(_ref2) {
    var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
    return $e9d71c4f80416d0e$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $e9d71c4f80416d0e$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $e9d71c4f80416d0e$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $e9d71c4f80416d0e$var$goIntoStart = function goIntoStart(_ref3) {
    var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
    return $e9d71c4f80416d0e$var$patch(axis.line, moveInto.contentBox[axis.start] + $e9d71c4f80416d0e$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $e9d71c4f80416d0e$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var $e9d71c4f80416d0e$var$whenReordering = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, afterCritical = _ref.afterCritical;
    var insideDestination = $e9d71c4f80416d0e$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return $e9d71c4f80416d0e$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = impact.displaced, displacedBy = impact.displacedBy;
    var closestAfter = displaced.all[0];
    if (closestAfter) {
        var closest = draggables[closestAfter];
        if ($e9d71c4f80416d0e$var$didStartAfterCritical(closestAfter, afterCritical)) return $e9d71c4f80416d0e$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, $23492784bb53e9d7$export$cc800923e997bb8)(closest.page, displacedBy.point);
        return $e9d71c4f80416d0e$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($e9d71c4f80416d0e$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        var page = (0, $23492784bb53e9d7$export$cc800923e997bb8)(last.page, $e9d71c4f80416d0e$var$negate(afterCritical.displacedBy.point));
        return $e9d71c4f80416d0e$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $e9d71c4f80416d0e$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $e9d71c4f80416d0e$var$withDroppableDisplacement = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return $e9d71c4f80416d0e$var$add(point, frame.scroll.diff.displacement);
};
var $e9d71c4f80416d0e$var$getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
    var original = draggable.page.borderBox.center;
    var at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === "REORDER") return $e9d71c4f80416d0e$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $e9d71c4f80416d0e$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $e9d71c4f80416d0e$var$getPageBorderBoxCenterFromImpact = function(args) {
    var withoutDisplacement = $e9d71c4f80416d0e$var$getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? $e9d71c4f80416d0e$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $e9d71c4f80416d0e$var$scrollViewport = function(viewport, newScroll) {
    var diff = $e9d71c4f80416d0e$var$subtract(newScroll, viewport.scroll.initial);
    var displacement = $e9d71c4f80416d0e$var$negate(diff);
    var frame = (0, $23492784bb53e9d7$export$4b834cebd9e5cebe)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $e9d71c4f80416d0e$var$getDraggables(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
function $e9d71c4f80416d0e$var$tryGetVisible(id, groups) {
    for(var i = 0; i < groups.length; i++){
        var displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $e9d71c4f80416d0e$var$speculativelyIncrease = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
    var scrolledViewport = $e9d71c4f80416d0e$var$scrollViewport(viewport, $e9d71c4f80416d0e$var$add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? $e9d71c4f80416d0e$var$scrollDroppable(destination, $e9d71c4f80416d0e$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var last = impact.displaced;
    var withViewportScroll = $e9d71c4f80416d0e$var$getDisplacementGroups({
        afterDragging: $e9d71c4f80416d0e$var$getDraggables(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var withDroppableScroll = $e9d71c4f80416d0e$var$getDisplacementGroups({
        afterDragging: $e9d71c4f80416d0e$var$getDraggables(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var invisible = {};
    var visible = {};
    var groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach(function(id) {
        var displacement = $e9d71c4f80416d0e$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    var newImpact = (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, impact, {
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    });
    return newImpact;
};
var $e9d71c4f80416d0e$var$withViewportDisplacement = function(viewport, point) {
    return $e9d71c4f80416d0e$var$add(viewport.scroll.diff.displacement, point);
};
var $e9d71c4f80416d0e$var$getClientFromPageBorderBoxCenter = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
    var withoutPageScrollChange = $e9d71c4f80416d0e$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = $e9d71c4f80416d0e$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $e9d71c4f80416d0e$var$add(draggable.client.borderBox.center, offset);
};
var $e9d71c4f80416d0e$var$isTotallyVisibleInNewLocation = function(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
    var changeNeeded = $e9d71c4f80416d0e$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = $e9d71c4f80416d0e$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $e9d71c4f80416d0e$var$isTotallyVisibleOnAxis(args) : $e9d71c4f80416d0e$var$isTotallyVisible(args);
};
var $e9d71c4f80416d0e$var$moveToNextPlace = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
    if (!destination.isEnabled) return null;
    var insideDestination = $e9d71c4f80416d0e$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = $e9d71c4f80416d0e$var$isHomeOf(draggable, destination);
    var impact = $e9d71c4f80416d0e$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $e9d71c4f80416d0e$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $e9d71c4f80416d0e$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var isVisibleInNewLocation = $e9d71c4f80416d0e$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = $e9d71c4f80416d0e$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = $e9d71c4f80416d0e$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = $e9d71c4f80416d0e$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var $e9d71c4f80416d0e$var$getKnownActive = function getKnownActive(droppable) {
    var rect = droppable.subject.active;
    !rect && $e9d71c4f80416d0e$var$invariant(false);
    return rect;
};
var $e9d71c4f80416d0e$var$getBestCrossAxisDroppable = function(_ref) {
    var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = $e9d71c4f80416d0e$var$isWithin(active[axis.start], active[axis.end]);
    var candidates = $e9d71c4f80416d0e$var$toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return $e9d71c4f80416d0e$var$isPartiallyVisibleThroughFrame(viewport.frame)($e9d71c4f80416d0e$var$getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = $e9d71c4f80416d0e$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = $e9d71c4f80416d0e$var$getKnownActive(droppable);
        var isBetweenDestinationClipped = $e9d71c4f80416d0e$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = $e9d71c4f80416d0e$var$getKnownActive(a)[axis.crossAxisStart];
        var second = $e9d71c4f80416d0e$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return $e9d71c4f80416d0e$var$getKnownActive(droppable)[axis.crossAxisStart] === $e9d71c4f80416d0e$var$getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = $e9d71c4f80416d0e$var$isWithin($e9d71c4f80416d0e$var$getKnownActive(droppable)[axis.start], $e9d71c4f80416d0e$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return $e9d71c4f80416d0e$var$getKnownActive(a)[axis.start] - $e9d71c4f80416d0e$var$getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = $e9d71c4f80416d0e$var$closest(pageBorderBoxCenter, $e9d71c4f80416d0e$var$getCorners($e9d71c4f80416d0e$var$getKnownActive(a)));
        var second = $e9d71c4f80416d0e$var$closest(pageBorderBoxCenter, $e9d71c4f80416d0e$var$getCorners($e9d71c4f80416d0e$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $e9d71c4f80416d0e$var$getKnownActive(a)[axis.start] - $e9d71c4f80416d0e$var$getKnownActive(b)[axis.start];
    })[0];
};
var $e9d71c4f80416d0e$var$getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
    var original = draggable.page.borderBox.center;
    return $e9d71c4f80416d0e$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $e9d71c4f80416d0e$var$subtract(original, afterCritical.displacedBy.point) : original;
};
var $e9d71c4f80416d0e$var$getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
    var original = draggable.page.borderBox;
    return $e9d71c4f80416d0e$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $e9d71c4f80416d0e$var$offsetByPosition(original, $e9d71c4f80416d0e$var$negate(afterCritical.displacedBy.point)) : original;
};
var $e9d71c4f80416d0e$var$getClosestDraggable = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    var sorted = insideDestination.filter(function(draggable) {
        return $e9d71c4f80416d0e$var$isTotallyVisible({
            target: $e9d71c4f80416d0e$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = $e9d71c4f80416d0e$var$distance(pageBorderBoxCenter, $e9d71c4f80416d0e$var$withDroppableDisplacement(destination, $e9d71c4f80416d0e$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        var distanceToB = $e9d71c4f80416d0e$var$distance(pageBorderBoxCenter, $e9d71c4f80416d0e$var$withDroppableDisplacement(destination, $e9d71c4f80416d0e$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $e9d71c4f80416d0e$var$getDisplacedBy = (0, $7ecb05d430698c92$export$2e2bcd8739ae039)(function getDisplacedBy(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $e9d71c4f80416d0e$var$patch(axis.line, displacement)
    };
});
var $e9d71c4f80416d0e$var$getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    if (droppable.descriptor.mode === "virtual") return $e9d71c4f80416d0e$var$patch(axis.line, placeholderSize[axis.line]);
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = $e9d71c4f80416d0e$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $e9d71c4f80416d0e$var$patch(axis.line, needsToGrowBy);
};
var $e9d71c4f80416d0e$var$withMaxScroll = function withMaxScroll(frame, max) {
    return (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, frame, {
        scroll: (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, frame.scroll, {
            max: max
        })
    });
};
var $e9d71c4f80416d0e$var$addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!$e9d71c4f80416d0e$var$isHomeOf(draggable, droppable) && $e9d71c4f80416d0e$var$invariant(false);
    !!droppable.subject.withPlaceholder && $e9d71c4f80416d0e$var$invariant(false);
    var placeholderSize = $e9d71c4f80416d0e$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = $e9d71c4f80416d0e$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var _subject = $e9d71c4f80416d0e$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, droppable, {
            subject: _subject
        });
    }
    var maxScroll = requiredGrowth ? $e9d71c4f80416d0e$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = $e9d71c4f80416d0e$var$withMaxScroll(frame, maxScroll);
    var subject = $e9d71c4f80416d0e$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $e9d71c4f80416d0e$var$removePlaceholder = function removePlaceholder(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && $e9d71c4f80416d0e$var$invariant(false);
    var frame = droppable.frame;
    if (!frame) {
        var _subject2 = $e9d71c4f80416d0e$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, droppable, {
            subject: _subject2
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $e9d71c4f80416d0e$var$invariant(false);
    var newFrame = $e9d71c4f80416d0e$var$withMaxScroll(frame, oldMaxScroll);
    var subject = $e9d71c4f80416d0e$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $e9d71c4f80416d0e$var$moveToNewDroppable = function(_ref) {
    var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            displaced: $e9d71c4f80416d0e$var$emptyGroups,
            displacedBy: $e9d71c4f80416d0e$var$noDisplacedBy,
            at: {
                type: "REORDER",
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        var proposedPageBorderBoxCenter = $e9d71c4f80416d0e$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var withPlaceholder = $e9d71c4f80416d0e$var$isHomeOf(draggable, destination) ? destination : $e9d71c4f80416d0e$var$addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = $e9d71c4f80416d0e$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var proposedIndex = function() {
        var relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    }();
    var displacedBy = $e9d71c4f80416d0e$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $e9d71c4f80416d0e$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $e9d71c4f80416d0e$var$emptyGroups,
        index: proposedIndex
    });
};
var $e9d71c4f80416d0e$var$moveCrossAxis = function(_ref) {
    var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var destination = $e9d71c4f80416d0e$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = $e9d71c4f80416d0e$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = $e9d71c4f80416d0e$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    var impact = $e9d71c4f80416d0e$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $e9d71c4f80416d0e$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var clientSelection = $e9d71c4f80416d0e$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $e9d71c4f80416d0e$var$whatIsDraggedOver = function(impact) {
    var at = impact.at;
    if (!at) return null;
    if (at.type === "REORDER") return at.destination.droppableId;
    return at.combine.droppableId;
};
var $e9d71c4f80416d0e$var$getDroppableOver = function getDroppableOver(impact, droppables) {
    var id = $e9d71c4f80416d0e$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $e9d71c4f80416d0e$var$moveInDirection = function(_ref) {
    var state = _ref.state, type = _ref.type;
    var isActuallyOver = $e9d71c4f80416d0e$var$getDroppableOver(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === "vertical" && (type === "MOVE_UP" || type === "MOVE_DOWN") || direction === "horizontal" && (type === "MOVE_LEFT" || type === "MOVE_RIGHT");
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === "MOVE_DOWN" || type === "MOVE_RIGHT";
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
    return isMovingOnMainAxis ? $e9d71c4f80416d0e$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $e9d71c4f80416d0e$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $e9d71c4f80416d0e$var$isMovementAllowed(state) {
    return state.phase === "DRAGGING" || state.phase === "COLLECTING";
}
function $e9d71c4f80416d0e$var$isPositionInFrame(frame) {
    var isWithinVertical = $e9d71c4f80416d0e$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $e9d71c4f80416d0e$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $e9d71c4f80416d0e$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $e9d71c4f80416d0e$var$getFurthestAway(_ref) {
    var pageBorderBox = _ref.pageBorderBox, draggable = _ref.draggable, candidates = _ref.candidates;
    var startCenter = draggable.page.borderBox.center;
    var sorted = candidates.map(function(candidate) {
        var axis = candidate.axis;
        var target = $e9d71c4f80416d0e$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $e9d71c4f80416d0e$var$distance(startCenter, target)
        };
    }).sort(function(a, b) {
        return b.distance - a.distance;
    });
    return sorted[0] ? sorted[0].id : null;
}
function $e9d71c4f80416d0e$var$getDroppableOver$1(_ref2) {
    var pageBorderBox = _ref2.pageBorderBox, draggable = _ref2.draggable, droppables = _ref2.droppables;
    var candidates = $e9d71c4f80416d0e$var$toDroppableList(droppables).filter(function(item) {
        if (!item.isEnabled) return false;
        var active = item.subject.active;
        if (!active) return false;
        if (!$e9d71c4f80416d0e$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($e9d71c4f80416d0e$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        var axis = item.axis;
        var childCenter = active.center[axis.crossAxisLine];
        var crossAxisStart = pageBorderBox[axis.crossAxisStart];
        var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        var isContained = $e9d71c4f80416d0e$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        var isStartContained = isContained(crossAxisStart);
        var isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $e9d71c4f80416d0e$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
var $e9d71c4f80416d0e$var$offsetRectByPosition = function offsetRectByPosition(rect, point) {
    return (0, $23492784bb53e9d7$export$4b834cebd9e5cebe)($e9d71c4f80416d0e$var$offsetByPosition(rect, point));
};
var $e9d71c4f80416d0e$var$withDroppableScroll = function(droppable, area) {
    var frame = droppable.frame;
    if (!frame) return area;
    return $e9d71c4f80416d0e$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $e9d71c4f80416d0e$var$getIsDisplaced(_ref) {
    var displaced = _ref.displaced, id = _ref.id;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $e9d71c4f80416d0e$var$atIndex(_ref) {
    var draggable = _ref.draggable, closest = _ref.closest, inHomeList = _ref.inHomeList;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $e9d71c4f80416d0e$var$getReorderImpact = function(_ref2) {
    var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
    var axis = destination.axis;
    var displacedBy = $e9d71c4f80416d0e$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $e9d71c4f80416d0e$var$removeDraggableFromList(draggable, insideDestination);
    var closest = $e9d71c4f80416d0e$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childCenter = child.page.borderBox.center[axis.line];
        var didStartAfterCritical$1 = $e9d71c4f80416d0e$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $e9d71c4f80416d0e$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    });
    var newIndex = $e9d71c4f80416d0e$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $e9d71c4f80416d0e$var$isHomeOf(draggable, destination)
    });
    return $e9d71c4f80416d0e$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
var $e9d71c4f80416d0e$var$combineThresholdDivisor = 4;
var $e9d71c4f80416d0e$var$getCombineImpact = function(_ref) {
    var draggable = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var displacedBy = $e9d71c4f80416d0e$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $e9d71c4f80416d0e$var$removeDraggableFromList(draggable, insideDestination);
    var combineWith = $e9d71c4f80416d0e$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childRect = child.page.borderBox;
        var childSize = childRect[axis.size];
        var threshold = childSize / $e9d71c4f80416d0e$var$combineThresholdDivisor;
        var didStartAfterCritical$1 = $e9d71c4f80416d0e$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $e9d71c4f80416d0e$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    var impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: "COMBINE",
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $e9d71c4f80416d0e$var$getDragImpact = function(_ref) {
    var pageOffset = _ref.pageOffset, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBox = $e9d71c4f80416d0e$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    var destinationId = $e9d71c4f80416d0e$var$getDroppableOver$1({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $e9d71c4f80416d0e$var$noImpact;
    var destination = droppables[destinationId];
    var insideDestination = $e9d71c4f80416d0e$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var pageBorderBoxWithDroppableScroll = $e9d71c4f80416d0e$var$withDroppableScroll(destination, pageBorderBox);
    return $e9d71c4f80416d0e$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $e9d71c4f80416d0e$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $e9d71c4f80416d0e$var$patchDroppableMap = function(droppables, updated) {
    var _extends2;
    return (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var $e9d71c4f80416d0e$var$clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
    var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
    var last = $e9d71c4f80416d0e$var$whatIsDraggedOver(previousImpact);
    var now = $e9d71c4f80416d0e$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = $e9d71c4f80416d0e$var$removePlaceholder(lastDroppable);
    return $e9d71c4f80416d0e$var$patchDroppableMap(droppables, updated);
};
var $e9d71c4f80416d0e$var$recomputePlaceholders = function(_ref2) {
    var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
    var cleaned = $e9d71c4f80416d0e$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = $e9d71c4f80416d0e$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if ($e9d71c4f80416d0e$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = $e9d71c4f80416d0e$var$addPlaceholder(droppable, draggable, draggables);
    return $e9d71c4f80416d0e$var$patchDroppableMap(cleaned, patched);
};
var $e9d71c4f80416d0e$var$update = function(_ref) {
    var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = $e9d71c4f80416d0e$var$subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $e9d71c4f80416d0e$var$add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: $e9d71c4f80416d0e$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $e9d71c4f80416d0e$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $e9d71c4f80416d0e$var$add(client.offset, viewport.scroll.diff.value)
    };
    var current = {
        client: client,
        page: page
    };
    if (state.phase === "COLLECTING") return (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({
        phase: "COLLECTING"
    }, state, {
        dimensions: dimensions,
        viewport: viewport,
        current: current
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || $e9d71c4f80416d0e$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    var withUpdatedPlaceholders = $e9d71c4f80416d0e$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, state, {
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
function $e9d71c4f80416d0e$var$getDraggables$1(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
var $e9d71c4f80416d0e$var$recompute = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
    var last = impact.displaced;
    var afterDragging = $e9d71c4f80416d0e$var$getDraggables$1(last.all, draggables);
    var displaced = $e9d71c4f80416d0e$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, impact, {
        displaced: displaced
    });
};
var $e9d71c4f80416d0e$var$getClientBorderBoxCenter = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBoxCenter = $e9d71c4f80416d0e$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $e9d71c4f80416d0e$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $e9d71c4f80416d0e$var$refreshSnap = function(_ref) {
    var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
    !(state.movementMode === "SNAP") && $e9d71c4f80416d0e$var$invariant(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = $e9d71c4f80416d0e$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $e9d71c4f80416d0e$var$invariant(false);
    var destination = droppables[isOver];
    var impact = $e9d71c4f80416d0e$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    var clientSelection = $e9d71c4f80416d0e$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $e9d71c4f80416d0e$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $e9d71c4f80416d0e$var$getHomeLocation = function(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var $e9d71c4f80416d0e$var$getLiftEffect = function(_ref) {
    var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
    var displacedBy = $e9d71c4f80416d0e$var$getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = $e9d71c4f80416d0e$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $e9d71c4f80416d0e$var$invariant(false);
    var afterDragging = insideHome.slice(rawIndex + 1);
    var effected = afterDragging.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var afterCritical = {
        inVirtualList: home.descriptor.mode === "virtual",
        displacedBy: displacedBy,
        effected: effected
    };
    var displaced = $e9d71c4f80416d0e$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    var impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: $e9d71c4f80416d0e$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $e9d71c4f80416d0e$var$patchDimensionMap = function(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: $e9d71c4f80416d0e$var$patchDroppableMap(dimensions.droppables, updated)
    };
};
var $e9d71c4f80416d0e$var$start = function start(key) {};
var $e9d71c4f80416d0e$var$finish = function finish(key) {};
var $e9d71c4f80416d0e$var$offsetDraggable = function(_ref) {
    var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
    var client = (0, $23492784bb53e9d7$export$cc800923e997bb8)(draggable.client, offset$1);
    var page = (0, $23492784bb53e9d7$export$1d0caec378d7d0ae)(client, initialWindowScroll);
    var moved = (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, draggable, {
        placeholder: (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, draggable.placeholder, {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var $e9d71c4f80416d0e$var$getFrame = function(droppable) {
    var frame = droppable.frame;
    !frame && $e9d71c4f80416d0e$var$invariant(false);
    return frame;
};
var $e9d71c4f80416d0e$var$adjustAdditionsForScrollChanges = function(_ref) {
    var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = $e9d71c4f80416d0e$var$getFrame(modified);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = $e9d71c4f80416d0e$var$add(windowScrollChange, droppableScrollChange);
        var moved = $e9d71c4f80416d0e$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var $e9d71c4f80416d0e$var$publishWhileDraggingInVirtual = function(_ref) {
    var state = _ref.state, published = _ref.published;
    $e9d71c4f80416d0e$var$start();
    var withScrollChange = published.modified.map(function(update) {
        var existing = state.dimensions.droppables[update.droppableId];
        var scrolled = $e9d71c4f80416d0e$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    var droppables = (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, state.dimensions.droppables, {}, $e9d71c4f80416d0e$var$toDroppableMap(withScrollChange));
    var updatedAdditions = $e9d71c4f80416d0e$var$toDraggableMap($e9d71c4f80416d0e$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    var draggables = (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, state.dimensions.draggables, {}, updatedAdditions);
    published.removals.forEach(function(id) {
        delete draggables[id];
    });
    var dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    var wasOverId = $e9d71c4f80416d0e$var$whatIsDraggedOver(state.impact);
    var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var home = dimensions.droppables[state.critical.droppable.id];
    var _getLiftEffect = $e9d71c4f80416d0e$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    var impact = $e9d71c4f80416d0e$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $e9d71c4f80416d0e$var$finish();
    var draggingState = (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({
        phase: "DRAGGING"
    }, state, {
        phase: "DRAGGING",
        impact: impact,
        onLiftImpact: onLiftImpact,
        dimensions: dimensions,
        afterCritical: afterCritical,
        forceShouldAnimate: false
    });
    if (state.phase === "COLLECTING") return draggingState;
    var dropPending = (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({
        phase: "DROP_PENDING"
    }, draggingState, {
        phase: "DROP_PENDING",
        reason: state.reason,
        isWaiting: false
    });
    return dropPending;
};
var $e9d71c4f80416d0e$var$isSnapping = function isSnapping(state) {
    return state.movementMode === "SNAP";
};
var $e9d71c4f80416d0e$var$postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
    var dimensions = $e9d71c4f80416d0e$var$patchDimensionMap(state.dimensions, updated);
    if (!$e9d71c4f80416d0e$var$isSnapping(state) || isEnabledChanging) return $e9d71c4f80416d0e$var$update({
        state: state,
        dimensions: dimensions
    });
    return $e9d71c4f80416d0e$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $e9d71c4f80416d0e$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === "SNAP") return (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({
        phase: "DRAGGING"
    }, state, {
        scrollJumpRequest: null
    });
    return state;
}
var $e9d71c4f80416d0e$var$idle = {
    phase: "IDLE",
    completed: null,
    shouldFlush: false
};
var $e9d71c4f80416d0e$var$reducer = function(state, action) {
    if (state === void 0) state = $e9d71c4f80416d0e$var$idle;
    if (action.type === "FLUSH") return (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, $e9d71c4f80416d0e$var$idle, {
        shouldFlush: true
    });
    if (action.type === "INITIAL_PUBLISH") {
        !(state.phase === "IDLE") && $e9d71c4f80416d0e$var$invariant(false);
        var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $e9d71c4f80416d0e$var$origin
        };
        var initial = {
            client: client,
            page: {
                selection: $e9d71c4f80416d0e$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $e9d71c4f80416d0e$var$add(client.selection, viewport.scroll.initial),
                offset: $e9d71c4f80416d0e$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        var isWindowScrollAllowed = $e9d71c4f80416d0e$var$toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getLiftEffect = $e9d71c4f80416d0e$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var result = {
            phase: "DRAGGING",
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === "COLLECTION_STARTING") {
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && $e9d71c4f80416d0e$var$invariant(false);
        var _result = (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({
            phase: "COLLECTING"
        }, state, {
            phase: "COLLECTING"
        });
        return _result;
    }
    if (action.type === "PUBLISH_WHILE_DRAGGING") {
        !(state.phase === "COLLECTING" || state.phase === "DROP_PENDING") && $e9d71c4f80416d0e$var$invariant(false);
        return $e9d71c4f80416d0e$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === "MOVE") {
        if (state.phase === "DROP_PENDING") return state;
        !$e9d71c4f80416d0e$var$isMovementAllowed(state) && $e9d71c4f80416d0e$var$invariant(false);
        var _clientSelection = action.payload.client;
        if ($e9d71c4f80416d0e$var$isEqual(_clientSelection, state.current.client.selection)) return state;
        return $e9d71c4f80416d0e$var$update({
            state: state,
            clientSelection: _clientSelection,
            impact: $e9d71c4f80416d0e$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === "UPDATE_DROPPABLE_SCROLL") {
        if (state.phase === "DROP_PENDING") return $e9d71c4f80416d0e$var$removeScrollJumpRequest(state);
        if (state.phase === "COLLECTING") return $e9d71c4f80416d0e$var$removeScrollJumpRequest(state);
        !$e9d71c4f80416d0e$var$isMovementAllowed(state) && $e9d71c4f80416d0e$var$invariant(false);
        var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = $e9d71c4f80416d0e$var$scrollDroppable(target, newScroll);
        return $e9d71c4f80416d0e$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !$e9d71c4f80416d0e$var$isMovementAllowed(state) && $e9d71c4f80416d0e$var$invariant(false);
        var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
        var _target = state.dimensions.droppables[_id];
        !_target && $e9d71c4f80416d0e$var$invariant(false);
        !(_target.isEnabled !== isEnabled) && $e9d71c4f80416d0e$var$invariant(false);
        var updated = (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, _target, {
            isEnabled: isEnabled
        });
        return $e9d71c4f80416d0e$var$postDroppableChange(state, updated, true);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !$e9d71c4f80416d0e$var$isMovementAllowed(state) && $e9d71c4f80416d0e$var$invariant(false);
        var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
        var _target2 = state.dimensions.droppables[_id2];
        !_target2 && $e9d71c4f80416d0e$var$invariant(false);
        !(_target2.isCombineEnabled !== isCombineEnabled) && $e9d71c4f80416d0e$var$invariant(false);
        var _updated = (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, _target2, {
            isCombineEnabled: isCombineEnabled
        });
        return $e9d71c4f80416d0e$var$postDroppableChange(state, _updated, true);
    }
    if (action.type === "MOVE_BY_WINDOW_SCROLL") {
        if (state.phase === "DROP_PENDING" || state.phase === "DROP_ANIMATING") return state;
        !$e9d71c4f80416d0e$var$isMovementAllowed(state) && $e9d71c4f80416d0e$var$invariant(false);
        !state.isWindowScrollAllowed && $e9d71c4f80416d0e$var$invariant(false);
        var _newScroll = action.payload.newScroll;
        if ($e9d71c4f80416d0e$var$isEqual(state.viewport.scroll.current, _newScroll)) return $e9d71c4f80416d0e$var$removeScrollJumpRequest(state);
        var _viewport = $e9d71c4f80416d0e$var$scrollViewport(state.viewport, _newScroll);
        if ($e9d71c4f80416d0e$var$isSnapping(state)) return $e9d71c4f80416d0e$var$refreshSnap({
            state: state,
            viewport: _viewport
        });
        return $e9d71c4f80416d0e$var$update({
            state: state,
            viewport: _viewport
        });
    }
    if (action.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
        if (!$e9d71c4f80416d0e$var$isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if ($e9d71c4f80416d0e$var$isEqual(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, state.viewport, {
            scroll: (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, state.viewport.scroll, {
                max: maxScroll
            })
        });
        return (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({
            phase: "DRAGGING"
        }, state, {
            viewport: withMaxScroll
        });
    }
    if (action.type === "MOVE_UP" || action.type === "MOVE_DOWN" || action.type === "MOVE_LEFT" || action.type === "MOVE_RIGHT") {
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && $e9d71c4f80416d0e$var$invariant(false);
        var _result2 = $e9d71c4f80416d0e$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!_result2) return state;
        return $e9d71c4f80416d0e$var$update({
            state: state,
            impact: _result2.impact,
            clientSelection: _result2.clientSelection,
            scrollJumpRequest: _result2.scrollJumpRequest
        });
    }
    if (action.type === "DROP_PENDING") {
        var reason = action.payload.reason;
        !(state.phase === "COLLECTING") && $e9d71c4f80416d0e$var$invariant(false);
        var newState = (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({
            phase: "DROP_PENDING"
        }, state, {
            phase: "DROP_PENDING",
            isWaiting: true,
            reason: reason
        });
        return newState;
    }
    if (action.type === "DROP_ANIMATE") {
        var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
        !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && $e9d71c4f80416d0e$var$invariant(false);
        var _result3 = {
            phase: "DROP_ANIMATING",
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return _result3;
    }
    if (action.type === "DROP_COMPLETE") {
        var _completed = action.payload.completed;
        return {
            phase: "IDLE",
            completed: _completed,
            shouldFlush: false
        };
    }
    return state;
};
var $e9d71c4f80416d0e$var$beforeInitialCapture = function beforeInitialCapture(args) {
    return {
        type: "BEFORE_INITIAL_CAPTURE",
        payload: args
    };
};
var $e9d71c4f80416d0e$var$lift = function lift(args) {
    return {
        type: "LIFT",
        payload: args
    };
};
var $e9d71c4f80416d0e$var$initialPublish = function initialPublish(args) {
    return {
        type: "INITIAL_PUBLISH",
        payload: args
    };
};
var $e9d71c4f80416d0e$var$publishWhileDragging = function publishWhileDragging(args) {
    return {
        type: "PUBLISH_WHILE_DRAGGING",
        payload: args
    };
};
var $e9d71c4f80416d0e$var$collectionStarting = function collectionStarting() {
    return {
        type: "COLLECTION_STARTING",
        payload: null
    };
};
var $e9d71c4f80416d0e$var$updateDroppableScroll = function updateDroppableScroll(args) {
    return {
        type: "UPDATE_DROPPABLE_SCROLL",
        payload: args
    };
};
var $e9d71c4f80416d0e$var$updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
    return {
        type: "UPDATE_DROPPABLE_IS_ENABLED",
        payload: args
    };
};
var $e9d71c4f80416d0e$var$updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
    return {
        type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
        payload: args
    };
};
var $e9d71c4f80416d0e$var$move = function move(args) {
    return {
        type: "MOVE",
        payload: args
    };
};
var $e9d71c4f80416d0e$var$moveByWindowScroll = function moveByWindowScroll(args) {
    return {
        type: "MOVE_BY_WINDOW_SCROLL",
        payload: args
    };
};
var $e9d71c4f80416d0e$var$updateViewportMaxScroll = function updateViewportMaxScroll(args) {
    return {
        type: "UPDATE_VIEWPORT_MAX_SCROLL",
        payload: args
    };
};
var $e9d71c4f80416d0e$var$moveUp = function moveUp() {
    return {
        type: "MOVE_UP",
        payload: null
    };
};
var $e9d71c4f80416d0e$var$moveDown = function moveDown() {
    return {
        type: "MOVE_DOWN",
        payload: null
    };
};
var $e9d71c4f80416d0e$var$moveRight = function moveRight() {
    return {
        type: "MOVE_RIGHT",
        payload: null
    };
};
var $e9d71c4f80416d0e$var$moveLeft = function moveLeft() {
    return {
        type: "MOVE_LEFT",
        payload: null
    };
};
var $e9d71c4f80416d0e$var$flush = function flush() {
    return {
        type: "FLUSH",
        payload: null
    };
};
var $e9d71c4f80416d0e$var$animateDrop = function animateDrop(args) {
    return {
        type: "DROP_ANIMATE",
        payload: args
    };
};
var $e9d71c4f80416d0e$var$completeDrop = function completeDrop(args) {
    return {
        type: "DROP_COMPLETE",
        payload: args
    };
};
var $e9d71c4f80416d0e$var$drop = function drop(args) {
    return {
        type: "DROP",
        payload: args
    };
};
var $e9d71c4f80416d0e$var$dropPending = function dropPending(args) {
    return {
        type: "DROP_PENDING",
        payload: args
    };
};
var $e9d71c4f80416d0e$var$dropAnimationFinished = function dropAnimationFinished() {
    return {
        type: "DROP_ANIMATION_FINISHED",
        payload: null
    };
};
function $e9d71c4f80416d0e$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    var indexes = insideDestination.map(function(d) {
        return d.descriptor.index;
    });
    var errors = {};
    for(var i = 1; i < indexes.length; i++){
        var current = indexes[i];
        var previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!Object.keys(errors).length) return;
    var formatted = indexes.map(function(index) {
        var hasError = Boolean(errors[index]);
        return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
    }).join(", ");
}
function $e9d71c4f80416d0e$var$validateDimensions(critical, dimensions) {
    var insideDestination;
}
var $e9d71c4f80416d0e$var$lift$1 = function(marshal) {
    return function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== "LIFT") {
                    next(action);
                    return;
                }
                var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                var initial = getState();
                if (initial.phase === "DROP_ANIMATING") dispatch($e9d71c4f80416d0e$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === "IDLE") && $e9d71c4f80416d0e$var$invariant(false);
                dispatch($e9d71c4f80416d0e$var$flush());
                dispatch($e9d71c4f80416d0e$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === "SNAP"
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                $e9d71c4f80416d0e$var$validateDimensions(critical, dimensions);
                dispatch($e9d71c4f80416d0e$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var $e9d71c4f80416d0e$var$style = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "INITIAL_PUBLISH") marshal.dragging();
                if (action.type === "DROP_ANIMATE") marshal.dropping(action.payload.completed.result.reason);
                if (action.type === "FLUSH" || action.type === "DROP_COMPLETE") marshal.resting();
                next(action);
            };
        };
    };
};
var $e9d71c4f80416d0e$var$curves = {
    outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
    drop: "cubic-bezier(.2,1,.1,1)"
};
var $e9d71c4f80416d0e$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var $e9d71c4f80416d0e$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var $e9d71c4f80416d0e$var$outOfTheWayTiming = $e9d71c4f80416d0e$var$timings.outOfTheWay + "s " + $e9d71c4f80416d0e$var$curves.outOfTheWay;
var $e9d71c4f80416d0e$var$transitions = {
    fluid: "opacity " + $e9d71c4f80416d0e$var$outOfTheWayTiming,
    snap: "transform " + $e9d71c4f80416d0e$var$outOfTheWayTiming + ", opacity " + $e9d71c4f80416d0e$var$outOfTheWayTiming,
    drop: function drop(duration) {
        var timing = duration + "s " + $e9d71c4f80416d0e$var$curves.drop;
        return "transform " + timing + ", opacity " + timing;
    },
    outOfTheWay: "transform " + $e9d71c4f80416d0e$var$outOfTheWayTiming,
    placeholder: "height " + $e9d71c4f80416d0e$var$outOfTheWayTiming + ", width " + $e9d71c4f80416d0e$var$outOfTheWayTiming + ", margin " + $e9d71c4f80416d0e$var$outOfTheWayTiming
};
var $e9d71c4f80416d0e$var$moveTo = function moveTo(offset) {
    return $e9d71c4f80416d0e$var$isEqual(offset, $e9d71c4f80416d0e$var$origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};
var $e9d71c4f80416d0e$var$transforms = {
    moveTo: $e9d71c4f80416d0e$var$moveTo,
    drop: function drop(offset, isCombining) {
        var translate = $e9d71c4f80416d0e$var$moveTo(offset);
        if (!translate) return null;
        if (!isCombining) return translate;
        return translate + " scale(" + $e9d71c4f80416d0e$var$combine.scale.drop + ")";
    }
};
var $e9d71c4f80416d0e$var$minDropTime = $e9d71c4f80416d0e$var$timings.minDropTime, $e9d71c4f80416d0e$var$maxDropTime = $e9d71c4f80416d0e$var$timings.maxDropTime;
var $e9d71c4f80416d0e$var$dropTimeRange = $e9d71c4f80416d0e$var$maxDropTime - $e9d71c4f80416d0e$var$minDropTime;
var $e9d71c4f80416d0e$var$maxDropTimeAtDistance = 1500;
var $e9d71c4f80416d0e$var$cancelDropModifier = 0.6;
var $e9d71c4f80416d0e$var$getDropDuration = function(_ref) {
    var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
    var distance$1 = $e9d71c4f80416d0e$var$distance(current, destination);
    if (distance$1 <= 0) return $e9d71c4f80416d0e$var$minDropTime;
    if (distance$1 >= $e9d71c4f80416d0e$var$maxDropTimeAtDistance) return $e9d71c4f80416d0e$var$maxDropTime;
    var percentage = distance$1 / $e9d71c4f80416d0e$var$maxDropTimeAtDistance;
    var duration = $e9d71c4f80416d0e$var$minDropTime + $e9d71c4f80416d0e$var$dropTimeRange * percentage;
    var withDuration = reason === "CANCEL" ? duration * $e9d71c4f80416d0e$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $e9d71c4f80416d0e$var$getNewHomeClientOffset = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = $e9d71c4f80416d0e$var$whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = $e9d71c4f80416d0e$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = $e9d71c4f80416d0e$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $e9d71c4f80416d0e$var$getDropImpact = function(_ref) {
    var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
    if (!lastImpact.at || reason !== "DROP") {
        var recomputedHomeImpact = $e9d71c4f80416d0e$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === "REORDER") return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    var withoutMovement = (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, lastImpact, {
        displaced: $e9d71c4f80416d0e$var$emptyGroups
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
var $e9d71c4f80416d0e$var$drop$1 = function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== "DROP") {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === "COLLECTING") {
                dispatch($e9d71c4f80416d0e$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === "IDLE") return;
            var isWaitingForDrop = state.phase === "DROP_PENDING" && state.isWaiting;
            !!isWaitingForDrop && $e9d71c4f80416d0e$var$invariant(false);
            !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && $e9d71c4f80416d0e$var$invariant(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var _getDropImpact = $e9d71c4f80416d0e$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var destination = didDropInsideDroppable ? $e9d71c4f80416d0e$var$tryGetDestination(impact) : null;
            var combine = didDropInsideDroppable ? $e9d71c4f80416d0e$var$tryGetCombine(impact) : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = $e9d71c4f80416d0e$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            var completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !$e9d71c4f80416d0e$var$isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($e9d71c4f80416d0e$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            var dropDuration = $e9d71c4f80416d0e$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($e9d71c4f80416d0e$var$animateDrop(args));
        };
    };
};
var $e9d71c4f80416d0e$var$getWindowScroll = function() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
function $e9d71c4f80416d0e$var$getWindowScrollBinding(update) {
    return {
        eventName: "scroll",
        options: {
            passive: true,
            capture: false
        },
        fn: function fn(event) {
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $e9d71c4f80416d0e$var$getScrollListener(_ref) {
    var onWindowScroll = _ref.onWindowScroll;
    function updateScroll() {
        onWindowScroll($e9d71c4f80416d0e$var$getWindowScroll());
    }
    var scheduled = (0, $c4876ac90ad9a21f$export$2e2bcd8739ae039)(updateScroll);
    var binding = $e9d71c4f80416d0e$var$getWindowScrollBinding(scheduled);
    var unbind = $e9d71c4f80416d0e$var$noop;
    function isActive() {
        return unbind !== $e9d71c4f80416d0e$var$noop;
    }
    function start() {
        !!isActive() && $e9d71c4f80416d0e$var$invariant(false);
        unbind = $e9d71c4f80416d0e$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $e9d71c4f80416d0e$var$invariant(false);
        scheduled.cancel();
        unbind();
        unbind = $e9d71c4f80416d0e$var$noop;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
var $e9d71c4f80416d0e$var$shouldEnd = function shouldEnd(action) {
    return action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
};
var $e9d71c4f80416d0e$var$scrollListener = function(store) {
    var listener = $e9d71c4f80416d0e$var$getScrollListener({
        onWindowScroll: function onWindowScroll(newScroll) {
            store.dispatch($e9d71c4f80416d0e$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return function(next) {
        return function(action) {
            if (!listener.isActive() && action.type === "INITIAL_PUBLISH") listener.start();
            if (listener.isActive() && $e9d71c4f80416d0e$var$shouldEnd(action)) listener.stop();
            next(action);
        };
    };
};
var $e9d71c4f80416d0e$var$getExpiringAnnounce = function(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function result(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var $e9d71c4f80416d0e$var$getAsyncMarshal = function() {
    var entries = [];
    var execute = function execute(timerId) {
        var index = $e9d71c4f80416d0e$var$findIndex(entries, function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && $e9d71c4f80416d0e$var$invariant(false);
        var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
        entry.callback();
    };
    var add = function add(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function flush() {
        if (!entries.length) return;
        var shallow = [].concat(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var $e9d71c4f80416d0e$var$areLocationsEqual = function areLocationsEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var $e9d71c4f80416d0e$var$isCombineEqual = function isCombineEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var $e9d71c4f80416d0e$var$isCriticalEqual = function isCriticalEqual(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var $e9d71c4f80416d0e$var$withTimings = function withTimings(key, fn) {
    $e9d71c4f80416d0e$var$start();
    fn();
    $e9d71c4f80416d0e$var$finish();
};
var $e9d71c4f80416d0e$var$getDragStart = function getDragStart(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
var $e9d71c4f80416d0e$var$execute = function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = $e9d71c4f80416d0e$var$getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
};
var $e9d71c4f80416d0e$var$getPublisher = function(getResponders, announce) {
    var asyncMarshal = $e9d71c4f80416d0e$var$getAsyncMarshal();
    var dragging = null;
    var beforeCapture = function beforeCapture(draggableId, mode) {
        !!dragging && $e9d71c4f80416d0e$var$invariant(false);
        $e9d71c4f80416d0e$var$withTimings("onBeforeCapture", function() {
            var fn = getResponders().onBeforeCapture;
            if (fn) {
                var before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    var beforeStart = function beforeStart(critical, mode) {
        !!dragging && $e9d71c4f80416d0e$var$invariant(false);
        $e9d71c4f80416d0e$var$withTimings("onBeforeDragStart", function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn($e9d71c4f80416d0e$var$getDragStart(critical, mode));
        });
    };
    var start = function start(critical, mode) {
        !!dragging && $e9d71c4f80416d0e$var$invariant(false);
        var data = $e9d71c4f80416d0e$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            $e9d71c4f80416d0e$var$withTimings("onDragStart", function() {
                return $e9d71c4f80416d0e$var$execute(getResponders().onDragStart, data, announce, $e9d71c4f80416d0e$var$preset.onDragStart);
            });
        });
    };
    var update = function update(critical, impact) {
        var location = $e9d71c4f80416d0e$var$tryGetDestination(impact);
        var combine = $e9d71c4f80416d0e$var$tryGetCombine(impact);
        !dragging && $e9d71c4f80416d0e$var$invariant(false);
        var hasCriticalChanged = !$e9d71c4f80416d0e$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !$e9d71c4f80416d0e$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !$e9d71c4f80416d0e$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, $e9d71c4f80416d0e$var$getDragStart(critical, dragging.mode), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            $e9d71c4f80416d0e$var$withTimings("onDragUpdate", function() {
                return $e9d71c4f80416d0e$var$execute(getResponders().onDragUpdate, data, announce, $e9d71c4f80416d0e$var$preset.onDragUpdate);
            });
        });
    };
    var flush = function flush() {
        !dragging && $e9d71c4f80416d0e$var$invariant(false);
        asyncMarshal.flush();
    };
    var drop = function drop(result) {
        !dragging && $e9d71c4f80416d0e$var$invariant(false);
        dragging = null;
        $e9d71c4f80416d0e$var$withTimings("onDragEnd", function() {
            return $e9d71c4f80416d0e$var$execute(getResponders().onDragEnd, result, announce, $e9d71c4f80416d0e$var$preset.onDragEnd);
        });
    };
    var abort = function abort() {
        if (!dragging) return;
        var result = (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, $e9d71c4f80416d0e$var$getDragStart(dragging.lastCritical, dragging.mode), {
            combine: null,
            destination: null,
            reason: "CANCEL"
        });
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $e9d71c4f80416d0e$var$responders = function(getResponders, announce) {
    var publisher = $e9d71c4f80416d0e$var$getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === "BEFORE_INITIAL_CAPTURE") {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === "INITIAL_PUBLISH") {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === "DROP_COMPLETE") {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === "FLUSH") {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === "DRAGGING") publisher.update(state.critical, state.impact);
            };
        };
    };
};
var $e9d71c4f80416d0e$var$dropAnimationFinish = function(store) {
    return function(next) {
        return function(action) {
            if (action.type !== "DROP_ANIMATION_FINISHED") {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === "DROP_ANIMATING") && $e9d71c4f80416d0e$var$invariant(false);
            store.dispatch($e9d71c4f80416d0e$var$completeDrop({
                completed: state.completed
            }));
        };
    };
};
var $e9d71c4f80416d0e$var$dropAnimationFlushOnScroll = function(store) {
    var unbind = null;
    var frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return function(next) {
        return function(action) {
            if (action.type === "FLUSH" || action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATION_FINISHED") clear();
            next(action);
            if (action.type !== "DROP_ANIMATE") return;
            var binding = {
                eventName: "scroll",
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    var state = store.getState();
                    if (state.phase === "DROP_ANIMATING") store.dispatch($e9d71c4f80416d0e$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(function() {
                frameId = null;
                unbind = $e9d71c4f80416d0e$var$bindEvents(window, [
                    binding
                ]);
            });
        };
    };
};
var $e9d71c4f80416d0e$var$dimensionMarshalStopper = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "DROP_COMPLETE" || action.type === "FLUSH" || action.type === "DROP_ANIMATE") marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var $e9d71c4f80416d0e$var$focus = function(marshal) {
    var isWatching = false;
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "INITIAL_PUBLISH") {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === "FLUSH") {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === "DROP_COMPLETE") {
                    isWatching = false;
                    var result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
        };
    };
};
var $e9d71c4f80416d0e$var$shouldStop = function shouldStop(action) {
    return action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
};
var $e9d71c4f80416d0e$var$autoScroll = function(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if ($e9d71c4f80416d0e$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === "INITIAL_PUBLISH") {
                    next(action);
                    var state = store.getState();
                    !(state.phase === "DRAGGING") && $e9d71c4f80416d0e$var$invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var $e9d71c4f80416d0e$var$pendingDrop = function(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== "PUBLISH_WHILE_DRAGGING") return;
            var postActionState = store.getState();
            if (postActionState.phase !== "DROP_PENDING") return;
            if (postActionState.isWaiting) return;
            store.dispatch($e9d71c4f80416d0e$var$drop({
                reason: postActionState.reason
            }));
        };
    };
};
var $e9d71c4f80416d0e$var$composeEnhancers = (0, $f8baa4858faeac49$export$f672e0b6f7222cd7);
var $e9d71c4f80416d0e$var$createStore = function(_ref) {
    var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
    return (0, $f8baa4858faeac49$export$f51a9068ac82ea43)($e9d71c4f80416d0e$var$reducer, $e9d71c4f80416d0e$var$composeEnhancers((0, $f8baa4858faeac49$export$9ff26e0402cc7b7)($e9d71c4f80416d0e$var$style(styleMarshal), $e9d71c4f80416d0e$var$dimensionMarshalStopper(dimensionMarshal), $e9d71c4f80416d0e$var$lift$1(dimensionMarshal), $e9d71c4f80416d0e$var$drop$1, $e9d71c4f80416d0e$var$dropAnimationFinish, $e9d71c4f80416d0e$var$dropAnimationFlushOnScroll, $e9d71c4f80416d0e$var$pendingDrop, $e9d71c4f80416d0e$var$autoScroll(autoScroller), $e9d71c4f80416d0e$var$scrollListener, $e9d71c4f80416d0e$var$focus(focusMarshal), $e9d71c4f80416d0e$var$responders(getResponders, announce))));
};
var $e9d71c4f80416d0e$var$clean$1 = function clean() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
function $e9d71c4f80416d0e$var$createPublisher(_ref) {
    var registry = _ref.registry, callbacks = _ref.callbacks;
    var staging = $e9d71c4f80416d0e$var$clean$1();
    var frameId = null;
    var collect = function collect() {
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(function() {
            frameId = null;
            $e9d71c4f80416d0e$var$start();
            var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
            var added = Object.keys(additions).map(function(id) {
                return registry.draggable.getById(id).getDimension($e9d71c4f80416d0e$var$origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = Object.keys(modified).map(function(id) {
                var entry = registry.droppable.getById(id);
                var scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            var result = {
                additions: added,
                removals: Object.keys(removals),
                modified: updated
            };
            staging = $e9d71c4f80416d0e$var$clean$1();
            $e9d71c4f80416d0e$var$finish();
            callbacks.publish(result);
        });
    };
    var add = function add(entry) {
        var id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    var remove = function remove(entry) {
        var descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function stop() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $e9d71c4f80416d0e$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $e9d71c4f80416d0e$var$getMaxScroll = function(_ref) {
    var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
    var maxScroll = $e9d71c4f80416d0e$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $e9d71c4f80416d0e$var$getDocumentElement = function() {
    var doc = document.documentElement;
    !doc && $e9d71c4f80416d0e$var$invariant(false);
    return doc;
};
var $e9d71c4f80416d0e$var$getMaxWindowScroll = function() {
    var doc = $e9d71c4f80416d0e$var$getDocumentElement();
    var maxScroll = $e9d71c4f80416d0e$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $e9d71c4f80416d0e$var$getViewport = function() {
    var scroll = $e9d71c4f80416d0e$var$getWindowScroll();
    var maxScroll = $e9d71c4f80416d0e$var$getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = $e9d71c4f80416d0e$var$getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, $23492784bb53e9d7$export$4b834cebd9e5cebe)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $e9d71c4f80416d0e$var$origin,
                displacement: $e9d71c4f80416d0e$var$origin
            }
        }
    };
    return viewport;
};
var $e9d71c4f80416d0e$var$getInitialPublish = function(_ref) {
    var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry = _ref.registry;
    $e9d71c4f80416d0e$var$start();
    var viewport = $e9d71c4f80416d0e$var$getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: $e9d71c4f80416d0e$var$toDraggableMap(draggables),
        droppables: $e9d71c4f80416d0e$var$toDroppableMap(droppables)
    };
    $e9d71c4f80416d0e$var$finish();
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $e9d71c4f80416d0e$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== "virtual") return false;
    return true;
}
var $e9d71c4f80416d0e$var$createDimensionMarshal = function(registry, callbacks) {
    var collection = null;
    var publisher = $e9d71c4f80416d0e$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
        !registry.droppable.exists(id) && $e9d71c4f80416d0e$var$invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
        if (!collection) return;
        !registry.droppable.exists(id) && $e9d71c4f80416d0e$var$invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
        if (!collection) return;
        !registry.droppable.exists(id) && $e9d71c4f80416d0e$var$invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    var scrollDroppable = function scrollDroppable(id, change) {
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    var stopPublishing = function stopPublishing() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection.unsubscribe();
        collection = null;
    };
    var subscriber = function subscriber(event) {
        !collection && $e9d71c4f80416d0e$var$invariant(false);
        var dragging = collection.critical.draggable;
        if (event.type === "ADDITION") {
            if ($e9d71c4f80416d0e$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === "REMOVAL") {
            if ($e9d71c4f80416d0e$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    var startPublishing = function startPublishing(request) {
        !!collection && $e9d71c4f80416d0e$var$invariant(false);
        var entry = registry.draggable.getById(request.draggableId);
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        var unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $e9d71c4f80416d0e$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $e9d71c4f80416d0e$var$canStartDrag = function(state, id) {
    if (state.phase === "IDLE") return true;
    if (state.phase !== "DROP_ANIMATING") return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === "DROP";
};
var $e9d71c4f80416d0e$var$scrollWindow = function(change) {
    window.scrollBy(change.x, change.y);
};
var $e9d71c4f80416d0e$var$getScrollableDroppables = (0, $7ecb05d430698c92$export$2e2bcd8739ae039)(function(droppables) {
    return $e9d71c4f80416d0e$var$toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var $e9d71c4f80416d0e$var$getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
    var maybe = $e9d71c4f80416d0e$var$find($e9d71c4f80416d0e$var$getScrollableDroppables(droppables), function(droppable) {
        !droppable.frame && $e9d71c4f80416d0e$var$invariant(false);
        return $e9d71c4f80416d0e$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    });
    return maybe;
};
var $e9d71c4f80416d0e$var$getBestScrollableDroppable = function(_ref) {
    var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
    if (destination) {
        var _dimension = droppables[destination];
        if (!_dimension.frame) return null;
        return _dimension;
    }
    var dimension = $e9d71c4f80416d0e$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
var $e9d71c4f80416d0e$var$config = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function ease(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    }
};
var $e9d71c4f80416d0e$var$getDistanceThresholds = function(container, axis) {
    var startScrollingFrom = container[axis.size] * $e9d71c4f80416d0e$var$config.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * $e9d71c4f80416d0e$var$config.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $e9d71c4f80416d0e$var$getPercentage = function(_ref) {
    var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var $e9d71c4f80416d0e$var$minScroll = 1;
var $e9d71c4f80416d0e$var$getValueFromDistance = function(distanceToEdge, thresholds) {
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return $e9d71c4f80416d0e$var$config.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $e9d71c4f80416d0e$var$minScroll;
    var percentageFromMaxScrollValueAt = $e9d71c4f80416d0e$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = $e9d71c4f80416d0e$var$config.maxPixelScroll * $e9d71c4f80416d0e$var$config.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $e9d71c4f80416d0e$var$accelerateAt = $e9d71c4f80416d0e$var$config.durationDampening.accelerateAt;
var $e9d71c4f80416d0e$var$stopAt = $e9d71c4f80416d0e$var$config.durationDampening.stopDampeningAt;
var $e9d71c4f80416d0e$var$dampenValueByTime = function(proposedScroll, dragStartTime) {
    var startOfRange = dragStartTime;
    var endOfRange = $e9d71c4f80416d0e$var$stopAt;
    var now = Date.now();
    var runTime = now - startOfRange;
    if (runTime >= $e9d71c4f80416d0e$var$stopAt) return proposedScroll;
    if (runTime < $e9d71c4f80416d0e$var$accelerateAt) return $e9d71c4f80416d0e$var$minScroll;
    var betweenAccelerateAtAndStopAtPercentage = $e9d71c4f80416d0e$var$getPercentage({
        startOfRange: $e9d71c4f80416d0e$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * $e9d71c4f80416d0e$var$config.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $e9d71c4f80416d0e$var$getValue = function(_ref) {
    var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $e9d71c4f80416d0e$var$getValueFromDistance(distanceToEdge, thresholds);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($e9d71c4f80416d0e$var$dampenValueByTime(scroll, dragStartTime), $e9d71c4f80416d0e$var$minScroll);
};
var $e9d71c4f80416d0e$var$getScrollOnAxis = function(_ref) {
    var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var thresholds = $e9d71c4f80416d0e$var$getDistanceThresholds(container, axis);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $e9d71c4f80416d0e$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * $e9d71c4f80416d0e$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};
var $e9d71c4f80416d0e$var$adjustForSizeLimits = function(_ref) {
    var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var $e9d71c4f80416d0e$var$clean$2 = $e9d71c4f80416d0e$var$apply(function(value) {
    return value === 0 ? 0 : value;
});
var $e9d71c4f80416d0e$var$getScroll = function(_ref) {
    var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = $e9d71c4f80416d0e$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $e9d71c4f80416d0e$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var x = $e9d71c4f80416d0e$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $e9d71c4f80416d0e$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var required = $e9d71c4f80416d0e$var$clean$2({
        x: x,
        y: y
    });
    if ($e9d71c4f80416d0e$var$isEqual(required, $e9d71c4f80416d0e$var$origin)) return null;
    var limited = $e9d71c4f80416d0e$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $e9d71c4f80416d0e$var$isEqual(limited, $e9d71c4f80416d0e$var$origin) ? null : limited;
};
var $e9d71c4f80416d0e$var$smallestSigned = $e9d71c4f80416d0e$var$apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var $e9d71c4f80416d0e$var$getOverlap = function() {
    var getRemainder = function getRemainder(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(_ref) {
        var current = _ref.current, max = _ref.max, change = _ref.change;
        var targetScroll = $e9d71c4f80416d0e$var$add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($e9d71c4f80416d0e$var$isEqual(overlap, $e9d71c4f80416d0e$var$origin)) return null;
        return overlap;
    };
}();
var $e9d71c4f80416d0e$var$canPartiallyScroll = function canPartiallyScroll(_ref2) {
    var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = $e9d71c4f80416d0e$var$smallestSigned(change);
    var overlap = $e9d71c4f80416d0e$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var $e9d71c4f80416d0e$var$canScrollWindow = function canScrollWindow(viewport, change) {
    return $e9d71c4f80416d0e$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var $e9d71c4f80416d0e$var$getWindowOverlap = function getWindowOverlap(viewport, change) {
    if (!$e9d71c4f80416d0e$var$canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return $e9d71c4f80416d0e$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var $e9d71c4f80416d0e$var$canScrollDroppable = function canScrollDroppable(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return $e9d71c4f80416d0e$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $e9d71c4f80416d0e$var$getDroppableOverlap = function getDroppableOverlap(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!$e9d71c4f80416d0e$var$canScrollDroppable(droppable, change)) return null;
    return $e9d71c4f80416d0e$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $e9d71c4f80416d0e$var$getWindowScrollChange = function(_ref) {
    var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $e9d71c4f80416d0e$var$getScroll({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $e9d71c4f80416d0e$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $e9d71c4f80416d0e$var$getDroppableScrollChange = function(_ref) {
    var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = $e9d71c4f80416d0e$var$getScroll({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $e9d71c4f80416d0e$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $e9d71c4f80416d0e$var$scroll$1 = function(_ref) {
    var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var _change = $e9d71c4f80416d0e$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (_change) {
            scrollWindow(_change);
            return;
        }
    }
    var droppable = $e9d71c4f80416d0e$var$getBestScrollableDroppable({
        center: center,
        destination: $e9d71c4f80416d0e$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change = $e9d71c4f80416d0e$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $e9d71c4f80416d0e$var$createFluidScroller = function(_ref) {
    var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var scheduleWindowScroll = (0, $c4876ac90ad9a21f$export$2e2bcd8739ae039)(scrollWindow);
    var scheduleDroppableScroll = (0, $c4876ac90ad9a21f$export$2e2bcd8739ae039)(scrollDroppable);
    var dragging = null;
    var tryScroll = function tryScroll(state) {
        !dragging && $e9d71c4f80416d0e$var$invariant(false);
        var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
        $e9d71c4f80416d0e$var$scroll$1({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var start$1 = function start$1(state) {
        $e9d71c4f80416d0e$var$start();
        !!dragging && $e9d71c4f80416d0e$var$invariant(false);
        var dragStartTime = Date.now();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function fakeScrollCallback() {
            wasScrollNeeded = true;
        };
        $e9d71c4f80416d0e$var$scroll$1({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $e9d71c4f80416d0e$var$finish();
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function stop() {
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $e9d71c4f80416d0e$var$createJumpScroller = function(_ref) {
    var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
    var moveByOffset = function moveByOffset(state, offset) {
        var client = $e9d71c4f80416d0e$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
        if (!$e9d71c4f80416d0e$var$canScrollDroppable(droppable, change)) return change;
        var overlap = $e9d71c4f80416d0e$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = $e9d71c4f80416d0e$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = $e9d71c4f80416d0e$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!$e9d71c4f80416d0e$var$canScrollWindow(viewport, change)) return change;
        var overlap = $e9d71c4f80416d0e$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = $e9d71c4f80416d0e$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = $e9d71c4f80416d0e$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function jumpScroller(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = $e9d71c4f80416d0e$var$whatIsDraggedOver(state.impact);
        !destination && $e9d71c4f80416d0e$var$invariant(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $e9d71c4f80416d0e$var$createAutoScroller = function(_ref) {
    var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
    var fluidScroller = $e9d71c4f80416d0e$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var jumpScroll = $e9d71c4f80416d0e$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function scroll(state) {
        if (state.phase !== "DRAGGING") return;
        if (state.movementMode === "FLUID") {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var $e9d71c4f80416d0e$var$prefix$1 = "data-rbd";
var $e9d71c4f80416d0e$var$dragHandle = function() {
    var base = $e9d71c4f80416d0e$var$prefix$1 + "-drag-handle";
    return {
        base: base,
        draggableId: base + "-draggable-id",
        contextId: base + "-context-id"
    };
}();
var $e9d71c4f80416d0e$var$draggable = function() {
    var base = $e9d71c4f80416d0e$var$prefix$1 + "-draggable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $e9d71c4f80416d0e$var$droppable = function() {
    var base = $e9d71c4f80416d0e$var$prefix$1 + "-droppable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $e9d71c4f80416d0e$var$scrollContainer = {
    contextId: $e9d71c4f80416d0e$var$prefix$1 + "-scroll-container-context-id"
};
var $e9d71c4f80416d0e$var$makeGetSelector = function makeGetSelector(context) {
    return function(attribute) {
        return "[" + attribute + '="' + context + '"]';
    };
};
var $e9d71c4f80416d0e$var$getStyles = function getStyles(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return "";
        return rule.selector + " { " + value + " }";
    }).join(" ");
};
var $e9d71c4f80416d0e$var$noPointerEvents = "pointer-events: none;";
var $e9d71c4f80416d0e$var$getStyles$1 = function(contextId) {
    var getSelector = $e9d71c4f80416d0e$var$makeGetSelector(contextId);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector($e9d71c4f80416d0e$var$dragHandle.contextId),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: $e9d71c4f80416d0e$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: " + $e9d71c4f80416d0e$var$transitions.outOfTheWay + ";\n    ";
        return {
            selector: getSelector($e9d71c4f80416d0e$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector($e9d71c4f80416d0e$var$droppable.contextId),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: "body",
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $e9d71c4f80416d0e$var$getStyles(rules, "always"),
        resting: $e9d71c4f80416d0e$var$getStyles(rules, "resting"),
        dragging: $e9d71c4f80416d0e$var$getStyles(rules, "dragging"),
        dropAnimating: $e9d71c4f80416d0e$var$getStyles(rules, "dropAnimating"),
        userCancel: $e9d71c4f80416d0e$var$getStyles(rules, "userCancel")
    };
};
var $e9d71c4f80416d0e$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $4RFnf.useLayoutEffect) : (0, $4RFnf.useEffect);
var $e9d71c4f80416d0e$var$getHead = function getHead() {
    var head = document.querySelector("head");
    !head && $e9d71c4f80416d0e$var$invariant(false);
    return head;
};
var $e9d71c4f80416d0e$var$createStyleEl = function createStyleEl(nonce) {
    var el = document.createElement("style");
    if (nonce) el.setAttribute("nonce", nonce);
    el.type = "text/css";
    return el;
};
function $e9d71c4f80416d0e$var$useStyleMarshal(contextId, nonce) {
    var styles = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return $e9d71c4f80416d0e$var$getStyles$1(contextId);
    }, [
        contextId
    ]);
    var alwaysRef = (0, $4RFnf.useRef)(null);
    var dynamicRef = (0, $4RFnf.useRef)(null);
    var setDynamicStyle = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)((0, $7ecb05d430698c92$export$2e2bcd8739ae039)(function(proposed) {
        var el = dynamicRef.current;
        !el && $e9d71c4f80416d0e$var$invariant(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function(proposed) {
        var el = alwaysRef.current;
        !el && $e9d71c4f80416d0e$var$invariant(false);
        el.textContent = proposed;
    }, []);
    $e9d71c4f80416d0e$var$useIsomorphicLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && $e9d71c4f80416d0e$var$invariant(false);
        var always = $e9d71c4f80416d0e$var$createStyleEl(nonce);
        var dynamic = $e9d71c4f80416d0e$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute($e9d71c4f80416d0e$var$prefix$1 + "-always", contextId);
        dynamic.setAttribute($e9d71c4f80416d0e$var$prefix$1 + "-dynamic", contextId);
        $e9d71c4f80416d0e$var$getHead().appendChild(always);
        $e9d71c4f80416d0e$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function remove(ref) {
                var current = ref.current;
                !current && $e9d71c4f80416d0e$var$invariant(false);
                $e9d71c4f80416d0e$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    var dragging = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function(reason) {
        if (reason === "DROP") {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting
        };
    }, [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
var $e9d71c4f80416d0e$var$getWindowFromEl = function(el) {
    return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function $e9d71c4f80416d0e$var$isHtmlElement(el) {
    return el instanceof $e9d71c4f80416d0e$var$getWindowFromEl(el).HTMLElement;
}
function $e9d71c4f80416d0e$var$findDragHandle(contextId, draggableId) {
    var selector = "[" + $e9d71c4f80416d0e$var$dragHandle.contextId + '="' + contextId + '"]';
    var possible = $e9d71c4f80416d0e$var$toArray(document.querySelectorAll(selector));
    if (!possible.length) return null;
    var handle = $e9d71c4f80416d0e$var$find(possible, function(el) {
        return el.getAttribute($e9d71c4f80416d0e$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$e9d71c4f80416d0e$var$isHtmlElement(handle)) return null;
    return handle;
}
function $e9d71c4f80416d0e$var$useFocusMarshal(contextId) {
    var entriesRef = (0, $4RFnf.useRef)({});
    var recordRef = (0, $4RFnf.useRef)(null);
    var restoreFocusFrameRef = (0, $4RFnf.useRef)(null);
    var isMountedRef = (0, $4RFnf.useRef)(false);
    var register = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function register(id, focus) {
        var entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            var entries = entriesRef.current;
            var current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    var tryGiveFocus = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function tryGiveFocus(tryGiveFocusTo) {
        var handle = $e9d71c4f80416d0e$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    var tryShiftRecord = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    var tryRestoreFocusRecorded = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(function() {
            restoreFocusFrameRef.current = null;
            var record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    var tryRecordFocus = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function tryRecordFocus(id) {
        recordRef.current = null;
        var focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($e9d71c4f80416d0e$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $e9d71c4f80416d0e$var$useIsomorphicLayoutEffect(function() {
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            var frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    var marshal = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return {
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        };
    }, [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $e9d71c4f80416d0e$var$createRegistry() {
    var entries = {
        draggables: {},
        droppables: {}
    };
    var subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            var index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach(function(cb) {
            return cb(event);
        });
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        var entry = findDraggableById(id);
        !entry && $e9d71c4f80416d0e$var$invariant(false);
        return entry;
    }
    var draggableAPI = {
        register: function register(entry) {
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: "ADDITION",
                value: entry
            });
        },
        update: function update(entry, last) {
            var current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var draggableId = entry.descriptor.id;
            var current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            notify({
                type: "REMOVAL",
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: function exists(id) {
            return Boolean(findDraggableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $e9d71c4f80416d0e$var$values(entries.draggables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        var entry = findDroppableById(id);
        !entry && $e9d71c4f80416d0e$var$invariant(false);
        return entry;
    }
    var droppableAPI = {
        register: function register(entry) {
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: function exists(id) {
            return Boolean(findDroppableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $e9d71c4f80416d0e$var$values(entries.droppables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $e9d71c4f80416d0e$var$useRegistry() {
    var registry = (0, $e4b050ab5f92332c$export$1538c33de8887b59)($e9d71c4f80416d0e$var$createRegistry, []);
    (0, $4RFnf.useEffect)(function() {
        return function unmount() {
            requestAnimationFrame(registry.clean);
        };
    }, [
        registry
    ]);
    return registry;
}
var $e9d71c4f80416d0e$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createContext(null);
var $e9d71c4f80416d0e$var$getBodyElement = function() {
    var body = document.body;
    !body && $e9d71c4f80416d0e$var$invariant(false);
    return body;
};
var $e9d71c4f80416d0e$var$visuallyHidden = {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    border: "0",
    padding: "0",
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    "clip-path": "inset(100%)"
};
var $e9d71c4f80416d0e$var$getId = function getId(contextId) {
    return "rbd-announcement-" + contextId;
};
function $e9d71c4f80416d0e$var$useAnnouncer(contextId) {
    var id = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return $e9d71c4f80416d0e$var$getId(contextId);
    }, [
        contextId
    ]);
    var ref = (0, $4RFnf.useRef)(null);
    (0, $4RFnf.useEffect)(function setup() {
        var el = document.createElement("div");
        ref.current = el;
        el.id = id;
        el.setAttribute("aria-live", "assertive");
        el.setAttribute("aria-atomic", "true");
        (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)(el.style, $e9d71c4f80416d0e$var$visuallyHidden);
        $e9d71c4f80416d0e$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                var body = $e9d71c4f80416d0e$var$getBodyElement();
                if (body.contains(el)) body.removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    var announce = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var $e9d71c4f80416d0e$var$count = 0;
var $e9d71c4f80416d0e$var$defaults = {
    separator: "::"
};
function $e9d71c4f80416d0e$var$reset() {
    $e9d71c4f80416d0e$var$count = 0;
}
function $e9d71c4f80416d0e$var$useUniqueId(prefix, options) {
    if (options === void 0) options = $e9d71c4f80416d0e$var$defaults;
    return (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return "" + prefix + options.separator + $e9d71c4f80416d0e$var$count++;
    }, [
        options.separator,
        prefix
    ]);
}
function $e9d71c4f80416d0e$var$getElementId(_ref) {
    var contextId = _ref.contextId, uniqueId = _ref.uniqueId;
    return "rbd-hidden-text-" + contextId + "-" + uniqueId;
}
function $e9d71c4f80416d0e$var$useHiddenTextElement(_ref2) {
    var contextId = _ref2.contextId, text = _ref2.text;
    var uniqueId = $e9d71c4f80416d0e$var$useUniqueId("hidden-text", {
        separator: "-"
    });
    var id = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return $e9d71c4f80416d0e$var$getElementId({
            contextId: contextId,
            uniqueId: uniqueId
        });
    }, [
        uniqueId,
        contextId
    ]);
    (0, $4RFnf.useEffect)(function mount() {
        var el = document.createElement("div");
        el.id = id;
        el.textContent = text;
        el.style.display = "none";
        $e9d71c4f80416d0e$var$getBodyElement().appendChild(el);
        return function unmount() {
            var body = $e9d71c4f80416d0e$var$getBodyElement();
            if (body.contains(el)) body.removeChild(el);
        };
    }, [
        id,
        text
    ]);
    return id;
}
var $e9d71c4f80416d0e$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createContext(null);
var $e9d71c4f80416d0e$var$peerDependencies = {
    react: "^16.8.5 || ^17.0.0 || ^18.0.0",
    "react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
};
var $e9d71c4f80416d0e$var$semver = /(\d+)\.(\d+)\.(\d+)/;
var $e9d71c4f80416d0e$var$getVersion = function getVersion(value) {
    var result = $e9d71c4f80416d0e$var$semver.exec(value);
    !(result != null) && $e9d71c4f80416d0e$var$invariant(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var $e9d71c4f80416d0e$var$isSatisfied = function isSatisfied(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $e9d71c4f80416d0e$var$checkReactVersion = function(peerDepValue, actualValue) {
    var peerDep = $e9d71c4f80416d0e$var$getVersion(peerDepValue);
    var actual = $e9d71c4f80416d0e$var$getVersion(actualValue);
    if ($e9d71c4f80416d0e$var$isSatisfied(peerDep, actual)) return;
};
var $e9d71c4f80416d0e$var$suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var $e9d71c4f80416d0e$var$checkDoctype = function(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $e9d71c4f80416d0e$var$useDev(useHook) {}
function $e9d71c4f80416d0e$var$useDevSetupWarning(fn, inputs) {
    $e9d71c4f80416d0e$var$useDev(function() {
        (0, $4RFnf.useEffect)(function() {
            try {
                fn();
            } catch (e) {
                $e9d71c4f80416d0e$var$error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
            }
        }, inputs);
    });
}
function $e9d71c4f80416d0e$var$useStartupValidation() {
    $e9d71c4f80416d0e$var$useDevSetupWarning(function() {
        $e9d71c4f80416d0e$var$checkReactVersion($e9d71c4f80416d0e$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).version);
        $e9d71c4f80416d0e$var$checkDoctype(document);
    }, []);
}
function $e9d71c4f80416d0e$var$usePrevious(current) {
    var ref = (0, $4RFnf.useRef)(current);
    (0, $4RFnf.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
function $e9d71c4f80416d0e$var$create() {
    var lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $e9d71c4f80416d0e$var$invariant(false);
        var newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $e9d71c4f80416d0e$var$invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
var $e9d71c4f80416d0e$var$tab = 9;
var $e9d71c4f80416d0e$var$enter = 13;
var $e9d71c4f80416d0e$var$escape = 27;
var $e9d71c4f80416d0e$var$space = 32;
var $e9d71c4f80416d0e$var$pageUp = 33;
var $e9d71c4f80416d0e$var$pageDown = 34;
var $e9d71c4f80416d0e$var$end = 35;
var $e9d71c4f80416d0e$var$home = 36;
var $e9d71c4f80416d0e$var$arrowLeft = 37;
var $e9d71c4f80416d0e$var$arrowUp = 38;
var $e9d71c4f80416d0e$var$arrowRight = 39;
var $e9d71c4f80416d0e$var$arrowDown = 40;
var $e9d71c4f80416d0e$var$_preventedKeys;
var $e9d71c4f80416d0e$var$preventedKeys = ($e9d71c4f80416d0e$var$_preventedKeys = {}, $e9d71c4f80416d0e$var$_preventedKeys[$e9d71c4f80416d0e$var$enter] = true, $e9d71c4f80416d0e$var$_preventedKeys[$e9d71c4f80416d0e$var$tab] = true, $e9d71c4f80416d0e$var$_preventedKeys);
var $e9d71c4f80416d0e$var$preventStandardKeyEvents = function(event) {
    if ($e9d71c4f80416d0e$var$preventedKeys[event.keyCode]) event.preventDefault();
};
var $e9d71c4f80416d0e$var$supportedEventName = function() {
    var base = "visibilitychange";
    if (typeof document === "undefined") return base;
    var candidates = [
        base,
        "ms" + base,
        "webkit" + base,
        "moz" + base,
        "o" + base
    ];
    var supported = $e9d71c4f80416d0e$var$find(candidates, function(eventName) {
        return "on" + eventName in document;
    });
    return supported || base;
}();
var $e9d71c4f80416d0e$var$primaryButton = 0;
var $e9d71c4f80416d0e$var$sloppyClickThreshold = 5;
function $e9d71c4f80416d0e$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $e9d71c4f80416d0e$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $e9d71c4f80416d0e$var$sloppyClickThreshold;
}
var $e9d71c4f80416d0e$var$idle$1 = {
    type: "IDLE"
};
function $e9d71c4f80416d0e$var$getCaptureBindings(_ref) {
    var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
    return [
        {
            eventName: "mousemove",
            fn: function fn(event) {
                var button = event.button, clientX = event.clientX, clientY = event.clientY;
                if (button !== $e9d71c4f80416d0e$var$primaryButton) return;
                var point = {
                    x: clientX,
                    y: clientY
                };
                var phase = getPhase();
                if (phase.type === "DRAGGING") {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === "PENDING") && $e9d71c4f80416d0e$var$invariant(false);
                var pending = phase.point;
                if (!$e9d71c4f80416d0e$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                var actions = phase.actions.fluidLift(point);
                setPhase({
                    type: "DRAGGING",
                    actions: actions
                });
            }
        },
        {
            eventName: "mouseup",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "mousedown",
            fn: function fn(event) {
                if (getPhase().type === "DRAGGING") event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "keydown",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type === "PENDING") {
                    cancel();
                    return;
                }
                if (event.keyCode === $e9d71c4f80416d0e$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $e9d71c4f80416d0e$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "scroll",
            options: {
                passive: true,
                capture: false
            },
            fn: function fn() {
                if (getPhase().type === "PENDING") cancel();
            }
        },
        {
            eventName: "webkitmouseforcedown",
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== "IDLE") && $e9d71c4f80416d0e$var$invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $e9d71c4f80416d0e$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $e9d71c4f80416d0e$export$2f59cd992b42195a(api) {
    var phaseRef = (0, $4RFnf.useRef)($e9d71c4f80416d0e$var$idle$1);
    var unbindEventsRef = (0, $4RFnf.useRef)($e9d71c4f80416d0e$var$noop);
    var startCaptureBinding = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return {
            eventName: "mousedown",
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $e9d71c4f80416d0e$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                var point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var preventForcePressBinding = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return {
            eventName: "webkitmouseforcewillbegin",
            fn: function fn(event) {
                if (event.defaultPrevented) return;
                var id = api.findClosestDraggableId(event);
                if (!id) return;
                var options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function listenForCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $e9d71c4f80416d0e$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    var stop = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        var current = phaseRef.current;
        if (current.type === "IDLE") return;
        phaseRef.current = $e9d71c4f80416d0e$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    var cancel = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var bindings = $e9d71c4f80416d0e$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: function getPhase() {
                return phaseRef.current;
            },
            setPhase: function setPhase(phase) {
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $e9d71c4f80416d0e$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    var startPendingDrag = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === "IDLE") && $e9d71c4f80416d0e$var$invariant(false);
        phaseRef.current = {
            type: "PENDING",
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $e9d71c4f80416d0e$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $e9d71c4f80416d0e$var$_scrollJumpKeys;
function $e9d71c4f80416d0e$var$noop$1() {}
var $e9d71c4f80416d0e$var$scrollJumpKeys = ($e9d71c4f80416d0e$var$_scrollJumpKeys = {}, $e9d71c4f80416d0e$var$_scrollJumpKeys[$e9d71c4f80416d0e$var$pageDown] = true, $e9d71c4f80416d0e$var$_scrollJumpKeys[$e9d71c4f80416d0e$var$pageUp] = true, $e9d71c4f80416d0e$var$_scrollJumpKeys[$e9d71c4f80416d0e$var$home] = true, $e9d71c4f80416d0e$var$_scrollJumpKeys[$e9d71c4f80416d0e$var$end] = true, $e9d71c4f80416d0e$var$_scrollJumpKeys);
function $e9d71c4f80416d0e$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: "keydown",
            fn: function fn(event) {
                if (event.keyCode === $e9d71c4f80416d0e$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $e9d71c4f80416d0e$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $e9d71c4f80416d0e$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $e9d71c4f80416d0e$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $e9d71c4f80416d0e$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $e9d71c4f80416d0e$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($e9d71c4f80416d0e$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $e9d71c4f80416d0e$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "mousedown",
            fn: cancel
        },
        {
            eventName: "mouseup",
            fn: cancel
        },
        {
            eventName: "click",
            fn: cancel
        },
        {
            eventName: "touchstart",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "wheel",
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $e9d71c4f80416d0e$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $e9d71c4f80416d0e$export$42b74264faad0714(api) {
    var unbindEventsRef = (0, $4RFnf.useRef)($e9d71c4f80416d0e$var$noop$1);
    var startCaptureBinding = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return {
            eventName: "keydown",
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $e9d71c4f80416d0e$var$space) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                var isCapturing = true;
                var actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $e9d71c4f80416d0e$var$invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $e9d71c4f80416d0e$var$bindEvents(window, $e9d71c4f80416d0e$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function tryStartCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $e9d71c4f80416d0e$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $e9d71c4f80416d0e$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $e9d71c4f80416d0e$var$idle$2 = {
    type: "IDLE"
};
var $e9d71c4f80416d0e$var$timeForLongPress = 120;
var $e9d71c4f80416d0e$var$forcePressThreshold = 0.15;
function $e9d71c4f80416d0e$var$getWindowBindings(_ref) {
    var cancel = _ref.cancel, getPhase = _ref.getPhase;
    return [
        {
            eventName: "orientationchange",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "contextmenu",
            fn: function fn(event) {
                event.preventDefault();
            }
        },
        {
            eventName: "keydown",
            fn: function fn(event) {
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                if (event.keyCode === $e9d71c4f80416d0e$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $e9d71c4f80416d0e$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $e9d71c4f80416d0e$var$getHandleBindings(_ref2) {
    var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
    return [
        {
            eventName: "touchmove",
            options: {
                capture: false
            },
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: "touchend",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "touchcancel",
            fn: function fn(event) {
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "touchforcechange",
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== "IDLE") && $e9d71c4f80416d0e$var$invariant(false);
                var touch = event.touches[0];
                if (!touch) return;
                var isForcePress = touch.force >= $e9d71c4f80416d0e$var$forcePressThreshold;
                if (!isForcePress) return;
                var shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === "PENDING") {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $e9d71c4f80416d0e$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $e9d71c4f80416d0e$export$ac235fd3a7bcf7b4(api) {
    var phaseRef = (0, $4RFnf.useRef)($e9d71c4f80416d0e$var$idle$2);
    var unbindEventsRef = (0, $4RFnf.useRef)($e9d71c4f80416d0e$var$noop);
    var getPhase = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function getPhase() {
        return phaseRef.current;
    }, []);
    var setPhase = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    var startCaptureBinding = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return {
            eventName: "touchstart",
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                var touch = event.touches[0];
                var clientX = touch.clientX, clientY = touch.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function listenForCapture() {
        var options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $e9d71c4f80416d0e$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    var stop = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        var current = phaseRef.current;
        if (current.type === "IDLE") return;
        if (current.type === "PENDING") clearTimeout(current.longPressTimerId);
        setPhase($e9d71c4f80416d0e$var$idle$2);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    var cancel = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        var unbindTarget = $e9d71c4f80416d0e$var$bindEvents(window, $e9d71c4f80416d0e$var$getHandleBindings(args), options);
        var unbindWindow = $e9d71c4f80416d0e$var$bindEvents(window, $e9d71c4f80416d0e$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    var startDragging = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function startDragging() {
        var phase = getPhase();
        !(phase.type === "PENDING") && $e9d71c4f80416d0e$var$invariant(false);
        var actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: "DRAGGING",
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    var startPendingDrag = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function startPendingDrag(actions, point) {
        !(getPhase().type === "IDLE") && $e9d71c4f80416d0e$var$invariant(false);
        var longPressTimerId = setTimeout(startDragging, $e9d71c4f80416d0e$var$timeForLongPress);
        setPhase({
            type: "PENDING",
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $e9d71c4f80416d0e$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            var phase = getPhase();
            if (phase.type === "PENDING") {
                clearTimeout(phase.longPressTimerId);
                setPhase($e9d71c4f80416d0e$var$idle$2);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $e9d71c4f80416d0e$var$useIsomorphicLayoutEffect(function webkitHack() {
        var unbind = $e9d71c4f80416d0e$var$bindEvents(window, [
            {
                eventName: "touchmove",
                fn: function fn() {},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $e9d71c4f80416d0e$var$useValidateSensorHooks(sensorHooks) {
    $e9d71c4f80416d0e$var$useDev(function() {
        var previousRef = $e9d71c4f80416d0e$var$usePrevious(sensorHooks);
        $e9d71c4f80416d0e$var$useDevSetupWarning(function() {
            !(previousRef.current.length === sensorHooks.length) && $e9d71c4f80416d0e$var$invariant(false);
        });
    });
}
var $e9d71c4f80416d0e$var$interactiveTagNames = {
    input: true,
    button: true,
    textarea: true,
    select: true,
    option: true,
    optgroup: true,
    video: true,
    audio: true
};
function $e9d71c4f80416d0e$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = Boolean($e9d71c4f80416d0e$var$interactiveTagNames[current.tagName.toLowerCase()]);
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute("contenteditable");
    if (attribute === "true" || attribute === "") return true;
    if (current === parent) return false;
    return $e9d71c4f80416d0e$var$isAnInteractiveElement(parent, current.parentElement);
}
function $e9d71c4f80416d0e$var$isEventInInteractiveElement(draggable, event) {
    var target = event.target;
    if (!$e9d71c4f80416d0e$var$isHtmlElement(target)) return false;
    return $e9d71c4f80416d0e$var$isAnInteractiveElement(draggable, target);
}
var $e9d71c4f80416d0e$var$getBorderBoxCenterPosition = function(el) {
    return (0, $23492784bb53e9d7$export$4b834cebd9e5cebe)(el.getBoundingClientRect()).center;
};
function $e9d71c4f80416d0e$var$isElement(el) {
    return el instanceof $e9d71c4f80416d0e$var$getWindowFromEl(el).Element;
}
var $e9d71c4f80416d0e$var$supportedMatchesName = function() {
    var base = "matches";
    if (typeof document === "undefined") return base;
    var candidates = [
        base,
        "msMatchesSelector",
        "webkitMatchesSelector"
    ];
    var value = $e9d71c4f80416d0e$var$find(candidates, function(name) {
        return name in Element.prototype;
    });
    return value || base;
}();
function $e9d71c4f80416d0e$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$e9d71c4f80416d0e$var$supportedMatchesName](selector)) return el;
    return $e9d71c4f80416d0e$var$closestPonyfill(el.parentElement, selector);
}
function $e9d71c4f80416d0e$var$closest$1(el, selector) {
    if (el.closest) return el.closest(selector);
    return $e9d71c4f80416d0e$var$closestPonyfill(el, selector);
}
function $e9d71c4f80416d0e$var$getSelector(contextId) {
    return "[" + $e9d71c4f80416d0e$var$dragHandle.contextId + '="' + contextId + '"]';
}
function $e9d71c4f80416d0e$var$findClosestDragHandleFromEvent(contextId, event) {
    var target = event.target;
    if (!$e9d71c4f80416d0e$var$isElement(target)) return null;
    var selector = $e9d71c4f80416d0e$var$getSelector(contextId);
    var handle = $e9d71c4f80416d0e$var$closest$1(target, selector);
    if (!handle) return null;
    if (!$e9d71c4f80416d0e$var$isHtmlElement(handle)) return null;
    return handle;
}
function $e9d71c4f80416d0e$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    var handle = $e9d71c4f80416d0e$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($e9d71c4f80416d0e$var$dragHandle.draggableId);
}
function $e9d71c4f80416d0e$var$findDraggable(contextId, draggableId) {
    var selector = "[" + $e9d71c4f80416d0e$var$draggable.contextId + '="' + contextId + '"]';
    var possible = $e9d71c4f80416d0e$var$toArray(document.querySelectorAll(selector));
    var draggable$1 = $e9d71c4f80416d0e$var$find(possible, function(el) {
        return el.getAttribute($e9d71c4f80416d0e$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$e9d71c4f80416d0e$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $e9d71c4f80416d0e$var$preventDefault(event) {
    event.preventDefault();
}
function $e9d71c4f80416d0e$var$_isActive(_ref) {
    var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $e9d71c4f80416d0e$var$canStart(_ref2) {
    var lockAPI = _ref2.lockAPI, store = _ref2.store, registry = _ref2.registry, draggableId = _ref2.draggableId;
    if (lockAPI.isClaimed()) return false;
    var entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$e9d71c4f80416d0e$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $e9d71c4f80416d0e$var$tryStart(_ref3) {
    var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
    var shouldStart = $e9d71c4f80416d0e$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    var entry = registry.draggable.getById(draggableId);
    var el = $e9d71c4f80416d0e$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $e9d71c4f80416d0e$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    var lock = lockAPI.claim(forceSensorStop || $e9d71c4f80416d0e$var$noop);
    var phase = "PRE_DRAG";
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($e9d71c4f80416d0e$var$_isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    var tryDispatchWhenDragging = tryDispatch.bind(null, "DRAGGING");
    function lift$1(args) {
        function completed() {
            lockAPI.release();
            phase = "COMPLETED";
        }
        if (phase !== "PRE_DRAG") {
            completed();
            !(phase === "PRE_DRAG") && $e9d71c4f80416d0e$var$invariant(false);
        }
        store.dispatch($e9d71c4f80416d0e$var$lift(args.liftActionArgs));
        phase = "DRAGGING";
        function finish(reason, options) {
            if (options === void 0) options = {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                var unbind = $e9d71c4f80416d0e$var$bindEvents(window, [
                    {
                        eventName: "click",
                        fn: $e9d71c4f80416d0e$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($e9d71c4f80416d0e$var$drop({
                reason: reason
            }));
        }
        return (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({
            isActive: function isActive() {
                return $e9d71c4f80416d0e$var$_isActive({
                    expected: "DRAGGING",
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: function drop(options) {
                return finish("DROP", options);
            },
            cancel: function cancel(options) {
                return finish("CANCEL", options);
            }
        }, args.actions);
    }
    function fluidLift(clientSelection) {
        var move$1 = (0, $c4876ac90ad9a21f$export$2e2bcd8739ae039)(function(client) {
            tryDispatchWhenDragging(function() {
                return $e9d71c4f80416d0e$var$move({
                    client: client
                });
            });
        });
        var api = lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: "FLUID"
            },
            cleanup: function cleanup() {
                return move$1.cancel();
            },
            actions: {
                move: move$1
            }
        });
        return (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, api, {
            move: move$1
        });
    }
    function snapLift() {
        var actions = {
            moveUp: function moveUp$1() {
                return tryDispatchWhenDragging($e9d71c4f80416d0e$var$moveUp);
            },
            moveRight: function moveRight$1() {
                return tryDispatchWhenDragging($e9d71c4f80416d0e$var$moveRight);
            },
            moveDown: function moveDown$1() {
                return tryDispatchWhenDragging($e9d71c4f80416d0e$var$moveDown);
            },
            moveLeft: function moveLeft$1() {
                return tryDispatchWhenDragging($e9d71c4f80416d0e$var$moveLeft);
            }
        };
        return lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $e9d71c4f80416d0e$var$getBorderBoxCenterPosition(el),
                movementMode: "SNAP"
            },
            cleanup: $e9d71c4f80416d0e$var$noop,
            actions: actions
        });
    }
    function abortPreDrag() {
        var shouldRelease = $e9d71c4f80416d0e$var$_isActive({
            expected: "PRE_DRAG",
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    var preDrag = {
        isActive: function isActive() {
            return $e9d71c4f80416d0e$var$_isActive({
                expected: "PRE_DRAG",
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            });
        },
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
var $e9d71c4f80416d0e$var$defaultSensors = [
    $e9d71c4f80416d0e$export$2f59cd992b42195a,
    $e9d71c4f80416d0e$export$42b74264faad0714,
    $e9d71c4f80416d0e$export$ac235fd3a7bcf7b4
];
function $e9d71c4f80416d0e$var$useSensorMarshal(_ref4) {
    var contextId = _ref4.contextId, store = _ref4.store, registry = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
    var useSensors = [].concat(enableDefaultSensors ? $e9d71c4f80416d0e$var$defaultSensors : [], customSensors || []);
    var lockAPI = (0, $4RFnf.useState)(function() {
        return $e9d71c4f80416d0e$var$create();
    })[0];
    var tryAbandonLock = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function tryAbandonLock(previous, current) {
        if (previous.isDragging && !current.isDragging) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $e9d71c4f80416d0e$var$useIsomorphicLayoutEffect(function listenToStore() {
        var previous = store.getState();
        var unsubscribe = store.subscribe(function() {
            var current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $e9d71c4f80416d0e$var$useIsomorphicLayoutEffect(function() {
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    var canGetLock = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function(draggableId) {
        return $e9d71c4f80416d0e$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    var tryGetLock = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function(draggableId, forceStop, options) {
        return $e9d71c4f80416d0e$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        });
    }, [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    var findClosestDraggableId = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function(event) {
        return $e9d71c4f80416d0e$var$tryGetClosestDraggableIdFromEvent(contextId, event);
    }, [
        contextId
    ]);
    var findOptionsForDraggable = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function(id) {
        var entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    var tryReleaseLock = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function tryReleaseLock() {
        if (!lockAPI.isClaimed()) return;
        lockAPI.tryAbandon();
        if (store.getState().phase !== "IDLE") store.dispatch($e9d71c4f80416d0e$var$flush());
    }, [
        lockAPI,
        store
    ]);
    var isLockClaimed = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(lockAPI.isClaimed, [
        lockAPI
    ]);
    var api = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return {
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        };
    }, [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $e9d71c4f80416d0e$var$useValidateSensorHooks(useSensors);
    for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
}
var $e9d71c4f80416d0e$var$createResponders = function createResponders(props) {
    return {
        onBeforeCapture: props.onBeforeCapture,
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
function $e9d71c4f80416d0e$var$getStore(lazyRef) {
    !lazyRef.current && $e9d71c4f80416d0e$var$invariant(false);
    return lazyRef.current;
}
function $e9d71c4f80416d0e$var$App(props) {
    var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, dragHandleUsageInstructions = props.dragHandleUsageInstructions;
    var lazyStoreRef = (0, $4RFnf.useRef)(null);
    $e9d71c4f80416d0e$var$useStartupValidation();
    var lastPropsRef = $e9d71c4f80416d0e$var$usePrevious(props);
    var getResponders = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        return $e9d71c4f80416d0e$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = $e9d71c4f80416d0e$var$useAnnouncer(contextId);
    var dragHandleUsageInstructionsId = $e9d71c4f80416d0e$var$useHiddenTextElement({
        contextId: contextId,
        text: dragHandleUsageInstructions
    });
    var styleMarshal = $e9d71c4f80416d0e$var$useStyleMarshal(contextId, nonce);
    var lazyDispatch = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function(action) {
        $e9d71c4f80416d0e$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    var marshalCallbacks = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return (0, $f8baa4858faeac49$export$aea084d96e84da92)({
            publishWhileDragging: $e9d71c4f80416d0e$var$publishWhileDragging,
            updateDroppableScroll: $e9d71c4f80416d0e$var$updateDroppableScroll,
            updateDroppableIsEnabled: $e9d71c4f80416d0e$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $e9d71c4f80416d0e$var$updateDroppableIsCombineEnabled,
            collectionStarting: $e9d71c4f80416d0e$var$collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var registry = $e9d71c4f80416d0e$var$useRegistry();
    var dimensionMarshal = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return $e9d71c4f80416d0e$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    var autoScroller = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return $e9d71c4f80416d0e$var$createAutoScroller((0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({
            scrollWindow: $e9d71c4f80416d0e$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable
        }, (0, $f8baa4858faeac49$export$aea084d96e84da92)({
            move: $e9d71c4f80416d0e$var$move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch
    ]);
    var focusMarshal = $e9d71c4f80416d0e$var$useFocusMarshal(contextId);
    var store = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return $e9d71c4f80416d0e$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        var current = $e9d71c4f80416d0e$var$getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== "IDLE") current.dispatch($e9d71c4f80416d0e$var$flush());
    }, []);
    var isDragging = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        var state = $e9d71c4f80416d0e$var$getStore(lazyStoreRef).getState();
        return state.isDragging || state.phase === "DROP_ANIMATING";
    }, []);
    var appCallbacks = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return {
            isDragging: isDragging,
            tryAbort: tryResetStore
        };
    }, [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    var getCanLift = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function(id) {
        return $e9d71c4f80416d0e$var$canStartDrag($e9d71c4f80416d0e$var$getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        return $e9d71c4f80416d0e$var$isMovementAllowed($e9d71c4f80416d0e$var$getStore(lazyStoreRef).getState());
    }, []);
    var appContext = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return {
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
            registry: registry
        };
    }, [
        contextId,
        dimensionMarshal,
        dragHandleUsageInstructionsId,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        registry
    ]);
    $e9d71c4f80416d0e$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $4RFnf.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createElement($e9d71c4f80416d0e$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createElement((0, $6d47983a1d0d2cfb$export$2e2bcd8739ae039), {
        context: $e9d71c4f80416d0e$var$StoreContext,
        store: store
    }, props.children));
}
var $e9d71c4f80416d0e$var$count$1 = 0;
function $e9d71c4f80416d0e$var$reset$1() {
    $e9d71c4f80416d0e$var$count$1 = 0;
}
function $e9d71c4f80416d0e$var$useInstanceCount() {
    return (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return "" + $e9d71c4f80416d0e$var$count$1++;
    }, []);
}
function $e9d71c4f80416d0e$export$2bfe52350fc0150d() {
    $e9d71c4f80416d0e$var$reset$1();
    $e9d71c4f80416d0e$var$reset();
}
function $e9d71c4f80416d0e$export$237bd83162c14364(props) {
    var contextId = $e9d71c4f80416d0e$var$useInstanceCount();
    var dragHandleUsageInstructions = props.dragHandleUsageInstructions || $e9d71c4f80416d0e$var$preset.dragHandleUsageInstructions;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createElement($e9d71c4f80416d0e$var$ErrorBoundary, null, function(setCallbacks) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createElement($e9d71c4f80416d0e$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            dragHandleUsageInstructions: dragHandleUsageInstructions,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd
        }, props.children);
    });
}
var $e9d71c4f80416d0e$var$isEqual$1 = function isEqual(base) {
    return function(value) {
        return base === value;
    };
};
var $e9d71c4f80416d0e$var$isScroll = $e9d71c4f80416d0e$var$isEqual$1("scroll");
var $e9d71c4f80416d0e$var$isAuto = $e9d71c4f80416d0e$var$isEqual$1("auto");
var $e9d71c4f80416d0e$var$isVisible$1 = $e9d71c4f80416d0e$var$isEqual$1("visible");
var $e9d71c4f80416d0e$var$isEither = function isEither(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var $e9d71c4f80416d0e$var$isBoth = function isBoth(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var $e9d71c4f80416d0e$var$isElementScrollable = function isElementScrollable(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $e9d71c4f80416d0e$var$isEither(overflow, $e9d71c4f80416d0e$var$isScroll) || $e9d71c4f80416d0e$var$isEither(overflow, $e9d71c4f80416d0e$var$isAuto);
};
var $e9d71c4f80416d0e$var$isBodyScrollable = function isBodyScrollable() {
    var body, html, htmlStyle, htmlOverflow;
    return false;
};
var $e9d71c4f80416d0e$var$getClosestScrollable = function getClosestScrollable(el) {
    if (el == null) return null;
    if (el === document.body) return $e9d71c4f80416d0e$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$e9d71c4f80416d0e$var$isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var $e9d71c4f80416d0e$var$checkForNestedScrollContainers = function(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = $e9d71c4f80416d0e$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $e9d71c4f80416d0e$var$getScroll$1 = function(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var $e9d71c4f80416d0e$var$getIsFixed = function getIsFixed(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === "fixed") return true;
    return getIsFixed(el.parentElement);
};
var $e9d71c4f80416d0e$var$getEnv = function(start) {
    var closestScrollable = $e9d71c4f80416d0e$var$getClosestScrollable(start);
    var isFixedOnPage = $e9d71c4f80416d0e$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $e9d71c4f80416d0e$var$getDroppableDimension = function(_ref) {
    var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = $e9d71c4f80416d0e$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $e9d71c4f80416d0e$var$origin,
                    displacement: $e9d71c4f80416d0e$var$origin
                }
            }
        };
    }();
    var axis = direction === "vertical" ? $e9d71c4f80416d0e$var$vertical : $e9d71c4f80416d0e$var$horizontal;
    var subject = $e9d71c4f80416d0e$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var $e9d71c4f80416d0e$var$getClient = function getClient(targetRef, closestScrollable) {
    var base = (0, $23492784bb53e9d7$export$34928e660d2a8702)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, $23492784bb53e9d7$export$9f77e0932fb78f72)(paddingBox, base.border);
    var client = (0, $23492784bb53e9d7$export$6459fc9e86be362e)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $e9d71c4f80416d0e$var$getDimension = function(_ref) {
    var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = $e9d71c4f80416d0e$var$getClient(ref, closestScrollable);
    var page = (0, $23492784bb53e9d7$export$1d0caec378d7d0ae)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, $23492784bb53e9d7$export$34928e660d2a8702)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $23492784bb53e9d7$export$1d0caec378d7d0ae)(frameClient, windowScroll),
            scroll: $e9d71c4f80416d0e$var$getScroll$1(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = $e9d71c4f80416d0e$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
var $e9d71c4f80416d0e$var$immediate = {
    passive: false
};
var $e9d71c4f80416d0e$var$delayed = {
    passive: true
};
var $e9d71c4f80416d0e$var$getListenerOptions = function(options) {
    return options.shouldPublishImmediately ? $e9d71c4f80416d0e$var$immediate : $e9d71c4f80416d0e$var$delayed;
};
function $e9d71c4f80416d0e$var$useRequiredContext(Context) {
    var result = (0, $4RFnf.useContext)(Context);
    !result && $e9d71c4f80416d0e$var$invariant(false);
    return result;
}
var $e9d71c4f80416d0e$var$getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function $e9d71c4f80416d0e$var$useDroppablePublisher(args) {
    var whileDraggingRef = (0, $4RFnf.useRef)(null);
    var appContext = $e9d71c4f80416d0e$var$useRequiredContext($e9d71c4f80416d0e$var$AppContext);
    var uniqueId = $e9d71c4f80416d0e$var$useUniqueId("droppable");
    var registry = appContext.registry, marshal = appContext.marshal;
    var previousRef = $e9d71c4f80416d0e$var$usePrevious(args);
    var descriptor = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return {
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        };
    }, [
        args.droppableId,
        args.mode,
        args.type
    ]);
    var publishedDescriptorRef = (0, $4RFnf.useRef)(descriptor);
    var memoizedUpdateScroll = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return (0, $7ecb05d430698c92$export$2e2bcd8739ae039)(function(x, y) {
            !whileDraggingRef.current && $e9d71c4f80416d0e$var$invariant(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $e9d71c4f80416d0e$var$origin;
        return $e9d71c4f80416d0e$var$getScroll$1(dragging.env.closestScrollable);
    }, []);
    var updateScroll = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return (0, $c4876ac90ad9a21f$export$2e2bcd8739ae039)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $e9d71c4f80416d0e$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $e9d71c4f80416d0e$var$invariant(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function(windowScroll, options) {
        !!whileDraggingRef.current && $e9d71c4f80416d0e$var$invariant(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && $e9d71c4f80416d0e$var$invariant(false);
        var env = $e9d71c4f80416d0e$var$getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = $e9d71c4f80416d0e$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        var scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($e9d71c4f80416d0e$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener("scroll", onClosestScroll, $e9d71c4f80416d0e$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var getScrollWhileDragging = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $e9d71c4f80416d0e$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $e9d71c4f80416d0e$var$invariant(false);
        return $e9d71c4f80416d0e$var$getScroll$1(closest);
    }, []);
    var dragStopped = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        !dragging && $e9d71c4f80416d0e$var$invariant(false);
        var closest = $e9d71c4f80416d0e$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($e9d71c4f80416d0e$var$scrollContainer.contextId);
        closest.removeEventListener("scroll", onClosestScroll, $e9d71c4f80416d0e$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && $e9d71c4f80416d0e$var$invariant(false);
        var closest = $e9d71c4f80416d0e$var$getClosestScrollableFromDrag(dragging);
        !closest && $e9d71c4f80416d0e$var$invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    var entry = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        };
    }, [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $e9d71c4f80416d0e$var$useIsomorphicLayoutEffect(function() {
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $e9d71c4f80416d0e$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $e9d71c4f80416d0e$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $e9d71c4f80416d0e$var$noop$2() {}
var $e9d71c4f80416d0e$var$empty = {
    width: 0,
    height: 0,
    margin: $e9d71c4f80416d0e$var$noSpacing
};
var $e9d71c4f80416d0e$var$getSize = function getSize(_ref) {
    var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
    if (isAnimatingOpenOnMount) return $e9d71c4f80416d0e$var$empty;
    if (animate === "close") return $e9d71c4f80416d0e$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var $e9d71c4f80416d0e$var$getStyle = function getStyle(_ref2) {
    var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
    var size = $e9d71c4f80416d0e$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: "border-box",
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: "0",
        flexGrow: "0",
        pointerEvents: "none",
        transition: animate !== "none" ? $e9d71c4f80416d0e$var$transitions.placeholder : null
    };
};
function $e9d71c4f80416d0e$var$Placeholder(props) {
    var animateOpenTimerRef = (0, $4RFnf.useRef)(null);
    var tryClearAnimateOpenTimer = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
    var _useState = (0, $4RFnf.useState)(props.animate === "open"), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, $4RFnf.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return $e9d71c4f80416d0e$var$noop$2;
        if (animate !== "open") {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $e9d71c4f80416d0e$var$noop$2;
        }
        if (animateOpenTimerRef.current) return $e9d71c4f80416d0e$var$noop$2;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function(event) {
        if (event.propertyName !== "height") return;
        onTransitionEnd();
        if (animate === "close") onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = $e9d71c4f80416d0e$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createElement(props.placeholder.tagName, {
        style: style,
        "data-rbd-placeholder-context-id": contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
}
var $e9d71c4f80416d0e$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).memo($e9d71c4f80416d0e$var$Placeholder);
var $e9d71c4f80416d0e$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createContext(null);
function $e9d71c4f80416d0e$var$checkIsValidInnerRef(el) {
    !(el && $e9d71c4f80416d0e$var$isHtmlElement(el)) && $e9d71c4f80416d0e$var$invariant(false);
}
function $e9d71c4f80416d0e$var$isBoolean(value) {
    return typeof value === "boolean";
}
function $e9d71c4f80416d0e$var$runChecks(args, checks) {
    checks.forEach(function(check) {
        return check(args);
    });
}
var $e9d71c4f80416d0e$var$shared = [
    function required(_ref) {
        var props = _ref.props;
        !props.droppableId && $e9d71c4f80416d0e$var$invariant(false);
        !(typeof props.droppableId === "string") && $e9d71c4f80416d0e$var$invariant(false);
    },
    function _boolean(_ref2) {
        var props = _ref2.props;
        !$e9d71c4f80416d0e$var$isBoolean(props.isDropDisabled) && $e9d71c4f80416d0e$var$invariant(false);
        !$e9d71c4f80416d0e$var$isBoolean(props.isCombineEnabled) && $e9d71c4f80416d0e$var$invariant(false);
        !$e9d71c4f80416d0e$var$isBoolean(props.ignoreContainerClipping) && $e9d71c4f80416d0e$var$invariant(false);
    },
    function ref(_ref3) {
        var getDroppableRef = _ref3.getDroppableRef;
        $e9d71c4f80416d0e$var$checkIsValidInnerRef(getDroppableRef());
    }
];
var $e9d71c4f80416d0e$var$standard = [
    function placeholder(_ref4) {
        var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
        if (!props.placeholder) return;
        var ref = getPlaceholderRef();
        if (ref) return;
    }
];
var $e9d71c4f80416d0e$var$virtual = [
    function hasClone(_ref5) {
        var props = _ref5.props;
        !props.renderClone && $e9d71c4f80416d0e$var$invariant(false);
    },
    function hasNoPlaceholder(_ref6) {
        var getPlaceholderRef = _ref6.getPlaceholderRef;
        !!getPlaceholderRef() && $e9d71c4f80416d0e$var$invariant(false);
    }
];
function $e9d71c4f80416d0e$var$useValidation(args) {
    $e9d71c4f80416d0e$var$useDevSetupWarning(function() {
        $e9d71c4f80416d0e$var$runChecks(args, $e9d71c4f80416d0e$var$shared);
        if (args.props.mode === "standard") $e9d71c4f80416d0e$var$runChecks(args, $e9d71c4f80416d0e$var$standard);
        if (args.props.mode === "virtual") $e9d71c4f80416d0e$var$runChecks(args, $e9d71c4f80416d0e$var$virtual);
    });
}
var $e9d71c4f80416d0e$var$AnimateInOut = function(_React$PureComponent) {
    (0, $6690d7c47859749b$export$2e2bcd8739ae039)(AnimateInOut, _React$PureComponent);
    function AnimateInOut() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$PureComponent.call.apply(_React$PureComponent, [
            this
        ].concat(args)) || this;
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? "open" : "none"
        };
        _this.onClose = function() {
            if (_this.state.animate !== "close") return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: "none"
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: "open"
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: "close"
        };
        return {
            isVisible: false,
            animate: "close",
            data: null
        };
    };
    var _proto = AnimateInOut.prototype;
    _proto.render = function render() {
        if (!this.state.isVisible) return null;
        var provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    };
    return AnimateInOut;
}((0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).PureComponent);
var $e9d71c4f80416d0e$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var $e9d71c4f80416d0e$var$getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
    if (dropping) return $e9d71c4f80416d0e$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $e9d71c4f80416d0e$var$transitions.snap;
    return $e9d71c4f80416d0e$var$transitions.fluid;
};
var $e9d71c4f80416d0e$var$getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
    if (!isCombining) return null;
    return isDropAnimating ? $e9d71c4f80416d0e$var$combine.opacity.drop : $e9d71c4f80416d0e$var$combine.opacity.combining;
};
var $e9d71c4f80416d0e$var$getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === "SNAP";
};
function $e9d71c4f80416d0e$var$getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = $e9d71c4f80416d0e$var$getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? $e9d71c4f80416d0e$var$transforms.drop(offset, isCombining) : $e9d71c4f80416d0e$var$transforms.moveTo(offset);
    var style = {
        position: "fixed",
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: "border-box",
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $e9d71c4f80416d0e$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $e9d71c4f80416d0e$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $e9d71c4f80416d0e$var$zIndexOptions.dropAnimating : $e9d71c4f80416d0e$var$zIndexOptions.dragging,
        pointerEvents: "none"
    };
    return style;
}
function $e9d71c4f80416d0e$var$getSecondaryStyle(secondary) {
    return {
        transform: $e9d71c4f80416d0e$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? null : "none"
    };
}
function $e9d71c4f80416d0e$var$getStyle$1(mapped) {
    return mapped.type === "DRAGGING" ? $e9d71c4f80416d0e$var$getDraggingStyle(mapped) : $e9d71c4f80416d0e$var$getSecondaryStyle(mapped);
}
function $e9d71c4f80416d0e$var$getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = $e9d71c4f80416d0e$var$origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, $23492784bb53e9d7$export$b8dfc5d4e552b8e1)(borderBox, computedStyles);
    var page = (0, $23492784bb53e9d7$export$1d0caec378d7d0ae)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $e9d71c4f80416d0e$var$useDraggablePublisher(args) {
    var uniqueId = $e9d71c4f80416d0e$var$useUniqueId("draggable");
    var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
    var options = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return {
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        };
    }, [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    var getDimension = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function(windowScroll) {
        var el = getDraggableRef();
        !el && $e9d71c4f80416d0e$var$invariant(false);
        return $e9d71c4f80416d0e$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    var entry = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        };
    }, [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    var publishedRef = (0, $4RFnf.useRef)(entry);
    var isFirstPublishRef = (0, $4RFnf.useRef)(true);
    $e9d71c4f80416d0e$var$useIsomorphicLayoutEffect(function() {
        registry.draggable.register(publishedRef.current);
        return function() {
            return registry.draggable.unregister(publishedRef.current);
        };
    }, [
        registry.draggable
    ]);
    $e9d71c4f80416d0e$var$useIsomorphicLayoutEffect(function() {
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        var last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
function $e9d71c4f80416d0e$var$useValidation$1(props, contextId, getRef) {
    $e9d71c4f80416d0e$var$useDevSetupWarning(function() {
        function prefix(id) {
            return "Draggable[id: " + id + "]: ";
        }
        var id = props.draggableId;
        !id && $e9d71c4f80416d0e$var$invariant(false);
        !(typeof id === "string") && $e9d71c4f80416d0e$var$invariant(false);
        !$e9d71c4f80416d0e$var$isInteger(props.index) && $e9d71c4f80416d0e$var$invariant(false);
        if (props.mapped.type === "DRAGGING") return;
        $e9d71c4f80416d0e$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$e9d71c4f80416d0e$var$findDragHandle(contextId, id) && $e9d71c4f80416d0e$var$invariant(false);
    });
}
function $e9d71c4f80416d0e$var$useClonePropValidation(isClone) {
    $e9d71c4f80416d0e$var$useDev(function() {
        var initialRef = (0, $4RFnf.useRef)(isClone);
        $e9d71c4f80416d0e$var$useDevSetupWarning(function() {
            !(isClone === initialRef.current) && $e9d71c4f80416d0e$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $e9d71c4f80416d0e$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
function $e9d71c4f80416d0e$var$Draggable(props) {
    var ref = (0, $4RFnf.useRef)(null);
    var setRef = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function(el) {
        ref.current = el;
    }, []);
    var getRef = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        return ref.current;
    }, []);
    var _useRequiredContext = $e9d71c4f80416d0e$var$useRequiredContext($e9d71c4f80416d0e$var$AppContext), contextId = _useRequiredContext.contextId, dragHandleUsageInstructionsId = _useRequiredContext.dragHandleUsageInstructionsId, registry = _useRequiredContext.registry;
    var _useRequiredContext2 = $e9d71c4f80416d0e$var$useRequiredContext($e9d71c4f80416d0e$var$DroppableContext), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
    var descriptor = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return {
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        };
    }, [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
    $e9d71c4f80416d0e$var$useValidation$1(props, contextId, getRef);
    $e9d71c4f80416d0e$var$useClonePropValidation(isClone);
    if (!isClone) {
        var forPublisher = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
            return {
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $e9d71c4f80416d0e$var$useDraggablePublisher(forPublisher);
    }
    var dragHandleProps = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return isEnabled ? {
            tabIndex: 0,
            role: "button",
            "aria-describedby": dragHandleUsageInstructionsId,
            "data-rbd-drag-handle-draggable-id": draggableId,
            "data-rbd-drag-handle-context-id": contextId,
            draggable: false,
            onDragStart: $e9d71c4f80416d0e$var$preventHtml5Dnd
        } : null;
    }, [
        contextId,
        dragHandleUsageInstructionsId,
        draggableId,
        isEnabled
    ]);
    var onMoveEnd = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function(event) {
        if (mapped.type !== "DRAGGING") return;
        if (!mapped.dropping) return;
        if (event.propertyName !== "transform") return;
        dropAnimationFinishedAction();
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        var style = $e9d71c4f80416d0e$var$getStyle$1(mapped);
        var onTransitionEnd = mapped.type === "DRAGGING" && mapped.dropping ? onMoveEnd : null;
        var result = {
            innerRef: setRef,
            draggableProps: {
                "data-rbd-draggable-context-id": contextId,
                "data-rbd-draggable-id": draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    var rubric = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    }, [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return children(provided, mapped.snapshot, rubric);
}
var $e9d71c4f80416d0e$var$isStrictEqual = function(a, b) {
    return a === b;
};
var $e9d71c4f80416d0e$var$whatIsDraggedOverFromResult = function(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var $e9d71c4f80416d0e$var$getCombineWithFromResult = function getCombineWithFromResult(result) {
    return result.combine ? result.combine.draggableId : null;
};
var $e9d71c4f80416d0e$var$getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
    return impact.at && impact.at.type === "COMBINE" ? impact.at.combine.draggableId : null;
};
function $e9d71c4f80416d0e$var$getDraggableSelector() {
    var memoizedOffset = (0, $7ecb05d430698c92$export$2e2bcd8739ae039)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $7ecb05d430698c92$export$2e2bcd8739ae039)(function(mode, isClone, draggingOver, combineWith, dropping) {
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getMemoizedProps = (0, $7ecb05d430698c92$export$2e2bcd8739ae039)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
        return {
            mapped: {
                type: "DRAGGING",
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var draggingOver = $e9d71c4f80416d0e$var$whatIsDraggedOver(state.impact);
            var combineWith = $e9d71c4f80416d0e$var$getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var isClone = ownProps.isClone;
            var _dimension = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var mode = result.mode;
            var _draggingOver = $e9d71c4f80416d0e$var$whatIsDraggedOverFromResult(result);
            var _combineWith = $e9d71c4f80416d0e$var$getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: $e9d71c4f80416d0e$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: _combineWith ? $e9d71c4f80416d0e$var$combine.opacity.drop : null,
                scale: _combineWith ? $e9d71c4f80416d0e$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: "DRAGGING",
                    offset: state.newHomeClientOffset,
                    dimension: _dimension,
                    dropping: dropping,
                    draggingOver: _draggingOver,
                    combineWith: _combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $e9d71c4f80416d0e$var$getSecondarySnapshot(combineTargetFor) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
var $e9d71c4f80416d0e$var$atRest = {
    mapped: {
        type: "SECONDARY",
        offset: $e9d71c4f80416d0e$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $e9d71c4f80416d0e$var$getSecondarySnapshot(null)
    }
};
function $e9d71c4f80416d0e$var$getSecondarySelector() {
    var memoizedOffset = (0, $7ecb05d430698c92$export$2e2bcd8739ae039)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $7ecb05d430698c92$export$2e2bcd8739ae039)($e9d71c4f80416d0e$var$getSecondarySnapshot);
    var getMemoizedProps = (0, $7ecb05d430698c92$export$2e2bcd8739ae039)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: "SECONDARY",
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    var getFallback = function getFallback(combineTargetFor) {
        return combineTargetFor ? getMemoizedProps($e9d71c4f80416d0e$var$origin, combineTargetFor, true) : null;
    };
    var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
        var visualDisplacement = impact.displaced.visible[ownId];
        var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        var combine = $e9d71c4f80416d0e$var$tryGetCombine(impact);
        var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            var change = $e9d71c4f80416d0e$var$negate(afterCritical.displacedBy.point);
            var _offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(_offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        var displaceBy = impact.displacedBy.point;
        var offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
var $e9d71c4f80416d0e$var$makeMapStateToProps = function makeMapStateToProps() {
    var draggingSelector = $e9d71c4f80416d0e$var$getDraggableSelector();
    var secondarySelector = $e9d71c4f80416d0e$var$getSecondarySelector();
    var selector = function selector(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $e9d71c4f80416d0e$var$atRest;
    };
    return selector;
};
var $e9d71c4f80416d0e$var$mapDispatchToProps = {
    dropAnimationFinished: $e9d71c4f80416d0e$var$dropAnimationFinished
};
var $e9d71c4f80416d0e$var$ConnectedDraggable = (0, $21fa3a388fd530f0$export$2e2bcd8739ae039)($e9d71c4f80416d0e$var$makeMapStateToProps, $e9d71c4f80416d0e$var$mapDispatchToProps, null, {
    context: $e9d71c4f80416d0e$var$StoreContext,
    pure: true,
    areStatePropsEqual: $e9d71c4f80416d0e$var$isStrictEqual
})($e9d71c4f80416d0e$var$Draggable);
function $e9d71c4f80416d0e$var$PrivateDraggable(props) {
    var droppableContext = $e9d71c4f80416d0e$var$useRequiredContext($e9d71c4f80416d0e$var$DroppableContext);
    var isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createElement($e9d71c4f80416d0e$var$ConnectedDraggable, props);
}
function $e9d71c4f80416d0e$export$f2a139e5d18b9882(props) {
    var isEnabled = typeof props.isDragDisabled === "boolean" ? !props.isDragDisabled : true;
    var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createElement($e9d71c4f80416d0e$var$PrivateDraggable, (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
function $e9d71c4f80416d0e$var$Droppable(props) {
    var appContext = (0, $4RFnf.useContext)($e9d71c4f80416d0e$var$AppContext);
    !appContext && $e9d71c4f80416d0e$var$invariant(false);
    var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, $4RFnf.useRef)(null);
    var placeholderRef = (0, $4RFnf.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
    var getDroppableRef = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        return droppableRef.current;
    }, []);
    var setDroppableRef = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function(value) {
        droppableRef.current = value;
    }, []);
    var getPlaceholderRef = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        return placeholderRef.current;
    }, []);
    var setPlaceholderRef = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function(value) {
        placeholderRef.current = value;
    }, []);
    $e9d71c4f80416d0e$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var onPlaceholderTransitionEnd = (0, $e4b050ab5f92332c$export$35808ee640e87ca7)(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $e9d71c4f80416d0e$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $e9d71c4f80416d0e$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    var placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createElement($e9d71c4f80416d0e$var$AnimateInOut, {
        on: props.placeholder,
        shouldAnimate: props.shouldAnimatePlaceholder
    }, function(_ref) {
        var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
        return (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createElement($e9d71c4f80416d0e$var$Placeholder$1, {
            placeholder: data,
            onClose: onClose,
            innerRef: setPlaceholderRef,
            animate: animate,
            contextId: contextId,
            onTransitionEnd: onPlaceholderTransitionEnd
        });
    });
    var provided = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                "data-rbd-droppable-id": droppableId,
                "data-rbd-droppable-context-id": contextId
            }
        };
    }, [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    var droppableContext = (0, $e4b050ab5f92332c$export$1538c33de8887b59)(function() {
        return {
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        };
    }, [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        var dragging = useClone.dragging, render = useClone.render;
        var node = (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createElement($e9d71c4f80416d0e$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, function(draggableProvided, draggableSnapshot) {
            return render(draggableProvided, draggableSnapshot, dragging);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($6ce1434187f7101c$exports))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($4RFnf))).createElement($e9d71c4f80416d0e$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
}
var $e9d71c4f80416d0e$var$isMatchingType = function isMatchingType(type, critical) {
    return type === critical.droppable.type;
};
var $e9d71c4f80416d0e$var$getDraggable = function getDraggable(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var $e9d71c4f80416d0e$var$makeMapStateToProps$1 = function makeMapStateToProps() {
    var idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    var idleWithoutAnimation = (0, $c8d7680d3e4d6453$export$2e2bcd8739ae039)({}, idleWithAnimation, {
        shouldAnimatePlaceholder: false
    });
    var getDraggableRubric = (0, $7ecb05d430698c92$export$2e2bcd8739ae039)(function(descriptor) {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    });
    var getMapProps = (0, $7ecb05d430698c92$export$2e2bcd8739ae039)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            var useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            var _snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: _snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        var snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    var selector = function selector(state, ownProps) {
        var id = ownProps.droppableId;
        var type = ownProps.type;
        var isEnabled = !ownProps.isDropDisabled;
        var renderClone = ownProps.renderClone;
        if (state.isDragging) {
            var critical = state.critical;
            if (!$e9d71c4f80416d0e$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            var dragging = $e9d71c4f80416d0e$var$getDraggable(critical, state.dimensions);
            var isDraggingOver = $e9d71c4f80416d0e$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (!$e9d71c4f80416d0e$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            var _dragging = $e9d71c4f80416d0e$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $e9d71c4f80416d0e$var$whatIsDraggedOverFromResult(completed.result) === id, $e9d71c4f80416d0e$var$whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
        }
        if (state.phase === "IDLE" && state.completed && !state.shouldFlush) {
            var _completed = state.completed;
            if (!$e9d71c4f80416d0e$var$isMatchingType(type, _completed.critical)) return idleWithoutAnimation;
            var wasOver = $e9d71c4f80416d0e$var$whatIsDraggedOver(_completed.impact) === id;
            var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === "COMBINE");
            var isHome = _completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
var $e9d71c4f80416d0e$var$mapDispatchToProps$1 = {
    updateViewportMaxScroll: $e9d71c4f80416d0e$var$updateViewportMaxScroll
};
function $e9d71c4f80416d0e$var$getBody() {
    !document.body && $e9d71c4f80416d0e$var$invariant(false);
    return document.body;
}
var $e9d71c4f80416d0e$var$defaultProps = {
    mode: "standard",
    type: "DEFAULT",
    direction: "vertical",
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $e9d71c4f80416d0e$var$getBody
};
var $e9d71c4f80416d0e$export$423ec2075359570a = (0, $21fa3a388fd530f0$export$2e2bcd8739ae039)($e9d71c4f80416d0e$var$makeMapStateToProps$1, $e9d71c4f80416d0e$var$mapDispatchToProps$1, null, {
    context: $e9d71c4f80416d0e$var$StoreContext,
    pure: true,
    areStatePropsEqual: $e9d71c4f80416d0e$var$isStrictEqual
})($e9d71c4f80416d0e$var$Droppable);
$e9d71c4f80416d0e$export$423ec2075359570a.defaultProps = $e9d71c4f80416d0e$var$defaultProps;



const $6dced8dfb7696b2d$var$ContentBlock = ()=>{
    const editedBlog = (0, $99aed3ab2dc6c7d9$export$2105062e25df4afe)((state)=>state.blog.editedBlog);
    const dispatch = (0, $99aed3ab2dc6c7d9$export$8ad76b76a4c905f8)();
    const handleDragEnd = (result)=>{
        if (!result.destination) return;
        const reorderedBlocks = Array.from(editedBlog.contentBlocks);
        const [movedBlock] = reorderedBlocks.splice(result.source.index, 1);
        reorderedBlocks.splice(result.destination.index, 0, movedBlock);
        dispatch((0, $69f4e9eaa71aaec3$export$3c22e49343768f0d)(reorderedBlocks));
    };
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $e9d71c4f80416d0e$export$237bd83162c14364), {
        onDragEnd: handleDragEnd,
        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $e9d71c4f80416d0e$export$423ec2075359570a), {
            droppableId: "contentBlocks",
            children: (provided)=>/*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                    ...provided.droppableProps,
                    ref: provided.innerRef,
                    children: [
                        editedBlog?.contentBlocks?.map((contentBlock, index)=>/*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $e9d71c4f80416d0e$export$f2a139e5d18b9882), {
                                draggableId: contentBlock._id,
                                index: index,
                                children: (provided)=>/*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                                        ref: provided.innerRef,
                                        ...provided.draggableProps,
                                        ...provided.dragHandleProps,
                                        className: "mx-auto px-4 w-full dark:bg-[#2222222d] rounded-xl p-6 border border-gray-200 dark:border-0 mb-6",
                                        children: contentBlock?.type === "text" ? /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $889a70f304b7970e$export$2e2bcd8739ae039), {
                                            contentBlock: contentBlock
                                        }) : /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $c0c7719e62524337$export$2e2bcd8739ae039), {
                                            contentBlock: contentBlock
                                        })
                                    })
                            }, contentBlock._id)),
                        provided.placeholder
                    ]
                })
        })
    });
};
var $6dced8dfb7696b2d$export$2e2bcd8739ae039 = $6dced8dfb7696b2d$var$ContentBlock;



var $4RFnf = parcelRequire("4RFnf");




class $13d928cdc4343aa2$export$b9721ef022f71a68 extends Error {
}
$13d928cdc4343aa2$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $13d928cdc4343aa2$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $13d928cdc4343aa2$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $13d928cdc4343aa2$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $13d928cdc4343aa2$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $13d928cdc4343aa2$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $13d928cdc4343aa2$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $13d928cdc4343aa2$var$base64UrlDecode(part);
    } catch (e) {
        throw new $13d928cdc4343aa2$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $13d928cdc4343aa2$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}


const $0c03d9e093a5cbe9$export$84773cc9bf7dbe87 = ()=>localStorage.getItem("accessToken");
const $0c03d9e093a5cbe9$export$9bfe7023cfca0786 = (token)=>localStorage.setItem("accessToken", token);
const $0c03d9e093a5cbe9$export$6f7d274070c97d7 = ()=>localStorage.removeItem("accessToken");
const $0c03d9e093a5cbe9$export$1c3df4d50873ab4b = ()=>document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*=\s*([^;]*).*$)|^.*$/, "$1");
const $0c03d9e093a5cbe9$export$b007d77a962aa175 = (token)=>{
    if (!token) return true;
    const { exp: exp } = (0, $13d928cdc4343aa2$export$fa1e2fb699b7861e)(token);
    return Date.now() >= exp * 1000;
};




const $6dff2692fb74e3ff$var$customFetch = async (url, options = {})=>{
    var token = (0, $0c03d9e093a5cbe9$export$84773cc9bf7dbe87)();
    if ((0, $0c03d9e093a5cbe9$export$b007d77a962aa175)(token)) {
        token = (0, $40f37ebd723a2bb1$export$f8f36faf9a051362)();
        if (!token) {
            window.location.href = "/login";
            return;
        }
    }
    options.headers = {
        ...options.headers,
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
    };
    return await fetch(url, options);
};
var $6dff2692fb74e3ff$export$2e2bcd8739ae039 = $6dff2692fb74e3ff$var$customFetch;


const $40f37ebd723a2bb1$export$f8f36faf9a051362 = async ()=>{
    const response = await fetch((0, $949f23ee69f32f96$export$2a2261c5a58ac0), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include"
    });
    if (response.ok) {
        const data = await response.json();
        (0, $0c03d9e093a5cbe9$export$9bfe7023cfca0786)(data.accessToken);
        return data.accessToken;
    } else (0, $0c03d9e093a5cbe9$export$6f7d274070c97d7)();
    return null;
};
const $40f37ebd723a2bb1$var$createBlog = async (editedBlog, publish)=>{
    const response = await (0, $6dff2692fb74e3ff$export$2e2bcd8739ae039)((0, $949f23ee69f32f96$export$33946c87f7d00129), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            ...editedBlog,
            published: publish
        })
    });
    console.log("API create response", response);
    return response;
};
const $40f37ebd723a2bb1$var$updateBlog = async (editedBlog, publish)=>{
    const response = await (0, $6dff2692fb74e3ff$export$2e2bcd8739ae039)(`${(0, $949f23ee69f32f96$export$33946c87f7d00129)}/${editedBlog._id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            ...editedBlog,
            published: publish
        })
    });
    console.log("API update response", response);
    return response;
};
const $40f37ebd723a2bb1$export$fb5500896bf9f887 = async ({ editedBlog: editedBlog, publish: publish })=>{
    console.log(JSON.stringify({
        ...editedBlog,
        published: publish
    }));
    if (!editedBlog._id) return await $40f37ebd723a2bb1$var$createBlog(editedBlog, publish);
    else return await $40f37ebd723a2bb1$var$updateBlog(editedBlog, publish);
};


const $9fcaf3c5952e7598$var$BlogContent = ()=>{
    const { darkMode: darkMode } = (0, $4RFnf.useContext)((0, $1039ae88e8de639f$export$2e2bcd8739ae039));
    const dispatch = (0, $99aed3ab2dc6c7d9$export$8ad76b76a4c905f8)();
    const [blockType, setBlockType] = (0, $4RFnf.useState)("text");
    const editedBlog = (0, $99aed3ab2dc6c7d9$export$2105062e25df4afe)((state)=>state.blog.editedBlog);
    const { id: id } = (0, $2dda13c5d6544900$export$99eaa27ddbbb95ef)();
    const navigate = (0, $2dda13c5d6544900$export$9770f232ac06a008)();
    const handleSaveBlog = async (publish)=>{
        var response = await (0, $40f37ebd723a2bb1$export$fb5500896bf9f887)({
            editedBlog: editedBlog,
            publish: publish
        });
        if (!response.ok) {
            alert("Error saving blog");
            return;
        } else {
            alert("Blog saved successfully");
            if (!id) {
                var data = await response.json();
                navigate(`/blog/edit/${data._id}`, {
                    replace: true
                });
            }
        }
    };
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $6dced8dfb7696b2d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                className: "flex my-5",
                children: [
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("select", {
                        onChange: (e)=>setBlockType(e.target.value),
                        className: "border-2 mr-3 border-gray-300 p-2 w-32 rounded-lg",
                        children: [
                            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("option", {
                                value: "text",
                                children: "Text"
                            }),
                            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("option", {
                                value: "image",
                                children: "Image"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("i", {
                        onClick: ()=>dispatch((0, $69f4e9eaa71aaec3$export$af077dbfc4682e93)({
                                type: blockType,
                                content: ""
                            })),
                        className: "fas fa-plus-circle fa-2x cursor-pointer",
                        style: {
                            color: darkMode ? "green" : "green"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                className: "mt-6 flex space-x-4",
                children: [
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("button", {
                        onClick: ()=>handleSaveBlog(false),
                        className: "flex-1 bg-gray-800 text-white py-3 rounded-lg shadow-md hover:bg-gray-700 transition-all duration-300 dark:bg-gray-700 dark:hover:bg-gray-600",
                        children: "Save Draft"
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("button", {
                        onClick: ()=>handleSaveBlog(true),
                        className: "flex-1 bg-gray-800 text-white py-3 rounded-lg shadow-md hover:bg-gray-700 transition-all duration-300 dark:bg-gray-700 dark:hover:bg-gray-600",
                        children: "Publish"
                    })
                ]
            })
        ]
    });
};
var $9fcaf3c5952e7598$export$2e2bcd8739ae039 = $9fcaf3c5952e7598$var$BlogContent;





const $19eb873cca86fff3$var$PreviewImageEditor = ()=>{
    const dispatch = (0, $99aed3ab2dc6c7d9$export$8ad76b76a4c905f8)();
    const editedBlog = (0, $99aed3ab2dc6c7d9$export$2105062e25df4afe)((state)=>state.blog.editedBlog);
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        className: "mb-5",
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("label", {
                className: "block text-gray-700 dark:text-gray-300 text-sm font-bold mb-2",
                children: "Preview Image"
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("input", {
                type: "text",
                value: editedBlog?.image,
                onChange: (e)=>dispatch((0, $69f4e9eaa71aaec3$export$afbaf9de62621d7b)(e.target.value)),
                className: "border-2 border-gray-300 dark:border-gray-700 p-2 w-full rounded-lg focus:outline-none focus:border-blue-500",
                placeholder: "Enter the image url"
            })
        ]
    });
};
var $19eb873cca86fff3$export$2e2bcd8739ae039 = $19eb873cca86fff3$var$PreviewImageEditor;






const $b68d8117a1466081$var$KeywordsEditor = ()=>{
    const dispatch = (0, $99aed3ab2dc6c7d9$export$8ad76b76a4c905f8)();
    const editedBlog = (0, $99aed3ab2dc6c7d9$export$2105062e25df4afe)((state)=>state.blog.editedBlog);
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        className: "mb-5",
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("label", {
                className: "block text-gray-700 dark:text-gray-300 text-sm font-bold mb-2",
                children: "Keywords"
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("input", {
                type: "text",
                value: editedBlog?.keywords,
                onChange: (e)=>dispatch((0, $69f4e9eaa71aaec3$export$9c6f66d1d405561d)(e.target.value)),
                className: "border-2 border-gray-300 dark:border-gray-700 p-2 w-full rounded-lg focus:outline-none focus:border-blue-500",
                placeholder: "Enter comma-separated keywords"
            })
        ]
    });
};
var $b68d8117a1466081$export$2e2bcd8739ae039 = $b68d8117a1466081$var$KeywordsEditor;


const $67d4a50afd70a8e7$var$BlogEditHome = ()=>{
    const navigate = (0, $2dda13c5d6544900$export$9770f232ac06a008)();
    const { titleAndId: titleAndId } = (0, $2dda13c5d6544900$export$99eaa27ddbbb95ef)();
    const id = titleAndId?.split("-").pop();
    const dispatch = (0, $99aed3ab2dc6c7d9$export$8ad76b76a4c905f8)();
    const editedBlog = (0, $99aed3ab2dc6c7d9$export$2105062e25df4afe)((state)=>state.blog.editedBlog);
    const handlePreviewClick = async ()=>{
        var response = await (0, $40f37ebd723a2bb1$export$fb5500896bf9f887)({
            editedBlog: editedBlog,
            publish: false
        });
        console.log("response", response);
        if (!response.ok) return;
        else if (!id) {
            var data = await response.json();
            console.log("Redirecting to neww preview", data._id);
            navigate(`/blog/edit/${data._id}/preview`, {
                replace: true
            });
        } else {
            console.log("Redirecting to preview");
            navigate(`preview`);
        }
    };
    (0, $4RFnf.useEffect)(()=>{
        if (titleAndId) getBlog();
        else dispatch((0, $69f4e9eaa71aaec3$export$a36094bd725add13)({
            title: "New Blog",
            description: "Some description",
            author: "Damyant Jain"
        }));
        return ()=>{
            dispatch((0, $69f4e9eaa71aaec3$export$b1e61d1688165092)());
        };
    }, []);
    const getBlog = async ()=>{
        var response = await fetch(`${(0, $949f23ee69f32f96$export$33946c87f7d00129)}/${id}`);
        if (!response.ok) {
            console.error("Blog not found");
            return;
        }
        var data = await response.json();
        dispatch((0, $69f4e9eaa71aaec3$export$a36094bd725add13)(data));
    };
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        className: "mx-5 md:mx-16 lg:mx-32 xl:mx-44 dark:bg-[#121212] min-h-screen",
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                className: "flex justify-between items-center mb-5",
                children: [
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("h1", {
                        className: "text-2xl font-bold text-gray-800 dark:text-gray-200",
                        children: "Edit Blog"
                    }),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("button", {
                        onClick: handlePreviewClick,
                        className: "bg-gray-800 py-2 px-3 text-white rounded-lg shadow-md hover:bg-gray-700 transition-all duration-300 dark:bg-gray-700 dark:hover:bg-gray-600",
                        children: "Save & Preview"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                className: "mx-auto px-4 w-full dark:bg-[#2222222d] rounded-xl p-6 border border-gray-200 dark:border-0 mb-6",
                children: [
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $c54a04eed4aca5e2$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $b3f9c969751deef6$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $19eb873cca86fff3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $b68d8117a1466081$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $9fcaf3c5952e7598$export$2e2bcd8739ae039), {})
        ]
    });
};
var $67d4a50afd70a8e7$export$2e2bcd8739ae039 = $67d4a50afd70a8e7$var$BlogEditHome;







var $4RFnf = parcelRequire("4RFnf");

const $cb8bcdef2efebaa9$var$ProtectedComponent = ({ children: children })=>{
    const [isAuthenticated, setIsAuthenticated] = (0, $4RFnf.useState)(false);
    const [isLoading, setIsLoading] = (0, $4RFnf.useState)(true);
    (0, $4RFnf.useEffect)(()=>{
        const checkToken = async ()=>{
            let token = (0, $0c03d9e093a5cbe9$export$84773cc9bf7dbe87)();
            if ((0, $0c03d9e093a5cbe9$export$b007d77a962aa175)(token)) {
                token = await (0, $40f37ebd723a2bb1$export$f8f36faf9a051362)();
                if (!token) {
                    setIsAuthenticated(false);
                    setIsLoading(false);
                    return;
                }
            }
            setIsAuthenticated(true);
            setIsLoading(false);
        };
        checkToken();
    }, []);
    if (isLoading) return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
        children: "Loading..."
    });
    return isAuthenticated ? children : /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $2dda13c5d6544900$export$444b3ab0cb9aec40), {
        to: "/blog/login"
    });
};
var $cb8bcdef2efebaa9$export$2e2bcd8739ae039 = $cb8bcdef2efebaa9$var$ProtectedComponent;




var $4RFnf = parcelRequire("4RFnf");

var $dTaMq = parcelRequire("dTaMq");
const $04854254ba2703ee$export$5b0f6292f11d1d18 = (data)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($dTaMq))).AES.encrypt(data, "thebloominggarden").toString();
};
const $04854254ba2703ee$export$e85a0c9a1067c5d3 = (data)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($dTaMq))).AES.decrypt(data, "thebloominggarden").toString((0, (/*@__PURE__*/$parcel$interopDefault($dTaMq))).enc.Utf8);
};





const $9b4e1e667bfb4488$var$Login = ()=>{
    const [username, setUsername] = (0, $4RFnf.useState)("");
    const [password, setPassword] = (0, $4RFnf.useState)("");
    const navigate = (0, $2dda13c5d6544900$export$9770f232ac06a008)();
    const handleLoginClick = async ()=>{
        const encryptedPassword = (0, $04854254ba2703ee$export$5b0f6292f11d1d18)(password);
        const encryptedUsername = (0, $04854254ba2703ee$export$5b0f6292f11d1d18)(username);
        const response = await fetch((0, $949f23ee69f32f96$export$86dcaf45db3d1606), {
            method: "POST",
            body: JSON.stringify({
                username: encryptedUsername,
                password: encryptedPassword
            }),
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            }
        });
        if (response.ok) {
            const body = await response.json();
            (0, $0c03d9e093a5cbe9$export$9bfe7023cfca0786)(body.accessToken);
            clearFields();
            navigate("/blog/edit");
        } else {
            setPassword("");
            showMessage("Login failed");
        }
    };
    const clearFields = ()=>{
        setUsername("");
        setPassword("");
    };
    const showMessage = (message)=>{
        alert(message);
    };
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
        className: "flex items-center flex-col",
        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
            className: "rounded-lg dark:bg-inherit text-right",
            children: [
                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                    className: "font-poppins text-center mb-10 mt-6 text-2xl text-[#333333] dark:text-[#e0e0e0]",
                    children: "Reads"
                }),
                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("input", {
                    type: "text",
                    value: username,
                    onChange: (e)=>setUsername(e.target.value),
                    placeholder: "Username",
                    className: "mb-4 px-3 py-2 w-72 font-opensans rounded-lg ring-1 ring-gray-300"
                }),
                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("input", {
                    type: "password",
                    value: password,
                    onChange: (e)=>setPassword(e.target.value),
                    placeholder: "Password",
                    className: "mb-4 px-3 py-2 w-72 font-opensans rounded-lg ring-1 ring-gray-300"
                }),
                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("button", {
                    onClick: ()=>handleLoginClick(),
                    className: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded",
                    children: "Login"
                })
            ]
        })
    });
};
var $9b4e1e667bfb4488$export$2e2bcd8739ae039 = $9b4e1e667bfb4488$var$Login;




const $c2a43e1ee111da5a$var$BlogPreview = ()=>{
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                className: "w-full flex items-center justify-center",
                children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                    className: " bg-[#feeb73] text-xl text-[#333333] text-center md:mx-0 sm:mx-10 mx-5 w-full md:w-[680px]",
                    children: "This is just a preview of the blog."
                })
            }),
            /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $3ae5dfd3aef929fc$export$2e2bcd8739ae039), {})
        ]
    });
};
var $c2a43e1ee111da5a$export$2e2bcd8739ae039 = $c2a43e1ee111da5a$var$BlogPreview;




var $4RFnf = parcelRequire("4RFnf");




const $5b0e984e47f5bd60$var$BlogEditHome = ({ mode: mode })=>{
    const [posts, setPosts] = (0, $4RFnf.useState)([]);
    const navigate = (0, $2dda13c5d6544900$export$9770f232ac06a008)();
    (0, $4RFnf.useEffect)(()=>{
        getBlogs();
    }, []);
    const getBlogs = async ()=>{
        var response = await (0, $6dff2692fb74e3ff$export$2e2bcd8739ae039)((0, $949f23ee69f32f96$export$33946c87f7d00129));
        if (!response.ok) {
            setPosts([]);
            return;
        } else {
            var data = await response.json();
            setPosts(data);
        }
    };
    const handleNewBlog = ()=>{
        navigate(`/blog/edit/new`);
    };
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
            className: "mx-5 md:mx-16 lg:mx-32 xl:mx-44",
            children: [
                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsxs)("div", {
                    className: "flex justify-between items-start  mt-5 mb-10",
                    children: [
                        /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("h1", {
                            className: "text-xl md:text-2xl text-[#333333] dark:text-[#e0e0e0] font-poppins",
                            children: "Edit Blog"
                        }),
                        /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("button", {
                            onClick: handleNewBlog,
                            className: "bg-gray-800 py-2 px-3 text-white rounded-lg shadow-md hover:bg-gray-700 transition-all duration-300 dark:bg-gray-700 dark:hover:bg-gray-600",
                            children: "New Blog"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $9c54885fd1343cb6$export$2e2bcd8739ae039), {
                    posts: posts
                })
            ]
        })
    });
};
var $5b0e984e47f5bd60$export$2e2bcd8739ae039 = $5b0e984e47f5bd60$var$BlogEditHome;


const $a57ad15b73d7f8c0$var$blogRoute = {
    path: "blog",
    element: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $ef26f297f078fa4a$export$2e2bcd8739ae039), {}),
    children: [
        {
            path: "",
            element: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $554228b811351d1d$export$2e2bcd8739ae039), {})
        },
        {
            path: "login",
            element: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $9b4e1e667bfb4488$export$2e2bcd8739ae039), {})
        },
        {
            path: "edit",
            children: [
                {
                    path: "",
                    element: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $cb8bcdef2efebaa9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $5b0e984e47f5bd60$export$2e2bcd8739ae039), {})
                    })
                },
                {
                    path: "new",
                    element: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $cb8bcdef2efebaa9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $67d4a50afd70a8e7$export$2e2bcd8739ae039), {})
                    })
                },
                {
                    path: ":titleAndId",
                    children: [
                        {
                            path: "",
                            element: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $cb8bcdef2efebaa9$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $67d4a50afd70a8e7$export$2e2bcd8739ae039), {})
                            })
                        },
                        {
                            path: "preview",
                            element: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $cb8bcdef2efebaa9$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $c2a43e1ee111da5a$export$2e2bcd8739ae039), {})
                            })
                        }
                    ]
                }
            ]
        },
        {
            path: ":titleAndId",
            element: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $3ae5dfd3aef929fc$export$2e2bcd8739ae039), {})
        }
    ]
};
var $a57ad15b73d7f8c0$export$2e2bcd8739ae039 = $a57ad15b73d7f8c0$var$blogRoute;






const $ec6ccf0ccbb770a1$var$appStore = (0, $6d3bbb1da5d24806$export$7d8a5b498da695ac)({
    reducer: {
        blog: (0, $69f4e9eaa71aaec3$export$2e2bcd8739ae039)
    }
});
var $ec6ccf0ccbb770a1$export$2e2bcd8739ae039 = $ec6ccf0ccbb770a1$var$appStore;



const $3c1483f93957eaf7$var$AppLayout = ()=>{
    const getInitialMode = ()=>{
        return JSON.parse(localStorage.getItem("dark"));
    };
    const [darkMode, setDarkMode] = (0, $4RFnf.useState)(getInitialMode());
    (0, $4RFnf.useEffect)(()=>{
        localStorage.setItem("dark", darkMode);
        document.body.style.backgroundColor = darkMode ? "#121212" : "";
    }, [
        darkMode
    ]);
    return /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $99aed3ab2dc6c7d9$export$2881499e37b75b9a), {
        store: (0, $ec6ccf0ccbb770a1$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $1039ae88e8de639f$export$2e2bcd8739ae039).Provider, {
            value: {
                darkMode: darkMode,
                setDarkMode: setDarkMode
            },
            children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)("div", {
                className: `dark:bg-[#121212] ${darkMode ? "dark" : ""} `,
                children: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $2dda13c5d6544900$export$910ae8079b2c2852), {})
            })
        })
    });
};
const $3c1483f93957eaf7$var$appRouter = (0, $ab1c2d1a5ff1b7e8$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)($3c1483f93957eaf7$var$AppLayout, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $bffff0e09a609a2b$export$2e2bcd8739ae039), {})
            },
            (0, $a57ad15b73d7f8c0$export$2e2bcd8739ae039),
            {
                path: "*",
                element: /*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $2dda13c5d6544900$export$444b3ab0cb9aec40), {
                    to: "/"
                })
            }
        ]
    }
]);
const $3c1483f93957eaf7$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($e6901a497e5ba7f6$exports))).createRoot(document.getElementById("root"));
$3c1483f93957eaf7$var$root.render(/*#__PURE__*/ (0, $e1117946e7cdcf39$exports.jsx)((0, $ab1c2d1a5ff1b7e8$export$323e4fc2fa4753fb), {
    router: $3c1483f93957eaf7$var$appRouter
}));


//# sourceMappingURL=index.bd0d6e0c.js.map
